// Import from mPAY Prod (date: 29 Jan 2026)
export default {
  10: {
    name: {
      th: 'กรุงเทพมหานคร',
      en: 'Bangkok',
    },
    amphoes: {
      1001: {
        name: {
          th: 'พระนคร',
          en: 'Phra Nakhon',
        },
        tambons: {
          100101: {
            name: {
              th: 'พระบรมมหาราชวัง',
              en: 'Phra Borom Maha Ratchawang',
            },
            zipcode: '10200',
          },
          100102: {
            name: {
              th: 'วังบูรพาภิรมย์',
              en: 'Wang Burapha Phirom',
            },
            zipcode: '10200',
          },
          100103: {
            name: {
              th: 'วัดราชบพิธ',
              en: 'Wat Ratchabophit',
            },
            zipcode: '10200',
          },
          100104: {
            name: {
              th: 'สำราญราษฎร์',
              en: 'Samran Rat',
            },
            zipcode: '10200',
          },
          100105: {
            name: {
              th: 'ศาลเจ้าพ่อเสือ',
              en: 'San Chaopho Suea',
            },
            zipcode: '10200',
          },
          100106: {
            name: {
              th: 'เสาชิงช้า',
              en: 'Sao Chingcha',
            },
            zipcode: '10200',
          },
          100107: {
            name: {
              th: 'บวรนิเวศ',
              en: 'Bowon Niwet',
            },
            zipcode: '10200',
          },
          100108: {
            name: {
              th: 'ตลาดยอด',
              en: 'Talat Yot',
            },
            zipcode: '10200',
          },
          100109: {
            name: {
              th: 'ชนะสงคราม',
              en: 'Chana Songkhram',
            },
            zipcode: '10200',
          },
          100110: {
            name: {
              th: 'บ้านพานถม',
              en: 'Ban Phan Thom',
            },
            zipcode: '10200',
          },
          100111: {
            name: {
              th: 'บางขุนพรหม',
              en: 'Bang Khun Phrom',
            },
            zipcode: '10200',
          },
          100112: {
            name: {
              th: 'วัดสามพระยา',
              en: 'Wat Sam Phraya',
            },
            zipcode: '10200',
          },
        },
      },
      1002: {
        name: {
          th: 'ดุสิต',
          en: 'Dusit',
        },
        tambons: {
          100201: {
            name: {
              th: 'ดุสิต',
              en: 'Dusit',
            },
            zipcode: '10300',
          },
          100202: {
            name: {
              th: 'วชิรพยาบาล',
              en: 'Wachiraphayaban',
            },
            zipcode: '10300',
          },
          100203: {
            name: {
              th: 'สวนจิตรลดา',
              en: 'Suan Chittralada',
            },
            zipcode: '10300',
          },
          100204: {
            name: {
              th: 'สี่แยกมหานาค',
              en: 'Si Yaek Maha Nak',
            },
            zipcode: '10300',
          },
          100206: {
            name: {
              th: 'ถนนนครไชยศรี',
              en: 'Thanon Nakhon Chai Si',
            },
            zipcode: '10300',
          },
        },
      },
      1003: {
        name: {
          th: 'หนองจอก',
          en: 'Nong Chok',
        },
        tambons: {
          100301: {
            name: {
              th: 'กระทุ่มราย',
              en: 'Krathum Rai',
            },
            zipcode: '10530',
          },
          100302: {
            name: {
              th: 'หนองจอก',
              en: 'Nong Chok',
            },
            zipcode: '10530',
          },
          100303: {
            name: {
              th: 'คลองสิบ',
              en: 'Khlong Sip',
            },
            zipcode: '10530',
          },
          100304: {
            name: {
              th: 'คลองสิบสอง',
              en: 'Khlong Sip Song',
            },
            zipcode: '10530',
          },
          100305: {
            name: {
              th: 'โคกแฝด',
              en: 'Khok Faet',
            },
            zipcode: '10530',
          },
          100306: {
            name: {
              th: 'คู้ฝั่งเหนือ',
              en: 'Khu Fang Nuea',
            },
            zipcode: '10530',
          },
          100307: {
            name: {
              th: 'ลำผักชี',
              en: 'Lam Phak Chi',
            },
            zipcode: '10530',
          },
          100308: {
            name: {
              th: 'ลำต้อยติ่ง',
              en: 'Lam Toi Ting',
            },
            zipcode: '10530',
          },
        },
      },
      1004: {
        name: {
          th: 'บางรัก',
          en: 'Bang Rak',
        },
        tambons: {
          100401: {
            name: {
              th: 'มหาพฤฒาราม',
              en: 'Maha Phruettharam',
            },
            zipcode: '10500',
          },
          100402: {
            name: {
              th: 'สีลม',
              en: 'Si Lom',
            },
            zipcode: '10500',
          },
          100403: {
            name: {
              th: 'สุริยวงศ์',
              en: 'Suriyawong',
            },
            zipcode: '10500',
          },
          100404: {
            name: {
              th: 'บางรัก',
              en: 'Bang Rak',
            },
            zipcode: '10500',
          },
          100405: {
            name: {
              th: 'สี่พระยา',
              en: 'Si Phraya',
            },
            zipcode: '10500',
          },
        },
      },
      1005: {
        name: {
          th: 'บางเขน',
          en: 'Bang Khen',
        },
        tambons: {
          100502: {
            name: {
              th: 'อนุสาวรีย์',
              en: 'Anusawari',
            },
            zipcode: '10220',
          },
          100508: {
            name: {
              th: 'ท่าแร้ง',
              en: 'Tha Raeng',
            },
            zipcode: '10230',
          },
        },
      },
      1006: {
        name: {
          th: 'บางกะปิ',
          en: 'Bang Kapi',
        },
        tambons: {
          100601: {
            name: {
              th: 'คลองจั่น',
              en: 'Khlong Chan',
            },
            zipcode: '10240',
          },
          100608: {
            name: {
              th: 'หัวหมาก',
              en: 'Hua Mak',
            },
            zipcode: '10240',
          },
        },
      },
      1007: {
        name: {
          th: 'ปทุมวัน',
          en: 'Pathum Wan',
        },
        tambons: {
          100701: {
            name: {
              th: 'รองเมือง',
              en: 'Rong Mueang',
            },
            zipcode: '10330',
          },
          100702: {
            name: {
              th: 'วังใหม่',
              en: 'Wang Mai',
            },
            zipcode: '10330',
          },
          100703: {
            name: {
              th: 'ปทุมวัน',
              en: 'Pathum Wan',
            },
            zipcode: '10330',
          },
          100704: {
            name: {
              th: 'ลุมพินี',
              en: 'Lumphini',
            },
            zipcode: '10330',
          },
        },
      },
      1008: {
        name: {
          th: 'ป้อมปราบศัตรูพ่าย',
          en: 'Pom Prap',
        },
        tambons: {
          100801: {
            name: {
              th: 'ป้อมปราบ',
              en: 'Pom Prap',
            },
            zipcode: '10100',
          },
          100802: {
            name: {
              th: 'วัดเทพศิรินทร์',
              en: 'Wat Thepsirin',
            },
            zipcode: '10100',
          },
          100803: {
            name: {
              th: 'คลองมหานาค',
              en: 'Khlong Mahanak',
            },
            zipcode: '10100',
          },
          100804: {
            name: {
              th: 'บ้านบาตร',
              en: 'Ban Bat',
            },
            zipcode: '10100',
          },
          100805: {
            name: {
              th: 'วัดโสมนัส',
              en: 'Wat Sommanat',
            },
            zipcode: '10100',
          },
        },
      },
      1009: {
        name: {
          th: 'พระโขนง',
          en: 'Phra Khanong',
        },
        tambons: {
          100905: {
            name: {
              th: 'บางจาก',
              en: 'Bang Chak',
            },
            zipcode: '10260',
          },
          100910: {
            name: {
              th: 'พระโขนงใต้',
              en: 'Phra Khanong Tai',
            },
            zipcode: '10260',
          },
        },
      },
      1010: {
        name: {
          th: 'มีนบุรี',
          en: 'Min Buri',
        },
        tambons: {
          101001: {
            name: {
              th: 'มีนบุรี',
              en: 'Min Buri',
            },
            zipcode: '10510',
          },
          101002: {
            name: {
              th: 'แสนแสบ',
              en: 'Saen Saep',
            },
            zipcode: '10510',
          },
        },
      },
      1011: {
        name: {
          th: 'ลาดกระบัง',
          en: 'Lat Krabang',
        },
        tambons: {
          101101: {
            name: {
              th: 'ลาดกระบัง',
              en: 'Lat Krabang',
            },
            zipcode: '10520',
          },
          101102: {
            name: {
              th: 'คลองสองต้นนุ่น',
              en: 'Khlong Song Ton Nun',
            },
            zipcode: '10520',
          },
          101103: {
            name: {
              th: 'คลองสามประเวศ',
              en: 'Khlong Sam Prawet',
            },
            zipcode: '10520',
          },
          101104: {
            name: {
              th: 'ลำปลาทิว',
              en: 'Lam Pla Thio',
            },
            zipcode: '10520',
          },
          101105: {
            name: {
              th: 'ทับยาว',
              en: 'Thap Yao',
            },
            zipcode: '10520',
          },
          101106: {
            name: {
              th: 'ขุมทอง',
              en: 'Khum Thong',
            },
            zipcode: '10520',
          },
        },
      },
      1012: {
        name: {
          th: 'ยานนาวา',
          en: 'Yan Nawa',
        },
        tambons: {
          101203: {
            name: {
              th: 'ช่องนนทรี',
              en: 'Chong Nonsi',
            },
            zipcode: '10120',
          },
          101204: {
            name: {
              th: 'บางโพงพาง',
              en: 'Bang Phong Pang',
            },
            zipcode: '10120',
          },
        },
      },
      1013: {
        name: {
          th: 'สัมพันธวงศ์',
          en: 'Samphanthawong',
        },
        tambons: {
          101301: {
            name: {
              th: 'จักรวรรดิ',
              en: 'Chakkrawat',
            },
            zipcode: '10100',
          },
          101302: {
            name: {
              th: 'สัมพันธวงศ์',
              en: 'Samphanthawong',
            },
            zipcode: '10100',
          },
          101303: {
            name: {
              th: 'ตลาดน้อย',
              en: 'Talat Noi',
            },
            zipcode: '10100',
          },
        },
      },
      1014: {
        name: {
          th: 'พญาไท',
          en: 'Phaya Thai',
        },
        tambons: {
          101401: {
            name: {
              th: 'สามเสนใน',
              en: 'Sam Sen Nai',
            },
            zipcode: '10400',
          },
          101406: {
            name: {
              th: 'พญาไท',
              en: 'Phaya Thai',
            },
            zipcode: '10400',
          },
        },
      },
      1015: {
        name: {
          th: 'ธนบุรี',
          en: 'Thon Buri',
        },
        tambons: {
          101501: {
            name: {
              th: 'วัดกัลยาณ์',
              en: 'Wat Kanlaya',
            },
            zipcode: '10600',
          },
          101502: {
            name: {
              th: 'หิรัญรูจี',
              en: 'Hiran Ruchi',
            },
            zipcode: '10600',
          },
          101503: {
            name: {
              th: 'บางยี่เรือ',
              en: 'Bang Yi Ruea',
            },
            zipcode: '10600',
          },
          101504: {
            name: {
              th: 'บุคคโล',
              en: 'Bukkhalo',
            },
            zipcode: '10600',
          },
          101505: {
            name: {
              th: 'ตลาดพลู',
              en: 'Talat Phlu',
            },
            zipcode: '10600',
          },
          101506: {
            name: {
              th: 'ดาวคะนอง',
              en: 'Dao Khanong',
            },
            zipcode: '10600',
          },
          101507: {
            name: {
              th: 'สำเหร่',
              en: 'Samre',
            },
            zipcode: '10600',
          },
        },
      },
      1016: {
        name: {
          th: 'บางกอกใหญ่',
          en: 'Bangkok Yai',
        },
        tambons: {
          101601: {
            name: {
              th: 'วัดอรุณ',
              en: 'Wat Arun',
            },
            zipcode: '10600',
          },
          101602: {
            name: {
              th: 'วัดท่าพระ',
              en: 'Wat Tha Phra',
            },
            zipcode: '10600',
          },
        },
      },
      1017: {
        name: {
          th: 'ห้วยขวาง',
          en: 'Huai Khwang',
        },
        tambons: {
          101701: {
            name: {
              th: 'ห้วยขวาง',
              en: 'Huai Khwang',
            },
            zipcode: '10310',
          },
          101702: {
            name: {
              th: 'บางกะปิ',
              en: 'Bang Kapi',
            },
            zipcode: '10310',
          },
          101704: {
            name: {
              th: 'สามเสนนอก',
              en: 'Sam Sen Nok',
            },
            zipcode: '10310',
          },
        },
      },
      1018: {
        name: {
          th: 'คลองสาน',
          en: 'Klong San',
        },
        tambons: {
          101801: {
            name: {
              th: 'สมเด็จเจ้าพระยา',
              en: 'Somdet Chao Phraya',
            },
            zipcode: '10600',
          },
          101802: {
            name: {
              th: 'คลองสาน',
              en: 'Khlong San',
            },
            zipcode: '10600',
          },
          101803: {
            name: {
              th: 'บางลำภูล่าง',
              en: 'Bang Lamphu Lang',
            },
            zipcode: '10600',
          },
          101804: {
            name: {
              th: 'คลองต้นไทร',
              en: 'Khlong Ton Sai',
            },
            zipcode: '10600',
          },
        },
      },
      1019: {
        name: {
          th: 'ตลิ่งชัน',
          en: 'Taling Chan',
        },
        tambons: {
          101901: {
            name: {
              th: 'คลองชักพระ',
              en: 'Khlong Chak Phra',
            },
            zipcode: '10170',
          },
          101902: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '10170',
          },
          101903: {
            name: {
              th: 'ฉิมพลี',
              en: 'Chim Phli',
            },
            zipcode: '10170',
          },
          101904: {
            name: {
              th: 'บางพรม',
              en: 'Bang Phrom',
            },
            zipcode: '10170',
          },
          101905: {
            name: {
              th: 'บางระมาด',
              en: 'Bang Ramat',
            },
            zipcode: '10170',
          },
          101907: {
            name: {
              th: 'บางเชือกหนัง',
              en: 'Bang Chueak Nang',
            },
            zipcode: '10170',
          },
        },
      },
      1020: {
        name: {
          th: 'บางกอกน้อย',
          en: 'Bangkok Noi',
        },
        tambons: {
          102004: {
            name: {
              th: 'ศิริราช',
              en: 'Siriraj',
            },
            zipcode: '10700',
          },
          102005: {
            name: {
              th: 'บ้านช่างหล่อ',
              en: 'Ban Chang Lo',
            },
            zipcode: '10700',
          },
          102006: {
            name: {
              th: 'บางขุนนนท์',
              en: 'Bang Khun Non',
            },
            zipcode: '10700',
          },
          102007: {
            name: {
              th: 'บางขุนศรี',
              en: 'Bang Khun Si',
            },
            zipcode: '10700',
          },
          102009: {
            name: {
              th: 'อรุณอมรินทร์',
              en: 'Arun Amarin',
            },
            zipcode: '10700',
          },
        },
      },
      1021: {
        name: {
          th: 'บางขุนเทียน',
          en: 'Bang Khun Thian',
        },
        tambons: {
          102105: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '10150',
          },
          102107: {
            name: {
              th: 'แสมดำ',
              en: 'Samae Dam',
            },
            zipcode: '10150',
          },
        },
      },
      1022: {
        name: {
          th: 'ภาษีเจริญ',
          en: 'Phasi Charoen',
        },
        tambons: {
          102201: {
            name: {
              th: 'บางหว้า',
              en: 'Bang Wa',
            },
            zipcode: '10160',
          },
          102202: {
            name: {
              th: 'บางด้วน',
              en: 'Bang Duan',
            },
            zipcode: '10160',
          },
          102203: {
            name: {
              th: 'บางแค',
              en: 'Bang Khae',
            },
            zipcode: '10160',
          },
          102204: {
            name: {
              th: 'บางแคเหนือ',
              en: 'Bang Khae Nuea',
            },
            zipcode: '10160',
          },
          102205: {
            name: {
              th: 'บางไผ่',
              en: 'Bang Phai',
            },
            zipcode: '10160',
          },
          102206: {
            name: {
              th: 'บางจาก',
              en: 'Bang Chak',
            },
            zipcode: '10160',
          },
          102207: {
            name: {
              th: 'บางแวก',
              en: 'Bang Waek',
            },
            zipcode: '10160',
          },
          102208: {
            name: {
              th: 'คลองขวาง',
              en: 'Khlong Khwang',
            },
            zipcode: '10160',
          },
          102209: {
            name: {
              th: 'ปากคลองภาษีเจริญ',
              en: 'Pak Khlong Phasi Charoen',
            },
            zipcode: '10160',
          },
          102210: {
            name: {
              th: 'คูหาสวรรค์',
              en: 'Khuha Sawan',
            },
            zipcode: '10160',
          },
        },
      },
      1023: {
        name: {
          th: 'หนองแขม',
          en: 'Nong Khaem',
        },
        tambons: {
          102302: {
            name: {
              th: 'หนองแขม',
              en: 'Nong Khaem',
            },
            zipcode: '10160',
          },
          102303: {
            name: {
              th: 'หนองค้างพลู',
              en: 'Nong Khang Phlu',
            },
            zipcode: '10160',
          },
        },
      },
      1024: {
        name: {
          th: 'ราษฎร์บูรณะ',
          en: 'Rat Burana',
        },
        tambons: {
          102401: {
            name: {
              th: 'ราษฎร์บูรณะ',
              en: 'Rat Burana',
            },
            zipcode: '10140',
          },
          102402: {
            name: {
              th: 'บางปะกอก',
              en: 'Bang Pakok',
            },
            zipcode: '10140',
          },
        },
      },
      1025: {
        name: {
          th: 'บางพลัด',
          en: 'Bang Phlat',
        },
        tambons: {
          102501: {
            name: {
              th: 'บางพลัด',
              en: 'Bang Phlat',
            },
            zipcode: '10700',
          },
          102502: {
            name: {
              th: 'บางอ้อ',
              en: 'Bang O',
            },
            zipcode: '10700',
          },
          102503: {
            name: {
              th: 'บางบำหรุ',
              en: 'Bang Bamru',
            },
            zipcode: '10700',
          },
          102504: {
            name: {
              th: 'บางยี่ขัน',
              en: 'Bang Yi Khan',
            },
            zipcode: '10700',
          },
        },
      },
      1026: {
        name: {
          th: 'ดินแดง',
          en: 'Din Daeng',
        },
        tambons: {
          102601: {
            name: {
              th: 'ดินแดง',
              en: 'Din Daeng',
            },
            zipcode: '10400',
          },
          102602: {
            name: {
              th: 'รัชดาภิเษก',
              en: 'Ratchadaphisek',
            },
            zipcode: '10400',
          },
        },
      },
      1027: {
        name: {
          th: 'บึงกุ่ม',
          en: 'Bung Kum',
        },
        tambons: {
          102701: {
            name: {
              th: 'คลองกุ่ม',
              en: 'Khlong Kum',
            },
            zipcode: '10240',
          },
          102702: {
            name: {
              th: 'สะพานสูง',
              en: 'Saphan Sung',
            },
            zipcode: '10240',
          },
          102703: {
            name: {
              th: 'คันนายาว',
              en: 'Khan Na Yao',
            },
            zipcode: '10240',
          },
          102704: {
            name: {
              th: 'นวมินทร์',
              en: 'Nawamin',
            },
            zipcode: '10240',
          },
          102705: {
            name: {
              th: 'นวลจันทร์',
              en: 'Nuan Chan',
            },
            zipcode: '10240',
          },
        },
      },
      1028: {
        name: {
          th: 'สาทร',
          en: 'Sathon',
        },
        tambons: {
          102801: {
            name: {
              th: 'ทุ่งวัดดอน',
              en: 'Thung Wat Don',
            },
            zipcode: '10120',
          },
          102802: {
            name: {
              th: 'ยานนาวา',
              en: 'Yan Nawa',
            },
            zipcode: '10120',
          },
          102803: {
            name: {
              th: 'ทุ่งมหาเมฆ',
              en: 'Thung Maha Mek',
            },
            zipcode: '10120',
          },
        },
      },
      1029: {
        name: {
          th: 'บางซื่อ',
          en: 'Bang Su',
        },
        tambons: {
          102901: {
            name: {
              th: 'บางซื่อ',
              en: 'Bang Sue',
            },
            zipcode: '10800',
          },
          102902: {
            name: {
              th: 'วงศ์สว่าง',
              en: 'Wong Sawang',
            },
            zipcode: '10800',
          },
        },
      },
      1030: {
        name: {
          th: 'จตุจักร',
          en: 'Chatuchak',
        },
        tambons: {
          103001: {
            name: {
              th: 'ลาดยาว',
              en: 'Lat Yao',
            },
            zipcode: '10900',
          },
          103002: {
            name: {
              th: 'เสนานิคม',
              en: 'Sena Nikhom',
            },
            zipcode: '10900',
          },
          103003: {
            name: {
              th: 'จันทรเกษม',
              en: 'Chan Kasem',
            },
            zipcode: '10900',
          },
          103004: {
            name: {
              th: 'จอมพล',
              en: 'Chom Phon',
            },
            zipcode: '10900',
          },
          103005: {
            name: {
              th: 'จตุจักร',
              en: 'Chatuchak',
            },
            zipcode: '10900',
          },
        },
      },
      1031: {
        name: {
          th: 'บางคอแหลม',
          en: 'Bang Kho Laem',
        },
        tambons: {
          103101: {
            name: {
              th: 'บางคอแหลม',
              en: 'Bang Kho Laem',
            },
            zipcode: '10120',
          },
          103102: {
            name: {
              th: 'วัดพระยาไกร',
              en: 'Wat Phraya Krai',
            },
            zipcode: '10120',
          },
          103103: {
            name: {
              th: 'บางโคล่',
              en: 'Bang Khlo',
            },
            zipcode: '10120',
          },
        },
      },
      1032: {
        name: {
          th: 'ประเวศ',
          en: 'Prawet',
        },
        tambons: {
          103201: {
            name: {
              th: 'ประเวศ',
              en: 'Prawet',
            },
            zipcode: '10250',
          },
          103202: {
            name: {
              th: 'หนองบอน',
              en: 'Nong Bon',
            },
            zipcode: '10250',
          },
          103203: {
            name: {
              th: 'ดอกไม้',
              en: 'Dok Mai',
            },
            zipcode: '10250',
          },
          103204: {
            name: {
              th: 'สวนหลวง',
              en: 'Suan Luang',
            },
            zipcode: '10250',
          },
        },
      },
      1033: {
        name: {
          th: 'คลองเตย',
          en: 'Khlong Toei',
        },
        tambons: {
          103301: {
            name: {
              th: 'คลองเตย',
              en: 'Khlong Toei',
            },
            zipcode: '10110',
          },
          103302: {
            name: {
              th: 'คลองตัน',
              en: 'Khlong Tan',
            },
            zipcode: '10110',
          },
          103303: {
            name: {
              th: 'พระโขนง',
              en: 'Phra Khanong',
            },
            zipcode: '10110',
          },
          103304: {
            name: {
              th: 'คลองเตยเหนือ*',
              en: 'Khlong Toei Nuea*',
            },
            zipcode: '10110',
          },
          103305: {
            name: {
              th: 'คลองตันเหนือ',
              en: 'Khlong Tan Nuea',
            },
            zipcode: '10110',
          },
          103306: {
            name: {
              th: 'พระโขนงเหนือ',
              en: 'Phra Khanong Nuea',
            },
            zipcode: '10110',
          },
        },
      },
      1034: {
        name: {
          th: 'สวนหลวง',
          en: 'Suan Luang',
        },
        tambons: {
          103401: {
            name: {
              th: 'สวนหลวง',
              en: 'Suan Luang',
            },
            zipcode: '10250',
          },
          103402: {
            name: {
              th: 'พัฒนาการ',
              en: 'Phatthanakan',
            },
            zipcode: '10250',
          },
          103403: {
            name: {
              th: 'อ่อนนุช',
              en: 'Onnut',
            },
            zipcode: '10250',
          },
        },
      },
      1035: {
        name: {
          th: 'จอมทอง',
          en: 'Chom Thong',
        },
        tambons: {
          103501: {
            name: {
              th: 'บางขุนเทียน',
              en: 'Bang Khun Thian',
            },
            zipcode: '10150',
          },
          103502: {
            name: {
              th: 'บางค้อ',
              en: 'Bang Kho',
            },
            zipcode: '10150',
          },
          103503: {
            name: {
              th: 'บางมด',
              en: 'Bang Mot',
            },
            zipcode: '10150',
          },
          103504: {
            name: {
              th: 'จอมทอง',
              en: 'Chom Thong',
            },
            zipcode: '10150',
          },
        },
      },
      1036: {
        name: {
          th: 'ดอนเมือง',
          en: 'Don Muang',
        },
        tambons: {
          103602: {
            name: {
              th: 'สีกัน',
              en: 'Si Kan',
            },
            zipcode: '10001',
          },
          103604: {
            name: {
              th: 'ดอนเมือง',
              en: 'Don Mueang',
            },
            zipcode: '10210',
          },
          103605: {
            name: {
              th: 'สนามบิน',
              en: 'Sanam Bin',
            },
            zipcode: '10211',
          },
        },
      },
      1037: {
        name: {
          th: 'ราชเทวี',
          en: 'Ratchthewi',
        },
        tambons: {
          103701: {
            name: {
              th: 'ทุ่งพญาไท',
              en: 'Thung Phaya Thai',
            },
            zipcode: '10400',
          },
          103702: {
            name: {
              th: 'ถนนพญาไท',
              en: 'Thanon Phaya Thai',
            },
            zipcode: '10400',
          },
          103703: {
            name: {
              th: 'ถนนเพชรบุรี',
              en: 'Thanon Phetchaburi',
            },
            zipcode: '10400',
          },
          103704: {
            name: {
              th: 'มักกะสัน',
              en: 'Makkasan',
            },
            zipcode: '10400',
          },
        },
      },
      1038: {
        name: {
          th: 'ลาดพร้าว',
          en: 'Lat Phrao',
        },
        tambons: {
          103801: {
            name: {
              th: 'ลาดพร้าว',
              en: 'Lat Phrao',
            },
            zipcode: '10230',
          },
          103802: {
            name: {
              th: 'จรเข้บัว',
              en: 'Chorakhe Bua',
            },
            zipcode: '10230',
          },
        },
      },
      1039: {
        name: {
          th: 'วัฒนา',
          en: 'Watthana',
        },
        tambons: {
          103901: {
            name: {
              th: 'คลองเตยเหนือ',
              en: 'Khlong Toei Nuea',
            },
            zipcode: '10110',
          },
          103902: {
            name: {
              th: 'คลองตันเหนือ',
              en: 'Khlong Tan Nuea',
            },
            zipcode: '10110',
          },
          103903: {
            name: {
              th: 'พระโขนงเหนือ',
              en: 'Phra Khanong Nuea',
            },
            zipcode: '10110',
          },
        },
      },
      1040: {
        name: {
          th: 'บางแค',
          en: 'Bang Kae',
        },
        tambons: {
          104001: {
            name: {
              th: 'บางแค',
              en: 'Bang Khae',
            },
            zipcode: '10160',
          },
          104002: {
            name: {
              th: 'บางแคเหนือ',
              en: 'Bang Khae Nuea',
            },
            zipcode: '10160',
          },
          104003: {
            name: {
              th: 'บางไผ่',
              en: 'Bang Phai',
            },
            zipcode: '10160',
          },
          104004: {
            name: {
              th: 'หลักสอง',
              en: 'Lak Song',
            },
            zipcode: '10160',
          },
        },
      },
      1041: {
        name: {
          th: 'หลักสี่',
          en: 'Laksi',
        },
        tambons: {
          104101: {
            name: {
              th: 'ทุ่งสองห้อง',
              en: 'Thung Song Hong',
            },
            zipcode: '10002',
          },
          104102: {
            name: {
              th: 'ตลาดบางเขน',
              en: 'Talat Bang Khen',
            },
            zipcode: '10210',
          },
        },
      },
      1042: {
        name: {
          th: 'สายไหม',
          en: 'Saimai',
        },
        tambons: {
          104201: {
            name: {
              th: 'สายไหม',
              en: 'Sai Mai',
            },
            zipcode: '10220',
          },
          104202: {
            name: {
              th: 'ออเงิน',
              en: 'O Ngoen',
            },
            zipcode: '10220',
          },
          104203: {
            name: {
              th: 'คลองถนน',
              en: 'Khlong Thanon',
            },
            zipcode: '10220',
          },
        },
      },
      1043: {
        name: {
          th: 'คันนายาว',
          en: 'Khannayao',
        },
        tambons: {
          104301: {
            name: {
              th: 'คันนายาว',
              en: 'Khan Na Yao',
            },
            zipcode: '10230',
          },
          104302: {
            name: {
              th: 'รามอินทรา',
              en: 'Ram Inthra',
            },
            zipcode: '10230',
          },
        },
      },
      1044: {
        name: {
          th: 'สะพานสูง',
          en: 'Saphansung',
        },
        tambons: {
          104401: {
            name: {
              th: 'สะพานสูง',
              en: 'Saphan Sung',
            },
            zipcode: '10240',
          },
          104402: {
            name: {
              th: 'ราษฏร์พัฒนา',
              en: 'Khwaeng Rat Phatthana',
            },
            zipcode: '10240',
          },
          104403: {
            name: {
              th: 'ทับช้าง',
              en: 'Khwaeng Thap Chang',
            },
            zipcode: '10250',
          },
        },
      },
      1045: {
        name: {
          th: 'วังทองหลาง',
          en: 'Wangthonglang',
        },
        tambons: {
          104501: {
            name: {
              th: 'วังทองหลาง',
              en: 'Wang Thonglang',
            },
            zipcode: '10310',
          },
          104502: {
            name: {
              th: 'สะพานสอง',
              en: 'Saphan Song',
            },
            zipcode: '10310',
          },
          104503: {
            name: {
              th: 'คลองเจ้าคุณสิงห์',
              en: 'Khlong Chaokhun Sing',
            },
            zipcode: '10310',
          },
          104504: {
            name: {
              th: 'พลับพลา',
              en: 'Phlapphla',
            },
            zipcode: '10310',
          },
        },
      },
      1046: {
        name: {
          th: 'คลองสามวา',
          en: 'Klongsamwa',
        },
        tambons: {
          104601: {
            name: {
              th: 'สามวาตะวันตก',
              en: 'Sam Wa Tawan Tok',
            },
            zipcode: '10510',
          },
          104602: {
            name: {
              th: 'สามวาตะวันออก',
              en: 'Sam Wa Tawan Ok',
            },
            zipcode: '10510',
          },
          104603: {
            name: {
              th: 'บางชัน',
              en: 'Bang Chan',
            },
            zipcode: '10510',
          },
          104604: {
            name: {
              th: 'ทรายกองดิน',
              en: 'Sai Kong Din',
            },
            zipcode: '10510',
          },
          104605: {
            name: {
              th: 'ทรายกองดินใต้',
              en: 'Sai Kong Din Tai',
            },
            zipcode: '10510',
          },
        },
      },
      1047: {
        name: {
          th: 'บางนา',
          en: 'Bang Na',
        },
        tambons: {
          104701: {
            name: {
              th: 'บางนา',
              en: 'Bang Na',
            },
            zipcode: '10260',
          },
          104702: {
            name: {
              th: 'บางนาเหนือ',
              en: 'Bang Na Nuea',
            },
            zipcode: '10260',
          },
          104703: {
            name: {
              th: 'บางนาใต้',
              en: 'Bang Na Tai',
            },
            zipcode: '10260',
          },
        },
      },
      1048: {
        name: {
          th: 'ทวีวัฒนา',
          en: 'Thawiwatthana',
        },
        tambons: {
          104801: {
            name: {
              th: 'ทวีวัฒนา',
              en: 'Thawi Watthana',
            },
            zipcode: '10170',
          },
          104802: {
            name: {
              th: 'ศาลาธรรมสพน์',
              en: 'Sala Thammasop',
            },
            zipcode: '10170',
          },
        },
      },
      1049: {
        name: {
          th: 'ทุ่งครุ',
          en: 'Thung Khru',
        },
        tambons: {
          104901: {
            name: {
              th: 'บางมด',
              en: 'Bang Mot',
            },
            zipcode: '10140',
          },
          104902: {
            name: {
              th: 'ทุ่งครุ',
              en: 'Thung Khru',
            },
            zipcode: '10140',
          },
        },
      },
      1050: {
        name: {
          th: 'บางบอน',
          en: 'Bang Bon',
        },
        tambons: {
          105001: {
            name: {
              th: 'บางบอน',
              en: 'Bang Bon',
            },
            zipcode: '10150',
          },
          105002: {
            name: {
              th: 'บางบอนเหนือ',
              en: 'Bang Bon Nuea',
            },
            zipcode: '10150',
          },
          105003: {
            name: {
              th: 'บางบอนใต้',
              en: 'Bang Bon Tai',
            },
            zipcode: '10150',
          },
          105004: {
            name: {
              th: 'คลองบางพราน',
              en: 'Khlong Bang Pran',
            },
            zipcode: '10150',
          },
          105005: {
            name: {
              th: 'คลองบางบอน',
              en: 'Khlong Bang Bon',
            },
            zipcode: '10150',
          },
        },
      },
    },
  },
  11: {
    name: {
      th: 'สมุทรปราการ',
      en: 'Samut Prakan',
    },
    amphoes: {
      1101: {
        name: {
          th: 'เมืองสมุทรปราการ',
          en: 'Muang',
        },
        tambons: {
          110101: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '10270',
          },
          110102: {
            name: {
              th: 'สำโรงเหนือ',
              en: 'Samrong Nuea',
            },
            zipcode: '10270',
          },
          110103: {
            name: {
              th: 'บางเมือง',
              en: 'Bang Mueang',
            },
            zipcode: '10270',
          },
          110104: {
            name: {
              th: 'ท้ายบ้าน',
              en: 'Thai Ban',
            },
            zipcode: '10280',
          },
          110108: {
            name: {
              th: 'บางปูใหม่',
              en: 'Bang Pu Mai',
            },
            zipcode: '10280',
          },
          110110: {
            name: {
              th: 'แพรกษา',
              en: 'Phraek Sa',
            },
            zipcode: '10280',
          },
          110111: {
            name: {
              th: 'บางโปรง',
              en: 'Bang Prong',
            },
            zipcode: '10270',
          },
          110112: {
            name: {
              th: 'บางปู',
              en: 'Bang Pu',
            },
            zipcode: '10270',
          },
          110113: {
            name: {
              th: 'บางด้วน',
              en: 'Bang Duan',
            },
            zipcode: '10270',
          },
          110114: {
            name: {
              th: 'บางเมืองใหม่',
              en: 'Bang Mueang Mai',
            },
            zipcode: '10270',
          },
          110115: {
            name: {
              th: 'เทพารักษ์',
              en: 'Thepharak',
            },
            zipcode: '10270',
          },
          110116: {
            name: {
              th: 'ท้ายบ้านใหม่',
              en: 'Thai Ban Mai',
            },
            zipcode: '10280',
          },
          110117: {
            name: {
              th: 'แพรกษาใหม่',
              en: 'Phraek Sa Mai',
            },
            zipcode: '10280',
          },
        },
      },
      1102: {
        name: {
          th: 'บางบ่อ',
          en: 'Bang Bo',
        },
        tambons: {
          110201: {
            name: {
              th: 'บางบ่อ',
              en: 'Bang Bo',
            },
            zipcode: '10560',
          },
          110202: {
            name: {
              th: 'บ้านระกาศ',
              en: 'Ban Ra Kat',
            },
            zipcode: '10560',
          },
          110203: {
            name: {
              th: 'บางพลีน้อย',
              en: 'Bang Phli Noi',
            },
            zipcode: '10560',
          },
          110204: {
            name: {
              th: 'บางเพรียง',
              en: 'Bang Phriang',
            },
            zipcode: '10560',
          },
          110205: {
            name: {
              th: 'คลองด่าน',
              en: 'Khlong Dan',
            },
            zipcode: '10550',
          },
          110206: {
            name: {
              th: 'คลองสวน',
              en: 'Khlong Suan',
            },
            zipcode: '10560',
          },
          110207: {
            name: {
              th: 'เปร็ง',
              en: 'Preng',
            },
            zipcode: '10560',
          },
          110208: {
            name: {
              th: 'คลองนิยมยาตรา',
              en: 'Khlong Niyom Yattra',
            },
            zipcode: '10560',
          },
        },
      },
      1103: {
        name: {
          th: 'บางพลี',
          en: 'Bang Phli',
        },
        tambons: {
          110301: {
            name: {
              th: 'บางพลีใหญ่',
              en: 'Bang Phli Yai',
            },
            zipcode: '10540',
          },
          110302: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '10540',
          },
          110303: {
            name: {
              th: 'บางปลา',
              en: 'Bang Pla',
            },
            zipcode: '10540',
          },
          110304: {
            name: {
              th: 'บางโฉลง',
              en: 'Bang Chalong',
            },
            zipcode: '10540',
          },
          110308: {
            name: {
              th: 'ราชาเทวะ',
              en: 'Racha Thewa',
            },
            zipcode: '10540',
          },
          110309: {
            name: {
              th: 'หนองปรือ',
              en: 'Nong Prue',
            },
            zipcode: '10540',
          },
        },
      },
      1104: {
        name: {
          th: 'พระประแดง',
          en: 'Phra Pradaeng',
        },
        tambons: {
          110401: {
            name: {
              th: 'ตลาด',
              en: 'Talat',
            },
            zipcode: '10130',
          },
          110402: {
            name: {
              th: 'บางพึ่ง',
              en: 'Bang Phueng',
            },
            zipcode: '10130',
          },
          110403: {
            name: {
              th: 'บางจาก',
              en: 'Bang Chak',
            },
            zipcode: '10130',
          },
          110404: {
            name: {
              th: 'บางครุ',
              en: 'Bang Khru',
            },
            zipcode: '10130',
          },
          110405: {
            name: {
              th: 'บางหญ้าแพรก',
              en: 'Bang Ya Phraek',
            },
            zipcode: '10130',
          },
          110406: {
            name: {
              th: 'บางหัวเสือ',
              en: 'Bang Hua Suea',
            },
            zipcode: '10130',
          },
          110407: {
            name: {
              th: 'สำโรงใต้',
              en: 'Samrong Tai',
            },
            zipcode: '10130',
          },
          110408: {
            name: {
              th: 'บางยอ',
              en: 'Bang Yo',
            },
            zipcode: '10130',
          },
          110409: {
            name: {
              th: 'บางกะเจ้า',
              en: 'Bang Kachao',
            },
            zipcode: '10130',
          },
          110410: {
            name: {
              th: 'บางน้ำผึ้ง',
              en: 'Bang Nam Phueng',
            },
            zipcode: '10130',
          },
          110411: {
            name: {
              th: 'บางกระสอบ',
              en: 'Bang Krasop',
            },
            zipcode: '10130',
          },
          110412: {
            name: {
              th: 'บางกอบัว',
              en: 'Bang Ko Bua',
            },
            zipcode: '10130',
          },
          110413: {
            name: {
              th: 'ทรงคนอง',
              en: 'Song Khanong',
            },
            zipcode: '10130',
          },
          110414: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '10130',
          },
          110415: {
            name: {
              th: 'สำโรงกลาง',
              en: 'Samrong Klang',
            },
            zipcode: '10130',
          },
        },
      },
      1105: {
        name: {
          th: 'พระสมุทรเจดีย์',
          en: 'Phra Samutjede',
        },
        tambons: {
          110501: {
            name: {
              th: 'นาเกลือ',
              en: 'Na Kluea',
            },
            zipcode: '10290',
          },
          110502: {
            name: {
              th: 'บ้านคลองสวน',
              en: 'Ban Khlong Suan',
            },
            zipcode: '10290',
          },
          110503: {
            name: {
              th: 'แหลมฟ้าผ่า',
              en: 'Laem Fa Pha',
            },
            zipcode: '10290',
          },
          110504: {
            name: {
              th: 'ปากคลองบางปลากด',
              en: 'Pak Khlong Bang Pla Kot',
            },
            zipcode: '10290',
          },
          110505: {
            name: {
              th: 'ในคลองบางปลากด',
              en: 'Nai Khlong Bang Pla Kot',
            },
            zipcode: '10290',
          },
        },
      },
      1106: {
        name: {
          th: 'บางเสาธง',
          en: 'King Amphoe Bang Sao Thong',
        },
        tambons: {
          110601: {
            name: {
              th: 'บางเสาธง',
              en: 'Bang Sao Thong',
            },
            zipcode: '10540',
          },
          110602: {
            name: {
              th: 'ศีรษะจรเข้น้อย',
              en: 'Sisa Chorakhe Noiย ',
            },
            zipcode: '10540',
          },
          110603: {
            name: {
              th: 'ศีรษะจรเข้ใหญ่',
              en: 'Sisa Chorakhe Yai',
            },
            zipcode: '10540',
          },
        },
      },
    },
  },
  12: {
    name: {
      th: 'นนทบุรี',
      en: 'Nonthaburi',
    },
    amphoes: {
      1201: {
        name: {
          th: 'เมืองนนทบุรี',
          en: 'Muang',
        },
        tambons: {
          120101: {
            name: {
              th: 'สวนใหญ่',
              en: 'Suan Yai',
            },
            zipcode: '11000',
          },
          120102: {
            name: {
              th: 'ตลาดขวัญ',
              en: 'Talat Khwan',
            },
            zipcode: '11000',
          },
          120103: {
            name: {
              th: 'บางเขน',
              en: 'Bang Khen',
            },
            zipcode: '11000',
          },
          120104: {
            name: {
              th: 'บางกระสอ',
              en: 'Bang Kraso',
            },
            zipcode: '11000',
          },
          120105: {
            name: {
              th: 'ท่าทราย',
              en: 'Tha Sai',
            },
            zipcode: '11000',
          },
          120106: {
            name: {
              th: 'บางไผ่',
              en: 'Bang Phai',
            },
            zipcode: '11000',
          },
          120107: {
            name: {
              th: 'บางศรีเมือง',
              en: 'Bang Si Mueang',
            },
            zipcode: '11000',
          },
          120108: {
            name: {
              th: 'บางกร่าง',
              en: 'Bang Krang',
            },
            zipcode: '11000',
          },
          120109: {
            name: {
              th: 'ไทรม้า',
              en: 'Sai Ma',
            },
            zipcode: '11000',
          },
          120110: {
            name: {
              th: 'บางรักน้อย',
              en: 'Bang Rak Noi',
            },
            zipcode: '11000',
          },
        },
      },
      1202: {
        name: {
          th: 'บางกรวย',
          en: 'Bang Kruai',
        },
        tambons: {
          120201: {
            name: {
              th: 'วัดชลอ',
              en: 'Wat Chalo',
            },
            zipcode: '11130',
          },
          120202: {
            name: {
              th: 'บางกรวย',
              en: 'Bang Kruai',
            },
            zipcode: '11130',
          },
          120203: {
            name: {
              th: 'บางสีทอง',
              en: 'Bang Si Thong',
            },
            zipcode: '11130',
          },
          120204: {
            name: {
              th: 'บางขนุน',
              en: 'Bang Khanun',
            },
            zipcode: '11130',
          },
          120205: {
            name: {
              th: 'บางขุนกอง',
              en: 'Bang Khun Kong',
            },
            zipcode: '11130',
          },
          120206: {
            name: {
              th: 'บางคูเวียง',
              en: 'Bang Khu Wiang',
            },
            zipcode: '11130',
          },
          120207: {
            name: {
              th: 'มหาสวัสดิ์',
              en: 'Maha Sawat',
            },
            zipcode: '11130',
          },
          120208: {
            name: {
              th: 'ปลายบาง',
              en: 'Plai Bang',
            },
            zipcode: '11130',
          },
          120209: {
            name: {
              th: 'ศาลากลาง',
              en: 'Sala Klang',
            },
            zipcode: '11130',
          },
        },
      },
      1203: {
        name: {
          th: 'บางใหญ่',
          en: 'Bang Yai',
        },
        tambons: {
          120301: {
            name: {
              th: 'บางม่วง',
              en: 'Bang Muang',
            },
            zipcode: '11140',
          },
          120302: {
            name: {
              th: 'บางแม่นาง',
              en: 'BangMaeNang',
            },
            zipcode: '11140',
          },
          120303: {
            name: {
              th: 'บางเลน',
              en: 'Bang Len',
            },
            zipcode: '11140',
          },
          120304: {
            name: {
              th: 'เสาธงหิน',
              en: 'Sao Thong Hinย ',
            },
            zipcode: '11140',
          },
          120305: {
            name: {
              th: 'บางใหญ่',
              en: 'Bang Yai',
            },
            zipcode: '11140',
          },
          120306: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '11140',
          },
        },
      },
      1204: {
        name: {
          th: 'บางบัวทอง',
          en: 'Bang Bua Thong',
        },
        tambons: {
          120401: {
            name: {
              th: 'โสนลอย',
              en: 'Sano Loi',
            },
            zipcode: '11110',
          },
          120402: {
            name: {
              th: 'บางบัวทอง',
              en: 'Bang Bua Thong',
            },
            zipcode: '11110',
          },
          120403: {
            name: {
              th: 'บางรักใหญ่',
              en: 'Bang Rak Yai',
            },
            zipcode: '11110',
          },
          120404: {
            name: {
              th: 'บางคูรัด',
              en: 'Bang Khu Rat',
            },
            zipcode: '11110',
          },
          120405: {
            name: {
              th: 'ละหาร',
              en: 'Lahan',
            },
            zipcode: '11110',
          },
          120406: {
            name: {
              th: 'ลำโพ',
              en: 'Lam Pho',
            },
            zipcode: '11110',
          },
          120407: {
            name: {
              th: 'พิมลราช',
              en: 'Phimon Rat',
            },
            zipcode: '11110',
          },
          120408: {
            name: {
              th: 'บางรักพัฒนา',
              en: 'Bang Rak Phatthana',
            },
            zipcode: '11110',
          },
        },
      },
      1205: {
        name: {
          th: 'ไทรน้อย',
          en: 'Sai Noi',
        },
        tambons: {
          120501: {
            name: {
              th: 'ไทรน้อย',
              en: 'Sai Noi',
            },
            zipcode: '11150',
          },
          120502: {
            name: {
              th: 'ราษฎร์นิยม',
              en: 'Rat Niyom',
            },
            zipcode: '11150',
          },
          120503: {
            name: {
              th: 'หนองเพรางาย',
              en: 'Nong Phrao Ngai',
            },
            zipcode: '11150',
          },
          120504: {
            name: {
              th: 'ไทรใหญ่',
              en: 'Sai Yai',
            },
            zipcode: '11150',
          },
          120505: {
            name: {
              th: 'ขุนศรี',
              en: 'Khun Si',
            },
            zipcode: '11150',
          },
          120506: {
            name: {
              th: 'คลองขวาง',
              en: 'Khlong Khwang',
            },
            zipcode: '11150',
          },
          120507: {
            name: {
              th: 'ทวีวัฒนา',
              en: 'Thawi Watthana',
            },
            zipcode: '11150',
          },
        },
      },
      1206: {
        name: {
          th: 'ปากเกร็ด',
          en: 'Pak Kret',
        },
        tambons: {
          120601: {
            name: {
              th: 'ปากเกร็ด',
              en: 'Pak Kret',
            },
            zipcode: '11120',
          },
          120602: {
            name: {
              th: 'บางตลาด',
              en: 'Bang Talat',
            },
            zipcode: '11120',
          },
          120603: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '11120',
          },
          120604: {
            name: {
              th: 'บางพูด',
              en: 'Bang Phut',
            },
            zipcode: '11120',
          },
          120605: {
            name: {
              th: 'บางตะไนย์',
              en: 'Bang Tanai',
            },
            zipcode: '11120',
          },
          120606: {
            name: {
              th: 'คลองพระอุดม',
              en: 'Khlong Phra Udom',
            },
            zipcode: '11120',
          },
          120607: {
            name: {
              th: 'ท่าอิฐ',
              en: 'Tha It',
            },
            zipcode: '11120',
          },
          120608: {
            name: {
              th: 'เกาะเกร็ด',
              en: 'Ko Kret',
            },
            zipcode: '11120',
          },
          120609: {
            name: {
              th: 'อ้อมเกร็ด',
              en: 'Om Kret',
            },
            zipcode: '11120',
          },
          120610: {
            name: {
              th: 'คลองข่อย',
              en: 'Khlong Khoi',
            },
            zipcode: '11120',
          },
          120611: {
            name: {
              th: 'บางพลับ',
              en: 'Bang Phlap',
            },
            zipcode: '11120',
          },
          120612: {
            name: {
              th: 'คลองเกลือ',
              en: 'Khlong Klueaย ',
            },
            zipcode: '11120',
          },
        },
      },
    },
  },
  13: {
    name: {
      th: 'ปทุมธานี',
      en: 'Pathum Thani',
    },
    amphoes: {
      1301: {
        name: {
          th: 'เมืองปทุมธานี',
          en: 'Muang',
        },
        tambons: {
          130101: {
            name: {
              th: 'บางปรอก',
              en: 'Bang Prok',
            },
            zipcode: '12000',
          },
          130102: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '12000',
          },
          130103: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '12000',
          },
          130104: {
            name: {
              th: 'บ้านฉาง',
              en: 'Ban Chang',
            },
            zipcode: '12000',
          },
          130105: {
            name: {
              th: 'บ้านกระแชง',
              en: 'Ban Krachaeng',
            },
            zipcode: '12000',
          },
          130106: {
            name: {
              th: 'บางขะแยง',
              en: 'Bang Khayaeng',
            },
            zipcode: '12000',
          },
          130107: {
            name: {
              th: 'บางคูวัด',
              en: 'Bang Khu Wat',
            },
            zipcode: '12000',
          },
          130108: {
            name: {
              th: 'บางหลวง',
              en: 'Bang Luang',
            },
            zipcode: '12000',
          },
          130109: {
            name: {
              th: 'บางเดื่อ',
              en: 'Bang Duea',
            },
            zipcode: '12000',
          },
          130110: {
            name: {
              th: 'บางพูด',
              en: 'Bang Phut',
            },
            zipcode: '12000',
          },
          130111: {
            name: {
              th: 'บางพูน',
              en: 'Bang Phun',
            },
            zipcode: '12000',
          },
          130112: {
            name: {
              th: 'บางกะดี',
              en: 'Bang Kadi',
            },
            zipcode: '12000',
          },
          130113: {
            name: {
              th: 'สวนพริกไทย',
              en: 'Suan Phrik Thai',
            },
            zipcode: '12000',
          },
          130114: {
            name: {
              th: 'หลักหก',
              en: 'Lak Hok',
            },
            zipcode: '12000',
          },
        },
      },
      1302: {
        name: {
          th: 'คลองหลวง',
          en: 'Khlong Luang',
        },
        tambons: {
          130201: {
            name: {
              th: 'คลองหนึ่ง',
              en: 'Khlong Nueng',
            },
            zipcode: '12120',
          },
          130202: {
            name: {
              th: 'คลองสอง',
              en: 'Khlong Song',
            },
            zipcode: '12120',
          },
          130203: {
            name: {
              th: 'คลองสาม',
              en: 'Khlong Sam',
            },
            zipcode: '12120',
          },
          130204: {
            name: {
              th: 'คลองสี่',
              en: 'Khlong Si',
            },
            zipcode: '12120',
          },
          130205: {
            name: {
              th: 'คลองห้า',
              en: 'Khlong Ha',
            },
            zipcode: '12120',
          },
          130206: {
            name: {
              th: 'คลองหก',
              en: 'Khlong Hok',
            },
            zipcode: '12120',
          },
          130207: {
            name: {
              th: 'คลองเจ็ด',
              en: 'Khlong Chet',
            },
            zipcode: '12120',
          },
        },
      },
      1303: {
        name: {
          th: 'ธัญบุรี',
          en: 'Thanyaburi',
        },
        tambons: {
          130301: {
            name: {
              th: 'ประชาธิปัตย์',
              en: 'Prachathipat',
            },
            zipcode: '12130',
          },
          130302: {
            name: {
              th: 'บึงยี่โถ',
              en: 'Bueng Yitho',
            },
            zipcode: '12130',
          },
          130303: {
            name: {
              th: 'รังสิต',
              en: 'Rangsit',
            },
            zipcode: '12110',
          },
          130304: {
            name: {
              th: 'ลำผักกูด',
              en: 'Lam Phak Kut',
            },
            zipcode: '12110',
          },
          130305: {
            name: {
              th: 'บึงสนั่น',
              en: 'Bueng Sanan',
            },
            zipcode: '12110',
          },
          130306: {
            name: {
              th: 'บึงน้ำรักษ์',
              en: 'Bueng Nam Rak',
            },
            zipcode: '12110',
          },
        },
      },
      1304: {
        name: {
          th: 'หนองเสือ',
          en: 'Nong Sua',
        },
        tambons: {
          130401: {
            name: {
              th: 'บึงบา',
              en: 'Bueng Ba',
            },
            zipcode: '12170',
          },
          130402: {
            name: {
              th: 'บึงบอน',
              en: 'Bueng Bon',
            },
            zipcode: '12170',
          },
          130403: {
            name: {
              th: 'บึงกาสาม',
              en: 'Bueng Ka Sam',
            },
            zipcode: '12170',
          },
          130404: {
            name: {
              th: 'บึงชำอ้อ',
              en: 'Bueng Cham O',
            },
            zipcode: '12170',
          },
          130405: {
            name: {
              th: 'หนองสามวัง',
              en: 'Nong Sam Wang',
            },
            zipcode: '12170',
          },
          130406: {
            name: {
              th: 'ศาลาครุ',
              en: 'Sala Khru',
            },
            zipcode: '12170',
          },
          130407: {
            name: {
              th: 'นพรัตน์',
              en: 'Noppharat',
            },
            zipcode: '12170',
          },
        },
      },
      1305: {
        name: {
          th: 'ลาดหลุมแก้ว',
          en: 'Lat Lum Kaeo',
        },
        tambons: {
          130501: {
            name: {
              th: 'ระแหง',
              en: 'Rahaeng',
            },
            zipcode: '12140',
          },
          130502: {
            name: {
              th: 'ลาดหลุมแก้ว',
              en: 'Lat Lum Kaeo',
            },
            zipcode: '12140',
          },
          130503: {
            name: {
              th: 'คูบางหลวง',
              en: 'Khu Bang Luang',
            },
            zipcode: '12140',
          },
          130504: {
            name: {
              th: 'คูขวาง',
              en: 'Khu Khwang',
            },
            zipcode: '12140',
          },
          130505: {
            name: {
              th: 'คลองพระอุดม',
              en: 'Khlong Phra Udom',
            },
            zipcode: '12140',
          },
          130506: {
            name: {
              th: 'บ่อเงิน',
              en: 'Bo Ngoen',
            },
            zipcode: '12140',
          },
          130507: {
            name: {
              th: 'หน้าไม้',
              en: 'Na Mai',
            },
            zipcode: '12140',
          },
        },
      },
      1306: {
        name: {
          th: 'ลำลูกกา',
          en: 'Lam Luk Ka',
        },
        tambons: {
          130601: {
            name: {
              th: 'คูคต',
              en: 'Khu Khot',
            },
            zipcode: '12130',
          },
          130602: {
            name: {
              th: 'ลาดสวาย',
              en: 'Lat Sawai',
            },
            zipcode: '12150',
          },
          130603: {
            name: {
              th: 'บึงคำพร้อย',
              en: 'Bueng Kham Phroi',
            },
            zipcode: '12150',
          },
          130604: {
            name: {
              th: 'ลำลูกกา',
              en: 'Lam Luk Ka',
            },
            zipcode: '12150',
          },
          130605: {
            name: {
              th: 'บึงทองหลาง',
              en: 'Bueng Thong Lang',
            },
            zipcode: '12150',
          },
          130606: {
            name: {
              th: 'ลำไทร',
              en: 'Lam Sai',
            },
            zipcode: '12150',
          },
          130607: {
            name: {
              th: 'บึงคอไห',
              en: 'Bueng Kho Hai',
            },
            zipcode: '12150',
          },
          130608: {
            name: {
              th: 'พืชอุดม',
              en: 'Phuet Udom',
            },
            zipcode: '12150',
          },
        },
      },
      1307: {
        name: {
          th: 'สามโคก',
          en: 'Sam Khok',
        },
        tambons: {
          130701: {
            name: {
              th: 'บางเตย',
              en: 'Bang Toei',
            },
            zipcode: '12160',
          },
          130702: {
            name: {
              th: 'คลองควาย',
              en: 'Khlong Khwai',
            },
            zipcode: '12160',
          },
          130703: {
            name: {
              th: 'สามโคก',
              en: 'Sam Khok',
            },
            zipcode: '12160',
          },
          130704: {
            name: {
              th: 'กระแชง',
              en: 'Krachaeng',
            },
            zipcode: '12160',
          },
          130705: {
            name: {
              th: 'บางโพธิ์เหนือ',
              en: 'Bang Pho Nuea',
            },
            zipcode: '12160',
          },
          130706: {
            name: {
              th: 'เชียงรากใหญ่',
              en: 'Chiang Rak Yai',
            },
            zipcode: '12160',
          },
          130707: {
            name: {
              th: 'บ้านปทุม',
              en: 'Ban Pathum',
            },
            zipcode: '12160',
          },
          130708: {
            name: {
              th: 'บ้านงิ้ว',
              en: 'Ban Ngio',
            },
            zipcode: '12160',
          },
          130709: {
            name: {
              th: 'เชียงรากน้อย',
              en: 'Chiang Rak Noi',
            },
            zipcode: '12160',
          },
          130710: {
            name: {
              th: 'บางกระบือ',
              en: 'Bang Krabue',
            },
            zipcode: '12160',
          },
          130711: {
            name: {
              th: 'ท้ายเกาะ',
              en: 'Thai Ko',
            },
            zipcode: '12160',
          },
        },
      },
    },
  },
  14: {
    name: {
      th: 'พระนครศรีอยุธยา',
      en: 'Phra Nakhon Si Ayutthaya',
    },
    amphoes: {
      1401: {
        name: {
          th: 'พระนครศรีอยุธยา',
          en: 'Phra Nakhon SiAyutthaya',
        },
        tambons: {
          140101: {
            name: {
              th: 'ประตูชัย',
              en: 'Pratu Chai',
            },
            zipcode: '13000',
          },
          140102: {
            name: {
              th: 'กะมัง',
              en: 'Kamang',
            },
            zipcode: '13000',
          },
          140103: {
            name: {
              th: 'หอรัตนไชย',
              en: 'Ho Rattanachai',
            },
            zipcode: '13000',
          },
          140104: {
            name: {
              th: 'หัวรอ',
              en: 'Hua Ro',
            },
            zipcode: '13000',
          },
          140105: {
            name: {
              th: 'ท่าวาสุกรี',
              en: 'Tha Wasukri',
            },
            zipcode: '13000',
          },
          140106: {
            name: {
              th: 'ไผ่ลิง',
              en: 'Phai Ling',
            },
            zipcode: '13000',
          },
          140107: {
            name: {
              th: 'ปากกราน',
              en: 'Pak Kran',
            },
            zipcode: '13000',
          },
          140108: {
            name: {
              th: 'ภูเขาทอง',
              en: 'Phukhao Thong',
            },
            zipcode: '13000',
          },
          140109: {
            name: {
              th: 'สำเภาล่ม',
              en: 'Samphao Lom',
            },
            zipcode: '13000',
          },
          140110: {
            name: {
              th: 'สวนพริก',
              en: 'Suan Phrik',
            },
            zipcode: '13000',
          },
          140111: {
            name: {
              th: 'คลองตะเคียน',
              en: 'Khlong Takhian',
            },
            zipcode: '13000',
          },
          140112: {
            name: {
              th: 'วัดตูม',
              en: 'Wat Tum',
            },
            zipcode: '13000',
          },
          140113: {
            name: {
              th: 'หันตรา',
              en: 'Hantra',
            },
            zipcode: '13000',
          },
          140114: {
            name: {
              th: 'ลุมพลี',
              en: 'Lumphli',
            },
            zipcode: '13000',
          },
          140115: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '13000',
          },
          140116: {
            name: {
              th: 'บ้านเกาะ',
              en: 'Ban Ko',
            },
            zipcode: '13000',
          },
          140117: {
            name: {
              th: 'คลองสวนพลู',
              en: 'Khlong Suan Phlu',
            },
            zipcode: '13000',
          },
          140118: {
            name: {
              th: 'คลองสระบัว',
              en: 'Khlong Sa Bua',
            },
            zipcode: '13000',
          },
          140119: {
            name: {
              th: 'เกาะเรียน',
              en: 'Ko Rian',
            },
            zipcode: '13000',
          },
          140120: {
            name: {
              th: 'บ้านป้อม',
              en: 'Ban Pom',
            },
            zipcode: '13000',
          },
          140121: {
            name: {
              th: 'บ้านรุน',
              en: 'Ban Run',
            },
            zipcode: '13000',
          },
        },
      },
      1402: {
        name: {
          th: 'ท่าเรือ',
          en: 'Tha Rua',
        },
        tambons: {
          140201: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '13130',
          },
          140202: {
            name: {
              th: 'จำปา',
              en: 'Champa',
            },
            zipcode: '13130',
          },
          140203: {
            name: {
              th: 'ท่าหลวง',
              en: 'Tha Luang',
            },
            zipcode: '13130',
          },
          140204: {
            name: {
              th: 'บ้านร่อม',
              en: 'Ban Rom',
            },
            zipcode: '13130',
          },
          140205: {
            name: {
              th: 'ศาลาลอย',
              en: 'Sala Loi',
            },
            zipcode: '13130',
          },
          140206: {
            name: {
              th: 'วังแดง',
              en: 'Wang Daeng',
            },
            zipcode: '13130',
          },
          140207: {
            name: {
              th: 'โพธิ์เอน',
              en: 'Pho En',
            },
            zipcode: '13130',
          },
          140208: {
            name: {
              th: 'ปากท่า',
              en: 'Pak Tha',
            },
            zipcode: '13130',
          },
          140209: {
            name: {
              th: 'หนองขนาก',
              en: 'Nong Khanak',
            },
            zipcode: '13130',
          },
          140210: {
            name: {
              th: 'ท่าเจ้าสนุก',
              en: 'Tha Chao Sanuk',
            },
            zipcode: '13130',
          },
        },
      },
      1403: {
        name: {
          th: 'นครหลวง',
          en: 'Nakhon Luang',
        },
        tambons: {
          140301: {
            name: {
              th: 'นครหลวง',
              en: 'Nakhon Luang',
            },
            zipcode: '13260',
          },
          140302: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '13260',
          },
          140303: {
            name: {
              th: 'บ่อโพง',
              en: 'Bo Phong',
            },
            zipcode: '13260',
          },
          140304: {
            name: {
              th: 'บ้านชุ้ง',
              en: 'Ban Chung',
            },
            zipcode: '13260',
          },
          140305: {
            name: {
              th: 'ปากจั่น',
              en: 'Pak Chan',
            },
            zipcode: '13260',
          },
          140306: {
            name: {
              th: 'บางระกำ',
              en: 'Bang Rakam',
            },
            zipcode: '13260',
          },
          140307: {
            name: {
              th: 'บางพระครู',
              en: 'Bang Phra Khru',
            },
            zipcode: '13260',
          },
          140308: {
            name: {
              th: 'แม่ลา',
              en: 'Mae La',
            },
            zipcode: '13260',
          },
          140309: {
            name: {
              th: 'หนองปลิง',
              en: 'Nong Pling',
            },
            zipcode: '13260',
          },
          140310: {
            name: {
              th: 'คลองสะแก',
              en: 'Khlong Sakae',
            },
            zipcode: '13260',
          },
          140311: {
            name: {
              th: 'สามไถ',
              en: 'Sam Thai',
            },
            zipcode: '13260',
          },
          140312: {
            name: {
              th: 'พระนอน',
              en: 'Phra Non',
            },
            zipcode: '13260',
          },
        },
      },
      1404: {
        name: {
          th: 'บางไทร',
          en: 'Bang Sai',
        },
        tambons: {
          140401: {
            name: {
              th: 'บางไทร',
              en: 'Bang Sai',
            },
            zipcode: '13190',
          },
          140402: {
            name: {
              th: 'บางพลี',
              en: 'Bang Phli',
            },
            zipcode: '13190',
          },
          140403: {
            name: {
              th: 'สนามชัย',
              en: 'Sanam Chai',
            },
            zipcode: '13190',
          },
          140404: {
            name: {
              th: 'บ้านแป้ง',
              en: 'Ban Paeng',
            },
            zipcode: '13190',
          },
          140405: {
            name: {
              th: 'หน้าไม้',
              en: 'Na Mai',
            },
            zipcode: '13190',
          },
          140406: {
            name: {
              th: 'บางยี่โท',
              en: 'Bang Yi Tho',
            },
            zipcode: '13190',
          },
          140407: {
            name: {
              th: 'แคออก',
              en: 'Khae Ok',
            },
            zipcode: '13190',
          },
          140408: {
            name: {
              th: 'แคตก',
              en: 'Khae Tok',
            },
            zipcode: '13190',
          },
          140409: {
            name: {
              th: 'ช่างเหล็ก',
              en: 'Chang Lek',
            },
            zipcode: '13190',
          },
          140410: {
            name: {
              th: 'กระแชง',
              en: 'Krachaeng',
            },
            zipcode: '13190',
          },
          140411: {
            name: {
              th: 'บ้านกลึง',
              en: 'Ban Klueng',
            },
            zipcode: '13190',
          },
          140412: {
            name: {
              th: 'ช้างน้อย',
              en: 'Chang Noi',
            },
            zipcode: '13190',
          },
          140413: {
            name: {
              th: 'ห่อหมก',
              en: 'Homok',
            },
            zipcode: '13190',
          },
          140414: {
            name: {
              th: 'ไผ่พระ',
              en: 'Phai Phra',
            },
            zipcode: '13190',
          },
          140415: {
            name: {
              th: 'กกแก้วบูรพา',
              en: 'Kok Kaeo Burapha',
            },
            zipcode: '13190',
          },
          140416: {
            name: {
              th: 'ไม้ตรา',
              en: 'Mai Tra',
            },
            zipcode: '13190',
          },
          140417: {
            name: {
              th: 'บ้านม้า',
              en: 'Ban Ma',
            },
            zipcode: '13190',
          },
          140418: {
            name: {
              th: 'บ้านเกาะ',
              en: 'Ban Ko',
            },
            zipcode: '13190',
          },
          140419: {
            name: {
              th: 'ราชคราม',
              en: 'Ratchakhram',
            },
            zipcode: '13290',
          },
          140420: {
            name: {
              th: 'ช้างใหญ่',
              en: 'Chang Yai',
            },
            zipcode: '13290',
          },
          140421: {
            name: {
              th: 'โพแตง',
              en: 'Pho Taeng',
            },
            zipcode: '13290',
          },
          140422: {
            name: {
              th: 'เชียงรากน้อย',
              en: 'Chiang Rak Noi',
            },
            zipcode: '13290',
          },
          140423: {
            name: {
              th: 'โคกช้าง',
              en: 'Khok Chang',
            },
            zipcode: '13190',
          },
        },
      },
      1405: {
        name: {
          th: 'บางบาล',
          en: 'Bang Ban',
        },
        tambons: {
          140501: {
            name: {
              th: 'บางบาล',
              en: 'Bang Ban',
            },
            zipcode: '13250',
          },
          140502: {
            name: {
              th: 'วัดยม',
              en: 'Wat Yom',
            },
            zipcode: '13250',
          },
          140503: {
            name: {
              th: 'ไทรน้อย',
              en: 'Sai Noi',
            },
            zipcode: '13250',
          },
          140504: {
            name: {
              th: 'สะพานไทย',
              en: 'Saphan Thai',
            },
            zipcode: '13250',
          },
          140505: {
            name: {
              th: 'มหาพราหมณ์',
              en: 'Maha Phram',
            },
            zipcode: '13250',
          },
          140506: {
            name: {
              th: 'กบเจา',
              en: 'Kop Chao',
            },
            zipcode: '13250',
          },
          140507: {
            name: {
              th: 'บ้านคลัง',
              en: 'Ban Khlang',
            },
            zipcode: '13250',
          },
          140508: {
            name: {
              th: 'พระขาว',
              en: 'Phra Khao',
            },
            zipcode: '13250',
          },
          140509: {
            name: {
              th: 'น้ำเต้า',
              en: 'Nam Tao',
            },
            zipcode: '13250',
          },
          140510: {
            name: {
              th: 'ทางช้าง',
              en: 'Thang Chang',
            },
            zipcode: '13250',
          },
          140511: {
            name: {
              th: 'วัดตะกู',
              en: 'Wat Taku',
            },
            zipcode: '13250',
          },
          140512: {
            name: {
              th: 'บางหลวง',
              en: 'Bang Luang',
            },
            zipcode: '13250',
          },
          140513: {
            name: {
              th: 'บางหลวงโดด',
              en: 'Bang Luang Dot',
            },
            zipcode: '13250',
          },
          140514: {
            name: {
              th: 'บางหัก',
              en: 'Bang Hak',
            },
            zipcode: '13250',
          },
          140515: {
            name: {
              th: 'บางชะนี',
              en: 'Bang Chani',
            },
            zipcode: '13250',
          },
          140516: {
            name: {
              th: 'บ้านกุ่ม',
              en: 'Ban Kum',
            },
            zipcode: '13250',
          },
        },
      },
      1406: {
        name: {
          th: 'บางปะอิน',
          en: 'Bang Pa-In',
        },
        tambons: {
          140601: {
            name: {
              th: 'บ้านเลน',
              en: 'Ban Len',
            },
            zipcode: '13160',
          },
          140602: {
            name: {
              th: 'เชียงรากน้อย',
              en: 'Chiang Rak Noi',
            },
            zipcode: '13180',
          },
          140603: {
            name: {
              th: 'บ้านโพ',
              en: 'Ban Pho',
            },
            zipcode: '13160',
          },
          140604: {
            name: {
              th: 'บ้านกรด',
              en: 'Ban Krot',
            },
            zipcode: '13160',
          },
          140605: {
            name: {
              th: 'บางกระสั้น',
              en: 'Bang Krasan',
            },
            zipcode: '13160',
          },
          140606: {
            name: {
              th: 'คลองจิก',
              en: 'Khlong Chik',
            },
            zipcode: '13160',
          },
          140607: {
            name: {
              th: 'บ้านหว้า',
              en: 'Ban Wa',
            },
            zipcode: '13160',
          },
          140608: {
            name: {
              th: 'วัดยม',
              en: 'Wat Yom',
            },
            zipcode: '13160',
          },
          140609: {
            name: {
              th: 'บางประแดง',
              en: 'Bang Pradaeng',
            },
            zipcode: '13160',
          },
          140610: {
            name: {
              th: 'สามเรือน',
              en: 'Sam Ruean',
            },
            zipcode: '13160',
          },
          140611: {
            name: {
              th: 'เกาะเกิด',
              en: 'Ko Koet',
            },
            zipcode: '13160',
          },
          140612: {
            name: {
              th: 'บ้านพลับ',
              en: 'Ban Phlap',
            },
            zipcode: '13160',
          },
          140613: {
            name: {
              th: 'บ้านแป้ง',
              en: 'Ban Paeng',
            },
            zipcode: '13160',
          },
          140614: {
            name: {
              th: 'คุ้งลาน',
              en: 'Khung Lan',
            },
            zipcode: '13160',
          },
          140615: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '13160',
          },
          140616: {
            name: {
              th: 'บ้านสร้าง',
              en: 'Ban Sang',
            },
            zipcode: '13170',
          },
          140617: {
            name: {
              th: 'ตลาดเกรียบ',
              en: 'Talat Kriap',
            },
            zipcode: '13160',
          },
          140618: {
            name: {
              th: 'ขนอนหลวง',
              en: 'Khanon Luang',
            },
            zipcode: '13160',
          },
        },
      },
      1407: {
        name: {
          th: 'บางปะหัน',
          en: 'Bang Pahan',
        },
        tambons: {
          140701: {
            name: {
              th: 'บางปะหัน',
              en: 'Bang Pahan',
            },
            zipcode: '13220',
          },
          140702: {
            name: {
              th: 'ขยาย',
              en: 'Khayai',
            },
            zipcode: '13220',
          },
          140703: {
            name: {
              th: 'บางเดื่อ',
              en: 'Bang Duea',
            },
            zipcode: '13220',
          },
          140704: {
            name: {
              th: 'เสาธง',
              en: 'Sao Thong',
            },
            zipcode: '13220',
          },
          140705: {
            name: {
              th: 'ทางกลาง',
              en: 'Thang Klang',
            },
            zipcode: '13220',
          },
          140706: {
            name: {
              th: 'บางเพลิง',
              en: 'Bang Phloeng',
            },
            zipcode: '13220',
          },
          140707: {
            name: {
              th: 'หันสัง',
              en: 'Hansang',
            },
            zipcode: '13220',
          },
          140708: {
            name: {
              th: 'บางนางร้า',
              en: 'Bang Nang Ra',
            },
            zipcode: '13220',
          },
          140709: {
            name: {
              th: 'ตานิม',
              en: 'Ta Nim',
            },
            zipcode: '13220',
          },
          140710: {
            name: {
              th: 'ทับน้ำ',
              en: 'Thap Nam',
            },
            zipcode: '13220',
          },
          140711: {
            name: {
              th: 'บ้านม้า',
              en: 'Ban Ma',
            },
            zipcode: '13220',
          },
          140712: {
            name: {
              th: 'ขวัญเมือง',
              en: 'Khwan Mueang',
            },
            zipcode: '13220',
          },
          140713: {
            name: {
              th: 'บ้านลี่',
              en: 'Ban Li',
            },
            zipcode: '13220',
          },
          140714: {
            name: {
              th: 'โพธิ์สามต้น',
              en: 'Pho Sam Ton',
            },
            zipcode: '13220',
          },
          140715: {
            name: {
              th: 'พุทเลา',
              en: 'Phutlao',
            },
            zipcode: '13220',
          },
          140716: {
            name: {
              th: 'ตาลเอน',
              en: 'Tan En',
            },
            zipcode: '13220',
          },
          140717: {
            name: {
              th: 'บ้านขล้อ',
              en: 'Ban Khlo',
            },
            zipcode: '13220',
          },
        },
      },
      1408: {
        name: {
          th: 'ผักไห่',
          en: 'Phak Hai',
        },
        tambons: {
          140801: {
            name: {
              th: 'ผักไห่',
              en: 'Phak Hai',
            },
            zipcode: '13120',
          },
          140802: {
            name: {
              th: 'อมฤต',
              en: 'Ammarit',
            },
            zipcode: '13120',
          },
          140803: {
            name: {
              th: 'บ้านแค',
              en: 'Ban Khae',
            },
            zipcode: '13120',
          },
          140804: {
            name: {
              th: 'ลาดน้ำเค็ม',
              en: 'Lat Nam Khem',
            },
            zipcode: '13120',
          },
          140805: {
            name: {
              th: 'ตาลาน',
              en: 'Talan',
            },
            zipcode: '13120',
          },
          140806: {
            name: {
              th: 'ท่าดินแดง',
              en: 'Tha Din Daeng',
            },
            zipcode: '13120',
          },
          140807: {
            name: {
              th: 'ดอนลาน',
              en: 'Don Lan',
            },
            zipcode: '13280',
          },
          140808: {
            name: {
              th: 'นาคู',
              en: 'Na Khu',
            },
            zipcode: '13280',
          },
          140809: {
            name: {
              th: 'กุฎี',
              en: 'Kudi',
            },
            zipcode: '13120',
          },
          140810: {
            name: {
              th: 'ลำตะเคียน',
              en: 'Lam Takhian',
            },
            zipcode: '13280',
          },
          140811: {
            name: {
              th: 'โคกช้าง',
              en: 'Khok Chang',
            },
            zipcode: '13120',
          },
          140812: {
            name: {
              th: 'จักราช',
              en: 'Chakkarat',
            },
            zipcode: '13280',
          },
          140813: {
            name: {
              th: 'หนองน้ำใหญ่',
              en: 'Nong Nam Yai',
            },
            zipcode: '13280',
          },
          140814: {
            name: {
              th: 'ลาดชิด',
              en: 'Lat Chit',
            },
            zipcode: '13120',
          },
          140815: {
            name: {
              th: 'หน้าโคก',
              en: 'Na Khok',
            },
            zipcode: '13120',
          },
          140816: {
            name: {
              th: 'บ้านใหญ่',
              en: 'Ban Yai',
            },
            zipcode: '13120',
          },
        },
      },
      1409: {
        name: {
          th: 'ภาชี',
          en: 'Phachi',
        },
        tambons: {
          140901: {
            name: {
              th: 'ภาชี',
              en: 'Phachi',
            },
            zipcode: '13140',
          },
          140902: {
            name: {
              th: 'โคกม่วง',
              en: 'Khok Muang',
            },
            zipcode: '13140',
          },
          140903: {
            name: {
              th: 'ระโสม',
              en: 'Rasom',
            },
            zipcode: '13140',
          },
          140904: {
            name: {
              th: 'หนองน้ำใส',
              en: 'Nong Nam Sai',
            },
            zipcode: '13140',
          },
          140905: {
            name: {
              th: 'ดอนหญ้านาง',
              en: 'Don Ya Nang',
            },
            zipcode: '13140',
          },
          140906: {
            name: {
              th: 'ไผ่ล้อม',
              en: 'Phai Lom',
            },
            zipcode: '13140',
          },
          140907: {
            name: {
              th: 'กระจิว',
              en: 'Krachio',
            },
            zipcode: '13140',
          },
          140908: {
            name: {
              th: 'พระแก้ว',
              en: 'Phra Kaeo',
            },
            zipcode: '13140',
          },
        },
      },
      1410: {
        name: {
          th: 'ลาดบัวหลวง',
          en: 'Lat Bua Luang',
        },
        tambons: {
          141001: {
            name: {
              th: 'ลาดบัวหลวง',
              en: 'Lat Bua Luang',
            },
            zipcode: '13230',
          },
          141002: {
            name: {
              th: 'หลักชัย',
              en: 'Lakchai',
            },
            zipcode: '13230',
          },
          141003: {
            name: {
              th: 'สามเมือง',
              en: 'Sam Mueang',
            },
            zipcode: '13230',
          },
          141004: {
            name: {
              th: 'พระยาบันลือ',
              en: 'Phraya Banlue',
            },
            zipcode: '13230',
          },
          141005: {
            name: {
              th: 'สิงหนาท',
              en: 'Singhanat',
            },
            zipcode: '13230',
          },
          141006: {
            name: {
              th: 'คู้สลอด',
              en: 'Khu Salot',
            },
            zipcode: '13230',
          },
          141007: {
            name: {
              th: 'คลองพระยาบันลือ',
              en: 'Khlong Phraya Banlue',
            },
            zipcode: '13230',
          },
        },
      },
      1411: {
        name: {
          th: 'วังน้อย',
          en: 'Wang Noi',
        },
        tambons: {
          141101: {
            name: {
              th: 'ลำตาเสา',
              en: 'Lam Ta Sao',
            },
            zipcode: '13170',
          },
          141102: {
            name: {
              th: 'บ่อตาโล่',
              en: 'Bo Ta Lo',
            },
            zipcode: '13170',
          },
          141103: {
            name: {
              th: 'วังน้อย',
              en: 'Wang Noi',
            },
            zipcode: '13170',
          },
          141104: {
            name: {
              th: 'ลำไทร',
              en: 'Lam Sai',
            },
            zipcode: '13170',
          },
          141105: {
            name: {
              th: 'สนับทึบ',
              en: 'Sanap Thuep',
            },
            zipcode: '13170',
          },
          141106: {
            name: {
              th: 'พยอม',
              en: 'Phayom',
            },
            zipcode: '13170',
          },
          141107: {
            name: {
              th: 'หันตะเภา',
              en: 'Han Taphao',
            },
            zipcode: '13170',
          },
          141108: {
            name: {
              th: 'วังจุฬา',
              en: 'Wang Chula',
            },
            zipcode: '13170',
          },
          141109: {
            name: {
              th: 'ข้าวงาม',
              en: 'Khao Ngam',
            },
            zipcode: '13170',
          },
          141110: {
            name: {
              th: 'ชะแมบ',
              en: 'Chamaep',
            },
            zipcode: '13170',
          },
        },
      },
      1412: {
        name: {
          th: 'เสนา',
          en: 'Sena',
        },
        tambons: {
          141201: {
            name: {
              th: 'เสนา',
              en: 'Sena',
            },
            zipcode: '13110',
          },
          141202: {
            name: {
              th: 'บ้านแพน',
              en: 'Ban Phaen',
            },
            zipcode: '13110',
          },
          141203: {
            name: {
              th: 'เจ้าเจ็ด',
              en: 'Chao Chet',
            },
            zipcode: '13110',
          },
          141204: {
            name: {
              th: 'สามกอ',
              en: 'Sam Ko',
            },
            zipcode: '13110',
          },
          141205: {
            name: {
              th: 'บางนมโค',
              en: 'Bang Nom Kho',
            },
            zipcode: '13110',
          },
          141206: {
            name: {
              th: 'หัวเวียง',
              en: 'Hua Wiang',
            },
            zipcode: '13110',
          },
          141207: {
            name: {
              th: 'มารวิชัย',
              en: 'Manwichai',
            },
            zipcode: '13110',
          },
          141208: {
            name: {
              th: 'บ้านโพธิ์',
              en: 'Ban Pho',
            },
            zipcode: '13110',
          },
          141209: {
            name: {
              th: 'รางจรเข้',
              en: 'Rang Chon Khe',
            },
            zipcode: '13110',
          },
          141210: {
            name: {
              th: 'บ้านกระทุ่ม',
              en: 'Ban Krathum',
            },
            zipcode: '13110',
          },
          141211: {
            name: {
              th: 'บ้านแถว',
              en: 'Ban Thaeo',
            },
            zipcode: '13110',
          },
          141212: {
            name: {
              th: 'ชายนา',
              en: 'Chai Na',
            },
            zipcode: '13110',
          },
          141213: {
            name: {
              th: 'สามตุ่ม',
              en: 'Sam Tum',
            },
            zipcode: '13110',
          },
          141214: {
            name: {
              th: 'ลาดงา',
              en: 'Lat Nga',
            },
            zipcode: '13110',
          },
          141215: {
            name: {
              th: 'ดอนทอง',
              en: 'Don Thong',
            },
            zipcode: '13110',
          },
          141216: {
            name: {
              th: 'บ้านหลวง',
              en: 'Ban Luang',
            },
            zipcode: '13110',
          },
          141217: {
            name: {
              th: 'เจ้าเสด็จ',
              en: 'Chao Sadet',
            },
            zipcode: '13110',
          },
        },
      },
      1413: {
        name: {
          th: 'บางซ้าย',
          en: 'Bang Sai',
        },
        tambons: {
          141301: {
            name: {
              th: 'บางซ้าย',
              en: 'Bang Sai',
            },
            zipcode: '13270',
          },
          141302: {
            name: {
              th: 'แก้วฟ้า',
              en: 'Kaeo Fa',
            },
            zipcode: '13270',
          },
          141303: {
            name: {
              th: 'เต่าเล่า',
              en: 'Tao Lao',
            },
            zipcode: '13270',
          },
          141304: {
            name: {
              th: 'ปลายกลัด',
              en: 'Plai Klat',
            },
            zipcode: '13270',
          },
          141305: {
            name: {
              th: 'เทพมงคล',
              en: 'Thepphamongkhon',
            },
            zipcode: '13270',
          },
          141306: {
            name: {
              th: 'วังพัฒนา',
              en: 'Wang Phatthana',
            },
            zipcode: '13270',
          },
        },
      },
      1414: {
        name: {
          th: 'อุทัย',
          en: 'Uthai',
        },
        tambons: {
          141401: {
            name: {
              th: 'คานหาม',
              en: 'Khan Ham',
            },
            zipcode: '13210',
          },
          141402: {
            name: {
              th: 'บ้านช้าง',
              en: 'Ban Chang',
            },
            zipcode: '13210',
          },
          141403: {
            name: {
              th: 'สามบัณฑิต',
              en: 'Sam Bandit',
            },
            zipcode: '13210',
          },
          141404: {
            name: {
              th: 'บ้านหีบ',
              en: 'Ban Hip',
            },
            zipcode: '13210',
          },
          141405: {
            name: {
              th: 'หนองไม้ซุง',
              en: 'Nong Mai Sung',
            },
            zipcode: '13210',
          },
          141406: {
            name: {
              th: 'อุทัย',
              en: 'Uthai',
            },
            zipcode: '13210',
          },
          141407: {
            name: {
              th: 'เสนา',
              en: 'Sena',
            },
            zipcode: '13210',
          },
          141408: {
            name: {
              th: 'หนองน้ำส้ม',
              en: 'Nong Nam Som',
            },
            zipcode: '13210',
          },
          141409: {
            name: {
              th: 'โพสาวหาญ',
              en: 'Pho Sao Han',
            },
            zipcode: '13210',
          },
          141410: {
            name: {
              th: 'ธนู',
              en: 'Thanu',
            },
            zipcode: '13210',
          },
          141411: {
            name: {
              th: 'ข้าวเม่า',
              en: 'Khao Mao',
            },
            zipcode: '13210',
          },
        },
      },
      1415: {
        name: {
          th: 'มหาราช',
          en: 'Maharat',
        },
        tambons: {
          141501: {
            name: {
              th: 'หัวไผ่',
              en: 'Hua Phai',
            },
            zipcode: '13150',
          },
          141502: {
            name: {
              th: 'กะทุ่ม',
              en: 'Kathum',
            },
            zipcode: '13150',
          },
          141503: {
            name: {
              th: 'มหาราช',
              en: 'MahaRat',
            },
            zipcode: '13150',
          },
          141504: {
            name: {
              th: 'น้ำเต้า',
              en: 'Nam Tao',
            },
            zipcode: '13150',
          },
          141505: {
            name: {
              th: 'บางนา',
              en: 'Bang Na',
            },
            zipcode: '13150',
          },
          141506: {
            name: {
              th: 'โรงช้าง',
              en: 'Rong Chang',
            },
            zipcode: '13150',
          },
          141507: {
            name: {
              th: 'เจ้าปลุก',
              en: 'ChaoPluk',
            },
            zipcode: '13150',
          },
          141508: {
            name: {
              th: 'พิตเพียน',
              en: 'Phitphian',
            },
            zipcode: '13150',
          },
          141509: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '13150',
          },
          141510: {
            name: {
              th: 'บ้านขวาง',
              en: 'Ban Khwang',
            },
            zipcode: '13150',
          },
          141511: {
            name: {
              th: 'ท่าตอ',
              en: 'ThaTo',
            },
            zipcode: '13150',
          },
          141512: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '13150',
          },
        },
      },
      1416: {
        name: {
          th: 'บ้านแพรก',
          en: 'Ban Phraek',
        },
        tambons: {
          141601: {
            name: {
              th: 'บ้านแพรก',
              en: 'Banย  Phraek',
            },
            zipcode: '13240',
          },
          141602: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '13240',
          },
          141603: {
            name: {
              th: 'สำพะเนียง',
              en: 'Sam Phaniang',
            },
            zipcode: '13240',
          },
          141604: {
            name: {
              th: 'คลองน้อย',
              en: 'Khlong Noi',
            },
            zipcode: '13240',
          },
          141605: {
            name: {
              th: 'สองห้อง',
              en: 'Song Hong',
            },
            zipcode: '13240',
          },
        },
      },
    },
  },
  15: {
    name: {
      th: 'อ่างทอง',
      en: 'Ang Thong',
    },
    amphoes: {
      1501: {
        name: {
          th: 'เมืองอ่างทอง',
          en: 'Muang',
        },
        tambons: {
          150101: {
            name: {
              th: 'ตลาดหลวง',
              en: 'Talat Luang',
            },
            zipcode: '14000',
          },
          150102: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '14000',
          },
          150103: {
            name: {
              th: 'ศาลาแดง',
              en: 'Sala Daeng',
            },
            zipcode: '14000',
          },
          150104: {
            name: {
              th: 'ป่างิ้ว',
              en: 'Pa Ngio',
            },
            zipcode: '14000',
          },
          150105: {
            name: {
              th: 'บ้านแห',
              en: 'Ban Hae',
            },
            zipcode: '14000',
          },
          150106: {
            name: {
              th: 'ตลาดกรวด',
              en: 'Talat Kruat',
            },
            zipcode: '14000',
          },
          150107: {
            name: {
              th: 'มหาดไทย',
              en: 'Mahat Thai',
            },
            zipcode: '14000',
          },
          150108: {
            name: {
              th: 'บ้านอิฐ',
              en: 'Ban It',
            },
            zipcode: '14000',
          },
          150109: {
            name: {
              th: 'หัวไผ่',
              en: 'Hua Phai',
            },
            zipcode: '14000',
          },
          150110: {
            name: {
              th: 'จำปาหล่อ',
              en: 'Champa Lo',
            },
            zipcode: '14000',
          },
          150111: {
            name: {
              th: 'โพสะ',
              en: 'Phosa',
            },
            zipcode: '14000',
          },
          150112: {
            name: {
              th: 'บ้านรี',
              en: 'Ban Ri',
            },
            zipcode: '14000',
          },
          150113: {
            name: {
              th: 'คลองวัว',
              en: 'Khlong Wua',
            },
            zipcode: '14000',
          },
          150114: {
            name: {
              th: 'ย่านซื่อ',
              en: 'Yan Sue',
            },
            zipcode: '14000',
          },
        },
      },
      1502: {
        name: {
          th: 'ไชโย',
          en: 'ChaiYo',
        },
        tambons: {
          150201: {
            name: {
              th: 'จรเข้ร้อง',
              en: 'Chorakhe Rong',
            },
            zipcode: '14140',
          },
          150202: {
            name: {
              th: 'ไชยภูมิ',
              en: 'Chaiyaphum',
            },
            zipcode: '14140',
          },
          150203: {
            name: {
              th: 'ชัยฤทธิ์',
              en: 'Chaiyarit',
            },
            zipcode: '14140',
          },
          150204: {
            name: {
              th: 'เทวราช',
              en: 'Thewarat',
            },
            zipcode: '14140',
          },
          150205: {
            name: {
              th: 'ราชสถิตย์',
              en: 'Ratchasathit',
            },
            zipcode: '14140',
          },
          150206: {
            name: {
              th: 'ไชโย',
              en: 'Chaiyo',
            },
            zipcode: '14140',
          },
          150207: {
            name: {
              th: 'หลักฟ้า',
              en: 'Lak Fa',
            },
            zipcode: '14140',
          },
          150208: {
            name: {
              th: 'ชะไว',
              en: 'Chawai',
            },
            zipcode: '14140',
          },
          150209: {
            name: {
              th: 'ตรีณรงค์',
              en: 'Tri Narong',
            },
            zipcode: '14140',
          },
        },
      },
      1503: {
        name: {
          th: 'ป่าโมก',
          en: 'PaMok',
        },
        tambons: {
          150301: {
            name: {
              th: 'บางปลากด',
              en: 'Bang Pla Kot',
            },
            zipcode: '14130',
          },
          150302: {
            name: {
              th: 'ป่าโมก',
              en: 'Pa Mok',
            },
            zipcode: '14130',
          },
          150303: {
            name: {
              th: 'สายทอง',
              en: 'Sai Thong',
            },
            zipcode: '14130',
          },
          150304: {
            name: {
              th: 'โรงช้าง',
              en: 'Rong Chang',
            },
            zipcode: '14130',
          },
          150305: {
            name: {
              th: 'บางเสด็จ',
              en: 'Bang Sadet',
            },
            zipcode: '14130',
          },
          150306: {
            name: {
              th: 'นรสิงห์',
              en: 'Norasing',
            },
            zipcode: '14130',
          },
          150307: {
            name: {
              th: 'เอกราช',
              en: 'Ekkarat',
            },
            zipcode: '14130',
          },
          150308: {
            name: {
              th: 'โผงเผง',
              en: 'Phong Pheng',
            },
            zipcode: '14130',
          },
        },
      },
      1504: {
        name: {
          th: 'โพธิ์ทอง',
          en: 'PoThong',
        },
        tambons: {
          150401: {
            name: {
              th: 'อ่างแก้ว',
              en: 'Ang Kaeo',
            },
            zipcode: '14120',
          },
          150402: {
            name: {
              th: 'อินทประมูล',
              en: 'Inthapramun',
            },
            zipcode: '14120',
          },
          150403: {
            name: {
              th: 'บางพลับ',
              en: 'Bang Phlap',
            },
            zipcode: '14120',
          },
          150404: {
            name: {
              th: 'หนองแม่ไก่',
              en: 'Nong Mae Kai',
            },
            zipcode: '14120',
          },
          150405: {
            name: {
              th: 'รำมะสัก',
              en: 'Ram Ma Sak',
            },
            zipcode: '14120',
          },
          150406: {
            name: {
              th: 'บางระกำ',
              en: 'Bang Rakam',
            },
            zipcode: '14120',
          },
          150407: {
            name: {
              th: 'โพธิ์รังนก',
              en: 'Pho Rang Nok',
            },
            zipcode: '14120',
          },
          150408: {
            name: {
              th: 'องครักษ์',
              en: 'Ongkharak',
            },
            zipcode: '14120',
          },
          150409: {
            name: {
              th: 'โคกพุทรา',
              en: 'Khok Phutsa',
            },
            zipcode: '14120',
          },
          150410: {
            name: {
              th: 'ยางช้าย',
              en: 'Yang Chai',
            },
            zipcode: '14120',
          },
          150411: {
            name: {
              th: 'บ่อแร่',
              en: 'Bo Rae',
            },
            zipcode: '14120',
          },
          150412: {
            name: {
              th: 'ทางพระ',
              en: 'Thang Phra',
            },
            zipcode: '14120',
          },
          150413: {
            name: {
              th: 'สามง่าม',
              en: 'Sam Ngam',
            },
            zipcode: '14120',
          },
          150414: {
            name: {
              th: 'บางเจ้าฉ่า',
              en: 'Bang Chao Cha',
            },
            zipcode: '14120',
          },
          150415: {
            name: {
              th: 'คำหยาด',
              en: 'Kham Yat',
            },
            zipcode: '14120',
          },
        },
      },
      1505: {
        name: {
          th: 'แสวงหา',
          en: 'Sawaengha',
        },
        tambons: {
          150501: {
            name: {
              th: 'แสวงหา',
              en: 'Sawaeng Ha',
            },
            zipcode: '14150',
          },
          150502: {
            name: {
              th: 'ศรีพราน',
              en: 'Si Phran',
            },
            zipcode: '14150',
          },
          150503: {
            name: {
              th: 'บ้านพราน',
              en: 'Ban Phran',
            },
            zipcode: '14150',
          },
          150504: {
            name: {
              th: 'วังน้ำเย็น',
              en: 'Wang Nam Yen',
            },
            zipcode: '14150',
          },
          150505: {
            name: {
              th: 'สีบัวทอง',
              en: 'Si Bua Thong',
            },
            zipcode: '14150',
          },
          150506: {
            name: {
              th: 'ห้วยไผ่',
              en: 'Huai Phai',
            },
            zipcode: '14150',
          },
          150507: {
            name: {
              th: 'จำลอง',
              en: 'Chamlong',
            },
            zipcode: '14150',
          },
        },
      },
      1506: {
        name: {
          th: 'วิเศษชัยชาญ',
          en: 'Wiset Chai Chan',
        },
        tambons: {
          150601: {
            name: {
              th: 'ไผ่จำศิล',
              en: 'Phai Cham Sin',
            },
            zipcode: '14110',
          },
          150602: {
            name: {
              th: 'ศาลเจ้าโรงทอง',
              en: 'San Chao Rong Thong',
            },
            zipcode: '14110',
          },
          150603: {
            name: {
              th: 'ไผ่ดำพัฒนา',
              en: 'Phai Dam Phatthana',
            },
            zipcode: '14110',
          },
          150604: {
            name: {
              th: 'สาวร้องไห้',
              en: 'Sao Rong Hai',
            },
            zipcode: '14110',
          },
          150605: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '14110',
          },
          150606: {
            name: {
              th: 'ยี่ล้น',
              en: 'Yi Lon',
            },
            zipcode: '14110',
          },
          150607: {
            name: {
              th: 'บางจัก',
              en: 'Bang Chak',
            },
            zipcode: '14110',
          },
          150608: {
            name: {
              th: 'ห้วยคันแหลน',
              en: 'Huai Khan Laen',
            },
            zipcode: '14110',
          },
          150609: {
            name: {
              th: 'คลองขนาก',
              en: 'Khlong Khanak',
            },
            zipcode: '14110',
          },
          150610: {
            name: {
              th: 'ไผ่วง',
              en: 'Phai Wong',
            },
            zipcode: '14110',
          },
          150611: {
            name: {
              th: 'สี่ร้อย',
              en: 'Si Roi',
            },
            zipcode: '14110',
          },
          150612: {
            name: {
              th: 'ม่วงเตี้ย',
              en: 'Muang Tia',
            },
            zipcode: '14110',
          },
          150613: {
            name: {
              th: 'หัวตะพาน',
              en: 'Hua Taphan',
            },
            zipcode: '14110',
          },
          150614: {
            name: {
              th: 'หลักแก้ว',
              en: 'Lak Kaeo',
            },
            zipcode: '14110',
          },
          150615: {
            name: {
              th: 'ตลาดใหม่',
              en: 'Talat Mai',
            },
            zipcode: '14110',
          },
        },
      },
      1507: {
        name: {
          th: 'สามโก้',
          en: 'Sam Ko',
        },
        tambons: {
          150701: {
            name: {
              th: 'สามโก้',
              en: 'Samko',
            },
            zipcode: '14160',
          },
          150702: {
            name: {
              th: 'ราษฎรพัฒนา',
              en: 'Ratsadon Phatthana',
            },
            zipcode: '14160',
          },
          150703: {
            name: {
              th: 'อบทม',
              en: 'Op Thom',
            },
            zipcode: '14160',
          },
          150704: {
            name: {
              th: 'โพธิ์ม่วงพันธ์',
              en: 'Pho Muang Phan',
            },
            zipcode: '14160',
          },
          150705: {
            name: {
              th: 'มงคลธรรมนิมิต',
              en: 'Mongkhon Tham Nimit',
            },
            zipcode: '14160',
          },
        },
      },
    },
  },
  16: {
    name: {
      th: 'ลพบุรี',
      en: 'Lop Buri',
    },
    amphoes: {
      1601: {
        name: {
          th: 'เมืองลพบุรี',
          en: 'Muang',
        },
        tambons: {
          160101: {
            name: {
              th: 'ทะเลชุบศร',
              en: 'Thale Chup Son',
            },
            zipcode: '15000',
          },
          160102: {
            name: {
              th: 'ท่าหิน',
              en: 'Tha Hin',
            },
            zipcode: '15000',
          },
          160103: {
            name: {
              th: 'กกโก',
              en: 'Kok Ko',
            },
            zipcode: '15000',
          },
          160104: {
            name: {
              th: 'โก่งธนู',
              en: 'Kong Thanu',
            },
            zipcode: '13240',
          },
          160105: {
            name: {
              th: 'เขาพระงาม',
              en: 'Khao Phra Ngam',
            },
            zipcode: '15000',
          },
          160106: {
            name: {
              th: 'เขาสามยอด',
              en: 'Khao Sam Yot',
            },
            zipcode: '15000',
          },
          160107: {
            name: {
              th: 'โคกกะเทียม',
              en: 'Khok Kathiam',
            },
            zipcode: '15000',
          },
          160108: {
            name: {
              th: 'โคกลำพาน',
              en: 'Khok Lam Phan',
            },
            zipcode: '15000',
          },
          160109: {
            name: {
              th: 'โคกตูม',
              en: 'Khok Tum',
            },
            zipcode: '15210',
          },
          160110: {
            name: {
              th: 'งิ้วราย',
              en: 'Ngio Rai',
            },
            zipcode: '15000',
          },
          160111: {
            name: {
              th: 'ดอนโพธิ์',
              en: 'Don Pho',
            },
            zipcode: '15000',
          },
          160112: {
            name: {
              th: 'ตะลุง',
              en: 'Talung',
            },
            zipcode: '15000',
          },
          160114: {
            name: {
              th: 'ท่าแค',
              en: 'Tha Khae',
            },
            zipcode: '15000',
          },
          160115: {
            name: {
              th: 'ท่าศาลา',
              en: 'Tha Sala',
            },
            zipcode: '15000',
          },
          160116: {
            name: {
              th: 'นิคมสร้างตนเอง',
              en: 'Nikhom Sang Ton Eng',
            },
            zipcode: '15000',
          },
          160117: {
            name: {
              th: 'บางขันหมาก',
              en: 'Bang Khan Mak',
            },
            zipcode: '15000',
          },
          160118: {
            name: {
              th: 'บ้านข่อย',
              en: 'Ban Khoi',
            },
            zipcode: '15000',
          },
          160119: {
            name: {
              th: 'ท้ายตลาด',
              en: 'Thai Talat',
            },
            zipcode: '15000',
          },
          160120: {
            name: {
              th: 'ป่าตาล',
              en: 'Pa Tan',
            },
            zipcode: '15000',
          },
          160121: {
            name: {
              th: 'พรหมมาสตร์',
              en: 'Phrommat',
            },
            zipcode: '15000',
          },
          160122: {
            name: {
              th: 'โพธิ์เก้าต้น',
              en: 'Pho Kao Ton',
            },
            zipcode: '15000',
          },
          160123: {
            name: {
              th: 'โพธิ์ตรุ',
              en: 'Pho Tru',
            },
            zipcode: '15000',
          },
          160124: {
            name: {
              th: 'สี่คลอง',
              en: 'Si Khlong',
            },
            zipcode: '15000',
          },
          160125: {
            name: {
              th: 'ถนนใหญ่',
              en: 'Thanon Yai',
            },
            zipcode: '15000',
          },
        },
      },
      1602: {
        name: {
          th: 'พัฒนานิคม',
          en: 'Phatthana Nikhom',
        },
        tambons: {
          160201: {
            name: {
              th: 'พัฒนานิคม',
              en: 'Phatthana Nikhom',
            },
            zipcode: '15140',
          },
          160202: {
            name: {
              th: 'ช่องสาริกา',
              en: 'Chong Sarika',
            },
            zipcode: '15220',
          },
          160203: {
            name: {
              th: 'มะนาวหวาน',
              en: 'Manao Wan',
            },
            zipcode: '15140',
          },
          160204: {
            name: {
              th: 'ดีลัง',
              en: 'Di Lang',
            },
            zipcode: '15220',
          },
          160205: {
            name: {
              th: 'โคกสลุง',
              en: 'Khok Salung',
            },
            zipcode: '15140',
          },
          160206: {
            name: {
              th: 'ชอนน้อย',
              en: 'Chon Noi',
            },
            zipcode: '15140',
          },
          160207: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '15140',
          },
          160208: {
            name: {
              th: 'ห้วยขุนราม',
              en: 'Huai Khun Ram',
            },
            zipcode: '18220',
          },
          160209: {
            name: {
              th: 'น้ำสุด',
              en: 'Nam Sut',
            },
            zipcode: '15140',
          },
        },
      },
      1603: {
        name: {
          th: 'โคกสำโรง',
          en: 'Khok Samrong',
        },
        tambons: {
          160301: {
            name: {
              th: 'โคกสำโรง',
              en: 'Khok Samrong',
            },
            zipcode: '15120',
          },
          160302: {
            name: {
              th: 'เกาะแก้ว',
              en: 'Ko Kaeo',
            },
            zipcode: '15120',
          },
          160303: {
            name: {
              th: 'ถลุงเหล็ก',
              en: 'Thalung Lek',
            },
            zipcode: '15120',
          },
          160304: {
            name: {
              th: 'หลุมข้าว',
              en: 'Lum Khao',
            },
            zipcode: '15120',
          },
          160305: {
            name: {
              th: 'ห้วยโป่ง',
              en: 'Huai Pong',
            },
            zipcode: '15120',
          },
          160306: {
            name: {
              th: 'คลองเกตุ',
              en: 'Khlong Ket',
            },
            zipcode: '15120',
          },
          160307: {
            name: {
              th: 'สะแกราบ',
              en: 'Sakae Rap',
            },
            zipcode: '15120',
          },
          160308: {
            name: {
              th: 'เพนียด',
              en: 'Phaniat',
            },
            zipcode: '15120',
          },
          160309: {
            name: {
              th: 'วังเพลิง',
              en: 'Wang Phloeng',
            },
            zipcode: '15120',
          },
          160310: {
            name: {
              th: 'ดงมะรุม',
              en: 'Dong Marum',
            },
            zipcode: '15120',
          },
          160318: {
            name: {
              th: 'วังขอนขว้าง',
              en: 'Wang Khon Khwang',
            },
            zipcode: '15120',
          },
          160320: {
            name: {
              th: 'วังจั่น',
              en: 'Wang Chan',
            },
            zipcode: '15120',
          },
          160322: {
            name: {
              th: 'หนองแขม',
              en: 'Nong Khaem',
            },
            zipcode: '15120',
          },
        },
      },
      1604: {
        name: {
          th: 'ชัยบาดาล',
          en: 'Chai Badan',
        },
        tambons: {
          160401: {
            name: {
              th: 'ลำนารายณ์',
              en: 'Lam Narai',
            },
            zipcode: '15130',
          },
          160402: {
            name: {
              th: 'ชัยนารายณ์',
              en: 'Chai Narai',
            },
            zipcode: '15130',
          },
          160403: {
            name: {
              th: 'ศิลาทิพย์',
              en: 'Sila Thip',
            },
            zipcode: '15130',
          },
          160404: {
            name: {
              th: 'ห้วยหิน',
              en: 'Huai Hin',
            },
            zipcode: '15130',
          },
          160405: {
            name: {
              th: 'ม่วงค่อม',
              en: 'Muang Khom',
            },
            zipcode: '15230',
          },
          160406: {
            name: {
              th: 'บัวชุม',
              en: 'Bua Chum',
            },
            zipcode: '15130',
          },
          160407: {
            name: {
              th: 'ท่าดินดำ',
              en: 'Tha Din Dam',
            },
            zipcode: '15130',
          },
          160408: {
            name: {
              th: 'มะกอกหวาน',
              en: 'Makok Wan',
            },
            zipcode: '15230',
          },
          160409: {
            name: {
              th: 'ซับตะเคียน',
              en: 'Sap Takhian',
            },
            zipcode: '15130',
          },
          160410: {
            name: {
              th: 'นาโสม',
              en: 'Na Som',
            },
            zipcode: '15190',
          },
          160411: {
            name: {
              th: 'หนองยายโต๊ะ',
              en: 'Nong Yai To',
            },
            zipcode: '15130',
          },
          160412: {
            name: {
              th: 'เกาะรัง',
              en: 'Ko Rang',
            },
            zipcode: '15130',
          },
          160414: {
            name: {
              th: 'ท่ามะนาว',
              en: 'Tha Manao',
            },
            zipcode: '15130',
          },
          160417: {
            name: {
              th: 'นิคมลำนารายณ์',
              en: 'Nikhom Lam Narai',
            },
            zipcode: '15130',
          },
          160418: {
            name: {
              th: 'ชัยบาดาล',
              en: 'Chai Badan',
            },
            zipcode: '15230',
          },
          160419: {
            name: {
              th: 'บ้านใหม่สามัคคี',
              en: 'Ban Mai Samakkhi',
            },
            zipcode: '15130',
          },
          160422: {
            name: {
              th: 'เขาแหลม',
              en: 'Khao Laem',
            },
            zipcode: '15130',
          },
        },
      },
      1605: {
        name: {
          th: 'ท่าวุ้ง',
          en: 'Tha Wung',
        },
        tambons: {
          160501: {
            name: {
              th: 'ท่าวุ้ง',
              en: 'Tha Wung',
            },
            zipcode: '15150',
          },
          160502: {
            name: {
              th: 'บางคู้',
              en: 'Bang Khu',
            },
            zipcode: '15150',
          },
          160503: {
            name: {
              th: 'โพตลาดแก้ว',
              en: 'Pho Talat Kaeo',
            },
            zipcode: '15150',
          },
          160504: {
            name: {
              th: 'บางลี่',
              en: 'Bang Li',
            },
            zipcode: '15150',
          },
          160505: {
            name: {
              th: 'บางงา',
              en: 'Bang Nga',
            },
            zipcode: '15150',
          },
          160506: {
            name: {
              th: 'โคกสลุด',
              en: 'Khok Salut',
            },
            zipcode: '15150',
          },
          160507: {
            name: {
              th: 'เขาสมอคอน',
              en: 'Khao Samo Khon',
            },
            zipcode: '15180',
          },
          160508: {
            name: {
              th: 'หัวสำโรง',
              en: 'Hua Samrong',
            },
            zipcode: '15150',
          },
          160509: {
            name: {
              th: 'ลาดสาลี่',
              en: 'Lat Sali',
            },
            zipcode: '15150',
          },
          160510: {
            name: {
              th: 'บ้านเบิก',
              en: 'Ban Boek',
            },
            zipcode: '15150',
          },
          160511: {
            name: {
              th: 'มุจลินท์',
              en: 'Mutchalin',
            },
            zipcode: '15150',
          },
        },
      },
      1606: {
        name: {
          th: 'บ้านหมี่',
          en: 'Ban Mi',
        },
        tambons: {
          160601: {
            name: {
              th: 'ไผ่ใหญ่',
              en: 'Phai Yai',
            },
            zipcode: '15110',
          },
          160602: {
            name: {
              th: 'บ้านทราย',
              en: 'Ban Sai',
            },
            zipcode: '15110',
          },
          160603: {
            name: {
              th: 'บ้านกล้วย',
              en: 'Ban Kluai',
            },
            zipcode: '15110',
          },
          160604: {
            name: {
              th: 'ดงพลับ',
              en: 'Dong Phlap',
            },
            zipcode: '15110',
          },
          160605: {
            name: {
              th: 'บ้านชี',
              en: 'Ban Chi',
            },
            zipcode: '15180',
          },
          160606: {
            name: {
              th: 'พุคา',
              en: 'Phu Kha',
            },
            zipcode: '15110',
          },
          160607: {
            name: {
              th: 'หินปัก',
              en: 'Hin Pak',
            },
            zipcode: '15110',
          },
          160608: {
            name: {
              th: 'บางพึ่ง',
              en: 'Bang Phueng',
            },
            zipcode: '15110',
          },
          160609: {
            name: {
              th: 'หนองทรายขาว',
              en: 'Nong Sai Khao',
            },
            zipcode: '15110',
          },
          160610: {
            name: {
              th: 'บางกะพี้',
              en: 'Bang Kaphi',
            },
            zipcode: '15110',
          },
          160611: {
            name: {
              th: 'หนองเต่า',
              en: 'Nong Tao',
            },
            zipcode: '15110',
          },
          160612: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '15110',
          },
          160613: {
            name: {
              th: 'บางขาม',
              en: 'Bang Kham',
            },
            zipcode: '15180',
          },
          160614: {
            name: {
              th: 'ดอนดึง',
              en: 'Don Dueng',
            },
            zipcode: '15110',
          },
          160615: {
            name: {
              th: 'ชอนม่วง',
              en: 'Chon Muang',
            },
            zipcode: '15110',
          },
          160616: {
            name: {
              th: 'หนองกระเบียน',
              en: 'Nong Krabian',
            },
            zipcode: '15110',
          },
          160617: {
            name: {
              th: 'สายห้วยแก้ว',
              en: 'Sai Huai Kaeo',
            },
            zipcode: '15110',
          },
          160618: {
            name: {
              th: 'มหาสอน',
              en: 'Maha Son',
            },
            zipcode: '15110',
          },
          160619: {
            name: {
              th: 'บ้านหมี่',
              en: 'Ban Mi',
            },
            zipcode: '15110',
          },
          160620: {
            name: {
              th: 'เชียงงา',
              en: 'Chiang Nga',
            },
            zipcode: '15110',
          },
          160621: {
            name: {
              th: 'หนองเมือง',
              en: 'Nong Mueang',
            },
            zipcode: '15110',
          },
          160622: {
            name: {
              th: 'สนามแจง',
              en: 'Sanam Chaeng',
            },
            zipcode: '15110',
          },
        },
      },
      1607: {
        name: {
          th: 'ท่าหลวง',
          en: 'Tha Luang',
        },
        tambons: {
          160701: {
            name: {
              th: 'ท่าหลวง',
              en: 'Tha Luang',
            },
            zipcode: '15230',
          },
          160702: {
            name: {
              th: 'แก่งผักกูด',
              en: 'Kaeng Phak Kut',
            },
            zipcode: '15230',
          },
          160703: {
            name: {
              th: 'ซับจำปา',
              en: 'Sab Champha',
            },
            zipcode: '15230',
          },
          160704: {
            name: {
              th: 'หนองผักแว่น',
              en: 'Nong Phak Waen',
            },
            zipcode: '15230',
          },
          160705: {
            name: {
              th: 'ทะเลวังวัด',
              en: 'Thale Wang Wat',
            },
            zipcode: '15230',
          },
          160706: {
            name: {
              th: 'หัวลำ',
              en: 'Hua Lam',
            },
            zipcode: '15230',
          },
        },
      },
      1608: {
        name: {
          th: 'สระโบสถ์',
          en: 'Sa Bot',
        },
        tambons: {
          160801: {
            name: {
              th: 'สระโบสถ์',
              en: 'Sa Bot',
            },
            zipcode: '15240',
          },
          160802: {
            name: {
              th: 'มหาโพธิ',
              en: 'Maha Phot',
            },
            zipcode: '15240',
          },
          160803: {
            name: {
              th: 'ทุ่งท่าช้าง',
              en: 'Thung Tha Chang',
            },
            zipcode: '15240',
          },
          160804: {
            name: {
              th: 'ห้วยใหญ่',
              en: 'Huai Yai',
            },
            zipcode: '15240',
          },
          160805: {
            name: {
              th: 'นิยมชัย',
              en: 'Niyom Chai',
            },
            zipcode: '15240',
          },
        },
      },
      1609: {
        name: {
          th: 'โคกเจริญ',
          en: 'Khok Charoen',
        },
        tambons: {
          160901: {
            name: {
              th: 'โคกเจริญ',
              en: 'Khok Charoen',
            },
            zipcode: '15250',
          },
          160902: {
            name: {
              th: 'ยางราก',
              en: 'Yang Rak',
            },
            zipcode: '15250',
          },
          160903: {
            name: {
              th: 'หนองมะค่า',
              en: 'Nong Makha',
            },
            zipcode: '15250',
          },
          160904: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '15250',
          },
          160905: {
            name: {
              th: 'โคกแสมสาร',
              en: 'Khok Samae San',
            },
            zipcode: '15250',
          },
        },
      },
      1610: {
        name: {
          th: 'ลำสนธิ',
          en: 'Lam Sonthi',
        },
        tambons: {
          161001: {
            name: {
              th: 'ลำสนธิ',
              en: 'Lam Sonthi',
            },
            zipcode: '15190',
          },
          161002: {
            name: {
              th: 'ซับสมบูรณ์',
              en: 'Sab Sombun',
            },
            zipcode: '15190',
          },
          161003: {
            name: {
              th: 'หนองรี',
              en: 'Nong Ri',
            },
            zipcode: '15190',
          },
          161004: {
            name: {
              th: 'กุดตาเพชร',
              en: 'Kut Ta Phet',
            },
            zipcode: '15190',
          },
          161005: {
            name: {
              th: 'เขารวก',
              en: 'Khao Ruak',
            },
            zipcode: '15190',
          },
          161006: {
            name: {
              th: 'เขาน้อย',
              en: 'Khao Noi',
            },
            zipcode: '15130',
          },
        },
      },
      1611: {
        name: {
          th: 'หนองม่วง',
          en: 'Nong Muang',
        },
        tambons: {
          161101: {
            name: {
              th: 'หนองม่วง',
              en: 'Nong Muang',
            },
            zipcode: '15170',
          },
          161102: {
            name: {
              th: 'บ่อทอง',
              en: 'Bo Thong',
            },
            zipcode: '15170',
          },
          161103: {
            name: {
              th: 'ดงดินแดง',
              en: 'Dong Din Daeng',
            },
            zipcode: '15170',
          },
          161104: {
            name: {
              th: 'ชอนสมบูรณ์',
              en: 'Chon Sombun',
            },
            zipcode: '15170',
          },
          161105: {
            name: {
              th: 'ยางโทน',
              en: 'Yang Thon',
            },
            zipcode: '15170',
          },
          161106: {
            name: {
              th: 'ชอนสารเดช',
              en: 'Chon Saradet',
            },
            zipcode: '15170',
          },
        },
      },
    },
  },
  17: {
    name: {
      th: 'สิงห์บุรี',
      en: 'Sing Buri',
    },
    amphoes: {
      1701: {
        name: {
          th: 'เมืองสิงห์บุรี',
          en: 'Muang',
        },
        tambons: {
          170101: {
            name: {
              th: 'บางพุทรา',
              en: 'Bang Phutsa',
            },
            zipcode: '16000',
          },
          170102: {
            name: {
              th: 'บางมัญ',
              en: 'Bang Man',
            },
            zipcode: '16000',
          },
          170103: {
            name: {
              th: 'โพกรวม',
              en: 'Phok Ruam',
            },
            zipcode: '16000',
          },
          170104: {
            name: {
              th: 'ม่วงหมู่',
              en: 'Muang Mu',
            },
            zipcode: '16000',
          },
          170105: {
            name: {
              th: 'หัวไผ่',
              en: 'Hua Phai',
            },
            zipcode: '16000',
          },
          170106: {
            name: {
              th: 'ต้นโพธิ์',
              en: 'Ton Pho',
            },
            zipcode: '16000',
          },
          170107: {
            name: {
              th: 'จักรสีห์',
              en: 'Chaksi',
            },
            zipcode: '16000',
          },
          170108: {
            name: {
              th: 'บางกระบือ',
              en: 'Bang Krabue',
            },
            zipcode: '16000',
          },
        },
      },
      1702: {
        name: {
          th: 'บางระจัน',
          en: 'Bang Rachan',
        },
        tambons: {
          170201: {
            name: {
              th: 'สิงห์',
              en: 'Sing',
            },
            zipcode: '16130',
          },
          170202: {
            name: {
              th: 'ไม้ดัด',
              en: 'Mai Dat',
            },
            zipcode: '16130',
          },
          170203: {
            name: {
              th: 'เชิงกลัด',
              en: 'Choeng Klat',
            },
            zipcode: '16130',
          },
          170204: {
            name: {
              th: 'โพชนไก่',
              en: 'Pho Chon Kai',
            },
            zipcode: '16130',
          },
          170205: {
            name: {
              th: 'แม่ลา',
              en: 'Mae La',
            },
            zipcode: '16130',
          },
          170206: {
            name: {
              th: 'บ้านจ่า',
              en: 'Ban Cha',
            },
            zipcode: '16130',
          },
          170207: {
            name: {
              th: 'พักทัน',
              en: 'Phak Than',
            },
            zipcode: '16130',
          },
          170208: {
            name: {
              th: 'สระแจง',
              en: 'Sa Chaeng',
            },
            zipcode: '16130',
          },
        },
      },
      1703: {
        name: {
          th: 'ค่ายบางระจัน',
          en: 'Khai Bang Rachan',
        },
        tambons: {
          170301: {
            name: {
              th: 'โพทะเล',
              en: 'Pho Thale',
            },
            zipcode: '16150',
          },
          170302: {
            name: {
              th: 'บางระจัน',
              en: 'Bang Rachan',
            },
            zipcode: '16150',
          },
          170303: {
            name: {
              th: 'โพสังโฆ',
              en: 'Pho Sangkho',
            },
            zipcode: '16150',
          },
          170304: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '16150',
          },
          170305: {
            name: {
              th: 'คอทราย',
              en: 'Kho Sai',
            },
            zipcode: '16150',
          },
          170306: {
            name: {
              th: 'หนองกระทุ่ม',
              en: 'Nong Krathum',
            },
            zipcode: '16150',
          },
        },
      },
      1704: {
        name: {
          th: 'พรหมบุรี',
          en: 'Phrom Buri',
        },
        tambons: {
          170401: {
            name: {
              th: 'พระงาม',
              en: 'Phra Ngam',
            },
            zipcode: '16120',
          },
          170402: {
            name: {
              th: 'พรหมบุรี',
              en: 'Phrom Buri',
            },
            zipcode: '16160',
          },
          170403: {
            name: {
              th: 'บางน้ำเชี่ยว',
              en: 'Bang Nam Chiao',
            },
            zipcode: '16120',
          },
          170404: {
            name: {
              th: 'บ้านหม้อ',
              en: 'Ban Mo',
            },
            zipcode: '16120',
          },
          170405: {
            name: {
              th: 'บ้านแป้ง',
              en: 'Ban Paeng',
            },
            zipcode: '16120',
          },
          170406: {
            name: {
              th: 'หัวป่า',
              en: 'Hua Pa',
            },
            zipcode: '16120',
          },
          170407: {
            name: {
              th: 'โรงช้าง',
              en: 'Rong Chang',
            },
            zipcode: '16120',
          },
        },
      },
      1705: {
        name: {
          th: 'ท่าช้าง',
          en: 'Tha Chang',
        },
        tambons: {
          170501: {
            name: {
              th: 'ถอนสมอ',
              en: 'Thon Samo',
            },
            zipcode: '16140',
          },
          170502: {
            name: {
              th: 'โพประจักษ์',
              en: 'Pho Prachak',
            },
            zipcode: '16140',
          },
          170503: {
            name: {
              th: 'วิหารขาว',
              en: 'Wihan Khao',
            },
            zipcode: '16140',
          },
          170504: {
            name: {
              th: 'พิกุลทอง',
              en: 'Phikun Thong',
            },
            zipcode: '16140',
          },
        },
      },
      1706: {
        name: {
          th: 'อินทร์บุรี',
          en: 'In Buri',
        },
        tambons: {
          170601: {
            name: {
              th: 'อินทร์บุรี',
              en: 'In Buri',
            },
            zipcode: '16110',
          },
          170602: {
            name: {
              th: 'ประศุก',
              en: 'Prasuk',
            },
            zipcode: '16110',
          },
          170603: {
            name: {
              th: 'ทับยา',
              en: 'Thap Ya',
            },
            zipcode: '16110',
          },
          170604: {
            name: {
              th: 'งิ้วราย',
              en: 'Ngio Rai',
            },
            zipcode: '16110',
          },
          170605: {
            name: {
              th: 'ชีน้ำร้าย',
              en: 'Chi Nam Rai',
            },
            zipcode: '16110',
          },
          170606: {
            name: {
              th: 'ท่างาม',
              en: 'Tha Ngam',
            },
            zipcode: '16110',
          },
          170607: {
            name: {
              th: 'น้ำตาล',
              en: 'Nam Tan',
            },
            zipcode: '16110',
          },
          170608: {
            name: {
              th: 'ทองเอน',
              en: 'Thong En',
            },
            zipcode: '16110',
          },
          170609: {
            name: {
              th: 'ห้วยชัน',
              en: 'Huai Chan',
            },
            zipcode: '16110',
          },
          170610: {
            name: {
              th: 'โพธิ์ชัย',
              en: 'Pho Chai',
            },
            zipcode: '16110',
          },
        },
      },
    },
  },
  18: {
    name: {
      th: 'ชัยนาท',
      en: 'Chai Nat',
    },
    amphoes: {
      1801: {
        name: {
          th: 'เมืองชัยนาท',
          en: 'Muang',
        },
        tambons: {
          180101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '17000',
          },
          180102: {
            name: {
              th: 'บ้านกล้วย',
              en: 'Ban Kluai',
            },
            zipcode: '17000',
          },
          180103: {
            name: {
              th: 'ท่าชัย',
              en: 'Tha Chai',
            },
            zipcode: '17000',
          },
          180104: {
            name: {
              th: 'ชัยนาท',
              en: 'Chai Nat',
            },
            zipcode: '17000',
          },
          180105: {
            name: {
              th: 'เขาท่าพระ',
              en: 'Khao Tha Phra',
            },
            zipcode: '17000',
          },
          180106: {
            name: {
              th: 'หาดท่าเสา',
              en: 'Hat Tha Sao',
            },
            zipcode: '17000',
          },
          180107: {
            name: {
              th: 'ธรรมามูล',
              en: 'Thammamun',
            },
            zipcode: '17000',
          },
          180108: {
            name: {
              th: 'เสือโฮก',
              en: 'Suea Hok',
            },
            zipcode: '17000',
          },
          180109: {
            name: {
              th: 'นางลือ',
              en: 'Nang Lue',
            },
            zipcode: '17000',
          },
        },
      },
      1802: {
        name: {
          th: 'มโนรมย์',
          en: 'Manorom',
        },
        tambons: {
          180201: {
            name: {
              th: 'คุ้งสำเภา',
              en: 'Khung Samphao',
            },
            zipcode: '17110',
          },
          180202: {
            name: {
              th: 'วัดโคก',
              en: 'Wat Khok',
            },
            zipcode: '17110',
          },
          180203: {
            name: {
              th: 'ศิลาดาน',
              en: 'Sila Dan',
            },
            zipcode: '17110',
          },
          180204: {
            name: {
              th: 'ท่าฉนวน',
              en: 'Tha Chanuan',
            },
            zipcode: '17110',
          },
          180205: {
            name: {
              th: 'หางน้ำสาคร',
              en: 'Hang Nam Sakhon',
            },
            zipcode: '17170',
          },
          180206: {
            name: {
              th: 'ไร่พัฒนา',
              en: 'Rai Phatthana',
            },
            zipcode: '17170',
          },
          180207: {
            name: {
              th: 'อู่ตะเภา',
              en: 'U Taphao',
            },
            zipcode: '17170',
          },
        },
      },
      1803: {
        name: {
          th: 'วัดสิงห์',
          en: 'Wat Singh',
        },
        tambons: {
          180301: {
            name: {
              th: 'วัดสิงห์',
              en: 'Wat Sing',
            },
            zipcode: '17120',
          },
          180302: {
            name: {
              th: 'มะขามเฒ่า',
              en: 'Makham Thao',
            },
            zipcode: '17120',
          },
          180303: {
            name: {
              th: 'หนองน้อย',
              en: 'Nong Noi',
            },
            zipcode: '17120',
          },
          180304: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '17120',
          },
          180306: {
            name: {
              th: 'หนองขุ่น',
              en: 'Nong Khun',
            },
            zipcode: '17120',
          },
          180307: {
            name: {
              th: 'บ่อแร่',
              en: 'Bo Rae',
            },
            zipcode: '17120',
          },
          180311: {
            name: {
              th: 'วังหมัน',
              en: 'Wang Man',
            },
            zipcode: '17120',
          },
        },
      },
      1804: {
        name: {
          th: 'สรรพยา',
          en: 'Sanphaya',
        },
        tambons: {
          180401: {
            name: {
              th: 'สรรพยา',
              en: 'Sapphaya',
            },
            zipcode: '17150',
          },
          180402: {
            name: {
              th: 'ตลุก',
              en: 'Taluk',
            },
            zipcode: '17150',
          },
          180403: {
            name: {
              th: 'เขาแก้ว',
              en: 'Khao Kaeo',
            },
            zipcode: '17150',
          },
          180404: {
            name: {
              th: 'โพนางดำตก',
              en: 'Pho Nang Dam Tok',
            },
            zipcode: '17150',
          },
          180405: {
            name: {
              th: 'โพนางดำออก',
              en: 'Pho Nang Dam Ok',
            },
            zipcode: '17150',
          },
          180406: {
            name: {
              th: 'บางหลวง',
              en: 'Bang Luang',
            },
            zipcode: '17150',
          },
          180407: {
            name: {
              th: 'หาดอาษา',
              en: 'Hat Asa',
            },
            zipcode: '17150',
          },
        },
      },
      1805: {
        name: {
          th: 'สรรคบุรี',
          en: 'Sankhaburi',
        },
        tambons: {
          180501: {
            name: {
              th: 'แพรกศรีราชา',
              en: 'Phraek Si Racha',
            },
            zipcode: '17140',
          },
          180502: {
            name: {
              th: 'เที่ยงแท้',
              en: 'Thiang Thae',
            },
            zipcode: '17140',
          },
          180503: {
            name: {
              th: 'ห้วยกรด',
              en: 'Huai Krot',
            },
            zipcode: '17140',
          },
          180504: {
            name: {
              th: 'โพงาม',
              en: 'Pho Ngam',
            },
            zipcode: '17140',
          },
          180505: {
            name: {
              th: 'บางขุด',
              en: 'Bang Khut',
            },
            zipcode: '17140',
          },
          180506: {
            name: {
              th: 'ดงคอน',
              en: 'Dong Khon',
            },
            zipcode: '17140',
          },
          180507: {
            name: {
              th: 'ดอนกำ',
              en: 'Don Kam',
            },
            zipcode: '17140',
          },
          180508: {
            name: {
              th: 'ห้วยกรดพัฒนา',
              en: 'Huai Krot Phatthana',
            },
            zipcode: '17140',
          },
        },
      },
      1806: {
        name: {
          th: 'หันคา',
          en: 'Hankha',
        },
        tambons: {
          180601: {
            name: {
              th: 'หันคา',
              en: 'Hankha',
            },
            zipcode: '17130',
          },
          180602: {
            name: {
              th: 'บ้านเชี่ยน',
              en: 'Ban Chian',
            },
            zipcode: '17130',
          },
          180605: {
            name: {
              th: 'ไพรนกยูง',
              en: 'Phrai Nok Yung',
            },
            zipcode: '17130',
          },
          180606: {
            name: {
              th: 'หนองแซง',
              en: 'Nong Saeng',
            },
            zipcode: '17160',
          },
          180607: {
            name: {
              th: 'ห้วยงู',
              en: 'Huai Ngu',
            },
            zipcode: '17160',
          },
          180608: {
            name: {
              th: 'วังไก่เถื่อน',
              en: 'Wang Kai Thuean',
            },
            zipcode: '17130',
          },
          180609: {
            name: {
              th: 'เด่นใหญ่',
              en: 'Den Yai',
            },
            zipcode: '17130',
          },
          180611: {
            name: {
              th: 'สามง่ามท่าโบสถ์',
              en: 'Sam Ngam Tha Bot',
            },
            zipcode: '17160',
          },
        },
      },
      1807: {
        name: {
          th: 'หนองมะโมง',
          en: 'Nong Mamong',
        },
        tambons: {
          180701: {
            name: {
              th: 'หนองมะโมง',
              en: 'Nong Mamong',
            },
            zipcode: '17120',
          },
          180702: {
            name: {
              th: 'วังตะเคียน',
              en: 'Wang Takhian',
            },
            zipcode: '17120',
          },
          180703: {
            name: {
              th: 'สะพานหิน',
              en: 'Saphan Hin',
            },
            zipcode: '17120',
          },
          180704: {
            name: {
              th: 'กุดจอก',
              en: 'Kut Chok',
            },
            zipcode: '17120',
          },
        },
      },
      1808: {
        name: {
          th: 'เนินขาม',
          en: 'King Amphoe Noen Kham',
        },
        tambons: {
          180801: {
            name: {
              th: 'เนินขาม',
              en: 'Noen Kham',
            },
            zipcode: '17130',
          },
          180802: {
            name: {
              th: 'กะบกเตี้ย',
              en: 'Kabok Tia',
            },
            zipcode: '17130',
          },
          180803: {
            name: {
              th: 'สุขเดือนห้า',
              en: 'Suk Duean Ha',
            },
            zipcode: '17130',
          },
        },
      },
    },
  },
  19: {
    name: {
      th: 'สระบุรี',
      en: 'Saraburi',
    },
    amphoes: {
      1901: {
        name: {
          th: 'เมืองสระบุรี',
          en: 'Muang',
        },
        tambons: {
          190101: {
            name: {
              th: 'ปากเพรียว',
              en: 'Pak Phriao',
            },
            zipcode: '18000',
          },
          190105: {
            name: {
              th: 'ดาวเรือง',
              en: 'Dao Rueang',
            },
            zipcode: '18000',
          },
          190106: {
            name: {
              th: 'นาโฉง',
              en: 'Na Chong',
            },
            zipcode: '18000',
          },
          190107: {
            name: {
              th: 'โคกสว่าง',
              en: 'Khok Sawang',
            },
            zipcode: '18000',
          },
          190108: {
            name: {
              th: 'หนองโน',
              en: 'Nong No',
            },
            zipcode: '18000',
          },
          190109: {
            name: {
              th: 'หนองยาว',
              en: 'Nong Yao',
            },
            zipcode: '18000',
          },
          190110: {
            name: {
              th: 'ปากข้าวสาร',
              en: 'Pak Khao San',
            },
            zipcode: '18000',
          },
          190111: {
            name: {
              th: 'หนองปลาไหล',
              en: 'Nong Pla Lai',
            },
            zipcode: '18000',
          },
          190112: {
            name: {
              th: 'กุดนกเปล้า',
              en: 'Kut Nok Plao',
            },
            zipcode: '18000',
          },
          190113: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '18000',
          },
          190114: {
            name: {
              th: 'ตะกุด',
              en: 'Takut',
            },
            zipcode: '18000',
          },
        },
      },
      1902: {
        name: {
          th: 'แก่งคอย',
          en: 'Kaeng Khoy',
        },
        tambons: {
          190201: {
            name: {
              th: 'แก่งคอย',
              en: 'Kaeng Khoi',
            },
            zipcode: '18110',
          },
          190202: {
            name: {
              th: 'ทับกวาง',
              en: 'Thap Kwang',
            },
            zipcode: '18260',
          },
          190203: {
            name: {
              th: 'ตาลเดี่ยว',
              en: 'Tan Diao',
            },
            zipcode: '18110',
          },
          190204: {
            name: {
              th: 'ห้วยแห้ง',
              en: 'Huai Haeng',
            },
            zipcode: '18110',
          },
          190205: {
            name: {
              th: 'ท่าคล้อ',
              en: 'Tha Khlo',
            },
            zipcode: '18110',
          },
          190206: {
            name: {
              th: 'หินซ้อน',
              en: 'Hin Son',
            },
            zipcode: '18110',
          },
          190207: {
            name: {
              th: 'บ้านธาตุ',
              en: 'Ban That',
            },
            zipcode: '18110',
          },
          190208: {
            name: {
              th: 'บ้านป่า',
              en: 'Ban Pa',
            },
            zipcode: '18110',
          },
          190209: {
            name: {
              th: 'ท่าตูม',
              en: 'Tha Tum',
            },
            zipcode: '18110',
          },
          190210: {
            name: {
              th: 'ชะอม',
              en: 'Cha-om',
            },
            zipcode: '18110',
          },
          190211: {
            name: {
              th: 'สองคอน',
              en: 'Song Khon',
            },
            zipcode: '18110',
          },
          190212: {
            name: {
              th: 'เตาปูน',
              en: 'Tao Pun',
            },
            zipcode: '18110',
          },
          190213: {
            name: {
              th: 'ชำผักแพว',
              en: 'Cham Phak Phaeo',
            },
            zipcode: '18110',
          },
          190215: {
            name: {
              th: 'ท่ามะปราง',
              en: 'Tha Maprang',
            },
            zipcode: '18110',
          },
        },
      },
      1903: {
        name: {
          th: 'หนองแค',
          en: 'Nong Khae',
        },
        tambons: {
          190301: {
            name: {
              th: 'หนองแค',
              en: 'Nong Khae',
            },
            zipcode: '18140',
          },
          190302: {
            name: {
              th: 'กุ่มหัก',
              en: 'Kum Hak',
            },
            zipcode: '18140',
          },
          190303: {
            name: {
              th: 'คชสิทธิ์',
              en: 'Khotchasit',
            },
            zipcode: '18250',
          },
          190304: {
            name: {
              th: 'โคกตูม',
              en: 'Khok Tum',
            },
            zipcode: '18250',
          },
          190305: {
            name: {
              th: 'โคกแย้',
              en: 'Khok Yae',
            },
            zipcode: '18230',
          },
          190306: {
            name: {
              th: 'บัวลอย',
              en: 'Bua Loi',
            },
            zipcode: '18230',
          },
          190307: {
            name: {
              th: 'ไผ่ต่ำ',
              en: 'Phai Tam',
            },
            zipcode: '18140',
          },
          190308: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '18250',
          },
          190309: {
            name: {
              th: 'ห้วยขมิ้น',
              en: 'Huai Khamin',
            },
            zipcode: '18230',
          },
          190310: {
            name: {
              th: 'ห้วยทราย',
              en: 'Huai Sai',
            },
            zipcode: '18230',
          },
          190311: {
            name: {
              th: 'หนองไข่น้ำ',
              en: 'Nong Khai Nam',
            },
            zipcode: '18140',
          },
          190312: {
            name: {
              th: 'หนองแขม',
              en: 'Nong Khaem',
            },
            zipcode: '18140',
          },
          190313: {
            name: {
              th: 'หนองจิก',
              en: 'Nong Chik',
            },
            zipcode: '18230',
          },
          190314: {
            name: {
              th: 'หนองจรเข้',
              en: 'Nong Chorakhe',
            },
            zipcode: '18140',
          },
          190315: {
            name: {
              th: 'หนองนาก',
              en: 'Nong Nak',
            },
            zipcode: '18230',
          },
          190316: {
            name: {
              th: 'หนองปลาหมอ',
              en: 'Nong Pla Mo',
            },
            zipcode: '18140',
          },
          190317: {
            name: {
              th: 'หนองปลิง',
              en: 'Nong Pling',
            },
            zipcode: '18140',
          },
          190318: {
            name: {
              th: 'หนองโรง',
              en: 'Nong Rong',
            },
            zipcode: '18140',
          },
        },
      },
      1904: {
        name: {
          th: 'วิหารแดง',
          en: 'Wihan Daeng',
        },
        tambons: {
          190401: {
            name: {
              th: 'หนองหมู',
              en: 'Nong Mu',
            },
            zipcode: '18150',
          },
          190402: {
            name: {
              th: 'บ้านลำ',
              en: 'Ban Lam',
            },
            zipcode: '18150',
          },
          190403: {
            name: {
              th: 'คลองเรือ',
              en: 'Khlong Ruea',
            },
            zipcode: '18150',
          },
          190404: {
            name: {
              th: 'วิหารแดง',
              en: 'Wihan Daeng',
            },
            zipcode: '18150',
          },
          190405: {
            name: {
              th: 'หนองสรวง',
              en: 'Nong Suang',
            },
            zipcode: '18150',
          },
          190406: {
            name: {
              th: 'เจริญธรรม',
              en: 'Charoen Tham',
            },
            zipcode: '18150',
          },
        },
      },
      1905: {
        name: {
          th: 'หนองแซง',
          en: 'Nong Saeng',
        },
        tambons: {
          190501: {
            name: {
              th: 'หนองแซง',
              en: 'Nong Saeng',
            },
            zipcode: '18170',
          },
          190502: {
            name: {
              th: 'หนองควายโซ',
              en: 'Nong Khwai So',
            },
            zipcode: '18170',
          },
          190503: {
            name: {
              th: 'หนองหัวโพ',
              en: 'Nong Hua Pho',
            },
            zipcode: '18170',
          },
          190504: {
            name: {
              th: 'หนองสีดา',
              en: 'Nong Sida',
            },
            zipcode: '18170',
          },
          190505: {
            name: {
              th: 'หนองกบ',
              en: 'Nong Kop',
            },
            zipcode: '18170',
          },
          190506: {
            name: {
              th: 'ไก่เส่า',
              en: 'Kai Sao',
            },
            zipcode: '18170',
          },
          190507: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '18170',
          },
          190508: {
            name: {
              th: 'ม่วงหวาน',
              en: 'Muang Wan',
            },
            zipcode: '18170',
          },
          190509: {
            name: {
              th: 'เขาดิน',
              en: 'Khao Din',
            },
            zipcode: '18170',
          },
        },
      },
      1906: {
        name: {
          th: 'บ้านหมอ',
          en: 'Ban Mo',
        },
        tambons: {
          190601: {
            name: {
              th: 'บ้านหมอ',
              en: 'Ban Mo',
            },
            zipcode: '18130',
          },
          190602: {
            name: {
              th: 'บางโขมด',
              en: 'Bang Khamot',
            },
            zipcode: '18130',
          },
          190603: {
            name: {
              th: 'สร่างโศก',
              en: 'Sang Sok',
            },
            zipcode: '18130',
          },
          190604: {
            name: {
              th: 'ตลาดน้อย',
              en: 'Talat Noi',
            },
            zipcode: '18130',
          },
          190605: {
            name: {
              th: 'หรเทพ',
              en: 'Horathep',
            },
            zipcode: '18130',
          },
          190606: {
            name: {
              th: 'โคกใหญ่',
              en: 'Khok Yai',
            },
            zipcode: '18130',
          },
          190607: {
            name: {
              th: 'ไผ่ขวาง',
              en: 'Phai Khwang',
            },
            zipcode: '18130',
          },
          190608: {
            name: {
              th: 'บ้านครัว',
              en: 'Ban Khrua',
            },
            zipcode: '18270',
          },
          190609: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '18130',
          },
        },
      },
      1907: {
        name: {
          th: 'ดอนพุด',
          en: 'Don Phut',
        },
        tambons: {
          190701: {
            name: {
              th: 'ดอนพุด',
              en: 'Don Phut',
            },
            zipcode: '18210',
          },
          190702: {
            name: {
              th: 'ไผ่หลิ่ว',
              en: 'Phai Lio',
            },
            zipcode: '18210',
          },
          190703: {
            name: {
              th: 'บ้านหลวง',
              en: 'Ban Luang',
            },
            zipcode: '18210',
          },
          190704: {
            name: {
              th: 'ดงตะงาว',
              en: 'Dong Ta Ngao',
            },
            zipcode: '18210',
          },
        },
      },
      1908: {
        name: {
          th: 'หนองโดน',
          en: 'Nong Don',
        },
        tambons: {
          190801: {
            name: {
              th: 'หนองโดน',
              en: 'Nong Don',
            },
            zipcode: '18190',
          },
          190802: {
            name: {
              th: 'บ้านกลับ',
              en: 'Ban Klap',
            },
            zipcode: '18190',
          },
          190803: {
            name: {
              th: 'ดอนทอง',
              en: 'Don Thong',
            },
            zipcode: '18190',
          },
          190804: {
            name: {
              th: 'บ้านโปร่ง',
              en: 'Ban Prong',
            },
            zipcode: '18190',
          },
        },
      },
      1909: {
        name: {
          th: 'พระพุทธบาท',
          en: 'Phra Phutthabat',
        },
        tambons: {
          190901: {
            name: {
              th: 'พระพุทธบาท',
              en: 'Phra Phutthabat',
            },
            zipcode: '18120',
          },
          190902: {
            name: {
              th: 'ขุนโขลน',
              en: 'Khun Khlon',
            },
            zipcode: '18120',
          },
          190903: {
            name: {
              th: 'ธารเกษม',
              en: 'Than Kasem',
            },
            zipcode: '18120',
          },
          190904: {
            name: {
              th: 'นายาว',
              en: 'Na Yao',
            },
            zipcode: '18120',
          },
          190905: {
            name: {
              th: 'พุคำจาน',
              en: 'Phu Kham Chan',
            },
            zipcode: '18120',
          },
          190906: {
            name: {
              th: 'เขาวง',
              en: 'Khao Wong',
            },
            zipcode: '18120',
          },
          190907: {
            name: {
              th: 'ห้วยป่าหวาย',
              en: 'Huai Pa Wai',
            },
            zipcode: '18120',
          },
          190908: {
            name: {
              th: 'พุกร่าง',
              en: 'Phu Krang',
            },
            zipcode: '18120',
          },
          190909: {
            name: {
              th: 'หนองแก',
              en: 'Nong Kae',
            },
            zipcode: '18120',
          },
        },
      },
      1910: {
        name: {
          th: 'เสาไห้',
          en: 'Sao Hai',
        },
        tambons: {
          191001: {
            name: {
              th: 'เสาไห้',
              en: 'Sao Hai',
            },
            zipcode: '18160',
          },
          191002: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '18160',
          },
          191003: {
            name: {
              th: 'หัวปลวก',
              en: 'Hua Pluak',
            },
            zipcode: '18160',
          },
          191004: {
            name: {
              th: 'งิ้วงาม',
              en: 'Ngio Ngam',
            },
            zipcode: '18160',
          },
          191005: {
            name: {
              th: 'ศาลารีไทย',
              en: 'Sala Ri Thai',
            },
            zipcode: '18160',
          },
          191006: {
            name: {
              th: 'ต้นตาล',
              en: 'Ton Tan',
            },
            zipcode: '18160',
          },
          191007: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '18160',
          },
          191008: {
            name: {
              th: 'พระยาทด',
              en: 'Phraya Thot',
            },
            zipcode: '18160',
          },
          191009: {
            name: {
              th: 'ม่วงงาม',
              en: 'Muang Ngam',
            },
            zipcode: '18160',
          },
          191010: {
            name: {
              th: 'เริงราง',
              en: 'Roeng Rang',
            },
            zipcode: '18160',
          },
          191011: {
            name: {
              th: 'เมืองเก่า',
              en: 'Mueang Kao',
            },
            zipcode: '18160',
          },
          191012: {
            name: {
              th: 'สวนดอกไม้',
              en: 'Suan Dok Mai',
            },
            zipcode: '18160',
          },
        },
      },
      1911: {
        name: {
          th: 'มวกเหล็ก',
          en: 'Muak Lek',
        },
        tambons: {
          191101: {
            name: {
              th: 'มวกเหล็ก',
              en: 'Muak Lek',
            },
            zipcode: '18180',
          },
          191102: {
            name: {
              th: 'มิตรภาพ',
              en: 'Mittraphap',
            },
            zipcode: '18180',
          },
          191104: {
            name: {
              th: 'หนองย่างเสือ',
              en: 'Nong Yang Suea',
            },
            zipcode: '18180',
          },
          191105: {
            name: {
              th: 'ลำสมพุง',
              en: 'Lam Somphung',
            },
            zipcode: '30130',
          },
          191107: {
            name: {
              th: 'ลำพญากลาง',
              en: 'Lam Phaya Klang',
            },
            zipcode: '18180',
          },
          191109: {
            name: {
              th: 'ซับสนุ่น',
              en: 'Sap Sanun',
            },
            zipcode: '18220',
          },
        },
      },
      1912: {
        name: {
          th: 'วังม่วง',
          en: 'Wong Muang',
        },
        tambons: {
          191201: {
            name: {
              th: 'แสลงพัน',
              en: 'Salaeng Phan',
            },
            zipcode: '18220',
          },
          191202: {
            name: {
              th: 'คำพราน',
              en: 'Kham Phran',
            },
            zipcode: '18220',
          },
          191203: {
            name: {
              th: 'วังม่วง',
              en: 'Wang Muang',
            },
            zipcode: '18220',
          },
        },
      },
      1913: {
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chalermprakiat',
        },
        tambons: {
          191301: {
            name: {
              th: 'เขาดินพัฒนา',
              en: 'Khao Din Phatthana',
            },
            zipcode: '18000',
          },
          191302: {
            name: {
              th: 'บ้านแก้ง',
              en: 'Ban Kaeng',
            },
            zipcode: '18000',
          },
          191303: {
            name: {
              th: 'ผึ้งรวง',
              en: 'Phueng Ruang',
            },
            zipcode: '18000',
          },
          191304: {
            name: {
              th: 'พุแค',
              en: 'Phu Khae',
            },
            zipcode: '18240',
          },
          191305: {
            name: {
              th: 'ห้วยบง',
              en: 'Huai Bong',
            },
            zipcode: '18000',
          },
          191306: {
            name: {
              th: 'หน้าพระลาน',
              en: 'Na Phra Lan',
            },
            zipcode: '18240',
          },
        },
      },
    },
  },
  20: {
    name: {
      th: 'ชลบุรี',
      en: 'Chon Buri',
    },
    amphoes: {
      2001: {
        name: {
          th: 'เมืองชลบุรี',
          en: 'Muang',
        },
        tambons: {
          200101: {
            name: {
              th: 'บางปลาสร้อย',
              en: 'Bang Pla Soi',
            },
            zipcode: '20000',
          },
          200102: {
            name: {
              th: 'มะขามหย่ง',
              en: 'Makham Yong',
            },
            zipcode: '20000',
          },
          200103: {
            name: {
              th: 'บ้านโขด',
              en: 'Ban Khot',
            },
            zipcode: '20000',
          },
          200104: {
            name: {
              th: 'แสนสุข',
              en: 'Saen Suk',
            },
            zipcode: '20130',
          },
          200105: {
            name: {
              th: 'บ้านสวน',
              en: 'Ban Suan',
            },
            zipcode: '20000',
          },
          200106: {
            name: {
              th: 'หนองรี',
              en: 'Nong Ri',
            },
            zipcode: '20000',
          },
          200107: {
            name: {
              th: 'นาป่า',
              en: 'Na Pa',
            },
            zipcode: '20000',
          },
          200108: {
            name: {
              th: 'หนองข้างคอก',
              en: 'Nong Khang Khok',
            },
            zipcode: '20000',
          },
          200109: {
            name: {
              th: 'ดอนหัวฬ่อ',
              en: 'Don Hua Lo',
            },
            zipcode: '20000',
          },
          200110: {
            name: {
              th: 'หนองไม้แดง',
              en: 'Nong Mai Daeng',
            },
            zipcode: '20000',
          },
          200111: {
            name: {
              th: 'บางทราย',
              en: 'Bang Sai',
            },
            zipcode: '20000',
          },
          200112: {
            name: {
              th: 'คลองตำหรุ',
              en: 'Khlong Tamru',
            },
            zipcode: '20000',
          },
          200113: {
            name: {
              th: 'เหมือง',
              en: 'Mueang',
            },
            zipcode: '20130',
          },
          200114: {
            name: {
              th: 'บ้านปึก',
              en: 'Ban Puek',
            },
            zipcode: '20130',
          },
          200115: {
            name: {
              th: 'ห้วยกะปิ',
              en: 'Huai Kapi',
            },
            zipcode: '20000',
          },
          200116: {
            name: {
              th: 'เสม็ด',
              en: 'Samet',
            },
            zipcode: '20000',
          },
          200117: {
            name: {
              th: 'อ่างศิลา',
              en: 'Ang Sila',
            },
            zipcode: '20000',
          },
          200118: {
            name: {
              th: 'สำนักบก',
              en: 'Samnak Bok',
            },
            zipcode: '20000',
          },
        },
      },
      2002: {
        name: {
          th: 'บ้านบึง',
          en: 'Ban Bung',
        },
        tambons: {
          200201: {
            name: {
              th: 'บ้านบึง',
              en: 'Ban Bueng',
            },
            zipcode: '20170',
          },
          200202: {
            name: {
              th: 'คลองกิ่ว',
              en: 'Khlong Kio',
            },
            zipcode: '20220',
          },
          200203: {
            name: {
              th: 'มาบไผ่',
              en: 'Map Phai',
            },
            zipcode: '20170',
          },
          200204: {
            name: {
              th: 'หนองซ้ำซาก',
              en: 'Nong Samsak',
            },
            zipcode: '20170',
          },
          200205: {
            name: {
              th: 'หนองบอนแดง',
              en: 'Nong Bon Daeng',
            },
            zipcode: '20170',
          },
          200206: {
            name: {
              th: 'หนองชาก',
              en: 'Nong Chak',
            },
            zipcode: '20170',
          },
          200207: {
            name: {
              th: 'หนองอิรุณ',
              en: 'Nong Irun',
            },
            zipcode: '20220',
          },
          200208: {
            name: {
              th: 'หนองไผ่แก้ว',
              en: 'Nong Phai Kaeo',
            },
            zipcode: '20220',
          },
        },
      },
      2003: {
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        tambons: {
          200301: {
            name: {
              th: 'หนองใหญ่',
              en: 'Nong Yai',
            },
            zipcode: '20190',
          },
          200302: {
            name: {
              th: 'คลองพลู',
              en: 'Khlong Phlu',
            },
            zipcode: '20190',
          },
          200303: {
            name: {
              th: 'หนองเสือช้าง',
              en: 'Nong Suea Chang',
            },
            zipcode: '20190',
          },
          200304: {
            name: {
              th: 'ห้างสูง',
              en: 'Hang Sung',
            },
            zipcode: '20190',
          },
          200305: {
            name: {
              th: 'เขาซก',
              en: 'Khao Sok',
            },
            zipcode: '20190',
          },
        },
      },
      2004: {
        name: {
          th: 'บางละมุง',
          en: 'Bang Lamung',
        },
        tambons: {
          200401: {
            name: {
              th: 'บางละมุง',
              en: 'Bang Lamung',
            },
            zipcode: '20150',
          },
          200402: {
            name: {
              th: 'หนองปรือ',
              en: 'Nong Prue',
            },
            zipcode: '20150',
          },
          200403: {
            name: {
              th: 'หนองปลาไหล',
              en: 'Nong Pla Lai',
            },
            zipcode: '20150',
          },
          200404: {
            name: {
              th: 'โป่ง',
              en: 'Pong',
            },
            zipcode: '20150',
          },
          200405: {
            name: {
              th: 'เขาไม้แก้ว',
              en: 'Khao Mai Kaeo',
            },
            zipcode: '20150',
          },
          200406: {
            name: {
              th: 'ห้วยใหญ่',
              en: 'Huai Yai',
            },
            zipcode: '20150',
          },
          200407: {
            name: {
              th: 'ตะเคียนเตี้ย',
              en: 'Takhian Tia',
            },
            zipcode: '20150',
          },
          200408: {
            name: {
              th: 'นาเกลือ',
              en: 'Na Kluea',
            },
            zipcode: '20150',
          },
        },
      },
      2005: {
        name: {
          th: 'พานทอง',
          en: 'Phan Thong',
        },
        tambons: {
          200501: {
            name: {
              th: 'พานทอง',
              en: 'Phan Thong',
            },
            zipcode: '20160',
          },
          200502: {
            name: {
              th: 'หนองตำลึง',
              en: 'Nong Tamlueng',
            },
            zipcode: '20160',
          },
          200503: {
            name: {
              th: 'มาบโป่ง',
              en: 'Map Pong',
            },
            zipcode: '20160',
          },
          200504: {
            name: {
              th: 'หนองกะขะ',
              en: 'Nong Kakha',
            },
            zipcode: '20160',
          },
          200505: {
            name: {
              th: 'หนองหงษ์',
              en: 'Nong Hong',
            },
            zipcode: '20160',
          },
          200506: {
            name: {
              th: 'โคกขี้หนอน',
              en: 'Khok Khi Non',
            },
            zipcode: '20160',
          },
          200507: {
            name: {
              th: 'บ้านเก่า',
              en: 'Ban Kao',
            },
            zipcode: '20160',
          },
          200508: {
            name: {
              th: 'หน้าประดู่',
              en: 'Na Pradu',
            },
            zipcode: '20160',
          },
          200509: {
            name: {
              th: 'บางนาง',
              en: 'Bang Nang',
            },
            zipcode: '20160',
          },
          200510: {
            name: {
              th: 'เกาะลอย',
              en: 'Ko Loi',
            },
            zipcode: '20160',
          },
          200511: {
            name: {
              th: 'บางหัก',
              en: 'Bang Hak',
            },
            zipcode: '20160',
          },
        },
      },
      2006: {
        name: {
          th: 'พนัสนิคม',
          en: 'Phanut Nikhom',
        },
        tambons: {
          200601: {
            name: {
              th: 'พนัสนิคม',
              en: 'Phanat Nikhom',
            },
            zipcode: '20140',
          },
          200602: {
            name: {
              th: 'หน้าพระธาตุ',
              en: 'Na Phrathat',
            },
            zipcode: '20140',
          },
          200603: {
            name: {
              th: 'วัดหลวง',
              en: 'Wat Luang',
            },
            zipcode: '20140',
          },
          200604: {
            name: {
              th: 'บ้านเซิด',
              en: 'Ban Soet',
            },
            zipcode: '20140',
          },
          200605: {
            name: {
              th: 'นาเริก',
              en: 'Na Roek',
            },
            zipcode: '20140',
          },
          200606: {
            name: {
              th: 'หมอนนาง',
              en: 'Mon Nang',
            },
            zipcode: '20140',
          },
          200607: {
            name: {
              th: 'สระสี่เหลี่ยม',
              en: 'Sa Si Liam',
            },
            zipcode: '20140',
          },
          200608: {
            name: {
              th: 'วัดโบสถ์',
              en: 'Wat Bot',
            },
            zipcode: '20140',
          },
          200609: {
            name: {
              th: 'กุฎโง้ง',
              en: 'Kut Ngong',
            },
            zipcode: '20140',
          },
          200610: {
            name: {
              th: 'หัวถนน',
              en: 'Hua Thanon',
            },
            zipcode: '20140',
          },
          200611: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '20140',
          },
          200613: {
            name: {
              th: 'หนองปรือ',
              en: 'Nong Prue',
            },
            zipcode: '20140',
          },
          200614: {
            name: {
              th: 'หนองขยาด',
              en: 'Nong Khayat',
            },
            zipcode: '20140',
          },
          200615: {
            name: {
              th: 'ทุ่งขวาง',
              en: 'Thung Khwang',
            },
            zipcode: '20140',
          },
          200616: {
            name: {
              th: 'หนองเหียง',
              en: 'Nong Hiang',
            },
            zipcode: '20140',
          },
          200617: {
            name: {
              th: 'นาวังหิน',
              en: 'Na Wang Hin',
            },
            zipcode: '20140',
          },
          200618: {
            name: {
              th: 'บ้านช้าง',
              en: 'Ban Chang',
            },
            zipcode: '20140',
          },
          200620: {
            name: {
              th: 'โคกเพลาะ',
              en: 'Khok Phlo',
            },
            zipcode: '20140',
          },
          200621: {
            name: {
              th: 'ไร่หลักทอง',
              en: 'Rai Lak Thong',
            },
            zipcode: '20140',
          },
          200622: {
            name: {
              th: 'นามะตูม',
              en: 'Na Matum',
            },
            zipcode: '20140',
          },
        },
      },
      2007: {
        name: {
          th: 'ศรีราชา',
          en: 'Sri Racha',
        },
        tambons: {
          200701: {
            name: {
              th: 'ศรีราชา',
              en: 'Si Racha',
            },
            zipcode: '20110',
          },
          200702: {
            name: {
              th: 'สุรศักดิ์',
              en: 'Surasak',
            },
            zipcode: '20110',
          },
          200703: {
            name: {
              th: 'ทุ่งสุขลา',
              en: 'Thung Sukhla',
            },
            zipcode: '20230',
          },
          200704: {
            name: {
              th: 'บึง',
              en: 'Bueng',
            },
            zipcode: '20230',
          },
          200705: {
            name: {
              th: 'หนองขาม',
              en: 'Nong Kham',
            },
            zipcode: '20110',
          },
          200706: {
            name: {
              th: 'เขาคันทรง',
              en: 'KhaoKhansong',
            },
            zipcode: '20110',
          },
          200707: {
            name: {
              th: 'บางพระ',
              en: 'Bang Phra',
            },
            zipcode: '20110',
          },
          200708: {
            name: {
              th: 'บ่อวิน',
              en: 'BoWin',
            },
            zipcode: '20230',
          },
        },
      },
      2008: {
        name: {
          th: 'เกาะสีชัง',
          en: 'Ko Sichang',
        },
        tambons: {
          200801: {
            name: {
              th: 'ท่าเทววงษ์',
              en: 'Tha Thewawong',
            },
            zipcode: '20120',
          },
        },
      },
      2009: {
        name: {
          th: 'สัตหีบ',
          en: 'Satahip',
        },
        tambons: {
          200901: {
            name: {
              th: 'สัตหีบ',
              en: 'Sattahip',
            },
            zipcode: '20180',
          },
          200902: {
            name: {
              th: 'นาจอมเทียน',
              en: 'Na Chom Thian',
            },
            zipcode: '20250',
          },
          200903: {
            name: {
              th: 'พลูตาหลวง',
              en: 'Phlu Ta Luang',
            },
            zipcode: '20180',
          },
          200904: {
            name: {
              th: 'บางเสร่',
              en: 'Bang Sare',
            },
            zipcode: '20250',
          },
          200905: {
            name: {
              th: 'แสมสาร',
              en: 'Samaesan',
            },
            zipcode: '20180',
          },
        },
      },
      2010: {
        name: {
          th: 'บ่อทอง',
          en: 'Bo Tong',
        },
        tambons: {
          201001: {
            name: {
              th: 'บ่อทอง',
              en: 'Bo Thong',
            },
            zipcode: '20270',
          },
          201002: {
            name: {
              th: 'วัดสุวรรณ',
              en: 'Wat Suwan',
            },
            zipcode: '20270',
          },
          201003: {
            name: {
              th: 'บ่อกวางทอง',
              en: 'Bo Kwang Thong',
            },
            zipcode: '20270',
          },
          201004: {
            name: {
              th: 'ธาตุทอง',
              en: 'That Thong',
            },
            zipcode: '20270',
          },
          201005: {
            name: {
              th: 'เกษตรสุวรรณ',
              en: 'Kaset Suwan',
            },
            zipcode: '20270',
          },
          201006: {
            name: {
              th: 'พลวงทอง',
              en: 'Phluang Thong',
            },
            zipcode: '20270',
          },
        },
      },
      2011: {
        name: {
          th: 'เกาะจันทร์',
          en: 'Ko Chan',
        },
        tambons: {
          201101: {
            name: {
              th: 'เกาะจันทร์',
              en: 'Ko Chan',
            },
            zipcode: '20240',
          },
          201102: {
            name: {
              th: 'ท่าบุญมี',
              en: 'Tha Bun Mi',
            },
            zipcode: '20240',
          },
        },
      },
    },
  },
  21: {
    name: {
      th: 'ระยอง',
      en: 'Rayong',
    },
    amphoes: {
      2101: {
        name: {
          th: 'เมืองระยอง',
          en: 'Muang',
        },
        tambons: {
          210101: {
            name: {
              th: 'ท่าประดู่',
              en: 'Tha Pradu',
            },
            zipcode: '21000',
          },
          210102: {
            name: {
              th: 'เชิงเนิน',
              en: 'Choeng Noen',
            },
            zipcode: '21000',
          },
          210103: {
            name: {
              th: 'ตะพง',
              en: 'Taphong',
            },
            zipcode: '21000',
          },
          210104: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '21000',
          },
          210105: {
            name: {
              th: 'เพ',
              en: 'Phe',
            },
            zipcode: '21160',
          },
          210106: {
            name: {
              th: 'แกลง',
              en: 'Klaeng',
            },
            zipcode: '21160',
          },
          210107: {
            name: {
              th: 'บ้านแลง',
              en: 'Ban Laeng',
            },
            zipcode: '21000',
          },
          210108: {
            name: {
              th: 'นาตาขวัญ',
              en: 'Na Ta Khwan',
            },
            zipcode: '21000',
          },
          210109: {
            name: {
              th: 'เนินพระ',
              en: 'Noen Phra',
            },
            zipcode: '21000',
          },
          210110: {
            name: {
              th: 'กะเฉด',
              en: 'Kachet',
            },
            zipcode: '21100',
          },
          210111: {
            name: {
              th: 'ทับมา',
              en: 'Thap Ma',
            },
            zipcode: '21000',
          },
          210112: {
            name: {
              th: 'น้ำคอก',
              en: 'Nam Khok',
            },
            zipcode: '21000',
          },
          210113: {
            name: {
              th: 'ห้วยโป่ง',
              en: 'Huai Pong',
            },
            zipcode: '21150',
          },
          210114: {
            name: {
              th: 'มาบตาพุด',
              en: 'Map Ta Phut',
            },
            zipcode: '21150',
          },
          210115: {
            name: {
              th: 'สำนักทอง',
              en: 'Samnak Thong',
            },
            zipcode: '21100',
          },
        },
      },
      2102: {
        name: {
          th: 'บ้านฉาง',
          en: 'Ban Chang',
        },
        tambons: {
          210201: {
            name: {
              th: 'สำนักท้อน',
              en: 'Samnak Thon',
            },
            zipcode: '21130',
          },
          210202: {
            name: {
              th: 'พลา',
              en: 'Phla',
            },
            zipcode: '21130',
          },
          210203: {
            name: {
              th: 'บ้านฉาง',
              en: 'Ban Chang',
            },
            zipcode: '21130',
          },
        },
      },
      2103: {
        name: {
          th: 'แกลง',
          en: 'Klaeng',
        },
        tambons: {
          210301: {
            name: {
              th: 'ทางเกวียน',
              en: 'Thang Kwian',
            },
            zipcode: '21110',
          },
          210302: {
            name: {
              th: 'วังหว้า',
              en: 'Wang Wa',
            },
            zipcode: '21110',
          },
          210303: {
            name: {
              th: 'ชากโดน',
              en: 'Chak Don',
            },
            zipcode: '21110',
          },
          210304: {
            name: {
              th: 'เนินฆ้อ',
              en: 'Noen Kho',
            },
            zipcode: '21110',
          },
          210305: {
            name: {
              th: 'กร่ำ',
              en: 'Kram',
            },
            zipcode: '21190',
          },
          210306: {
            name: {
              th: 'ชากพง',
              en: 'Chak Phong',
            },
            zipcode: '21190',
          },
          210307: {
            name: {
              th: 'กระแสบน',
              en: 'Krasae Bon',
            },
            zipcode: '21110',
          },
          210308: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '21110',
          },
          210309: {
            name: {
              th: 'ทุ่งควายกิน',
              en: 'Thung Khwai Kin',
            },
            zipcode: '21110',
          },
          210310: {
            name: {
              th: 'กองดิน',
              en: 'Kong Din',
            },
            zipcode: '22160',
          },
          210311: {
            name: {
              th: 'คลองปูน',
              en: 'Khlong Pun',
            },
            zipcode: '21170',
          },
          210312: {
            name: {
              th: 'พังราด',
              en: 'Phang Rat',
            },
            zipcode: '21170',
          },
          210313: {
            name: {
              th: 'ปากน้ำกระแส',
              en: 'Pak Nam Krasae',
            },
            zipcode: '21170',
          },
          210317: {
            name: {
              th: 'ห้วยยาง',
              en: 'Huai Yang',
            },
            zipcode: '21110',
          },
          210318: {
            name: {
              th: 'สองสลึง',
              en: 'Song Salueng',
            },
            zipcode: '21110',
          },
        },
      },
      2104: {
        name: {
          th: 'วังจันทร์',
          en: 'Wang Chan',
        },
        tambons: {
          210401: {
            name: {
              th: 'วังจันทร์',
              en: 'Wang Chan',
            },
            zipcode: '21210',
          },
          210402: {
            name: {
              th: 'ชุมแสง',
              en: 'Chum Saeng',
            },
            zipcode: '21210',
          },
          210403: {
            name: {
              th: 'ป่ายุบใน',
              en: 'Pa Yup Nai',
            },
            zipcode: '21210',
          },
          210404: {
            name: {
              th: 'พลงตาเอี่ยม',
              en: 'Phlong Ta Iam',
            },
            zipcode: '21210',
          },
        },
      },
      2105: {
        name: {
          th: 'บ้านค่าย',
          en: 'Ban Khai',
        },
        tambons: {
          210501: {
            name: {
              th: 'บ้านค่าย',
              en: 'Ban Kha',
            },
            zipcode: '21120',
          },
          210502: {
            name: {
              th: 'หนองละลอก',
              en: 'Nong Lalok',
            },
            zipcode: '21120',
          },
          210503: {
            name: {
              th: 'หนองตะพาน',
              en: 'Nong Taphan',
            },
            zipcode: '21120',
          },
          210504: {
            name: {
              th: 'ตาขัน',
              en: 'Ta Khan',
            },
            zipcode: '21120',
          },
          210505: {
            name: {
              th: 'บางบุตร',
              en: 'Bang But',
            },
            zipcode: '21120',
          },
          210506: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '21120',
          },
          210507: {
            name: {
              th: 'ชากบก',
              en: 'Chak Bok',
            },
            zipcode: '21120',
          },
        },
      },
      2106: {
        name: {
          th: 'ปลวกแดง',
          en: 'Pluak Daeng',
        },
        tambons: {
          210601: {
            name: {
              th: 'ปลวกแดง',
              en: 'Pluak Daeng',
            },
            zipcode: '21140',
          },
          210602: {
            name: {
              th: 'ตาสิทธิ์',
              en: 'Ta Sit',
            },
            zipcode: '21140',
          },
          210603: {
            name: {
              th: 'ละหาร',
              en: 'Lahan',
            },
            zipcode: '21140',
          },
          210604: {
            name: {
              th: 'แม่น้ำคู้',
              en: 'Maenam Khu',
            },
            zipcode: '21140',
          },
          210605: {
            name: {
              th: 'มาบยางพร',
              en: 'Map Yang Phon',
            },
            zipcode: '21140',
          },
          210606: {
            name: {
              th: 'หนองไร่',
              en: 'Nong Rai',
            },
            zipcode: '21140',
          },
        },
      },
      2107: {
        name: {
          th: 'เขาชะเมา',
          en: 'Khao Chamao',
        },
        tambons: {
          210701: {
            name: {
              th: 'น้ำเป็น',
              en: 'Nam Pen',
            },
            zipcode: '21110',
          },
          210702: {
            name: {
              th: 'ห้วยทับมอญ',
              en: 'Huai Thap Mon',
            },
            zipcode: '21110',
          },
          210703: {
            name: {
              th: 'ชำฆ้อ',
              en: 'Cham Kho',
            },
            zipcode: '21110',
          },
          210704: {
            name: {
              th: 'เขาน้อย',
              en: 'Khao Noi',
            },
            zipcode: '21110',
          },
        },
      },
      2108: {
        name: {
          th: 'นิคมพัฒนา',
          en: 'King Amphoe Nikhom Phathana',
        },
        tambons: {
          210801: {
            name: {
              th: 'นิคมพัฒนา',
              en: 'Nikhom Phatthana',
            },
            zipcode: '21180',
          },
          210802: {
            name: {
              th: 'มาบข่า',
              en: 'Map Kha',
            },
            zipcode: '21180',
          },
          210803: {
            name: {
              th: 'พนานิคม',
              en: 'Phana Nikhom',
            },
            zipcode: '21180',
          },
          210804: {
            name: {
              th: 'มะขามคู่',
              en: 'Makham Khu',
            },
            zipcode: '21180',
          },
        },
      },
    },
  },
  22: {
    name: {
      th: 'จันทบุรี',
      en: 'Chanthaburi',
    },
    amphoes: {
      2201: {
        name: {
          th: 'เมืองจันทบุรี',
          en: 'Muang',
        },
        tambons: {
          220101: {
            name: {
              th: 'ตลาด',
              en: 'Talat',
            },
            zipcode: '22000',
          },
          220102: {
            name: {
              th: 'วัดใหม่',
              en: 'Wat Mai',
            },
            zipcode: '22000',
          },
          220103: {
            name: {
              th: 'คลองนารายณ์',
              en: 'Khlong Narai',
            },
            zipcode: '22000',
          },
          220104: {
            name: {
              th: 'เกาะขวาง',
              en: 'Ko Khwang',
            },
            zipcode: '22000',
          },
          220105: {
            name: {
              th: 'คมบาง',
              en: 'Khom Bang',
            },
            zipcode: '22000',
          },
          220106: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '22000',
          },
          220107: {
            name: {
              th: 'จันทนิมิต',
              en: 'Chanthanimit',
            },
            zipcode: '22000',
          },
          220108: {
            name: {
              th: 'บางกะจะ',
              en: 'Bang Kacha',
            },
            zipcode: '22000',
          },
          220109: {
            name: {
              th: 'แสลง',
              en: 'Salaeng',
            },
            zipcode: '22000',
          },
          220110: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '22000',
          },
          220111: {
            name: {
              th: 'พลับพลา',
              en: 'Phlapphla',
            },
            zipcode: '22000',
          },
        },
      },
      2202: {
        name: {
          th: 'ขลุง',
          en: 'Khlung',
        },
        tambons: {
          220201: {
            name: {
              th: 'ขลุง',
              en: 'Khlung',
            },
            zipcode: '22110',
          },
          220202: {
            name: {
              th: 'บ่อ',
              en: 'Bo',
            },
            zipcode: '22110',
          },
          220203: {
            name: {
              th: 'เกวียนหัก',
              en: 'Kwian Hak',
            },
            zipcode: '22110',
          },
          220204: {
            name: {
              th: 'ตะปอน',
              en: 'Tapon',
            },
            zipcode: '22110',
          },
          220205: {
            name: {
              th: 'บางชัน',
              en: 'Bang Chan',
            },
            zipcode: '22110',
          },
          220206: {
            name: {
              th: 'วันยาว',
              en: 'Wan Yao',
            },
            zipcode: '22110',
          },
          220207: {
            name: {
              th: 'ซึ้ง',
              en: 'Sueng',
            },
            zipcode: '22110',
          },
          220208: {
            name: {
              th: 'มาบไพ',
              en: 'Map Phai',
            },
            zipcode: '22110',
          },
          220209: {
            name: {
              th: 'วังสรรพรส',
              en: 'Wang Sappharot',
            },
            zipcode: '22110',
          },
          220210: {
            name: {
              th: 'ตรอกนอง',
              en: 'Trok Nong',
            },
            zipcode: '22110',
          },
          220211: {
            name: {
              th: 'ตกพรม',
              en: 'Tok Phrom',
            },
            zipcode: '22110',
          },
          220212: {
            name: {
              th: 'บ่อเวฬุ',
              en: 'Bo Welu',
            },
            zipcode: '22150',
          },
        },
      },
      2203: {
        name: {
          th: 'ท่าใหม่',
          en: 'Tha Mai',
        },
        tambons: {
          220301: {
            name: {
              th: 'ท่าใหม่',
              en: 'Tha Mai',
            },
            zipcode: '22120',
          },
          220302: {
            name: {
              th: 'ยายร้า',
              en: 'Yai Ra',
            },
            zipcode: '22120',
          },
          220303: {
            name: {
              th: 'สีพยา',
              en: 'Si Phaya',
            },
            zipcode: '22120',
          },
          220304: {
            name: {
              th: 'บ่อพุ',
              en: 'Bo Phu',
            },
            zipcode: '22120',
          },
          220305: {
            name: {
              th: 'พลอยแหวน',
              en: 'Phloi Waen',
            },
            zipcode: '22120',
          },
          220306: {
            name: {
              th: 'เขาวัว',
              en: 'Khao Wua',
            },
            zipcode: '22120',
          },
          220307: {
            name: {
              th: 'เขาบายศรี',
              en: 'Khao Baisi',
            },
            zipcode: '22120',
          },
          220308: {
            name: {
              th: 'สองพี่น้อง',
              en: 'Song Phi Nong',
            },
            zipcode: '22120',
          },
          220309: {
            name: {
              th: 'ทุ่งเบญจา',
              en: 'Thung Bencha',
            },
            zipcode: '22170',
          },
          220311: {
            name: {
              th: 'รำพัน',
              en: 'Ramphan',
            },
            zipcode: '22170',
          },
          220312: {
            name: {
              th: 'โขมง',
              en: 'Khamong',
            },
            zipcode: '22170',
          },
          220313: {
            name: {
              th: 'ตะกาดเง้า',
              en: 'Takat Ngao',
            },
            zipcode: '22120',
          },
          220314: {
            name: {
              th: 'คลองขุด',
              en: 'Khlong Khut',
            },
            zipcode: '22120',
          },
          220324: {
            name: {
              th: 'เขาแก้ว',
              en: 'Khao Kaeo',
            },
            zipcode: '22170',
          },
        },
      },
      2204: {
        name: {
          th: 'โป่งน้ำร้อน',
          en: 'Pong Nam Ron',
        },
        tambons: {
          220401: {
            name: {
              th: 'ทับไทร',
              en: 'Thap Sai',
            },
            zipcode: '22140',
          },
          220402: {
            name: {
              th: 'โป่งน้ำร้อน',
              en: 'Pong Nam Ron',
            },
            zipcode: '22140',
          },
          220404: {
            name: {
              th: 'หนองตาคง',
              en: 'Nong Ta Khong',
            },
            zipcode: '22140',
          },
          220409: {
            name: {
              th: 'เทพนิมิต',
              en: 'Thep Nimit',
            },
            zipcode: '22140',
          },
          220410: {
            name: {
              th: 'คลองใหญ่',
              en: 'Khlong Yai',
            },
            zipcode: '22140',
          },
        },
      },
      2205: {
        name: {
          th: 'มะขาม',
          en: 'Makham',
        },
        tambons: {
          220501: {
            name: {
              th: 'มะขาม',
              en: 'Makham',
            },
            zipcode: '22150',
          },
          220502: {
            name: {
              th: 'ท่าหลวง',
              en: 'Tha Luang',
            },
            zipcode: '22150',
          },
          220503: {
            name: {
              th: 'ปัถวี',
              en: 'Patthawi',
            },
            zipcode: '22150',
          },
          220504: {
            name: {
              th: 'วังแซ้ม',
              en: 'Wang Saem',
            },
            zipcode: '22150',
          },
          220506: {
            name: {
              th: 'ฉมัน',
              en: 'Chaman',
            },
            zipcode: '22150',
          },
          220508: {
            name: {
              th: 'อ่างคีรี',
              en: 'Ang Khiri',
            },
            zipcode: '22150',
          },
        },
      },
      2206: {
        name: {
          th: 'แหลมสิงห์',
          en: 'Laem Sing',
        },
        tambons: {
          220601: {
            name: {
              th: 'ปากน้ำแหลมสิงห์',
              en: 'Pak Nam Laem Sing',
            },
            zipcode: '22130',
          },
          220602: {
            name: {
              th: 'เกาะเปริด',
              en: 'Ko Perit',
            },
            zipcode: '22130',
          },
          220603: {
            name: {
              th: 'หนองชิ่ม',
              en: 'Nong Chim',
            },
            zipcode: '22130',
          },
          220604: {
            name: {
              th: 'พลิ้ว',
              en: 'Phlio',
            },
            zipcode: '22190',
          },
          220605: {
            name: {
              th: 'คลองน้ำเค็ม',
              en: 'Khlong Nam Khem',
            },
            zipcode: '22190',
          },
          220606: {
            name: {
              th: 'บางสระเก้า',
              en: 'Bang Sa Kao',
            },
            zipcode: '22190',
          },
          220607: {
            name: {
              th: 'บางกะไชย',
              en: 'Bang Kachai',
            },
            zipcode: '22120',
          },
        },
      },
      2207: {
        name: {
          th: 'สอยดาว',
          en: 'Soi Dao',
        },
        tambons: {
          220701: {
            name: {
              th: 'ปะตง',
              en: 'Patong',
            },
            zipcode: '22180',
          },
          220702: {
            name: {
              th: 'ทุ่งขนาน',
              en: 'Thung Khanan',
            },
            zipcode: '22180',
          },
          220703: {
            name: {
              th: 'ทับช้าง',
              en: 'Thap Chang',
            },
            zipcode: '22180',
          },
          220704: {
            name: {
              th: 'ทรายขาว',
              en: 'Sai Khao',
            },
            zipcode: '22180',
          },
          220705: {
            name: {
              th: 'สะตอน',
              en: 'Saton',
            },
            zipcode: '22180',
          },
        },
      },
      2208: {
        name: {
          th: 'แก่งหางแมว',
          en: 'Kaeng Hang Maeo',
        },
        tambons: {
          220801: {
            name: {
              th: 'แก่งหางแมว',
              en: 'Kaeng Hang Maeo',
            },
            zipcode: '22160',
          },
          220802: {
            name: {
              th: 'ขุนซ่อง',
              en: 'Khun Song',
            },
            zipcode: '22160',
          },
          220803: {
            name: {
              th: 'สามพี่น้อง',
              en: 'Sam Phi Nong',
            },
            zipcode: '22160',
          },
          220804: {
            name: {
              th: 'พวา',
              en: 'Phawa',
            },
            zipcode: '22160',
          },
          220805: {
            name: {
              th: 'เขาวงกต',
              en: 'Khao Wongkot',
            },
            zipcode: '22160',
          },
        },
      },
      2209: {
        name: {
          th: 'นายายอาม',
          en: 'Na Yai Am',
        },
        tambons: {
          220901: {
            name: {
              th: 'นายายอาม',
              en: 'Na Yai Am',
            },
            zipcode: '22160',
          },
          220902: {
            name: {
              th: 'วังโตนด',
              en: 'Wang Tanot',
            },
            zipcode: '22170',
          },
          220903: {
            name: {
              th: 'กระแจะ',
              en: 'Krachae',
            },
            zipcode: '22170',
          },
          220904: {
            name: {
              th: 'สนามไชย',
              en: 'Sanam Chai',
            },
            zipcode: '22170',
          },
          220905: {
            name: {
              th: 'ช้างข้าม',
              en: 'Chang Kham',
            },
            zipcode: '22160',
          },
          220906: {
            name: {
              th: 'วังใหม่',
              en: 'Wang Mai',
            },
            zipcode: '22170',
          },
        },
      },
      2210: {
        name: {
          th: 'เขาคิชฌกูฏ',
          en: 'Khao Kitchagoot',
        },
        tambons: {
          221001: {
            name: {
              th: 'ชากไทย',
              en: 'Chak Thai',
            },
            zipcode: '22210',
          },
          221002: {
            name: {
              th: 'พลวง',
              en: 'Phluang',
            },
            zipcode: '22210',
          },
          221003: {
            name: {
              th: 'ตะเคียนทอง',
              en: 'Takhian Thong',
            },
            zipcode: '22210',
          },
          221004: {
            name: {
              th: 'คลองพลู',
              en: 'Khlong Phlu',
            },
            zipcode: '22210',
          },
          221005: {
            name: {
              th: 'จันทเขลม',
              en: 'Chanthakhlem',
            },
            zipcode: '22210',
          },
        },
      },
    },
  },
  23: {
    name: {
      th: 'ตราด',
      en: 'Trat',
    },
    amphoes: {
      2301: {
        name: {
          th: 'เมืองตราด',
          en: 'Muang',
        },
        tambons: {
          230101: {
            name: {
              th: 'บางพระ',
              en: 'Bang Phra',
            },
            zipcode: '23000',
          },
          230102: {
            name: {
              th: 'หนองเสม็ด',
              en: 'Nong Samet',
            },
            zipcode: '23000',
          },
          230103: {
            name: {
              th: 'หนองโสน',
              en: 'Nong Sano',
            },
            zipcode: '23000',
          },
          230104: {
            name: {
              th: 'หนองคันทรง',
              en: 'Nong Khan Song',
            },
            zipcode: '23000',
          },
          230105: {
            name: {
              th: 'ห้วงน้ำขาว',
              en: 'Huang Nam Khao',
            },
            zipcode: '23000',
          },
          230106: {
            name: {
              th: 'อ่าวใหญ่',
              en: 'Ao Yai',
            },
            zipcode: '23000',
          },
          230107: {
            name: {
              th: 'วังกระแจะ',
              en: 'Wang Krachae',
            },
            zipcode: '23000',
          },
          230108: {
            name: {
              th: 'ห้วยแร้ง',
              en: 'Huai Raeng',
            },
            zipcode: '23000',
          },
          230109: {
            name: {
              th: 'เนินทราย',
              en: 'Noen Sai',
            },
            zipcode: '23000',
          },
          230110: {
            name: {
              th: 'ท่าพริก',
              en: 'Tha Phrik',
            },
            zipcode: '23000',
          },
          230111: {
            name: {
              th: 'ท่ากุ่ม',
              en: 'Tha Kum',
            },
            zipcode: '23000',
          },
          230112: {
            name: {
              th: 'ตะกาง',
              en: 'Takang',
            },
            zipcode: '23000',
          },
          230113: {
            name: {
              th: 'ชำราก',
              en: 'Chamrak',
            },
            zipcode: '23000',
          },
          230114: {
            name: {
              th: 'แหลมกลัด',
              en: 'Laem Klat',
            },
            zipcode: '23000',
          },
        },
      },
      2302: {
        name: {
          th: 'คลองใหญ่',
          en: 'Khlong Yai',
        },
        tambons: {
          230201: {
            name: {
              th: 'คลองใหญ่',
              en: 'Khlong Yai',
            },
            zipcode: '23110',
          },
          230202: {
            name: {
              th: 'ไม้รูด',
              en: 'Mai Rut',
            },
            zipcode: '23110',
          },
          230203: {
            name: {
              th: 'หาดเล็ก',
              en: 'Hat Lek',
            },
            zipcode: '23110',
          },
        },
      },
      2303: {
        name: {
          th: 'เขาสมิง',
          en: 'Khao Saming',
        },
        tambons: {
          230301: {
            name: {
              th: 'เขาสมิง',
              en: 'Khao Saming',
            },
            zipcode: '23130',
          },
          230302: {
            name: {
              th: 'แสนตุ้ง',
              en: 'Saen Tung',
            },
            zipcode: '23150',
          },
          230303: {
            name: {
              th: 'วังตะเคียน',
              en: 'Wang Takhian',
            },
            zipcode: '23130',
          },
          230304: {
            name: {
              th: 'ท่าโสม',
              en: 'Tha Som',
            },
            zipcode: '23150',
          },
          230305: {
            name: {
              th: 'สะตอ',
              en: 'Sato',
            },
            zipcode: '23150',
          },
          230306: {
            name: {
              th: 'ประณีต',
              en: 'Pranit',
            },
            zipcode: '23150',
          },
          230307: {
            name: {
              th: 'เทพนิมิต',
              en: 'Thep Nimit',
            },
            zipcode: '23150',
          },
          230308: {
            name: {
              th: 'ทุ่งนนทรี',
              en: 'Thung Nonsi',
            },
            zipcode: '23130',
          },
        },
      },
      2304: {
        name: {
          th: 'บ่อไร่',
          en: 'Bo Rai',
        },
        tambons: {
          230401: {
            name: {
              th: 'บ่อพลอย',
              en: 'Bo Phloi',
            },
            zipcode: '23140',
          },
          230402: {
            name: {
              th: 'ช้างทูน',
              en: 'Chang Thun',
            },
            zipcode: '23140',
          },
          230403: {
            name: {
              th: 'ด่านชุมพล',
              en: 'Dan Chumphon',
            },
            zipcode: '23140',
          },
          230404: {
            name: {
              th: 'หนองบอน',
              en: 'Nong Bon',
            },
            zipcode: '23140',
          },
          230405: {
            name: {
              th: 'นนทรีย์',
              en: 'Nonsi',
            },
            zipcode: '23140',
          },
        },
      },
      2305: {
        name: {
          th: 'แหลมงอบ',
          en: 'Lam Ngop',
        },
        tambons: {
          230501: {
            name: {
              th: 'แหลมงอบ',
              en: 'Laem Ngop',
            },
            zipcode: '23120',
          },
          230502: {
            name: {
              th: 'น้ำเชี่ยว',
              en: 'Nam Chiao',
            },
            zipcode: '23120',
          },
          230503: {
            name: {
              th: 'บางปิด',
              en: 'Bang Pit',
            },
            zipcode: '23120',
          },
          230507: {
            name: {
              th: 'คลองใหญ่',
              en: 'Khlong Yai',
            },
            zipcode: '23120',
          },
        },
      },
      2306: {
        name: {
          th: 'เกาะกูด',
          en: 'King Amphoe Ko Kut',
        },
        tambons: {
          230601: {
            name: {
              th: 'เกาะหมาก',
              en: 'Ko Mak',
            },
            zipcode: '23000',
          },
          230602: {
            name: {
              th: 'เกาะกูด',
              en: 'Ko Kut',
            },
            zipcode: '23000',
          },
        },
      },
      2307: {
        name: {
          th: 'เกาะช้าง',
          en: 'King Amphoe Ko Chang',
        },
        tambons: {
          230701: {
            name: {
              th: 'เกาะช้าง',
              en: 'Ko Chang',
            },
            zipcode: '23170',
          },
          230702: {
            name: {
              th: 'เกาะช้างใต้',
              en: 'Ko Chang Taiย ',
            },
            zipcode: '23170',
          },
        },
      },
    },
  },
  24: {
    name: {
      th: 'ฉะเชิงเทรา',
      en: 'Chachoengsao',
    },
    amphoes: {
      2401: {
        name: {
          th: 'เมืองฉะเชิงเทรา',
          en: 'Muang',
        },
        tambons: {
          240101: {
            name: {
              th: 'หน้าเมือง',
              en: 'Na Mueang',
            },
            zipcode: '24000',
          },
          240102: {
            name: {
              th: 'ท่าไข่',
              en: 'Tha Khai',
            },
            zipcode: '24000',
          },
          240103: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '24000',
          },
          240104: {
            name: {
              th: 'คลองนา',
              en: 'Khlong Na',
            },
            zipcode: '24000',
          },
          240105: {
            name: {
              th: 'บางตีนเป็ด',
              en: 'Bang Tin Pet',
            },
            zipcode: '24000',
          },
          240106: {
            name: {
              th: 'บางไผ่',
              en: 'Bang Phai',
            },
            zipcode: '24000',
          },
          240107: {
            name: {
              th: 'คลองจุกกระเฌอ',
              en: 'Khlong Chuk Krachoe',
            },
            zipcode: '24000',
          },
          240108: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '24000',
          },
          240109: {
            name: {
              th: 'บางขวัญ',
              en: 'Bang Khwan',
            },
            zipcode: '24000',
          },
          240110: {
            name: {
              th: 'คลองนครเนื่องเขต',
              en: 'Khlong Nakhon Nueang Khet',
            },
            zipcode: '24000',
          },
          240111: {
            name: {
              th: 'วังตะเคียน',
              en: 'Wang Takhian',
            },
            zipcode: '24000',
          },
          240112: {
            name: {
              th: 'โสธร',
              en: 'Sothon',
            },
            zipcode: '24000',
          },
          240113: {
            name: {
              th: 'บางพระ',
              en: 'Bang Phra',
            },
            zipcode: '24000',
          },
          240114: {
            name: {
              th: 'บางกะไห',
              en: 'Bang Kahai',
            },
            zipcode: '24000',
          },
          240115: {
            name: {
              th: 'หนามแดง',
              en: 'Nam Daeng',
            },
            zipcode: '24000',
          },
          240116: {
            name: {
              th: 'คลองเปรง',
              en: 'Khlong Preng',
            },
            zipcode: '24000',
          },
          240117: {
            name: {
              th: 'คลองอุดมชลจร',
              en: 'Khlong Udom Chonlachon',
            },
            zipcode: '24000',
          },
          240118: {
            name: {
              th: 'คลองหลวงแพ่ง',
              en: 'Khlong Luang Phaeng',
            },
            zipcode: '24000',
          },
          240119: {
            name: {
              th: 'บางเตย',
              en: 'Bang Toei',
            },
            zipcode: '24000',
          },
        },
      },
      2402: {
        name: {
          th: 'บางคล้า',
          en: 'Bang Khla',
        },
        tambons: {
          240201: {
            name: {
              th: 'บางคล้า',
              en: 'Bang Khla',
            },
            zipcode: '24110',
          },
          240204: {
            name: {
              th: 'บางสวน',
              en: 'Bang Suan',
            },
            zipcode: '24110',
          },
          240208: {
            name: {
              th: 'บางกระเจ็ด',
              en: 'Bang Krachet',
            },
            zipcode: '24110',
          },
          240209: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '24110',
          },
          240210: {
            name: {
              th: 'ท่าทองหลาง',
              en: 'Tha Thonglang',
            },
            zipcode: '24110',
          },
          240211: {
            name: {
              th: 'สาวชะโงก',
              en: 'Sao Cha-ngok',
            },
            zipcode: '24110',
          },
          240212: {
            name: {
              th: 'เสม็ดเหนือ',
              en: 'Samet Nuea',
            },
            zipcode: '24110',
          },
          240213: {
            name: {
              th: 'เสม็ดใต้',
              en: 'Samet Tai',
            },
            zipcode: '24110',
          },
          240214: {
            name: {
              th: 'หัวไทร',
              en: 'Hua Sai',
            },
            zipcode: '24110',
          },
        },
      },
      2403: {
        name: {
          th: 'บางน้ำเปรี้ยว',
          en: 'Bang Nam Prieo',
        },
        tambons: {
          240301: {
            name: {
              th: 'บางน้ำเปรี้ยว',
              en: 'Bang Nam Priao',
            },
            zipcode: '24150',
          },
          240302: {
            name: {
              th: 'บางขนาก',
              en: 'Bang Khanak',
            },
            zipcode: '24150',
          },
          240303: {
            name: {
              th: 'สิงโตทอง',
              en: 'Singto Thong',
            },
            zipcode: '24150',
          },
          240304: {
            name: {
              th: 'หมอนทอง',
              en: 'Mon Thong',
            },
            zipcode: '24150',
          },
          240305: {
            name: {
              th: 'บึงน้ำรักษ์',
              en: 'Bueng Nam Rak',
            },
            zipcode: '24170',
          },
          240306: {
            name: {
              th: 'ดอนเกาะกา',
              en: 'Don Ko Ka',
            },
            zipcode: '24170',
          },
          240307: {
            name: {
              th: 'โยธะกา',
              en: 'Yothaka',
            },
            zipcode: '24150',
          },
          240308: {
            name: {
              th: 'ดอนฉิมพลี',
              en: 'Don Chimphli',
            },
            zipcode: '24170',
          },
          240309: {
            name: {
              th: 'ศาลาแดง',
              en: 'Sala Daeng',
            },
            zipcode: '24000',
          },
          240310: {
            name: {
              th: 'โพรงอากาศ',
              en: 'Phrong Akat',
            },
            zipcode: '24150',
          },
        },
      },
      2404: {
        name: {
          th: 'บางปะกง',
          en: 'Bang Pakong',
        },
        tambons: {
          240401: {
            name: {
              th: 'บางปะกง',
              en: 'Bang Pakong',
            },
            zipcode: '24130',
          },
          240402: {
            name: {
              th: 'ท่าสะอ้าน',
              en: 'Tha Sa-an',
            },
            zipcode: '24130',
          },
          240403: {
            name: {
              th: 'บางวัว',
              en: 'Bang Wua',
            },
            zipcode: '24180',
          },
          240404: {
            name: {
              th: 'บางสมัคร',
              en: 'Bang Samak',
            },
            zipcode: '24180',
          },
          240405: {
            name: {
              th: 'บางผึ้ง',
              en: 'Bang Phueng',
            },
            zipcode: '24130',
          },
          240406: {
            name: {
              th: 'บางเกลือ',
              en: 'Bang Kluea',
            },
            zipcode: '24180',
          },
          240407: {
            name: {
              th: 'สองคลอง',
              en: 'Song Khlong',
            },
            zipcode: '24130',
          },
          240408: {
            name: {
              th: 'หนองจอก',
              en: 'Nong Chok',
            },
            zipcode: '24130',
          },
          240409: {
            name: {
              th: 'พิมพา',
              en: 'Phimpha',
            },
            zipcode: '24130',
          },
          240410: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '24130',
          },
          240411: {
            name: {
              th: 'หอมศีล',
              en: 'Hom Sin',
            },
            zipcode: '24180',
          },
          240412: {
            name: {
              th: 'เขาดิน',
              en: 'Khao Din',
            },
            zipcode: '24130',
          },
        },
      },
      2405: {
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        tambons: {
          240501: {
            name: {
              th: 'บ้านโพธิ์',
              en: 'Ban Pho',
            },
            zipcode: '24140',
          },
          240502: {
            name: {
              th: 'เกาะไร่',
              en: 'Ko Rai',
            },
            zipcode: '24140',
          },
          240503: {
            name: {
              th: 'คลองขุด',
              en: 'Khlong Khut',
            },
            zipcode: '24140',
          },
          240504: {
            name: {
              th: 'คลองบ้านโพธิ์',
              en: 'Khlong Ban Pho',
            },
            zipcode: '24140',
          },
          240505: {
            name: {
              th: 'คลองประเวศ',
              en: 'Khlong Prawet',
            },
            zipcode: '24140',
          },
          240506: {
            name: {
              th: 'ดอนทราย',
              en: 'Don Sai',
            },
            zipcode: '24140',
          },
          240507: {
            name: {
              th: 'เทพราช',
              en: 'Theppharat',
            },
            zipcode: '24140',
          },
          240508: {
            name: {
              th: 'ท่าพลับ',
              en: 'Tha Phlap',
            },
            zipcode: '24140',
          },
          240509: {
            name: {
              th: 'หนองตีนนก',
              en: 'Nong Tin Nok',
            },
            zipcode: '24140',
          },
          240510: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '24140',
          },
          240511: {
            name: {
              th: 'บางซ่อน',
              en: 'Bang Son',
            },
            zipcode: '24140',
          },
          240512: {
            name: {
              th: 'บางกรูด',
              en: 'Bang Krut',
            },
            zipcode: '24140',
          },
          240513: {
            name: {
              th: 'แหลมประดู่',
              en: 'Laem Pradu',
            },
            zipcode: '24140',
          },
          240514: {
            name: {
              th: 'ลาดขวาง',
              en: 'Lat Khwang',
            },
            zipcode: '24140',
          },
          240515: {
            name: {
              th: 'สนามจันทร์',
              en: 'Sanam Chan',
            },
            zipcode: '24140',
          },
          240516: {
            name: {
              th: 'แสนภูดาษ',
              en: 'Saen Phu Dat',
            },
            zipcode: '24140',
          },
          240517: {
            name: {
              th: 'สิบเอ็ดศอก',
              en: 'Sip Et Sok',
            },
            zipcode: '24140',
          },
        },
      },
      2406: {
        name: {
          th: 'พนมสารคาม',
          en: 'Phanom Sarakam',
        },
        tambons: {
          240601: {
            name: {
              th: 'เกาะขนุน',
              en: 'Ko Khanun',
            },
            zipcode: '24120',
          },
          240602: {
            name: {
              th: 'บ้านซ่อง',
              en: 'Ban Song',
            },
            zipcode: '24120',
          },
          240603: {
            name: {
              th: 'พนมสารคาม',
              en: 'Phanom Sarakham',
            },
            zipcode: '24120',
          },
          240604: {
            name: {
              th: 'เมืองเก่า',
              en: 'Mueang Kao',
            },
            zipcode: '24120',
          },
          240605: {
            name: {
              th: 'หนองยาว',
              en: 'Nong Yao',
            },
            zipcode: '24120',
          },
          240606: {
            name: {
              th: 'ท่าถ่าน',
              en: 'Tha Than',
            },
            zipcode: '24120',
          },
          240607: {
            name: {
              th: 'หนองแหน',
              en: 'Nong Nae',
            },
            zipcode: '24120',
          },
          240608: {
            name: {
              th: 'เขาหินซ้อน',
              en: 'Khao Hin Son',
            },
            zipcode: '24120',
          },
        },
      },
      2407: {
        name: {
          th: 'ราชสาส์น',
          en: 'Ratchasan',
        },
        tambons: {
          240701: {
            name: {
              th: 'บางคา',
              en: 'Bang Kha',
            },
            zipcode: '24120',
          },
          240702: {
            name: {
              th: 'เมืองใหม่',
              en: 'Mueang Mai',
            },
            zipcode: '24120',
          },
          240703: {
            name: {
              th: 'ดงน้อย',
              en: 'Dong Noi',
            },
            zipcode: '24120',
          },
        },
      },
      2408: {
        name: {
          th: 'สนามชัยเขต',
          en: 'Sanam Chaiket',
        },
        tambons: {
          240801: {
            name: {
              th: 'คู้ยายหมี',
              en: 'Khu Yai Mi',
            },
            zipcode: '24160',
          },
          240802: {
            name: {
              th: 'ท่ากระดาน',
              en: 'Tha Kradan',
            },
            zipcode: '24160',
          },
          240803: {
            name: {
              th: 'ทุ่งพระยา',
              en: 'Thung Phraya',
            },
            zipcode: '24160',
          },
          240805: {
            name: {
              th: 'ลาดกระทิง',
              en: 'Lat Krathing',
            },
            zipcode: '24160',
          },
        },
      },
      2409: {
        name: {
          th: 'แปลงยาว',
          en: 'Plaeng Yao',
        },
        tambons: {
          240901: {
            name: {
              th: 'แปลงยาว',
              en: 'Plaeng Yao',
            },
            zipcode: '24190',
          },
          240902: {
            name: {
              th: 'วังเย็น',
              en: 'Wang Yen',
            },
            zipcode: '24190',
          },
          240903: {
            name: {
              th: 'หัวสำโรง',
              en: 'Hua Samrong',
            },
            zipcode: '24190',
          },
          240904: {
            name: {
              th: 'หนองไม้แก่น',
              en: 'Nong Mai Kaen',
            },
            zipcode: '24190',
          },
        },
      },
      2410: {
        name: {
          th: 'ท่าตะเกียบ',
          en: 'Tha Takep',
        },
        tambons: {
          241001: {
            name: {
              th: 'ท่าตะเกียบ',
              en: 'Tha Takiap',
            },
            zipcode: '24160',
          },
          241002: {
            name: {
              th: 'คลองตะเกรา',
              en: 'Khlong Takrao',
            },
            zipcode: '24160',
          },
        },
      },
      2411: {
        name: {
          th: 'คลองเขื่อน',
          en: 'Khlong Khuean',
        },
        tambons: {
          241101: {
            name: {
              th: 'ก้อนแก้ว',
              en: 'Kon Kaeo',
            },
            zipcode: '24000',
          },
          241102: {
            name: {
              th: 'คลองเขื่อน',
              en: 'Khlong Khuean',
            },
            zipcode: '24000',
          },
          241103: {
            name: {
              th: 'บางเล่า',
              en: 'Bang Lao',
            },
            zipcode: '24000',
          },
          241104: {
            name: {
              th: 'บางโรง',
              en: 'Bang Rong',
            },
            zipcode: '24000',
          },
          241105: {
            name: {
              th: 'บางตลาด',
              en: 'Bang Talat',
            },
            zipcode: '24110',
          },
        },
      },
    },
  },
  25: {
    name: {
      th: 'ปราจีนบุรี',
      en: 'Prachin Buri',
    },
    amphoes: {
      2501: {
        name: {
          th: 'เมืองปราจีนบุรี',
          en: 'Muang',
        },
        tambons: {
          250101: {
            name: {
              th: 'หน้าเมือง',
              en: 'Na Mueang',
            },
            zipcode: '25000',
          },
          250102: {
            name: {
              th: 'รอบเมือง',
              en: 'Rop Mueang',
            },
            zipcode: '25000',
          },
          250103: {
            name: {
              th: 'วัดโบสถ์',
              en: 'Wat Bot',
            },
            zipcode: '25000',
          },
          250104: {
            name: {
              th: 'บางเดชะ',
              en: 'Bang Decha',
            },
            zipcode: '25000',
          },
          250105: {
            name: {
              th: 'ท่างาม',
              en: 'Tha Ngam',
            },
            zipcode: '25000',
          },
          250106: {
            name: {
              th: 'บางบริบูรณ์',
              en: 'Bang Boribun',
            },
            zipcode: '25000',
          },
          250107: {
            name: {
              th: 'ดงพระราม',
              en: 'Dong Phraram',
            },
            zipcode: '25000',
          },
          250108: {
            name: {
              th: 'บ้านพระ',
              en: 'Ban Phra',
            },
            zipcode: '25230',
          },
          250109: {
            name: {
              th: 'โคกไม้ลาย',
              en: 'Khok Mai Lai',
            },
            zipcode: '25230',
          },
          250110: {
            name: {
              th: 'ไม้เค็ด',
              en: 'Mai Khet',
            },
            zipcode: '25230',
          },
          250111: {
            name: {
              th: 'ดงขี้เหล็ก',
              en: 'Dong Khilek',
            },
            zipcode: '25000',
          },
          250112: {
            name: {
              th: 'เนินหอม',
              en: 'Noen Hom',
            },
            zipcode: '25230',
          },
          250113: {
            name: {
              th: 'โนนห้อม',
              en: 'Non Hom',
            },
            zipcode: '25000',
          },
        },
      },
      2502: {
        name: {
          th: 'กบินทร์บุรี',
          en: 'Kabin Buri',
        },
        tambons: {
          250201: {
            name: {
              th: 'กบินทร์',
              en: 'Kabin',
            },
            zipcode: '25110',
          },
          250202: {
            name: {
              th: 'เมืองเก่า',
              en: 'Mueang Kao',
            },
            zipcode: '25240',
          },
          250203: {
            name: {
              th: 'วังดาล',
              en: 'Wang Dan',
            },
            zipcode: '25110',
          },
          250204: {
            name: {
              th: 'นนทรี',
              en: 'Nonsi',
            },
            zipcode: '25110',
          },
          250205: {
            name: {
              th: 'ย่านรี',
              en: 'Yan Ri',
            },
            zipcode: '25110',
          },
          250206: {
            name: {
              th: 'วังตะเคียน',
              en: 'Wang Takhian',
            },
            zipcode: '25110',
          },
          250207: {
            name: {
              th: 'หาดนางแก้ว',
              en: 'Hat Nang Kaeo',
            },
            zipcode: '25110',
          },
          250208: {
            name: {
              th: 'ลาดตะเคียน',
              en: 'Lat Takhian',
            },
            zipcode: '25110',
          },
          250209: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '25110',
          },
          250210: {
            name: {
              th: 'บ่อทอง',
              en: 'Bo Thong',
            },
            zipcode: '25110',
          },
          250211: {
            name: {
              th: 'หนองกี่',
              en: 'Nong Ki',
            },
            zipcode: '25110',
          },
          250212: {
            name: {
              th: 'นาแขม',
              en: 'Na Khaem',
            },
            zipcode: '25110',
          },
          250213: {
            name: {
              th: 'เขาไม้แก้ว',
              en: 'Khao Mai Kaeo',
            },
            zipcode: '25110',
          },
          250214: {
            name: {
              th: 'วังท่าช้าง',
              en: 'Wang Tha Chang',
            },
            zipcode: '25110',
          },
        },
      },
      2503: {
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        tambons: {
          250301: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '25220',
          },
          250302: {
            name: {
              th: 'สำพันตา',
              en: 'Samphan Ta',
            },
            zipcode: '25220',
          },
          250303: {
            name: {
              th: 'สะพานหิน',
              en: 'Saphan Hin',
            },
            zipcode: '25220',
          },
          250304: {
            name: {
              th: 'ทุ่งโพธิ์',
              en: 'Thung Pho',
            },
            zipcode: '25220',
          },
          250305: {
            name: {
              th: 'แก่งดินสอ',
              en: 'Kaeng Din So',
            },
            zipcode: '25220',
          },
          250306: {
            name: {
              th: 'บุพราหมณ์',
              en: 'Bu Phram',
            },
            zipcode: '25220',
          },
        },
      },
      2506: {
        name: {
          th: 'บ้านสร้าง',
          en: 'Ban Sang',
        },
        tambons: {
          250601: {
            name: {
              th: 'บ้านสร้าง',
              en: 'Ban Sang',
            },
            zipcode: '25150',
          },
          250602: {
            name: {
              th: 'บางกระเบา',
              en: 'Bang Krabao',
            },
            zipcode: '25150',
          },
          250603: {
            name: {
              th: 'บางเตย',
              en: 'Bang Toei',
            },
            zipcode: '25150',
          },
          250604: {
            name: {
              th: 'บางยาง',
              en: 'Bang Yang',
            },
            zipcode: '25150',
          },
          250605: {
            name: {
              th: 'บางแตน',
              en: 'Bang Taen',
            },
            zipcode: '25150',
          },
          250606: {
            name: {
              th: 'บางพลวง',
              en: 'Bang Phluang',
            },
            zipcode: '25150',
          },
          250607: {
            name: {
              th: 'บางปลาร้า',
              en: 'Bang Pla Ra',
            },
            zipcode: '25150',
          },
          250608: {
            name: {
              th: 'บางขาม',
              en: 'Bang Kham',
            },
            zipcode: '25150',
          },
          250609: {
            name: {
              th: 'กระทุ่มแพ้ว',
              en: 'Krathum Phaeo',
            },
            zipcode: '25150',
          },
        },
      },
      2507: {
        name: {
          th: 'ประจันตคาม',
          en: 'Prachantakham',
        },
        tambons: {
          250701: {
            name: {
              th: 'ประจันตคาม',
              en: 'Prachantakham',
            },
            zipcode: '25130',
          },
          250702: {
            name: {
              th: 'เกาะลอย',
              en: 'Ko Loi',
            },
            zipcode: '25130',
          },
          250703: {
            name: {
              th: 'บ้านหอย',
              en: 'Ban Hoi',
            },
            zipcode: '25130',
          },
          250704: {
            name: {
              th: 'หนองแสง',
              en: 'Nong Saeng',
            },
            zipcode: '25130',
          },
          250705: {
            name: {
              th: 'ดงบัง',
              en: 'Dong Bang',
            },
            zipcode: '25130',
          },
          250706: {
            name: {
              th: 'คำโตนด',
              en: 'Kham Tanot',
            },
            zipcode: '25130',
          },
          250707: {
            name: {
              th: 'บุฝ้าย',
              en: 'Bu Fai',
            },
            zipcode: '25130',
          },
          250708: {
            name: {
              th: 'หนองแก้ว',
              en: 'Nong Kaeo',
            },
            zipcode: '25130',
          },
          250709: {
            name: {
              th: 'โพธิ์งาม',
              en: 'Pho Ngam',
            },
            zipcode: '25130',
          },
        },
      },
      2508: {
        name: {
          th: 'ศรีมหาโพธิ',
          en: 'Si Maha Phot',
        },
        tambons: {
          250801: {
            name: {
              th: 'ศรีมหาโพธิ',
              en: 'Si Maha Phot',
            },
            zipcode: '25140',
          },
          250802: {
            name: {
              th: 'สัมพันธ์',
              en: 'Samphan',
            },
            zipcode: '25140',
          },
          250803: {
            name: {
              th: 'บ้านทาม',
              en: 'Ban Tham',
            },
            zipcode: '25140',
          },
          250804: {
            name: {
              th: 'ท่าตูม',
              en: 'Tha Tum',
            },
            zipcode: '25140',
          },
          250805: {
            name: {
              th: 'บางกุ้ง',
              en: 'Bang Kung',
            },
            zipcode: '25140',
          },
          250806: {
            name: {
              th: 'ดงกระทงยาม',
              en: 'Dong Krathong Yam',
            },
            zipcode: '25140',
          },
          250807: {
            name: {
              th: 'หนองโพรง',
              en: 'Nong Phrong',
            },
            zipcode: '25140',
          },
          250808: {
            name: {
              th: 'หัวหว้า',
              en: 'Hua Wa',
            },
            zipcode: '25140',
          },
          250809: {
            name: {
              th: 'หาดยาง',
              en: 'Hat Yang',
            },
            zipcode: '25140',
          },
          250810: {
            name: {
              th: 'กรอกสมบูรณ์',
              en: 'Krok Sombun',
            },
            zipcode: '25140',
          },
        },
      },
      2509: {
        name: {
          th: 'ศรีมโหสถ',
          en: 'Sri Maho Sot',
        },
        tambons: {
          250901: {
            name: {
              th: 'โคกปีบ',
              en: 'Khok Pip',
            },
            zipcode: '25190',
          },
          250902: {
            name: {
              th: 'โคกไทย',
              en: 'Khok Thai',
            },
            zipcode: '25190',
          },
          250903: {
            name: {
              th: 'คู้ลำพัน',
              en: 'Khu Lam Phan',
            },
            zipcode: '25190',
          },
          250904: {
            name: {
              th: 'ไผ่ชะเลือด',
              en: 'Phai Cha Lueat',
            },
            zipcode: '25190',
          },
        },
      },
    },
  },
  26: {
    name: {
      th: 'นครนายก',
      en: 'Nakhon Nayok',
    },
    amphoes: {
      2601: {
        name: {
          th: 'เมืองนครนายก',
          en: 'Muang',
        },
        tambons: {
          260101: {
            name: {
              th: 'นครนายก',
              en: 'Nakhon Nayok',
            },
            zipcode: '26000',
          },
          260102: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '26000',
          },
          260103: {
            name: {
              th: 'บ้านใหญ่',
              en: 'Ban Yai',
            },
            zipcode: '26000',
          },
          260104: {
            name: {
              th: 'วังกระโจม',
              en: 'Wang Krachom',
            },
            zipcode: '26000',
          },
          260105: {
            name: {
              th: 'ท่าทราย',
              en: 'Tha Sai',
            },
            zipcode: '26000',
          },
          260106: {
            name: {
              th: 'ดอนยอ',
              en: 'Don Yo',
            },
            zipcode: '26000',
          },
          260107: {
            name: {
              th: 'ศรีจุฬา',
              en: 'Si Chula',
            },
            zipcode: '26000',
          },
          260108: {
            name: {
              th: 'ดงละคร',
              en: 'Dong Lakhon',
            },
            zipcode: '26000',
          },
          260109: {
            name: {
              th: 'ศรีนาวา',
              en: 'Si Nawa',
            },
            zipcode: '26000',
          },
          260110: {
            name: {
              th: 'สาริกา',
              en: 'Sarika',
            },
            zipcode: '26000',
          },
          260111: {
            name: {
              th: 'หินตั้ง',
              en: 'Hin Tang',
            },
            zipcode: '26000',
          },
          260112: {
            name: {
              th: 'เขาพระ',
              en: 'Khao Phra',
            },
            zipcode: '26000',
          },
          260113: {
            name: {
              th: 'พรหมณี',
              en: 'Phrommani',
            },
            zipcode: '26000',
          },
        },
      },
      2602: {
        name: {
          th: 'ปากพลี',
          en: 'Pak Phli',
        },
        tambons: {
          260201: {
            name: {
              th: 'เกาะหวาย',
              en: 'Ko Wai',
            },
            zipcode: '26130',
          },
          260202: {
            name: {
              th: 'เกาะโพธิ์',
              en: 'Ko Pho',
            },
            zipcode: '26130',
          },
          260203: {
            name: {
              th: 'ปากพลี',
              en: 'Pak Phli',
            },
            zipcode: '26130',
          },
          260204: {
            name: {
              th: 'โคกกรวด',
              en: 'Khok Kruat',
            },
            zipcode: '26130',
          },
          260205: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '26130',
          },
          260206: {
            name: {
              th: 'หนองแสง',
              en: 'Nong Saeng',
            },
            zipcode: '26130',
          },
          260207: {
            name: {
              th: 'นาหินลาด',
              en: 'Na Hin Lat',
            },
            zipcode: '26130',
          },
        },
      },
      2603: {
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        tambons: {
          260301: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '26110',
          },
          260302: {
            name: {
              th: 'บ้านพร้าว',
              en: 'Ban Phrao',
            },
            zipcode: '26110',
          },
          260303: {
            name: {
              th: 'บ้านพริก',
              en: 'Ban Phrik',
            },
            zipcode: '26110',
          },
          260304: {
            name: {
              th: 'อาษา',
              en: 'Asa',
            },
            zipcode: '26110',
          },
          260305: {
            name: {
              th: 'ทองหลาง',
              en: 'Thong Lang',
            },
            zipcode: '26110',
          },
          260306: {
            name: {
              th: 'บางอ้อ',
              en: 'Bang O',
            },
            zipcode: '26110',
          },
          260307: {
            name: {
              th: 'พิกุลออก',
              en: 'Phikun Ok',
            },
            zipcode: '26110',
          },
          260308: {
            name: {
              th: 'ป่าขะ',
              en: 'Pa Kha',
            },
            zipcode: '26110',
          },
          260309: {
            name: {
              th: 'เขาเพิ่ม',
              en: 'Khao Phoem',
            },
            zipcode: '26110',
          },
          260310: {
            name: {
              th: 'ศรีกะอาง',
              en: 'Si Ka-ang',
            },
            zipcode: '26110',
          },
        },
      },
      2604: {
        name: {
          th: 'องครักษ์',
          en: 'Ongkarak',
        },
        tambons: {
          260401: {
            name: {
              th: 'พระอาจารย์',
              en: 'Phra Achan',
            },
            zipcode: '26120',
          },
          260402: {
            name: {
              th: 'บึงศาล',
              en: 'Bueng San',
            },
            zipcode: '26120',
          },
          260403: {
            name: {
              th: 'ศีรษะกระบือ',
              en: 'Sisa Krabue',
            },
            zipcode: '26120',
          },
          260404: {
            name: {
              th: 'โพธิ์แทน',
              en: 'Pho Thaen',
            },
            zipcode: '26120',
          },
          260405: {
            name: {
              th: 'บางสมบูรณ์',
              en: 'Bang Sombun',
            },
            zipcode: '26120',
          },
          260406: {
            name: {
              th: 'ทรายมูล',
              en: 'Sai Mun',
            },
            zipcode: '26120',
          },
          260407: {
            name: {
              th: 'บางปลากด',
              en: 'Bang Pla Kot',
            },
            zipcode: '26120',
          },
          260408: {
            name: {
              th: 'บางลูกเสือ',
              en: 'Bang Luk Suea',
            },
            zipcode: '26120',
          },
          260409: {
            name: {
              th: 'องครักษ์',
              en: 'Ongkharak',
            },
            zipcode: '26120',
          },
          260410: {
            name: {
              th: 'ชุมพล',
              en: 'Chumphon',
            },
            zipcode: '26120',
          },
          260411: {
            name: {
              th: 'คลองใหญ่',
              en: 'Khlong Yai',
            },
            zipcode: '26120',
          },
        },
      },
    },
  },
  27: {
    name: {
      th: 'สระแก้ว',
      en: 'Sa Kaeo',
    },
    amphoes: {
      2701: {
        name: {
          th: 'เมืองสระแก้ว',
          en: 'Muang',
        },
        tambons: {
          270101: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '27000',
          },
          270102: {
            name: {
              th: 'บ้านแก้ง',
              en: 'Ban Kaeng',
            },
            zipcode: '27000',
          },
          270103: {
            name: {
              th: 'ศาลาลำดวน',
              en: 'Sala Lamduan',
            },
            zipcode: '27000',
          },
          270104: {
            name: {
              th: 'โคกปี่ฆ้อง',
              en: 'Khok Pi Khong',
            },
            zipcode: '27000',
          },
          270105: {
            name: {
              th: 'ท่าแยก',
              en: 'Tha Yaek',
            },
            zipcode: '27000',
          },
          270106: {
            name: {
              th: 'ท่าเกษม',
              en: 'Tha Kasem',
            },
            zipcode: '27000',
          },
          270108: {
            name: {
              th: 'สระขวัญ',
              en: 'Sa Khwan',
            },
            zipcode: '27000',
          },
          270111: {
            name: {
              th: 'หนองบอน',
              en: 'Nong Bon',
            },
            zipcode: '27000',
          },
        },
      },
      2702: {
        name: {
          th: 'คลองหาด',
          en: 'Khong Hat',
        },
        tambons: {
          270201: {
            name: {
              th: 'คลองหาด',
              en: 'Khlong Hat',
            },
            zipcode: '27260',
          },
          270202: {
            name: {
              th: 'ไทยอุดม',
              en: 'Thai Udom',
            },
            zipcode: '27260',
          },
          270203: {
            name: {
              th: 'ซับมะกรูด',
              en: 'Sap Makrut',
            },
            zipcode: '27260',
          },
          270204: {
            name: {
              th: 'ไทรเดี่ยว',
              en: 'Sai Diao',
            },
            zipcode: '27260',
          },
          270205: {
            name: {
              th: 'คลองไก่เถื่อน',
              en: 'Khlong Kai Thuean',
            },
            zipcode: '27260',
          },
          270206: {
            name: {
              th: 'เบญจขร',
              en: 'Benchakhon',
            },
            zipcode: '27260',
          },
          270207: {
            name: {
              th: 'ไทรทอง',
              en: 'Sai Thong',
            },
            zipcode: '27260',
          },
        },
      },
      2703: {
        name: {
          th: 'ตาพระยา',
          en: 'Ta Phaya',
        },
        tambons: {
          270301: {
            name: {
              th: 'ตาพระยา',
              en: 'Ta Phraya',
            },
            zipcode: '27180',
          },
          270302: {
            name: {
              th: 'ทัพเสด็จ',
              en: 'Thap Sadet',
            },
            zipcode: '27180',
          },
          270306: {
            name: {
              th: 'ทัพราช',
              en: 'Thap Rat',
            },
            zipcode: '27180',
          },
          270307: {
            name: {
              th: 'ทัพไทย',
              en: 'Thap Thai',
            },
            zipcode: '27180',
          },
          270309: {
            name: {
              th: 'โคคลาน',
              en: 'Kho Khlan',
            },
            zipcode: '27180',
          },
        },
      },
      2704: {
        name: {
          th: 'วังน้ำเย็น',
          en: 'Wang Nam Yen',
        },
        tambons: {
          270401: {
            name: {
              th: 'วังน้ำเย็น',
              en: 'Wang Nam Yen',
            },
            zipcode: '27210',
          },
          270403: {
            name: {
              th: 'ตาหลังใน',
              en: 'Ta Lang Nai',
            },
            zipcode: '27210',
          },
          270405: {
            name: {
              th: 'คลองหินปูน',
              en: 'Khlong Hin Pun',
            },
            zipcode: '27210',
          },
          270406: {
            name: {
              th: 'ทุ่งมหาเจริญ',
              en: 'Thung Maha Charoen',
            },
            zipcode: '27210',
          },
        },
      },
      2705: {
        name: {
          th: 'วัฒนานคร',
          en: 'Watthana Nakhon',
        },
        tambons: {
          270501: {
            name: {
              th: 'วัฒนานคร',
              en: 'Watthana Nakhon',
            },
            zipcode: '27160',
          },
          270502: {
            name: {
              th: 'ท่าเกวียน',
              en: 'Tha Kwian',
            },
            zipcode: '27160',
          },
          270503: {
            name: {
              th: 'ผักขะ',
              en: 'Phak Hai',
            },
            zipcode: '27160',
          },
          270504: {
            name: {
              th: 'โนนหมากเค็ง',
              en: 'Non Mak Kheng',
            },
            zipcode: '27160',
          },
          270505: {
            name: {
              th: 'หนองน้ำใส',
              en: 'Nong Nam Sai',
            },
            zipcode: '27160',
          },
          270506: {
            name: {
              th: 'ช่องกุ่ม',
              en: 'Chong Kum',
            },
            zipcode: '27160',
          },
          270507: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '27160',
          },
          270508: {
            name: {
              th: 'แซร์ออ',
              en: 'Sae-o',
            },
            zipcode: '27160',
          },
          270509: {
            name: {
              th: 'หนองหมากฝ้าย',
              en: 'Nong Mak Fai',
            },
            zipcode: '27160',
          },
          270510: {
            name: {
              th: 'หนองตะเคียนบอน',
              en: 'Nong Takhian Bon',
            },
            zipcode: '27160',
          },
          270511: {
            name: {
              th: 'ห้วยโจด',
              en: 'Huai Chot',
            },
            zipcode: '27160',
          },
        },
      },
      2706: {
        name: {
          th: 'อรัญประเทศ',
          en: 'Aranyaprathet',
        },
        tambons: {
          270601: {
            name: {
              th: 'อรัญประเทศ',
              en: 'Aranyaprathet',
            },
            zipcode: '27120',
          },
          270602: {
            name: {
              th: 'เมืองไผ่',
              en: 'Mueang Phai',
            },
            zipcode: '27120',
          },
          270603: {
            name: {
              th: 'หันทราย',
              en: 'Han Sai',
            },
            zipcode: '27120',
          },
          270604: {
            name: {
              th: 'คลองน้ำใส',
              en: 'Khlong Nam Sai',
            },
            zipcode: '27120',
          },
          270605: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '27120',
          },
          270606: {
            name: {
              th: 'ป่าไร่',
              en: 'Pa Rai',
            },
            zipcode: '27120',
          },
          270607: {
            name: {
              th: 'ทับพริก',
              en: 'Thap Phrik',
            },
            zipcode: '27120',
          },
          270608: {
            name: {
              th: 'บ้านใหม่หนองไทร',
              en: 'Ban Mai Nong Sai',
            },
            zipcode: '27120',
          },
          270609: {
            name: {
              th: 'ผ่านศึก',
              en: 'Phan Suek',
            },
            zipcode: '27120',
          },
          270610: {
            name: {
              th: 'หนองสังข์',
              en: 'Nong Sang',
            },
            zipcode: '27120',
          },
          270611: {
            name: {
              th: 'คลองทับจันทร์',
              en: 'Khlong Thap Chan',
            },
            zipcode: '27120',
          },
          270612: {
            name: {
              th: 'ฟากห้วย',
              en: 'Fak Huai',
            },
            zipcode: '27120',
          },
          270613: {
            name: {
              th: 'บ้านด่าน',
              en: 'Ban Dan',
            },
            zipcode: '27120',
          },
        },
      },
      2707: {
        name: {
          th: 'เขาฉกรรจ์',
          en: 'Khao Chakan',
        },
        tambons: {
          270701: {
            name: {
              th: 'เขาฉกรรจ์',
              en: 'Khao Chakan',
            },
            zipcode: '27000',
          },
          270702: {
            name: {
              th: 'หนองหว้า',
              en: 'Nong Wa',
            },
            zipcode: '27000',
          },
          270703: {
            name: {
              th: 'พระเพลิง',
              en: 'Phra Phloeng',
            },
            zipcode: '27000',
          },
          270704: {
            name: {
              th: 'เขาสามสิบ',
              en: 'Khao Sam Sip',
            },
            zipcode: '27000',
          },
        },
      },
      2708: {
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        tambons: {
          270801: {
            name: {
              th: 'โคกสูง',
              en: 'Khok Sung',
            },
            zipcode: '27120',
          },
          270802: {
            name: {
              th: 'หนองม่วง',
              en: 'Nong Muang',
            },
            zipcode: '27180',
          },
          270803: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '27180',
          },
          270804: {
            name: {
              th: 'โนนหมากมุ่น',
              en: 'Non Mak Mun',
            },
            zipcode: '27120',
          },
        },
      },
      2709: {
        name: {
          th: 'วังสมบูรณ์',
          en: 'Wang Somboon',
        },
        tambons: {
          270901: {
            name: {
              th: 'วังสมบูรณ์',
              en: 'Wang Sombun',
            },
            zipcode: '27250',
          },
          270902: {
            name: {
              th: 'วังใหม่',
              en: 'Wang Mai',
            },
            zipcode: '27250',
          },
          270903: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '27250',
          },
        },
      },
    },
  },
  30: {
    name: {
      th: 'นครราชสีมา',
      en: 'Nakhon Ratchasima',
    },
    amphoes: {
      3001: {
        name: {
          th: 'เมืองนครราชสีมา',
          en: 'Muang',
        },
        tambons: {
          300101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '30000',
          },
          300102: {
            name: {
              th: 'โพธิ์กลาง',
              en: 'Pho Klang',
            },
            zipcode: '30000',
          },
          300103: {
            name: {
              th: 'หนองจะบก',
              en: 'Nong Chabok',
            },
            zipcode: '30000',
          },
          300104: {
            name: {
              th: 'โคกสูง',
              en: 'Khok Sung',
            },
            zipcode: '30310',
          },
          300105: {
            name: {
              th: 'มะเริง',
              en: 'Maroeng',
            },
            zipcode: '30000',
          },
          300106: {
            name: {
              th: 'หนองระเวียง',
              en: 'Nong Rawiang',
            },
            zipcode: '30000',
          },
          300107: {
            name: {
              th: 'ปรุใหญ่',
              en: 'Pru Yai',
            },
            zipcode: '30000',
          },
          300108: {
            name: {
              th: 'หมื่นไวย',
              en: 'Muen Wai',
            },
            zipcode: '30000',
          },
          300109: {
            name: {
              th: 'พลกรัง',
              en: 'Phon Krang',
            },
            zipcode: '30000',
          },
          300110: {
            name: {
              th: 'หนองไผ่ล้อม',
              en: 'Nong Phai Lom',
            },
            zipcode: '30000',
          },
          300111: {
            name: {
              th: 'หัวทะเล',
              en: 'Hua Thale',
            },
            zipcode: '30000',
          },
          300112: {
            name: {
              th: 'บ้านเกาะ',
              en: 'Ban Ko',
            },
            zipcode: '30000',
          },
          300113: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '30000',
          },
          300114: {
            name: {
              th: 'พุดซา',
              en: 'Phutsa',
            },
            zipcode: '30000',
          },
          300115: {
            name: {
              th: 'บ้านโพธิ์',
              en: 'Ban Pho',
            },
            zipcode: '30310',
          },
          300116: {
            name: {
              th: 'จอหอ',
              en: 'Cho Ho',
            },
            zipcode: '30310',
          },
          300117: {
            name: {
              th: 'โคกกรวด',
              en: 'Khok Kruat',
            },
            zipcode: '30280',
          },
          300118: {
            name: {
              th: 'ไชยมงคล',
              en: 'Chai Mongkhon',
            },
            zipcode: '30000',
          },
          300119: {
            name: {
              th: 'หนองบัวศาลา',
              en: 'Nong Bua Sala',
            },
            zipcode: '30000',
          },
          300120: {
            name: {
              th: 'สุรนารี',
              en: 'Suranari',
            },
            zipcode: '30000',
          },
          300121: {
            name: {
              th: 'สีมุม',
              en: 'Si Mum',
            },
            zipcode: '30000',
          },
          300122: {
            name: {
              th: 'ตลาด',
              en: 'Talat',
            },
            zipcode: '30310',
          },
          300123: {
            name: {
              th: 'พะเนา',
              en: 'Phanao',
            },
            zipcode: '30000',
          },
          300124: {
            name: {
              th: 'หนองกระทุ่ม',
              en: 'Nong Krathum',
            },
            zipcode: '30000',
          },
          300125: {
            name: {
              th: 'หนองไข่น้ำ',
              en: 'Nong Khai Nam',
            },
            zipcode: '30310',
          },
        },
      },
      3002: {
        name: {
          th: 'ครบุรี',
          en: 'Khon Buri',
        },
        tambons: {
          300201: {
            name: {
              th: 'แชะ',
              en: 'Chae',
            },
            zipcode: '30250',
          },
          300202: {
            name: {
              th: 'เฉลียง',
              en: 'Chaliang',
            },
            zipcode: '30250',
          },
          300203: {
            name: {
              th: 'ครบุรี',
              en: 'Khon Buri',
            },
            zipcode: '30250',
          },
          300204: {
            name: {
              th: 'โคกกระชาย',
              en: 'Khok Krachai',
            },
            zipcode: '30250',
          },
          300205: {
            name: {
              th: 'จระเข้หิน',
              en: 'Chorakhe Hin',
            },
            zipcode: '30250',
          },
          300206: {
            name: {
              th: 'มาบตะโกเอน',
              en: 'Map Tako En',
            },
            zipcode: '30250',
          },
          300207: {
            name: {
              th: 'อรพิมพ์',
              en: 'Oraphim',
            },
            zipcode: '30250',
          },
          300208: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '30250',
          },
          300209: {
            name: {
              th: 'ลำเพียก',
              en: 'Lam Phiak',
            },
            zipcode: '30250',
          },
          300210: {
            name: {
              th: 'ครบุรีใต้',
              en: 'Khon Buri Tai',
            },
            zipcode: '30250',
          },
          300211: {
            name: {
              th: 'ตะแบกบาน',
              en: 'Tabaek Ban',
            },
            zipcode: '30250',
          },
          300212: {
            name: {
              th: 'สระว่านพระยา',
              en: 'Sa Wan Phraya',
            },
            zipcode: '30250',
          },
        },
      },
      3003: {
        name: {
          th: 'เสิงสาง',
          en: 'Soeng Sang',
        },
        tambons: {
          300301: {
            name: {
              th: 'เสิงสาง',
              en: 'Soeng Sang',
            },
            zipcode: '30330',
          },
          300302: {
            name: {
              th: 'สระตะเคียน',
              en: 'Sa Takhian',
            },
            zipcode: '30330',
          },
          300303: {
            name: {
              th: 'โนนสมบูรณ์',
              en: 'Non Sombun',
            },
            zipcode: '30330',
          },
          300304: {
            name: {
              th: 'กุดโบสถ์',
              en: 'Kut Bot',
            },
            zipcode: '30330',
          },
          300305: {
            name: {
              th: 'สุขไพบูลย์',
              en: 'Suk Phaibun',
            },
            zipcode: '30330',
          },
          300306: {
            name: {
              th: 'บ้านราษฎร์',
              en: 'Ban Rat',
            },
            zipcode: '30330',
          },
        },
      },
      3004: {
        name: {
          th: 'คง',
          en: 'Kong',
        },
        tambons: {
          300401: {
            name: {
              th: 'เมืองคง',
              en: 'Mueang Khong',
            },
            zipcode: '30260',
          },
          300402: {
            name: {
              th: 'คูขาด',
              en: 'Khu Khat',
            },
            zipcode: '30260',
          },
          300403: {
            name: {
              th: 'เทพาลัย',
              en: 'Thephalai',
            },
            zipcode: '30260',
          },
          300404: {
            name: {
              th: 'ตาจั่น',
              en: 'Ta Chan',
            },
            zipcode: '30260',
          },
          300405: {
            name: {
              th: 'บ้านปรางค์',
              en: 'Ban Prang',
            },
            zipcode: '30260',
          },
          300406: {
            name: {
              th: 'หนองมะนาว',
              en: 'Nong Manao',
            },
            zipcode: '30260',
          },
          300407: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '30260',
          },
          300408: {
            name: {
              th: 'โนนเต็ง',
              en: 'Non Teng',
            },
            zipcode: '30260',
          },
          300409: {
            name: {
              th: 'ดอนใหญ่',
              en: 'Don Yai',
            },
            zipcode: '30260',
          },
          300410: {
            name: {
              th: 'ขามสมบูรณ์',
              en: 'Kham Sombun',
            },
            zipcode: '30260',
          },
        },
      },
      3005: {
        name: {
          th: 'บ้านเหลื่อม',
          en: 'Ban Luam',
        },
        tambons: {
          300501: {
            name: {
              th: 'บ้านเหลื่อม',
              en: 'Ban Lueam',
            },
            zipcode: '30350',
          },
          300502: {
            name: {
              th: 'วังโพธิ์',
              en: 'Wang Pho',
            },
            zipcode: '30350',
          },
          300503: {
            name: {
              th: 'โคกกระเบื้อง',
              en: 'Khok Krabueang',
            },
            zipcode: '30350',
          },
          300504: {
            name: {
              th: 'ช่อระกา',
              en: 'Cho Raka',
            },
            zipcode: '30350',
          },
        },
      },
      3006: {
        name: {
          th: 'จักราช',
          en: 'Chakkarat',
        },
        tambons: {
          300601: {
            name: {
              th: 'จักราช',
              en: 'Chakkarat',
            },
            zipcode: '30230',
          },
          300602: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '30230',
          },
          300603: {
            name: {
              th: 'ทองหลาง',
              en: 'Thong Lang',
            },
            zipcode: '30230',
          },
          300604: {
            name: {
              th: 'สีสุก',
              en: 'Si Suk',
            },
            zipcode: '30230',
          },
          300605: {
            name: {
              th: 'หนองขาม',
              en: 'Nong Kham',
            },
            zipcode: '30230',
          },
          300606: {
            name: {
              th: 'หนองงูเหลือม',
              en: 'Nong Ngu Lueam',
            },
            zipcode: '30230',
          },
          300607: {
            name: {
              th: 'หนองพลวง',
              en: 'Nong Phluang',
            },
            zipcode: '30230',
          },
          300608: {
            name: {
              th: 'หนองยาง',
              en: 'Nong Yang',
            },
            zipcode: '30230',
          },
          300609: {
            name: {
              th: 'พระพุทธ',
              en: 'Phra Phut',
            },
            zipcode: '30230',
          },
          300610: {
            name: {
              th: 'ศรีละกอ',
              en: 'Si Lako',
            },
            zipcode: '30230',
          },
          300611: {
            name: {
              th: 'คลองเมือง',
              en: 'Khlong Mueang',
            },
            zipcode: '30230',
          },
          300612: {
            name: {
              th: 'ช้างทอง',
              en: 'Chang Thong',
            },
            zipcode: '30230',
          },
          300613: {
            name: {
              th: 'หินโคน',
              en: 'Hin Khon',
            },
            zipcode: '30230',
          },
        },
      },
      3007: {
        name: {
          th: 'โชคชัย',
          en: 'Chok Chai',
        },
        tambons: {
          300701: {
            name: {
              th: 'กระโทก',
              en: 'Krathok',
            },
            zipcode: '30190',
          },
          300702: {
            name: {
              th: 'พลับพลา',
              en: 'Phlapphla',
            },
            zipcode: '30190',
          },
          300703: {
            name: {
              th: 'ท่าอ่าง',
              en: 'Tha Ang',
            },
            zipcode: '30190',
          },
          300704: {
            name: {
              th: 'ทุ่งอรุณ',
              en: 'Thung Arun',
            },
            zipcode: '30190',
          },
          300705: {
            name: {
              th: 'ท่าลาดขาว',
              en: 'Tha Lat Khao',
            },
            zipcode: '30190',
          },
          300706: {
            name: {
              th: 'ท่าจะหลุง',
              en: 'Tha Chalung',
            },
            zipcode: '30190',
          },
          300707: {
            name: {
              th: 'ท่าเยี่ยม',
              en: 'Tha Yiam',
            },
            zipcode: '30190',
          },
          300708: {
            name: {
              th: 'โชคชัย',
              en: 'Chok Chai',
            },
            zipcode: '30190',
          },
          300709: {
            name: {
              th: 'ละลมใหม่พัฒนา',
              en: 'Lalom Mai Phatthana',
            },
            zipcode: '30190',
          },
          300710: {
            name: {
              th: 'ด่านเกวียน',
              en: 'Dan Kwian',
            },
            zipcode: '30190',
          },
        },
      },
      3008: {
        name: {
          th: 'ด่านขุนทด',
          en: 'Dan Khun Thot',
        },
        tambons: {
          300801: {
            name: {
              th: 'กุดพิมาน',
              en: 'Kut Phiman',
            },
            zipcode: '30210',
          },
          300802: {
            name: {
              th: 'ด่านขุนทด',
              en: 'Dan Khun Thot',
            },
            zipcode: '30210',
          },
          300803: {
            name: {
              th: 'ด่านนอก',
              en: 'Dan Nok',
            },
            zipcode: '30210',
          },
          300804: {
            name: {
              th: 'ด่านใน',
              en: 'Dan Nai',
            },
            zipcode: '30210',
          },
          300805: {
            name: {
              th: 'ตะเคียน',
              en: 'Takhian',
            },
            zipcode: '30210',
          },
          300806: {
            name: {
              th: 'บ้านเก่า',
              en: 'Ban Kao',
            },
            zipcode: '30210',
          },
          300807: {
            name: {
              th: 'บ้านแปรง',
              en: 'Ban Praeng',
            },
            zipcode: '36220',
          },
          300808: {
            name: {
              th: 'พันชนะ',
              en: 'Phan Chana',
            },
            zipcode: '30210',
          },
          300809: {
            name: {
              th: 'สระจรเข้',
              en: 'Sa Chorakhe',
            },
            zipcode: '30210',
          },
          300810: {
            name: {
              th: 'หนองกราด',
              en: 'Nong Krat',
            },
            zipcode: '30210',
          },
          300811: {
            name: {
              th: 'หนองบัวตะเกียด',
              en: 'Nong Bua Takiat',
            },
            zipcode: '30210',
          },
          300812: {
            name: {
              th: 'หนองบัวละคร',
              en: 'Nong Bua Lakhon',
            },
            zipcode: '30210',
          },
          300813: {
            name: {
              th: 'หินดาด',
              en: 'Hin Dat',
            },
            zipcode: '30210',
          },
          300815: {
            name: {
              th: 'ห้วยบง',
              en: 'Huai Bong',
            },
            zipcode: '30210',
          },
          300817: {
            name: {
              th: 'โนนเมืองพัฒนา',
              en: 'Non Muaeng Patthana',
            },
            zipcode: '30210',
          },
          300818: {
            name: {
              th: 'หนองไทร',
              en: 'Nong Sai',
            },
            zipcode: '36220',
          },
        },
      },
      3009: {
        name: {
          th: 'โนนไทย',
          en: 'Non Thai',
        },
        tambons: {
          300901: {
            name: {
              th: 'โนนไทย',
              en: 'Non Thai',
            },
            zipcode: '30220',
          },
          300902: {
            name: {
              th: 'ด่านจาก',
              en: 'Dan Chak',
            },
            zipcode: '30220',
          },
          300903: {
            name: {
              th: 'กำปัง',
              en: 'Kampang',
            },
            zipcode: '30220',
          },
          300904: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '30220',
          },
          300905: {
            name: {
              th: 'ค้างพลู',
              en: 'Khang Phlu',
            },
            zipcode: '30220',
          },
          300906: {
            name: {
              th: 'บ้านวัง',
              en: 'Ban Wang',
            },
            zipcode: '30220',
          },
          300907: {
            name: {
              th: 'บัลลังก์',
              en: 'Banlang',
            },
            zipcode: '30220',
          },
          300908: {
            name: {
              th: 'สายออ',
              en: 'Sai O',
            },
            zipcode: '30220',
          },
          300909: {
            name: {
              th: 'ถนนโพธิ์',
              en: 'Thanon Pho',
            },
            zipcode: '30220',
          },
          300914: {
            name: {
              th: 'มะค่า',
              en: 'Makha',
            },
            zipcode: '30220',
          },
        },
      },
      3010: {
        name: {
          th: 'โนนสูง',
          en: 'Non Sung',
        },
        tambons: {
          301001: {
            name: {
              th: 'โนนสูง',
              en: 'Non Sung',
            },
            zipcode: '30160',
          },
          301002: {
            name: {
              th: 'ใหม่',
              en: 'Mai',
            },
            zipcode: '30160',
          },
          301003: {
            name: {
              th: 'โตนด',
              en: 'Tanot',
            },
            zipcode: '30160',
          },
          301004: {
            name: {
              th: 'บิง',
              en: 'Bing',
            },
            zipcode: '30160',
          },
          301005: {
            name: {
              th: 'ดอนชมพู',
              en: 'Don Chomphu',
            },
            zipcode: '30160',
          },
          301006: {
            name: {
              th: 'ธารปราสาท',
              en: 'Than Prasat',
            },
            zipcode: '30240',
          },
          301007: {
            name: {
              th: 'หลุมข้าว',
              en: 'Lum Khao',
            },
            zipcode: '30160',
          },
          301008: {
            name: {
              th: 'มะค่า',
              en: 'Makha',
            },
            zipcode: '30160',
          },
          301009: {
            name: {
              th: 'พลสงคราม',
              en: 'Phon Songkhram',
            },
            zipcode: '30160',
          },
          301010: {
            name: {
              th: 'จันอัด',
              en: 'Chan-at',
            },
            zipcode: '30160',
          },
          301011: {
            name: {
              th: 'ขามเฒ่า',
              en: 'Kham Thao',
            },
            zipcode: '30160',
          },
          301012: {
            name: {
              th: 'ด่านคล้า',
              en: 'Dan Khla',
            },
            zipcode: '30160',
          },
          301013: {
            name: {
              th: 'ลำคอหงษ์',
              en: 'Lam Kho Hong',
            },
            zipcode: '30160',
          },
          301014: {
            name: {
              th: 'เมืองปราสาท',
              en: 'Mueang Prasat',
            },
            zipcode: '30160',
          },
          301015: {
            name: {
              th: 'ดอนหวาย',
              en: 'Don Wai',
            },
            zipcode: '30160',
          },
          301016: {
            name: {
              th: 'ลำมูล',
              en: 'Lam Mun',
            },
            zipcode: '30160',
          },
        },
      },
      3011: {
        name: {
          th: 'ขามสะแกแสง',
          en: 'Kham Sakae Saeng',
        },
        tambons: {
          301101: {
            name: {
              th: 'ขามสะแกแสง',
              en: 'Kham Sakaesaeng',
            },
            zipcode: '30290',
          },
          301102: {
            name: {
              th: 'โนนเมือง',
              en: 'Non Mueang',
            },
            zipcode: '30290',
          },
          301103: {
            name: {
              th: 'เมืองนาท',
              en: 'Mueang Nat',
            },
            zipcode: '30290',
          },
          301104: {
            name: {
              th: 'ชีวึก',
              en: 'Chiwuek',
            },
            zipcode: '30290',
          },
          301105: {
            name: {
              th: 'พะงาด',
              en: 'Pha-ngat',
            },
            zipcode: '30290',
          },
          301106: {
            name: {
              th: 'หนองหัวฟาน',
              en: 'Nong Hua Fan',
            },
            zipcode: '30290',
          },
          301107: {
            name: {
              th: 'เมืองเกษตร',
              en: 'Mueang Kaset',
            },
            zipcode: '30290',
          },
        },
      },
      3012: {
        name: {
          th: 'บัวใหญ่',
          en: 'Bua Yai',
        },
        tambons: {
          301201: {
            name: {
              th: 'บัวใหญ่',
              en: 'Bua Yai',
            },
            zipcode: '30120',
          },
          301203: {
            name: {
              th: 'ห้วยยาง',
              en: 'Huai Yang',
            },
            zipcode: '30120',
          },
          301204: {
            name: {
              th: 'เสมาใหญ่',
              en: 'Sema Yai',
            },
            zipcode: '30120',
          },
          301206: {
            name: {
              th: 'ดอนตะหนิน',
              en: 'Don Tanin',
            },
            zipcode: '30120',
          },
          301207: {
            name: {
              th: 'หนองบัวสะอาด',
              en: 'Nong Bua Sa-at',
            },
            zipcode: '30120',
          },
          301208: {
            name: {
              th: 'โนนทองหลาง',
              en: 'Non Thonglang',
            },
            zipcode: '30120',
          },
          301209: {
            name: {
              th: 'หนองหว้า',
              en: 'Nong Wa',
            },
            zipcode: '30120',
          },
          301210: {
            name: {
              th: 'บัวลาย',
              en: 'Bua Lai',
            },
            zipcode: '30120',
          },
          301211: {
            name: {
              th: 'สีดา',
              en: 'Sida',
            },
            zipcode: '30120',
          },
          301212: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '30120',
          },
          301214: {
            name: {
              th: 'กุดจอก',
              en: 'Kut Chok',
            },
            zipcode: '30120',
          },
          301215: {
            name: {
              th: 'ด่านช้าง',
              en: 'Dan Chang',
            },
            zipcode: '30120',
          },
          301216: {
            name: {
              th: 'โนนจาน',
              en: 'Non Chan',
            },
            zipcode: '30120',
          },
          301218: {
            name: {
              th: 'สามเมือง',
              en: 'Sam Mueang',
            },
            zipcode: '30120',
          },
          301220: {
            name: {
              th: 'ขุนทอง',
              en: 'Khun Thong',
            },
            zipcode: '30120',
          },
          301221: {
            name: {
              th: 'หนองตาดใหญ่',
              en: 'Nong Tat Yai',
            },
            zipcode: '30120',
          },
          301222: {
            name: {
              th: 'เมืองพะไล',
              en: 'Mueang Phalai',
            },
            zipcode: '30120',
          },
          301223: {
            name: {
              th: 'โนนประดู่',
              en: 'Non Pradu',
            },
            zipcode: '30120',
          },
          301224: {
            name: {
              th: 'หนองแจ้งใหญ่',
              en: 'Nong Chaeng Yai',
            },
            zipcode: '30120',
          },
        },
      },
      3013: {
        name: {
          th: 'ประทาย',
          en: 'Pra Thai',
        },
        tambons: {
          301301: {
            name: {
              th: 'ประทาย',
              en: 'Prathai',
            },
            zipcode: '30180',
          },
          301303: {
            name: {
              th: 'กระทุ่มราย',
              en: 'Krathum Rai',
            },
            zipcode: '30180',
          },
          301304: {
            name: {
              th: 'วังไม้แดง',
              en: 'Wang Mai Daeng',
            },
            zipcode: '30180',
          },
          301306: {
            name: {
              th: 'ตลาดไทร',
              en: 'Talat Sai',
            },
            zipcode: '30180',
          },
          301307: {
            name: {
              th: 'หนองพลวง',
              en: 'Nong Phluang',
            },
            zipcode: '30180',
          },
          301308: {
            name: {
              th: 'หนองค่าย',
              en: 'Nong Khai',
            },
            zipcode: '30180',
          },
          301309: {
            name: {
              th: 'หันห้วยทราย',
              en: 'Han Huai Sai',
            },
            zipcode: '30180',
          },
          301310: {
            name: {
              th: 'ดอนมัน',
              en: 'Don Man',
            },
            zipcode: '30180',
          },
          301313: {
            name: {
              th: 'นางรำ',
              en: 'Nang Ram',
            },
            zipcode: '30180',
          },
          301314: {
            name: {
              th: 'โนนเพ็ด',
              en: 'Non Phet',
            },
            zipcode: '30180',
          },
          301315: {
            name: {
              th: 'ทุ่งสว่าง',
              en: 'Thung Sawang',
            },
            zipcode: '30180',
          },
          301317: {
            name: {
              th: 'โคกกลาง',
              en: 'Khok Klang',
            },
            zipcode: '30180',
          },
          301318: {
            name: {
              th: 'เมืองโดน',
              en: 'Mueang Don',
            },
            zipcode: '30180',
          },
        },
      },
      3014: {
        name: {
          th: 'ปักธงชัย',
          en: 'Pak Thong Chai',
        },
        tambons: {
          301401: {
            name: {
              th: 'เมืองปัก',
              en: 'Mueang Pak',
            },
            zipcode: '30150',
          },
          301402: {
            name: {
              th: 'ตะคุ',
              en: 'Takhu',
            },
            zipcode: '30150',
          },
          301403: {
            name: {
              th: 'โคกไทย',
              en: 'Khok Thai',
            },
            zipcode: '30150',
          },
          301404: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '30150',
          },
          301405: {
            name: {
              th: 'ตะขบ',
              en: 'Takhop',
            },
            zipcode: '30150',
          },
          301406: {
            name: {
              th: 'นกออก',
              en: 'Nok Ok',
            },
            zipcode: '30150',
          },
          301407: {
            name: {
              th: 'ดอน',
              en: 'Don',
            },
            zipcode: '30150',
          },
          301409: {
            name: {
              th: 'ตูม',
              en: 'Tum',
            },
            zipcode: '30150',
          },
          301410: {
            name: {
              th: 'งิ้ว',
              en: 'Ngio',
            },
            zipcode: '30150',
          },
          301411: {
            name: {
              th: 'สะแกราช',
              en: 'Sakae Rat',
            },
            zipcode: '30150',
          },
          301412: {
            name: {
              th: 'ลำนางแก้ว',
              en: 'Lam Nang Kaeo',
            },
            zipcode: '30150',
          },
          301416: {
            name: {
              th: 'ภูหลวง',
              en: 'Phu Luang',
            },
            zipcode: '30150',
          },
          301417: {
            name: {
              th: 'ธงชัยเหนือ',
              en: 'Thong Chai Nuea',
            },
            zipcode: '30150',
          },
          301418: {
            name: {
              th: 'สุขเกษม',
              en: 'Suk Kasem',
            },
            zipcode: '30150',
          },
          301419: {
            name: {
              th: 'เกษมทรัพย์',
              en: 'Kasem Sap',
            },
            zipcode: '30150',
          },
          301420: {
            name: {
              th: 'บ่อปลาทอง',
              en: 'Bo Pla Thong',
            },
            zipcode: '30150',
          },
        },
      },
      3015: {
        name: {
          th: 'พิมาย',
          en: 'Phimai',
        },
        tambons: {
          301501: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '30110',
          },
          301502: {
            name: {
              th: 'สัมฤทธิ์',
              en: 'Samrit',
            },
            zipcode: '30110',
          },
          301503: {
            name: {
              th: 'โบสถ์',
              en: 'Bot',
            },
            zipcode: '30110',
          },
          301504: {
            name: {
              th: 'กระเบื้องใหญ่',
              en: 'Krabueang Yai',
            },
            zipcode: '30110',
          },
          301505: {
            name: {
              th: 'ท่าหลวง',
              en: 'Tha Luang',
            },
            zipcode: '30110',
          },
          301506: {
            name: {
              th: 'รังกาใหญ่',
              en: 'Rang Ka Yai',
            },
            zipcode: '30110',
          },
          301507: {
            name: {
              th: 'ชีวาน',
              en: 'Chiwan',
            },
            zipcode: '30110',
          },
          301508: {
            name: {
              th: 'นิคมสร้างตนเอง',
              en: 'Nikhom Sang Ton Eng',
            },
            zipcode: '30110',
          },
          301509: {
            name: {
              th: 'กระชอน',
              en: 'Krachon',
            },
            zipcode: '30110',
          },
          301510: {
            name: {
              th: 'ดงใหญ่',
              en: 'Dong Yai',
            },
            zipcode: '30110',
          },
          301511: {
            name: {
              th: 'ธารละหลอด',
              en: 'Than Lalot',
            },
            zipcode: '30110',
          },
          301512: {
            name: {
              th: 'หนองระเวียง',
              en: 'Nong Rawiang',
            },
            zipcode: '30110',
          },
        },
      },
      3016: {
        name: {
          th: 'ห้วยแถลง',
          en: 'Huai Thalaeng',
        },
        tambons: {
          301601: {
            name: {
              th: 'ห้วยแถลง',
              en: 'Huai Thalaeng',
            },
            zipcode: '30240',
          },
          301602: {
            name: {
              th: 'ทับสวาย',
              en: 'Thap Sawai',
            },
            zipcode: '30240',
          },
          301603: {
            name: {
              th: 'เมืองพลับพลา',
              en: 'Mueang Phlapphla',
            },
            zipcode: '30240',
          },
          301604: {
            name: {
              th: 'หลุ่งตะเคียน',
              en: 'Lung Takhian',
            },
            zipcode: '30240',
          },
          301605: {
            name: {
              th: 'หินดาด',
              en: 'Hin Dat',
            },
            zipcode: '30240',
          },
          301606: {
            name: {
              th: 'งิ้ว',
              en: 'Ngio',
            },
            zipcode: '30240',
          },
          301607: {
            name: {
              th: 'กงรถ',
              en: 'Kong Rot',
            },
            zipcode: '30240',
          },
          301608: {
            name: {
              th: 'หลุ่งประดู่',
              en: 'Lung Pradu',
            },
            zipcode: '30240',
          },
          301609: {
            name: {
              th: 'ตะโก',
              en: 'Tako',
            },
            zipcode: '30240',
          },
          301610: {
            name: {
              th: 'ห้วยแคน',
              en: 'Huai Khaen',
            },
            zipcode: '30240',
          },
        },
      },
      3017: {
        name: {
          th: 'ชุมพวง',
          en: 'Chum Phuang',
        },
        tambons: {
          301701: {
            name: {
              th: 'ชุมพวง',
              en: 'Chum Phuang',
            },
            zipcode: '30270',
          },
          301702: {
            name: {
              th: 'ประสุข',
              en: 'Prasuk',
            },
            zipcode: '30270',
          },
          301703: {
            name: {
              th: 'ท่าลาด',
              en: 'Tha Lat',
            },
            zipcode: '30270',
          },
          301704: {
            name: {
              th: 'สาหร่าย',
              en: 'Sarai',
            },
            zipcode: '30270',
          },
          301705: {
            name: {
              th: 'ตลาดไทร',
              en: 'Talat Sai',
            },
            zipcode: '30270',
          },
          301706: {
            name: {
              th: 'ช่องแมว',
              en: 'Chong Maeo',
            },
            zipcode: '30270',
          },
          301707: {
            name: {
              th: 'ขุย',
              en: 'Khui',
            },
            zipcode: '30270',
          },
          301710: {
            name: {
              th: 'โนนรัง',
              en: 'Non Rang',
            },
            zipcode: '30270',
          },
          301711: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '30270',
          },
          301714: {
            name: {
              th: 'หนองหลัก',
              en: 'Nong Lak',
            },
            zipcode: '30270',
          },
          301715: {
            name: {
              th: 'ไพล',
              en: 'Phlai',
            },
            zipcode: '30270',
          },
          301716: {
            name: {
              th: 'โนนตูม',
              en: 'Non Tum',
            },
            zipcode: '30270',
          },
          301717: {
            name: {
              th: 'โนนยอ',
              en: 'Non Yo',
            },
            zipcode: '30270',
          },
        },
      },
      3018: {
        name: {
          th: 'สูงเนิน',
          en: 'Sung Noen',
        },
        tambons: {
          301801: {
            name: {
              th: 'สูงเนิน',
              en: 'Sung Noen',
            },
            zipcode: '30170',
          },
          301802: {
            name: {
              th: 'เสมา',
              en: 'Sema',
            },
            zipcode: '30170',
          },
          301803: {
            name: {
              th: 'โคราช',
              en: 'Khorat',
            },
            zipcode: '30170',
          },
          301804: {
            name: {
              th: 'บุ่งขี้เหล็ก',
              en: 'Bung Khilek',
            },
            zipcode: '30170',
          },
          301805: {
            name: {
              th: 'โนนค่า',
              en: 'Non Kha',
            },
            zipcode: '30170',
          },
          301806: {
            name: {
              th: 'โค้งยาง',
              en: 'Khong Yang',
            },
            zipcode: '30170',
          },
          301807: {
            name: {
              th: 'มะเกลือเก่า',
              en: 'Makluea Kao',
            },
            zipcode: '30170',
          },
          301808: {
            name: {
              th: 'มะเกลือใหม่',
              en: 'Makluea Mai',
            },
            zipcode: '30170',
          },
          301809: {
            name: {
              th: 'นากลาง',
              en: 'Na Klang',
            },
            zipcode: '30380',
          },
          301810: {
            name: {
              th: 'หนองตะไก้',
              en: 'Nong Takai',
            },
            zipcode: '30380',
          },
          301811: {
            name: {
              th: 'กุดจิก',
              en: 'Kut Chik',
            },
            zipcode: '30380',
          },
        },
      },
      3019: {
        name: {
          th: 'ขามทะเลสอ',
          en: 'Kham Thale So',
        },
        tambons: {
          301901: {
            name: {
              th: 'ขามทะเลสอ',
              en: 'Kham Thale So',
            },
            zipcode: '30280',
          },
          301902: {
            name: {
              th: 'โป่งแดง',
              en: 'Pong Daeng',
            },
            zipcode: '30280',
          },
          301903: {
            name: {
              th: 'พันดุง',
              en: 'Phan Dung',
            },
            zipcode: '30280',
          },
          301904: {
            name: {
              th: 'หนองสรวง',
              en: 'Nong Suang',
            },
            zipcode: '30280',
          },
          301905: {
            name: {
              th: 'บึงอ้อ',
              en: 'Bueng O',
            },
            zipcode: '30280',
          },
        },
      },
      3020: {
        name: {
          th: 'สีคิ้ว',
          en: 'Si Khiu',
        },
        tambons: {
          302001: {
            name: {
              th: 'สีคิ้ว',
              en: 'Sikhio',
            },
            zipcode: '30140',
          },
          302002: {
            name: {
              th: 'บ้านหัน',
              en: 'Ban Han',
            },
            zipcode: '30140',
          },
          302003: {
            name: {
              th: 'กฤษณา',
              en: 'Kritsana',
            },
            zipcode: '30140',
          },
          302004: {
            name: {
              th: 'ลาดบัวขาว',
              en: 'Lat Bua Khao',
            },
            zipcode: '30340',
          },
          302005: {
            name: {
              th: 'หนองหญ้าขาว',
              en: 'Nong Ya Khao',
            },
            zipcode: '30140',
          },
          302006: {
            name: {
              th: 'กุดน้อย',
              en: 'Kut Noi',
            },
            zipcode: '30140',
          },
          302007: {
            name: {
              th: 'หนองน้ำใส',
              en: 'Nong Nam Sai',
            },
            zipcode: '30140',
          },
          302008: {
            name: {
              th: 'วังโรงใหญ่',
              en: 'Wang Rong Yai',
            },
            zipcode: '30140',
          },
          302009: {
            name: {
              th: 'มิตรภาพ',
              en: 'Mittraphap',
            },
            zipcode: '30140',
          },
          302010: {
            name: {
              th: 'คลองไผ่',
              en: 'Khlong Phai',
            },
            zipcode: '30340',
          },
          302011: {
            name: {
              th: 'ดอนเมือง',
              en: 'Don Mueang',
            },
            zipcode: '30140',
          },
          302012: {
            name: {
              th: 'หนองบัวน้อย',
              en: 'Nong Bua Noi',
            },
            zipcode: '30140',
          },
        },
      },
      3021: {
        name: {
          th: 'ปากช่อง',
          en: 'Pak Chong',
        },
        tambons: {
          302101: {
            name: {
              th: 'ปากช่อง',
              en: 'Pak Chong',
            },
            zipcode: '30130',
          },
          302102: {
            name: {
              th: 'กลางดง',
              en: 'Klang Dong',
            },
            zipcode: '30320',
          },
          302103: {
            name: {
              th: 'จันทึก',
              en: 'Chanthuek',
            },
            zipcode: '30130',
          },
          302104: {
            name: {
              th: 'วังกะทะ',
              en: 'Wang Katha',
            },
            zipcode: '30130',
          },
          302105: {
            name: {
              th: 'หมูสี',
              en: 'Mu Si',
            },
            zipcode: '30130',
          },
          302106: {
            name: {
              th: 'หนองสาหร่าย',
              en: 'Nong Sarai',
            },
            zipcode: '30130',
          },
          302107: {
            name: {
              th: 'ขนงพระ',
              en: 'Khanong Phra',
            },
            zipcode: '30130',
          },
          302108: {
            name: {
              th: 'โป่งตาลอง',
              en: 'Pong Talong',
            },
            zipcode: '30130',
          },
          302109: {
            name: {
              th: 'คลองม่วง',
              en: 'Khlong Muang',
            },
            zipcode: '30130',
          },
          302110: {
            name: {
              th: 'หนองน้ำแดง',
              en: 'Nong Nam Daeng',
            },
            zipcode: '30130',
          },
          302111: {
            name: {
              th: 'วังไทร',
              en: 'Wang Sai',
            },
            zipcode: '30130',
          },
          302112: {
            name: {
              th: 'พญาเย็น',
              en: 'Phaya Yen',
            },
            zipcode: '30320',
          },
        },
      },
      3022: {
        name: {
          th: 'หนองบุญมาก',
          en: 'Nong Bun Nak',
        },
        tambons: {
          302201: {
            name: {
              th: 'หนองบุนนาก',
              en: 'Nong Bunnak',
            },
            zipcode: '30410',
          },
          302202: {
            name: {
              th: 'สารภี',
              en: 'Saraphi',
            },
            zipcode: '30410',
          },
          302203: {
            name: {
              th: 'ไทยเจริญ',
              en: 'Thai Charoen',
            },
            zipcode: '30410',
          },
          302204: {
            name: {
              th: 'หนองหัวแรต',
              en: 'Nong Hua Raet',
            },
            zipcode: '30410',
          },
          302205: {
            name: {
              th: 'แหลมทอง',
              en: 'Laem Thong',
            },
            zipcode: '30410',
          },
          302206: {
            name: {
              th: 'หนองตะไก้',
              en: 'Nong Takai',
            },
            zipcode: '30410',
          },
          302207: {
            name: {
              th: 'ลุงเขว้า',
              en: 'Lung Khwao',
            },
            zipcode: '30410',
          },
          302208: {
            name: {
              th: 'หนองไม้ไผ่',
              en: 'Nong Mai Phai',
            },
            zipcode: '30410',
          },
          302209: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '30410',
          },
        },
      },
      3023: {
        name: {
          th: 'แก้งสนามนาง',
          en: 'Kaeng Snam Nang',
        },
        tambons: {
          302301: {
            name: {
              th: 'แก้งสนามนาง',
              en: 'Kaeng Sanam Nang',
            },
            zipcode: '30440',
          },
          302302: {
            name: {
              th: 'โนนสำราญ',
              en: 'Non Samran',
            },
            zipcode: '30440',
          },
          302303: {
            name: {
              th: 'บึงพะไล',
              en: 'Bueng Phalai',
            },
            zipcode: '30440',
          },
          302304: {
            name: {
              th: 'สีสุก',
              en: 'Si Suk',
            },
            zipcode: '30440',
          },
          302305: {
            name: {
              th: 'บึงสำโรง',
              en: 'Bueng Samrong',
            },
            zipcode: '30440',
          },
        },
      },
      3024: {
        name: {
          th: 'โนนแดง',
          en: 'Non Daeng',
        },
        tambons: {
          302401: {
            name: {
              th: 'โนนแดง',
              en: 'Non Daeng',
            },
            zipcode: '30360',
          },
          302402: {
            name: {
              th: 'โนนตาเถร',
              en: 'Non Ta Then',
            },
            zipcode: '30360',
          },
          302403: {
            name: {
              th: 'สำพะเนียง',
              en: 'Sam Phaniang',
            },
            zipcode: '30360',
          },
          302404: {
            name: {
              th: 'วังหิน',
              en: 'Wang Hin',
            },
            zipcode: '30360',
          },
          302405: {
            name: {
              th: 'ดอนยาวใหญ่',
              en: 'Don Yao Yai',
            },
            zipcode: '30360',
          },
        },
      },
      3025: {
        name: {
          th: 'วังน้ำเขียว',
          en: 'Wong Namkhieo',
        },
        tambons: {
          302501: {
            name: {
              th: 'วังน้ำเขียว',
              en: 'Wang Nam Khiao',
            },
            zipcode: '30370',
          },
          302502: {
            name: {
              th: 'วังหมี',
              en: 'Wang Mi',
            },
            zipcode: '30370',
          },
          302503: {
            name: {
              th: 'ระเริง',
              en: 'Raroeng',
            },
            zipcode: '30150',
          },
          302504: {
            name: {
              th: 'อุดมทรัพย์',
              en: 'Udom Sap',
            },
            zipcode: '30370',
          },
          302505: {
            name: {
              th: 'ไทยสามัคคี',
              en: 'Thai Samakkhi',
            },
            zipcode: '30370',
          },
        },
      },
      3026: {
        name: {
          th: 'เทพารักษ์',
          en: 'Tepharak',
        },
        tambons: {
          302601: {
            name: {
              th: 'สำนักตะคร้อ',
              en: 'Samnak Takhro',
            },
            zipcode: '30210',
          },
          302602: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '30210',
          },
          302603: {
            name: {
              th: 'บึงปรือ',
              en: 'Bueng Prue',
            },
            zipcode: '30210',
          },
          302604: {
            name: {
              th: 'วังยายทอง',
              en: 'Wang Yai Thong',
            },
            zipcode: '30210',
          },
        },
      },
      3027: {
        name: {
          th: 'เมืองยาง',
          en: 'King Amphoe Muang Yang',
        },
        tambons: {
          302701: {
            name: {
              th: 'เมืองยาง',
              en: 'Mueang Yang',
            },
            zipcode: '30270',
          },
          302702: {
            name: {
              th: 'กระเบื้องนอก',
              en: 'Krabueang Nok',
            },
            zipcode: '30270',
          },
          302703: {
            name: {
              th: 'ละหานปลาค้าว',
              en: 'Lahan Pla Khao',
            },
            zipcode: '30270',
          },
          302704: {
            name: {
              th: 'โนนอุดม',
              en: 'Non Udom',
            },
            zipcode: '30270',
          },
        },
      },
      3028: {
        name: {
          th: 'พระทองคำ',
          en: 'King Amphoe Phrathorngkham',
        },
        tambons: {
          302801: {
            name: {
              th: 'สระพระ',
              en: 'Sa Phra',
            },
            zipcode: '30220',
          },
          302802: {
            name: {
              th: 'มาบกราด',
              en: 'Map Krat',
            },
            zipcode: '30220',
          },
          302803: {
            name: {
              th: 'พังเทียม',
              en: 'Phang Thiam',
            },
            zipcode: '30220',
          },
          302804: {
            name: {
              th: 'ทัพรั้ง',
              en: 'Thap Rang',
            },
            zipcode: '30220',
          },
          302805: {
            name: {
              th: 'หนองหอย',
              en: 'Nong Hoi',
            },
            zipcode: '30220',
          },
        },
      },
      3029: {
        name: {
          th: 'ลำทะเมนชัย',
          en: 'King Amphoe Lum Thamen Chai',
        },
        tambons: {
          302901: {
            name: {
              th: 'ขุย',
              en: 'Khui',
            },
            zipcode: '30270',
          },
          302902: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '30270',
          },
          302903: {
            name: {
              th: 'ช่องแมว',
              en: 'Chong Maeo',
            },
            zipcode: '30270',
          },
          302904: {
            name: {
              th: 'ไพล',
              en: 'Phlai',
            },
            zipcode: '30270',
          },
        },
      },
      3030: {
        name: {
          th: 'บัวลาย',
          en: 'Bua Lai',
        },
        tambons: {
          303001: {
            name: {
              th: 'เมืองพะไล',
              en: 'Mueang Phalai',
            },
            zipcode: '30120',
          },
          303002: {
            name: {
              th: 'โนนจาน',
              en: 'Non Chan',
            },
            zipcode: '30120',
          },
          303003: {
            name: {
              th: 'บัวลาย',
              en: 'Bua Lai',
            },
            zipcode: '30120',
          },
          303004: {
            name: {
              th: 'หนองหว้า',
              en: 'Nong Wa',
            },
            zipcode: '30120',
          },
        },
      },
      3031: {
        name: {
          th: 'สีดา',
          en: 'Si Da',
        },
        tambons: {
          303101: {
            name: {
              th: 'สีดา',
              en: 'Sida',
            },
            zipcode: '30430',
          },
          303102: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '30430',
          },
          303103: {
            name: {
              th: 'โนนประดู่',
              en: 'Non Pradu',
            },
            zipcode: '30430',
          },
          303104: {
            name: {
              th: 'สามเมือง',
              en: 'Sam Mueang',
            },
            zipcode: '30430',
          },
          303105: {
            name: {
              th: 'หนองตาดใหญ่',
              en: 'Nong Tat Yai',
            },
            zipcode: '30430',
          },
        },
      },
      3032: {
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chalermprakiat',
        },
        tambons: {
          303201: {
            name: {
              th: 'ช้างทอง',
              en: 'Chang Thong',
            },
            zipcode: '30230',
          },
          303202: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '30230',
          },
          303203: {
            name: {
              th: 'พระพุทธ',
              en: 'Phra Phut',
            },
            zipcode: '30230',
          },
          303204: {
            name: {
              th: 'หนองงูเหลือม',
              en: 'Nong Ngu Lueam',
            },
            zipcode: '30000',
          },
          303205: {
            name: {
              th: 'หนองยาง',
              en: 'Nong Yang',
            },
            zipcode: '30230',
          },
        },
      },
    },
  },
  31: {
    name: {
      th: 'บุรีรัมย์',
      en: 'Buri Ram',
    },
    amphoes: {
      3101: {
        name: {
          th: 'เมืองบุรีรัมย์',
          en: 'Muang',
        },
        tambons: {
          310101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '31000',
          },
          310102: {
            name: {
              th: 'อิสาณ',
              en: 'Isan',
            },
            zipcode: '31000',
          },
          310103: {
            name: {
              th: 'เสม็ด',
              en: 'Samet',
            },
            zipcode: '31000',
          },
          310104: {
            name: {
              th: 'บ้านบัว',
              en: 'Ban Bua',
            },
            zipcode: '31000',
          },
          310105: {
            name: {
              th: 'สะแกโพรง',
              en: 'Sakae Phrong',
            },
            zipcode: '31000',
          },
          310106: {
            name: {
              th: 'สวายจีก',
              en: 'Sawai Chik',
            },
            zipcode: '31000',
          },
          310108: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '31000',
          },
          310112: {
            name: {
              th: 'พระครู',
              en: 'Phra Khru',
            },
            zipcode: '31000',
          },
          310113: {
            name: {
              th: 'ถลุงเหล็ก',
              en: 'Thalung Lek',
            },
            zipcode: '31000',
          },
          310114: {
            name: {
              th: 'หนองตาด',
              en: 'Nong Tat',
            },
            zipcode: '31000',
          },
          310117: {
            name: {
              th: 'ลุมปุ๊ก',
              en: 'Lumpuk',
            },
            zipcode: '31000',
          },
          310118: {
            name: {
              th: 'สองห้อง',
              en: 'Song Hong',
            },
            zipcode: '31000',
          },
          310119: {
            name: {
              th: 'บัวทอง',
              en: 'Bua Thong',
            },
            zipcode: '31000',
          },
          310120: {
            name: {
              th: 'ชุมเห็ด',
              en: 'Chum Het',
            },
            zipcode: '31000',
          },
          310122: {
            name: {
              th: 'หลักเขต',
              en: 'Lak Khet',
            },
            zipcode: '31000',
          },
          310125: {
            name: {
              th: 'สะแกซำ',
              en: 'Sakae Sam',
            },
            zipcode: '31000',
          },
          310126: {
            name: {
              th: 'กลันทา',
              en: 'Kalantha',
            },
            zipcode: '31000',
          },
          310127: {
            name: {
              th: 'กระสัง',
              en: 'Krasang',
            },
            zipcode: '31000',
          },
          310128: {
            name: {
              th: 'เมืองฝาง',
              en: 'Mueang Fang',
            },
            zipcode: '31000',
          },
        },
      },
      3102: {
        name: {
          th: 'คูเมือง',
          en: 'Khu Muang',
        },
        tambons: {
          310201: {
            name: {
              th: 'คูเมือง',
              en: 'Khu Mueang',
            },
            zipcode: '31190',
          },
          310202: {
            name: {
              th: 'ปะเคียบ',
              en: 'Pa Khiap',
            },
            zipcode: '31190',
          },
          310203: {
            name: {
              th: 'บ้านแพ',
              en: 'Ban Phae',
            },
            zipcode: '31190',
          },
          310204: {
            name: {
              th: 'พรสำราญ',
              en: 'Phon Samran',
            },
            zipcode: '31190',
          },
          310205: {
            name: {
              th: 'หินเหล็กไฟ',
              en: 'Hin Lek Fai',
            },
            zipcode: '31190',
          },
          310206: {
            name: {
              th: 'ตูมใหญ่',
              en: 'Tum Yai',
            },
            zipcode: '31190',
          },
          310207: {
            name: {
              th: 'หนองขมาร',
              en: 'Nong Khaman',
            },
            zipcode: '31190',
          },
        },
      },
      3103: {
        name: {
          th: 'กระสัง',
          en: 'Krasang',
        },
        tambons: {
          310301: {
            name: {
              th: 'กระสัง',
              en: 'Krasang',
            },
            zipcode: '31160',
          },
          310302: {
            name: {
              th: 'ลำดวน',
              en: 'Lamduan',
            },
            zipcode: '31160',
          },
          310303: {
            name: {
              th: 'สองชั้น',
              en: 'Song Chan',
            },
            zipcode: '31160',
          },
          310304: {
            name: {
              th: 'สูงเนิน',
              en: 'Sung Noen',
            },
            zipcode: '31160',
          },
          310305: {
            name: {
              th: 'หนองเต็ง',
              en: 'Nong Teng',
            },
            zipcode: '31160',
          },
          310306: {
            name: {
              th: 'เมืองไผ่',
              en: 'Mueang Phai',
            },
            zipcode: '31160',
          },
          310307: {
            name: {
              th: 'ชุมแสง',
              en: 'Chum Saeng',
            },
            zipcode: '31160',
          },
          310308: {
            name: {
              th: 'บ้านปรือ',
              en: 'Ban Prue',
            },
            zipcode: '31160',
          },
          310309: {
            name: {
              th: 'ห้วยสำราญ',
              en: 'Huai Samran',
            },
            zipcode: '31160',
          },
          310310: {
            name: {
              th: 'กันทรารมย์',
              en: 'Kanthararom',
            },
            zipcode: '31160',
          },
          310311: {
            name: {
              th: 'ศรีภูมิ',
              en: 'Si Phum',
            },
            zipcode: '31160',
          },
        },
      },
      3104: {
        name: {
          th: 'นางรอง',
          en: 'Nang Rong',
        },
        tambons: {
          310401: {
            name: {
              th: 'นางรอง',
              en: 'Nang Rong',
            },
            zipcode: '31110',
          },
          310403: {
            name: {
              th: 'สะเดา',
              en: 'Sadao',
            },
            zipcode: '31110',
          },
          310405: {
            name: {
              th: 'ชุมแสง',
              en: 'Chum Saeng',
            },
            zipcode: '31110',
          },
          310406: {
            name: {
              th: 'หนองโบสถ์',
              en: 'Nong Bot',
            },
            zipcode: '31110',
          },
          310408: {
            name: {
              th: 'หนองกง',
              en: 'Nong Kong',
            },
            zipcode: '31110',
          },
          310413: {
            name: {
              th: 'ถนนหัก',
              en: 'Thanon Hak',
            },
            zipcode: '31110',
          },
          310414: {
            name: {
              th: 'หนองไทร',
              en: 'Nong Sai',
            },
            zipcode: '31110',
          },
          310415: {
            name: {
              th: 'ก้านเหลือง',
              en: 'Kan Lueang',
            },
            zipcode: '31110',
          },
          310416: {
            name: {
              th: 'บ้านสิงห์',
              en: 'Ban Sing',
            },
            zipcode: '31110',
          },
          310417: {
            name: {
              th: 'ลำไทรโยง',
              en: 'Lam Sai Yong',
            },
            zipcode: '31110',
          },
          310418: {
            name: {
              th: 'ทรัพย์พระยา',
              en: 'Sap Phraya',
            },
            zipcode: '31110',
          },
          310424: {
            name: {
              th: 'หนองยายพิมพ์',
              en: 'Nong Yai Phim',
            },
            zipcode: '31110',
          },
          310425: {
            name: {
              th: 'หัวถนน',
              en: 'Hua Thanon',
            },
            zipcode: '31110',
          },
          310426: {
            name: {
              th: 'ทุ่งแสงทอง',
              en: 'Thung Saeng Thong',
            },
            zipcode: '31110',
          },
          310427: {
            name: {
              th: 'หนองโสน',
              en: 'Nong Sano',
            },
            zipcode: '31110',
          },
        },
      },
      3105: {
        name: {
          th: 'หนองกี่',
          en: 'Nong Ki',
        },
        tambons: {
          310501: {
            name: {
              th: 'หนองกี่',
              en: 'Nong Ki',
            },
            zipcode: '31210',
          },
          310502: {
            name: {
              th: 'เย้ยปราสาท',
              en: 'Yoei Prasat',
            },
            zipcode: '31210',
          },
          310503: {
            name: {
              th: 'เมืองไผ่',
              en: 'Mueang Phai',
            },
            zipcode: '31210',
          },
          310504: {
            name: {
              th: 'ดอนอะราง',
              en: 'Don Arang',
            },
            zipcode: '31210',
          },
          310505: {
            name: {
              th: 'โคกสว่าง',
              en: 'Khok Sawang',
            },
            zipcode: '31210',
          },
          310506: {
            name: {
              th: 'ทุ่งกระตาดพัฒนา',
              en: 'Thung Kratat Phatthana',
            },
            zipcode: '31210',
          },
          310507: {
            name: {
              th: 'ทุ่งกระเต็น',
              en: 'Thung Kraten',
            },
            zipcode: '31210',
          },
          310508: {
            name: {
              th: 'ท่าโพธิ์ชัย',
              en: 'Tha Pho Chai',
            },
            zipcode: '31210',
          },
          310509: {
            name: {
              th: 'โคกสูง',
              en: 'Khok Sung',
            },
            zipcode: '31210',
          },
          310510: {
            name: {
              th: 'บุกระสัง',
              en: 'Bu Krasang',
            },
            zipcode: '31210',
          },
        },
      },
      3106: {
        name: {
          th: 'ละหานทราย',
          en: 'Lanhan Sai',
        },
        tambons: {
          310601: {
            name: {
              th: 'ละหานทราย',
              en: 'Lahan Sai',
            },
            zipcode: '31170',
          },
          310603: {
            name: {
              th: 'ตาจง',
              en: 'Ta Chong',
            },
            zipcode: '31170',
          },
          310604: {
            name: {
              th: 'สำโรงใหม่',
              en: 'Samrong Mai',
            },
            zipcode: '31170',
          },
          310607: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '31170',
          },
          310610: {
            name: {
              th: 'หนองตะครอง',
              en: 'Nong Takhrong',
            },
            zipcode: '31170',
          },
          310611: {
            name: {
              th: 'โคกว่าน',
              en: 'Khok Wan',
            },
            zipcode: '31170',
          },
        },
      },
      3107: {
        name: {
          th: 'ประโคนชัย',
          en: 'Phakhon Chai',
        },
        tambons: {
          310701: {
            name: {
              th: 'ประโคนชัย',
              en: 'Prakhon Chai',
            },
            zipcode: '31140',
          },
          310702: {
            name: {
              th: 'แสลงโทน',
              en: 'Salaeng Thon',
            },
            zipcode: '31140',
          },
          310703: {
            name: {
              th: 'บ้านไทร',
              en: 'Ban Sai',
            },
            zipcode: '31140',
          },
          310705: {
            name: {
              th: 'ละเวี้ย',
              en: 'Lawia',
            },
            zipcode: '31140',
          },
          310706: {
            name: {
              th: 'จรเข้มาก',
              en: 'Chorakhe Mak',
            },
            zipcode: '31140',
          },
          310707: {
            name: {
              th: 'ปังกู',
              en: 'Pang Ku',
            },
            zipcode: '31140',
          },
          310708: {
            name: {
              th: 'โคกย่าง',
              en: 'Khok Yang',
            },
            zipcode: '31140',
          },
          310710: {
            name: {
              th: 'โคกม้า',
              en: 'Khok Ma',
            },
            zipcode: '31140',
          },
          310713: {
            name: {
              th: 'ไพศาล',
              en: 'Phaisan',
            },
            zipcode: '31140',
          },
          310714: {
            name: {
              th: 'ตะโกตาพิ',
              en: 'Tako Taphi',
            },
            zipcode: '31140',
          },
          310715: {
            name: {
              th: 'เขาคอก',
              en: 'Khao Khok',
            },
            zipcode: '31140',
          },
          310716: {
            name: {
              th: 'หนองบอน',
              en: 'Nong Bon',
            },
            zipcode: '31140',
          },
          310718: {
            name: {
              th: 'โคกมะขาม',
              en: 'Khok Makham',
            },
            zipcode: '31140',
          },
          310719: {
            name: {
              th: 'โคกตูม',
              en: 'Khok Tum',
            },
            zipcode: '31140',
          },
          310720: {
            name: {
              th: 'ประทัดบุ',
              en: 'Prathat Bu',
            },
            zipcode: '31140',
          },
          310721: {
            name: {
              th: 'สี่เหลี่ยม',
              en: 'Si Liam',
            },
            zipcode: '31140',
          },
        },
      },
      3108: {
        name: {
          th: 'บ้านกรวด',
          en: 'Ban Kruat',
        },
        tambons: {
          310801: {
            name: {
              th: 'บ้านกรวด',
              en: 'Ban Kruat',
            },
            zipcode: '31180',
          },
          310802: {
            name: {
              th: 'โนนเจริญ',
              en: 'Non Charoen',
            },
            zipcode: '31180',
          },
          310803: {
            name: {
              th: 'หนองไม้งาม',
              en: 'Nong Mai Ngam',
            },
            zipcode: '31180',
          },
          310804: {
            name: {
              th: 'ปราสาท',
              en: 'Prasat',
            },
            zipcode: '31180',
          },
          310805: {
            name: {
              th: 'สายตะกู',
              en: 'Sai Taku',
            },
            zipcode: '31180',
          },
          310806: {
            name: {
              th: 'หินลาด',
              en: 'Hin Lat',
            },
            zipcode: '31180',
          },
          310807: {
            name: {
              th: 'บึงเจริญ',
              en: 'Bueng Charoen',
            },
            zipcode: '31180',
          },
          310808: {
            name: {
              th: 'จันทบเพชร',
              en: 'Chanthop Phet',
            },
            zipcode: '31180',
          },
          310809: {
            name: {
              th: 'เขาดินเหนือ',
              en: 'Khao Din Nuea',
            },
            zipcode: '31180',
          },
        },
      },
      3109: {
        name: {
          th: 'พุทไธสง',
          en: 'Phuttatisong',
        },
        tambons: {
          310901: {
            name: {
              th: 'พุทไธสง',
              en: 'Phutthaisong',
            },
            zipcode: '31120',
          },
          310902: {
            name: {
              th: 'มะเฟือง',
              en: 'Mafueang',
            },
            zipcode: '31120',
          },
          310903: {
            name: {
              th: 'บ้านจาน',
              en: 'Ban Chan',
            },
            zipcode: '31120',
          },
          310906: {
            name: {
              th: 'บ้านเป้า',
              en: 'Ban Pao',
            },
            zipcode: '31120',
          },
          310907: {
            name: {
              th: 'บ้านแวง',
              en: 'Ban Waeng',
            },
            zipcode: '31120',
          },
          310909: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '31120',
          },
          310910: {
            name: {
              th: 'หายโศก',
              en: 'Hai Sok',
            },
            zipcode: '31120',
          },
        },
      },
      3110: {
        name: {
          th: 'ลำปลายมาศ',
          en: 'Lum Plaimat',
        },
        tambons: {
          311001: {
            name: {
              th: 'ลำปลายมาศ',
              en: 'Lumย  Plaimat',
            },
            zipcode: '31130',
          },
          311002: {
            name: {
              th: 'หนองคู',
              en: 'Nong Khu',
            },
            zipcode: '31130',
          },
          311003: {
            name: {
              th: 'แสลงพัน',
              en: 'Salaeng Phan',
            },
            zipcode: '31130',
          },
          311004: {
            name: {
              th: 'ทะเมนชัย',
              en: 'Thamen Chai',
            },
            zipcode: '31130',
          },
          311005: {
            name: {
              th: 'ตลาดโพธิ์',
              en: 'Talat Pho',
            },
            zipcode: '31130',
          },
          311006: {
            name: {
              th: 'หนองกะทิง',
              en: 'Nong Kathing',
            },
            zipcode: '31130',
          },
          311007: {
            name: {
              th: 'โคกกลาง',
              en: 'Khok Klang',
            },
            zipcode: '31130',
          },
          311008: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '31130',
          },
          311009: {
            name: {
              th: 'เมืองแฝก',
              en: 'Mueang Faek',
            },
            zipcode: '31130',
          },
          311010: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '31130',
          },
          311011: {
            name: {
              th: 'ผไทรินทร์',
              en: 'Phathairin',
            },
            zipcode: '31130',
          },
          311012: {
            name: {
              th: 'โคกล่าม',
              en: 'Khok Lam',
            },
            zipcode: '31130',
          },
          311013: {
            name: {
              th: 'หินโคน',
              en: 'Hin Khon',
            },
            zipcode: '31130',
          },
          311014: {
            name: {
              th: 'หนองบัวโคก',
              en: 'Nong Bua Khok',
            },
            zipcode: '31130',
          },
          311015: {
            name: {
              th: 'บุโพธิ์',
              en: 'Bu Pho',
            },
            zipcode: '31130',
          },
          311016: {
            name: {
              th: 'หนองโดน',
              en: 'Nong Don',
            },
            zipcode: '31130',
          },
        },
      },
      3111: {
        name: {
          th: 'สตึก',
          en: 'Satuk',
        },
        tambons: {
          311101: {
            name: {
              th: 'สตึก',
              en: 'Satuek',
            },
            zipcode: '31150',
          },
          311102: {
            name: {
              th: 'นิคม',
              en: 'Nikhom',
            },
            zipcode: '31150',
          },
          311103: {
            name: {
              th: 'ทุ่งวัง',
              en: 'Thung Wang',
            },
            zipcode: '31150',
          },
          311104: {
            name: {
              th: 'เมืองแก',
              en: 'Mueang Kae',
            },
            zipcode: '31150',
          },
          311105: {
            name: {
              th: 'หนองใหญ่',
              en: 'Nong Yai',
            },
            zipcode: '31150',
          },
          311106: {
            name: {
              th: 'ร่อนทอง',
              en: 'Ron Thong',
            },
            zipcode: '31150',
          },
          311109: {
            name: {
              th: 'ดอนมนต์',
              en: 'Don Mon',
            },
            zipcode: '31150',
          },
          311110: {
            name: {
              th: 'ชุมแสง',
              en: 'Chum Saeng',
            },
            zipcode: '31150',
          },
          311111: {
            name: {
              th: 'ท่าม่วง',
              en: 'Tha Muang',
            },
            zipcode: '31150',
          },
          311112: {
            name: {
              th: 'สะแก',
              en: 'Sakae',
            },
            zipcode: '31150',
          },
          311114: {
            name: {
              th: 'สนามชัย',
              en: 'Sanam Chai',
            },
            zipcode: '31150',
          },
          311115: {
            name: {
              th: 'กระสัง',
              en: 'Krasang',
            },
            zipcode: '31150',
          },
        },
      },
      3112: {
        name: {
          th: 'ปะคำ',
          en: 'Pa Kham',
        },
        tambons: {
          311201: {
            name: {
              th: 'ปะคำ',
              en: 'Pakham',
            },
            zipcode: '31220',
          },
          311202: {
            name: {
              th: 'ไทยเจริญ',
              en: 'Thai Charoen',
            },
            zipcode: '31220',
          },
          311203: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '31220',
          },
          311204: {
            name: {
              th: 'โคกมะม่วง',
              en: 'Khok Mamuang',
            },
            zipcode: '31220',
          },
          311205: {
            name: {
              th: 'หูทำนบ',
              en: 'Hu Thamnop',
            },
            zipcode: '31220',
          },
        },
      },
      3113: {
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        tambons: {
          311301: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '31230',
          },
          311302: {
            name: {
              th: 'บ้านคู',
              en: 'Ban Khu',
            },
            zipcode: '31230',
          },
          311303: {
            name: {
              th: 'บ้านดู่',
              en: 'Ban Du',
            },
            zipcode: '31230',
          },
          311304: {
            name: {
              th: 'ดอนกอก',
              en: 'Don Kok',
            },
            zipcode: '31230',
          },
          311305: {
            name: {
              th: 'ศรีสว่าง',
              en: 'Si Sawang',
            },
            zipcode: '31230',
          },
        },
      },
      3114: {
        name: {
          th: 'หนองหงส์',
          en: 'Nong Hong',
        },
        tambons: {
          311401: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '31240',
          },
          311402: {
            name: {
              th: 'ห้วยหิน',
              en: 'Huai Hin',
            },
            zipcode: '31240',
          },
          311403: {
            name: {
              th: 'ไทยสามัคคี',
              en: 'Thai Samakkhi',
            },
            zipcode: '31240',
          },
          311404: {
            name: {
              th: 'หนองชัยศรี',
              en: 'Nong Chai Si',
            },
            zipcode: '31240',
          },
          311405: {
            name: {
              th: 'เสาเดียว',
              en: 'Sao Diao',
            },
            zipcode: '31240',
          },
          311406: {
            name: {
              th: 'เมืองฝ้าย',
              en: 'Mueang Fai',
            },
            zipcode: '31240',
          },
          311407: {
            name: {
              th: 'สระทอง',
              en: 'Sa Thong',
            },
            zipcode: '31240',
          },
        },
      },
      3115: {
        name: {
          th: 'พลับพลาชัย',
          en: 'Phlapphla Chai',
        },
        tambons: {
          311501: {
            name: {
              th: 'จันดุม',
              en: 'Chan Dum',
            },
            zipcode: '31250',
          },
          311502: {
            name: {
              th: 'โคกขมิ้น',
              en: 'Khok Khamin',
            },
            zipcode: '31250',
          },
          311503: {
            name: {
              th: 'ป่าชัน',
              en: 'Pa Chan',
            },
            zipcode: '31250',
          },
          311504: {
            name: {
              th: 'สะเดา',
              en: 'Sadao',
            },
            zipcode: '31250',
          },
          311505: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '31250',
          },
        },
      },
      3116: {
        name: {
          th: 'ห้วยราช',
          en: 'Huai Rat',
        },
        tambons: {
          311601: {
            name: {
              th: 'ห้วยราช',
              en: 'Huai Rat',
            },
            zipcode: '31000',
          },
          311602: {
            name: {
              th: 'สามแวง',
              en: 'Sam Waeng',
            },
            zipcode: '31000',
          },
          311603: {
            name: {
              th: 'ตาเสา',
              en: 'Ta Sao',
            },
            zipcode: '31000',
          },
          311604: {
            name: {
              th: 'บ้านตะโก',
              en: 'Ban Tako',
            },
            zipcode: '31000',
          },
          311605: {
            name: {
              th: 'สนวน',
              en: 'Sanuan',
            },
            zipcode: '31000',
          },
          311606: {
            name: {
              th: 'โคกเหล็ก',
              en: 'Khok Lek',
            },
            zipcode: '31000',
          },
          311607: {
            name: {
              th: 'เมืองโพธิ์',
              en: 'Mueang Pho',
            },
            zipcode: '31000',
          },
          311608: {
            name: {
              th: 'ห้วยราชา',
              en: 'Huai Racha',
            },
            zipcode: '31000',
          },
        },
      },
      3117: {
        name: {
          th: 'โนนสุวรรณ',
          en: 'Non Suwan',
        },
        tambons: {
          311701: {
            name: {
              th: 'โนนสุวรรณ',
              en: 'Non Suwan',
            },
            zipcode: '31110',
          },
          311702: {
            name: {
              th: 'ทุ่งจังหัน',
              en: 'Thung Changhan',
            },
            zipcode: '31110',
          },
          311703: {
            name: {
              th: 'โกรกแก้ว',
              en: 'Krok Kaeo',
            },
            zipcode: '31110',
          },
          311704: {
            name: {
              th: 'ดงอีจาน',
              en: 'Dong I Chan',
            },
            zipcode: '31110',
          },
        },
      },
      3118: {
        name: {
          th: 'ชำนิ',
          en: 'Cham Ni',
        },
        tambons: {
          311801: {
            name: {
              th: 'ชำนิ',
              en: 'Chamni',
            },
            zipcode: '31110',
          },
          311802: {
            name: {
              th: 'หนองปล่อง',
              en: 'Nong Plong',
            },
            zipcode: '31110',
          },
          311803: {
            name: {
              th: 'เมืองยาง',
              en: 'Mueang Yang',
            },
            zipcode: '31110',
          },
          311804: {
            name: {
              th: 'ช่อผกา',
              en: 'Cho Phaka',
            },
            zipcode: '31110',
          },
          311805: {
            name: {
              th: 'ละลวด',
              en: 'Laluat',
            },
            zipcode: '31110',
          },
          311806: {
            name: {
              th: 'โคกสนวน',
              en: 'Khok Sanuan',
            },
            zipcode: '31110',
          },
        },
      },
      3119: {
        name: {
          th: 'บ้านใหม่ไชยพจน์',
          en: 'Ban Mai Chaiyapot',
        },
        tambons: {
          311901: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '31120',
          },
          311902: {
            name: {
              th: 'ทองหลาง',
              en: 'Thong Lang',
            },
            zipcode: '31120',
          },
          311903: {
            name: {
              th: 'แดงใหญ่',
              en: 'Daeng Yai',
            },
            zipcode: '31120',
          },
          311904: {
            name: {
              th: 'กู่สวนแตง',
              en: 'Ku Suan Taeng',
            },
            zipcode: '31120',
          },
          311905: {
            name: {
              th: 'หนองเยือง',
              en: 'Nong Yueang',
            },
            zipcode: '31120',
          },
        },
      },
      3120: {
        name: {
          th: 'โนนดินแดง',
          en: 'Non Din Daeng',
        },
        tambons: {
          312001: {
            name: {
              th: 'โนนดินแดง',
              en: 'Non Din Daeng',
            },
            zipcode: '31260',
          },
          312002: {
            name: {
              th: 'ส้มป่อย',
              en: 'Som Poi',
            },
            zipcode: '31260',
          },
          312003: {
            name: {
              th: 'ลำนางรอง',
              en: 'Lam Nang Rong',
            },
            zipcode: '31260',
          },
        },
      },
      3121: {
        name: {
          th: 'บ้านด่าน',
          en: 'King Amphoe Ban Dan',
        },
        tambons: {
          312101: {
            name: {
              th: 'บ้านด่าน',
              en: 'Ban Dan',
            },
            zipcode: '31000',
          },
          312102: {
            name: {
              th: 'ปราสาท',
              en: 'Prasat',
            },
            zipcode: '31000',
          },
          312103: {
            name: {
              th: 'วังเหนือ',
              en: 'Wang Nuea',
            },
            zipcode: '31000',
          },
          312104: {
            name: {
              th: 'โนนขวาง',
              en: 'Non Khwang',
            },
            zipcode: '31000',
          },
        },
      },
      3122: {
        name: {
          th: 'แคนดง',
          en: 'Can Dong',
        },
        tambons: {
          312201: {
            name: {
              th: 'แคนดง',
              en: 'Khaen Dong',
            },
            zipcode: '31150',
          },
          312202: {
            name: {
              th: 'ดงพลอง',
              en: 'Dong Phlong',
            },
            zipcode: '31150',
          },
          312203: {
            name: {
              th: 'สระบัว',
              en: 'Sa Bua',
            },
            zipcode: '31150',
          },
          312204: {
            name: {
              th: 'หัวฝาย',
              en: 'Hua Fai',
            },
            zipcode: '31150',
          },
        },
      },
      3123: {
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chalermprakiat',
        },
        tambons: {
          312301: {
            name: {
              th: 'เจริญสุข',
              en: 'Charoen Suk',
            },
            zipcode: '31110',
          },
          312302: {
            name: {
              th: 'ตาเป๊ก',
              en: 'Ta Pek',
            },
            zipcode: '31110',
          },
          312303: {
            name: {
              th: 'อีสานเขต',
              en: 'Isan Khet',
            },
            zipcode: '31110',
          },
          312304: {
            name: {
              th: 'ถาวร',
              en: 'Thawon',
            },
            zipcode: '31170',
          },
          312305: {
            name: {
              th: 'ยายแย้มวัฒนา',
              en: 'Yai Yaem Watthana',
            },
            zipcode: '31170',
          },
        },
      },
    },
  },
  32: {
    name: {
      th: 'สุรินทร์',
      en: 'Surin',
    },
    amphoes: {
      3201: {
        name: {
          th: 'เมืองสุรินทร์',
          en: 'Muang',
        },
        tambons: {
          320101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '32000',
          },
          320102: {
            name: {
              th: 'ตั้งใจ',
              en: 'Tang Chai',
            },
            zipcode: '32000',
          },
          320103: {
            name: {
              th: 'เพี้ยราม',
              en: 'Phia Ram',
            },
            zipcode: '32000',
          },
          320104: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '32000',
          },
          320105: {
            name: {
              th: 'ท่าสว่าง',
              en: 'Tha Sawang',
            },
            zipcode: '32000',
          },
          320106: {
            name: {
              th: 'สลักได',
              en: 'Salakdai',
            },
            zipcode: '32000',
          },
          320107: {
            name: {
              th: 'ตาอ็อง',
              en: 'Ta Ong',
            },
            zipcode: '32000',
          },
          320109: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '32000',
          },
          320110: {
            name: {
              th: 'แกใหญ่',
              en: 'Kae Yai',
            },
            zipcode: '32000',
          },
          320111: {
            name: {
              th: 'นอกเมือง',
              en: 'Nok Mueang',
            },
            zipcode: '32000',
          },
          320112: {
            name: {
              th: 'คอโค',
              en: 'Kho Kho',
            },
            zipcode: '32000',
          },
          320113: {
            name: {
              th: 'สวาย',
              en: 'Sawai',
            },
            zipcode: '32000',
          },
          320114: {
            name: {
              th: 'เฉนียง',
              en: 'Chaniang',
            },
            zipcode: '32000',
          },
          320116: {
            name: {
              th: 'เทนมีย์',
              en: 'Thenmi',
            },
            zipcode: '32000',
          },
          320118: {
            name: {
              th: 'นาบัว',
              en: 'Na Bua',
            },
            zipcode: '32000',
          },
          320119: {
            name: {
              th: 'เมืองที',
              en: 'Mueang Thi',
            },
            zipcode: '32000',
          },
          320120: {
            name: {
              th: 'ราม',
              en: 'Ram',
            },
            zipcode: '32000',
          },
          320121: {
            name: {
              th: 'บุฤาษี',
              en: 'Bu Rue Si',
            },
            zipcode: '32000',
          },
          320122: {
            name: {
              th: 'ตระแสง',
              en: 'Trasaeng',
            },
            zipcode: '32000',
          },
          320125: {
            name: {
              th: 'แสลงพันธ์',
              en: 'Salaeng Phan',
            },
            zipcode: '32000',
          },
          320126: {
            name: {
              th: 'กาเกาะ',
              en: 'Ka Ko',
            },
            zipcode: '32000',
          },
        },
      },
      3202: {
        name: {
          th: 'ชุมพลบุรี',
          en: 'Chumphon Buri',
        },
        tambons: {
          320201: {
            name: {
              th: 'ชุมพลบุรี',
              en: 'Chumphon Buri',
            },
            zipcode: '32190',
          },
          320202: {
            name: {
              th: 'นาหนองไผ่',
              en: 'Na Nong Phai',
            },
            zipcode: '32190',
          },
          320203: {
            name: {
              th: 'ไพรขลา',
              en: 'Phrai Khla',
            },
            zipcode: '32190',
          },
          320204: {
            name: {
              th: 'ศรีณรงค์',
              en: 'Si Narong',
            },
            zipcode: '32190',
          },
          320205: {
            name: {
              th: 'ยะวึก',
              en: 'Yawuek',
            },
            zipcode: '32190',
          },
          320206: {
            name: {
              th: 'เมืองบัว',
              en: 'Mueang Bua',
            },
            zipcode: '32190',
          },
          320207: {
            name: {
              th: 'สระขุด',
              en: 'Sa Khut',
            },
            zipcode: '32190',
          },
          320208: {
            name: {
              th: 'กระเบื้อง',
              en: 'Krabueang',
            },
            zipcode: '32190',
          },
          320209: {
            name: {
              th: 'หนองเรือ',
              en: 'Nong Ruea',
            },
            zipcode: '32190',
          },
        },
      },
      3203: {
        name: {
          th: 'ท่าตูม',
          en: 'Tha Tum',
        },
        tambons: {
          320301: {
            name: {
              th: 'ท่าตูม',
              en: 'Tha Tum',
            },
            zipcode: '32120',
          },
          320302: {
            name: {
              th: 'กระโพ',
              en: 'Krapho',
            },
            zipcode: '32120',
          },
          320303: {
            name: {
              th: 'พรมเทพ',
              en: 'Phrom Thep',
            },
            zipcode: '32120',
          },
          320304: {
            name: {
              th: 'โพนครก',
              en: 'Phon Khrok',
            },
            zipcode: '32120',
          },
          320305: {
            name: {
              th: 'เมืองแก',
              en: 'Mueang Kae',
            },
            zipcode: '32120',
          },
          320306: {
            name: {
              th: 'บะ',
              en: 'Ba',
            },
            zipcode: '32120',
          },
          320307: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '32120',
          },
          320308: {
            name: {
              th: 'บัวโคก',
              en: 'Bua Khok',
            },
            zipcode: '32120',
          },
          320309: {
            name: {
              th: 'หนองเมธี',
              en: 'Nong Methi',
            },
            zipcode: '32120',
          },
          320310: {
            name: {
              th: 'ทุ่งกุลา',
              en: 'Thung Kula',
            },
            zipcode: '32120',
          },
        },
      },
      3204: {
        name: {
          th: 'จอมพระ',
          en: 'Chom Phra',
        },
        tambons: {
          320401: {
            name: {
              th: 'จอมพระ',
              en: 'Chom Phra',
            },
            zipcode: '32180',
          },
          320402: {
            name: {
              th: 'เมืองลีง',
              en: 'Mueang Ling',
            },
            zipcode: '32180',
          },
          320403: {
            name: {
              th: 'กระหาด',
              en: 'Krahat',
            },
            zipcode: '32180',
          },
          320404: {
            name: {
              th: 'บุแกรง',
              en: 'Bu Kraeng',
            },
            zipcode: '32180',
          },
          320405: {
            name: {
              th: 'หนองสนิท',
              en: 'Nong Sanit',
            },
            zipcode: '32180',
          },
          320406: {
            name: {
              th: 'บ้านผือ',
              en: 'Ban Phue',
            },
            zipcode: '32180',
          },
          320407: {
            name: {
              th: 'ลุ่มระวี',
              en: 'Lum Rawi',
            },
            zipcode: '32180',
          },
          320408: {
            name: {
              th: 'ชุมแสง',
              en: 'Chum Saeng',
            },
            zipcode: '32180',
          },
          320409: {
            name: {
              th: 'เป็นสุข',
              en: 'Pen Suk',
            },
            zipcode: '32180',
          },
        },
      },
      3205: {
        name: {
          th: 'ปราสาท',
          en: 'Pra Sat',
        },
        tambons: {
          320501: {
            name: {
              th: 'กังแอน',
              en: 'Kang Aen',
            },
            zipcode: '32140',
          },
          320502: {
            name: {
              th: 'ทมอ',
              en: 'Thamo',
            },
            zipcode: '32140',
          },
          320503: {
            name: {
              th: 'ไพล',
              en: 'Phlai',
            },
            zipcode: '32140',
          },
          320504: {
            name: {
              th: 'ปรือ',
              en: 'Prue',
            },
            zipcode: '32140',
          },
          320505: {
            name: {
              th: 'ทุ่งมน',
              en: 'Thung Mon',
            },
            zipcode: '32140',
          },
          320506: {
            name: {
              th: 'ตาเบา',
              en: 'Ta Bao',
            },
            zipcode: '32140',
          },
          320507: {
            name: {
              th: 'หนองใหญ่',
              en: 'Nong Yai',
            },
            zipcode: '32140',
          },
          320508: {
            name: {
              th: 'โคกยาง',
              en: 'Khok Yang',
            },
            zipcode: '32140',
          },
          320509: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '32140',
          },
          320510: {
            name: {
              th: 'บ้านไทร',
              en: 'Ban Sai',
            },
            zipcode: '32140',
          },
          320511: {
            name: {
              th: 'โชคนาสาม',
              en: 'Chok Na Sam',
            },
            zipcode: '32140',
          },
          320512: {
            name: {
              th: 'เชื้อเพลิง',
              en: 'Chuea Phloeng',
            },
            zipcode: '32140',
          },
          320513: {
            name: {
              th: 'ปราสาททนง',
              en: 'Prasat Thanong',
            },
            zipcode: '32140',
          },
          320514: {
            name: {
              th: 'ตานี',
              en: 'Tani',
            },
            zipcode: '32140',
          },
          320515: {
            name: {
              th: 'บ้านพลวง',
              en: 'Ban Phluang',
            },
            zipcode: '32140',
          },
          320516: {
            name: {
              th: 'กันตวจระมวล',
              en: 'Kantuatramuan',
            },
            zipcode: '32140',
          },
          320517: {
            name: {
              th: 'สมุด',
              en: 'Samut',
            },
            zipcode: '32140',
          },
          320518: {
            name: {
              th: 'ประทัดบุ',
              en: 'Prathat Bu',
            },
            zipcode: '32140',
          },
        },
      },
      3206: {
        name: {
          th: 'กาบเชิง',
          en: 'Kap Choeng',
        },
        tambons: {
          320601: {
            name: {
              th: 'กาบเชิง',
              en: 'Kap Choeng',
            },
            zipcode: '32210',
          },
          320604: {
            name: {
              th: 'คูตัน',
              en: 'Khu Tan',
            },
            zipcode: '32210',
          },
          320605: {
            name: {
              th: 'ด่าน',
              en: 'Dan',
            },
            zipcode: '32210',
          },
          320606: {
            name: {
              th: 'แนงมุด',
              en: 'Naeng Mut',
            },
            zipcode: '32210',
          },
          320607: {
            name: {
              th: 'โคกตะเคียน',
              en: 'Khok Takhian',
            },
            zipcode: '32210',
          },
          320610: {
            name: {
              th: 'ตะเคียน',
              en: 'Takhian',
            },
            zipcode: '32210',
          },
        },
      },
      3207: {
        name: {
          th: 'รัตนบุรี',
          en: 'Rattana Buri',
        },
        tambons: {
          320701: {
            name: {
              th: 'รัตนบุรี',
              en: 'Rattanaburi',
            },
            zipcode: '32130',
          },
          320702: {
            name: {
              th: 'ธาตุ',
              en: 'That',
            },
            zipcode: '32130',
          },
          320703: {
            name: {
              th: 'แก',
              en: 'Kae',
            },
            zipcode: '32130',
          },
          320704: {
            name: {
              th: 'ดอนแรด',
              en: 'Don Raet',
            },
            zipcode: '32130',
          },
          320705: {
            name: {
              th: 'หนองบัวทอง',
              en: 'Nong Bua Thong',
            },
            zipcode: '32130',
          },
          320706: {
            name: {
              th: 'หนองบัวบาน',
              en: 'Nong Bua Ban',
            },
            zipcode: '32130',
          },
          320709: {
            name: {
              th: 'ไผ่',
              en: 'Phai',
            },
            zipcode: '32130',
          },
          320711: {
            name: {
              th: 'เบิด',
              en: 'Boet',
            },
            zipcode: '32130',
          },
          320713: {
            name: {
              th: 'น้ำเขียว',
              en: 'Nam Khiao',
            },
            zipcode: '32130',
          },
          320714: {
            name: {
              th: 'กุดขาคีม',
              en: 'Kut Kha Khim',
            },
            zipcode: '32130',
          },
          320715: {
            name: {
              th: 'ยางสว่าง',
              en: 'Yang Sawang',
            },
            zipcode: '32130',
          },
          320716: {
            name: {
              th: 'ทับใหญ่',
              en: 'Thap Yai',
            },
            zipcode: '32130',
          },
        },
      },
      3208: {
        name: {
          th: 'สนม',
          en: 'Sanom',
        },
        tambons: {
          320801: {
            name: {
              th: 'สนม',
              en: 'Sanom',
            },
            zipcode: '32160',
          },
          320802: {
            name: {
              th: 'โพนโก',
              en: 'Phon Ko',
            },
            zipcode: '32160',
          },
          320803: {
            name: {
              th: 'หนองระฆัง',
              en: 'Nong Rakhang',
            },
            zipcode: '32160',
          },
          320804: {
            name: {
              th: 'นานวน',
              en: 'Na Nuan',
            },
            zipcode: '32160',
          },
          320805: {
            name: {
              th: 'แคน',
              en: 'Khaen',
            },
            zipcode: '32160',
          },
          320806: {
            name: {
              th: 'หัวงัว',
              en: 'Hua Ngua',
            },
            zipcode: '32160',
          },
          320807: {
            name: {
              th: 'หนองอียอ',
              en: 'Nong I Yo',
            },
            zipcode: '32160',
          },
        },
      },
      3209: {
        name: {
          th: 'ศีขรภูมิ',
          en: 'Sikhoraphum',
        },
        tambons: {
          320901: {
            name: {
              th: 'ระแงง',
              en: 'Ra-ngaeng',
            },
            zipcode: '32110',
          },
          320902: {
            name: {
              th: 'ตรึม',
              en: 'Truem',
            },
            zipcode: '32110',
          },
          320903: {
            name: {
              th: 'จารพัต',
              en: 'Charaphat',
            },
            zipcode: '32110',
          },
          320904: {
            name: {
              th: 'ยาง',
              en: 'Yang',
            },
            zipcode: '32110',
          },
          320905: {
            name: {
              th: 'แตล',
              en: 'Taen',
            },
            zipcode: '32110',
          },
          320906: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '32110',
          },
          320907: {
            name: {
              th: 'คาละแมะ',
              en: 'Khalamae',
            },
            zipcode: '32110',
          },
          320908: {
            name: {
              th: 'หนองเหล็ก',
              en: 'Nong Lek',
            },
            zipcode: '32110',
          },
          320909: {
            name: {
              th: 'หนองขวาว',
              en: 'Nong Khwao',
            },
            zipcode: '32110',
          },
          320910: {
            name: {
              th: 'ช่างปี่',
              en: 'Chang Pi',
            },
            zipcode: '32110',
          },
          320911: {
            name: {
              th: 'กุดหวาย',
              en: 'Kut Wai',
            },
            zipcode: '32110',
          },
          320912: {
            name: {
              th: 'ขวาวใหญ่',
              en: 'Khwao Yai',
            },
            zipcode: '32110',
          },
          320913: {
            name: {
              th: 'นารุ่ง',
              en: 'Na Rung',
            },
            zipcode: '32110',
          },
          320914: {
            name: {
              th: 'ตรมไพร',
              en: 'Trom Phrai',
            },
            zipcode: '32110',
          },
          320915: {
            name: {
              th: 'ผักไหม',
              en: 'Phak Mai',
            },
            zipcode: '32110',
          },
        },
      },
      3210: {
        name: {
          th: 'สังขะ',
          en: 'Sungkha',
        },
        tambons: {
          321001: {
            name: {
              th: 'สังขะ',
              en: 'Sangkha',
            },
            zipcode: '32150',
          },
          321002: {
            name: {
              th: 'ขอนแตก',
              en: 'Khon Taek',
            },
            zipcode: '32150',
          },
          321006: {
            name: {
              th: 'ดม',
              en: 'Dom',
            },
            zipcode: '32150',
          },
          321007: {
            name: {
              th: 'พระแก้ว',
              en: 'Phra Kaeo',
            },
            zipcode: '32150',
          },
          321008: {
            name: {
              th: 'บ้านจารย์',
              en: 'Ban Chan',
            },
            zipcode: '32150',
          },
          321009: {
            name: {
              th: 'กระเทียม',
              en: 'Krathiam',
            },
            zipcode: '32150',
          },
          321010: {
            name: {
              th: 'สะกาด',
              en: 'Sakat',
            },
            zipcode: '32150',
          },
          321011: {
            name: {
              th: 'ตาตุม',
              en: 'Ta Tum',
            },
            zipcode: '32150',
          },
          321012: {
            name: {
              th: 'ทับทัน',
              en: 'Thap Than',
            },
            zipcode: '32150',
          },
          321013: {
            name: {
              th: 'ตาคง',
              en: 'Ta Khong',
            },
            zipcode: '32150',
          },
          321015: {
            name: {
              th: 'บ้านชบ',
              en: 'Ban Chop',
            },
            zipcode: '32150',
          },
          321017: {
            name: {
              th: 'เทพรักษา',
              en: 'Thep Raksa',
            },
            zipcode: '32150',
          },
        },
      },
      3211: {
        name: {
          th: 'ลำดวน',
          en: 'Lamduan',
        },
        tambons: {
          321101: {
            name: {
              th: 'ลำดวน',
              en: 'Lamduan',
            },
            zipcode: '32220',
          },
          321102: {
            name: {
              th: 'โชคเหนือ',
              en: 'Chok Nuea',
            },
            zipcode: '32220',
          },
          321103: {
            name: {
              th: 'อู่โลก',
              en: 'U Lok',
            },
            zipcode: '32220',
          },
          321104: {
            name: {
              th: 'ตรำดม',
              en: 'Tramdom',
            },
            zipcode: '32220',
          },
          321105: {
            name: {
              th: 'ตระเปียงเตีย',
              en: 'Tapiang Tia',
            },
            zipcode: '32220',
          },
        },
      },
      3212: {
        name: {
          th: 'สำโรงทาบ',
          en: 'Samrong Thap',
        },
        tambons: {
          321201: {
            name: {
              th: 'สำโรงทาบ',
              en: 'Samrong Thap',
            },
            zipcode: '32170',
          },
          321202: {
            name: {
              th: 'หนองไผ่ล้อม',
              en: 'Nong Phai Lom',
            },
            zipcode: '32170',
          },
          321203: {
            name: {
              th: 'กระออม',
              en: 'Kra-om',
            },
            zipcode: '32170',
          },
          321204: {
            name: {
              th: 'หนองฮะ',
              en: 'Nong Ha',
            },
            zipcode: '32170',
          },
          321205: {
            name: {
              th: 'ศรีสุข',
              en: 'Si Suk',
            },
            zipcode: '32170',
          },
          321206: {
            name: {
              th: 'เกาะแก้ว',
              en: 'Ko Kaeo',
            },
            zipcode: '32170',
          },
          321207: {
            name: {
              th: 'หมื่นศรี',
              en: 'Muen Si',
            },
            zipcode: '32170',
          },
          321208: {
            name: {
              th: 'เสม็จ',
              en: 'Samet',
            },
            zipcode: '32170',
          },
          321209: {
            name: {
              th: 'สะโน',
              en: 'Sano',
            },
            zipcode: '32170',
          },
          321210: {
            name: {
              th: 'ประดู่',
              en: 'Pradu',
            },
            zipcode: '32170',
          },
        },
      },
      3213: {
        name: {
          th: 'บัวเชด',
          en: 'BuaChet',
        },
        tambons: {
          321301: {
            name: {
              th: 'บัวเชด',
              en: 'Buachet',
            },
            zipcode: '32230',
          },
          321302: {
            name: {
              th: 'สะเดา',
              en: 'Sadao',
            },
            zipcode: '32230',
          },
          321303: {
            name: {
              th: 'จรัส',
              en: 'Charat',
            },
            zipcode: '32230',
          },
          321304: {
            name: {
              th: 'ตาวัง',
              en: 'Ta Wang',
            },
            zipcode: '32230',
          },
          321305: {
            name: {
              th: 'อาโพน',
              en: 'A Phon',
            },
            zipcode: '32230',
          },
          321306: {
            name: {
              th: 'สำเภาลูน',
              en: 'Samphao Lun',
            },
            zipcode: '32230',
          },
        },
      },
      3214: {
        name: {
          th: 'พนมดงรัก',
          en: 'Phanom Dong Rak',
        },
        tambons: {
          321401: {
            name: {
              th: 'บักได',
              en: 'Bakdai',
            },
            zipcode: '32140',
          },
          321402: {
            name: {
              th: 'โคกกลาง',
              en: 'Khok Klang',
            },
            zipcode: '32140',
          },
          321403: {
            name: {
              th: 'จีกแดก',
              en: 'Chik Daek',
            },
            zipcode: '32140',
          },
          321404: {
            name: {
              th: 'ตาเมียง',
              en: 'Ta Miang',
            },
            zipcode: '32140',
          },
        },
      },
      3215: {
        name: {
          th: 'ศรีณรงค์',
          en: 'King Amphoe Sri Narong',
        },
        tambons: {
          321501: {
            name: {
              th: 'ณรงค์',
              en: 'Narong',
            },
            zipcode: '32150',
          },
          321502: {
            name: {
              th: 'แจนแวน',
              en: 'Chaenwaen',
            },
            zipcode: '32150',
          },
          321503: {
            name: {
              th: 'ตรวจ',
              en: 'Truat',
            },
            zipcode: '32150',
          },
          321504: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '32150',
          },
          321505: {
            name: {
              th: 'ศรีสุข',
              en: 'Si Suk',
            },
            zipcode: '32150',
          },
        },
      },
      3216: {
        name: {
          th: 'เขวาสินรินทร์',
          en: 'Khwao Sinrin',
        },
        tambons: {
          321601: {
            name: {
              th: 'เขวาสินรินทร์',
              en: 'Khwao Sinarin',
            },
            zipcode: '32000',
          },
          321602: {
            name: {
              th: 'บึง',
              en: 'Bueng',
            },
            zipcode: '32000',
          },
          321603: {
            name: {
              th: 'ตากูก',
              en: 'Ta Kuk',
            },
            zipcode: '32000',
          },
          321604: {
            name: {
              th: 'ปราสาททอง',
              en: 'Prasat Thong',
            },
            zipcode: '32000',
          },
          321605: {
            name: {
              th: 'บ้านแร่',
              en: 'Ban Rae',
            },
            zipcode: '32000',
          },
        },
      },
      3217: {
        name: {
          th: 'โนนนารายณ์',
          en: 'King Amphoe NhonNarai',
        },
        tambons: {
          321701: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '32130',
          },
          321702: {
            name: {
              th: 'คำผง',
              en: 'Kham Phong',
            },
            zipcode: '32130',
          },
          321703: {
            name: {
              th: 'โนน',
              en: 'Non',
            },
            zipcode: '32130',
          },
          321704: {
            name: {
              th: 'ระเวียง',
              en: 'Rawiang',
            },
            zipcode: '32130',
          },
          321705: {
            name: {
              th: 'หนองเทพ',
              en: 'Nong Thep',
            },
            zipcode: '32130',
          },
        },
      },
    },
  },
  33: {
    name: {
      th: 'ศรีสะเกษ',
      en: 'Si? Sa Ket',
    },
    amphoes: {
      3301: {
        name: {
          th: 'เมืองศรีสะเกษ',
          en: 'Muang',
        },
        tambons: {
          330101: {
            name: {
              th: 'เมืองเหนือ',
              en: 'Mueang Nuea',
            },
            zipcode: '33000',
          },
          330102: {
            name: {
              th: 'เมืองใต้',
              en: 'Mueang Tai',
            },
            zipcode: '33000',
          },
          330103: {
            name: {
              th: 'คูซอด',
              en: 'Khu Sot',
            },
            zipcode: '33000',
          },
          330104: {
            name: {
              th: 'ซำ',
              en: 'Sam',
            },
            zipcode: '33000',
          },
          330105: {
            name: {
              th: 'จาน',
              en: 'Chan',
            },
            zipcode: '33000',
          },
          330106: {
            name: {
              th: 'ตะดอบ',
              en: 'Tadop',
            },
            zipcode: '33000',
          },
          330107: {
            name: {
              th: 'หนองครก',
              en: 'Nong Khrok',
            },
            zipcode: '33000',
          },
          330111: {
            name: {
              th: 'โพนข่า',
              en: 'Phon Kha',
            },
            zipcode: '33000',
          },
          330112: {
            name: {
              th: 'โพนค้อ',
              en: 'Phon Kho',
            },
            zipcode: '33000',
          },
          330115: {
            name: {
              th: 'โพนเขวา',
              en: 'Phon Khwao',
            },
            zipcode: '33000',
          },
          330116: {
            name: {
              th: 'หญ้าปล้อง',
              en: 'Ya Plong',
            },
            zipcode: '33000',
          },
          330118: {
            name: {
              th: 'ทุ่ม',
              en: 'Thum',
            },
            zipcode: '33000',
          },
          330119: {
            name: {
              th: 'หนองไฮ',
              en: 'Nong Hai',
            },
            zipcode: '33000',
          },
          330121: {
            name: {
              th: 'หนองแก้ว',
              en: 'Nong Kaeo',
            },
            zipcode: '33000',
          },
          330122: {
            name: {
              th: 'น้ำคำ',
              en: 'Nam Kham',
            },
            zipcode: '33000',
          },
          330123: {
            name: {
              th: 'โพธิ์',
              en: 'Pho',
            },
            zipcode: '33000',
          },
          330124: {
            name: {
              th: 'หมากเขียบ',
              en: 'Mak Khiap',
            },
            zipcode: '33000',
          },
          330127: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '33000',
          },
        },
      },
      3302: {
        name: {
          th: 'ยางชุมน้อย',
          en: 'Yang Chumnoi',
        },
        tambons: {
          330201: {
            name: {
              th: 'ยางชุมน้อย',
              en: 'Yang Chum Noi',
            },
            zipcode: '33190',
          },
          330202: {
            name: {
              th: 'ลิ้นฟ้า',
              en: 'Lin Fa',
            },
            zipcode: '33190',
          },
          330203: {
            name: {
              th: 'คอนกาม',
              en: 'Khon Kam',
            },
            zipcode: '33190',
          },
          330204: {
            name: {
              th: 'โนนคูณ',
              en: 'Non Khun',
            },
            zipcode: '33190',
          },
          330205: {
            name: {
              th: 'กุดเมืองฮาม',
              en: 'Kut Mueang Ham',
            },
            zipcode: '33190',
          },
          330206: {
            name: {
              th: 'บึงบอน',
              en: 'Bueng Bon',
            },
            zipcode: '33190',
          },
          330207: {
            name: {
              th: 'ยางชุมใหญ่',
              en: 'Yang Chum Yai',
            },
            zipcode: '33190',
          },
        },
      },
      3303: {
        name: {
          th: 'กันทรารมย์',
          en: 'Kanthararom',
        },
        tambons: {
          330301: {
            name: {
              th: 'ดูน',
              en: 'Dun',
            },
            zipcode: '33130',
          },
          330302: {
            name: {
              th: 'โนนสัง',
              en: 'Non Sang',
            },
            zipcode: '33130',
          },
          330303: {
            name: {
              th: 'หนองหัวช้าง',
              en: 'Nong Hua Chang',
            },
            zipcode: '33130',
          },
          330304: {
            name: {
              th: 'ยาง',
              en: 'Yang',
            },
            zipcode: '33130',
          },
          330305: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '33130',
          },
          330306: {
            name: {
              th: 'หนองแก้ว',
              en: 'Nong Kaeo',
            },
            zipcode: '33130',
          },
          330307: {
            name: {
              th: 'ทาม',
              en: 'Tham',
            },
            zipcode: '33130',
          },
          330308: {
            name: {
              th: 'ละทาย',
              en: 'Lathai',
            },
            zipcode: '33130',
          },
          330309: {
            name: {
              th: 'เมืองน้อย',
              en: 'Mueang Noi',
            },
            zipcode: '33130',
          },
          330310: {
            name: {
              th: 'อีปาด',
              en: 'I Pat',
            },
            zipcode: '33130',
          },
          330311: {
            name: {
              th: 'บัวน้อย',
              en: 'Bua Noi',
            },
            zipcode: '33130',
          },
          330312: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '33130',
          },
          330313: {
            name: {
              th: 'ดู่',
              en: 'Du',
            },
            zipcode: '33130',
          },
          330314: {
            name: {
              th: 'ผักแพว',
              en: 'Phak Phaeo',
            },
            zipcode: '33130',
          },
          330315: {
            name: {
              th: 'จาน',
              en: 'Chan',
            },
            zipcode: '33130',
          },
          330320: {
            name: {
              th: 'คำเนียม',
              en: 'Kham Niam',
            },
            zipcode: '33130',
          },
        },
      },
      3304: {
        name: {
          th: 'กันทรลักษ์',
          en: 'Kantharalak',
        },
        tambons: {
          330401: {
            name: {
              th: 'บึงมะลู',
              en: 'Bueng Malu',
            },
            zipcode: '33110',
          },
          330402: {
            name: {
              th: 'กุดเสลา',
              en: 'Kut Salao',
            },
            zipcode: '33110',
          },
          330403: {
            name: {
              th: 'เมือง',
              en: 'Mueang',
            },
            zipcode: '33110',
          },
          330405: {
            name: {
              th: 'สังเม็ก',
              en: 'Sang Mek',
            },
            zipcode: '33110',
          },
          330406: {
            name: {
              th: 'น้ำอ้อม',
              en: 'Nam Om',
            },
            zipcode: '33110',
          },
          330407: {
            name: {
              th: 'ละลาย',
              en: 'Lalai',
            },
            zipcode: '33110',
          },
          330408: {
            name: {
              th: 'รุง',
              en: 'Rung',
            },
            zipcode: '33110',
          },
          330409: {
            name: {
              th: 'ตระกาจ',
              en: 'Trakat',
            },
            zipcode: '33110',
          },
          330411: {
            name: {
              th: 'จานใหญ่',
              en: 'Chan Yai',
            },
            zipcode: '33110',
          },
          330412: {
            name: {
              th: 'ภูเงิน',
              en: 'Phu Ngoen',
            },
            zipcode: '33110',
          },
          330413: {
            name: {
              th: 'ชำ',
              en: 'Cham',
            },
            zipcode: '33110',
          },
          330414: {
            name: {
              th: 'กระแชง',
              en: 'Krachaeng',
            },
            zipcode: '33110',
          },
          330415: {
            name: {
              th: 'โนนสำราญ',
              en: 'Non Samran',
            },
            zipcode: '33110',
          },
          330416: {
            name: {
              th: 'หนองหญ้าลาด',
              en: 'Nong Ya Lat',
            },
            zipcode: '33110',
          },
          330419: {
            name: {
              th: 'เสาธงชัย',
              en: 'Sao Thong Chai',
            },
            zipcode: '33110',
          },
          330420: {
            name: {
              th: 'ขนุน',
              en: 'Khanun',
            },
            zipcode: '33110',
          },
          330421: {
            name: {
              th: 'สวนกล้วย',
              en: 'Suan Kluai',
            },
            zipcode: '33110',
          },
          330423: {
            name: {
              th: 'เวียงเหนือ',
              en: 'Wiang Nuea',
            },
            zipcode: '33110',
          },
          330424: {
            name: {
              th: 'ทุ่งใหญ่',
              en: 'Thung Yai',
            },
            zipcode: '33110',
          },
          330425: {
            name: {
              th: 'ภูผาหมอก',
              en: 'Phu Pha Mok',
            },
            zipcode: '33110',
          },
        },
      },
      3305: {
        name: {
          th: 'ขุขันธ์',
          en: 'Khukhan',
        },
        tambons: {
          330501: {
            name: {
              th: 'กันทรารมย์',
              en: 'Kanthararom',
            },
            zipcode: '33140',
          },
          330502: {
            name: {
              th: 'จะกง',
              en: 'Chakong',
            },
            zipcode: '33140',
          },
          330503: {
            name: {
              th: 'ใจดี',
              en: 'Chai Di',
            },
            zipcode: '33140',
          },
          330504: {
            name: {
              th: 'ดองกำเม็ด',
              en: 'Dong Kam Met',
            },
            zipcode: '33140',
          },
          330505: {
            name: {
              th: 'โสน',
              en: 'Sano',
            },
            zipcode: '33140',
          },
          330506: {
            name: {
              th: 'ปรือใหญ่',
              en: 'Prue Yai',
            },
            zipcode: '33140',
          },
          330507: {
            name: {
              th: 'สะเดาใหญ่',
              en: 'Sadao Yai',
            },
            zipcode: '33140',
          },
          330508: {
            name: {
              th: 'ตาอุด',
              en: 'Ta Ut',
            },
            zipcode: '33140',
          },
          330509: {
            name: {
              th: 'ห้วยเหนือ',
              en: 'Huai Nuea',
            },
            zipcode: '33140',
          },
          330510: {
            name: {
              th: 'ห้วยใต้',
              en: 'Huai Tai',
            },
            zipcode: '33140',
          },
          330511: {
            name: {
              th: 'หัวเสือ',
              en: 'Hua Suea',
            },
            zipcode: '33140',
          },
          330513: {
            name: {
              th: 'ตะเคียน',
              en: 'Takhian',
            },
            zipcode: '33140',
          },
          330515: {
            name: {
              th: 'นิคมพัฒนา',
              en: 'Nikhom Phatthana',
            },
            zipcode: '33140',
          },
          330517: {
            name: {
              th: 'โคกเพชร',
              en: 'Khok Phet',
            },
            zipcode: '33140',
          },
          330518: {
            name: {
              th: 'ปราสาท',
              en: 'Prasat',
            },
            zipcode: '33140',
          },
          330521: {
            name: {
              th: 'สำโรงตาเจ็น',
              en: 'Samrong Ta Chen',
            },
            zipcode: '33140',
          },
          330522: {
            name: {
              th: 'ห้วยสำราญ',
              en: 'Huai Samran',
            },
            zipcode: '33140',
          },
          330524: {
            name: {
              th: 'กฤษณา',
              en: 'Kritsana',
            },
            zipcode: '33140',
          },
          330525: {
            name: {
              th: 'ลมศักดิ์',
              en: 'Lom Sak',
            },
            zipcode: '33140',
          },
          330526: {
            name: {
              th: 'หนองฉลอง',
              en: 'Nong Chalong',
            },
            zipcode: '33140',
          },
          330527: {
            name: {
              th: 'ศรีตระกูล',
              en: 'Si Trakun',
            },
            zipcode: '33140',
          },
          330528: {
            name: {
              th: 'ศรีสะอาด',
              en: 'Si Sa-at',
            },
            zipcode: '33140',
          },
        },
      },
      3306: {
        name: {
          th: 'ไพรบึง',
          en: 'PhraiBung',
        },
        tambons: {
          330601: {
            name: {
              th: 'ไพรบึง',
              en: 'Phrai Bueng',
            },
            zipcode: '33180',
          },
          330602: {
            name: {
              th: 'ดินแดง',
              en: 'Din Daeng',
            },
            zipcode: '33180',
          },
          330603: {
            name: {
              th: 'ปราสาทเยอ',
              en: 'Prasat Yoe',
            },
            zipcode: '33180',
          },
          330604: {
            name: {
              th: 'สำโรงพลัน',
              en: 'Samrong Phlan',
            },
            zipcode: '33180',
          },
          330605: {
            name: {
              th: 'สุขสวัสดิ์',
              en: 'Suk Sawat',
            },
            zipcode: '33180',
          },
          330606: {
            name: {
              th: 'โนนปูน',
              en: 'Non Pun',
            },
            zipcode: '33180',
          },
        },
      },
      3307: {
        name: {
          th: 'ปรางค์กู่',
          en: 'PrangKu',
        },
        tambons: {
          330701: {
            name: {
              th: 'พิมาย',
              en: 'Phimai',
            },
            zipcode: '33170',
          },
          330702: {
            name: {
              th: 'กู่',
              en: 'Ku',
            },
            zipcode: '33170',
          },
          330703: {
            name: {
              th: 'หนองเชียงทูน',
              en: 'Nong Chiang Thun',
            },
            zipcode: '33170',
          },
          330704: {
            name: {
              th: 'ตูม',
              en: 'Tum',
            },
            zipcode: '33170',
          },
          330705: {
            name: {
              th: 'สมอ',
              en: 'Samo',
            },
            zipcode: '33170',
          },
          330706: {
            name: {
              th: 'โพธิ์ศรี',
              en: 'Pho Si',
            },
            zipcode: '33170',
          },
          330707: {
            name: {
              th: 'สำโรงปราสาท',
              en: 'Samrong Prasat',
            },
            zipcode: '33170',
          },
          330708: {
            name: {
              th: 'ดู่',
              en: 'Du',
            },
            zipcode: '33170',
          },
          330709: {
            name: {
              th: 'สวาย',
              en: 'Sawai',
            },
            zipcode: '33170',
          },
          330710: {
            name: {
              th: 'พิมายเหนือ',
              en: 'Phimai Nuea',
            },
            zipcode: '33170',
          },
        },
      },
      3308: {
        name: {
          th: 'ขุนหาญ',
          en: 'KhunHan',
        },
        tambons: {
          330801: {
            name: {
              th: 'สิ',
              en: 'Si',
            },
            zipcode: '33150',
          },
          330802: {
            name: {
              th: 'บักดอง',
              en: 'Bak Dong',
            },
            zipcode: '33150',
          },
          330803: {
            name: {
              th: 'พราน',
              en: 'Phran',
            },
            zipcode: '33150',
          },
          330804: {
            name: {
              th: 'โพธิ์วงศ์',
              en: 'Pho Wong',
            },
            zipcode: '33150',
          },
          330805: {
            name: {
              th: 'ไพร',
              en: 'Phrai',
            },
            zipcode: '33150',
          },
          330806: {
            name: {
              th: 'กระหวัน',
              en: 'Krawan',
            },
            zipcode: '33150',
          },
          330807: {
            name: {
              th: 'ขุนหาญ',
              en: 'Khun Han',
            },
            zipcode: '33150',
          },
          330808: {
            name: {
              th: 'โนนสูง',
              en: 'Non Sung',
            },
            zipcode: '33150',
          },
          330809: {
            name: {
              th: 'กันทรอม',
              en: 'Kanthrom',
            },
            zipcode: '33150',
          },
          330810: {
            name: {
              th: 'ภูฝ้าย',
              en: 'Phu Fai',
            },
            zipcode: '33150',
          },
          330811: {
            name: {
              th: 'โพธิ์กระสังข์',
              en: 'Pho Krasang',
            },
            zipcode: '33150',
          },
          330812: {
            name: {
              th: 'ห้วยจันทร์',
              en: 'Huai Chan',
            },
            zipcode: '33150',
          },
        },
      },
      3309: {
        name: {
          th: 'ราษีไศล',
          en: 'RasiSalai',
        },
        tambons: {
          330901: {
            name: {
              th: 'เมืองคง',
              en: 'Mueang Khong',
            },
            zipcode: '33160',
          },
          330902: {
            name: {
              th: 'เมืองแคน',
              en: 'Mueang Khaen',
            },
            zipcode: '33160',
          },
          330903: {
            name: {
              th: 'หนองแค',
              en: 'Nong Khae',
            },
            zipcode: '33160',
          },
          330906: {
            name: {
              th: 'จิกสังข์ทอง',
              en: 'Chik Sang Thong',
            },
            zipcode: '33160',
          },
          330907: {
            name: {
              th: 'ด่าน',
              en: 'Dan',
            },
            zipcode: '33160',
          },
          330908: {
            name: {
              th: 'ดู่',
              en: 'Du',
            },
            zipcode: '33160',
          },
          330909: {
            name: {
              th: 'หนองอึ่ง',
              en: 'Nong Ueng',
            },
            zipcode: '33160',
          },
          330910: {
            name: {
              th: 'บัวหุ่ง',
              en: 'Bua Hung',
            },
            zipcode: '33160',
          },
          330911: {
            name: {
              th: 'ไผ่',
              en: 'Phai',
            },
            zipcode: '33160',
          },
          330912: {
            name: {
              th: 'ส้มป่อย',
              en: 'Som Poi',
            },
            zipcode: '33160',
          },
          330913: {
            name: {
              th: 'หนองหมี',
              en: 'Nong Mi',
            },
            zipcode: '33160',
          },
          330914: {
            name: {
              th: 'หว้านคำ',
              en: 'Wan Kham',
            },
            zipcode: '33160',
          },
          330915: {
            name: {
              th: 'สร้างปี่',
              en: 'Sang Pi',
            },
            zipcode: '33160',
          },
        },
      },
      3310: {
        name: {
          th: 'อุทุมพรพิสัย',
          en: 'UthumphonPhisai',
        },
        tambons: {
          331001: {
            name: {
              th: 'กำแพง',
              en: 'Kamphaeng',
            },
            zipcode: '33120',
          },
          331002: {
            name: {
              th: 'อี่หล่ำ',
              en: 'I Lam',
            },
            zipcode: '33120',
          },
          331003: {
            name: {
              th: 'ก้านเหลือง',
              en: 'Kan Lueang',
            },
            zipcode: '33120',
          },
          331004: {
            name: {
              th: 'ทุ่งไชย',
              en: 'Thung Chai',
            },
            zipcode: '33120',
          },
          331005: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '33120',
          },
          331006: {
            name: {
              th: 'แขม',
              en: 'Khaem',
            },
            zipcode: '33120',
          },
          331007: {
            name: {
              th: 'หนองไฮ',
              en: 'Nong Hai',
            },
            zipcode: '33120',
          },
          331008: {
            name: {
              th: 'ขะยูง',
              en: 'Khayung',
            },
            zipcode: '33120',
          },
          331010: {
            name: {
              th: 'ตาเกษ',
              en: 'Ta Ket',
            },
            zipcode: '33120',
          },
          331011: {
            name: {
              th: 'หัวช้าง',
              en: 'Hua Chang',
            },
            zipcode: '33120',
          },
          331012: {
            name: {
              th: 'รังแร้ง',
              en: 'Rang Raeng',
            },
            zipcode: '33120',
          },
          331014: {
            name: {
              th: 'แต้',
              en: 'Tae',
            },
            zipcode: '33120',
          },
          331015: {
            name: {
              th: 'แข้',
              en: 'Khae',
            },
            zipcode: '33120',
          },
          331016: {
            name: {
              th: 'โพธิ์ชัย',
              en: 'Pho Chai',
            },
            zipcode: '33120',
          },
          331017: {
            name: {
              th: 'ปะอาว',
              en: 'Pa Ao',
            },
            zipcode: '33120',
          },
          331018: {
            name: {
              th: 'หนองห้าง',
              en: 'Nong Hang',
            },
            zipcode: '33120',
          },
          331022: {
            name: {
              th: 'สระกำแพงใหญ่',
              en: 'Sa Kamphaeng Yai',
            },
            zipcode: '33120',
          },
          331024: {
            name: {
              th: 'โคกหล่าม',
              en: 'Khok Lam',
            },
            zipcode: '33120',
          },
          331025: {
            name: {
              th: 'โคกจาน',
              en: 'Khok Chan',
            },
            zipcode: '33120',
          },
        },
      },
      3311: {
        name: {
          th: 'บึงบูรพ์',
          en: 'BangBun',
        },
        tambons: {
          331101: {
            name: {
              th: 'เป๊าะ',
              en: 'Po',
            },
            zipcode: '33220',
          },
          331102: {
            name: {
              th: 'บึงบูรพ์',
              en: 'Bueng Bun',
            },
            zipcode: '33220',
          },
        },
      },
      3312: {
        name: {
          th: 'ห้วยทับทัน',
          en: 'HuaiThap Than',
        },
        tambons: {
          331201: {
            name: {
              th: 'ห้วยทับทัน',
              en: 'Huai Thap Than',
            },
            zipcode: '33210',
          },
          331202: {
            name: {
              th: 'เมืองหลวง',
              en: 'Mueang Luang',
            },
            zipcode: '33210',
          },
          331203: {
            name: {
              th: 'กล้วยกว้าง',
              en: 'Kluai Kwang',
            },
            zipcode: '33210',
          },
          331204: {
            name: {
              th: 'ผักไหม',
              en: 'Phak Mai',
            },
            zipcode: '33210',
          },
          331205: {
            name: {
              th: 'จานแสนไชย',
              en: 'Chan Saen Chai',
            },
            zipcode: '33210',
          },
          331206: {
            name: {
              th: 'ปราสาท',
              en: 'Prasat',
            },
            zipcode: '33210',
          },
        },
      },
      3313: {
        name: {
          th: 'โนนคูณ',
          en: 'Non Khun',
        },
        tambons: {
          331301: {
            name: {
              th: 'โนนค้อ',
              en: 'Non Kho',
            },
            zipcode: '33250',
          },
          331302: {
            name: {
              th: 'บก',
              en: 'Bok',
            },
            zipcode: '33250',
          },
          331303: {
            name: {
              th: 'โพธิ์',
              en: 'Pho',
            },
            zipcode: '33250',
          },
          331304: {
            name: {
              th: 'หนองกุง',
              en: 'Nong Kung',
            },
            zipcode: '33250',
          },
          331305: {
            name: {
              th: 'เหล่ากวาง',
              en: 'Lao Kwang',
            },
            zipcode: '33250',
          },
        },
      },
      3314: {
        name: {
          th: 'ศรีรัตนะ',
          en: 'Sri Ratana',
        },
        tambons: {
          331401: {
            name: {
              th: 'ศรีแก้ว',
              en: 'Si Kaeo',
            },
            zipcode: '33240',
          },
          331402: {
            name: {
              th: 'พิงพวย',
              en: 'Phing Phuai',
            },
            zipcode: '33240',
          },
          331403: {
            name: {
              th: 'สระเยาว์',
              en: 'Sa Yao',
            },
            zipcode: '33240',
          },
          331404: {
            name: {
              th: 'ตูม',
              en: 'Tum',
            },
            zipcode: '33240',
          },
          331405: {
            name: {
              th: 'เสื่องข้าว',
              en: 'Sueang Khao',
            },
            zipcode: '33240',
          },
          331406: {
            name: {
              th: 'ศรีโนนงาม',
              en: 'Si Non Ngam',
            },
            zipcode: '33240',
          },
          331407: {
            name: {
              th: 'สะพุง',
              en: 'Saphung',
            },
            zipcode: '33240',
          },
        },
      },
      3315: {
        name: {
          th: 'น้ำเกลี้ยง',
          en: 'Nam Kliang',
        },
        tambons: {
          331501: {
            name: {
              th: 'น้ำเกลี้ยง',
              en: 'Nam Kliang',
            },
            zipcode: '33130',
          },
          331502: {
            name: {
              th: 'ละเอาะ',
              en: 'La-o',
            },
            zipcode: '33130',
          },
          331503: {
            name: {
              th: 'ตองปิด',
              en: 'Tong Pit',
            },
            zipcode: '33130',
          },
          331504: {
            name: {
              th: 'เขิน',
              en: 'Khoen',
            },
            zipcode: '33130',
          },
          331505: {
            name: {
              th: 'รุ่งระวี',
              en: 'Rung Rawi',
            },
            zipcode: '33130',
          },
          331506: {
            name: {
              th: 'คูบ',
              en: 'Khup',
            },
            zipcode: '33130',
          },
        },
      },
      3316: {
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        tambons: {
          331601: {
            name: {
              th: 'บุสูง',
              en: 'Bu Sung',
            },
            zipcode: '33270',
          },
          331602: {
            name: {
              th: 'ธาตุ',
              en: 'That',
            },
            zipcode: '33270',
          },
          331603: {
            name: {
              th: 'ดวนใหญ่',
              en: 'Duan Yai',
            },
            zipcode: '33270',
          },
          331604: {
            name: {
              th: 'บ่อแก้ว',
              en: 'Bo Kaeo',
            },
            zipcode: '33270',
          },
          331605: {
            name: {
              th: 'ศรีสำราญ',
              en: 'Si Samran',
            },
            zipcode: '33270',
          },
          331606: {
            name: {
              th: 'ทุ่งสว่าง',
              en: 'Thung Sawang',
            },
            zipcode: '33270',
          },
          331607: {
            name: {
              th: 'วังหิน',
              en: 'Wang Hin',
            },
            zipcode: '33270',
          },
          331608: {
            name: {
              th: 'โพนยาง',
              en: 'Phon Yang',
            },
            zipcode: '33270',
          },
        },
      },
      3317: {
        name: {
          th: 'ภูสิงห์',
          en: 'Phu Sing',
        },
        tambons: {
          331701: {
            name: {
              th: 'โคกตาล',
              en: 'Khok Tan',
            },
            zipcode: '33140',
          },
          331702: {
            name: {
              th: 'ห้วยตามอญ',
              en: 'Huai Ta Mon',
            },
            zipcode: '33140',
          },
          331703: {
            name: {
              th: 'ห้วยตึ๊กชู',
              en: 'Huai Tuekchu',
            },
            zipcode: '33140',
          },
          331704: {
            name: {
              th: 'ละลม',
              en: 'Lalom',
            },
            zipcode: '33140',
          },
          331705: {
            name: {
              th: 'ตะเคียนราม',
              en: 'Takhian Ram',
            },
            zipcode: '33140',
          },
          331706: {
            name: {
              th: 'ดงรัก',
              en: 'Dong Rak',
            },
            zipcode: '33140',
          },
          331707: {
            name: {
              th: 'ไพรพัฒนา',
              en: 'Phrai Phatthana',
            },
            zipcode: '33140',
          },
        },
      },
      3318: {
        name: {
          th: 'เมืองจันทร์',
          en: 'Muang Chan',
        },
        tambons: {
          331801: {
            name: {
              th: 'เมืองจันทร์',
              en: 'Mueang Chan',
            },
            zipcode: '33120',
          },
          331802: {
            name: {
              th: 'ตาโกน',
              en: 'Ta Kon',
            },
            zipcode: '33120',
          },
          331803: {
            name: {
              th: 'หนองใหญ่',
              en: 'Nong Yai',
            },
            zipcode: '33120',
          },
        },
      },
      3319: {
        name: {
          th: 'เบญจลักษ์',
          en: 'Benjalak',
        },
        tambons: {
          331901: {
            name: {
              th: 'เสียว',
              en: 'Siao',
            },
            zipcode: '33110',
          },
          331902: {
            name: {
              th: 'หนองหว้า',
              en: 'Nong Wa',
            },
            zipcode: '33110',
          },
          331903: {
            name: {
              th: 'หนองงูเหลือม',
              en: 'Nong Ngu Lueam',
            },
            zipcode: '33110',
          },
          331904: {
            name: {
              th: 'หนองฮาง',
              en: 'Nong Hang',
            },
            zipcode: '33110',
          },
          331905: {
            name: {
              th: 'ท่าคล้อ',
              en: 'Tha Khlo',
            },
            zipcode: '33110',
          },
        },
      },
      3320: {
        name: {
          th: 'พยุห์',
          en: 'Phayu',
        },
        tambons: {
          332001: {
            name: {
              th: 'พยุห์',
              en: 'Phayu',
            },
            zipcode: '33230',
          },
          332002: {
            name: {
              th: 'พรหมสวัสดิ์',
              en: 'Phrom Sawat',
            },
            zipcode: '33230',
          },
          332003: {
            name: {
              th: 'ตำแย',
              en: 'Tamyae',
            },
            zipcode: '33230',
          },
          332004: {
            name: {
              th: 'โนนเพ็ก',
              en: 'Non Phek',
            },
            zipcode: '33230',
          },
          332005: {
            name: {
              th: 'หนองค้า',
              en: 'Nong Kha',
            },
            zipcode: '33230',
          },
        },
      },
      3321: {
        name: {
          th: 'โพธิ์ศรีสุวรรณ',
          en: 'King Amphoe PhoSiSuwan',
        },
        tambons: {
          332101: {
            name: {
              th: 'โดด',
              en: 'Dot',
            },
            zipcode: '33120',
          },
          332102: {
            name: {
              th: 'เสียว',
              en: 'Siao',
            },
            zipcode: '33120',
          },
          332103: {
            name: {
              th: 'หนองม้า',
              en: 'Nong Ma',
            },
            zipcode: '33120',
          },
          332104: {
            name: {
              th: 'ผือใหญ่',
              en: 'Phue Yai',
            },
            zipcode: '33120',
          },
          332105: {
            name: {
              th: 'อีเซ',
              en: 'I Se',
            },
            zipcode: '33120',
          },
        },
      },
      3322: {
        name: {
          th: 'ศิลาลาด',
          en: 'King Amphoe SilaLat',
        },
        tambons: {
          332201: {
            name: {
              th: 'กุง',
              en: 'Kung',
            },
            zipcode: '33160',
          },
          332202: {
            name: {
              th: 'คลีกลิ้ง',
              en: 'Khli Kling',
            },
            zipcode: '33160',
          },
          332203: {
            name: {
              th: 'หนองบัวดง',
              en: 'Nong Bua Dong',
            },
            zipcode: '33160',
          },
          332204: {
            name: {
              th: 'โจดม่วง',
              en: 'Chot Muang',
            },
            zipcode: '33160',
          },
        },
      },
    },
  },
  34: {
    name: {
      th: 'อุบลราชธานี',
      en: 'Ubon Ratchathani',
    },
    amphoes: {
      3401: {
        name: {
          th: 'เมืองอุบลราชธานี',
          en: 'Muang',
        },
        tambons: {
          340101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '34000',
          },
          340104: {
            name: {
              th: 'หัวเรือ',
              en: 'Hua Ruea',
            },
            zipcode: '34000',
          },
          340105: {
            name: {
              th: 'หนองขอน',
              en: 'Nong Khon',
            },
            zipcode: '34000',
          },
          340107: {
            name: {
              th: 'ปทุม',
              en: 'Pathum',
            },
            zipcode: '34000',
          },
          340108: {
            name: {
              th: 'ขามใหญ่',
              en: 'Kham Yai',
            },
            zipcode: '34000',
          },
          340109: {
            name: {
              th: 'แจระแม',
              en: 'Chaeramae',
            },
            zipcode: '34000',
          },
          340111: {
            name: {
              th: 'หนองบ่อ',
              en: 'Nong Bo',
            },
            zipcode: '34000',
          },
          340112: {
            name: {
              th: 'ไร่น้อย',
              en: 'Rai Noi',
            },
            zipcode: '34000',
          },
          340113: {
            name: {
              th: 'กระโสบ',
              en: 'Krasop',
            },
            zipcode: '34000',
          },
          340116: {
            name: {
              th: 'กุดลาด',
              en: 'Ku Talat',
            },
            zipcode: '34000',
          },
          340119: {
            name: {
              th: 'ขี้เหล็ก',
              en: 'Khilek',
            },
            zipcode: '34000',
          },
          340120: {
            name: {
              th: 'ปะอาว',
              en: 'Pa Ao',
            },
            zipcode: '34000',
          },
        },
      },
      3402: {
        name: {
          th: 'ศรีเมืองใหม่',
          en: 'Si Muang Mai',
        },
        tambons: {
          340201: {
            name: {
              th: 'นาคำ',
              en: 'Na Kham',
            },
            zipcode: '34250',
          },
          340202: {
            name: {
              th: 'แก้งกอก',
              en: 'Kaeng Kok',
            },
            zipcode: '34250',
          },
          340203: {
            name: {
              th: 'เอือดใหญ่',
              en: 'Ueat Yai',
            },
            zipcode: '34250',
          },
          340204: {
            name: {
              th: 'วาริน',
              en: 'Warin',
            },
            zipcode: '34250',
          },
          340205: {
            name: {
              th: 'ลาดควาย',
              en: 'Lat Khwai',
            },
            zipcode: '34250',
          },
          340206: {
            name: {
              th: 'สงยาง',
              en: 'Song Yang',
            },
            zipcode: '34250',
          },
          340207: {
            name: {
              th: 'ตะบ่าย',
              en: 'Ta Bai',
            },
            zipcode: '34250',
          },
          340208: {
            name: {
              th: 'คำไหล',
              en: 'Kham Lai',
            },
            zipcode: '34250',
          },
          340209: {
            name: {
              th: 'หนามแท่ง',
              en: 'Nam Thaeng',
            },
            zipcode: '34250',
          },
          340210: {
            name: {
              th: 'นาเลิน',
              en: 'Na Loen',
            },
            zipcode: '34250',
          },
          340211: {
            name: {
              th: 'ดอนใหญ่',
              en: 'Don Yai',
            },
            zipcode: '34250',
          },
        },
      },
      3403: {
        name: {
          th: 'โขงเจียม',
          en: 'Khong Chiam',
        },
        tambons: {
          340301: {
            name: {
              th: 'โขงเจียม',
              en: 'Khong Chiam',
            },
            zipcode: '34220',
          },
          340302: {
            name: {
              th: 'ห้วยยาง',
              en: 'Huai Yang',
            },
            zipcode: '34220',
          },
          340303: {
            name: {
              th: 'นาโพธิ์กลาง',
              en: 'Na Pho Klang',
            },
            zipcode: '34220',
          },
          340304: {
            name: {
              th: 'หนองแสงใหญ่',
              en: 'Nong Saeng Yai',
            },
            zipcode: '34220',
          },
          340305: {
            name: {
              th: 'ห้วยไผ่',
              en: 'Huai Phai',
            },
            zipcode: '34220',
          },
          340306: {
            name: {
              th: 'คำเขื่อนแก้ว',
              en: 'Kham Khuean Kaeo',
            },
            zipcode: '34220',
          },
        },
      },
      3404: {
        name: {
          th: 'เขื่องใน',
          en: 'Khuang Nai',
        },
        tambons: {
          340401: {
            name: {
              th: 'เขื่องใน',
              en: 'Khueang Nai',
            },
            zipcode: '34150',
          },
          340402: {
            name: {
              th: 'สร้างถ่อ',
              en: 'Sang Tho',
            },
            zipcode: '34150',
          },
          340403: {
            name: {
              th: 'ค้อทอง',
              en: 'Kho Thong',
            },
            zipcode: '34150',
          },
          340404: {
            name: {
              th: 'ก่อเอ้',
              en: 'Ko E',
            },
            zipcode: '34150',
          },
          340405: {
            name: {
              th: 'หัวดอน',
              en: 'Hua Don',
            },
            zipcode: '34150',
          },
          340406: {
            name: {
              th: 'ชีทวน',
              en: 'Chi Thuan',
            },
            zipcode: '34150',
          },
          340407: {
            name: {
              th: 'ท่าไห',
              en: 'Tha Hai',
            },
            zipcode: '34150',
          },
          340408: {
            name: {
              th: 'นาคำใหญ่',
              en: 'Na Kham Yai',
            },
            zipcode: '34150',
          },
          340409: {
            name: {
              th: 'แดงหม้อ',
              en: 'Daeng Mo',
            },
            zipcode: '34150',
          },
          340410: {
            name: {
              th: 'ธาตุน้อย',
              en: 'That Noi',
            },
            zipcode: '34150',
          },
          340411: {
            name: {
              th: 'บ้านไทย',
              en: 'Ban Thai',
            },
            zipcode: '34320',
          },
          340412: {
            name: {
              th: 'บ้านกอก',
              en: 'Ban Kok',
            },
            zipcode: '34320',
          },
          340413: {
            name: {
              th: 'กลางใหญ่',
              en: 'Klang Yai',
            },
            zipcode: '34320',
          },
          340414: {
            name: {
              th: 'โนนรัง',
              en: 'Non Rang',
            },
            zipcode: '34320',
          },
          340415: {
            name: {
              th: 'ยางขี้นก',
              en: 'Yang Khi Nok',
            },
            zipcode: '34150',
          },
          340416: {
            name: {
              th: 'ศรีสุข',
              en: 'Si Suk',
            },
            zipcode: '34150',
          },
          340417: {
            name: {
              th: 'สหธาตุ',
              en: 'Sahathat',
            },
            zipcode: '34150',
          },
          340418: {
            name: {
              th: 'หนองเหล่า',
              en: 'Nong Lao',
            },
            zipcode: '34150',
          },
        },
      },
      3405: {
        name: {
          th: 'เขมราฐ',
          en: 'Khemarat',
        },
        tambons: {
          340501: {
            name: {
              th: 'เขมราฐ',
              en: 'Khemarat',
            },
            zipcode: '34170',
          },
          340503: {
            name: {
              th: 'ขามป้อม',
              en: 'Kham Pom',
            },
            zipcode: '34170',
          },
          340504: {
            name: {
              th: 'เจียด',
              en: 'Chiat',
            },
            zipcode: '34170',
          },
          340507: {
            name: {
              th: 'หนองผือ',
              en: 'Nong Phue',
            },
            zipcode: '34170',
          },
          340508: {
            name: {
              th: 'นาแวง',
              en: 'Na Waeng',
            },
            zipcode: '34170',
          },
          340510: {
            name: {
              th: 'แก้งเหนือ',
              en: 'Kaeng Nuea',
            },
            zipcode: '34170',
          },
          340511: {
            name: {
              th: 'หนองนกทา',
              en: 'Nong Nok Tha',
            },
            zipcode: '34170',
          },
          340512: {
            name: {
              th: 'หนองสิม',
              en: 'Nong Sim',
            },
            zipcode: '34170',
          },
          340513: {
            name: {
              th: 'หัวนา',
              en: 'Hua Na',
            },
            zipcode: '34170',
          },
        },
      },
      3407: {
        name: {
          th: 'เดชอุดม',
          en: 'Det Udom',
        },
        tambons: {
          340701: {
            name: {
              th: 'เมืองเดช',
              en: 'Mueang Det',
            },
            zipcode: '34160',
          },
          340702: {
            name: {
              th: 'นาส่วง',
              en: 'Na Suang',
            },
            zipcode: '34160',
          },
          340704: {
            name: {
              th: 'นาเจริญ',
              en: 'Na Charoen',
            },
            zipcode: '34160',
          },
          340706: {
            name: {
              th: 'ทุ่งเทิง',
              en: 'Thung Thoeng',
            },
            zipcode: '34160',
          },
          340708: {
            name: {
              th: 'สมสะอาด',
              en: 'Som Sa-at',
            },
            zipcode: '34160',
          },
          340709: {
            name: {
              th: 'กุดประทาย',
              en: 'Kut Prathai',
            },
            zipcode: '34160',
          },
          340710: {
            name: {
              th: 'ตบหู',
              en: 'Top Hu',
            },
            zipcode: '34160',
          },
          340711: {
            name: {
              th: 'กลาง',
              en: 'Klang',
            },
            zipcode: '34160',
          },
          340712: {
            name: {
              th: 'แก้ง',
              en: 'Kaeng',
            },
            zipcode: '34160',
          },
          340713: {
            name: {
              th: 'ท่าโพธิ์ศรี',
              en: 'Tha Pho Si',
            },
            zipcode: '34160',
          },
          340715: {
            name: {
              th: 'บัวงาม',
              en: 'Bua Ngam',
            },
            zipcode: '34160',
          },
          340716: {
            name: {
              th: 'คำครั่ง',
              en: 'Kham Khrang',
            },
            zipcode: '34160',
          },
          340717: {
            name: {
              th: 'นากระแซง',
              en: 'Na Krasaeng',
            },
            zipcode: '34160',
          },
          340720: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '34160',
          },
          340721: {
            name: {
              th: 'ป่าโมง',
              en: 'Pa Mong',
            },
            zipcode: '34160',
          },
          340723: {
            name: {
              th: 'โนนสมบูรณ์',
              en: 'Non Sombun',
            },
            zipcode: '34160',
          },
        },
      },
      3408: {
        name: {
          th: 'นาจะหลวย',
          en: 'Na Chaluai',
        },
        tambons: {
          340801: {
            name: {
              th: 'นาจะหลวย',
              en: 'Na Chaluai',
            },
            zipcode: '34280',
          },
          340802: {
            name: {
              th: 'โนนสมบูรณ์',
              en: 'Non Sombun',
            },
            zipcode: '34280',
          },
          340803: {
            name: {
              th: 'พรสวรรค์',
              en: 'Phon Sawan',
            },
            zipcode: '34280',
          },
          340804: {
            name: {
              th: 'บ้านตูม',
              en: 'Ban Tum',
            },
            zipcode: '34280',
          },
          340805: {
            name: {
              th: 'โสกแสง',
              en: 'Sok Saeng',
            },
            zipcode: '34280',
          },
          340806: {
            name: {
              th: 'โนนสวรรค์',
              en: 'Non Sawan',
            },
            zipcode: '34280',
          },
        },
      },
      3409: {
        name: {
          th: 'น้ำยืน',
          en: 'Nam Yun',
        },
        tambons: {
          340901: {
            name: {
              th: 'โซง',
              en: 'Song',
            },
            zipcode: '34260',
          },
          340903: {
            name: {
              th: 'ยาง',
              en: 'Yang',
            },
            zipcode: '34260',
          },
          340904: {
            name: {
              th: 'โดมประดิษฐ์',
              en: 'Dom Pradit',
            },
            zipcode: '34260',
          },
          340906: {
            name: {
              th: 'บุเปือย',
              en: 'Bu Pueai',
            },
            zipcode: '34260',
          },
          340907: {
            name: {
              th: 'สีวิเชียร',
              en: 'Si Wichian',
            },
            zipcode: '34260',
          },
          340909: {
            name: {
              th: 'ยางใหญ่',
              en: 'Yang Yai',
            },
            zipcode: '34260',
          },
          340911: {
            name: {
              th: 'เก่าขาม',
              en: 'Kao Kham',
            },
            zipcode: '34260',
          },
        },
      },
      3410: {
        name: {
          th: 'บุณฑริก',
          en: 'Buntharik',
        },
        tambons: {
          341001: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '34230',
          },
          341002: {
            name: {
              th: 'ห้วยข่า',
              en: 'Huai Kha',
            },
            zipcode: '34230',
          },
          341003: {
            name: {
              th: 'คอแลน',
              en: 'Kho Laen',
            },
            zipcode: '34230',
          },
          341004: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '34230',
          },
          341005: {
            name: {
              th: 'หนองสะโน',
              en: 'Nong Sano',
            },
            zipcode: '34230',
          },
          341006: {
            name: {
              th: 'โนนค้อ',
              en: 'Non Kho',
            },
            zipcode: '34230',
          },
          341007: {
            name: {
              th: 'บัวงาม',
              en: 'Bua Ngam',
            },
            zipcode: '34230',
          },
          341008: {
            name: {
              th: 'บ้านแมด',
              en: 'Ban Maet',
            },
            zipcode: '34230',
          },
        },
      },
      3411: {
        name: {
          th: 'ตระการพืชผล',
          en: 'Trakan Phutphon',
        },
        tambons: {
          341101: {
            name: {
              th: 'ขุหลุ',
              en: 'Khulu',
            },
            zipcode: '34130',
          },
          341102: {
            name: {
              th: 'กระเดียน',
              en: 'Kradian',
            },
            zipcode: '34130',
          },
          341103: {
            name: {
              th: 'เกษม',
              en: 'Kasem',
            },
            zipcode: '34130',
          },
          341104: {
            name: {
              th: 'กุศกร',
              en: 'Kutsakon',
            },
            zipcode: '34130',
          },
          341105: {
            name: {
              th: 'ขามเปี้ย',
              en: 'Kham Pia',
            },
            zipcode: '34130',
          },
          341106: {
            name: {
              th: 'คอนสาย',
              en: 'Khon Sai',
            },
            zipcode: '34130',
          },
          341107: {
            name: {
              th: 'โคกจาน',
              en: 'Khok Chan',
            },
            zipcode: '34130',
          },
          341108: {
            name: {
              th: 'นาพิน',
              en: 'Na Phin',
            },
            zipcode: '34130',
          },
          341109: {
            name: {
              th: 'นาสะไม',
              en: 'Na Samai',
            },
            zipcode: '34130',
          },
          341110: {
            name: {
              th: 'โนนกุง',
              en: 'Non Kung',
            },
            zipcode: '34130',
          },
          341111: {
            name: {
              th: 'ตระการ',
              en: 'Trakan',
            },
            zipcode: '34130',
          },
          341112: {
            name: {
              th: 'ตากแดด',
              en: 'Tak Daet',
            },
            zipcode: '34130',
          },
          341113: {
            name: {
              th: 'ไหล่ทุ่ง',
              en: 'Lai Thung',
            },
            zipcode: '34130',
          },
          341114: {
            name: {
              th: 'เป้า',
              en: 'Pao',
            },
            zipcode: '34130',
          },
          341115: {
            name: {
              th: 'เซเป็ด',
              en: 'Se Pet',
            },
            zipcode: '34130',
          },
          341116: {
            name: {
              th: 'สะพือ',
              en: 'Saphue',
            },
            zipcode: '34130',
          },
          341117: {
            name: {
              th: 'หนองเต่า',
              en: 'Nong Tao',
            },
            zipcode: '34130',
          },
          341118: {
            name: {
              th: 'ถ้ำแข้',
              en: 'Tham Khae',
            },
            zipcode: '34130',
          },
          341119: {
            name: {
              th: 'ท่าหลวง',
              en: 'Tha Luang',
            },
            zipcode: '34130',
          },
          341120: {
            name: {
              th: 'ห้วยฝ้ายพัฒนา',
              en: 'Huai Fai Phatthana',
            },
            zipcode: '34130',
          },
          341121: {
            name: {
              th: 'กุดยาลวน',
              en: 'Kut Ya Luan',
            },
            zipcode: '34130',
          },
          341122: {
            name: {
              th: 'บ้านแดง',
              en: 'Ban Daeng',
            },
            zipcode: '34130',
          },
          341123: {
            name: {
              th: 'คำเจริญ',
              en: 'Kham Charoen',
            },
            zipcode: '34130',
          },
        },
      },
      3412: {
        name: {
          th: 'กุดข้าวปุ้น',
          en: 'Kut Khao Pun',
        },
        tambons: {
          341201: {
            name: {
              th: 'ข้าวปุ้น',
              en: 'Khaopun',
            },
            zipcode: '34270',
          },
          341202: {
            name: {
              th: 'โนนสวาง',
              en: 'Non Sawang',
            },
            zipcode: '34270',
          },
          341203: {
            name: {
              th: 'แก่งเค็ง',
              en: 'Kaeng Kheng',
            },
            zipcode: '34270',
          },
          341204: {
            name: {
              th: 'กาบิน',
              en: 'Ka Bin',
            },
            zipcode: '34270',
          },
          341205: {
            name: {
              th: 'หนองทันน้ำ',
              en: 'Nong Than Nam',
            },
            zipcode: '34270',
          },
        },
      },
      3414: {
        name: {
          th: 'ม่วงสามสิบ',
          en: 'Muang Samsip',
        },
        tambons: {
          341401: {
            name: {
              th: 'ม่วงสามสิบ',
              en: 'Muang Sam Sip',
            },
            zipcode: '34140',
          },
          341402: {
            name: {
              th: 'เหล่าบก',
              en: 'Lao Bok',
            },
            zipcode: '34140',
          },
          341403: {
            name: {
              th: 'ดุมใหญ่',
              en: 'Dum Yai',
            },
            zipcode: '34140',
          },
          341404: {
            name: {
              th: 'หนองช้างใหญ่',
              en: 'Nong Chang Yai',
            },
            zipcode: '34140',
          },
          341405: {
            name: {
              th: 'หนองเมือง',
              en: 'Nong Muang',
            },
            zipcode: '34140',
          },
          341406: {
            name: {
              th: 'เตย',
              en: 'Toei',
            },
            zipcode: '34140',
          },
          341407: {
            name: {
              th: 'ยางสักกระโพหลุ่ม',
              en: 'Yang Sak Krapho Lum',
            },
            zipcode: '34140',
          },
          341408: {
            name: {
              th: 'หนองไข่นก',
              en: 'Nong Khai Nok',
            },
            zipcode: '34140',
          },
          341409: {
            name: {
              th: 'หนองเหล่า',
              en: 'Nong Lao',
            },
            zipcode: '34140',
          },
          341410: {
            name: {
              th: 'หนองฮาง',
              en: 'Nong Hang',
            },
            zipcode: '34140',
          },
          341411: {
            name: {
              th: 'ยางโยภาพ',
              en: 'Yang Yo Phap',
            },
            zipcode: '34140',
          },
          341412: {
            name: {
              th: 'ไผ่ใหญ่',
              en: 'Phai Yai',
            },
            zipcode: '34140',
          },
          341413: {
            name: {
              th: 'นาเลิง',
              en: 'Na Loeng',
            },
            zipcode: '34140',
          },
          341414: {
            name: {
              th: 'โพนแพง',
              en: 'Phon Phaeng',
            },
            zipcode: '34140',
          },
        },
      },
      3415: {
        name: {
          th: 'วารินชำราบ',
          en: 'Warin Shamrap',
        },
        tambons: {
          341501: {
            name: {
              th: 'วารินชำราบ',
              en: 'Warin Chamrap',
            },
            zipcode: '34190',
          },
          341502: {
            name: {
              th: 'ธาตุ',
              en: 'That',
            },
            zipcode: '34190',
          },
          341504: {
            name: {
              th: 'ท่าลาด',
              en: 'Tha Lat',
            },
            zipcode: '34310',
          },
          341505: {
            name: {
              th: 'โนนโหนน',
              en: 'Non Non',
            },
            zipcode: '34190',
          },
          341507: {
            name: {
              th: 'คูเมือง',
              en: 'Khu Mueang',
            },
            zipcode: '34190',
          },
          341508: {
            name: {
              th: 'สระสมิง',
              en: 'Sa Saming',
            },
            zipcode: '34190',
          },
          341510: {
            name: {
              th: 'คำน้ำแซบ',
              en: 'Kham Nam Saep',
            },
            zipcode: '34190',
          },
          341511: {
            name: {
              th: 'บุ่งหวาย',
              en: 'Bung Wai',
            },
            zipcode: '34310',
          },
          341515: {
            name: {
              th: 'คำขวาง',
              en: 'Kham Khwang',
            },
            zipcode: '34190',
          },
          341516: {
            name: {
              th: 'โพธิ์ใหญ่',
              en: 'Pho Yai',
            },
            zipcode: '34190',
          },
          341518: {
            name: {
              th: 'แสนสุข',
              en: 'Saen Suk',
            },
            zipcode: '34190',
          },
          341520: {
            name: {
              th: 'หนองกินเพล',
              en: 'Nong Kin Phen',
            },
            zipcode: '34190',
          },
          341521: {
            name: {
              th: 'โนนผึ้ง',
              en: 'Non Phueng',
            },
            zipcode: '34190',
          },
          341522: {
            name: {
              th: 'เมืองศรีไค',
              en: 'Mueang Si Khai',
            },
            zipcode: '34190',
          },
          341524: {
            name: {
              th: 'ห้วยขะยูง',
              en: 'Huai Ka Yung',
            },
            zipcode: '34310',
          },
          341526: {
            name: {
              th: 'บุ่งไหม',
              en: 'Bung Mai',
            },
            zipcode: '34190',
          },
        },
      },
      3419: {
        name: {
          th: 'พิบูลมังสาหาร',
          en: 'Phibun Mangsahan',
        },
        tambons: {
          341901: {
            name: {
              th: 'พิบูล',
              en: 'Phibun',
            },
            zipcode: '34110',
          },
          341902: {
            name: {
              th: 'กุดชมภู',
              en: 'Kut Chom Phu',
            },
            zipcode: '34110',
          },
          341904: {
            name: {
              th: 'ดอนจิก',
              en: 'Don Chik',
            },
            zipcode: '34110',
          },
          341905: {
            name: {
              th: 'ทรายมูล',
              en: 'Sai Mun',
            },
            zipcode: '34110',
          },
          341906: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '34110',
          },
          341907: {
            name: {
              th: 'โนนกลาง',
              en: 'Non Klang',
            },
            zipcode: '34110',
          },
          341909: {
            name: {
              th: 'โพธิ์ไทร',
              en: 'Pho Sai',
            },
            zipcode: '34110',
          },
          341910: {
            name: {
              th: 'โพธิ์ศรี',
              en: 'Pho Si',
            },
            zipcode: '34110',
          },
          341911: {
            name: {
              th: 'ระเว',
              en: 'Rawe',
            },
            zipcode: '34110',
          },
          341912: {
            name: {
              th: 'ไร่ใต้',
              en: 'Rai Tai',
            },
            zipcode: '34110',
          },
          341913: {
            name: {
              th: 'หนองบัวฮี',
              en: 'Nong Bua Hi',
            },
            zipcode: '34110',
          },
          341914: {
            name: {
              th: 'อ่างศิลา',
              en: 'Ang Sila',
            },
            zipcode: '34110',
          },
          341918: {
            name: {
              th: 'โนนกาหลง',
              en: 'Non Kalong',
            },
            zipcode: '34110',
          },
          341919: {
            name: {
              th: 'บ้านแขม',
              en: 'Ban Khaem',
            },
            zipcode: '34110',
          },
        },
      },
      3420: {
        name: {
          th: 'ตาลสุม',
          en: 'Tan Sum',
        },
        tambons: {
          342001: {
            name: {
              th: 'ตาลสุม',
              en: 'Tan Sum',
            },
            zipcode: '34330',
          },
          342002: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '34330',
          },
          342003: {
            name: {
              th: 'จิกเทิง',
              en: 'Chik Thoeng',
            },
            zipcode: '34330',
          },
          342004: {
            name: {
              th: 'หนองกุง',
              en: 'Nong Kung',
            },
            zipcode: '34330',
          },
          342005: {
            name: {
              th: 'นาคาย',
              en: 'Na Khai',
            },
            zipcode: '34330',
          },
          342006: {
            name: {
              th: 'คำหว้า',
              en: 'Kham Wa',
            },
            zipcode: '34330',
          },
        },
      },
      3421: {
        name: {
          th: 'โพธิ์ไทร',
          en: 'Pho Sai',
        },
        tambons: {
          342101: {
            name: {
              th: 'โพธิ์ไทร',
              en: 'Pho Sai',
            },
            zipcode: '34340',
          },
          342102: {
            name: {
              th: 'ม่วงใหญ่',
              en: 'Muang Yai',
            },
            zipcode: '34340',
          },
          342103: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '34340',
          },
          342104: {
            name: {
              th: 'สองคอน',
              en: 'Song Khon',
            },
            zipcode: '34340',
          },
          342105: {
            name: {
              th: 'สารภี',
              en: 'Saraphi',
            },
            zipcode: '34340',
          },
          342106: {
            name: {
              th: 'เหล่างาม',
              en: 'Lao Ngam',
            },
            zipcode: '34340',
          },
        },
      },
      3422: {
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        tambons: {
          342201: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '34360',
          },
          342202: {
            name: {
              th: 'โคกก่อง',
              en: 'Khok Kong',
            },
            zipcode: '34360',
          },
          342203: {
            name: {
              th: 'หนองไฮ',
              en: 'Nong Hai',
            },
            zipcode: '34360',
          },
          342204: {
            name: {
              th: 'ค้อน้อย',
              en: 'Kho Noi',
            },
            zipcode: '34360',
          },
          342205: {
            name: {
              th: 'โนนกาเล็น',
              en: 'Non Ka Len',
            },
            zipcode: '34360',
          },
          342206: {
            name: {
              th: 'โคกสว่าง',
              en: 'Khok Sawang',
            },
            zipcode: '34360',
          },
          342207: {
            name: {
              th: 'โนนกลาง',
              en: 'Non Klang',
            },
            zipcode: '34360',
          },
          342208: {
            name: {
              th: 'บอน',
              en: 'Bon',
            },
            zipcode: '34360',
          },
          342209: {
            name: {
              th: 'ขามป้อม',
              en: 'Kham Pom',
            },
            zipcode: '34360',
          },
        },
      },
      3424: {
        name: {
          th: 'ดอนมดแดง',
          en: 'Don Mot Daeng',
        },
        tambons: {
          342401: {
            name: {
              th: 'ดอนมดแดง',
              en: 'Don Mot Daeng',
            },
            zipcode: '34000',
          },
          342402: {
            name: {
              th: 'เหล่าแดง',
              en: 'Lao Daeng',
            },
            zipcode: '34000',
          },
          342403: {
            name: {
              th: 'ท่าเมือง',
              en: 'Tha Mueang',
            },
            zipcode: '34000',
          },
          342404: {
            name: {
              th: 'คำไฮใหญ่',
              en: 'Kham Hai Yai',
            },
            zipcode: '34000',
          },
        },
      },
      3425: {
        name: {
          th: 'สิรินธร',
          en: 'Sirinthon',
        },
        tambons: {
          342501: {
            name: {
              th: 'คันไร่',
              en: 'Khan Rai',
            },
            zipcode: '34350',
          },
          342502: {
            name: {
              th: 'ช่องเม็ก',
              en: 'Chong Mek',
            },
            zipcode: '34350',
          },
          342503: {
            name: {
              th: 'โนนก่อ',
              en: 'Non Ko',
            },
            zipcode: '34350',
          },
          342504: {
            name: {
              th: 'นิคมสร้างตนเองลำโดมน',
              en: 'Nikhom Lamdom Noi',
            },
            zipcode: '34350',
          },
          342505: {
            name: {
              th: 'ฝางคำ',
              en: 'Fang Kham',
            },
            zipcode: '34350',
          },
          342506: {
            name: {
              th: 'คำเขื่อนแก้ว',
              en: 'Kham Khuean Kaeo',
            },
            zipcode: '34350',
          },
        },
      },
      3426: {
        name: {
          th: 'ทุ่งศรีอุดม',
          en: 'Thung Si Udom',
        },
        tambons: {
          342602: {
            name: {
              th: 'หนองอ้ม',
              en: 'Nong Om',
            },
            zipcode: '34160',
          },
          342603: {
            name: {
              th: 'นาเกษม',
              en: 'Na Kasem',
            },
            zipcode: '34160',
          },
          342604: {
            name: {
              th: 'กุดเรือ',
              en: 'Kut Ruea',
            },
            zipcode: '34160',
          },
          342605: {
            name: {
              th: 'โคกชำแระ',
              en: 'Khok Chamrae',
            },
            zipcode: '34160',
          },
          342606: {
            name: {
              th: 'นาห่อม',
              en: 'Na Hom',
            },
            zipcode: '34160',
          },
        },
      },
      3429: {
        name: {
          th: 'นาเยีย',
          en: 'Na Yia',
        },
        tambons: {
          342901: {
            name: {
              th: 'นาเยีย',
              en: 'Na Yia',
            },
            zipcode: '34160',
          },
          342902: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '34160',
          },
          342903: {
            name: {
              th: 'นาเรือง',
              en: 'Na Rueang',
            },
            zipcode: '34160',
          },
        },
      },
      3430: {
        name: {
          th: 'นาตาล',
          en: 'Natan',
        },
        tambons: {
          343001: {
            name: {
              th: 'นาตาล',
              en: 'Na Tan',
            },
            zipcode: '34170',
          },
          343002: {
            name: {
              th: 'พะลาน',
              en: 'Phalan',
            },
            zipcode: '34170',
          },
          343003: {
            name: {
              th: 'กองโพน',
              en: 'Kong Phon',
            },
            zipcode: '34170',
          },
          343004: {
            name: {
              th: 'พังเคน',
              en: 'Phang Khen',
            },
            zipcode: '34170',
          },
        },
      },
      3431: {
        name: {
          th: 'เหล่าเสือโก้ก',
          en: 'Lao Suea Kok',
        },
        tambons: {
          343101: {
            name: {
              th: 'เหล่าเสือโก้ก',
              en: 'Lao Suea Kok',
            },
            zipcode: '34000',
          },
          343102: {
            name: {
              th: 'โพนเมือง',
              en: 'Phon Mueang',
            },
            zipcode: '34000',
          },
          343103: {
            name: {
              th: 'แพงใหญ่',
              en: 'Phaeng Yai',
            },
            zipcode: '34000',
          },
          343104: {
            name: {
              th: 'หนองบก',
              en: 'Nong Bok',
            },
            zipcode: '34000',
          },
        },
      },
      3432: {
        name: {
          th: 'สว่างวีระวงศ์',
          en: 'King Amphoe Swang Weerawong',
        },
        tambons: {
          343201: {
            name: {
              th: 'แก่งโดม',
              en: 'Kaeng Dom',
            },
            zipcode: '34190',
          },
          343202: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '34190',
          },
          343203: {
            name: {
              th: 'บุ่งมะแลง',
              en: 'Bung Malaeng',
            },
            zipcode: '34190',
          },
          343204: {
            name: {
              th: 'สว่าง',
              en: 'Sawang',
            },
            zipcode: '34190',
          },
        },
      },
      3433: {
        name: {
          th: 'น้ำขุ่น',
          en: 'Nam Khun',
        },
        tambons: {
          343301: {
            name: {
              th: 'ตาเกา',
              en: 'Ta Kao',
            },
            zipcode: '34260',
          },
          343302: {
            name: {
              th: 'ไพบูลย์',
              en: 'Phaibun',
            },
            zipcode: '34260',
          },
          343303: {
            name: {
              th: 'ขี้เหล็ก',
              en: 'Khilek',
            },
            zipcode: '34260',
          },
          343304: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '34260',
          },
        },
      },
    },
  },
  35: {
    name: {
      th: 'ยโสธร',
      en: 'Yasothon',
    },
    amphoes: {
      3501: {
        name: {
          th: 'เมืองยโสธร',
          en: 'Muang',
        },
        tambons: {
          350101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '35000',
          },
          350102: {
            name: {
              th: 'น้ำคำใหญ่',
              en: 'Nam Kham Yai',
            },
            zipcode: '35000',
          },
          350103: {
            name: {
              th: 'ตาดทอง',
              en: 'Tat Thong',
            },
            zipcode: '35000',
          },
          350104: {
            name: {
              th: 'สำราญ',
              en: 'Samran',
            },
            zipcode: '35000',
          },
          350105: {
            name: {
              th: 'ค้อเหนือ',
              en: 'Kho Nuea',
            },
            zipcode: '35000',
          },
          350106: {
            name: {
              th: 'ดู่ทุ่ง',
              en: 'Du Thung',
            },
            zipcode: '35000',
          },
          350107: {
            name: {
              th: 'เดิด',
              en: 'Doet',
            },
            zipcode: '35000',
          },
          350108: {
            name: {
              th: 'ขั้นไดใหญ่',
              en: 'Khandai Yai',
            },
            zipcode: '35000',
          },
          350109: {
            name: {
              th: 'ทุ่งแต้',
              en: 'Thung Tae',
            },
            zipcode: '35000',
          },
          350110: {
            name: {
              th: 'สิงห์',
              en: 'Sing',
            },
            zipcode: '35000',
          },
          350111: {
            name: {
              th: 'นาสะไมย์',
              en: 'Na Samai',
            },
            zipcode: '35000',
          },
          350112: {
            name: {
              th: 'เขื่องคำ',
              en: 'Khueang Kham',
            },
            zipcode: '35000',
          },
          350113: {
            name: {
              th: 'หนองหิน',
              en: 'Nong Hin',
            },
            zipcode: '35000',
          },
          350114: {
            name: {
              th: 'หนองคู',
              en: 'Nong Khu',
            },
            zipcode: '35000',
          },
          350115: {
            name: {
              th: 'ขุมเงิน',
              en: 'Khum Ngoen',
            },
            zipcode: '35000',
          },
          350116: {
            name: {
              th: 'ทุ่งนางโอก',
              en: 'Thung Nang Ok',
            },
            zipcode: '35000',
          },
          350117: {
            name: {
              th: 'หนองเรือ',
              en: 'Nong Ruea',
            },
            zipcode: '35000',
          },
          350118: {
            name: {
              th: 'หนองเป็ด',
              en: 'Nong Pet',
            },
            zipcode: '35000',
          },
        },
      },
      3502: {
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        tambons: {
          350201: {
            name: {
              th: 'ทรายมูล',
              en: 'Sai Mun',
            },
            zipcode: '35170',
          },
          350202: {
            name: {
              th: 'ดู่ลาด',
              en: 'Du Lat',
            },
            zipcode: '35170',
          },
          350203: {
            name: {
              th: 'ดงมะไฟ',
              en: 'Dong Mafai',
            },
            zipcode: '35170',
          },
          350204: {
            name: {
              th: 'นาเวียง',
              en: 'Na Wiang',
            },
            zipcode: '35170',
          },
          350205: {
            name: {
              th: 'ไผ่',
              en: 'Phai',
            },
            zipcode: '35170',
          },
        },
      },
      3503: {
        name: {
          th: 'กุดชุม',
          en: 'Kut Chum',
        },
        tambons: {
          350301: {
            name: {
              th: 'กุดชุม',
              en: 'Kut Chum',
            },
            zipcode: '35140',
          },
          350302: {
            name: {
              th: 'โนนเปือย',
              en: 'Non Pueai',
            },
            zipcode: '35140',
          },
          350303: {
            name: {
              th: 'กำแมด',
              en: 'Kammaet',
            },
            zipcode: '35140',
          },
          350304: {
            name: {
              th: 'นาโส่',
              en: 'Na So',
            },
            zipcode: '35140',
          },
          350305: {
            name: {
              th: 'ห้วยแก้ง',
              en: 'Huai Kaeng',
            },
            zipcode: '35140',
          },
          350306: {
            name: {
              th: 'หนองหมี',
              en: 'Nong Mi',
            },
            zipcode: '35140',
          },
          350307: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '35140',
          },
          350308: {
            name: {
              th: 'คำน้ำสร้าง',
              en: 'Kham Nam Sang',
            },
            zipcode: '35140',
          },
          350309: {
            name: {
              th: 'หนองแหน',
              en: 'Nong Nae',
            },
            zipcode: '35140',
          },
        },
      },
      3504: {
        name: {
          th: 'คำเขื่อนแก้ว',
          en: 'Kham Khuan Kaeo',
        },
        tambons: {
          350401: {
            name: {
              th: 'ลุมพุก',
              en: 'Lumphuk',
            },
            zipcode: '35110',
          },
          350402: {
            name: {
              th: 'ย่อ',
              en: 'Yo',
            },
            zipcode: '35110',
          },
          350403: {
            name: {
              th: 'สงเปือย',
              en: 'Song Pueai',
            },
            zipcode: '35110',
          },
          350404: {
            name: {
              th: 'โพนทัน',
              en: 'Phon Than',
            },
            zipcode: '35110',
          },
          350405: {
            name: {
              th: 'ทุ่งมน',
              en: 'Thung Mon',
            },
            zipcode: '35110',
          },
          350406: {
            name: {
              th: 'นาคำ',
              en: 'Na Kham',
            },
            zipcode: '35180',
          },
          350407: {
            name: {
              th: 'ดงแคนใหญ่',
              en: 'Dong Khaen Yai',
            },
            zipcode: '35180',
          },
          350408: {
            name: {
              th: 'กู่จาน',
              en: 'Ku Chan',
            },
            zipcode: '35110',
          },
          350409: {
            name: {
              th: 'นาแก',
              en: 'Na Kae',
            },
            zipcode: '35180',
          },
          350410: {
            name: {
              th: 'กุดกุง',
              en: 'Kut Kung',
            },
            zipcode: '35110',
          },
          350411: {
            name: {
              th: 'เหล่าไฮ',
              en: 'Lao Hai',
            },
            zipcode: '35110',
          },
          350412: {
            name: {
              th: 'แคนน้อย',
              en: 'Khaen Noi',
            },
            zipcode: '35180',
          },
          350413: {
            name: {
              th: 'ดงเจริญ',
              en: 'Dong Charoen',
            },
            zipcode: '35110',
          },
        },
      },
      3505: {
        name: {
          th: 'ป่าติ้ว',
          en: 'Pa Tu',
        },
        tambons: {
          350501: {
            name: {
              th: 'โพธิ์ไทร',
              en: 'Pho Sai',
            },
            zipcode: '35150',
          },
          350502: {
            name: {
              th: 'กระจาย',
              en: 'Krachai',
            },
            zipcode: '35150',
          },
          350503: {
            name: {
              th: 'โคกนาโก',
              en: 'Khok Na Ko',
            },
            zipcode: '35150',
          },
          350504: {
            name: {
              th: 'เชียงเพ็ง',
              en: 'Chiang Pheng',
            },
            zipcode: '35150',
          },
          350505: {
            name: {
              th: 'ศรีฐาน',
              en: 'Si Than',
            },
            zipcode: '35150',
          },
        },
      },
      3506: {
        name: {
          th: 'มหาชนะชัย',
          en: 'Maha Chana Chai',
        },
        tambons: {
          350601: {
            name: {
              th: 'ฟ้าหยาด',
              en: 'Fa Yat',
            },
            zipcode: '35130',
          },
          350602: {
            name: {
              th: 'หัวเมือง',
              en: 'Hua Mueang',
            },
            zipcode: '35130',
          },
          350603: {
            name: {
              th: 'คูเมือง',
              en: 'Khu Mueang',
            },
            zipcode: '35130',
          },
          350604: {
            name: {
              th: 'ผือฮี',
              en: 'Phue Hi',
            },
            zipcode: '35130',
          },
          350605: {
            name: {
              th: 'บากเรือ',
              en: 'Bak Ruea',
            },
            zipcode: '35130',
          },
          350606: {
            name: {
              th: 'ม่วง',
              en: 'Muang',
            },
            zipcode: '35130',
          },
          350607: {
            name: {
              th: 'โนนทราย',
              en: 'Non Sai',
            },
            zipcode: '35130',
          },
          350608: {
            name: {
              th: 'บึงแก',
              en: 'Bueng Kae',
            },
            zipcode: '35130',
          },
          350609: {
            name: {
              th: 'พระเสาร์',
              en: 'Phra Sao',
            },
            zipcode: '35130',
          },
          350610: {
            name: {
              th: 'สงยาง',
              en: 'Song Yang',
            },
            zipcode: '35130',
          },
        },
      },
      3507: {
        name: {
          th: 'ค้อวัง',
          en: 'Kho Wang',
        },
        tambons: {
          350701: {
            name: {
              th: 'ฟ้าห่วน',
              en: 'Fa Huan',
            },
            zipcode: '35160',
          },
          350702: {
            name: {
              th: 'กุดน้ำใส',
              en: 'Kut Nam Sai',
            },
            zipcode: '35160',
          },
          350703: {
            name: {
              th: 'น้ำอ้อม',
              en: 'Nam Om',
            },
            zipcode: '35160',
          },
          350704: {
            name: {
              th: 'ค้อวัง',
              en: 'Kho Wang',
            },
            zipcode: '35160',
          },
        },
      },
      3508: {
        name: {
          th: 'เลิงนกทา',
          en: 'Loeng Nok Tha',
        },
        tambons: {
          350802: {
            name: {
              th: 'บุ่งค้า',
              en: 'Bung Kha',
            },
            zipcode: '35120',
          },
          350803: {
            name: {
              th: 'สวาท',
              en: 'Sawat',
            },
            zipcode: '35120',
          },
          350805: {
            name: {
              th: 'ห้องแซง',
              en: 'Hong Saeng',
            },
            zipcode: '35120',
          },
          350806: {
            name: {
              th: 'สามัคคี',
              en: 'Samakkhi',
            },
            zipcode: '35120',
          },
          350807: {
            name: {
              th: 'กุดเชียงหมี',
              en: 'Kut Chiang Mi',
            },
            zipcode: '35120',
          },
          350810: {
            name: {
              th: 'สามแยก',
              en: 'Sam Yaek',
            },
            zipcode: '35120',
          },
          350811: {
            name: {
              th: 'กุดแห่',
              en: 'Kut Hae',
            },
            zipcode: '35120',
          },
          350812: {
            name: {
              th: 'โคกสำราญ',
              en: 'Khok Samran',
            },
            zipcode: '35120',
          },
          350813: {
            name: {
              th: 'สร้างมิ่ง',
              en: 'Sang Ming',
            },
            zipcode: '35120',
          },
          350814: {
            name: {
              th: 'ศรีแก้ว',
              en: 'Si Kaeo',
            },
            zipcode: '35120',
          },
        },
      },
      3509: {
        name: {
          th: 'ไทยเจริญ',
          en: 'Thai Charoen',
        },
        tambons: {
          350901: {
            name: {
              th: 'ไทยเจริญ',
              en: 'Thai Charoen',
            },
            zipcode: '35120',
          },
          350902: {
            name: {
              th: 'น้ำคำ',
              en: 'Nam Kham',
            },
            zipcode: '35120',
          },
          350903: {
            name: {
              th: 'ส้มผ่อ',
              en: 'Som Pho',
            },
            zipcode: '35120',
          },
          350904: {
            name: {
              th: 'คำเตย',
              en: 'Kham Toei',
            },
            zipcode: '35120',
          },
          350905: {
            name: {
              th: 'คำไผ่',
              en: 'Kham Phai',
            },
            zipcode: '35120',
          },
        },
      },
    },
  },
  36: {
    name: {
      th: 'ชัยภูมิ',
      en: 'Chaiyaphum',
    },
    amphoes: {
      3601: {
        name: {
          th: 'เมืองชัยภูมิ',
          en: 'Muang',
        },
        tambons: {
          360101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '36000',
          },
          360102: {
            name: {
              th: 'รอบเมือง',
              en: 'Rop Mueang',
            },
            zipcode: '36000',
          },
          360103: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '36000',
          },
          360104: {
            name: {
              th: 'นาฝาย',
              en: 'Na Fai',
            },
            zipcode: '36000',
          },
          360105: {
            name: {
              th: 'บ้านค่าย',
              en: 'Ban Kha',
            },
            zipcode: '36240',
          },
          360106: {
            name: {
              th: 'กุดตุ้ม',
              en: 'Kut Tum',
            },
            zipcode: '36000',
          },
          360107: {
            name: {
              th: 'ชีลอง',
              en: 'Chi Long',
            },
            zipcode: '36000',
          },
          360108: {
            name: {
              th: 'บ้านเล่า',
              en: 'Ban Lao',
            },
            zipcode: '36000',
          },
          360109: {
            name: {
              th: 'นาเสียว',
              en: 'Na Siao',
            },
            zipcode: '36000',
          },
          360110: {
            name: {
              th: 'หนองนาแซง',
              en: 'Nong Na Saeng',
            },
            zipcode: '36000',
          },
          360111: {
            name: {
              th: 'ลาดใหญ่',
              en: 'Lat Yai',
            },
            zipcode: '36000',
          },
          360112: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '36240',
          },
          360113: {
            name: {
              th: 'ท่าหินโงม',
              en: 'Tha Hin Ngom',
            },
            zipcode: '36000',
          },
          360114: {
            name: {
              th: 'ห้วยต้อน',
              en: 'Huai Ton',
            },
            zipcode: '36000',
          },
          360115: {
            name: {
              th: 'ห้วยบง',
              en: 'Huai Bong',
            },
            zipcode: '36000',
          },
          360116: {
            name: {
              th: 'โนนสำราญ',
              en: 'Non Samran',
            },
            zipcode: '36240',
          },
          360117: {
            name: {
              th: 'โคกสูง',
              en: 'Khok Sung',
            },
            zipcode: '36000',
          },
          360118: {
            name: {
              th: 'บุ่งคล้า',
              en: 'Bung Khla',
            },
            zipcode: '36000',
          },
          360119: {
            name: {
              th: 'ซับสีทอง',
              en: 'Sap Si Thong',
            },
            zipcode: '36000',
          },
        },
      },
      3602: {
        name: {
          th: 'บ้านเขว้า',
          en: 'Ban Klwao',
        },
        tambons: {
          360201: {
            name: {
              th: 'บ้านเขว้า',
              en: 'Ban Khwao',
            },
            zipcode: '36170',
          },
          360202: {
            name: {
              th: 'ตลาดแร้ง',
              en: 'Talat Raeng',
            },
            zipcode: '36170',
          },
          360203: {
            name: {
              th: 'ลุ่มลำชี',
              en: 'Lum Lamchi',
            },
            zipcode: '36170',
          },
          360204: {
            name: {
              th: 'ชีบน',
              en: 'Chi Bon',
            },
            zipcode: '36170',
          },
          360205: {
            name: {
              th: 'ภูแลนคา',
              en: 'Phu Laen Kha',
            },
            zipcode: '36170',
          },
          360206: {
            name: {
              th: 'โนนแดง',
              en: 'Non Daeng',
            },
            zipcode: '36170',
          },
        },
      },
      3603: {
        name: {
          th: 'คอนสวรรค์',
          en: 'Khon Sawan',
        },
        tambons: {
          360301: {
            name: {
              th: 'คอนสวรรค์',
              en: 'Khon Sawan',
            },
            zipcode: '36140',
          },
          360302: {
            name: {
              th: 'ยางหวาย',
              en: 'Yang Wai',
            },
            zipcode: '36140',
          },
          360303: {
            name: {
              th: 'ช่องสามหมอ',
              en: 'Chong Sam Mo',
            },
            zipcode: '36140',
          },
          360304: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '36140',
          },
          360305: {
            name: {
              th: 'ห้วยไร่',
              en: 'Huai Rai',
            },
            zipcode: '36140',
          },
          360306: {
            name: {
              th: 'บ้านโสก',
              en: 'Ban Sok',
            },
            zipcode: '36140',
          },
          360307: {
            name: {
              th: 'โคกมั่งงอย',
              en: 'Khok Mang Ngoi',
            },
            zipcode: '36140',
          },
          360308: {
            name: {
              th: 'หนองขาม',
              en: 'Nong Kham',
            },
            zipcode: '36140',
          },
          360309: {
            name: {
              th: 'ศรีสำราญ',
              en: 'Si Samran',
            },
            zipcode: '36140',
          },
        },
      },
      3604: {
        name: {
          th: 'เกษตรสมบูรณ์',
          en: 'Kaset Sombun',
        },
        tambons: {
          360401: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '36120',
          },
          360402: {
            name: {
              th: 'บ้านหัน',
              en: 'Ban Han',
            },
            zipcode: '36120',
          },
          360403: {
            name: {
              th: 'บ้านเดื่อ',
              en: 'Ban Duea',
            },
            zipcode: '36120',
          },
          360404: {
            name: {
              th: 'บ้านเป้า',
              en: 'Ban Pao',
            },
            zipcode: '36120',
          },
          360405: {
            name: {
              th: 'กุดเลาะ',
              en: 'Kut Lo',
            },
            zipcode: '36120',
          },
          360406: {
            name: {
              th: 'โนนกอก',
              en: 'Non Kok',
            },
            zipcode: '36120',
          },
          360407: {
            name: {
              th: 'สระโพนทอง',
              en: 'Sa Phon Thong',
            },
            zipcode: '36120',
          },
          360408: {
            name: {
              th: 'หนองข่า',
              en: 'Nong Kha',
            },
            zipcode: '36120',
          },
          360409: {
            name: {
              th: 'หนองโพนงาม',
              en: 'Nong Phon Ngam',
            },
            zipcode: '36120',
          },
          360410: {
            name: {
              th: 'บ้านบัว',
              en: 'Ban Bua',
            },
            zipcode: '36120',
          },
          360412: {
            name: {
              th: 'โนนทอง',
              en: 'Non Thong',
            },
            zipcode: '36120',
          },
        },
      },
      3605: {
        name: {
          th: 'หนองบัวแดง',
          en: 'Nong Bua Daeng',
        },
        tambons: {
          360501: {
            name: {
              th: 'หนองบัวแดง',
              en: 'Nong Bua Daeng',
            },
            zipcode: '36210',
          },
          360502: {
            name: {
              th: 'กุดชุมแสง',
              en: 'Kut Chum Saeng',
            },
            zipcode: '36210',
          },
          360503: {
            name: {
              th: 'ถ้ำวัวแดง',
              en: 'Tham Wua Daeng',
            },
            zipcode: '36210',
          },
          360504: {
            name: {
              th: 'นางแดด',
              en: 'Nang Daet',
            },
            zipcode: '36210',
          },
          360507: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '36210',
          },
          360508: {
            name: {
              th: 'คูเมือง',
              en: 'Khu Mueang',
            },
            zipcode: '36210',
          },
          360509: {
            name: {
              th: 'ท่าใหญ่',
              en: 'Tha Yai',
            },
            zipcode: '36210',
          },
          360511: {
            name: {
              th: 'วังชมภู',
              en: 'Wang Chomphu',
            },
            zipcode: '36210',
          },
        },
      },
      3606: {
        name: {
          th: 'จัตุรัส',
          en: 'Chaturat',
        },
        tambons: {
          360601: {
            name: {
              th: 'บ้านกอก',
              en: 'Ban Kok',
            },
            zipcode: '36130',
          },
          360602: {
            name: {
              th: 'หนองบัวบาน',
              en: 'Nong Bua Ban',
            },
            zipcode: '36130',
          },
          360603: {
            name: {
              th: 'บ้านขาม',
              en: 'Ban Kham',
            },
            zipcode: '36130',
          },
          360605: {
            name: {
              th: 'กุดน้ำใส',
              en: 'Kut Nam Sai',
            },
            zipcode: '36130',
          },
          360606: {
            name: {
              th: 'หนองโดน',
              en: 'Nong Don',
            },
            zipcode: '36130',
          },
          360607: {
            name: {
              th: 'ละหาน',
              en: 'Lahan',
            },
            zipcode: '36130',
          },
          360610: {
            name: {
              th: 'หนองบัวใหญ่',
              en: 'Nong Bua Yai',
            },
            zipcode: '36130',
          },
          360611: {
            name: {
              th: 'หนองบัวโคก',
              en: 'Nong Bua Khok',
            },
            zipcode: '36220',
          },
          360613: {
            name: {
              th: 'ส้มป่อย',
              en: 'Som Poi',
            },
            zipcode: '36130',
          },
        },
      },
      3607: {
        name: {
          th: 'บำเหน็จณรงค์',
          en: 'Bamnet Narong',
        },
        tambons: {
          360701: {
            name: {
              th: 'บ้านชวน',
              en: 'Ban Chuan',
            },
            zipcode: '36160',
          },
          360702: {
            name: {
              th: 'บ้านเพชร',
              en: 'Ban Phet',
            },
            zipcode: '36160',
          },
          360703: {
            name: {
              th: 'บ้านตาล',
              en: 'Ban Tan',
            },
            zipcode: '36220',
          },
          360704: {
            name: {
              th: 'หัวทะเล',
              en: 'Hua Thale',
            },
            zipcode: '36220',
          },
          360705: {
            name: {
              th: 'โคกเริงรมย์',
              en: 'Khok Roeng Rom',
            },
            zipcode: '36160',
          },
          360706: {
            name: {
              th: 'เกาะมะนาว',
              en: 'Ko Manao',
            },
            zipcode: '36160',
          },
          360707: {
            name: {
              th: 'โคกเพชรพัฒนา',
              en: 'Khok Phet Phatthana',
            },
            zipcode: '36160',
          },
        },
      },
      3608: {
        name: {
          th: 'หนองบัวระเหว',
          en: 'Nong Bua Rahaew',
        },
        tambons: {
          360801: {
            name: {
              th: 'หนองบัวระเหว',
              en: 'Nong Bua Rawe',
            },
            zipcode: '36250',
          },
          360802: {
            name: {
              th: 'วังตะเฆ่',
              en: 'Wang Takhe',
            },
            zipcode: '36250',
          },
          360803: {
            name: {
              th: 'ห้วยแย้',
              en: 'Huai Yae',
            },
            zipcode: '36250',
          },
          360804: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '36250',
          },
          360805: {
            name: {
              th: 'โสกปลาดุก',
              en: 'Sok Pla Duk',
            },
            zipcode: '36250',
          },
        },
      },
      3609: {
        name: {
          th: 'เทพสถิต',
          en: 'Thep Sathit',
        },
        tambons: {
          360901: {
            name: {
              th: 'วะตะแบก',
              en: 'Wa Tabaek',
            },
            zipcode: '36230',
          },
          360902: {
            name: {
              th: 'ห้วยยายจิ๋ว',
              en: 'Huai Yai Chio',
            },
            zipcode: '36230',
          },
          360903: {
            name: {
              th: 'นายางกลัก',
              en: 'Na Yang Klak',
            },
            zipcode: '36230',
          },
          360904: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '36230',
          },
          360905: {
            name: {
              th: 'โป่งนก',
              en: 'Pong Nok',
            },
            zipcode: '36230',
          },
        },
      },
      3610: {
        name: {
          th: 'ภูเขียว',
          en: 'Phu Khieo',
        },
        tambons: {
          361001: {
            name: {
              th: 'ผักปัง',
              en: 'Phak Pang',
            },
            zipcode: '36110',
          },
          361002: {
            name: {
              th: 'กวางโจน',
              en: 'Kwang Chon',
            },
            zipcode: '36110',
          },
          361003: {
            name: {
              th: 'หนองคอนไทย',
              en: 'Nong Khon Thai',
            },
            zipcode: '36110',
          },
          361004: {
            name: {
              th: 'บ้านแก้ง',
              en: 'Ban Kaeng',
            },
            zipcode: '36110',
          },
          361005: {
            name: {
              th: 'กุดยม',
              en: 'Kut Yom',
            },
            zipcode: '36110',
          },
          361006: {
            name: {
              th: 'บ้านเพชร',
              en: 'Ban Phet',
            },
            zipcode: '36110',
          },
          361007: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '36110',
          },
          361008: {
            name: {
              th: 'หนองตูม',
              en: 'Nong Tum',
            },
            zipcode: '36110',
          },
          361009: {
            name: {
              th: 'โอโล',
              en: 'O Lo',
            },
            zipcode: '36110',
          },
          361010: {
            name: {
              th: 'ธาตุทอง',
              en: 'That Thong',
            },
            zipcode: '36110',
          },
          361011: {
            name: {
              th: 'บ้านดอน',
              en: 'Ban Don',
            },
            zipcode: '36110',
          },
        },
      },
      3611: {
        name: {
          th: 'บ้านแท่น',
          en: 'Ban Thaen',
        },
        tambons: {
          361101: {
            name: {
              th: 'บ้านแท่น',
              en: 'Ban Thaen',
            },
            zipcode: '36190',
          },
          361102: {
            name: {
              th: 'สามสวน',
              en: 'Sam Suan',
            },
            zipcode: '36190',
          },
          361103: {
            name: {
              th: 'สระพัง',
              en: 'Sa Phang',
            },
            zipcode: '36190',
          },
          361104: {
            name: {
              th: 'บ้านเต่า',
              en: 'Ban Tao',
            },
            zipcode: '36190',
          },
          361105: {
            name: {
              th: 'หนองคู',
              en: 'Nong Khu',
            },
            zipcode: '36190',
          },
        },
      },
      3612: {
        name: {
          th: 'แก้งคร้อ',
          en: 'Kaeng Khlo',
        },
        tambons: {
          361201: {
            name: {
              th: 'ช่องสามหมอ',
              en: 'Chong Sam Mo',
            },
            zipcode: '36150',
          },
          361202: {
            name: {
              th: 'หนองขาม',
              en: 'Nong Kham',
            },
            zipcode: '36150',
          },
          361203: {
            name: {
              th: 'นาหนองทุ่ม',
              en: 'Na Nong Thum',
            },
            zipcode: '36150',
          },
          361204: {
            name: {
              th: 'บ้านแก้ง',
              en: 'Ban Kaeng',
            },
            zipcode: '36150',
          },
          361205: {
            name: {
              th: 'หนองสังข์',
              en: 'Nong Sang',
            },
            zipcode: '36150',
          },
          361206: {
            name: {
              th: 'หลุบคา',
              en: 'Lup Kha',
            },
            zipcode: '36150',
          },
          361207: {
            name: {
              th: 'โคกกุง',
              en: 'Khok Kung',
            },
            zipcode: '36150',
          },
          361208: {
            name: {
              th: 'เก่าย่าดี',
              en: 'Kao Ya Di',
            },
            zipcode: '36150',
          },
          361209: {
            name: {
              th: 'ท่ามะไฟหวาน',
              en: 'Tha Mafai Wan',
            },
            zipcode: '36150',
          },
          361210: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '36150',
          },
        },
      },
      3613: {
        name: {
          th: 'คอนสาร',
          en: 'Khon San',
        },
        tambons: {
          361301: {
            name: {
              th: 'คอนสาร',
              en: 'Khon San',
            },
            zipcode: '36180',
          },
          361302: {
            name: {
              th: 'ทุ่งพระ',
              en: 'Thung Phra',
            },
            zipcode: '36180',
          },
          361303: {
            name: {
              th: 'โนนคูณ',
              en: 'Non Khun',
            },
            zipcode: '36180',
          },
          361304: {
            name: {
              th: 'ห้วยยาง',
              en: 'Huai Yang',
            },
            zipcode: '36180',
          },
          361305: {
            name: {
              th: 'ทุ่งลุยลาย',
              en: 'Thung Luilai',
            },
            zipcode: '36180',
          },
          361306: {
            name: {
              th: 'ดงบัง',
              en: 'Dong Bang',
            },
            zipcode: '36180',
          },
          361307: {
            name: {
              th: 'ทุ่งนาเลา',
              en: 'Thung Na Lao',
            },
            zipcode: '36180',
          },
          361308: {
            name: {
              th: 'ดงกลาง',
              en: 'Dong Klang',
            },
            zipcode: '36180',
          },
        },
      },
      3614: {
        name: {
          th: 'ภักดีชุมพล',
          en: 'Phakdi Chum Phon',
        },
        tambons: {
          361401: {
            name: {
              th: 'บ้านเจียง',
              en: 'Ban Chiang',
            },
            zipcode: '36260',
          },
          361402: {
            name: {
              th: 'เจาทอง',
              en: 'Chao Thong',
            },
            zipcode: '36260',
          },
          361403: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '36260',
          },
          361404: {
            name: {
              th: 'แหลมทอง',
              en: 'Laem Thong',
            },
            zipcode: '36260',
          },
        },
      },
      3615: {
        name: {
          th: 'เนินสง่า',
          en: 'Noen Sanga',
        },
        tambons: {
          361501: {
            name: {
              th: 'หนองฉิม',
              en: 'Nong Chim',
            },
            zipcode: '36130',
          },
          361502: {
            name: {
              th: 'ตาเนิน',
              en: 'Ta Noen',
            },
            zipcode: '36130',
          },
          361503: {
            name: {
              th: 'กะฮาด',
              en: 'Kahad',
            },
            zipcode: '36130',
          },
          361504: {
            name: {
              th: 'รังงาม',
              en: 'Rang Ngam',
            },
            zipcode: '36130',
          },
        },
      },
      3616: {
        name: {
          th: 'ซับใหญ่',
          en: 'Sap Yai',
        },
        tambons: {
          361601: {
            name: {
              th: 'ซับใหญ่',
              en: 'Sap Yai',
            },
            zipcode: '36130',
          },
          361602: {
            name: {
              th: 'ท่ากูบ',
              en: 'Tha Kup',
            },
            zipcode: '36130',
          },
          361603: {
            name: {
              th: 'ตะโกทอง',
              en: 'Tako Thong',
            },
            zipcode: '36130',
          },
        },
      },
    },
  },
  37: {
    name: {
      th: 'อำนาจเจริญ',
      en: 'Amnat Charoen',
    },
    amphoes: {
      3701: {
        name: {
          th: 'เมืองอำนาจเจริญ',
          en: 'Muang',
        },
        tambons: {
          370101: {
            name: {
              th: 'บุ่ง',
              en: 'Bung',
            },
            zipcode: '37000',
          },
          370102: {
            name: {
              th: 'ไก่คำ',
              en: 'Kai Kham',
            },
            zipcode: '37000',
          },
          370103: {
            name: {
              th: 'นาจิก',
              en: 'Na Chik',
            },
            zipcode: '37000',
          },
          370104: {
            name: {
              th: 'ปลาค้าว',
              en: 'Pla Khao',
            },
            zipcode: '37000',
          },
          370105: {
            name: {
              th: 'เหล่าพรวน',
              en: 'Lao Phruan',
            },
            zipcode: '37000',
          },
          370106: {
            name: {
              th: 'สร้างนกทา',
              en: 'Sang Nok Tha',
            },
            zipcode: '37000',
          },
          370107: {
            name: {
              th: 'คึมใหญ่',
              en: 'Khuem Yai',
            },
            zipcode: '37000',
          },
          370108: {
            name: {
              th: 'นาผือ',
              en: 'Na Phue',
            },
            zipcode: '37000',
          },
          370109: {
            name: {
              th: 'น้ำปลีก',
              en: 'Nam Plik',
            },
            zipcode: '37000',
          },
          370110: {
            name: {
              th: 'นาวัง',
              en: 'Na Wang',
            },
            zipcode: '37000',
          },
          370111: {
            name: {
              th: 'นาหมอม้า',
              en: 'Na Mo Ma',
            },
            zipcode: '37000',
          },
          370112: {
            name: {
              th: 'โนนโพธิ์',
              en: 'Non Pho',
            },
            zipcode: '37000',
          },
          370113: {
            name: {
              th: 'โนนหนามแท่ง',
              en: 'Non Nam Thaeng',
            },
            zipcode: '37000',
          },
          370114: {
            name: {
              th: 'ห้วยไร่',
              en: 'Huai Rai',
            },
            zipcode: '37000',
          },
          370115: {
            name: {
              th: 'หนองมะแซว',
              en: 'Nong Masaeo',
            },
            zipcode: '37000',
          },
          370116: {
            name: {
              th: 'กุดปลาดุก',
              en: 'Kut Pla Duk',
            },
            zipcode: '37000',
          },
          370117: {
            name: {
              th: 'ดอนเมย',
              en: 'Don Moei',
            },
            zipcode: '37000',
          },
          370118: {
            name: {
              th: 'นายม',
              en: 'Na Yom',
            },
            zipcode: '37000',
          },
          370119: {
            name: {
              th: 'นาแต้',
              en: 'Na Tae',
            },
            zipcode: '37000',
          },
        },
      },
      3702: {
        name: {
          th: 'ชานุมาน',
          en: 'Chanuman',
        },
        tambons: {
          370201: {
            name: {
              th: 'ชานุมาน',
              en: 'Chanuman',
            },
            zipcode: '37210',
          },
          370202: {
            name: {
              th: 'โคกสาร',
              en: 'Khok San',
            },
            zipcode: '37210',
          },
          370203: {
            name: {
              th: 'คำเขื่อนแก้ว',
              en: 'Kham Khuean Kaeo',
            },
            zipcode: '37210',
          },
          370204: {
            name: {
              th: 'โคกก่ง',
              en: 'Khok Kong',
            },
            zipcode: '37210',
          },
          370205: {
            name: {
              th: 'ป่าก่อ',
              en: 'Pa Ko',
            },
            zipcode: '37210',
          },
        },
      },
      3703: {
        name: {
          th: 'ปทุมราชวงศา',
          en: 'Pathum Rachawongsa',
        },
        tambons: {
          370301: {
            name: {
              th: 'หนองข่า',
              en: 'Nong Kha',
            },
            zipcode: '37110',
          },
          370302: {
            name: {
              th: 'คำโพน',
              en: 'Kham Phon',
            },
            zipcode: '37110',
          },
          370303: {
            name: {
              th: 'นาหว้า',
              en: 'Na Wa',
            },
            zipcode: '37110',
          },
          370304: {
            name: {
              th: 'ลือ',
              en: 'Lue',
            },
            zipcode: '37110',
          },
          370305: {
            name: {
              th: 'ห้วย',
              en: 'Huai',
            },
            zipcode: '37110',
          },
          370306: {
            name: {
              th: 'โนนงาม',
              en: 'Non Ngam',
            },
            zipcode: '37110',
          },
          370307: {
            name: {
              th: 'นาป่าแซง',
              en: 'Na Pa Saeng',
            },
            zipcode: '37110',
          },
        },
      },
      3704: {
        name: {
          th: 'พนา',
          en: 'Phana',
        },
        tambons: {
          370401: {
            name: {
              th: 'พนา',
              en: 'Phana',
            },
            zipcode: '37180',
          },
          370402: {
            name: {
              th: 'จานลาน',
              en: 'Chan Lan',
            },
            zipcode: '37180',
          },
          370403: {
            name: {
              th: 'ไม้กลอน',
              en: 'Mai Klon',
            },
            zipcode: '37180',
          },
          370404: {
            name: {
              th: 'พระเหลา',
              en: 'Phra Lao',
            },
            zipcode: '37180',
          },
        },
      },
      3705: {
        name: {
          th: 'เสนางคนิคม',
          en: 'Senangkanikhom',
        },
        tambons: {
          370501: {
            name: {
              th: 'เสนางคนิคม',
              en: 'Senangkhanikhom',
            },
            zipcode: '37290',
          },
          370502: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '37290',
          },
          370503: {
            name: {
              th: 'ไร่สีสุก',
              en: 'Rai Si Suk',
            },
            zipcode: '37290',
          },
          370504: {
            name: {
              th: 'นาเวียง',
              en: 'Na Wiang',
            },
            zipcode: '37290',
          },
          370505: {
            name: {
              th: 'หนองไฮ',
              en: 'Nong Hai',
            },
            zipcode: '37290',
          },
          370506: {
            name: {
              th: 'หนองสามสี',
              en: 'Nong Sam Si',
            },
            zipcode: '37290',
          },
        },
      },
      3706: {
        name: {
          th: 'หัวตะพาน',
          en: 'Hua Taphan',
        },
        tambons: {
          370601: {
            name: {
              th: 'หัวตะพาน',
              en: 'Hua Taphan',
            },
            zipcode: '37240',
          },
          370602: {
            name: {
              th: 'คำพระ',
              en: 'Kham Phra',
            },
            zipcode: '37240',
          },
          370603: {
            name: {
              th: 'เค็งใหญ่',
              en: 'Kheng Yai',
            },
            zipcode: '37240',
          },
          370604: {
            name: {
              th: 'หนองแก้ว',
              en: 'Nong Kaeo',
            },
            zipcode: '37240',
          },
          370605: {
            name: {
              th: 'โพนเมืองน้อย',
              en: 'Phon Mueang Noi',
            },
            zipcode: '37240',
          },
          370606: {
            name: {
              th: 'สร้างถ่อน้อย',
              en: 'Sang Tho Noi',
            },
            zipcode: '37240',
          },
          370607: {
            name: {
              th: 'จิกดู่',
              en: 'Chik Du',
            },
            zipcode: '37240',
          },
          370608: {
            name: {
              th: 'รัตนวารี',
              en: 'Rattanawari',
            },
            zipcode: '37240',
          },
        },
      },
      3707: {
        name: {
          th: 'ลืออำนาจ',
          en: 'Lu Amnat',
        },
        tambons: {
          370701: {
            name: {
              th: 'อำนาจ',
              en: 'Amnat',
            },
            zipcode: '37000',
          },
          370702: {
            name: {
              th: 'ดงมะยาง',
              en: 'Dong Ma Yang',
            },
            zipcode: '37000',
          },
          370703: {
            name: {
              th: 'เปือย',
              en: 'Pueai',
            },
            zipcode: '37000',
          },
          370704: {
            name: {
              th: 'ดงบัง',
              en: 'Dong Bang',
            },
            zipcode: '37000',
          },
          370705: {
            name: {
              th: 'ไร่ขี',
              en: 'Rai Khi',
            },
            zipcode: '37000',
          },
          370706: {
            name: {
              th: 'แมด',
              en: 'Maet',
            },
            zipcode: '37000',
          },
          370707: {
            name: {
              th: 'โคกกลาง',
              en: 'Khok Klang',
            },
            zipcode: '37000',
          },
        },
      },
    },
  },
  38: {
    name: {
      th: 'บึงกาฬ',
      en: 'BUENG KAN',
    },
    amphoes: {
      3801: {
        name: {
          th: 'เมืองบึงกาฬ',
          en: 'Mueang Bueng Kan',
        },
        tambons: {
          380101: {
            name: {
              th: 'บึงกาฬ',
              en: 'Bueng Kan',
            },
            zipcode: '38000',
          },
          380102: {
            name: {
              th: 'โนนสมบูรณ์',
              en: 'Non Sombun',
            },
            zipcode: '38000',
          },
          380103: {
            name: {
              th: 'โนนสว่าง',
              en: 'Non Sawang',
            },
            zipcode: '38000',
          },
          380104: {
            name: {
              th: 'หอคำ',
              en: 'Ho Kham',
            },
            zipcode: '38000',
          },
          380105: {
            name: {
              th: 'หนองเลิง',
              en: 'Nong Loeng',
            },
            zipcode: '38000',
          },
          380106: {
            name: {
              th: 'โคกก่อง',
              en: 'Khok Kong',
            },
            zipcode: '38000',
          },
          380107: {
            name: {
              th: 'นาสวรรค์',
              en: 'Na Sawan',
            },
            zipcode: '38000',
          },
          380108: {
            name: {
              th: 'ไคสี',
              en: 'Khai Si',
            },
            zipcode: '38000',
          },
          380109: {
            name: {
              th: 'ชัยพร',
              en: 'Chaiyaphon',
            },
            zipcode: '38000',
          },
          380110: {
            name: {
              th: 'วิศิษฐ์',
              en: 'Wisit',
            },
            zipcode: '38000',
          },
          380111: {
            name: {
              th: 'คำนาดี',
              en: 'Kham Na Di',
            },
            zipcode: '38000',
          },
          380112: {
            name: {
              th: 'โป่งเปือย',
              en: 'Pong Pueai',
            },
            zipcode: '38000',
          },
        },
      },
      3802: {
        name: {
          th: 'พรเจริญ',
          en: 'Phon Charoen',
        },
        tambons: {
          380201: {
            name: {
              th: 'ศรีชมภู',
              en: 'Si Chomphu',
            },
            zipcode: '38180',
          },
          380202: {
            name: {
              th: 'ดอนหญ้านาง',
              en: 'Don Ya Nang',
            },
            zipcode: '38180',
          },
          380203: {
            name: {
              th: 'พรเจริญ',
              en: 'Phon Charoen',
            },
            zipcode: '38180',
          },
          380204: {
            name: {
              th: 'หนองหัวช้าง',
              en: 'Nong Hua Chang',
            },
            zipcode: '38180',
          },
          380205: {
            name: {
              th: 'วังชมภู',
              en: 'Wang Chomphu',
            },
            zipcode: '38180',
          },
          380206: {
            name: {
              th: 'ป่าแฝก',
              en: 'Pa Faek',
            },
            zipcode: '38180',
          },
          380207: {
            name: {
              th: 'ศรีสำราญ',
              en: 'Si Samran',
            },
            zipcode: '38180',
          },
        },
      },
      3803: {
        name: {
          th: 'โซ่พิสัย',
          en: 'So Phisai',
        },
        tambons: {
          380301: {
            name: {
              th: 'โซ่',
              en: 'So',
            },
            zipcode: '38170',
          },
          380302: {
            name: {
              th: 'หนองพันทา',
              en: 'Nong Phan Tha',
            },
            zipcode: '38170',
          },
          380303: {
            name: {
              th: 'ศรีชมภู',
              en: 'Si Chomphu',
            },
            zipcode: '38170',
          },
          380304: {
            name: {
              th: 'คำแก้ว',
              en: 'Kham Kaeo',
            },
            zipcode: '38170',
          },
          380305: {
            name: {
              th: 'บัวตูม',
              en: 'Bua Tum',
            },
            zipcode: '38170',
          },
          380306: {
            name: {
              th: 'ถ้ำเจริญ',
              en: 'Tham Charoen',
            },
            zipcode: '38170',
          },
          380307: {
            name: {
              th: 'เหล่าทอง',
              en: 'Lao Thong',
            },
            zipcode: '38170',
          },
        },
      },
      3804: {
        name: {
          th: 'เซกา',
          en: 'Seka',
        },
        tambons: {
          380401: {
            name: {
              th: 'เซกา',
              en: 'Seka',
            },
            zipcode: '38150',
          },
          380402: {
            name: {
              th: 'ซาง',
              en: 'Sang',
            },
            zipcode: '38150',
          },
          380403: {
            name: {
              th: 'ท่ากกแดง',
              en: 'Tha Kok Daeng',
            },
            zipcode: '38150',
          },
          380404: {
            name: {
              th: 'บ้านต้อง',
              en: 'Ban Tong',
            },
            zipcode: '38150',
          },
          380405: {
            name: {
              th: 'ป่งไฮ',
              en: 'Pong Hai',
            },
            zipcode: '38150',
          },
          380406: {
            name: {
              th: 'น้ำจั้น',
              en: 'Nam Chan',
            },
            zipcode: '38150',
          },
          380407: {
            name: {
              th: 'ท่าสะอาด',
              en: 'Tha Sa-at',
            },
            zipcode: '38150',
          },
          380408: {
            name: {
              th: 'หนองทุ่ม',
              en: 'Nong Thum',
            },
            zipcode: '38150',
          },
          380409: {
            name: {
              th: 'โสกก่าม',
              en: 'Sok Kam',
            },
            zipcode: '38150',
          },
        },
      },
      3805: {
        name: {
          th: 'ปากคาด',
          en: 'Pak Khat',
        },
        tambons: {
          380501: {
            name: {
              th: 'ปากคาด',
              en: 'Pak Khat',
            },
            zipcode: '38190',
          },
          380502: {
            name: {
              th: 'หนองยอง',
              en: 'Nong Yong',
            },
            zipcode: '38190',
          },
          380503: {
            name: {
              th: 'นากั้ง',
              en: 'Na Kang',
            },
            zipcode: '38190',
          },
          380504: {
            name: {
              th: 'โนนศิลา',
              en: 'Non Sila',
            },
            zipcode: '38190',
          },
          380505: {
            name: {
              th: 'สมสนุก',
              en: 'Som Sanuk',
            },
            zipcode: '38190',
          },
          380506: {
            name: {
              th: 'นาดง',
              en: 'Na Dong',
            },
            zipcode: '38190',
          },
        },
      },
      3806: {
        name: {
          th: 'บึงโขงหลง',
          en: 'Bueng Khong Long',
        },
        tambons: {
          380601: {
            name: {
              th: 'บึงโขงหลง',
              en: 'Bueng Khong Long',
            },
            zipcode: '38220',
          },
          380602: {
            name: {
              th: 'โพธิ์หมากแข้ง',
              en: 'Pho Mak Khaeng',
            },
            zipcode: '38220',
          },
          380603: {
            name: {
              th: 'ดงบัง',
              en: 'Dong Bang',
            },
            zipcode: '38220',
          },
          380604: {
            name: {
              th: 'ท่าดอกคำ',
              en: 'Tha Dok Kham',
            },
            zipcode: '38220',
          },
        },
      },
      3807: {
        name: {
          th: 'ศรีวิไล',
          en: 'Si Wilai',
        },
        tambons: {
          380701: {
            name: {
              th: 'ศรีวิไล',
              en: 'Si Wilai',
            },
            zipcode: '38210',
          },
          380702: {
            name: {
              th: 'ชุมภูพร',
              en: 'Chumphu Phon',
            },
            zipcode: '38210',
          },
          380703: {
            name: {
              th: 'นาแสง',
              en: 'Na Saeng',
            },
            zipcode: '38210',
          },
          380704: {
            name: {
              th: 'นาสะแบง',
              en: 'Na Sabaeng',
            },
            zipcode: '38210',
          },
          380705: {
            name: {
              th: 'นาสิงห์',
              en: 'Na Sing',
            },
            zipcode: '38210',
          },
        },
      },
      3808: {
        name: {
          th: 'บุ่งคล้า',
          en: 'Bung Khla',
        },
        tambons: {
          380801: {
            name: {
              th: 'บุ่งคล้า',
              en: 'Bung Khla',
            },
            zipcode: '38000',
          },
          380802: {
            name: {
              th: 'หนองเดิ่น',
              en: 'Nong Doen',
            },
            zipcode: '38000',
          },
          380803: {
            name: {
              th: 'โคกกว้าง',
              en: 'Khok Kwang',
            },
            zipcode: '38000',
          },
        },
      },
    },
  },
  39: {
    name: {
      th: 'หนองบัวลำภู',
      en: 'Nong Bua Lam Phu',
    },
    amphoes: {
      3901: {
        name: {
          th: 'เมืองหนองบัวลำภู',
          en: 'Muang',
        },
        tambons: {
          390101: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '39000',
          },
          390102: {
            name: {
              th: 'หนองภัยศูนย์',
              en: 'Nong Phai Sun',
            },
            zipcode: '39000',
          },
          390103: {
            name: {
              th: 'โพธิ์ชัย',
              en: 'Pho Chai',
            },
            zipcode: '39000',
          },
          390104: {
            name: {
              th: 'หนองสวรรค์',
              en: 'Nong Sawan',
            },
            zipcode: '39000',
          },
          390105: {
            name: {
              th: 'หัวนา',
              en: 'Hua Na',
            },
            zipcode: '39000',
          },
          390106: {
            name: {
              th: 'บ้านขาม',
              en: 'Ban Kham',
            },
            zipcode: '39000',
          },
          390107: {
            name: {
              th: 'นามะเฟือง',
              en: 'Na Mafueang',
            },
            zipcode: '39000',
          },
          390108: {
            name: {
              th: 'บ้านพร้าว',
              en: 'Ban Phrao',
            },
            zipcode: '39000',
          },
          390109: {
            name: {
              th: 'โนนขมิ้น',
              en: 'Non Khamin',
            },
            zipcode: '39000',
          },
          390110: {
            name: {
              th: 'ลำภู',
              en: 'Lam Phu',
            },
            zipcode: '39000',
          },
          390111: {
            name: {
              th: 'กุดจิก',
              en: 'Kut Chik',
            },
            zipcode: '39000',
          },
          390112: {
            name: {
              th: 'โนนทัน',
              en: 'Non Than',
            },
            zipcode: '39000',
          },
          390113: {
            name: {
              th: 'นาคำไฮ',
              en: 'Na Kham Hai',
            },
            zipcode: '39000',
          },
          390114: {
            name: {
              th: 'ป่าไม้งาม',
              en: 'Pa Mai Ngam',
            },
            zipcode: '39000',
          },
          390115: {
            name: {
              th: 'หนองหว้า',
              en: 'Nong Wa',
            },
            zipcode: '39000',
          },
        },
      },
      3902: {
        name: {
          th: 'นากลาง',
          en: 'Na Klang',
        },
        tambons: {
          390201: {
            name: {
              th: 'นากลาง',
              en: 'Na Klang',
            },
            zipcode: '39170',
          },
          390202: {
            name: {
              th: 'ด่านช้าง',
              en: 'Dan Chang',
            },
            zipcode: '39170',
          },
          390205: {
            name: {
              th: 'กุดดินจี่',
              en: 'Kut Din Chi',
            },
            zipcode: '39350',
          },
          390206: {
            name: {
              th: 'ฝั่งแดง',
              en: 'Fang Daeng',
            },
            zipcode: '39170',
          },
          390207: {
            name: {
              th: 'เก่ากลอย',
              en: 'Kao Kloi',
            },
            zipcode: '39350',
          },
          390209: {
            name: {
              th: 'โนนเมือง',
              en: 'Non Mueang',
            },
            zipcode: '39170',
          },
          390210: {
            name: {
              th: 'อุทัยสวรรค์',
              en: 'Uthai Sawan',
            },
            zipcode: '39170',
          },
          390211: {
            name: {
              th: 'ดงสวรรค์',
              en: 'Dong Sawan',
            },
            zipcode: '39350',
          },
          390213: {
            name: {
              th: 'กุดแห่',
              en: 'Kut Hae',
            },
            zipcode: '39170',
          },
        },
      },
      3903: {
        name: {
          th: 'โนนสัง',
          en: 'Non Sung',
        },
        tambons: {
          390301: {
            name: {
              th: 'โนนสัง',
              en: 'Non Sang',
            },
            zipcode: '39140',
          },
          390302: {
            name: {
              th: 'บ้านถิ่น',
              en: 'Ban Thin',
            },
            zipcode: '39140',
          },
          390303: {
            name: {
              th: 'หนองเรือ',
              en: 'Nong Ruea',
            },
            zipcode: '39140',
          },
          390304: {
            name: {
              th: 'กุดดู่',
              en: 'Kut Du',
            },
            zipcode: '39140',
          },
          390305: {
            name: {
              th: 'บ้านค้อ',
              en: 'Ban Kho',
            },
            zipcode: '39140',
          },
          390306: {
            name: {
              th: 'โนนเมือง',
              en: 'Non Mueang',
            },
            zipcode: '39140',
          },
          390307: {
            name: {
              th: 'โคกใหญ่',
              en: 'Khok Yai',
            },
            zipcode: '39140',
          },
          390308: {
            name: {
              th: 'โคกม่วง',
              en: 'Khok Muang',
            },
            zipcode: '39140',
          },
          390309: {
            name: {
              th: 'นิคมพัฒนา',
              en: 'Nikhom Phatthana',
            },
            zipcode: '39140',
          },
          390310: {
            name: {
              th: 'ปางกู่',
              en: 'Pang Ku',
            },
            zipcode: '39140',
          },
        },
      },
      3904: {
        name: {
          th: 'ศรีบุญเรือง',
          en: 'Si Bun Ruang',
        },
        tambons: {
          390401: {
            name: {
              th: 'เมืองใหม่',
              en: 'Mueang Mai',
            },
            zipcode: '39180',
          },
          390402: {
            name: {
              th: 'ศรีบุญเรือง',
              en: 'Si Bun Rueang',
            },
            zipcode: '39180',
          },
          390403: {
            name: {
              th: 'หนองบัวใต้',
              en: 'Nong Bua Tai',
            },
            zipcode: '39180',
          },
          390404: {
            name: {
              th: 'กุดสะเทียน',
              en: 'Kut Sathian',
            },
            zipcode: '39180',
          },
          390405: {
            name: {
              th: 'นากอก',
              en: 'Na Kok',
            },
            zipcode: '39180',
          },
          390406: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '39180',
          },
          390407: {
            name: {
              th: 'ยางหล่อ',
              en: 'Yang Lo',
            },
            zipcode: '39180',
          },
          390408: {
            name: {
              th: 'โนนม่วง',
              en: 'Non Muang',
            },
            zipcode: '39180',
          },
          390409: {
            name: {
              th: 'หนองกุงแก้ว',
              en: 'Nong Kung Kaeo',
            },
            zipcode: '39180',
          },
          390410: {
            name: {
              th: 'หนองแก',
              en: 'Nong Kae',
            },
            zipcode: '39180',
          },
          390411: {
            name: {
              th: 'ทรายทอง',
              en: 'Sai Thong',
            },
            zipcode: '39180',
          },
          390412: {
            name: {
              th: 'หันนางาม',
              en: 'Han Na Ngam',
            },
            zipcode: '39180',
          },
        },
      },
      3905: {
        name: {
          th: 'สุวรรณคูหา',
          en: 'Suwan Khuha',
        },
        tambons: {
          390501: {
            name: {
              th: 'นาสี',
              en: 'Na Si',
            },
            zipcode: '39270',
          },
          390502: {
            name: {
              th: 'บ้านโคก',
              en: 'Ban Khok',
            },
            zipcode: '39270',
          },
          390503: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '39270',
          },
          390504: {
            name: {
              th: 'นาด่าน',
              en: 'Na Dan',
            },
            zipcode: '39270',
          },
          390505: {
            name: {
              th: 'ดงมะไฟ',
              en: 'Dong Mafai',
            },
            zipcode: '39270',
          },
          390506: {
            name: {
              th: 'สุวรรณคูหา',
              en: 'Suwannakhuha',
            },
            zipcode: '39270',
          },
          390507: {
            name: {
              th: 'บุญทัน',
              en: 'Bun Than',
            },
            zipcode: '39270',
          },
          390508: {
            name: {
              th: 'กุดผึ้ง',
              en: 'Kut Phueng',
            },
            zipcode: '39270',
          },
        },
      },
      3906: {
        name: {
          th: 'นาวัง',
          en: 'Na Wang',
        },
        tambons: {
          390601: {
            name: {
              th: 'นาเหล่า',
              en: 'Na Lao',
            },
            zipcode: '39170',
          },
          390602: {
            name: {
              th: 'นาแก',
              en: 'Na Kae',
            },
            zipcode: '39170',
          },
          390603: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '39170',
          },
          390604: {
            name: {
              th: 'วังปลาป้อม',
              en: 'Wang Pla Pom',
            },
            zipcode: '39170',
          },
          390605: {
            name: {
              th: 'เทพคีรี',
              en: 'Thep Khiri',
            },
            zipcode: '39170',
          },
        },
      },
    },
  },
  40: {
    name: {
      th: 'ขอนแก่น',
      en: 'Khon Kaen',
    },
    amphoes: {
      4001: {
        name: {
          th: 'เมืองขอนแก่น',
          en: 'Muang',
        },
        tambons: {
          400101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '40000',
          },
          400102: {
            name: {
              th: 'สำราญ',
              en: 'Samran',
            },
            zipcode: '40000',
          },
          400103: {
            name: {
              th: 'โคกสี',
              en: 'Khok Si',
            },
            zipcode: '40000',
          },
          400104: {
            name: {
              th: 'ท่าพระ',
              en: 'Tha Phra',
            },
            zipcode: '40260',
          },
          400105: {
            name: {
              th: 'บ้านทุ่ม',
              en: 'Ban Thum',
            },
            zipcode: '40000',
          },
          400106: {
            name: {
              th: 'เมืองเก่า',
              en: 'Mueang Kao',
            },
            zipcode: '40000',
          },
          400107: {
            name: {
              th: 'พระลับ',
              en: 'Phra Lap',
            },
            zipcode: '40000',
          },
          400108: {
            name: {
              th: 'สาวะถี',
              en: 'Sawathi',
            },
            zipcode: '40000',
          },
          400109: {
            name: {
              th: 'บ้านหว้า',
              en: 'Ban Wa',
            },
            zipcode: '40000',
          },
          400110: {
            name: {
              th: 'บ้านค้อ',
              en: 'Ban Kho',
            },
            zipcode: '40000',
          },
          400111: {
            name: {
              th: 'แดงใหญ่',
              en: 'Daeng Yai',
            },
            zipcode: '40000',
          },
          400112: {
            name: {
              th: 'ดอนช้าง',
              en: 'Don Chang',
            },
            zipcode: '40000',
          },
          400113: {
            name: {
              th: 'ดอนหัน',
              en: 'Don Han',
            },
            zipcode: '40260',
          },
          400114: {
            name: {
              th: 'ศิลา',
              en: 'Sila',
            },
            zipcode: '40000',
          },
          400115: {
            name: {
              th: 'บ้านเป็ด',
              en: 'Ban Pet',
            },
            zipcode: '40000',
          },
          400116: {
            name: {
              th: 'หนองตูม',
              en: 'Nong Tum',
            },
            zipcode: '40000',
          },
          400117: {
            name: {
              th: 'บึงเนียม',
              en: 'Bueng Niam',
            },
            zipcode: '40000',
          },
          400118: {
            name: {
              th: 'โนนท่อน',
              en: 'Non Thon',
            },
            zipcode: '40000',
          },
        },
      },
      4002: {
        name: {
          th: 'บ้านฝาง',
          en: 'Ban Fang',
        },
        tambons: {
          400201: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '40270',
          },
          400202: {
            name: {
              th: 'ป่าหวายนั่ง',
              en: 'Pa Wai Nang',
            },
            zipcode: '40270',
          },
          400203: {
            name: {
              th: 'โนนฆ้อง',
              en: 'Non Khong',
            },
            zipcode: '40270',
          },
          400204: {
            name: {
              th: 'บ้านเหล่า',
              en: 'Ban Lao',
            },
            zipcode: '40270',
          },
          400205: {
            name: {
              th: 'ป่ามะนาว',
              en: 'Pa Manao',
            },
            zipcode: '40270',
          },
          400206: {
            name: {
              th: 'บ้านฝาง',
              en: 'Ban Fang',
            },
            zipcode: '40270',
          },
          400207: {
            name: {
              th: 'โคกงาม',
              en: 'Khok Ngam',
            },
            zipcode: '40270',
          },
        },
      },
      4003: {
        name: {
          th: 'พระยืน',
          en: 'Phra Yun',
        },
        tambons: {
          400301: {
            name: {
              th: 'พระยืน',
              en: 'Phra Yuen',
            },
            zipcode: '40320',
          },
          400302: {
            name: {
              th: 'พระบุ',
              en: 'Phra Bu',
            },
            zipcode: '40320',
          },
          400303: {
            name: {
              th: 'บ้านโต้น',
              en: 'Ban Ton',
            },
            zipcode: '40320',
          },
          400304: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '40320',
          },
          400305: {
            name: {
              th: 'ขามป้อม',
              en: 'Kham Pom',
            },
            zipcode: '40320',
          },
        },
      },
      4004: {
        name: {
          th: 'หนองเรือ',
          en: 'Nong Rua',
        },
        tambons: {
          400401: {
            name: {
              th: 'หนองเรือ',
              en: 'Nong Ruea',
            },
            zipcode: '40210',
          },
          400402: {
            name: {
              th: 'บ้านเม็ง',
              en: 'Ban Meng',
            },
            zipcode: '40210',
          },
          400403: {
            name: {
              th: 'บ้านกง',
              en: 'Ban Kong',
            },
            zipcode: '40240',
          },
          400404: {
            name: {
              th: 'ยางคำ',
              en: 'Yang Kham',
            },
            zipcode: '40240',
          },
          400405: {
            name: {
              th: 'จระเข้',
              en: 'Chorakhe',
            },
            zipcode: '40240',
          },
          400406: {
            name: {
              th: 'โนนทอง',
              en: 'Non Thong',
            },
            zipcode: '40210',
          },
          400407: {
            name: {
              th: 'กุดกว้าง',
              en: 'Kut Kwang',
            },
            zipcode: '40210',
          },
          400408: {
            name: {
              th: 'โนนทัน',
              en: 'Non Than',
            },
            zipcode: '40210',
          },
          400409: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '40210',
          },
          400410: {
            name: {
              th: 'บ้านผือ',
              en: 'Ban Phue',
            },
            zipcode: '40240',
          },
        },
      },
      4005: {
        name: {
          th: 'ชุมแพ',
          en: 'Chum Phae',
        },
        tambons: {
          400501: {
            name: {
              th: 'ชุมแพ',
              en: 'Chum Phae',
            },
            zipcode: '40130',
          },
          400502: {
            name: {
              th: 'โนนหัน',
              en: 'Non Han',
            },
            zipcode: '40290',
          },
          400503: {
            name: {
              th: 'นาหนองทุ่ม',
              en: 'Na Nong Thum',
            },
            zipcode: '40290',
          },
          400504: {
            name: {
              th: 'โนนอุดม',
              en: 'Non Udom',
            },
            zipcode: '40130',
          },
          400505: {
            name: {
              th: 'ขัวเรียง',
              en: 'Khua Riang',
            },
            zipcode: '40130',
          },
          400506: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '40130',
          },
          400507: {
            name: {
              th: 'ไชยสอ',
              en: 'Chai So',
            },
            zipcode: '40130',
          },
          400508: {
            name: {
              th: 'วังหินลาด',
              en: 'Wang Hin Lat',
            },
            zipcode: '40130',
          },
          400509: {
            name: {
              th: 'นาเพียง',
              en: 'Na Phiang',
            },
            zipcode: '40130',
          },
          400510: {
            name: {
              th: 'หนองเขียด',
              en: 'Nong Khiat',
            },
            zipcode: '40290',
          },
          400511: {
            name: {
              th: 'หนองเสาเล้า',
              en: 'Nong Sao Lao',
            },
            zipcode: '40130',
          },
          400512: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '40290',
          },
        },
      },
      4006: {
        name: {
          th: 'สีชมพู',
          en: 'Sichomphoo',
        },
        tambons: {
          400601: {
            name: {
              th: 'สีชมพู',
              en: 'Si Chomphu',
            },
            zipcode: '40220',
          },
          400602: {
            name: {
              th: 'ศรีสุข',
              en: 'Si Suk',
            },
            zipcode: '40220',
          },
          400603: {
            name: {
              th: 'นาจาน',
              en: 'Na Chan',
            },
            zipcode: '40220',
          },
          400604: {
            name: {
              th: 'วังเพิ่ม',
              en: 'Wang Phoem',
            },
            zipcode: '40220',
          },
          400605: {
            name: {
              th: 'ซำยาง',
              en: 'Sam Yang',
            },
            zipcode: '40220',
          },
          400606: {
            name: {
              th: 'หนองแดง',
              en: 'Nong Daeng',
            },
            zipcode: '40220',
          },
          400607: {
            name: {
              th: 'ดงลาน',
              en: 'Dong Lan',
            },
            zipcode: '40220',
          },
          400608: {
            name: {
              th: 'บริบูรณ์',
              en: 'Boribun',
            },
            zipcode: '40220',
          },
          400609: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '40220',
          },
          400610: {
            name: {
              th: 'ภูห่าน',
              en: 'Phu Han',
            },
            zipcode: '40220',
          },
        },
      },
      4007: {
        name: {
          th: 'น้ำพอง',
          en: 'Nam Phong',
        },
        tambons: {
          400701: {
            name: {
              th: 'น้ำพอง',
              en: 'Nam Phong',
            },
            zipcode: '40140',
          },
          400702: {
            name: {
              th: 'วังชัย',
              en: 'Wang Chai',
            },
            zipcode: '40140',
          },
          400703: {
            name: {
              th: 'หนองกุง',
              en: 'Nong Kung',
            },
            zipcode: '40140',
          },
          400704: {
            name: {
              th: 'บัวใหญ่',
              en: 'Bua Yai',
            },
            zipcode: '40140',
          },
          400705: {
            name: {
              th: 'สะอาด',
              en: 'Sa-at',
            },
            zipcode: '40310',
          },
          400706: {
            name: {
              th: 'ม่วงหวาน',
              en: 'Muang Wan',
            },
            zipcode: '40310',
          },
          400707: {
            name: {
              th: 'บ้านขาม',
              en: 'Ban Kham',
            },
            zipcode: '40140',
          },
          400708: {
            name: {
              th: 'บัวเงิน',
              en: 'Bua Ngoen',
            },
            zipcode: '40140',
          },
          400709: {
            name: {
              th: 'ทรายมูล',
              en: 'Sai Mun',
            },
            zipcode: '40140',
          },
          400710: {
            name: {
              th: 'ท่ากระเสริม',
              en: 'Tha Krasoem',
            },
            zipcode: '40140',
          },
          400711: {
            name: {
              th: 'พังทุย',
              en: 'Phang Thui',
            },
            zipcode: '40140',
          },
          400712: {
            name: {
              th: 'กุดน้ำใส',
              en: 'Kut Nam Sai',
            },
            zipcode: '40140',
          },
        },
      },
      4008: {
        name: {
          th: 'อุบลรัตน์',
          en: 'Ubolratana',
        },
        tambons: {
          400801: {
            name: {
              th: 'โคกสูง',
              en: 'Khok Sung',
            },
            zipcode: '40250',
          },
          400802: {
            name: {
              th: 'บ้านดง',
              en: 'Ban Dong',
            },
            zipcode: '40250',
          },
          400803: {
            name: {
              th: 'เขื่อนอุบลรัตน์',
              en: 'Khuean Ubolratana',
            },
            zipcode: '40250',
          },
          400804: {
            name: {
              th: 'นาคำ',
              en: 'Na Kham',
            },
            zipcode: '40250',
          },
          400805: {
            name: {
              th: 'ศรีสุขสำราญ',
              en: 'Si Suk Samran',
            },
            zipcode: '40250',
          },
          400806: {
            name: {
              th: 'ทุ่งโป่ง',
              en: 'Thung Pong',
            },
            zipcode: '40250',
          },
        },
      },
      4009: {
        name: {
          th: 'กระนวน',
          en: 'Kranuan',
        },
        tambons: {
          400901: {
            name: {
              th: 'หนองโก',
              en: 'Nong Ko',
            },
            zipcode: '40170',
          },
          400902: {
            name: {
              th: 'หนองกุงใหญ่',
              en: 'Nong Kung Yai',
            },
            zipcode: '40170',
          },
          400905: {
            name: {
              th: 'ห้วยโจด',
              en: 'Huai Chot',
            },
            zipcode: '40170',
          },
          400906: {
            name: {
              th: 'ห้วยยาง',
              en: 'Huai Yang',
            },
            zipcode: '40170',
          },
          400907: {
            name: {
              th: 'บ้านฝาง',
              en: 'Ban Fang',
            },
            zipcode: '40170',
          },
          400909: {
            name: {
              th: 'ดูนสาด',
              en: 'Dun Sat',
            },
            zipcode: '40170',
          },
          400910: {
            name: {
              th: 'หนองโน',
              en: 'Nong No',
            },
            zipcode: '40170',
          },
          400911: {
            name: {
              th: 'น้ำอ้อม',
              en: 'Nam Om',
            },
            zipcode: '40170',
          },
          400912: {
            name: {
              th: 'หัวนาคำ',
              en: 'Hua Na Kham',
            },
            zipcode: '40170',
          },
        },
      },
      4010: {
        name: {
          th: 'บ้านไผ่',
          en: 'Ban Phai',
        },
        tambons: {
          401001: {
            name: {
              th: 'บ้านไผ่',
              en: 'Ban Phai',
            },
            zipcode: '40110',
          },
          401002: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '40110',
          },
          401005: {
            name: {
              th: 'เมืองเพีย',
              en: 'Mueang Phia',
            },
            zipcode: '40110',
          },
          401009: {
            name: {
              th: 'บ้านลาน',
              en: 'Ban Lan',
            },
            zipcode: '40110',
          },
          401010: {
            name: {
              th: 'แคนเหนือ',
              en: 'Khaen Nuea',
            },
            zipcode: '40110',
          },
          401011: {
            name: {
              th: 'ภูเหล็ก',
              en: 'Phu Lek',
            },
            zipcode: '40110',
          },
          401013: {
            name: {
              th: 'ป่าปอ',
              en: 'Pa Po',
            },
            zipcode: '40110',
          },
          401014: {
            name: {
              th: 'หินตั้ง',
              en: 'Hin Tang',
            },
            zipcode: '40110',
          },
          401016: {
            name: {
              th: 'หนองน้ำใส',
              en: 'Nong Nam Sai',
            },
            zipcode: '40110',
          },
          401017: {
            name: {
              th: 'หัวหนอง',
              en: 'Hua Nong',
            },
            zipcode: '40110',
          },
        },
      },
      4011: {
        name: {
          th: 'เปือยน้อย',
          en: 'Puai Noi',
        },
        tambons: {
          401101: {
            name: {
              th: 'เปือยน้อย',
              en: 'Pueai Noi',
            },
            zipcode: '40340',
          },
          401102: {
            name: {
              th: 'วังม่วง',
              en: 'Wang Muang',
            },
            zipcode: '40340',
          },
          401103: {
            name: {
              th: 'ขามป้อม',
              en: 'Kham Pom',
            },
            zipcode: '40340',
          },
          401104: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '40340',
          },
        },
      },
      4012: {
        name: {
          th: 'พล',
          en: 'Phon',
        },
        tambons: {
          401201: {
            name: {
              th: 'เมืองพล',
              en: 'Mueang Phon',
            },
            zipcode: '40120',
          },
          401203: {
            name: {
              th: 'โจดหนองแก',
              en: 'Chot Nong Kae',
            },
            zipcode: '40120',
          },
          401204: {
            name: {
              th: 'เก่างิ้ว',
              en: 'Kao Ngio',
            },
            zipcode: '40120',
          },
          401205: {
            name: {
              th: 'หนองมะเขือ',
              en: 'Nong Makhuea',
            },
            zipcode: '40120',
          },
          401206: {
            name: {
              th: 'หนองแวงโสกพระ',
              en: 'Nong Waeng Sok Phra',
            },
            zipcode: '40120',
          },
          401207: {
            name: {
              th: 'เพ็กใหญ่',
              en: 'Phek Yai',
            },
            zipcode: '40120',
          },
          401208: {
            name: {
              th: 'โคกสง่า',
              en: 'Khok Sa-nga',
            },
            zipcode: '40120',
          },
          401209: {
            name: {
              th: 'หนองแวงนางเบ้า',
              en: 'Nong Waeng Nang Bao',
            },
            zipcode: '40120',
          },
          401210: {
            name: {
              th: 'ลอมคอม',
              en: 'Lom Khom',
            },
            zipcode: '40120',
          },
          401211: {
            name: {
              th: 'โนนข่า',
              en: 'Non Kha',
            },
            zipcode: '40120',
          },
          401212: {
            name: {
              th: 'โสกนกเต็น',
              en: 'Sok Nok Ten',
            },
            zipcode: '40120',
          },
          401213: {
            name: {
              th: 'หัวทุ่ง',
              en: 'Hua Thung',
            },
            zipcode: '40120',
          },
        },
      },
      4013: {
        name: {
          th: 'แวงใหญ่',
          en: 'Waeng Yai',
        },
        tambons: {
          401301: {
            name: {
              th: 'คอนฉิม',
              en: 'Khon Chim',
            },
            zipcode: '40330',
          },
          401302: {
            name: {
              th: 'ใหม่นาเพียง',
              en: 'Mai Na Phiang',
            },
            zipcode: '40330',
          },
          401303: {
            name: {
              th: 'โนนทอง',
              en: 'Non Thong',
            },
            zipcode: '40330',
          },
          401304: {
            name: {
              th: 'แวงใหญ่',
              en: 'Waeng Yai',
            },
            zipcode: '40330',
          },
          401305: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '40330',
          },
        },
      },
      4014: {
        name: {
          th: 'แวงน้อย',
          en: 'Waeng Noi',
        },
        tambons: {
          401401: {
            name: {
              th: 'แวงน้อย',
              en: 'Waeng Noi',
            },
            zipcode: '40230',
          },
          401402: {
            name: {
              th: 'ก้านเหลือง',
              en: 'Kan Lueang',
            },
            zipcode: '40230',
          },
          401403: {
            name: {
              th: 'ท่านางแนว',
              en: 'Tha Nang Naeo',
            },
            zipcode: '40230',
          },
          401404: {
            name: {
              th: 'ละหานนา',
              en: 'Lahan Na',
            },
            zipcode: '40230',
          },
          401405: {
            name: {
              th: 'ท่าวัด',
              en: 'Tha Wat',
            },
            zipcode: '40230',
          },
          401406: {
            name: {
              th: 'ทางขวาง',
              en: 'Thang Khwang',
            },
            zipcode: '40230',
          },
        },
      },
      4015: {
        name: {
          th: 'หนองสองห้อง',
          en: 'Nong Song Hong',
        },
        tambons: {
          401501: {
            name: {
              th: 'หนองสองห้อง',
              en: 'Nong Song Hong',
            },
            zipcode: '40190',
          },
          401502: {
            name: {
              th: 'คึมชาด',
              en: 'Khuemchat',
            },
            zipcode: '40190',
          },
          401503: {
            name: {
              th: 'โนนธาตุ',
              en: 'Non That',
            },
            zipcode: '40190',
          },
          401504: {
            name: {
              th: 'ตะกั่วป่า',
              en: 'Takua Pa',
            },
            zipcode: '40190',
          },
          401505: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '40190',
          },
          401506: {
            name: {
              th: 'หนองเม็ก',
              en: 'Nong Mek',
            },
            zipcode: '40190',
          },
          401507: {
            name: {
              th: 'ดอนดู่',
              en: 'Don Du',
            },
            zipcode: '40190',
          },
          401508: {
            name: {
              th: 'ดงเค็ง',
              en: 'Dong Kheng',
            },
            zipcode: '40190',
          },
          401509: {
            name: {
              th: 'หันโจด',
              en: 'Han Chot',
            },
            zipcode: '40190',
          },
          401510: {
            name: {
              th: 'ดอนดั่ง',
              en: 'Don Dang',
            },
            zipcode: '40190',
          },
          401511: {
            name: {
              th: 'วังหิน',
              en: 'Wang Hin',
            },
            zipcode: '40190',
          },
          401512: {
            name: {
              th: 'หนองไผ่ล้อม',
              en: 'Nong Phai Lom',
            },
            zipcode: '40190',
          },
        },
      },
      4016: {
        name: {
          th: 'ภูเวียง',
          en: 'Phu Wiang',
        },
        tambons: {
          401601: {
            name: {
              th: 'บ้านเรือ',
              en: 'Ban Ruea',
            },
            zipcode: '40150',
          },
          401604: {
            name: {
              th: 'หว้าทอง',
              en: 'Wa Thong',
            },
            zipcode: '40150',
          },
          401605: {
            name: {
              th: 'กุดขอนแก่น',
              en: 'Kut Khon Kaen',
            },
            zipcode: '40150',
          },
          401606: {
            name: {
              th: 'นาชุมแสง',
              en: 'Na Chum Saeng',
            },
            zipcode: '40150',
          },
          401607: {
            name: {
              th: 'นาหว้า',
              en: 'Na Wa',
            },
            zipcode: '40150',
          },
          401610: {
            name: {
              th: 'หนองกุงธนสาร',
              en: 'Nong Kung Thanasan',
            },
            zipcode: '40150',
          },
          401612: {
            name: {
              th: 'หนองกุงเซิน',
              en: 'Nong Kung Soen',
            },
            zipcode: '40150',
          },
          401613: {
            name: {
              th: 'สงเปือย',
              en: 'Song Pueai',
            },
            zipcode: '40150',
          },
          401614: {
            name: {
              th: 'ทุ่งชมพู',
              en: 'Thung Chomphu',
            },
            zipcode: '40150',
          },
          401616: {
            name: {
              th: 'ดินดำ',
              en: 'Din Dam',
            },
            zipcode: '40150',
          },
          401617: {
            name: {
              th: 'ภูเวียง',
              en: 'Phu Wiang',
            },
            zipcode: '40150',
          },
        },
      },
      4017: {
        name: {
          th: 'มัญจาคีรี',
          en: 'Mancha Khiri',
        },
        tambons: {
          401701: {
            name: {
              th: 'กุดเค้า',
              en: 'Kut Khao',
            },
            zipcode: '40160',
          },
          401702: {
            name: {
              th: 'สวนหม่อน',
              en: 'Suan Mon',
            },
            zipcode: '40160',
          },
          401703: {
            name: {
              th: 'หนองแปน',
              en: 'Nong Paen',
            },
            zipcode: '40160',
          },
          401704: {
            name: {
              th: 'โพนเพ็ก',
              en: 'Phon Phek',
            },
            zipcode: '40160',
          },
          401705: {
            name: {
              th: 'คำแคน',
              en: 'Kham Khaen',
            },
            zipcode: '40160',
          },
          401706: {
            name: {
              th: 'นาข่า',
              en: 'Na Kha',
            },
            zipcode: '40160',
          },
          401707: {
            name: {
              th: 'นางาม',
              en: 'Na Ngam',
            },
            zipcode: '40160',
          },
          401710: {
            name: {
              th: 'ท่าศาลา',
              en: 'Tha Sala',
            },
            zipcode: '40160',
          },
        },
      },
      4018: {
        name: {
          th: 'ชนบท',
          en: 'Chonnabot',
        },
        tambons: {
          401801: {
            name: {
              th: 'ชนบท',
              en: 'Chonnabot',
            },
            zipcode: '40180',
          },
          401802: {
            name: {
              th: 'กุดเพียขอม',
              en: 'Kut Phia Khom',
            },
            zipcode: '40180',
          },
          401803: {
            name: {
              th: 'วังแสง',
              en: 'Wang Saeng',
            },
            zipcode: '40180',
          },
          401804: {
            name: {
              th: 'ห้วยแก',
              en: 'Huai Kae',
            },
            zipcode: '40180',
          },
          401805: {
            name: {
              th: 'บ้านแท่น',
              en: 'Ban Thaen',
            },
            zipcode: '40180',
          },
          401806: {
            name: {
              th: 'ศรีบุญเรือง',
              en: 'Si Bun Rueang',
            },
            zipcode: '40180',
          },
          401807: {
            name: {
              th: 'โนนพะยอม',
              en: 'Non Phayom',
            },
            zipcode: '40180',
          },
          401808: {
            name: {
              th: 'ปอแดง',
              en: 'Po Daeng',
            },
            zipcode: '40180',
          },
        },
      },
      4019: {
        name: {
          th: 'เขาสวนกวาง',
          en: 'Kaosuankwang',
        },
        tambons: {
          401901: {
            name: {
              th: 'เขาสวนกวาง',
              en: 'Khao Suan Kwang',
            },
            zipcode: '40280',
          },
          401902: {
            name: {
              th: 'ดงเมืองแอม',
              en: 'Dong Mueang Aem',
            },
            zipcode: '40280',
          },
          401903: {
            name: {
              th: 'นางิ้ว',
              en: 'Na Ngio',
            },
            zipcode: '40280',
          },
          401904: {
            name: {
              th: 'โนนสมบูรณ์',
              en: 'Non Sombun',
            },
            zipcode: '40280',
          },
          401905: {
            name: {
              th: 'คำม่วง',
              en: 'Kham Muang',
            },
            zipcode: '40280',
          },
        },
      },
      4020: {
        name: {
          th: 'ภูผาม่าน',
          en: 'Phupaman',
        },
        tambons: {
          402001: {
            name: {
              th: 'โนนคอม',
              en: 'Non Don',
            },
            zipcode: '40350',
          },
          402002: {
            name: {
              th: 'นาฝาย',
              en: 'Na Fai',
            },
            zipcode: '40350',
          },
          402003: {
            name: {
              th: 'ภูผาม่าน',
              en: 'Phu Pha Man',
            },
            zipcode: '40350',
          },
          402004: {
            name: {
              th: 'วังสวาบ',
              en: 'Wang Suap',
            },
            zipcode: '40350',
          },
          402005: {
            name: {
              th: 'ห้วยม่วง',
              en: 'Huai Muang',
            },
            zipcode: '40350',
          },
        },
      },
      4021: {
        name: {
          th: 'ซำสูง',
          en: 'King Amphoe Some Sung',
        },
        tambons: {
          402101: {
            name: {
              th: 'กระนวน',
              en: 'Kranuan',
            },
            zipcode: '40170',
          },
          402102: {
            name: {
              th: 'คำแมด',
              en: 'Kham Maet',
            },
            zipcode: '40170',
          },
          402103: {
            name: {
              th: 'บ้านโนน',
              en: 'Ban Non',
            },
            zipcode: '40170',
          },
          402104: {
            name: {
              th: 'คูคำ',
              en: 'Khu Kham',
            },
            zipcode: '40170',
          },
          402105: {
            name: {
              th: 'ห้วยเตย',
              en: 'Huai Toei',
            },
            zipcode: '40170',
          },
        },
      },
      4022: {
        name: {
          th: 'โคกโพธิ์ไชย',
          en: 'King Amphoe Khok Pho Chai',
        },
        tambons: {
          402201: {
            name: {
              th: 'บ้านโคก',
              en: 'Ban Khok',
            },
            zipcode: '40160',
          },
          402202: {
            name: {
              th: 'โพธิ์ไชย',
              en: 'Pho Chai',
            },
            zipcode: '40160',
          },
          402203: {
            name: {
              th: 'ซับสมบูรณ์',
              en: 'Sab Sombun',
            },
            zipcode: '40160',
          },
          402204: {
            name: {
              th: 'นาแพง',
              en: 'Na Phaeng',
            },
            zipcode: '40160',
          },
        },
      },
      4023: {
        name: {
          th: 'หนองนาคำ',
          en: 'King Amphoe Nong Na Kham',
        },
        tambons: {
          402301: {
            name: {
              th: 'กุดธาตุ',
              en: 'Kut That',
            },
            zipcode: '40150',
          },
          402302: {
            name: {
              th: 'บ้านโคก',
              en: 'Ban Khok',
            },
            zipcode: '40150',
          },
          402303: {
            name: {
              th: 'ขนวน',
              en: 'Khanuan',
            },
            zipcode: '40150',
          },
        },
      },
      4024: {
        name: {
          th: 'บ้านแฮด',
          en: 'King Amphoe Ban Haad',
        },
        tambons: {
          402401: {
            name: {
              th: 'บ้านแฮด',
              en: 'Ban Haet',
            },
            zipcode: '40110',
          },
          402402: {
            name: {
              th: 'โคกสำราญ',
              en: 'Khok Samran',
            },
            zipcode: '40110',
          },
          402403: {
            name: {
              th: 'โนนสมบูรณ์',
              en: 'Non Sombun',
            },
            zipcode: '40110',
          },
          402404: {
            name: {
              th: 'หนองแซง',
              en: 'Nong Saeng',
            },
            zipcode: '40110',
          },
        },
      },
      4025: {
        name: {
          th: 'โนนศิลา',
          en: 'King Amphoe Nom Sila',
        },
        tambons: {
          402501: {
            name: {
              th: 'โนนศิลา',
              en: 'Non Sila',
            },
            zipcode: '40110',
          },
          402502: {
            name: {
              th: 'หนองปลาหมอ',
              en: 'Nong Pla Mo',
            },
            zipcode: '40110',
          },
          402503: {
            name: {
              th: 'บ้านหัน',
              en: 'Ban Han',
            },
            zipcode: '40110',
          },
          402504: {
            name: {
              th: 'เปือยใหญ่',
              en: 'Pueai Yai',
            },
            zipcode: '40110',
          },
          402505: {
            name: {
              th: 'โนนแดง',
              en: 'Non Daeng',
            },
            zipcode: '40110',
          },
        },
      },
      4029: {
        name: {
          th: 'เวียงเก่า',
          en: 'Wiang Kao',
        },
        tambons: {
          402901: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '40150',
          },
          402902: {
            name: {
              th: 'เมืองเก่าพัฒนา',
              en: 'Mueang Kao Phatthana',
            },
            zipcode: '40150',
          },
          402903: {
            name: {
              th: 'เขาน้อย',
              en: 'Khao Noi',
            },
            zipcode: '40150',
          },
        },
      },
    },
  },
  41: {
    name: {
      th: 'อุดรธานี',
      en: 'Udon Thani',
    },
    amphoes: {
      4101: {
        name: {
          th: 'เมืองอุดรธานี',
          en: 'Muang',
        },
        tambons: {
          410101: {
            name: {
              th: 'หมากแข้ง',
              en: 'Mak Khaeng',
            },
            zipcode: '41000',
          },
          410102: {
            name: {
              th: 'นิคมสงเคราะห์',
              en: 'Nikhom Songkhro',
            },
            zipcode: '41000',
          },
          410103: {
            name: {
              th: 'บ้านขาว',
              en: 'Ban Khao',
            },
            zipcode: '41000',
          },
          410104: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '41000',
          },
          410105: {
            name: {
              th: 'บ้านตาด',
              en: 'Ban Tat',
            },
            zipcode: '41000',
          },
          410106: {
            name: {
              th: 'โนนสูง',
              en: 'Non Sung',
            },
            zipcode: '41330',
          },
          410107: {
            name: {
              th: 'หมูม่น',
              en: 'Mu Mon',
            },
            zipcode: '41000',
          },
          410108: {
            name: {
              th: 'เชียงยืน',
              en: 'Chiang Yuen',
            },
            zipcode: '41000',
          },
          410109: {
            name: {
              th: 'หนองนาคำ',
              en: 'Nong Na Kham',
            },
            zipcode: '41000',
          },
          410110: {
            name: {
              th: 'กุดสระ',
              en: 'Kut Sa',
            },
            zipcode: '41000',
          },
          410111: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '41000',
          },
          410112: {
            name: {
              th: 'บ้านเลื่อม',
              en: 'Ban Lueam',
            },
            zipcode: '41000',
          },
          410113: {
            name: {
              th: 'เชียงพิณ',
              en: 'Chiang Phin',
            },
            zipcode: '41000',
          },
          410114: {
            name: {
              th: 'สามพร้าว',
              en: 'Sam Phrao',
            },
            zipcode: '41000',
          },
          410115: {
            name: {
              th: 'หนองไฮ',
              en: 'Nong Hai',
            },
            zipcode: '41000',
          },
          410116: {
            name: {
              th: 'นาข่า',
              en: 'Na Kha',
            },
            zipcode: '41000',
          },
          410117: {
            name: {
              th: 'บ้านจั่น',
              en: 'Ban Chan',
            },
            zipcode: '41000',
          },
          410118: {
            name: {
              th: 'หนองขอนกว้าง',
              en: 'Nong Khon Kwang',
            },
            zipcode: '41000',
          },
          410119: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '41000',
          },
          410120: {
            name: {
              th: 'นากว้าง',
              en: 'Na Kwang',
            },
            zipcode: '41000',
          },
          410121: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '41330',
          },
        },
      },
      4102: {
        name: {
          th: 'กุดจับ',
          en: 'Kut Chap',
        },
        tambons: {
          410201: {
            name: {
              th: 'กุดจับ',
              en: 'Kut Chap',
            },
            zipcode: '41250',
          },
          410202: {
            name: {
              th: 'ปะโค',
              en: 'Pa Kho',
            },
            zipcode: '41250',
          },
          410203: {
            name: {
              th: 'ขอนยูง',
              en: 'Khon Yung',
            },
            zipcode: '41250',
          },
          410204: {
            name: {
              th: 'เชียงเพ็ง',
              en: 'Chiang Pheng',
            },
            zipcode: '41250',
          },
          410205: {
            name: {
              th: 'สร้างก่อ',
              en: 'Sang Ko',
            },
            zipcode: '41250',
          },
          410206: {
            name: {
              th: 'เมืองเพีย',
              en: 'Mueang Phia',
            },
            zipcode: '41250',
          },
          410207: {
            name: {
              th: 'ตาลเลียน',
              en: 'Tan Lian',
            },
            zipcode: '41250',
          },
        },
      },
      4103: {
        name: {
          th: 'หนองวัวซอ',
          en: 'Nong Wua So',
        },
        tambons: {
          410301: {
            name: {
              th: 'หมากหญ้า',
              en: 'Mak Ya',
            },
            zipcode: '41360',
          },
          410302: {
            name: {
              th: 'หนองอ้อ',
              en: 'Nong O',
            },
            zipcode: '41220',
          },
          410303: {
            name: {
              th: 'อูบมุง',
              en: 'Up Mung',
            },
            zipcode: '41220',
          },
          410304: {
            name: {
              th: 'กุดหมากไฟ',
              en: 'Kut Mak Fai',
            },
            zipcode: '41220',
          },
          410305: {
            name: {
              th: 'น้ำพ่น',
              en: 'Nam Phon',
            },
            zipcode: '41360',
          },
          410306: {
            name: {
              th: 'หนองบัวบาน',
              en: 'Nong Bua Ban',
            },
            zipcode: '41360',
          },
          410307: {
            name: {
              th: 'โนนหวาย',
              en: 'Non Wai',
            },
            zipcode: '41220',
          },
          410308: {
            name: {
              th: 'หนองวัวซอ',
              en: 'Nong Wua So',
            },
            zipcode: '41360',
          },
        },
      },
      4104: {
        name: {
          th: 'กุมภวาปี',
          en: 'Kumphawapi',
        },
        tambons: {
          410401: {
            name: {
              th: 'ตูมใต้',
              en: 'Tum Tai',
            },
            zipcode: '41110',
          },
          410402: {
            name: {
              th: 'พันดอน',
              en: 'Phan Don',
            },
            zipcode: '41370',
          },
          410403: {
            name: {
              th: 'เวียงคำ',
              en: 'Wiang Kham',
            },
            zipcode: '41110',
          },
          410404: {
            name: {
              th: 'แชแล',
              en: 'Chaelae',
            },
            zipcode: '41110',
          },
          410406: {
            name: {
              th: 'เชียงแหว',
              en: 'Chiang Wae',
            },
            zipcode: '41110',
          },
          410407: {
            name: {
              th: 'ห้วยเกิ้ง',
              en: 'Huai Koeng',
            },
            zipcode: '41110',
          },
          410409: {
            name: {
              th: 'เสอเพลอ',
              en: 'Soephloe',
            },
            zipcode: '41370',
          },
          410410: {
            name: {
              th: 'สีออ',
              en: 'Si O',
            },
            zipcode: '41110',
          },
          410411: {
            name: {
              th: 'ปะโค',
              en: 'Pa Kho',
            },
            zipcode: '41370',
          },
          410413: {
            name: {
              th: 'ผาสุก',
              en: 'Pha Suk',
            },
            zipcode: '41370',
          },
          410414: {
            name: {
              th: 'ท่าลี่',
              en: 'Tha Li',
            },
            zipcode: '41110',
          },
          410415: {
            name: {
              th: 'กุมภวาปี',
              en: 'Kumphawapi',
            },
            zipcode: '41110',
          },
          410416: {
            name: {
              th: 'หนองหว้า',
              en: 'Nong Wa',
            },
            zipcode: '41110',
          },
        },
      },
      4105: {
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-At',
        },
        tambons: {
          410501: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '41240',
          },
          410502: {
            name: {
              th: 'บุ่งแก้ว',
              en: 'Bung Kaeo',
            },
            zipcode: '41240',
          },
          410503: {
            name: {
              th: 'โพธิ์ศรีสำราญ',
              en: 'Pho Si Samran',
            },
            zipcode: '41240',
          },
          410504: {
            name: {
              th: 'ทมนางาม',
              en: 'Thom Na Ngam',
            },
            zipcode: '41240',
          },
          410505: {
            name: {
              th: 'หนองกุงศรี',
              en: 'Nong Kung Si',
            },
            zipcode: '41240',
          },
          410506: {
            name: {
              th: 'โคกกลาง',
              en: 'Khok Klang',
            },
            zipcode: '41240',
          },
        },
      },
      4106: {
        name: {
          th: 'หนองหาน',
          en: 'Nong Han',
        },
        tambons: {
          410601: {
            name: {
              th: 'หนองหาน',
              en: 'Nong Han',
            },
            zipcode: '41130',
          },
          410602: {
            name: {
              th: 'หนองเม็ก',
              en: 'Nong Mek',
            },
            zipcode: '41130',
          },
          410605: {
            name: {
              th: 'พังงู',
              en: 'Phang Ngu',
            },
            zipcode: '41130',
          },
          410606: {
            name: {
              th: 'สะแบง',
              en: 'Sabaeng',
            },
            zipcode: '41130',
          },
          410607: {
            name: {
              th: 'สร้อยพร้าว',
              en: 'Soi Phrao',
            },
            zipcode: '41130',
          },
          410609: {
            name: {
              th: 'บ้านเชียง',
              en: 'Ban Chiang',
            },
            zipcode: '41320',
          },
          410610: {
            name: {
              th: 'บ้านยา',
              en: 'Ban Ya',
            },
            zipcode: '41320',
          },
          410611: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '41130',
          },
          410612: {
            name: {
              th: 'ผักตบ',
              en: 'Phak Top',
            },
            zipcode: '41130',
          },
          410614: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '41130',
          },
          410617: {
            name: {
              th: 'ดอนหายโศก',
              en: 'Don Hai Sok',
            },
            zipcode: '41130',
          },
          410618: {
            name: {
              th: 'หนองสระปลา',
              en: 'Nong Sa Pla',
            },
            zipcode: '41320',
          },
        },
      },
      4107: {
        name: {
          th: 'ทุ่งฝน',
          en: 'Thung Fon',
        },
        tambons: {
          410701: {
            name: {
              th: 'ทุ่งฝน',
              en: 'Thung Fon',
            },
            zipcode: '41310',
          },
          410702: {
            name: {
              th: 'ทุ่งใหญ่',
              en: 'Thung Yai',
            },
            zipcode: '41310',
          },
          410703: {
            name: {
              th: 'นาชุมแสง',
              en: 'Na Chum Saeng',
            },
            zipcode: '41310',
          },
          410704: {
            name: {
              th: 'นาทม',
              en: 'Na Thom',
            },
            zipcode: '41310',
          },
        },
      },
      4108: {
        name: {
          th: 'ไชยวาน',
          en: 'Chai Wan',
        },
        tambons: {
          410801: {
            name: {
              th: 'ไชยวาน',
              en: 'Chai Wan',
            },
            zipcode: '41290',
          },
          410802: {
            name: {
              th: 'หนองหลัก',
              en: 'Nong Lak',
            },
            zipcode: '41290',
          },
          410803: {
            name: {
              th: 'คำเลาะ',
              en: 'Kham Lo',
            },
            zipcode: '41290',
          },
          410804: {
            name: {
              th: 'โพนสูง',
              en: 'Phon Sung',
            },
            zipcode: '41290',
          },
        },
      },
      4109: {
        name: {
          th: 'ศรีธาตุ',
          en: 'Sri That',
        },
        tambons: {
          410901: {
            name: {
              th: 'ศรีธาตุ',
              en: 'Si That',
            },
            zipcode: '41230',
          },
          410902: {
            name: {
              th: 'จำปี',
              en: 'Champi',
            },
            zipcode: '41230',
          },
          410903: {
            name: {
              th: 'บ้านโปร่ง',
              en: 'Ban Prong',
            },
            zipcode: '41230',
          },
          410904: {
            name: {
              th: 'หัวนาคำ',
              en: 'Hua Na Kham',
            },
            zipcode: '41230',
          },
          410905: {
            name: {
              th: 'หนองนกเขียน',
              en: 'Nong Nok Khian',
            },
            zipcode: '41230',
          },
          410906: {
            name: {
              th: 'นายูง',
              en: 'Na Yung',
            },
            zipcode: '41230',
          },
          410907: {
            name: {
              th: 'ตาดทอง',
              en: 'Tat Thong',
            },
            zipcode: '41230',
          },
        },
      },
      4110: {
        name: {
          th: 'วังสามหมอ',
          en: 'Wang Sam Mo',
        },
        tambons: {
          411001: {
            name: {
              th: 'หนองกุงทับม้า',
              en: 'Nong Kung Thap Ma',
            },
            zipcode: '41280',
          },
          411002: {
            name: {
              th: 'หนองหญ้าไซ',
              en: 'Nong Ya Sai',
            },
            zipcode: '41280',
          },
          411003: {
            name: {
              th: 'บะยาว',
              en: 'Ba Yao',
            },
            zipcode: '41280',
          },
          411004: {
            name: {
              th: 'ผาสุก',
              en: 'Pha Suk',
            },
            zipcode: '41280',
          },
          411005: {
            name: {
              th: 'คำโคกสูง',
              en: 'Kham Khok Sung',
            },
            zipcode: '41280',
          },
          411006: {
            name: {
              th: 'วังสามหมอ',
              en: 'Wang Sam Mo',
            },
            zipcode: '41280',
          },
        },
      },
      4111: {
        name: {
          th: 'บ้านดุง',
          en: 'Ban Dung',
        },
        tambons: {
          411101: {
            name: {
              th: 'ศรีสุทโธ',
              en: 'Si Suttho',
            },
            zipcode: '41190',
          },
          411102: {
            name: {
              th: 'บ้านดุง',
              en: 'Ban Dung',
            },
            zipcode: '41190',
          },
          411103: {
            name: {
              th: 'ดงเย็น',
              en: 'Dong Yen',
            },
            zipcode: '41190',
          },
          411104: {
            name: {
              th: 'โพนสูง',
              en: 'Phon Sung',
            },
            zipcode: '41190',
          },
          411105: {
            name: {
              th: 'อ้อมกอ',
              en: 'Om Ko',
            },
            zipcode: '41190',
          },
          411106: {
            name: {
              th: 'บ้านจันทน์',
              en: 'Ban Chan',
            },
            zipcode: '41190',
          },
          411107: {
            name: {
              th: 'บ้านชัย',
              en: 'Ban Chai',
            },
            zipcode: '41190',
          },
          411108: {
            name: {
              th: 'นาไหม',
              en: 'Na Mai',
            },
            zipcode: '41190',
          },
          411109: {
            name: {
              th: 'ถ่อนนาลับ',
              en: 'Thon Na Lap',
            },
            zipcode: '41190',
          },
          411110: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '41190',
          },
          411111: {
            name: {
              th: 'บ้านม่วง',
              en: 'Ban Muang',
            },
            zipcode: '41190',
          },
          411112: {
            name: {
              th: 'บ้านตาด',
              en: 'Ban Tat',
            },
            zipcode: '41190',
          },
          411113: {
            name: {
              th: 'นาคำ',
              en: 'Na Kham',
            },
            zipcode: '41190',
          },
        },
      },
      4117: {
        name: {
          th: 'บ้านผือ',
          en: 'Ban Phu',
        },
        tambons: {
          411701: {
            name: {
              th: 'บ้านผือ',
              en: 'Ban Phue',
            },
            zipcode: '41160',
          },
          411702: {
            name: {
              th: 'หายโศก',
              en: 'Hai Sok',
            },
            zipcode: '41160',
          },
          411703: {
            name: {
              th: 'เขือน้ำ',
              en: 'Khuea Nam',
            },
            zipcode: '41160',
          },
          411704: {
            name: {
              th: 'คำบง',
              en: 'Kham Bong',
            },
            zipcode: '41160',
          },
          411705: {
            name: {
              th: 'โนนทอง',
              en: 'Non Thong',
            },
            zipcode: '41160',
          },
          411706: {
            name: {
              th: 'ข้าวสาร',
              en: 'Khao San',
            },
            zipcode: '41160',
          },
          411707: {
            name: {
              th: 'จำปาโมง',
              en: 'Champa Mong',
            },
            zipcode: '41160',
          },
          411708: {
            name: {
              th: 'กลางใหญ่',
              en: 'Klang Yai',
            },
            zipcode: '41160',
          },
          411709: {
            name: {
              th: 'เมืองพาน',
              en: 'Mueang Phan',
            },
            zipcode: '41160',
          },
          411710: {
            name: {
              th: 'คำด้วง',
              en: 'Kham Duang',
            },
            zipcode: '41160',
          },
          411711: {
            name: {
              th: 'หนองหัวคู',
              en: 'Nong Hua Khu',
            },
            zipcode: '41160',
          },
          411712: {
            name: {
              th: 'บ้านค้อ',
              en: 'Ban Kho',
            },
            zipcode: '41160',
          },
          411713: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '41160',
          },
        },
      },
      4118: {
        name: {
          th: 'น้ำโสม',
          en: 'Nam Som',
        },
        tambons: {
          411801: {
            name: {
              th: 'นางัว',
              en: 'Na Ngua',
            },
            zipcode: '41210',
          },
          411802: {
            name: {
              th: 'น้ำโสม',
              en: 'Nam Som',
            },
            zipcode: '41210',
          },
          411805: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '41210',
          },
          411806: {
            name: {
              th: 'บ้านหยวก',
              en: 'Ban Yuak',
            },
            zipcode: '41210',
          },
          411807: {
            name: {
              th: 'โสมเยี่ยม',
              en: 'Som Yiam',
            },
            zipcode: '41210',
          },
          411810: {
            name: {
              th: 'ศรีสำราญ',
              en: 'Si Samran',
            },
            zipcode: '41210',
          },
          411812: {
            name: {
              th: 'สามัคคี',
              en: 'Samakkhi',
            },
            zipcode: '41210',
          },
        },
      },
      4119: {
        name: {
          th: 'เพ็ญ',
          en: 'Phen',
        },
        tambons: {
          411901: {
            name: {
              th: 'เพ็ญ',
              en: 'Phen',
            },
            zipcode: '41150',
          },
          411902: {
            name: {
              th: 'บ้านธาตุ',
              en: 'Ban That',
            },
            zipcode: '41150',
          },
          411903: {
            name: {
              th: 'นาพู่',
              en: 'Na Phu',
            },
            zipcode: '41150',
          },
          411904: {
            name: {
              th: 'เชียงหวาง',
              en: 'Chiang Wang',
            },
            zipcode: '41150',
          },
          411905: {
            name: {
              th: 'สุมเส้า',
              en: 'Sum Sao',
            },
            zipcode: '41150',
          },
          411906: {
            name: {
              th: 'นาบัว',
              en: 'Na Bua',
            },
            zipcode: '41150',
          },
          411907: {
            name: {
              th: 'บ้านเหล่า',
              en: 'Ban Lao',
            },
            zipcode: '41150',
          },
          411908: {
            name: {
              th: 'จอมศรี',
              en: 'Chom Si',
            },
            zipcode: '41150',
          },
          411909: {
            name: {
              th: 'เตาไห',
              en: 'Tao Hai',
            },
            zipcode: '41150',
          },
          411910: {
            name: {
              th: 'โคกกลาง',
              en: 'Khok Klang',
            },
            zipcode: '41150',
          },
          411911: {
            name: {
              th: 'สร้างแป้น',
              en: 'Sang Paen',
            },
            zipcode: '41150',
          },
        },
      },
      4120: {
        name: {
          th: 'สร้างคอม',
          en: 'Sang Khom',
        },
        tambons: {
          412001: {
            name: {
              th: 'สร้างคอม',
              en: 'Sang Khom',
            },
            zipcode: '41260',
          },
          412002: {
            name: {
              th: 'เชียงดา',
              en: 'Chiang Da',
            },
            zipcode: '41260',
          },
          412003: {
            name: {
              th: 'บ้านยวด',
              en: 'Ban Yuat',
            },
            zipcode: '41260',
          },
          412004: {
            name: {
              th: 'บ้านโคก',
              en: 'Ban Khok',
            },
            zipcode: '41260',
          },
          412005: {
            name: {
              th: 'นาสะอาด',
              en: 'Na Sa-at',
            },
            zipcode: '41260',
          },
          412006: {
            name: {
              th: 'บ้านหินโงม',
              en: 'Ban Hin Ngom',
            },
            zipcode: '41260',
          },
        },
      },
      4121: {
        name: {
          th: 'หนองแสง',
          en: 'Nong Saeng',
        },
        tambons: {
          412101: {
            name: {
              th: 'หนองแสง',
              en: 'Nong Saeng',
            },
            zipcode: '41340',
          },
          412102: {
            name: {
              th: 'แสงสว่าง',
              en: 'Saeng Sawang',
            },
            zipcode: '41340',
          },
          412103: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '41340',
          },
          412104: {
            name: {
              th: 'ทับกุง',
              en: 'Thap Kung',
            },
            zipcode: '41340',
          },
        },
      },
      4122: {
        name: {
          th: 'นายูง',
          en: 'Na Yung',
        },
        tambons: {
          412201: {
            name: {
              th: 'นายูง',
              en: 'Na Yung',
            },
            zipcode: '41380',
          },
          412202: {
            name: {
              th: 'บ้านก้อง',
              en: 'Ban Kong',
            },
            zipcode: '41380',
          },
          412203: {
            name: {
              th: 'นาแค',
              en: 'Na Khae',
            },
            zipcode: '41380',
          },
          412204: {
            name: {
              th: 'โนนทอง',
              en: 'Non Thong',
            },
            zipcode: '41380',
          },
        },
      },
      4123: {
        name: {
          th: 'พิบูลย์รักษ์',
          en: 'Phibun Rak',
        },
        tambons: {
          412301: {
            name: {
              th: 'บ้านแดง',
              en: 'Ban Daeng',
            },
            zipcode: '41130',
          },
          412302: {
            name: {
              th: 'นาทราย',
              en: 'Na Sai',
            },
            zipcode: '41130',
          },
          412303: {
            name: {
              th: 'ดอนกลอย',
              en: 'Don Kloi',
            },
            zipcode: '41130',
          },
        },
      },
      4124: {
        name: {
          th: 'กู่แก้ว',
          en: 'Ku Kaeo',
        },
        tambons: {
          412401: {
            name: {
              th: 'บ้านจีต',
              en: 'Ban Chit',
            },
            zipcode: '41130',
          },
          412402: {
            name: {
              th: 'โนนทองอินทร์',
              en: 'Non Thong In',
            },
            zipcode: '41130',
          },
          412403: {
            name: {
              th: 'ค้อใหญ่',
              en: 'Kho Yai',
            },
            zipcode: '41130',
          },
          412404: {
            name: {
              th: 'คอนสาย',
              en: 'Khon Sai',
            },
            zipcode: '41130',
          },
        },
      },
      4125: {
        name: {
          th: 'ประจักษ์ศิลปาคม',
          en: 'Pra Jak Sil La Pa Kom',
        },
        tambons: {
          412501: {
            name: {
              th: 'นาม่วง',
              en: 'Na Muang',
            },
            zipcode: '41110',
          },
          412502: {
            name: {
              th: 'ห้วยสามพาด',
              en: 'Huai Sam Phat',
            },
            zipcode: '41110',
          },
          412503: {
            name: {
              th: 'อุ่มจาน',
              en: 'Um Chan',
            },
            zipcode: '41110',
          },
        },
      },
    },
  },
  42: {
    name: {
      th: 'เลย',
      en: 'Loei',
    },
    amphoes: {
      4201: {
        name: {
          th: 'เมืองเลย',
          en: 'Muang',
        },
        tambons: {
          420101: {
            name: {
              th: 'กุดป่อง',
              en: 'Kut Pong',
            },
            zipcode: '42000',
          },
          420102: {
            name: {
              th: 'เมือง',
              en: 'Mueang',
            },
            zipcode: '42000',
          },
          420103: {
            name: {
              th: 'นาอ้อ',
              en: 'Na O',
            },
            zipcode: '42100',
          },
          420104: {
            name: {
              th: 'กกดู่',
              en: 'Kok Du',
            },
            zipcode: '42000',
          },
          420105: {
            name: {
              th: 'น้ำหมาน',
              en: 'Nam Man',
            },
            zipcode: '42000',
          },
          420106: {
            name: {
              th: 'เสี้ยว',
              en: 'Siao',
            },
            zipcode: '42000',
          },
          420107: {
            name: {
              th: 'นาอาน',
              en: 'Na An',
            },
            zipcode: '42000',
          },
          420108: {
            name: {
              th: 'นาโป่ง',
              en: 'Na Pong',
            },
            zipcode: '42000',
          },
          420109: {
            name: {
              th: 'นาดินดำ',
              en: 'Na Din Dam',
            },
            zipcode: '42000',
          },
          420110: {
            name: {
              th: 'น้ำสวย',
              en: 'Nam Suai',
            },
            zipcode: '42000',
          },
          420111: {
            name: {
              th: 'ชัยพฤกษ์',
              en: 'Chaiyaphruek',
            },
            zipcode: '42000',
          },
          420112: {
            name: {
              th: 'นาแขม',
              en: 'Na Khaem',
            },
            zipcode: '42000',
          },
          420113: {
            name: {
              th: 'ศรีสองรัก',
              en: 'Si Song Rak',
            },
            zipcode: '42100',
          },
          420114: {
            name: {
              th: 'กกทอง',
              en: 'Kok Thong',
            },
            zipcode: '42000',
          },
        },
      },
      4202: {
        name: {
          th: 'นาด้วง',
          en: 'Na Duang',
        },
        tambons: {
          420201: {
            name: {
              th: 'นาด้วง',
              en: 'Na Duang',
            },
            zipcode: '42210',
          },
          420202: {
            name: {
              th: 'นาดอกคำ',
              en: 'Na Dok Kham',
            },
            zipcode: '42210',
          },
          420203: {
            name: {
              th: 'ท่าสะอาด',
              en: 'Tha Sa-at',
            },
            zipcode: '42210',
          },
          420204: {
            name: {
              th: 'ท่าสวรรค์',
              en: 'Tha Sawan',
            },
            zipcode: '42210',
          },
        },
      },
      4203: {
        name: {
          th: 'เชียงคาน',
          en: 'Chiang Khan',
        },
        tambons: {
          420301: {
            name: {
              th: 'เชียงคาน',
              en: 'Chiang Khan',
            },
            zipcode: '42110',
          },
          420302: {
            name: {
              th: 'ธาตุ',
              en: 'That',
            },
            zipcode: '42110',
          },
          420303: {
            name: {
              th: 'นาซ่าว',
              en: 'Na Sao',
            },
            zipcode: '42110',
          },
          420304: {
            name: {
              th: 'เขาแก้ว',
              en: 'Khao Kaeo',
            },
            zipcode: '42110',
          },
          420305: {
            name: {
              th: 'ปากตม',
              en: 'Pak Tom',
            },
            zipcode: '42110',
          },
          420306: {
            name: {
              th: 'บุฮม',
              en: 'Bu Hom',
            },
            zipcode: '42110',
          },
          420307: {
            name: {
              th: 'จอมศรี',
              en: 'Chom Si',
            },
            zipcode: '42110',
          },
          420308: {
            name: {
              th: 'หาดทรายขาว',
              en: 'Hat Sai Khao',
            },
            zipcode: '42110',
          },
        },
      },
      4204: {
        name: {
          th: 'ปากชม',
          en: 'Pak Chom',
        },
        tambons: {
          420401: {
            name: {
              th: 'ปากชม',
              en: 'Pak Chom',
            },
            zipcode: '42150',
          },
          420402: {
            name: {
              th: 'เชียงกลม',
              en: 'Chiang Klom',
            },
            zipcode: '42150',
          },
          420403: {
            name: {
              th: 'หาดคัมภีร์',
              en: 'Hat Khamphi',
            },
            zipcode: '42150',
          },
          420404: {
            name: {
              th: 'ห้วยบ่อซืน',
              en: 'Huai Bo Suen',
            },
            zipcode: '42150',
          },
          420405: {
            name: {
              th: 'ห้วยพิชัย',
              en: 'Huai Phichai',
            },
            zipcode: '42150',
          },
          420406: {
            name: {
              th: 'ชมเจริญ',
              en: 'Chom Charoen',
            },
            zipcode: '42150',
          },
        },
      },
      4205: {
        name: {
          th: 'ด่านซ้าย',
          en: 'Dan Sai',
        },
        tambons: {
          420501: {
            name: {
              th: 'ด่านซ้าย',
              en: 'Dan Sai',
            },
            zipcode: '42120',
          },
          420502: {
            name: {
              th: 'ปากหมัน',
              en: 'Pak Man',
            },
            zipcode: '42120',
          },
          420503: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '42120',
          },
          420504: {
            name: {
              th: 'โคกงาม',
              en: 'Khok Ngam',
            },
            zipcode: '42120',
          },
          420505: {
            name: {
              th: 'โพนสูง',
              en: 'Phon Sung',
            },
            zipcode: '42120',
          },
          420506: {
            name: {
              th: 'อิปุ่ม',
              en: 'Ipum',
            },
            zipcode: '42120',
          },
          420507: {
            name: {
              th: 'กกสะทอน',
              en: 'Kok Sathon',
            },
            zipcode: '42120',
          },
          420508: {
            name: {
              th: 'โป่ง',
              en: 'Pong',
            },
            zipcode: '42120',
          },
          420509: {
            name: {
              th: 'วังยาว',
              en: 'Wang Yao',
            },
            zipcode: '42120',
          },
          420510: {
            name: {
              th: 'นาหอ',
              en: 'Na Ho',
            },
            zipcode: '42120',
          },
        },
      },
      4206: {
        name: {
          th: 'นาแห้ว',
          en: 'Na Haeo',
        },
        tambons: {
          420601: {
            name: {
              th: 'นาแห้ว',
              en: 'Na Haeo',
            },
            zipcode: '42170',
          },
          420602: {
            name: {
              th: 'แสงภา',
              en: 'Saeng Pha',
            },
            zipcode: '42170',
          },
          420603: {
            name: {
              th: 'นาพึง',
              en: 'Na Phueng',
            },
            zipcode: '42170',
          },
          420604: {
            name: {
              th: 'นามาลา',
              en: 'Na Ma La',
            },
            zipcode: '42170',
          },
          420605: {
            name: {
              th: 'เหล่ากอหก',
              en: 'Lao Ko Hok',
            },
            zipcode: '42170',
          },
        },
      },
      4207: {
        name: {
          th: 'ภูเรือ',
          en: 'Phu Ruea',
        },
        tambons: {
          420701: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '42160',
          },
          420702: {
            name: {
              th: 'ท่าศาลา',
              en: 'Tha Sala',
            },
            zipcode: '42160',
          },
          420703: {
            name: {
              th: 'ร่องจิก',
              en: 'Rong Chik',
            },
            zipcode: '42160',
          },
          420704: {
            name: {
              th: 'ปลาบ่า',
              en: 'Pla Ba',
            },
            zipcode: '42160',
          },
          420705: {
            name: {
              th: 'ลาดค่าง',
              en: 'Lat Khang',
            },
            zipcode: '42160',
          },
          420706: {
            name: {
              th: 'สานตม',
              en: 'San Tom',
            },
            zipcode: '42160',
          },
        },
      },
      4208: {
        name: {
          th: 'ท่าลี่',
          en: 'Tha Li',
        },
        tambons: {
          420801: {
            name: {
              th: 'ท่าลี่',
              en: 'Tha Li',
            },
            zipcode: '42140',
          },
          420802: {
            name: {
              th: 'หนองผือ',
              en: 'Nong Phue',
            },
            zipcode: '42140',
          },
          420803: {
            name: {
              th: 'อาฮี',
              en: 'A Hi',
            },
            zipcode: '42140',
          },
          420804: {
            name: {
              th: 'น้ำแคม',
              en: 'Nam Khaem',
            },
            zipcode: '42140',
          },
          420805: {
            name: {
              th: 'โคกใหญ่',
              en: 'Khok Yai',
            },
            zipcode: '42140',
          },
          420806: {
            name: {
              th: 'น้ำทูน',
              en: 'Nam Thun',
            },
            zipcode: '42140',
          },
        },
      },
      4209: {
        name: {
          th: 'วังสะพุง',
          en: 'Wang Saphung',
        },
        tambons: {
          420901: {
            name: {
              th: 'วังสะพุง',
              en: 'Wang Saphung',
            },
            zipcode: '42130',
          },
          420902: {
            name: {
              th: 'ทรายขาว',
              en: 'Sai Khao',
            },
            zipcode: '42130',
          },
          420903: {
            name: {
              th: 'หนองหญ้าปล้อง',
              en: 'Nong Ya Plong',
            },
            zipcode: '42130',
          },
          420904: {
            name: {
              th: 'หนองงิ้ว',
              en: 'Nong Ngio',
            },
            zipcode: '42130',
          },
          420905: {
            name: {
              th: 'ปากปวน',
              en: 'Pak Puan',
            },
            zipcode: '42130',
          },
          420906: {
            name: {
              th: 'ผาน้อย',
              en: 'Pha Noi',
            },
            zipcode: '42130',
          },
          420910: {
            name: {
              th: 'ผาบิ้ง',
              en: 'Pha Bing',
            },
            zipcode: '42130',
          },
          420911: {
            name: {
              th: 'เขาหลวง',
              en: 'Khao Luang',
            },
            zipcode: '42130',
          },
          420912: {
            name: {
              th: 'โคกขมิ้น',
              en: 'Khok Khamin',
            },
            zipcode: '42130',
          },
          420913: {
            name: {
              th: 'ศรีสงคราม',
              en: 'Si Songkhram',
            },
            zipcode: '42130',
          },
        },
      },
      4210: {
        name: {
          th: 'ภูกระดึง',
          en: 'Phu Kradueng',
        },
        tambons: {
          421001: {
            name: {
              th: 'ศรีฐาน',
              en: 'Si Than',
            },
            zipcode: '42180',
          },
          421005: {
            name: {
              th: 'ผานกเค้า',
              en: 'Pha Nok Khao',
            },
            zipcode: '42180',
          },
          421007: {
            name: {
              th: 'ภูกระดึง',
              en: 'Phu Kradueng',
            },
            zipcode: '42180',
          },
          421010: {
            name: {
              th: 'ห้วยส้ม',
              en: 'Huai Som',
            },
            zipcode: '42180',
          },
        },
      },
      4211: {
        name: {
          th: 'ภูหลวง',
          en: 'Phu Luang',
        },
        tambons: {
          421101: {
            name: {
              th: 'ภูหอ',
              en: 'Phu Ho',
            },
            zipcode: '42230',
          },
          421102: {
            name: {
              th: 'หนองคัน',
              en: 'Nong Khan',
            },
            zipcode: '42230',
          },
          421104: {
            name: {
              th: 'ห้วยสีเสียด',
              en: 'Huai Sisiat',
            },
            zipcode: '42230',
          },
          421105: {
            name: {
              th: 'เลยวังไสย์',
              en: 'Loei Wang Sai',
            },
            zipcode: '42230',
          },
          421106: {
            name: {
              th: 'แก่งศรีภูมิ',
              en: 'Kaeng Si Phum',
            },
            zipcode: '42230',
          },
        },
      },
      4212: {
        name: {
          th: 'ผาขาว',
          en: 'Pha Khao',
        },
        tambons: {
          421201: {
            name: {
              th: 'ผาขาว',
              en: 'Pha Khao',
            },
            zipcode: '42240',
          },
          421202: {
            name: {
              th: 'ท่าช้างคล้อง',
              en: 'Tha Chang Khlong',
            },
            zipcode: '42240',
          },
          421203: {
            name: {
              th: 'โนนปอแดง',
              en: 'Non Po Daeng',
            },
            zipcode: '42240',
          },
          421204: {
            name: {
              th: 'โนนป่าซาง',
              en: 'Non Pa Sang',
            },
            zipcode: '42240',
          },
          421205: {
            name: {
              th: 'บ้านเพิ่ม',
              en: 'Ban Phoem',
            },
            zipcode: '42240',
          },
        },
      },
      4213: {
        name: {
          th: 'เอราวัณ',
          en: 'King Amphoe Erawan',
        },
        tambons: {
          421301: {
            name: {
              th: 'เอราวัณ',
              en: 'Erawan',
            },
            zipcode: '42220',
          },
          421302: {
            name: {
              th: 'ผาอินทร์แปลง',
              en: 'Pha In Plaeng',
            },
            zipcode: '42220',
          },
          421303: {
            name: {
              th: 'ผาสามยอด',
              en: 'Pha Sam Yot',
            },
            zipcode: '42220',
          },
          421304: {
            name: {
              th: 'ทรัพย์ไพวัลย์',
              en: 'Sap Phaiwan',
            },
            zipcode: '42220',
          },
        },
      },
      4214: {
        name: {
          th: 'หนองหิน',
          en: 'King Amphoe Nong Hin',
        },
        tambons: {
          421401: {
            name: {
              th: 'หนองหิน',
              en: 'Nong Hin',
            },
            zipcode: '42190',
          },
          421402: {
            name: {
              th: 'ตาดข่า',
              en: 'Tat Kha',
            },
            zipcode: '42190',
          },
          421403: {
            name: {
              th: 'ปวนพุ',
              en: 'Puan Phu',
            },
            zipcode: '42190',
          },
        },
      },
    },
  },
  43: {
    name: {
      th: 'หนองคาย',
      en: 'Nong Khai',
    },
    amphoes: {
      4301: {
        name: {
          th: 'เมืองหนองคาย',
          en: 'Muang',
        },
        tambons: {
          430101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '43000',
          },
          430102: {
            name: {
              th: 'มีชัย',
              en: 'Mi Chai',
            },
            zipcode: '43000',
          },
          430103: {
            name: {
              th: 'โพธิ์ชัย',
              en: 'Pho Chai',
            },
            zipcode: '43000',
          },
          430104: {
            name: {
              th: 'กวนวัน',
              en: 'Kuan Wan',
            },
            zipcode: '43000',
          },
          430105: {
            name: {
              th: 'เวียงคุก',
              en: 'Wiang Khuk',
            },
            zipcode: '43000',
          },
          430106: {
            name: {
              th: 'วัดธาตุ',
              en: 'Wat That',
            },
            zipcode: '43000',
          },
          430107: {
            name: {
              th: 'หาดคำ',
              en: 'Hat Kham',
            },
            zipcode: '43000',
          },
          430108: {
            name: {
              th: 'หินโงม',
              en: 'Hin Ngom',
            },
            zipcode: '43000',
          },
          430109: {
            name: {
              th: 'บ้านเดื่อ',
              en: 'Ban Duea',
            },
            zipcode: '43000',
          },
          430110: {
            name: {
              th: 'ค่ายบกหวาน',
              en: 'Khai Bok Wan',
            },
            zipcode: '43100',
          },
          430111: {
            name: {
              th: 'โพนสว่าง',
              en: 'Phon Sawang',
            },
            zipcode: '43000',
          },
          430113: {
            name: {
              th: 'พระธาตุบังพวน',
              en: 'Phra That Bang Phuan',
            },
            zipcode: '43100',
          },
          430116: {
            name: {
              th: 'หนองกอมเกาะ',
              en: 'Nong Kom Ko',
            },
            zipcode: '43000',
          },
          430117: {
            name: {
              th: 'ปะโค',
              en: 'Pa Kho',
            },
            zipcode: '43000',
          },
          430118: {
            name: {
              th: 'เมืองหมี',
              en: 'Mueang Mi',
            },
            zipcode: '43000',
          },
          430119: {
            name: {
              th: 'สีกาย',
              en: 'Si Kai',
            },
            zipcode: '43000',
          },
        },
      },
      4302: {
        name: {
          th: 'ท่าบ่อ',
          en: 'Tha Bo',
        },
        tambons: {
          430201: {
            name: {
              th: 'ท่าบ่อ',
              en: 'Tha Bo',
            },
            zipcode: '43110',
          },
          430202: {
            name: {
              th: 'น้ำโมง',
              en: 'Nam Mong',
            },
            zipcode: '43110',
          },
          430203: {
            name: {
              th: 'กองนาง',
              en: 'Kong Nang',
            },
            zipcode: '43110',
          },
          430204: {
            name: {
              th: 'โคกคอน',
              en: 'Khok Khon',
            },
            zipcode: '43110',
          },
          430205: {
            name: {
              th: 'บ้านเดื่อ',
              en: 'Ban Duea',
            },
            zipcode: '43110',
          },
          430206: {
            name: {
              th: 'บ้านถ่อน',
              en: 'Ban Thon',
            },
            zipcode: '43110',
          },
          430207: {
            name: {
              th: 'บ้านว่าน',
              en: 'Ban Wan',
            },
            zipcode: '43110',
          },
          430208: {
            name: {
              th: 'นาข่า',
              en: 'Na Kha',
            },
            zipcode: '43110',
          },
          430209: {
            name: {
              th: 'โพนสา',
              en: 'Phon Sa',
            },
            zipcode: '43110',
          },
          430210: {
            name: {
              th: 'หนองนาง',
              en: 'Nong Nang',
            },
            zipcode: '43110',
          },
        },
      },
      4305: {
        name: {
          th: 'โพนพิสัย',
          en: 'Phon Phisai',
        },
        tambons: {
          430501: {
            name: {
              th: 'จุมพล',
              en: 'Chumphon',
            },
            zipcode: '43120',
          },
          430502: {
            name: {
              th: 'วัดหลวง',
              en: 'Wat Luang',
            },
            zipcode: '43120',
          },
          430503: {
            name: {
              th: 'กุดบง',
              en: 'Kut Bong',
            },
            zipcode: '43120',
          },
          430504: {
            name: {
              th: 'ชุมช้าง',
              en: 'Chum Chang',
            },
            zipcode: '43120',
          },
          430506: {
            name: {
              th: 'ทุ่งหลวง',
              en: 'Thung Luang',
            },
            zipcode: '43120',
          },
          430507: {
            name: {
              th: 'เหล่าต่างคำ',
              en: 'Lao Tang Kham',
            },
            zipcode: '43120',
          },
          430508: {
            name: {
              th: 'นาหนัง',
              en: 'Na Nang',
            },
            zipcode: '43120',
          },
          430509: {
            name: {
              th: 'เซิม',
              en: 'Soem',
            },
            zipcode: '43120',
          },
          430513: {
            name: {
              th: 'บ้านโพธิ์',
              en: 'Ban Pho',
            },
            zipcode: '43120',
          },
          430521: {
            name: {
              th: 'บ้านผือ',
              en: 'Ban Phue',
            },
            zipcode: '43120',
          },
          430522: {
            name: {
              th: 'สร้างนางขาว',
              en: 'Sang Nang Khao',
            },
            zipcode: '43120',
          },
        },
      },
      4307: {
        name: {
          th: 'ศรีเชียงใหม่',
          en: 'Sri Chaing Mai',
        },
        tambons: {
          430701: {
            name: {
              th: 'พานพร้าว',
              en: 'Phan Phrao',
            },
            zipcode: '43130',
          },
          430703: {
            name: {
              th: 'บ้านหม้อ',
              en: 'Ban Mo',
            },
            zipcode: '43130',
          },
          430704: {
            name: {
              th: 'พระพุทธบาท',
              en: 'Phra Phutthabat',
            },
            zipcode: '43130',
          },
          430705: {
            name: {
              th: 'หนองปลาปาก',
              en: 'Nong Pla Pak',
            },
            zipcode: '43130',
          },
        },
      },
      4308: {
        name: {
          th: 'สังคม',
          en: 'Sangkhom',
        },
        tambons: {
          430801: {
            name: {
              th: 'แก้งไก่',
              en: 'Kaeng Kai',
            },
            zipcode: '43160',
          },
          430802: {
            name: {
              th: 'ผาตั้ง',
              en: 'Pha Tang',
            },
            zipcode: '43160',
          },
          430803: {
            name: {
              th: 'บ้านม่วง',
              en: 'Ban Muang',
            },
            zipcode: '43160',
          },
          430804: {
            name: {
              th: 'นางิ้ว',
              en: 'Na Ngio',
            },
            zipcode: '43160',
          },
          430805: {
            name: {
              th: 'สังคม',
              en: 'Sangkhom',
            },
            zipcode: '43160',
          },
        },
      },
      4314: {
        name: {
          th: 'สระใคร',
          en: 'King Amphoe Sa Khai',
        },
        tambons: {
          431401: {
            name: {
              th: 'สระใคร',
              en: 'Sakhrai',
            },
            zipcode: '43100',
          },
          431402: {
            name: {
              th: 'คอกช้าง',
              en: 'Khok Chang',
            },
            zipcode: '43100',
          },
          431403: {
            name: {
              th: 'บ้านฝาง',
              en: 'Ban Fang',
            },
            zipcode: '43100',
          },
        },
      },
      4315: {
        name: {
          th: 'เฝ้าไร่',
          en: 'Fao Rai',
        },
        tambons: {
          431501: {
            name: {
              th: 'เฝ้าไร่',
              en: 'Fao Rai',
            },
            zipcode: '43120',
          },
          431502: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '43120',
          },
          431503: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '43120',
          },
          431504: {
            name: {
              th: 'วังหลวง',
              en: 'Wang Luang',
            },
            zipcode: '43120',
          },
          431505: {
            name: {
              th: 'อุดมพร',
              en: 'Udom Phon',
            },
            zipcode: '43120',
          },
        },
      },
      4316: {
        name: {
          th: 'รัตนวาปี',
          en: 'King Amphoe Rat Ana Wapi',
        },
        tambons: {
          431601: {
            name: {
              th: 'รัตนวาปี',
              en: 'Rattanawapi',
            },
            zipcode: '43120',
          },
          431602: {
            name: {
              th: 'นาทับไฮ',
              en: 'Na Thap Hai',
            },
            zipcode: '43120',
          },
          431603: {
            name: {
              th: 'บ้านต้อน',
              en: 'Ban Ton',
            },
            zipcode: '43120',
          },
          431604: {
            name: {
              th: 'พระบาทนาสิงห์',
              en: 'Phra Bat Na Sing',
            },
            zipcode: '43120',
          },
          431605: {
            name: {
              th: 'โพนแพง',
              en: 'Phon Phaeng',
            },
            zipcode: '43120',
          },
        },
      },
      4317: {
        name: {
          th: 'โพธิ์ตาก',
          en: 'King Amphoe Pho Tak',
        },
        tambons: {
          431701: {
            name: {
              th: 'โพธิ์ตาก',
              en: 'Pho Tak',
            },
            zipcode: '43130',
          },
          431702: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '43130',
          },
          431703: {
            name: {
              th: 'ด่านศรีสุข',
              en: 'Dan Si Suk',
            },
            zipcode: '43130',
          },
        },
      },
    },
  },
  44: {
    name: {
      th: 'มหาสารคาม',
      en: 'Maha Sarakham',
    },
    amphoes: {
      4401: {
        name: {
          th: 'เมืองมหาสารคาม',
          en: 'Muang',
        },
        tambons: {
          440101: {
            name: {
              th: 'ตลาด',
              en: 'Talat',
            },
            zipcode: '44000',
          },
          440102: {
            name: {
              th: 'เขวา',
              en: 'Khwao',
            },
            zipcode: '44000',
          },
          440103: {
            name: {
              th: 'ท่าตูม',
              en: 'Tha Tum',
            },
            zipcode: '44000',
          },
          440104: {
            name: {
              th: 'แวงน่าง',
              en: 'Waeng Nang',
            },
            zipcode: '44000',
          },
          440105: {
            name: {
              th: 'โคกก่อ',
              en: 'Khok Ko',
            },
            zipcode: '44000',
          },
          440106: {
            name: {
              th: 'ดอนหว่าน',
              en: 'Don Wan',
            },
            zipcode: '44000',
          },
          440107: {
            name: {
              th: 'เกิ้ง',
              en: 'Koeng',
            },
            zipcode: '44000',
          },
          440108: {
            name: {
              th: 'แก่งเลิงจาน',
              en: 'Kaeng Loeng Chan',
            },
            zipcode: '44000',
          },
          440109: {
            name: {
              th: 'ท่าสองคอน',
              en: 'Tha Song Khon',
            },
            zipcode: '44000',
          },
          440110: {
            name: {
              th: 'ลาดพัฒนา',
              en: 'Lat Phatthana',
            },
            zipcode: '44000',
          },
          440111: {
            name: {
              th: 'หนองปลิง',
              en: 'Nong Pling',
            },
            zipcode: '44000',
          },
          440112: {
            name: {
              th: 'ห้วยแอ่ง',
              en: 'Huai Aeng',
            },
            zipcode: '44000',
          },
          440113: {
            name: {
              th: 'หนองโน',
              en: 'Nong No',
            },
            zipcode: '44000',
          },
          440114: {
            name: {
              th: 'บัวค้อ',
              en: 'Bua Kho',
            },
            zipcode: '44000',
          },
        },
      },
      4402: {
        name: {
          th: 'แกดำ',
          en: 'Kao Dam',
        },
        tambons: {
          440201: {
            name: {
              th: 'แกดำ',
              en: 'Kae Dam',
            },
            zipcode: '44190',
          },
          440202: {
            name: {
              th: 'วังแสง',
              en: 'Wang Saeng',
            },
            zipcode: '44190',
          },
          440203: {
            name: {
              th: 'มิตรภาพ',
              en: 'Mittraphap',
            },
            zipcode: '44190',
          },
          440204: {
            name: {
              th: 'หนองกุง',
              en: 'Nong Kung',
            },
            zipcode: '44190',
          },
          440205: {
            name: {
              th: 'โนนภิบาล',
              en: 'Non Phi Ban',
            },
            zipcode: '44190',
          },
        },
      },
      4403: {
        name: {
          th: 'โกสุมพิสัย',
          en: 'Kosum Phisai',
        },
        tambons: {
          440301: {
            name: {
              th: 'หัวขวาง',
              en: 'Hua Khwang',
            },
            zipcode: '44140',
          },
          440302: {
            name: {
              th: 'ยางน้อย',
              en: 'Yang Noi',
            },
            zipcode: '44140',
          },
          440303: {
            name: {
              th: 'วังยาว',
              en: 'Wang Yao',
            },
            zipcode: '44140',
          },
          440304: {
            name: {
              th: 'เขวาไร่',
              en: 'Khwao Rai',
            },
            zipcode: '44140',
          },
          440305: {
            name: {
              th: 'แพง',
              en: 'Phaeng',
            },
            zipcode: '44140',
          },
          440306: {
            name: {
              th: 'แก้งแก',
              en: 'Kaeng Kae',
            },
            zipcode: '44140',
          },
          440307: {
            name: {
              th: 'หนองเหล็ก',
              en: 'Nong Lek',
            },
            zipcode: '44140',
          },
          440308: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '44140',
          },
          440309: {
            name: {
              th: 'เหล่า',
              en: 'Lao',
            },
            zipcode: '44140',
          },
          440310: {
            name: {
              th: 'เขื่อน',
              en: 'Khuean',
            },
            zipcode: '44140',
          },
          440311: {
            name: {
              th: 'หนองบอน',
              en: 'Nong Bon',
            },
            zipcode: '44140',
          },
          440312: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '44140',
          },
          440313: {
            name: {
              th: 'ยางท่าแจ้ง',
              en: 'Yang Tha Chaeng',
            },
            zipcode: '44140',
          },
          440314: {
            name: {
              th: 'แห่ใต้',
              en: 'Hae Tai',
            },
            zipcode: '44140',
          },
          440315: {
            name: {
              th: 'หนองกุงสวรรค์',
              en: 'Nong Kung Sawan',
            },
            zipcode: '44140',
          },
          440316: {
            name: {
              th: 'เลิงใต้',
              en: 'Loeng Tai',
            },
            zipcode: '44140',
          },
          440317: {
            name: {
              th: 'ดอนกลาง',
              en: 'Don Klang',
            },
            zipcode: '44140',
          },
        },
      },
      4404: {
        name: {
          th: 'กันทรวิชัย',
          en: 'Kanthara Wichai',
        },
        tambons: {
          440401: {
            name: {
              th: 'โคกพระ',
              en: 'Khok Phra',
            },
            zipcode: '44150',
          },
          440402: {
            name: {
              th: 'คันธารราษฎร์',
              en: 'Khanthararat',
            },
            zipcode: '44150',
          },
          440403: {
            name: {
              th: 'มะค่า',
              en: 'Makha',
            },
            zipcode: '44150',
          },
          440404: {
            name: {
              th: 'ท่าขอนยาง',
              en: 'Tha Khon Yang',
            },
            zipcode: '44150',
          },
          440405: {
            name: {
              th: 'นาสีนวน',
              en: 'Na Si Nuan',
            },
            zipcode: '44150',
          },
          440406: {
            name: {
              th: 'ขามเรียง',
              en: 'Kham Riang',
            },
            zipcode: '44150',
          },
          440407: {
            name: {
              th: 'เขวาใหญ่',
              en: 'Khwao Yai',
            },
            zipcode: '44150',
          },
          440408: {
            name: {
              th: 'ศรีสุข',
              en: 'Si Suk',
            },
            zipcode: '44150',
          },
          440409: {
            name: {
              th: 'กุดใส้จ่อ',
              en: 'Kut Sai Cho',
            },
            zipcode: '44150',
          },
          440410: {
            name: {
              th: 'ขามเฒ่าพัฒนา',
              en: 'Kham Thao Phatthana',
            },
            zipcode: '44150',
          },
        },
      },
      4405: {
        name: {
          th: 'เชียงยืน',
          en: 'Chiang Yun',
        },
        tambons: {
          440501: {
            name: {
              th: 'เชียงยืน',
              en: 'Chiang Yuen',
            },
            zipcode: '44160',
          },
          440503: {
            name: {
              th: 'หนองซอน',
              en: 'Nong Son',
            },
            zipcode: '44160',
          },
          440505: {
            name: {
              th: 'ดอนเงิน',
              en: 'Don Ngoen',
            },
            zipcode: '44160',
          },
          440506: {
            name: {
              th: 'กู่ทอง',
              en: 'Ku Thong',
            },
            zipcode: '44160',
          },
          440507: {
            name: {
              th: 'นาทอง',
              en: 'Na Thong',
            },
            zipcode: '44160',
          },
          440508: {
            name: {
              th: 'เสือเฒ่า',
              en: 'Suea Thao',
            },
            zipcode: '44160',
          },
          440511: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '44160',
          },
          440512: {
            name: {
              th: 'เหล่าบัวบาน',
              en: 'Lao Bua Ban',
            },
            zipcode: '44160',
          },
        },
      },
      4406: {
        name: {
          th: 'บรบือ',
          en: 'Borabu',
        },
        tambons: {
          440601: {
            name: {
              th: 'บรบือ',
              en: 'Borabue',
            },
            zipcode: '44130',
          },
          440602: {
            name: {
              th: 'บ่อใหญ่',
              en: 'Bo Yai',
            },
            zipcode: '44130',
          },
          440604: {
            name: {
              th: 'วังไชย',
              en: 'Wang Chai',
            },
            zipcode: '44130',
          },
          440605: {
            name: {
              th: 'หนองม่วง',
              en: 'Nong Muang',
            },
            zipcode: '44130',
          },
          440606: {
            name: {
              th: 'กำพี้',
              en: 'Kamphi',
            },
            zipcode: '44130',
          },
          440607: {
            name: {
              th: 'โนนราษี',
              en: 'Non Rasi',
            },
            zipcode: '44130',
          },
          440608: {
            name: {
              th: 'โนนแดง',
              en: 'Non Daeng',
            },
            zipcode: '44130',
          },
          440610: {
            name: {
              th: 'หนองจิก',
              en: 'Nong Chik',
            },
            zipcode: '44130',
          },
          440611: {
            name: {
              th: 'บัวมาศ',
              en: 'Bua Mat',
            },
            zipcode: '44130',
          },
          440613: {
            name: {
              th: 'หนองคูขาด',
              en: 'Nong Khu Khat',
            },
            zipcode: '44130',
          },
          440615: {
            name: {
              th: 'วังใหม่',
              en: 'Wang Mai',
            },
            zipcode: '44130',
          },
          440616: {
            name: {
              th: 'ยาง',
              en: 'Yang',
            },
            zipcode: '44130',
          },
          440618: {
            name: {
              th: 'หนองสิม',
              en: 'Nong Sim',
            },
            zipcode: '44130',
          },
          440619: {
            name: {
              th: 'หนองโก',
              en: 'Nong Ko',
            },
            zipcode: '44130',
          },
          440620: {
            name: {
              th: 'ดอนงัว',
              en: 'Don Ngua',
            },
            zipcode: '44130',
          },
        },
      },
      4407: {
        name: {
          th: 'นาเชือก',
          en: 'Na Chuak',
        },
        tambons: {
          440701: {
            name: {
              th: 'นาเชือก',
              en: 'Na Chueak',
            },
            zipcode: '44170',
          },
          440702: {
            name: {
              th: 'สำโรง',
              en: 'Samrong',
            },
            zipcode: '44170',
          },
          440703: {
            name: {
              th: 'หนองแดง',
              en: 'Nong Daeng',
            },
            zipcode: '44170',
          },
          440704: {
            name: {
              th: 'เขวาไร่',
              en: 'Khwao Rai',
            },
            zipcode: '44170',
          },
          440705: {
            name: {
              th: 'หนองโพธิ์',
              en: 'Nong Pho',
            },
            zipcode: '44170',
          },
          440706: {
            name: {
              th: 'ปอพาน',
              en: 'Po Phan',
            },
            zipcode: '44170',
          },
          440707: {
            name: {
              th: 'หนองเม็ก',
              en: 'Nong Mek',
            },
            zipcode: '44170',
          },
          440708: {
            name: {
              th: 'หนองเรือ',
              en: 'Nong Ruea',
            },
            zipcode: '44170',
          },
          440709: {
            name: {
              th: 'หนองกุง',
              en: 'Nong Kung',
            },
            zipcode: '44170',
          },
          440710: {
            name: {
              th: 'สันป่าตอง',
              en: 'San Pa Tong',
            },
            zipcode: '44170',
          },
        },
      },
      4408: {
        name: {
          th: 'พยัคฆภูมิพิสัย',
          en: 'Phayakhaphum Phisai',
        },
        tambons: {
          440801: {
            name: {
              th: 'ปะหลาน',
              en: 'Palan',
            },
            zipcode: '44110',
          },
          440802: {
            name: {
              th: 'ก้ามปู',
              en: 'Kam Pu',
            },
            zipcode: '44110',
          },
          440803: {
            name: {
              th: 'เวียงสะอาด',
              en: 'Wiang Sa-at',
            },
            zipcode: '44110',
          },
          440804: {
            name: {
              th: 'เม็กดำ',
              en: 'Mek Dam',
            },
            zipcode: '44110',
          },
          440805: {
            name: {
              th: 'นาสีนวล',
              en: 'Na Si Nuan',
            },
            zipcode: '44110',
          },
          440809: {
            name: {
              th: 'ราษฎร์เจริญ',
              en: 'Rat Charoen',
            },
            zipcode: '44110',
          },
          440810: {
            name: {
              th: 'หนองบัวแก้ว',
              en: 'Nong Bua Kaeo',
            },
            zipcode: '44110',
          },
          440812: {
            name: {
              th: 'เมืองเตา',
              en: 'Mueang Tao',
            },
            zipcode: '44110',
          },
          440815: {
            name: {
              th: 'ลานสะแก',
              en: 'Lan Sakae',
            },
            zipcode: '44110',
          },
          440816: {
            name: {
              th: 'เวียงชัย',
              en: 'Wiang Chai',
            },
            zipcode: '44110',
          },
          440817: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '44110',
          },
          440818: {
            name: {
              th: 'ราษฎร์พัฒนา',
              en: 'Rat Phatthana',
            },
            zipcode: '44110',
          },
          440819: {
            name: {
              th: 'เมืองเสือ',
              en: 'Mueang Suea',
            },
            zipcode: '44110',
          },
          440820: {
            name: {
              th: 'ภารแอ่น',
              en: 'Phan Aen',
            },
            zipcode: '44110',
          },
        },
      },
      4409: {
        name: {
          th: 'วาปีปทุม',
          en: 'Wapi Pathum',
        },
        tambons: {
          440901: {
            name: {
              th: 'หนองแสง',
              en: 'Nong Saeng',
            },
            zipcode: '44120',
          },
          440902: {
            name: {
              th: 'ขามป้อม',
              en: 'Kham Pom',
            },
            zipcode: '44120',
          },
          440903: {
            name: {
              th: 'เสือโก้ก',
              en: 'Suea Kok',
            },
            zipcode: '44120',
          },
          440904: {
            name: {
              th: 'ดงใหญ่',
              en: 'Dong Yai',
            },
            zipcode: '44120',
          },
          440905: {
            name: {
              th: 'โพธิ์ชัย',
              en: 'Pho Chai',
            },
            zipcode: '44120',
          },
          440906: {
            name: {
              th: 'หัวเรือ',
              en: 'Hua Ruea',
            },
            zipcode: '44120',
          },
          440907: {
            name: {
              th: 'แคน',
              en: 'Khaen',
            },
            zipcode: '44120',
          },
          440908: {
            name: {
              th: 'งัวบา',
              en: 'Ngua Ba',
            },
            zipcode: '44120',
          },
          440909: {
            name: {
              th: 'นาข่า',
              en: 'Na Kha',
            },
            zipcode: '44120',
          },
          440910: {
            name: {
              th: 'บ้านหวาย',
              en: 'Ban Wai',
            },
            zipcode: '44120',
          },
          440911: {
            name: {
              th: 'หนองไฮ',
              en: 'Nong Hai',
            },
            zipcode: '44120',
          },
          440912: {
            name: {
              th: 'ประชาพัฒนา',
              en: 'Pracha Phatthana',
            },
            zipcode: '44120',
          },
          440913: {
            name: {
              th: 'หนองทุ่ม',
              en: 'Nong Thum',
            },
            zipcode: '44120',
          },
          440914: {
            name: {
              th: 'หนองแสน',
              en: 'Nong Saen',
            },
            zipcode: '44120',
          },
          440915: {
            name: {
              th: 'โคกสีทองหลาง',
              en: 'Khok Si Thonglang',
            },
            zipcode: '44120',
          },
        },
      },
      4410: {
        name: {
          th: 'นาดูน',
          en: 'Na Dun',
        },
        tambons: {
          441001: {
            name: {
              th: 'นาดูน',
              en: 'Na Dun',
            },
            zipcode: '44180',
          },
          441002: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '44180',
          },
          441003: {
            name: {
              th: 'หนองคู',
              en: 'Nong Khu',
            },
            zipcode: '44180',
          },
          441004: {
            name: {
              th: 'ดงบัง',
              en: 'Dong Bang',
            },
            zipcode: '44180',
          },
          441005: {
            name: {
              th: 'ดงดวน',
              en: 'Dong Duan',
            },
            zipcode: '44180',
          },
          441006: {
            name: {
              th: 'หัวดง',
              en: 'Hua Dong',
            },
            zipcode: '44180',
          },
          441007: {
            name: {
              th: 'ดงยาง',
              en: 'Dong Yang',
            },
            zipcode: '44180',
          },
          441008: {
            name: {
              th: 'กู่สันตรัตน์',
              en: 'Ku Santarat',
            },
            zipcode: '44180',
          },
          441009: {
            name: {
              th: 'พระธาตุ',
              en: 'Phra That',
            },
            zipcode: '44180',
          },
        },
      },
      4411: {
        name: {
          th: 'ยางสีสุราช',
          en: 'Yang Si Surat',
        },
        tambons: {
          441101: {
            name: {
              th: 'ยางสีสุราช',
              en: 'Yang Sisurat',
            },
            zipcode: '44210',
          },
          441102: {
            name: {
              th: 'นาภู',
              en: 'Na Phu',
            },
            zipcode: '44210',
          },
          441103: {
            name: {
              th: 'แวงดง',
              en: 'Waeng Dong',
            },
            zipcode: '44210',
          },
          441104: {
            name: {
              th: 'บ้านกู่',
              en: 'Ban Ku',
            },
            zipcode: '44210',
          },
          441105: {
            name: {
              th: 'ดงเมือง',
              en: 'Dong Mueang',
            },
            zipcode: '44210',
          },
          441106: {
            name: {
              th: 'สร้างแซ่ง',
              en: 'Sang Saeng',
            },
            zipcode: '44210',
          },
          441107: {
            name: {
              th: 'หนองบัวสันตุ',
              en: 'Nong Bua Santu',
            },
            zipcode: '44210',
          },
        },
      },
      4412: {
        name: {
          th: 'กุดรัง',
          en: 'Kut Rang',
        },
        tambons: {
          441201: {
            name: {
              th: 'กุดรัง',
              en: 'Kut Rang',
            },
            zipcode: '44130',
          },
          441202: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '44130',
          },
          441203: {
            name: {
              th: 'เลิงแฝก',
              en: 'Loeng Faek',
            },
            zipcode: '44130',
          },
          441204: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '44130',
          },
          441205: {
            name: {
              th: 'ห้วยเตย',
              en: 'Huai Toei',
            },
            zipcode: '44130',
          },
        },
      },
      4413: {
        name: {
          th: 'ชื่นชม',
          en: 'Chun Chom',
        },
        tambons: {
          441301: {
            name: {
              th: 'ชื่นชม',
              en: 'Chuen Chom',
            },
            zipcode: '44160',
          },
          441302: {
            name: {
              th: 'กุดปลาดุก',
              en: 'Kut Pla Duk',
            },
            zipcode: '44160',
          },
          441303: {
            name: {
              th: 'เหล่าดอกไม้',
              en: 'Lao Dok Mai',
            },
            zipcode: '44160',
          },
          441304: {
            name: {
              th: 'หนองกุง',
              en: 'Nong Kung',
            },
            zipcode: '44160',
          },
        },
      },
    },
  },
  45: {
    name: {
      th: 'ร้อยเอ็ด',
      en: 'Roi Et',
    },
    amphoes: {
      4501: {
        name: {
          th: 'เมืองร้อยเอ็ด',
          en: 'Muang',
        },
        tambons: {
          450101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '45000',
          },
          450102: {
            name: {
              th: 'รอบเมือง',
              en: 'Rop Mueang',
            },
            zipcode: '45000',
          },
          450103: {
            name: {
              th: 'เหนือเมือง',
              en: 'Nuea Mueang',
            },
            zipcode: '45000',
          },
          450104: {
            name: {
              th: 'ขอนแก่น',
              en: 'Khon Kaen',
            },
            zipcode: '45000',
          },
          450105: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '45000',
          },
          450106: {
            name: {
              th: 'สะอาดสมบูรณ์',
              en: 'Sa-at Sombun',
            },
            zipcode: '45000',
          },
          450108: {
            name: {
              th: 'สีแก้ว',
              en: 'Si Kaeo',
            },
            zipcode: '45000',
          },
          450109: {
            name: {
              th: 'ปอภาร  (ปอพาน)',
              en: 'Po Phan',
            },
            zipcode: '45000',
          },
          450110: {
            name: {
              th: 'โนนรัง',
              en: 'Non Rang',
            },
            zipcode: '45000',
          },
          450117: {
            name: {
              th: 'หนองแก้ว',
              en: 'Nong Kaeo',
            },
            zipcode: '45000',
          },
          450118: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '45000',
          },
          450120: {
            name: {
              th: 'ดงลาน',
              en: 'Dong Lan',
            },
            zipcode: '45000',
          },
          450123: {
            name: {
              th: 'แคนใหญ่',
              en: 'Khaen Yai',
            },
            zipcode: '45000',
          },
          450124: {
            name: {
              th: 'โนนตาล',
              en: 'Non Tan',
            },
            zipcode: '45000',
          },
          450125: {
            name: {
              th: 'เมืองทอง',
              en: 'Mueang Thong',
            },
            zipcode: '45000',
          },
        },
      },
      4502: {
        name: {
          th: 'เกษตรวิสัย',
          en: 'Kaset Wisai',
        },
        tambons: {
          450201: {
            name: {
              th: 'เกษตรวิสัย',
              en: 'Kaset Wisai',
            },
            zipcode: '45150',
          },
          450202: {
            name: {
              th: 'เมืองบัว',
              en: 'Mueang Bua',
            },
            zipcode: '45150',
          },
          450203: {
            name: {
              th: 'เหล่าหลวง',
              en: 'Lao Luang',
            },
            zipcode: '45150',
          },
          450204: {
            name: {
              th: 'สิงห์โคก',
              en: 'Sing Khok',
            },
            zipcode: '45150',
          },
          450205: {
            name: {
              th: 'ดงครั่งใหญ่',
              en: 'Dong Khrang Yai',
            },
            zipcode: '45150',
          },
          450206: {
            name: {
              th: 'บ้านฝาง',
              en: 'Ban Fang',
            },
            zipcode: '45150',
          },
          450207: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '45150',
          },
          450208: {
            name: {
              th: 'กำแพง',
              en: 'Kamphaeng',
            },
            zipcode: '45150',
          },
          450209: {
            name: {
              th: 'กู่กาสิงห์',
              en: 'Ku Ka Sing',
            },
            zipcode: '45150',
          },
          450210: {
            name: {
              th: 'น้ำอ้อม',
              en: 'Nam Om',
            },
            zipcode: '45150',
          },
          450211: {
            name: {
              th: 'โนนสว่าง',
              en: 'Non Sawang',
            },
            zipcode: '45150',
          },
          450212: {
            name: {
              th: 'ทุ่งทอง',
              en: 'Thung Thong',
            },
            zipcode: '45150',
          },
          450213: {
            name: {
              th: 'ดงครั่งน้อย',
              en: 'Dong Khrang Noi',
            },
            zipcode: '45150',
          },
        },
      },
      4503: {
        name: {
          th: 'ปทุมรัตต์',
          en: 'Pathum Rat',
        },
        tambons: {
          450301: {
            name: {
              th: 'บัวแดง',
              en: 'Bua Daeng',
            },
            zipcode: '45190',
          },
          450302: {
            name: {
              th: 'ดอกล้ำ',
              en: 'Dok Lam',
            },
            zipcode: '45190',
          },
          450303: {
            name: {
              th: 'หนองแคน',
              en: 'Nong Khaen',
            },
            zipcode: '45190',
          },
          450304: {
            name: {
              th: 'โพนสูง',
              en: 'Phon Sung',
            },
            zipcode: '45190',
          },
          450305: {
            name: {
              th: 'โนนสวรรค์',
              en: 'Non Sawan',
            },
            zipcode: '45190',
          },
          450306: {
            name: {
              th: 'สระบัว',
              en: 'Sa Bua',
            },
            zipcode: '45190',
          },
          450307: {
            name: {
              th: 'โนนสง่า',
              en: 'Non Sa-nga',
            },
            zipcode: '45190',
          },
          450308: {
            name: {
              th: 'ขี้เหล็ก',
              en: 'Khilek',
            },
            zipcode: '45190',
          },
        },
      },
      4504: {
        name: {
          th: 'จตุรพักตรพิมาน',
          en: 'Chaturaphak Phiman',
        },
        tambons: {
          450401: {
            name: {
              th: 'หัวช้าง',
              en: 'Hua Chang',
            },
            zipcode: '45180',
          },
          450402: {
            name: {
              th: 'หนองผือ',
              en: 'Nong Phue',
            },
            zipcode: '45180',
          },
          450403: {
            name: {
              th: 'เมืองหงส์',
              en: 'Mueang Hong',
            },
            zipcode: '45180',
          },
          450404: {
            name: {
              th: 'โคกล่าม',
              en: 'Khok Lam',
            },
            zipcode: '45180',
          },
          450405: {
            name: {
              th: 'น้ำใส',
              en: 'Nam Sai',
            },
            zipcode: '45180',
          },
          450406: {
            name: {
              th: 'ดงแดง',
              en: 'Dong Daeng',
            },
            zipcode: '45180',
          },
          450407: {
            name: {
              th: 'ดงกลาง',
              en: 'Dong Klang',
            },
            zipcode: '45180',
          },
          450408: {
            name: {
              th: 'ป่าสังข์',
              en: 'Pa Sang',
            },
            zipcode: '45180',
          },
          450409: {
            name: {
              th: 'อีง่อง',
              en: 'I Ngong',
            },
            zipcode: '45180',
          },
          450410: {
            name: {
              th: 'ลิ้นฟ้า',
              en: 'Lin Fa',
            },
            zipcode: '45180',
          },
          450411: {
            name: {
              th: 'ดู่น้อย',
              en: 'Du Noi',
            },
            zipcode: '45180',
          },
          450412: {
            name: {
              th: 'ศรีโคตร',
              en: 'Si Khot',
            },
            zipcode: '45180',
          },
        },
      },
      4505: {
        name: {
          th: 'ธวัชบุรี',
          en: 'Thawatchaburi',
        },
        tambons: {
          450501: {
            name: {
              th: 'นิเวศน์',
              en: 'Niwet',
            },
            zipcode: '45170',
          },
          450502: {
            name: {
              th: 'ธงธานี',
              en: 'Thong Thani',
            },
            zipcode: '45170',
          },
          450503: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '45170',
          },
          450504: {
            name: {
              th: 'ธวัชบุรี',
              en: 'Thawat Buri',
            },
            zipcode: '45170',
          },
          450506: {
            name: {
              th: 'อุ่มเม้า',
              en: 'Um Mao',
            },
            zipcode: '45170',
          },
          450507: {
            name: {
              th: 'มะอึ',
              en: 'Ma-ue',
            },
            zipcode: '45170',
          },
          450510: {
            name: {
              th: 'เขวาทุ่ง',
              en: 'Khwao Thung',
            },
            zipcode: '45170',
          },
          450515: {
            name: {
              th: 'ไพศาล',
              en: 'Phaisan',
            },
            zipcode: '45170',
          },
          450517: {
            name: {
              th: 'เมืองน้อย',
              en: 'Mueang Noi',
            },
            zipcode: '45170',
          },
          450520: {
            name: {
              th: 'บึงนคร',
              en: 'Bueng Nakhon',
            },
            zipcode: '45170',
          },
          450522: {
            name: {
              th: 'ราชธานี',
              en: 'Ratchathani',
            },
            zipcode: '45170',
          },
          450524: {
            name: {
              th: 'หนองพอก',
              en: 'Nong Phok',
            },
            zipcode: '45170',
          },
        },
      },
      4506: {
        name: {
          th: 'พนมไพร',
          en: 'Panom Phrai',
        },
        tambons: {
          450601: {
            name: {
              th: 'พนมไพร',
              en: 'Phanom Phrai',
            },
            zipcode: '45140',
          },
          450602: {
            name: {
              th: 'แสนสุข',
              en: 'Saen Suk',
            },
            zipcode: '45140',
          },
          450603: {
            name: {
              th: 'กุดน้ำใส',
              en: 'Kut Nam Sai',
            },
            zipcode: '45140',
          },
          450604: {
            name: {
              th: 'หนองทัพไทย',
              en: 'Nong Thap Thai',
            },
            zipcode: '45140',
          },
          450605: {
            name: {
              th: 'โพธิ์ใหญ่',
              en: 'Pho Yai',
            },
            zipcode: '45140',
          },
          450606: {
            name: {
              th: 'วารีสวัสดิ์',
              en: 'Wari Sawat',
            },
            zipcode: '45140',
          },
          450607: {
            name: {
              th: 'โคกสว่าง',
              en: 'Khok Sawang',
            },
            zipcode: '45140',
          },
          450611: {
            name: {
              th: 'โพธิ์ชัย',
              en: 'Pho Chai',
            },
            zipcode: '45140',
          },
          450612: {
            name: {
              th: 'นานวล',
              en: 'Na Nuan',
            },
            zipcode: '45140',
          },
          450613: {
            name: {
              th: 'คำไฮ',
              en: 'Kham Hai',
            },
            zipcode: '45140',
          },
          450614: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '45140',
          },
          450615: {
            name: {
              th: 'ค้อใหญ่',
              en: 'Kho Yai',
            },
            zipcode: '45140',
          },
          450617: {
            name: {
              th: 'ชานุวรรณ',
              en: 'Chanuwan',
            },
            zipcode: '45140',
          },
        },
      },
      4507: {
        name: {
          th: 'โพนทอง',
          en: 'Phon Thong',
        },
        tambons: {
          450701: {
            name: {
              th: 'แวง',
              en: 'Waeng',
            },
            zipcode: '45110',
          },
          450702: {
            name: {
              th: 'โคกกกม่วง',
              en: 'Khok Kok Muang',
            },
            zipcode: '45110',
          },
          450703: {
            name: {
              th: 'นาอุดม',
              en: 'Na Udom',
            },
            zipcode: '45110',
          },
          450704: {
            name: {
              th: 'สว่าง',
              en: 'Sawang',
            },
            zipcode: '45110',
          },
          450705: {
            name: {
              th: 'หนองใหญ่',
              en: 'Nong Yai',
            },
            zipcode: '45110',
          },
          450706: {
            name: {
              th: 'โพธิ์ทอง',
              en: 'Pho Thong',
            },
            zipcode: '45110',
          },
          450707: {
            name: {
              th: 'โนนชัยศรี',
              en: 'Non Chai Si',
            },
            zipcode: '45110',
          },
          450708: {
            name: {
              th: 'โพธิ์ศรีสว่าง',
              en: 'Pho Si Sawang',
            },
            zipcode: '45110',
          },
          450709: {
            name: {
              th: 'อุ่มเม่า',
              en: 'Um Mao',
            },
            zipcode: '45110',
          },
          450710: {
            name: {
              th: 'คำนาดี',
              en: 'Kham Na Di',
            },
            zipcode: '45110',
          },
          450711: {
            name: {
              th: 'พรมสวรรค์',
              en: 'Phrom Sawan',
            },
            zipcode: '45110',
          },
          450712: {
            name: {
              th: 'สระนกแก้ว',
              en: 'Sa Nok Kaeo',
            },
            zipcode: '45110',
          },
          450713: {
            name: {
              th: 'วังสามัคคี',
              en: 'Wang Samakkhi',
            },
            zipcode: '45110',
          },
          450714: {
            name: {
              th: 'โคกสูง',
              en: 'Khok Sung',
            },
            zipcode: '45110',
          },
        },
      },
      4508: {
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        tambons: {
          450801: {
            name: {
              th: 'ขามเปี้ย',
              en: 'Kham Pia',
            },
            zipcode: '45230',
          },
          450802: {
            name: {
              th: 'เชียงใหม่',
              en: 'Chiang Mai',
            },
            zipcode: '45230',
          },
          450803: {
            name: {
              th: 'บัวคำ',
              en: 'Bua Kham',
            },
            zipcode: '45230',
          },
          450804: {
            name: {
              th: 'อัคคะคำ',
              en: 'Akkha Kham',
            },
            zipcode: '45230',
          },
          450805: {
            name: {
              th: 'สะอาด',
              en: 'Sa-at',
            },
            zipcode: '45230',
          },
          450806: {
            name: {
              th: 'คำพอุง',
              en: 'Kham Pha-ung',
            },
            zipcode: '45230',
          },
          450807: {
            name: {
              th: 'หนองตาไก้',
              en: 'Nong Ta Kai',
            },
            zipcode: '45230',
          },
          450808: {
            name: {
              th: 'ดอนโอง',
              en: 'Don Ong',
            },
            zipcode: '45230',
          },
          450809: {
            name: {
              th: 'โพธิ์ศรี',
              en: 'Pho Si',
            },
            zipcode: '45230',
          },
        },
      },
      4509: {
        name: {
          th: 'หนองพอก',
          en: 'Nong Phok',
        },
        tambons: {
          450901: {
            name: {
              th: 'หนองพอก',
              en: 'Nong Phok',
            },
            zipcode: '45210',
          },
          450902: {
            name: {
              th: 'บึงงาม',
              en: 'Bueng Ngam',
            },
            zipcode: '45210',
          },
          450903: {
            name: {
              th: 'ภูเขาทอง',
              en: 'Phukhao Thong',
            },
            zipcode: '45210',
          },
          450904: {
            name: {
              th: 'กกโพธิ์',
              en: 'Kok Pho',
            },
            zipcode: '45210',
          },
          450905: {
            name: {
              th: 'โคกสว่าง',
              en: 'Khok Sawang',
            },
            zipcode: '45210',
          },
          450906: {
            name: {
              th: 'หนองขุ่นใหญ่',
              en: 'Nong Khun Yai',
            },
            zipcode: '45210',
          },
          450907: {
            name: {
              th: 'รอบเมือง',
              en: 'Rop Mueang',
            },
            zipcode: '45210',
          },
          450908: {
            name: {
              th: 'ผาน้ำย้อย',
              en: 'Pha Nam Yoi',
            },
            zipcode: '45210',
          },
          450909: {
            name: {
              th: 'ท่าสีดา',
              en: 'Tha Sida',
            },
            zipcode: '45210',
          },
        },
      },
      4510: {
        name: {
          th: 'เสลภูมิ',
          en: 'Selaphum',
        },
        tambons: {
          451001: {
            name: {
              th: 'กลาง',
              en: 'Klang',
            },
            zipcode: '45120',
          },
          451002: {
            name: {
              th: 'นางาม',
              en: 'Na Ngam',
            },
            zipcode: '45120',
          },
          451003: {
            name: {
              th: 'เมืองไพร',
              en: 'Mueang Phrai',
            },
            zipcode: '45120',
          },
          451004: {
            name: {
              th: 'นาแซง',
              en: 'Na Saeng',
            },
            zipcode: '45120',
          },
          451005: {
            name: {
              th: 'นาเมือง',
              en: 'Na Mueang',
            },
            zipcode: '45120',
          },
          451006: {
            name: {
              th: 'วังหลวง',
              en: 'Wang Luang',
            },
            zipcode: '45120',
          },
          451007: {
            name: {
              th: 'ท่าม่วง',
              en: 'Tha Muang',
            },
            zipcode: '45120',
          },
          451008: {
            name: {
              th: 'ขวาว',
              en: 'Khwao',
            },
            zipcode: '45120',
          },
          451009: {
            name: {
              th: 'โพธิ์ทอง',
              en: 'Pho Thong',
            },
            zipcode: '45120',
          },
          451010: {
            name: {
              th: 'ภูเงิน',
              en: 'Phu Ngoen',
            },
            zipcode: '45120',
          },
          451011: {
            name: {
              th: 'เกาะแก้ว',
              en: 'Ko Kaeo',
            },
            zipcode: '45120',
          },
          451012: {
            name: {
              th: 'นาเลิง',
              en: 'Na Loeng',
            },
            zipcode: '45120',
          },
          451013: {
            name: {
              th: 'เหล่าน้อย',
              en: 'Lao Noi',
            },
            zipcode: '45120',
          },
          451014: {
            name: {
              th: 'ศรีวิลัย',
              en: 'Si Wilai',
            },
            zipcode: '45120',
          },
          451015: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '45120',
          },
          451016: {
            name: {
              th: 'พรสวรรค์',
              en: 'Phon Sawan',
            },
            zipcode: '45120',
          },
          451017: {
            name: {
              th: 'ขวัญเมือง',
              en: 'Khwan Mueang',
            },
            zipcode: '45120',
          },
          451018: {
            name: {
              th: 'บึงเกลือ',
              en: 'Bueng Kluea',
            },
            zipcode: '45120',
          },
        },
      },
      4511: {
        name: {
          th: 'สุวรรณภูมิ',
          en: 'Suwannaphum',
        },
        tambons: {
          451101: {
            name: {
              th: 'สระคู',
              en: 'Sa Khu',
            },
            zipcode: '45130',
          },
          451102: {
            name: {
              th: 'ดอกไม้',
              en: 'Dok Mai',
            },
            zipcode: '45130',
          },
          451103: {
            name: {
              th: 'นาใหญ่',
              en: 'Na Yai',
            },
            zipcode: '45130',
          },
          451104: {
            name: {
              th: 'หินกอง',
              en: 'Hin Kong',
            },
            zipcode: '45130',
          },
          451105: {
            name: {
              th: 'เมืองทุ่ง',
              en: 'Mueang Thung',
            },
            zipcode: '45130',
          },
          451106: {
            name: {
              th: 'หัวโทน',
              en: 'Hua Thon',
            },
            zipcode: '45130',
          },
          451107: {
            name: {
              th: 'บ่อพันขัน',
              en: 'Bo Phan Khan',
            },
            zipcode: '45130',
          },
          451108: {
            name: {
              th: 'ทุ่งหลวง',
              en: 'Thung Luang',
            },
            zipcode: '45130',
          },
          451109: {
            name: {
              th: 'หัวช้าง',
              en: 'Hua Chang',
            },
            zipcode: '45130',
          },
          451110: {
            name: {
              th: 'น้ำคำ',
              en: 'Nam Kham',
            },
            zipcode: '45130',
          },
          451111: {
            name: {
              th: 'ห้วยหินลาด',
              en: 'Huai Hin Lat',
            },
            zipcode: '45130',
          },
          451112: {
            name: {
              th: 'ช้างเผือก',
              en: 'Chang Phueak',
            },
            zipcode: '45130',
          },
          451113: {
            name: {
              th: 'ทุ่งกุลา',
              en: 'Thung Kula',
            },
            zipcode: '45130',
          },
          451114: {
            name: {
              th: 'ทุ่งศรีเมือง',
              en: 'Thung Si Mueang',
            },
            zipcode: '45130',
          },
          451115: {
            name: {
              th: 'จำปาขัน',
              en: 'Champa Khan',
            },
            zipcode: '45130',
          },
        },
      },
      4512: {
        name: {
          th: 'เมืองสรวง',
          en: 'Muang Suang',
        },
        tambons: {
          451201: {
            name: {
              th: 'หนองผือ',
              en: 'Nong Phue',
            },
            zipcode: '45220',
          },
          451202: {
            name: {
              th: 'หนองหิน',
              en: 'Nong Hin',
            },
            zipcode: '45220',
          },
          451203: {
            name: {
              th: 'คูเมือง',
              en: 'Khu Mueang',
            },
            zipcode: '45220',
          },
          451204: {
            name: {
              th: 'กกกุง',
              en: 'Kok Kung',
            },
            zipcode: '45220',
          },
          451205: {
            name: {
              th: 'เมืองสรวง',
              en: 'Mueang Suang',
            },
            zipcode: '45220',
          },
        },
      },
      4513: {
        name: {
          th: 'โพนทราย',
          en: 'Phon Sai',
        },
        tambons: {
          451301: {
            name: {
              th: 'โพนทราย',
              en: 'Phon Sai',
            },
            zipcode: '45240',
          },
          451302: {
            name: {
              th: 'สามขา',
              en: 'Sam Kha',
            },
            zipcode: '45240',
          },
          451303: {
            name: {
              th: 'ศรีสว่าง',
              en: 'Si Sawang',
            },
            zipcode: '45240',
          },
          451304: {
            name: {
              th: 'ยางคำ',
              en: 'Yang Kham',
            },
            zipcode: '45240',
          },
          451305: {
            name: {
              th: 'ท่าหาดยาว',
              en: 'Tha Hat Yao',
            },
            zipcode: '45240',
          },
        },
      },
      4514: {
        name: {
          th: 'อาจสามารถ',
          en: 'At Samat',
        },
        tambons: {
          451401: {
            name: {
              th: 'อาจสามารถ',
              en: 'At Samat',
            },
            zipcode: '45160',
          },
          451402: {
            name: {
              th: 'โพนเมือง',
              en: 'Phon Mueang',
            },
            zipcode: '45160',
          },
          451403: {
            name: {
              th: 'บ้านแจ้ง',
              en: 'Ban Chaeng',
            },
            zipcode: '45160',
          },
          451404: {
            name: {
              th: 'หน่อม',
              en: 'Nom',
            },
            zipcode: '45160',
          },
          451405: {
            name: {
              th: 'หนองหมื่นถ่าน',
              en: 'Nong Muen Than',
            },
            zipcode: '45160',
          },
          451406: {
            name: {
              th: 'หนองขาม',
              en: 'Nong Kham',
            },
            zipcode: '45160',
          },
          451407: {
            name: {
              th: 'โหรา',
              en: 'Hora',
            },
            zipcode: '45160',
          },
          451408: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '45160',
          },
          451409: {
            name: {
              th: 'ขี้เหล็ก',
              en: 'Khilek',
            },
            zipcode: '45160',
          },
          451410: {
            name: {
              th: 'บ้านดู่',
              en: 'Ban Du',
            },
            zipcode: '45160',
          },
        },
      },
      4515: {
        name: {
          th: 'เมยวดี',
          en: 'Moi Wadi',
        },
        tambons: {
          451501: {
            name: {
              th: 'เมยวดี',
              en: 'Moei Wadi',
            },
            zipcode: '45250',
          },
          451502: {
            name: {
              th: 'ชุมพร',
              en: 'Chumphon',
            },
            zipcode: '45250',
          },
          451503: {
            name: {
              th: 'บุ่งเลิศ',
              en: 'Bung Loet',
            },
            zipcode: '45250',
          },
          451504: {
            name: {
              th: 'ชมสะอาด',
              en: 'Chom Sa-at',
            },
            zipcode: '45250',
          },
        },
      },
      4516: {
        name: {
          th: 'ศรีสมเด็จ',
          en: 'Srisomdet',
        },
        tambons: {
          451601: {
            name: {
              th: 'โพธิ์ทอง',
              en: 'Pho Thong',
            },
            zipcode: '45000',
          },
          451602: {
            name: {
              th: 'ศรีสมเด็จ',
              en: 'Si Somdet',
            },
            zipcode: '45000',
          },
          451603: {
            name: {
              th: 'เมืองเปลือย',
              en: 'Mueang Plueai',
            },
            zipcode: '45000',
          },
          451604: {
            name: {
              th: 'หนองใหญ่',
              en: 'Nong Yai',
            },
            zipcode: '45000',
          },
          451605: {
            name: {
              th: 'สวนจิก',
              en: 'Suan Chik',
            },
            zipcode: '45280',
          },
          451606: {
            name: {
              th: 'โพธิ์สัย',
              en: 'Phosai',
            },
            zipcode: '45280',
          },
          451607: {
            name: {
              th: 'หนองแวงควง',
              en: 'Nong Waeng Khuang',
            },
            zipcode: '45000',
          },
          451608: {
            name: {
              th: 'บ้านบาก',
              en: 'Ban Bak',
            },
            zipcode: '45000',
          },
        },
      },
      4517: {
        name: {
          th: 'จังหาร',
          en: 'Jung Han',
        },
        tambons: {
          451701: {
            name: {
              th: 'ดินดำ',
              en: 'Din Dam',
            },
            zipcode: '45000',
          },
          451702: {
            name: {
              th: 'ปาฝา',
              en: 'Pa Fa',
            },
            zipcode: '45000',
          },
          451703: {
            name: {
              th: 'ม่วงลาด',
              en: 'Muang Lat',
            },
            zipcode: '45000',
          },
          451704: {
            name: {
              th: 'จังหาร',
              en: 'Changhan',
            },
            zipcode: '45000',
          },
          451705: {
            name: {
              th: 'ดงสิงห์',
              en: 'Dong Sing',
            },
            zipcode: '45000',
          },
          451706: {
            name: {
              th: 'ยางใหญ่',
              en: 'Yang Yai',
            },
            zipcode: '45000',
          },
          451707: {
            name: {
              th: 'ผักแว่น',
              en: 'Phak Waen',
            },
            zipcode: '45000',
          },
          451708: {
            name: {
              th: 'แสนชาติ',
              en: 'Saen Chat',
            },
            zipcode: '45000',
          },
        },
      },
      4518: {
        name: {
          th: 'เชียงขวัญ',
          en: 'Chiang Khwan',
        },
        tambons: {
          451801: {
            name: {
              th: 'เชียงขวัญ',
              en: 'Chiang Khwan',
            },
            zipcode: '45000',
          },
          451802: {
            name: {
              th: 'พลับพลา',
              en: 'Phlapphla',
            },
            zipcode: '45170',
          },
          451803: {
            name: {
              th: 'พระธาตุ',
              en: 'Phra That',
            },
            zipcode: '45000',
          },
          451804: {
            name: {
              th: 'พระเจ้า',
              en: 'Phra Chao',
            },
            zipcode: '45000',
          },
          451805: {
            name: {
              th: 'หมูม้น',
              en: 'Mu Mon',
            },
            zipcode: '45170',
          },
          451806: {
            name: {
              th: 'บ้านเขือง',
              en: 'Ban Khueang',
            },
            zipcode: '45000',
          },
        },
      },
      4519: {
        name: {
          th: 'หนองฮี',
          en: 'King Amphoe Nong Hee',
        },
        tambons: {
          451901: {
            name: {
              th: 'หนองฮี',
              en: 'Nong Hi',
            },
            zipcode: '45140',
          },
          451902: {
            name: {
              th: 'สาวแห',
              en: 'Sao Hae',
            },
            zipcode: '45140',
          },
          451903: {
            name: {
              th: 'ดูกอึ่ง',
              en: 'Duk Ueng',
            },
            zipcode: '45140',
          },
          451904: {
            name: {
              th: 'เด่นราษฎร์',
              en: 'Den Rat',
            },
            zipcode: '45140',
          },
        },
      },
      4520: {
        name: {
          th: 'ทุ่งเขาหลวง',
          en: 'Thung Kao Luang',
        },
        tambons: {
          452001: {
            name: {
              th: 'ทุ่งเขาหลวง',
              en: 'Thung Khao Luang',
            },
            zipcode: '45170',
          },
          452002: {
            name: {
              th: 'เทอดไทย',
              en: 'Thoet Thai',
            },
            zipcode: '45170',
          },
          452003: {
            name: {
              th: 'บึงงาม',
              en: 'Bueng Ngam',
            },
            zipcode: '45170',
          },
          452004: {
            name: {
              th: 'มะบ้า',
              en: 'Maba',
            },
            zipcode: '45170',
          },
          452005: {
            name: {
              th: 'เหล่า',
              en: 'Lao',
            },
            zipcode: '45170',
          },
        },
      },
    },
  },
  46: {
    name: {
      th: 'กาฬสินธุ์',
      en: 'Kalasin',
    },
    amphoes: {
      4601: {
        name: {
          th: 'เมืองกาฬสินธุ์',
          en: 'Muang',
        },
        tambons: {
          460101: {
            name: {
              th: 'กาฬสินธุ์',
              en: 'Kalasin',
            },
            zipcode: '46000',
          },
          460102: {
            name: {
              th: 'เหนือ',
              en: 'Nuea',
            },
            zipcode: '46000',
          },
          460103: {
            name: {
              th: 'หลุบ',
              en: 'Lup',
            },
            zipcode: '46000',
          },
          460104: {
            name: {
              th: 'ไผ่',
              en: 'Phai',
            },
            zipcode: '46000',
          },
          460105: {
            name: {
              th: 'ลำปาว',
              en: 'Lam Pao',
            },
            zipcode: '46000',
          },
          460106: {
            name: {
              th: 'ลำพาน',
              en: 'Lam Phan',
            },
            zipcode: '46000',
          },
          460107: {
            name: {
              th: 'เชียงเครือ',
              en: 'Chiang Khruea',
            },
            zipcode: '46000',
          },
          460108: {
            name: {
              th: 'บึงวิชัย',
              en: 'Bueng Wichai',
            },
            zipcode: '46000',
          },
          460109: {
            name: {
              th: 'ห้วยโพธิ์',
              en: 'Huai Pho',
            },
            zipcode: '46000',
          },
          460111: {
            name: {
              th: 'ภูปอ',
              en: 'Phu Po',
            },
            zipcode: '46000',
          },
          460113: {
            name: {
              th: 'ภูดิน',
              en: 'Phu Din',
            },
            zipcode: '46000',
          },
          460115: {
            name: {
              th: 'หนองกุง',
              en: 'Nong Kung',
            },
            zipcode: '46000',
          },
          460116: {
            name: {
              th: 'กลางหมื่น',
              en: 'Klang Muen',
            },
            zipcode: '46000',
          },
          460117: {
            name: {
              th: 'ขมิ้น',
              en: 'Khamin',
            },
            zipcode: '46000',
          },
          460119: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '46000',
          },
          460120: {
            name: {
              th: 'นาจารย์',
              en: 'Na Chan',
            },
            zipcode: '46000',
          },
          460121: {
            name: {
              th: 'ลำคลอง',
              en: 'Lam Khlong',
            },
            zipcode: '46000',
          },
        },
      },
      4602: {
        name: {
          th: 'นามน',
          en: 'Na Mon',
        },
        tambons: {
          460201: {
            name: {
              th: 'นามน',
              en: 'Na Mon',
            },
            zipcode: '46230',
          },
          460202: {
            name: {
              th: 'ยอดแกง',
              en: 'Yot Kaeng',
            },
            zipcode: '46230',
          },
          460203: {
            name: {
              th: 'สงเปลือย',
              en: 'Song Plueai',
            },
            zipcode: '46230',
          },
          460204: {
            name: {
              th: 'หลักเหลี่ยม',
              en: 'Lak Liam',
            },
            zipcode: '46230',
          },
          460205: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '46230',
          },
        },
      },
      4603: {
        name: {
          th: 'กมลาไสย',
          en: 'Kamalasai',
        },
        tambons: {
          460301: {
            name: {
              th: 'กมลาไสย',
              en: 'Kamalasai',
            },
            zipcode: '46130',
          },
          460302: {
            name: {
              th: 'หลักเมือง',
              en: 'Lak Mueang',
            },
            zipcode: '46130',
          },
          460303: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '46130',
          },
          460304: {
            name: {
              th: 'ดงลิง',
              en: 'Dong Ling',
            },
            zipcode: '46130',
          },
          460305: {
            name: {
              th: 'ธัญญา',
              en: 'Thanya',
            },
            zipcode: '46130',
          },
          460308: {
            name: {
              th: 'หนองแปน',
              en: 'Nong Paen',
            },
            zipcode: '46130',
          },
          460310: {
            name: {
              th: 'เจ้าท่า',
              en: 'Chao Tha',
            },
            zipcode: '46130',
          },
          460311: {
            name: {
              th: 'โคกสมบูรณ์',
              en: 'Khok Sombun',
            },
            zipcode: '46130',
          },
        },
      },
      4604: {
        name: {
          th: 'ร่องคำ',
          en: 'Rong Kham',
        },
        tambons: {
          460401: {
            name: {
              th: 'ร่องคำ',
              en: 'Rong Kham',
            },
            zipcode: '46210',
          },
          460402: {
            name: {
              th: 'สามัคคี',
              en: 'Samakkhi',
            },
            zipcode: '46210',
          },
          460403: {
            name: {
              th: 'เหล่าอ้อย',
              en: 'Lao Oi',
            },
            zipcode: '46210',
          },
        },
      },
      4605: {
        name: {
          th: 'กุฉินารายณ์',
          en: 'Kuchinarai',
        },
        tambons: {
          460501: {
            name: {
              th: 'บัวขาว',
              en: 'Bua Khao',
            },
            zipcode: '46110',
          },
          460502: {
            name: {
              th: 'แจนแลน',
              en: 'Chaen Laen',
            },
            zipcode: '46110',
          },
          460503: {
            name: {
              th: 'เหล่าใหญ่',
              en: 'Lao Yai',
            },
            zipcode: '46110',
          },
          460504: {
            name: {
              th: 'จุมจัง',
              en: 'Chum Chang',
            },
            zipcode: '46110',
          },
          460505: {
            name: {
              th: 'เหล่าไฮงาม',
              en: 'Lao Hai Ngam',
            },
            zipcode: '46110',
          },
          460506: {
            name: {
              th: 'กุดหว้า',
              en: 'Kut Wa',
            },
            zipcode: '46110',
          },
          460507: {
            name: {
              th: 'สามขา',
              en: 'Sam Kha',
            },
            zipcode: '46110',
          },
          460508: {
            name: {
              th: 'นาขาม',
              en: 'Na Kham',
            },
            zipcode: '46110',
          },
          460509: {
            name: {
              th: 'หนองห้าง',
              en: 'Nong Hang',
            },
            zipcode: '46110',
          },
          460510: {
            name: {
              th: 'นาโก',
              en: 'Na Ko',
            },
            zipcode: '46110',
          },
          460511: {
            name: {
              th: 'สมสะอาด',
              en: 'Som Sa-at',
            },
            zipcode: '46110',
          },
          460512: {
            name: {
              th: 'กุดค้าว',
              en: 'Kut Khao',
            },
            zipcode: '46110',
          },
        },
      },
      4606: {
        name: {
          th: 'เขาวง',
          en: 'Khao Wong',
        },
        tambons: {
          460601: {
            name: {
              th: 'คุ้มเก่า',
              en: 'Khum Kao',
            },
            zipcode: '46160',
          },
          460602: {
            name: {
              th: 'สงเปลือย',
              en: 'Song Plueai',
            },
            zipcode: '46160',
          },
          460603: {
            name: {
              th: 'หนองผือ',
              en: 'Nong Phue',
            },
            zipcode: '46160',
          },
          460606: {
            name: {
              th: 'กุดสิมคุ้มใหม่',
              en: 'Kut Sim Khum Mai',
            },
            zipcode: '46160',
          },
          460608: {
            name: {
              th: 'สระพังทอง',
              en: 'Saphang Thong',
            },
            zipcode: '46160',
          },
          460611: {
            name: {
              th: 'กุดปลาค้าว',
              en: 'Kut Pla Khao',
            },
            zipcode: '46160',
          },
        },
      },
      4607: {
        name: {
          th: 'ยางตลาด',
          en: 'Yang Talat',
        },
        tambons: {
          460701: {
            name: {
              th: 'ยางตลาด',
              en: 'Yang Talat',
            },
            zipcode: '46120',
          },
          460702: {
            name: {
              th: 'หัวงัว',
              en: 'Hua Ngua',
            },
            zipcode: '46120',
          },
          460703: {
            name: {
              th: 'อุ่มเม่า',
              en: 'Um Mao',
            },
            zipcode: '46120',
          },
          460704: {
            name: {
              th: 'บัวบาน',
              en: 'Bua Ban',
            },
            zipcode: '46120',
          },
          460705: {
            name: {
              th: 'เว่อ',
              en: 'Woe',
            },
            zipcode: '46120',
          },
          460706: {
            name: {
              th: 'อิตื้อ',
              en: 'Itue',
            },
            zipcode: '46120',
          },
          460707: {
            name: {
              th: 'หัวนาคำ',
              en: 'Hua Na Kham',
            },
            zipcode: '46120',
          },
          460708: {
            name: {
              th: 'หนองอิเฒ่า',
              en: 'Nong I Thao',
            },
            zipcode: '46120',
          },
          460709: {
            name: {
              th: 'ดอนสมบูรณ์',
              en: 'Don Sombun',
            },
            zipcode: '46120',
          },
          460710: {
            name: {
              th: 'นาเชือก',
              en: 'Na Chueak',
            },
            zipcode: '46120',
          },
          460711: {
            name: {
              th: 'คลองขาม',
              en: 'Khlong Kham',
            },
            zipcode: '46120',
          },
          460712: {
            name: {
              th: 'เขาพระนอน',
              en: 'Khao Phra Non',
            },
            zipcode: '46120',
          },
          460713: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '46120',
          },
          460714: {
            name: {
              th: 'โนนสูง',
              en: 'Non Sung',
            },
            zipcode: '46120',
          },
          460715: {
            name: {
              th: 'หนองตอกแป้น',
              en: 'Nong Tok Paen',
            },
            zipcode: '46120',
          },
        },
      },
      4608: {
        name: {
          th: 'ห้วยเม็ก',
          en: 'Huai Mek',
        },
        tambons: {
          460801: {
            name: {
              th: 'ห้วยเม็ก',
              en: 'Huai Mek',
            },
            zipcode: '46170',
          },
          460802: {
            name: {
              th: 'คำใหญ่',
              en: 'Kham Yai',
            },
            zipcode: '46170',
          },
          460803: {
            name: {
              th: 'กุดโดน',
              en: 'Kut Don',
            },
            zipcode: '46170',
          },
          460804: {
            name: {
              th: 'บึงนาเรียง',
              en: 'Bueng Na Riang',
            },
            zipcode: '46170',
          },
          460805: {
            name: {
              th: 'หัวหิน',
              en: 'Hua Hin',
            },
            zipcode: '46170',
          },
          460806: {
            name: {
              th: 'พิมูล',
              en: 'Phimun',
            },
            zipcode: '46170',
          },
          460807: {
            name: {
              th: 'คำเหมือดแก้ว',
              en: 'Kham Mueat Kaeo',
            },
            zipcode: '46170',
          },
          460808: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '46170',
          },
          460809: {
            name: {
              th: 'ทรายทอง',
              en: 'Sai Thong',
            },
            zipcode: '46170',
          },
        },
      },
      4609: {
        name: {
          th: 'สหัสขันธ์',
          en: 'Sahasakan',
        },
        tambons: {
          460901: {
            name: {
              th: 'ภูสิงห์',
              en: 'Phu Sing',
            },
            zipcode: '46140',
          },
          460902: {
            name: {
              th: 'สหัสขันธ์',
              en: 'Sahatsakhan',
            },
            zipcode: '46140',
          },
          460903: {
            name: {
              th: 'นามะเขือ',
              en: 'Na Makhuea',
            },
            zipcode: '46140',
          },
          460904: {
            name: {
              th: 'โนนศิลา',
              en: 'Non Sila',
            },
            zipcode: '46140',
          },
          460905: {
            name: {
              th: 'นิคม',
              en: 'Nikhom',
            },
            zipcode: '46140',
          },
          460906: {
            name: {
              th: 'โนนแหลมทอง',
              en: 'Non Laem Thong',
            },
            zipcode: '46140',
          },
          460907: {
            name: {
              th: 'โนนบุรี',
              en: 'Non Buri',
            },
            zipcode: '46140',
          },
          460908: {
            name: {
              th: 'โนนน้ำเกลี้ยง',
              en: 'Non Nam Kliang',
            },
            zipcode: '46140',
          },
        },
      },
      4610: {
        name: {
          th: 'คำม่วง',
          en: 'Khum Muang',
        },
        tambons: {
          461001: {
            name: {
              th: 'ทุ่งคลอง',
              en: 'Thung Khlong',
            },
            zipcode: '46180',
          },
          461002: {
            name: {
              th: 'โพน',
              en: 'Phon',
            },
            zipcode: '46180',
          },
          461005: {
            name: {
              th: 'ดินจี่',
              en: 'Din Chi',
            },
            zipcode: '46180',
          },
          461006: {
            name: {
              th: 'นาบอน',
              en: 'Na Bon',
            },
            zipcode: '46180',
          },
          461007: {
            name: {
              th: 'นาทัน',
              en: 'Na Than',
            },
            zipcode: '46180',
          },
          461009: {
            name: {
              th: 'เนินยาง',
              en: 'Noen Yang',
            },
            zipcode: '46180',
          },
        },
      },
      4611: {
        name: {
          th: 'ท่าคันโท',
          en: 'Tha Khantho',
        },
        tambons: {
          461101: {
            name: {
              th: 'ท่าคันโท',
              en: 'Tha Khantho',
            },
            zipcode: '46190',
          },
          461102: {
            name: {
              th: 'กุงเก่า',
              en: 'Kung Kao',
            },
            zipcode: '46190',
          },
          461103: {
            name: {
              th: 'ยางอู้ม',
              en: 'Yang Um',
            },
            zipcode: '46190',
          },
          461104: {
            name: {
              th: 'กุดจิก',
              en: 'Kut Chik',
            },
            zipcode: '46190',
          },
          461105: {
            name: {
              th: 'นาตาล',
              en: 'Na Tan',
            },
            zipcode: '46190',
          },
          461106: {
            name: {
              th: 'ดงสมบูรณ์',
              en: 'Dong Sombun',
            },
            zipcode: '46190',
          },
        },
      },
      4612: {
        name: {
          th: 'หนองกุงศรี',
          en: 'Nong Kung Sri',
        },
        tambons: {
          461201: {
            name: {
              th: 'หนองกุงศรี',
              en: 'Nong Kung Si',
            },
            zipcode: '46220',
          },
          461202: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '46220',
          },
          461203: {
            name: {
              th: 'โคกเครือ',
              en: 'Khok Khruea',
            },
            zipcode: '46220',
          },
          461204: {
            name: {
              th: 'หนองสรวง',
              en: 'Nong Suang',
            },
            zipcode: '46220',
          },
          461205: {
            name: {
              th: 'เสาเล้า',
              en: 'Sao Lao',
            },
            zipcode: '46220',
          },
          461206: {
            name: {
              th: 'หนองใหญ่',
              en: 'Nong Yai',
            },
            zipcode: '46220',
          },
          461207: {
            name: {
              th: 'ดงมูล',
              en: 'Dong Mun',
            },
            zipcode: '46220',
          },
          461208: {
            name: {
              th: 'ลำหนองแสน',
              en: 'Lam Nong Saen',
            },
            zipcode: '46220',
          },
          461209: {
            name: {
              th: 'หนองหิน',
              en: 'Nong Hin',
            },
            zipcode: '46220',
          },
        },
      },
      4613: {
        name: {
          th: 'สมเด็จ',
          en: 'Somdet',
        },
        tambons: {
          461301: {
            name: {
              th: 'สมเด็จ',
              en: 'Somdet',
            },
            zipcode: '46150',
          },
          461302: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '46150',
          },
          461303: {
            name: {
              th: 'แซงบาดาล',
              en: 'Saeng Badan',
            },
            zipcode: '46150',
          },
          461304: {
            name: {
              th: 'มหาไชย',
              en: 'Maha Chai',
            },
            zipcode: '46150',
          },
          461305: {
            name: {
              th: 'หมูม่น',
              en: 'Mu Mon',
            },
            zipcode: '46150',
          },
          461306: {
            name: {
              th: 'ผาเสวย',
              en: 'Pha Sawoei',
            },
            zipcode: '46150',
          },
          461307: {
            name: {
              th: 'ศรีสมเด็จ',
              en: 'Si Somdet',
            },
            zipcode: '46150',
          },
          461308: {
            name: {
              th: 'ลำห้วยหลัว',
              en: 'Lam Huai Lua',
            },
            zipcode: '46150',
          },
        },
      },
      4614: {
        name: {
          th: 'ห้วยผึ้ง',
          en: 'Huai Phung',
        },
        tambons: {
          461401: {
            name: {
              th: 'คำบง',
              en: 'Kham Bong',
            },
            zipcode: '46240',
          },
          461402: {
            name: {
              th: 'ไค้นุ่น',
              en: 'Khai Nun',
            },
            zipcode: '46240',
          },
          461403: {
            name: {
              th: 'นิคมห้วยผึ้ง',
              en: 'Nikhom Huai Phueng',
            },
            zipcode: '46240',
          },
          461404: {
            name: {
              th: 'หนองอีบุตร',
              en: 'Nong I But',
            },
            zipcode: '46240',
          },
        },
      },
      4615: {
        name: {
          th: 'สามชัย',
          en: 'Sam Chai',
        },
        tambons: {
          461501: {
            name: {
              th: 'สำราญ',
              en: 'Samran',
            },
            zipcode: '46180',
          },
          461502: {
            name: {
              th: 'สำราญใต้',
              en: 'Samran Tai',
            },
            zipcode: '46180',
          },
          461503: {
            name: {
              th: 'คำสร้างเที่ยง',
              en: 'Kham Sang Thiang',
            },
            zipcode: '46180',
          },
          461504: {
            name: {
              th: 'หนองช้าง',
              en: 'Nong Chang',
            },
            zipcode: '46180',
          },
        },
      },
      4616: {
        name: {
          th: 'นาคู',
          en: 'Na Ku',
        },
        tambons: {
          461601: {
            name: {
              th: 'นาคู',
              en: 'Na Khu',
            },
            zipcode: '46160',
          },
          461602: {
            name: {
              th: 'สายนาวัง',
              en: 'Sai Na Wang',
            },
            zipcode: '46160',
          },
          461603: {
            name: {
              th: 'โนนนาจาน',
              en: 'Non Na Chan',
            },
            zipcode: '46160',
          },
          461604: {
            name: {
              th: 'บ่อแก้ว',
              en: 'Bo Kaeo',
            },
            zipcode: '46160',
          },
          461605: {
            name: {
              th: 'ภูแล่นช้าง',
              en: 'Phu Laen Chang',
            },
            zipcode: '46160',
          },
        },
      },
      4617: {
        name: {
          th: 'ดอนจาน',
          en: 'Don Jan',
        },
        tambons: {
          461701: {
            name: {
              th: 'ดอนจาน',
              en: 'Don Chan',
            },
            zipcode: '46000',
          },
          461702: {
            name: {
              th: 'สะอาดไชยศรี',
              en: 'Sa-at Chai Si',
            },
            zipcode: '46000',
          },
          461703: {
            name: {
              th: 'ดงพยุง',
              en: 'Dong Phayung',
            },
            zipcode: '46000',
          },
          461704: {
            name: {
              th: 'ม่วงนา',
              en: 'Muang Na',
            },
            zipcode: '46000',
          },
          461705: {
            name: {
              th: 'นาจำปา',
              en: 'Na Champa',
            },
            zipcode: '46000',
          },
        },
      },
      4618: {
        name: {
          th: 'ฆ้องชัย',
          en: 'Khong Chai',
        },
        tambons: {
          461801: {
            name: {
              th: 'ฆ้องชัยพัฒนา',
              en: 'Khong Chai Phatthana',
            },
            zipcode: '46130',
          },
          461802: {
            name: {
              th: 'เหล่ากลาง',
              en: 'Lao Klang',
            },
            zipcode: '46130',
          },
          461803: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '46130',
          },
          461804: {
            name: {
              th: 'โนนศิลาเลิง',
              en: 'Non Sila Loeng',
            },
            zipcode: '46130',
          },
          461805: {
            name: {
              th: 'ลำชี',
              en: 'Lam Chi',
            },
            zipcode: '46130',
          },
        },
      },
    },
  },
  47: {
    name: {
      th: 'สกลนคร',
      en: 'Sakon Nakhon',
    },
    amphoes: {
      4701: {
        name: {
          th: 'เมืองสกลนคร',
          en: 'Muang',
        },
        tambons: {
          470101: {
            name: {
              th: 'ธาตุเชิงชุม',
              en: 'That Choeng Chum',
            },
            zipcode: '47000',
          },
          470102: {
            name: {
              th: 'ขมิ้น',
              en: 'Khamin',
            },
            zipcode: '47220',
          },
          470103: {
            name: {
              th: 'งิ้วด่อน',
              en: 'Ngio Don',
            },
            zipcode: '47000',
          },
          470104: {
            name: {
              th: 'โนนหอม',
              en: 'Non Hom',
            },
            zipcode: '47000',
          },
          470106: {
            name: {
              th: 'เชียงเครือ',
              en: 'Chiang Khruea',
            },
            zipcode: '47000',
          },
          470107: {
            name: {
              th: 'ท่าแร่',
              en: 'Tha Rae',
            },
            zipcode: '47000',
          },
          470109: {
            name: {
              th: 'ม่วงลาย',
              en: 'Muang Lai',
            },
            zipcode: '47000',
          },
          470111: {
            name: {
              th: 'ดงชน',
              en: 'Dong Chon',
            },
            zipcode: '47000',
          },
          470112: {
            name: {
              th: 'ห้วยยาง',
              en: 'Huai Yang',
            },
            zipcode: '47000',
          },
          470113: {
            name: {
              th: 'พังขว้าง',
              en: 'Phang Khwang',
            },
            zipcode: '47000',
          },
          470115: {
            name: {
              th: 'ดงมะไฟ',
              en: 'Dong Mafai',
            },
            zipcode: '47000',
          },
          470116: {
            name: {
              th: 'ธาตุนาเวง',
              en: 'That Na Weng',
            },
            zipcode: '47000',
          },
          470117: {
            name: {
              th: 'เหล่าปอแดง',
              en: 'Lao Po Daeng',
            },
            zipcode: '47000',
          },
          470118: {
            name: {
              th: 'หนองลาด',
              en: 'Nong Lat',
            },
            zipcode: '47220',
          },
          470120: {
            name: {
              th: 'ฮางโฮง',
              en: 'Hang Hong',
            },
            zipcode: '47000',
          },
          470121: {
            name: {
              th: 'โคกก่อง',
              en: 'Khok Kong',
            },
            zipcode: '47000',
          },
        },
      },
      4702: {
        name: {
          th: 'กุสุมาลย์',
          en: 'Kusuman',
        },
        tambons: {
          470201: {
            name: {
              th: 'กุสุมาลย์',
              en: 'Kusuman',
            },
            zipcode: '47210',
          },
          470202: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '47210',
          },
          470203: {
            name: {
              th: 'นาเพียง',
              en: 'Na Phiang',
            },
            zipcode: '47230',
          },
          470204: {
            name: {
              th: 'โพธิไพศาล',
              en: 'Pho Phaisan',
            },
            zipcode: '47210',
          },
          470205: {
            name: {
              th: 'อุ่มจาน',
              en: 'Um Chan',
            },
            zipcode: '47230',
          },
        },
      },
      4703: {
        name: {
          th: 'กุดบาก',
          en: 'KutBak',
        },
        tambons: {
          470301: {
            name: {
              th: 'กุดบาก',
              en: 'Kut Bak',
            },
            zipcode: '47180',
          },
          470303: {
            name: {
              th: 'นาม่อง',
              en: 'Na Mong',
            },
            zipcode: '47180',
          },
          470305: {
            name: {
              th: 'กุดไห',
              en: 'Kut Hai',
            },
            zipcode: '47180',
          },
        },
      },
      4704: {
        name: {
          th: 'พรรณานิคม',
          en: 'PhannaNikhom',
        },
        tambons: {
          470401: {
            name: {
              th: 'พรรณา',
              en: 'Phanna',
            },
            zipcode: '47130',
          },
          470402: {
            name: {
              th: 'วังยาง',
              en: 'Wang Yang',
            },
            zipcode: '47130',
          },
          470403: {
            name: {
              th: 'พอกน้อย',
              en: 'Phok Noi',
            },
            zipcode: '47220',
          },
          470404: {
            name: {
              th: 'นาหัวบ่อ',
              en: 'Na Hua Bo',
            },
            zipcode: '47220',
          },
          470405: {
            name: {
              th: 'ไร่',
              en: 'Rai',
            },
            zipcode: '47130',
          },
          470406: {
            name: {
              th: 'ช้างมิ่ง',
              en: 'Chang Ming',
            },
            zipcode: '47130',
          },
          470407: {
            name: {
              th: 'นาใน',
              en: 'Na Nai',
            },
            zipcode: '47130',
          },
          470408: {
            name: {
              th: 'สว่าง',
              en: 'Sawang',
            },
            zipcode: '47130',
          },
          470409: {
            name: {
              th: 'บะฮี',
              en: 'Ba Hi',
            },
            zipcode: '47130',
          },
          470410: {
            name: {
              th: 'เชิงชุม',
              en: 'Choeng Chum',
            },
            zipcode: '47130',
          },
        },
      },
      4705: {
        name: {
          th: 'พังโคน',
          en: 'PhangKhon',
        },
        tambons: {
          470501: {
            name: {
              th: 'พังโคน',
              en: 'Phang Khon',
            },
            zipcode: '47160',
          },
          470502: {
            name: {
              th: 'ม่วงไข่',
              en: 'Muang Khai',
            },
            zipcode: '47160',
          },
          470503: {
            name: {
              th: 'แร่',
              en: 'Rae',
            },
            zipcode: '47160',
          },
          470504: {
            name: {
              th: 'ไฮหย่อง',
              en: 'Hai Yong',
            },
            zipcode: '47160',
          },
          470505: {
            name: {
              th: 'ต้นผึ้ง',
              en: 'Ton Phueng',
            },
            zipcode: '47160',
          },
        },
      },
      4706: {
        name: {
          th: 'วาริชภูมิ',
          en: 'Waritchaphum',
        },
        tambons: {
          470601: {
            name: {
              th: 'วาริชภูมิ',
              en: 'Waritchaphum',
            },
            zipcode: '47150',
          },
          470602: {
            name: {
              th: 'ปลาโหล',
              en: 'Pla Lo',
            },
            zipcode: '47150',
          },
          470603: {
            name: {
              th: 'หนองลาด',
              en: 'Nong Lat',
            },
            zipcode: '47150',
          },
          470604: {
            name: {
              th: 'คำบ่อ',
              en: 'Kham Bo',
            },
            zipcode: '47150',
          },
          470605: {
            name: {
              th: 'ค้อเขียว',
              en: 'Kho Khiao',
            },
            zipcode: '47150',
          },
        },
      },
      4707: {
        name: {
          th: 'นิคมน้ำอูน',
          en: 'NikhomNamUn',
        },
        tambons: {
          470701: {
            name: {
              th: 'นิคมน้ำอูน',
              en: 'Nikhom Nam Un',
            },
            zipcode: '47270',
          },
          470702: {
            name: {
              th: 'หนองปลิง',
              en: 'Nong Pling',
            },
            zipcode: '47270',
          },
          470703: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '47270',
          },
          470704: {
            name: {
              th: 'สุวรรณคาม',
              en: 'Suwannakham',
            },
            zipcode: '47270',
          },
        },
      },
      4708: {
        name: {
          th: 'วานรนิวาส',
          en: 'WananNiwat',
        },
        tambons: {
          470801: {
            name: {
              th: 'วานรนิวาส',
              en: 'Wanon Niwat',
            },
            zipcode: '47120',
          },
          470802: {
            name: {
              th: 'เดื่อศรีคันไชย',
              en: 'Duea Si Khan Chai',
            },
            zipcode: '47120',
          },
          470803: {
            name: {
              th: 'ขัวก่าย',
              en: 'Khua Kai',
            },
            zipcode: '47120',
          },
          470804: {
            name: {
              th: 'หนองสนม',
              en: 'Nong Sanom',
            },
            zipcode: '47120',
          },
          470805: {
            name: {
              th: 'คูสะคาม',
              en: 'Khu Sakham',
            },
            zipcode: '47120',
          },
          470806: {
            name: {
              th: 'ธาตุ',
              en: 'That',
            },
            zipcode: '47120',
          },
          470807: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '47120',
          },
          470808: {
            name: {
              th: 'ศรีวิชัย',
              en: 'Si Wichai',
            },
            zipcode: '47120',
          },
          470809: {
            name: {
              th: 'นาซอ',
              en: 'Na So',
            },
            zipcode: '47120',
          },
          470810: {
            name: {
              th: 'อินทร์แปลง',
              en: 'In Plaeng',
            },
            zipcode: '47120',
          },
          470811: {
            name: {
              th: 'นาคำ',
              en: 'Na Kham',
            },
            zipcode: '47120',
          },
          470812: {
            name: {
              th: 'คอนสวรรค์',
              en: 'Khon Sawan',
            },
            zipcode: '47120',
          },
          470813: {
            name: {
              th: 'กุดเรือคำ',
              en: 'Kut Ruea Kham',
            },
            zipcode: '47120',
          },
          470814: {
            name: {
              th: 'หนองแวงใต้',
              en: 'Nong Waeng Tai',
            },
            zipcode: '47120',
          },
        },
      },
      4709: {
        name: {
          th: 'คำตากล้า',
          en: 'Kham TaKla',
        },
        tambons: {
          470901: {
            name: {
              th: 'คำตากล้า',
              en: 'Kham Ta Kla',
            },
            zipcode: '47250',
          },
          470902: {
            name: {
              th: 'หนองบัวสิม',
              en: 'Nong Bua Sim',
            },
            zipcode: '47250',
          },
          470903: {
            name: {
              th: 'นาแต้',
              en: 'Na Tae',
            },
            zipcode: '47250',
          },
          470904: {
            name: {
              th: 'แพด',
              en: 'Phaet',
            },
            zipcode: '47250',
          },
        },
      },
      4710: {
        name: {
          th: 'บ้านม่วง',
          en: 'BanMuang',
        },
        tambons: {
          471001: {
            name: {
              th: 'ม่วง',
              en: 'Muang',
            },
            zipcode: '47140',
          },
          471002: {
            name: {
              th: 'มาย',
              en: 'Mai',
            },
            zipcode: '47140',
          },
          471003: {
            name: {
              th: 'ดงหม้อทอง',
              en: 'Dong Mo Thong',
            },
            zipcode: '47140',
          },
          471004: {
            name: {
              th: 'ดงเหนือ',
              en: 'Dong Nuea',
            },
            zipcode: '47140',
          },
          471005: {
            name: {
              th: 'ดงหม้อทองใต้',
              en: 'Dong Mo Thong Tai',
            },
            zipcode: '47140',
          },
          471006: {
            name: {
              th: 'ห้วยหลัว',
              en: 'Huai Lua',
            },
            zipcode: '47140',
          },
          471007: {
            name: {
              th: 'โนนสะอาด',
              en: 'Non Sa-at',
            },
            zipcode: '47140',
          },
          471008: {
            name: {
              th: 'หนองกวั่ง',
              en: 'Nong Kwang',
            },
            zipcode: '47140',
          },
          471009: {
            name: {
              th: 'บ่อแก้ว',
              en: 'Bo Kaeo',
            },
            zipcode: '47140',
          },
        },
      },
      4711: {
        name: {
          th: 'อากาศอำนวย',
          en: 'KatAamnuai',
        },
        tambons: {
          471101: {
            name: {
              th: 'อากาศ',
              en: 'Akat',
            },
            zipcode: '47170',
          },
          471102: {
            name: {
              th: 'โพนแพง',
              en: 'Phon Phaeng',
            },
            zipcode: '47170',
          },
          471103: {
            name: {
              th: 'วาใหญ่',
              en: 'Wa Yai',
            },
            zipcode: '47170',
          },
          471104: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '47170',
          },
          471105: {
            name: {
              th: 'ท่าก้อน',
              en: 'Tha Kon',
            },
            zipcode: '47170',
          },
          471106: {
            name: {
              th: 'นาฮี',
              en: 'Na Hi',
            },
            zipcode: '47170',
          },
          471107: {
            name: {
              th: 'บะหว้า',
              en: 'Ba Wa',
            },
            zipcode: '47170',
          },
          471108: {
            name: {
              th: 'สามัคคีพัฒนา',
              en: 'Samakkhi Phatthana',
            },
            zipcode: '47170',
          },
        },
      },
      4712: {
        name: {
          th: 'สว่างแดนดิน',
          en: 'SawangDanDin',
        },
        tambons: {
          471201: {
            name: {
              th: 'สว่างแดนดิน',
              en: 'Sawang Daen Din',
            },
            zipcode: '47110',
          },
          471203: {
            name: {
              th: 'คำสะอาด',
              en: 'Kham Sa-at',
            },
            zipcode: '47110',
          },
          471204: {
            name: {
              th: 'บ้านต้าย',
              en: 'Ban Tai',
            },
            zipcode: '47110',
          },
          471206: {
            name: {
              th: 'บงเหนือ',
              en: 'Bong Nuea',
            },
            zipcode: '47110',
          },
          471207: {
            name: {
              th: 'โพนสูง',
              en: 'Phon Sung',
            },
            zipcode: '47110',
          },
          471208: {
            name: {
              th: 'โคกสี',
              en: 'Khok Si',
            },
            zipcode: '47110',
          },
          471210: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '47110',
          },
          471211: {
            name: {
              th: 'บงใต้',
              en: 'Bong Tai',
            },
            zipcode: '47110',
          },
          471212: {
            name: {
              th: 'ค้อใต้',
              en: 'Kho Tai',
            },
            zipcode: '47110',
          },
          471213: {
            name: {
              th: 'พันนา',
              en: 'Phan Na',
            },
            zipcode: '47240',
          },
          471214: {
            name: {
              th: 'แวง',
              en: 'Waeng',
            },
            zipcode: '47240',
          },
          471215: {
            name: {
              th: 'ทรายมูล',
              en: 'Sai Mun',
            },
            zipcode: '47110',
          },
          471216: {
            name: {
              th: 'ตาลโกน',
              en: 'Tan Kon',
            },
            zipcode: '47240',
          },
          471217: {
            name: {
              th: 'ตาลเนิ้ง',
              en: 'Tan Noeng',
            },
            zipcode: '47240',
          },
          471220: {
            name: {
              th: 'ธาตุทอง',
              en: 'That Thong',
            },
            zipcode: '47240',
          },
          471221: {
            name: {
              th: 'บ้านถ่อน',
              en: 'Ban Thon',
            },
            zipcode: '47110',
          },
        },
      },
      4713: {
        name: {
          th: 'ส่องดาว',
          en: 'SongDao',
        },
        tambons: {
          471301: {
            name: {
              th: 'ส่องดาว',
              en: 'Song Dao',
            },
            zipcode: '47190',
          },
          471302: {
            name: {
              th: 'ท่าศิลา',
              en: 'Tha Sila',
            },
            zipcode: '47190',
          },
          471303: {
            name: {
              th: 'วัฒนา',
              en: 'Watthana',
            },
            zipcode: '47190',
          },
          471304: {
            name: {
              th: 'ปทุมวาปี',
              en: 'Pathum Wapi',
            },
            zipcode: '47190',
          },
        },
      },
      4714: {
        name: {
          th: 'เต่างอย',
          en: 'TaoNgoi',
        },
        tambons: {
          471401: {
            name: {
              th: 'เต่างอย',
              en: 'Tao Ngoi',
            },
            zipcode: '47260',
          },
          471402: {
            name: {
              th: 'บึงทวาย',
              en: 'Bueng Thawai',
            },
            zipcode: '47260',
          },
          471403: {
            name: {
              th: 'นาตาล',
              en: 'Na Tan',
            },
            zipcode: '47260',
          },
          471404: {
            name: {
              th: 'จันทร์เพ็ญ',
              en: 'Chan Phen',
            },
            zipcode: '47260',
          },
        },
      },
      4715: {
        name: {
          th: 'โคกศรีสุพรรณ',
          en: 'KhokSiSuphan',
        },
        tambons: {
          471501: {
            name: {
              th: 'ตองโขบ',
              en: 'Tong Khop',
            },
            zipcode: '47280',
          },
          471502: {
            name: {
              th: 'เหล่าโพนค้อ',
              en: 'Lao Phon Kho',
            },
            zipcode: '47280',
          },
          471503: {
            name: {
              th: 'ด่านม่วงคำ',
              en: 'Dan Muang Kham',
            },
            zipcode: '47280',
          },
          471504: {
            name: {
              th: 'แมดนาท่ม',
              en: 'Maet Na Thom',
            },
            zipcode: '47280',
          },
        },
      },
      4716: {
        name: {
          th: 'เจริญศิลป์',
          en: 'CharoenSilp',
        },
        tambons: {
          471601: {
            name: {
              th: 'บ้านเหล่า',
              en: 'Ban Lao',
            },
            zipcode: '47290',
          },
          471602: {
            name: {
              th: 'เจริญศิลป์',
              en: 'Charoen Sin',
            },
            zipcode: '47290',
          },
          471603: {
            name: {
              th: 'ทุ่งแก',
              en: 'Thung Kae',
            },
            zipcode: '47290',
          },
          471604: {
            name: {
              th: 'โคกศิลา',
              en: 'Khok Sila',
            },
            zipcode: '47290',
          },
          471605: {
            name: {
              th: 'หนองแปน',
              en: 'Nong Paen',
            },
            zipcode: '47290',
          },
        },
      },
      4717: {
        name: {
          th: 'โพนนาแก้ว',
          en: 'Phonnakaeo',
        },
        tambons: {
          471701: {
            name: {
              th: 'บ้านโพน',
              en: 'Ban Phon',
            },
            zipcode: '47230',
          },
          471702: {
            name: {
              th: 'นาแก้ว',
              en: 'Na Kaeo',
            },
            zipcode: '47230',
          },
          471703: {
            name: {
              th: 'นาตงวัฒนา',
              en: 'Na Tong Watthana',
            },
            zipcode: '47230',
          },
          471704: {
            name: {
              th: 'บ้านแป้น',
              en: 'Ban Paen',
            },
            zipcode: '47230',
          },
          471705: {
            name: {
              th: 'เชียงสือ',
              en: 'Chiang Sue',
            },
            zipcode: '47230',
          },
        },
      },
      4718: {
        name: {
          th: 'ภูพาน',
          en: 'Phu Phan',
        },
        tambons: {
          471801: {
            name: {
              th: 'สร้างค้อ',
              en: 'Sang Kho',
            },
            zipcode: '47180',
          },
          471802: {
            name: {
              th: 'หลุบเลา',
              en: 'Lup Lao',
            },
            zipcode: '47180',
          },
          471803: {
            name: {
              th: 'โคกภู',
              en: 'Khok Phu',
            },
            zipcode: '47180',
          },
          471804: {
            name: {
              th: 'กกปลาซิว',
              en: 'Kok Pla Sio',
            },
            zipcode: '47180',
          },
        },
      },
    },
  },
  48: {
    name: {
      th: 'นครพนม',
      en: 'Nakhon Phanom',
    },
    amphoes: {
      4801: {
        name: {
          th: 'เมืองนครพนม',
          en: 'Muang',
        },
        tambons: {
          480101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '48000',
          },
          480102: {
            name: {
              th: 'หนองแสง',
              en: 'Nong Saeng',
            },
            zipcode: '48000',
          },
          480103: {
            name: {
              th: 'นาทราย',
              en: 'Na Sai',
            },
            zipcode: '48000',
          },
          480104: {
            name: {
              th: 'นาราชควาย',
              en: 'Na Rat Khwai',
            },
            zipcode: '48000',
          },
          480105: {
            name: {
              th: 'กุรุคุ',
              en: 'Kurukhu',
            },
            zipcode: '48000',
          },
          480106: {
            name: {
              th: 'บ้านผึ้ง',
              en: 'Ban Phueng',
            },
            zipcode: '48000',
          },
          480107: {
            name: {
              th: 'อาจสามารถ',
              en: 'At Samat',
            },
            zipcode: '48000',
          },
          480108: {
            name: {
              th: 'ขามเฒ่า',
              en: 'Kham Thao',
            },
            zipcode: '48000',
          },
          480109: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '48000',
          },
          480110: {
            name: {
              th: 'ท่าค้อ',
              en: 'Tha Khlo',
            },
            zipcode: '48000',
          },
          480111: {
            name: {
              th: 'คำเตย',
              en: 'Kham Toei',
            },
            zipcode: '48000',
          },
          480112: {
            name: {
              th: 'หนองญาติ',
              en: 'Nong Yat',
            },
            zipcode: '48000',
          },
          480113: {
            name: {
              th: 'ดงขวาง',
              en: 'Dong Khwang',
            },
            zipcode: '48000',
          },
          480114: {
            name: {
              th: 'วังตามัว',
              en: 'Wang Ta Mua',
            },
            zipcode: '48000',
          },
          480115: {
            name: {
              th: 'โพธิ์ตาก',
              en: 'Pho Tak',
            },
            zipcode: '48000',
          },
        },
      },
      4802: {
        name: {
          th: 'ปลาปาก',
          en: 'Pla Pak',
        },
        tambons: {
          480201: {
            name: {
              th: 'ปลาปาก',
              en: 'Pla Pak',
            },
            zipcode: '48160',
          },
          480202: {
            name: {
              th: 'หนองฮี',
              en: 'Nong Hi',
            },
            zipcode: '48160',
          },
          480203: {
            name: {
              th: 'กุตาไก้',
              en: 'Kutakai',
            },
            zipcode: '48160',
          },
          480204: {
            name: {
              th: 'โคกสว่าง',
              en: 'Khok Sawang',
            },
            zipcode: '48160',
          },
          480205: {
            name: {
              th: 'โคกสูง',
              en: 'Khok Sung',
            },
            zipcode: '48160',
          },
          480206: {
            name: {
              th: 'มหาชัย',
              en: 'Maha Chai',
            },
            zipcode: '48160',
          },
          480207: {
            name: {
              th: 'นามะเขือ',
              en: 'Na Makhuea',
            },
            zipcode: '48160',
          },
          480208: {
            name: {
              th: 'หนองเทาใหญ่',
              en: 'Nong Thao Yai',
            },
            zipcode: '48160',
          },
        },
      },
      4803: {
        name: {
          th: 'ท่าอุเทน',
          en: 'Tha Uthen',
        },
        tambons: {
          480301: {
            name: {
              th: 'ท่าอุเทน',
              en: 'Tha Uthen',
            },
            zipcode: '48120',
          },
          480302: {
            name: {
              th: 'โนนตาล',
              en: 'Non Tan',
            },
            zipcode: '48120',
          },
          480303: {
            name: {
              th: 'ท่าจำปา',
              en: 'Tha Champa',
            },
            zipcode: '48120',
          },
          480304: {
            name: {
              th: 'ไชยบุรี',
              en: 'Chaiburi',
            },
            zipcode: '48120',
          },
          480305: {
            name: {
              th: 'พนอม',
              en: 'Phanom',
            },
            zipcode: '48120',
          },
          480306: {
            name: {
              th: 'พะทาย',
              en: 'Phathai',
            },
            zipcode: '48120',
          },
          480311: {
            name: {
              th: 'เวินพระบาท',
              en: 'Woen Phrabat',
            },
            zipcode: '48120',
          },
          480312: {
            name: {
              th: 'รามราช',
              en: 'Ram Rat',
            },
            zipcode: '48120',
          },
          480314: {
            name: {
              th: 'หนองเทา',
              en: 'Nong Thao',
            },
            zipcode: '48120',
          },
        },
      },
      4804: {
        name: {
          th: 'บ้านแพง',
          en: 'Ban Phaeng',
        },
        tambons: {
          480401: {
            name: {
              th: 'บ้านแพง',
              en: 'Ban Phaeng',
            },
            zipcode: '48140',
          },
          480402: {
            name: {
              th: 'ไผ่ล้อม',
              en: 'Phai Lom',
            },
            zipcode: '48140',
          },
          480403: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '48140',
          },
          480404: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '48140',
          },
          480408: {
            name: {
              th: 'นางัว',
              en: 'Na Ngua',
            },
            zipcode: '48140',
          },
          480409: {
            name: {
              th: 'นาเข',
              en: 'Na Khe',
            },
            zipcode: '48140',
          },
        },
      },
      4805: {
        name: {
          th: 'ธาตุพนม',
          en: 'That Phanom',
        },
        tambons: {
          480501: {
            name: {
              th: 'ธาตุพนม',
              en: 'That Phanom',
            },
            zipcode: '48110',
          },
          480502: {
            name: {
              th: 'ฝั่งแดง',
              en: 'Fang Daeng',
            },
            zipcode: '48110',
          },
          480503: {
            name: {
              th: 'โพนแพง',
              en: 'Phon Phaeng',
            },
            zipcode: '48110',
          },
          480504: {
            name: {
              th: 'พระกลางทุ่ง',
              en: 'Phra Klang Thung',
            },
            zipcode: '48110',
          },
          480505: {
            name: {
              th: 'นาถ่อน',
              en: 'Na Thon',
            },
            zipcode: '48110',
          },
          480506: {
            name: {
              th: 'แสนพัน',
              en: 'Saen Phan',
            },
            zipcode: '48110',
          },
          480507: {
            name: {
              th: 'ดอนนางหงส์',
              en: 'Don Nang Hong',
            },
            zipcode: '48110',
          },
          480508: {
            name: {
              th: 'น้ำก่ำ',
              en: 'Nam Kam',
            },
            zipcode: '48110',
          },
          480509: {
            name: {
              th: 'อุ่มเหม้า',
              en: 'Um Mao',
            },
            zipcode: '48110',
          },
          480510: {
            name: {
              th: 'นาหนาด',
              en: 'Na Nat',
            },
            zipcode: '48110',
          },
          480511: {
            name: {
              th: 'กุดฉิม',
              en: 'Kut Chim',
            },
            zipcode: '48110',
          },
          480512: {
            name: {
              th: 'ธาตุพนมเหนือ',
              en: 'That Phanom Nuea',
            },
            zipcode: '48110',
          },
        },
      },
      4806: {
        name: {
          th: 'เรณูนคร',
          en: 'Ranu Nakhon',
        },
        tambons: {
          480601: {
            name: {
              th: 'เรณู',
              en: 'Renu',
            },
            zipcode: '48170',
          },
          480602: {
            name: {
              th: 'โพนทอง',
              en: 'Phon Thong',
            },
            zipcode: '48170',
          },
          480603: {
            name: {
              th: 'ท่าลาด',
              en: 'Tha Lat',
            },
            zipcode: '48170',
          },
          480604: {
            name: {
              th: 'นางาม',
              en: 'Na Ngam',
            },
            zipcode: '48170',
          },
          480605: {
            name: {
              th: 'โคกหินแฮ่',
              en: 'Khok Hin Hae',
            },
            zipcode: '48170',
          },
          480607: {
            name: {
              th: 'หนองย่างชิ้น',
              en: 'Nong Yang Chin',
            },
            zipcode: '48170',
          },
          480608: {
            name: {
              th: 'เรณูใต้',
              en: 'Renu Tai',
            },
            zipcode: '48170',
          },
          480609: {
            name: {
              th: 'นาขาม',
              en: 'Na Kham',
            },
            zipcode: '48170',
          },
        },
      },
      4807: {
        name: {
          th: 'นาแก',
          en: 'Na Kae',
        },
        tambons: {
          480701: {
            name: {
              th: 'นาแก',
              en: 'Na Kae',
            },
            zipcode: '48130',
          },
          480702: {
            name: {
              th: 'พระซอง',
              en: 'Phra Song',
            },
            zipcode: '48130',
          },
          480703: {
            name: {
              th: 'หนองสังข์',
              en: 'Nong Sang',
            },
            zipcode: '48130',
          },
          480704: {
            name: {
              th: 'นาคู่',
              en: 'Na Khu',
            },
            zipcode: '48130',
          },
          480705: {
            name: {
              th: 'พิมาน',
              en: 'Phiman',
            },
            zipcode: '48130',
          },
          480706: {
            name: {
              th: 'พุ่มแก',
              en: 'Phum Kae',
            },
            zipcode: '48130',
          },
          480707: {
            name: {
              th: 'ก้านเหลือง',
              en: 'Kan Lueang',
            },
            zipcode: '48130',
          },
          480708: {
            name: {
              th: 'หนองบ่อ',
              en: 'Nong Bo',
            },
            zipcode: '48130',
          },
          480709: {
            name: {
              th: 'นาเลียง',
              en: 'Na Liang',
            },
            zipcode: '48130',
          },
          480712: {
            name: {
              th: 'บ้านแก้ง',
              en: 'Ban Kaeng',
            },
            zipcode: '48130',
          },
          480713: {
            name: {
              th: 'คำพี้',
              en: 'Kham Phi',
            },
            zipcode: '48130',
          },
          480715: {
            name: {
              th: 'สีชมพู',
              en: 'Si Chomphu',
            },
            zipcode: '48130',
          },
        },
      },
      4808: {
        name: {
          th: 'ศรีสงคราม',
          en: 'Si Song Khram',
        },
        tambons: {
          480801: {
            name: {
              th: 'ศรีสงคราม',
              en: 'Si Songkhram',
            },
            zipcode: '48150',
          },
          480802: {
            name: {
              th: 'นาเดื่อ',
              en: 'Na Duea',
            },
            zipcode: '48150',
          },
          480803: {
            name: {
              th: 'บ้านเอื้อง',
              en: 'Ban Ueang',
            },
            zipcode: '48150',
          },
          480804: {
            name: {
              th: 'สามผง',
              en: 'Sam Phong',
            },
            zipcode: '48150',
          },
          480805: {
            name: {
              th: 'ท่าบ่อสงคราม',
              en: 'Tha Bo Songkhram',
            },
            zipcode: '48150',
          },
          480806: {
            name: {
              th: 'บ้านข่า',
              en: 'Ban Kha',
            },
            zipcode: '48150',
          },
          480807: {
            name: {
              th: 'นาคำ',
              en: 'Na Kham',
            },
            zipcode: '48150',
          },
          480808: {
            name: {
              th: 'โพนสว่าง',
              en: 'Phon Sawang',
            },
            zipcode: '48150',
          },
          480809: {
            name: {
              th: 'หาดแพง',
              en: 'Hat Phaeng',
            },
            zipcode: '48150',
          },
        },
      },
      4809: {
        name: {
          th: 'นาหว้า',
          en: 'Nawa',
        },
        tambons: {
          480901: {
            name: {
              th: 'นาหว้า',
              en: 'Na Wa',
            },
            zipcode: '48180',
          },
          480902: {
            name: {
              th: 'นางัว',
              en: 'Na Ngua',
            },
            zipcode: '48180',
          },
          480903: {
            name: {
              th: 'บ้านเสียว',
              en: 'Ban Siao',
            },
            zipcode: '48180',
          },
          480904: {
            name: {
              th: 'นาคูณใหญ่',
              en: 'Na Khun Yai',
            },
            zipcode: '48180',
          },
          480905: {
            name: {
              th: 'เหล่าพัฒนา',
              en: 'Lao Phatthanaย ',
            },
            zipcode: '48180',
          },
          480906: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '48180',
          },
        },
      },
      4810: {
        name: {
          th: 'โพนสวรรค์',
          en: 'Phon Sawan',
        },
        tambons: {
          481001: {
            name: {
              th: 'โพนสวรรค์',
              en: 'Phon Sawan',
            },
            zipcode: '48190',
          },
          481002: {
            name: {
              th: 'นาหัวบ่อ',
              en: 'Na Hua Bo',
            },
            zipcode: '48190',
          },
          481003: {
            name: {
              th: 'นาขมิ้น',
              en: 'Na Khamin',
            },
            zipcode: '48190',
          },
          481004: {
            name: {
              th: 'โพนบก',
              en: 'Phon Bok',
            },
            zipcode: '48190',
          },
          481005: {
            name: {
              th: 'บ้านค้อ',
              en: 'Ban Kho',
            },
            zipcode: '48190',
          },
          481006: {
            name: {
              th: 'โพนจาน',
              en: 'Phon Chan',
            },
            zipcode: '48190',
          },
          481007: {
            name: {
              th: 'นาใน',
              en: 'Na Nai',
            },
            zipcode: '48190',
          },
        },
      },
      4811: {
        name: {
          th: 'นาทม',
          en: 'Na Thom',
        },
        tambons: {
          481101: {
            name: {
              th: 'นาทม',
              en: 'Na Thom',
            },
            zipcode: '48140',
          },
          481102: {
            name: {
              th: 'หนองซน',
              en: 'Nong Son',
            },
            zipcode: '48140',
          },
          481103: {
            name: {
              th: 'ดอนเตย',
              en: 'Don Toei',
            },
            zipcode: '48140',
          },
        },
      },
      4812: {
        name: {
          th: 'วังยาง',
          en: 'King Amphoe  Wong Yang',
        },
        tambons: {
          481201: {
            name: {
              th: 'วังยาง',
              en: 'Wang Yang',
            },
            zipcode: '48130',
          },
          481202: {
            name: {
              th: 'โคกสี',
              en: 'Khok Si',
            },
            zipcode: '48130',
          },
          481203: {
            name: {
              th: 'ยอดชาด',
              en: 'Yot Chat',
            },
            zipcode: '48130',
          },
          481204: {
            name: {
              th: 'หนองโพธิ์',
              en: 'Nong Pho',
            },
            zipcode: '48130',
          },
        },
      },
    },
  },
  49: {
    name: {
      th: 'มุกดาหาร',
      en: 'Mukdahan',
    },
    amphoes: {
      4901: {
        name: {
          th: 'เมืองมุกดาหาร',
          en: 'Muang',
        },
        tambons: {
          490101: {
            name: {
              th: 'มุกดาหาร',
              en: 'Mukdahan',
            },
            zipcode: '49000',
          },
          490102: {
            name: {
              th: 'ศรีบุญเรือง',
              en: 'Si Bun Rueang',
            },
            zipcode: '49000',
          },
          490103: {
            name: {
              th: 'บ้านโคก',
              en: 'Ban Khok',
            },
            zipcode: '49000',
          },
          490104: {
            name: {
              th: 'บางทรายใหญ่',
              en: 'Bang Sai Yai',
            },
            zipcode: '49000',
          },
          490105: {
            name: {
              th: 'โพนทราย',
              en: 'Phon Sai',
            },
            zipcode: '49000',
          },
          490106: {
            name: {
              th: 'ผึ่งแดด',
              en: 'Phueng Daet',
            },
            zipcode: '49000',
          },
          490107: {
            name: {
              th: 'นาโสก',
              en: 'Na Sok',
            },
            zipcode: '49000',
          },
          490108: {
            name: {
              th: 'นาสีนวน',
              en: 'Na Si Nuan',
            },
            zipcode: '49000',
          },
          490109: {
            name: {
              th: 'คำป่าหลาย',
              en: 'Kham Pa Lai',
            },
            zipcode: '49000',
          },
          490110: {
            name: {
              th: 'คำอาฮวน',
              en: 'Kham Ahuan',
            },
            zipcode: '49000',
          },
          490111: {
            name: {
              th: 'ดงเย็น',
              en: 'Dong Yen',
            },
            zipcode: '49000',
          },
          490112: {
            name: {
              th: 'ดงมอน',
              en: 'Dong Mon',
            },
            zipcode: '49000',
          },
          490113: {
            name: {
              th: 'กุดแข้',
              en: 'Kut Khae',
            },
            zipcode: '49000',
          },
        },
      },
      4902: {
        name: {
          th: 'นิคมคำสร้อย',
          en: 'Nikhom Kham Soi',
        },
        tambons: {
          490201: {
            name: {
              th: 'นิคมคำสร้อย',
              en: 'Nikhom Kham Soi',
            },
            zipcode: '49130',
          },
          490202: {
            name: {
              th: 'นากอก',
              en: 'Na Kok',
            },
            zipcode: '49130',
          },
          490203: {
            name: {
              th: 'หนองแวง',
              en: 'Nong Waeng',
            },
            zipcode: '49130',
          },
          490204: {
            name: {
              th: 'กกแดง',
              en: 'Kok Daeng',
            },
            zipcode: '49130',
          },
          490205: {
            name: {
              th: 'นาอุดม',
              en: 'Na Udom',
            },
            zipcode: '49130',
          },
          490206: {
            name: {
              th: 'โชคชัย',
              en: 'Chok Chai',
            },
            zipcode: '49130',
          },
          490207: {
            name: {
              th: 'ร่มเกล้า',
              en: 'Rom Klao',
            },
            zipcode: '49130',
          },
        },
      },
      4903: {
        name: {
          th: 'ดอนตาล',
          en: 'Don Tan',
        },
        tambons: {
          490301: {
            name: {
              th: 'ดอนตาล',
              en: 'Don Tan',
            },
            zipcode: '49120',
          },
          490302: {
            name: {
              th: 'โพธิ์ไทร',
              en: 'Pho Sai',
            },
            zipcode: '49120',
          },
          490303: {
            name: {
              th: 'ป่าไร่',
              en: 'Pa Rai',
            },
            zipcode: '49120',
          },
          490304: {
            name: {
              th: 'เหล่าหมี',
              en: 'Lao Mi',
            },
            zipcode: '49120',
          },
          490305: {
            name: {
              th: 'บ้านบาก',
              en: 'Ban Bak',
            },
            zipcode: '49120',
          },
          490306: {
            name: {
              th: 'นาสะเม็ง',
              en: 'Na Sameng',
            },
            zipcode: '49120',
          },
          490307: {
            name: {
              th: 'บ้านแก้ง',
              en: 'Ban Kaeng',
            },
            zipcode: '49120',
          },
        },
      },
      4904: {
        name: {
          th: 'ดงหลวง',
          en: 'Dong Luang',
        },
        tambons: {
          490401: {
            name: {
              th: 'ดงหลวง',
              en: 'Dong Luang',
            },
            zipcode: '49140',
          },
          490402: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '49140',
          },
          490403: {
            name: {
              th: 'กกตูม',
              en: 'Kok Tum',
            },
            zipcode: '49140',
          },
          490404: {
            name: {
              th: 'หนองแคน',
              en: 'Nong Khaen',
            },
            zipcode: '49140',
          },
          490405: {
            name: {
              th: 'ชะโนดน้อย',
              en: 'Chanot Noi',
            },
            zipcode: '49140',
          },
          490406: {
            name: {
              th: 'พังแดง',
              en: 'Phang Daeng',
            },
            zipcode: '49140',
          },
        },
      },
      4905: {
        name: {
          th: 'คำชะอี',
          en: 'Khamcha-I',
        },
        tambons: {
          490503: {
            name: {
              th: 'บ้านซ่ง',
              en: 'Ban Song',
            },
            zipcode: '49110',
          },
          490504: {
            name: {
              th: 'คำชะอี',
              en: 'Khamcha-i',
            },
            zipcode: '49110',
          },
          490505: {
            name: {
              th: 'หนองเอี่ยน',
              en: 'Nong Ian',
            },
            zipcode: '49110',
          },
          490506: {
            name: {
              th: 'บ้านค้อ',
              en: 'Ban Kho',
            },
            zipcode: '49110',
          },
          490507: {
            name: {
              th: 'บ้านเหล่า',
              en: 'Ban Lao',
            },
            zipcode: '49110',
          },
          490508: {
            name: {
              th: 'โพนงาม',
              en: 'Phon Ngam',
            },
            zipcode: '49110',
          },
          490511: {
            name: {
              th: 'เหล่าสร้างถ่อ',
              en: 'Lao Sang Tho',
            },
            zipcode: '49110',
          },
          490512: {
            name: {
              th: 'คำบก',
              en: 'Kham Bok',
            },
            zipcode: '49110',
          },
          490514: {
            name: {
              th: 'น้ำเที่ยง',
              en: 'Nam Thiang',
            },
            zipcode: '49110',
          },
        },
      },
      4906: {
        name: {
          th: 'หว้านใหญ่',
          en: 'Wan Yai',
        },
        tambons: {
          490601: {
            name: {
              th: 'หว้านใหญ่',
              en: 'Wan Yai',
            },
            zipcode: '49150',
          },
          490602: {
            name: {
              th: 'ป่งขาม',
              en: 'Pong Kham',
            },
            zipcode: '49150',
          },
          490603: {
            name: {
              th: 'บางทรายน้อย',
              en: 'Bang Sai Noi',
            },
            zipcode: '49150',
          },
          490604: {
            name: {
              th: 'ชะโนด',
              en: 'Chanot',
            },
            zipcode: '49150',
          },
          490605: {
            name: {
              th: 'ดงหมู',
              en: 'Dong Mu',
            },
            zipcode: '49150',
          },
        },
      },
      4907: {
        name: {
          th: 'หนองสูง',
          en: 'Nong Sung',
        },
        tambons: {
          490701: {
            name: {
              th: 'หนองสูง',
              en: 'Nong Sung',
            },
            zipcode: '49160',
          },
          490702: {
            name: {
              th: 'โนนยาง',
              en: 'Non Yang',
            },
            zipcode: '49160',
          },
          490703: {
            name: {
              th: 'ภูวง',
              en: 'Phu Wong',
            },
            zipcode: '49160',
          },
          490704: {
            name: {
              th: 'บ้านเป้า',
              en: 'Ban Pao',
            },
            zipcode: '49160',
          },
          490705: {
            name: {
              th: 'หนองสูงใต้',
              en: 'Nong Sung Tai',
            },
            zipcode: '49160',
          },
          490706: {
            name: {
              th: 'หนองสูงเหนือ',
              en: 'Nong Sung Nuea',
            },
            zipcode: '49160',
          },
        },
      },
    },
  },
  50: {
    name: {
      th: 'เชียงใหม่',
      en: 'Chiang Mai',
    },
    amphoes: {
      5001: {
        name: {
          th: 'เมืองเชียงใหม่',
          en: 'Muang',
        },
        tambons: {
          500101: {
            name: {
              th: 'ศรีภูมิ',
              en: 'Si Phum',
            },
            zipcode: '50200',
          },
          500102: {
            name: {
              th: 'พระสิงห์',
              en: 'Phra Sing',
            },
            zipcode: '50200',
          },
          500103: {
            name: {
              th: 'หายยา',
              en: 'Haiya',
            },
            zipcode: '50100',
          },
          500104: {
            name: {
              th: 'ช้างม่อย',
              en: 'Chang Moi',
            },
            zipcode: '50300',
          },
          500105: {
            name: {
              th: 'ช้างคลาน',
              en: 'Chang Khlan',
            },
            zipcode: '50100',
          },
          500106: {
            name: {
              th: 'วัดเกต',
              en: 'Wat Ket',
            },
            zipcode: '50000',
          },
          500107: {
            name: {
              th: 'ช้างเผือก',
              en: 'Chang Phueak',
            },
            zipcode: '50300',
          },
          500108: {
            name: {
              th: 'สุเทพ',
              en: 'Suthep',
            },
            zipcode: '50200',
          },
          500109: {
            name: {
              th: 'แม่เหียะ',
              en: 'Mae Hia',
            },
            zipcode: '50100',
          },
          500110: {
            name: {
              th: 'ป่าแดด',
              en: 'Pa Daet',
            },
            zipcode: '50100',
          },
          500111: {
            name: {
              th: 'หนองหอย',
              en: 'Nong Hoi',
            },
            zipcode: '50000',
          },
          500112: {
            name: {
              th: 'ท่าศาลา',
              en: 'Tha Sala',
            },
            zipcode: '50000',
          },
          500113: {
            name: {
              th: 'หนองป่าครั่ง',
              en: 'Nong Pa Khrang',
            },
            zipcode: '50000',
          },
          500114: {
            name: {
              th: 'ฟ้าฮ่าม',
              en: 'Fa Ham',
            },
            zipcode: '50000',
          },
          500115: {
            name: {
              th: 'ป่าตัน',
              en: 'Pa Tan',
            },
            zipcode: '50300',
          },
          500116: {
            name: {
              th: 'สันผีเสื้อ',
              en: 'San Phi Suea',
            },
            zipcode: '50300',
          },
        },
      },
      5002: {
        name: {
          th: 'จอมทอง',
          en: 'Chom Thong',
        },
        tambons: {
          500203: {
            name: {
              th: 'บ้านหลวง',
              en: 'Ban Luang',
            },
            zipcode: '50160',
          },
          500204: {
            name: {
              th: 'ข่วงเปา',
              en: 'Khuang Pao',
            },
            zipcode: '50160',
          },
          500205: {
            name: {
              th: 'สบเตี๊ยะ',
              en: 'Sop Tia',
            },
            zipcode: '50160',
          },
          500206: {
            name: {
              th: 'บ้านแปะ',
              en: 'Ban Pae',
            },
            zipcode: '50240',
          },
          500207: {
            name: {
              th: 'ดอยแก้ว',
              en: 'Doi Kaeo',
            },
            zipcode: '50160',
          },
          500209: {
            name: {
              th: 'แม่สอย',
              en: 'Mae Soi',
            },
            zipcode: '50240',
          },
        },
      },
      5003: {
        name: {
          th: 'แม่แจ่ม',
          en: 'Mae Chaem',
        },
        tambons: {
          500301: {
            name: {
              th: 'ช่างเคิ่ง',
              en: 'Chang Khoeng',
            },
            zipcode: '50270',
          },
          500302: {
            name: {
              th: 'ท่าผา',
              en: 'Tha Pha',
            },
            zipcode: '50270',
          },
          500303: {
            name: {
              th: 'บ้านทับ',
              en: 'Ban Thap',
            },
            zipcode: '50270',
          },
          500304: {
            name: {
              th: 'แม่ศึก',
              en: 'Mae Suek',
            },
            zipcode: '50270',
          },
          500305: {
            name: {
              th: 'แม่นาจร',
              en: 'Mae Na Chon',
            },
            zipcode: '50270',
          },
          500307: {
            name: {
              th: 'ปางหินฝน',
              en: 'Pang Hin Fon',
            },
            zipcode: '50270',
          },
          500308: {
            name: {
              th: 'กองแขก',
              en: 'Kong Khaek',
            },
            zipcode: '50270',
          },
        },
      },
      5004: {
        name: {
          th: 'เชียงดาว',
          en: 'Chiang Dao',
        },
        tambons: {
          500401: {
            name: {
              th: 'เชียงดาว',
              en: 'Chiang Dao',
            },
            zipcode: '50170',
          },
          500402: {
            name: {
              th: 'เมืองนะ',
              en: 'Mueang Na',
            },
            zipcode: '50170',
          },
          500403: {
            name: {
              th: 'เมืองงาย',
              en: 'Mueang Ngai',
            },
            zipcode: '50170',
          },
          500404: {
            name: {
              th: 'แม่นะ',
              en: 'Mae Na',
            },
            zipcode: '50170',
          },
          500405: {
            name: {
              th: 'เมืองคอง',
              en: 'Sa-nga Ban',
            },
            zipcode: '50170',
          },
          500406: {
            name: {
              th: 'ปิงโค้ง',
              en: 'Pa Lan',
            },
            zipcode: '50170',
          },
          500407: {
            name: {
              th: 'ทุ่งข้าวพวง',
              en: 'Thung Khao Phuang',
            },
            zipcode: '50170',
          },
        },
      },
      5005: {
        name: {
          th: 'ดอยสะเก็ด',
          en: 'Doi Saket',
        },
        tambons: {
          500501: {
            name: {
              th: 'เชิงดอย',
              en: 'Choeng Doi',
            },
            zipcode: '50220',
          },
          500502: {
            name: {
              th: 'สันปูเลย',
              en: 'San Pu Loei',
            },
            zipcode: '50220',
          },
          500503: {
            name: {
              th: 'ลวงเหนือ',
              en: 'Luang Nuea',
            },
            zipcode: '50220',
          },
          500504: {
            name: {
              th: 'ป่าป้อง',
              en: 'Pa Pong',
            },
            zipcode: '50220',
          },
          500505: {
            name: {
              th: 'สง่าบ้าน',
              en: 'Sa-nga Ban',
            },
            zipcode: '50220',
          },
          500506: {
            name: {
              th: 'ป่าลาน',
              en: 'Pa Lan',
            },
            zipcode: '50220',
          },
          500507: {
            name: {
              th: 'ตลาดขวัญ',
              en: 'Talat Khwan',
            },
            zipcode: '50220',
          },
          500508: {
            name: {
              th: 'สำราญราษฎร์',
              en: 'Samran Rat',
            },
            zipcode: '50220',
          },
          500509: {
            name: {
              th: 'แม่คือ',
              en: 'Mae Khue',
            },
            zipcode: '50220',
          },
          500510: {
            name: {
              th: 'ตลาดใหญ่',
              en: 'Talat Yai',
            },
            zipcode: '50220',
          },
          500511: {
            name: {
              th: 'แม่ฮ้อยเงิน',
              en: 'Mae Hoi Ngoen',
            },
            zipcode: '50220',
          },
          500512: {
            name: {
              th: 'แม่โป่ง',
              en: 'Mae Pong',
            },
            zipcode: '50220',
          },
          500513: {
            name: {
              th: 'ป่าเมี่ยง',
              en: 'Pa Miang',
            },
            zipcode: '50220',
          },
          500514: {
            name: {
              th: 'เทพเสด็จ',
              en: 'Thep Sadet',
            },
            zipcode: '50220',
          },
        },
      },
      5006: {
        name: {
          th: 'แม่แตง',
          en: 'Mae Taeng',
        },
        tambons: {
          500601: {
            name: {
              th: 'สันมหาพน',
              en: 'San Maha Phon',
            },
            zipcode: '50150',
          },
          500602: {
            name: {
              th: 'แม่แตง',
              en: 'Mae Taeng',
            },
            zipcode: '50150',
          },
          500603: {
            name: {
              th: 'ขี้เหล็ก',
              en: 'Khilek',
            },
            zipcode: '50150',
          },
          500604: {
            name: {
              th: 'ช่อแล',
              en: 'Cho Lae',
            },
            zipcode: '50150',
          },
          500605: {
            name: {
              th: 'แม่หอพระ',
              en: 'Mae Ho Phra',
            },
            zipcode: '50150',
          },
          500606: {
            name: {
              th: 'สบเปิง',
              en: 'Sop Poeng',
            },
            zipcode: '50150',
          },
          500607: {
            name: {
              th: 'บ้านเป้า',
              en: 'Ban Pao',
            },
            zipcode: '50150',
          },
          500608: {
            name: {
              th: 'สันป่ายาง',
              en: 'San Pa Yang',
            },
            zipcode: '50330',
          },
          500609: {
            name: {
              th: 'ป่าแป๋',
              en: 'Pa Pae',
            },
            zipcode: '50150',
          },
          500610: {
            name: {
              th: 'เมืองก๋าย',
              en: 'Mueang Kai',
            },
            zipcode: '50150',
          },
          500611: {
            name: {
              th: 'บ้านช้าง',
              en: 'Ban Chang',
            },
            zipcode: '50150',
          },
          500612: {
            name: {
              th: 'กื้ดช้าง',
              en: 'Kuet Chang',
            },
            zipcode: '50150',
          },
          500613: {
            name: {
              th: 'อินทขิล',
              en: 'Inthakhin',
            },
            zipcode: '50150',
          },
          500614: {
            name: {
              th: 'สมก๋าย',
              en: 'Som Kai',
            },
            zipcode: '50150',
          },
        },
      },
      5007: {
        name: {
          th: 'แม่ริม',
          en: 'Mae Rim',
        },
        tambons: {
          500701: {
            name: {
              th: 'ริมใต้',
              en: 'Rim Tai',
            },
            zipcode: '50180',
          },
          500702: {
            name: {
              th: 'ริมเหนือ',
              en: 'Rim Nuea',
            },
            zipcode: '50180',
          },
          500703: {
            name: {
              th: 'สันโป่ง',
              en: 'San Pong',
            },
            zipcode: '50180',
          },
          500704: {
            name: {
              th: 'ขี้เหล็ก',
              en: 'Khilek',
            },
            zipcode: '50180',
          },
          500705: {
            name: {
              th: 'สะลวง',
              en: 'Saluang',
            },
            zipcode: '50330',
          },
          500706: {
            name: {
              th: 'ห้วยทราย',
              en: 'Huai Sai',
            },
            zipcode: '50180',
          },
          500707: {
            name: {
              th: 'แม่แรม',
              en: 'Mae Raem',
            },
            zipcode: '50180',
          },
          500708: {
            name: {
              th: 'โป่งแยง',
              en: 'Pong Yaeng',
            },
            zipcode: '50180',
          },
          500709: {
            name: {
              th: 'แม่สา',
              en: 'Mae Sa',
            },
            zipcode: '50180',
          },
          500710: {
            name: {
              th: 'ดอนแก้ว',
              en: 'Don Kaeo',
            },
            zipcode: '50180',
          },
          500711: {
            name: {
              th: 'เหมืองแก้ว',
              en: 'Mueang Kaeo',
            },
            zipcode: '50180',
          },
        },
      },
      5008: {
        name: {
          th: 'สะเมิง',
          en: 'Samoeng',
        },
        tambons: {
          500801: {
            name: {
              th: 'สะเมิงใต้',
              en: 'Samoeng Tai',
            },
            zipcode: '50250',
          },
          500802: {
            name: {
              th: 'สะเมิงเหนือ',
              en: 'Samoeng Nuea',
            },
            zipcode: '50250',
          },
          500803: {
            name: {
              th: 'แม่สาบ',
              en: 'Mae Sap',
            },
            zipcode: '50250',
          },
          500804: {
            name: {
              th: 'บ่อแก้ว',
              en: 'Bo Kaeo',
            },
            zipcode: '50250',
          },
          500805: {
            name: {
              th: 'ยั้งเมิน',
              en: 'Yang Moen',
            },
            zipcode: '50250',
          },
        },
      },
      5009: {
        name: {
          th: 'ฝาง',
          en: 'Fang',
        },
        tambons: {
          500901: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '50110',
          },
          500903: {
            name: {
              th: 'ม่อนปิ่น',
              en: 'Mon Pin',
            },
            zipcode: '50110',
          },
          500904: {
            name: {
              th: 'แม่งอน',
              en: 'Mae Ngon',
            },
            zipcode: '50320',
          },
          500905: {
            name: {
              th: 'แม่สูน',
              en: 'Mae Sun',
            },
            zipcode: '50110',
          },
          500906: {
            name: {
              th: 'สันทราย',
              en: 'San Sai',
            },
            zipcode: '50110',
          },
          500910: {
            name: {
              th: 'แม่คะ',
              en: 'Mae Ka',
            },
            zipcode: '50110',
          },
          500911: {
            name: {
              th: 'แม่ข่า',
              en: 'Mae Kha',
            },
            zipcode: '50320',
          },
          500912: {
            name: {
              th: 'โป่งน้ำร้อน',
              en: 'Pong Nam Ron',
            },
            zipcode: '50110',
          },
        },
      },
      5010: {
        name: {
          th: 'แม่อาย',
          en: 'Mae Ai',
        },
        tambons: {
          501001: {
            name: {
              th: 'แม่อาย',
              en: 'Mae Ai',
            },
            zipcode: '50280',
          },
          501002: {
            name: {
              th: 'แม่สาว',
              en: 'Mae Sao',
            },
            zipcode: '50280',
          },
          501003: {
            name: {
              th: 'สันต้นหมื้อ',
              en: 'San Ton Mue',
            },
            zipcode: '50280',
          },
          501004: {
            name: {
              th: 'แม่นาวาง',
              en: 'Mae Na Wang',
            },
            zipcode: '50280',
          },
          501005: {
            name: {
              th: 'ท่าตอน',
              en: 'Tha Ton',
            },
            zipcode: '50280',
          },
          501006: {
            name: {
              th: 'บ้านหลวง',
              en: 'Ban Luang',
            },
            zipcode: '50280',
          },
          501007: {
            name: {
              th: 'มะลิกา',
              en: 'Malika',
            },
            zipcode: '50280',
          },
        },
      },
      5011: {
        name: {
          th: 'พร้าว',
          en: 'Phrao',
        },
        tambons: {
          501101: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '50190',
          },
          501102: {
            name: {
              th: 'ทุ่งหลวง',
              en: 'Thung Luang',
            },
            zipcode: '50190',
          },
          501103: {
            name: {
              th: 'ป่าตุ้ม',
              en: 'Pa Tum',
            },
            zipcode: '50190',
          },
          501104: {
            name: {
              th: 'ป่าไหน่',
              en: 'Pa Nai',
            },
            zipcode: '50190',
          },
          501105: {
            name: {
              th: 'สันทราย',
              en: 'San Sai',
            },
            zipcode: '50190',
          },
          501106: {
            name: {
              th: 'บ้านโป่ง',
              en: 'Ban Pong',
            },
            zipcode: '50190',
          },
          501107: {
            name: {
              th: 'น้ำแพร่',
              en: 'Nam Phrae',
            },
            zipcode: '50190',
          },
          501108: {
            name: {
              th: 'เขื่อนผาก',
              en: 'Khuean Phak',
            },
            zipcode: '50190',
          },
          501109: {
            name: {
              th: 'แม่แวน',
              en: 'Mae Waen',
            },
            zipcode: '50190',
          },
          501110: {
            name: {
              th: 'แม่ปั๋ง',
              en: 'Mae Pang',
            },
            zipcode: '50190',
          },
          501111: {
            name: {
              th: 'โหล่งขอด',
              en: 'Long Khot',
            },
            zipcode: '50190',
          },
        },
      },
      5012: {
        name: {
          th: 'สันป่าตอง',
          en: 'San Pa Tong',
        },
        tambons: {
          501201: {
            name: {
              th: 'ยุหว่า',
              en: 'Yu Wa',
            },
            zipcode: '50120',
          },
          501202: {
            name: {
              th: 'สันกลาง',
              en: 'San Klang',
            },
            zipcode: '50120',
          },
          501203: {
            name: {
              th: 'ท่าวังพร้าว',
              en: 'Tha Wang Phrao',
            },
            zipcode: '50120',
          },
          501204: {
            name: {
              th: 'มะขามหลวง',
              en: 'Makham Luang',
            },
            zipcode: '50120',
          },
          501205: {
            name: {
              th: 'แม่ก๊า',
              en: 'Mae Ka',
            },
            zipcode: '50120',
          },
          501206: {
            name: {
              th: 'บ้านแม',
              en: 'Ban Mae',
            },
            zipcode: '50120',
          },
          501207: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '50120',
          },
          501208: {
            name: {
              th: 'ทุ่งสะโตก',
              en: 'Thung Satok',
            },
            zipcode: '50120',
          },
          501210: {
            name: {
              th: 'ทุ่งต้อม',
              en: 'Thung Tom',
            },
            zipcode: '50120',
          },
          501214: {
            name: {
              th: 'น้ำบ่อหลวง',
              en: 'Nam Bo Luang',
            },
            zipcode: '50120',
          },
          501215: {
            name: {
              th: 'มะขุนหวาน',
              en: 'Makhun Wan',
            },
            zipcode: '50120',
          },
        },
      },
      5013: {
        name: {
          th: 'สันกำแพง',
          en: 'San Kamphaeng',
        },
        tambons: {
          501301: {
            name: {
              th: 'สันกำแพง',
              en: 'San Kamphaeng',
            },
            zipcode: '50130',
          },
          501302: {
            name: {
              th: 'ทรายมูล',
              en: 'Sai Mun',
            },
            zipcode: '50130',
          },
          501303: {
            name: {
              th: 'ร้องวัวแดง',
              en: 'Rong Wua Daeng',
            },
            zipcode: '50130',
          },
          501304: {
            name: {
              th: 'บวกค้าง',
              en: 'Buak Khang',
            },
            zipcode: '50130',
          },
          501305: {
            name: {
              th: 'แช่ช้าง',
              en: 'Chae Chang',
            },
            zipcode: '50130',
          },
          501306: {
            name: {
              th: 'ออนใต้',
              en: 'On Tai',
            },
            zipcode: '50130',
          },
          501310: {
            name: {
              th: 'แม่ปูคา',
              en: 'Mae Pu Kha',
            },
            zipcode: '50130',
          },
          501311: {
            name: {
              th: 'ห้วยทราย',
              en: 'Huai Sai',
            },
            zipcode: '50130',
          },
          501312: {
            name: {
              th: 'ต้นเปา',
              en: 'Ton Pao',
            },
            zipcode: '50130',
          },
          501313: {
            name: {
              th: 'สันกลาง',
              en: 'San Klang',
            },
            zipcode: '50130',
          },
        },
      },
      5014: {
        name: {
          th: 'สันทราย',
          en: 'San Sai',
        },
        tambons: {
          501401: {
            name: {
              th: 'สันทรายหลวง',
              en: 'San Sai Luang',
            },
            zipcode: '50210',
          },
          501402: {
            name: {
              th: 'สันทรายน้อย',
              en: 'San Sai Noi',
            },
            zipcode: '50210',
          },
          501403: {
            name: {
              th: 'สันพระเนตร',
              en: 'San Phranet',
            },
            zipcode: '50210',
          },
          501404: {
            name: {
              th: 'สันนาเม็ง',
              en: 'San Na Meng',
            },
            zipcode: '50210',
          },
          501405: {
            name: {
              th: 'สันป่าเปา',
              en: 'San Pa Pao',
            },
            zipcode: '50210',
          },
          501406: {
            name: {
              th: 'หนองแหย่ง',
              en: 'Nong Yaeng',
            },
            zipcode: '50210',
          },
          501407: {
            name: {
              th: 'หนองจ๊อม',
              en: 'Nong Chom',
            },
            zipcode: '50210',
          },
          501408: {
            name: {
              th: 'หนองหาร',
              en: 'Nong Han',
            },
            zipcode: '50290',
          },
          501409: {
            name: {
              th: 'แม่แฝก',
              en: 'Mae Faek',
            },
            zipcode: '50290',
          },
          501410: {
            name: {
              th: 'แม่แฝกใหม่',
              en: 'Mae Faek Mai',
            },
            zipcode: '50290',
          },
          501411: {
            name: {
              th: 'เมืองเล็น',
              en: 'Mueang Len',
            },
            zipcode: '50210',
          },
          501412: {
            name: {
              th: 'ป่าไผ่',
              en: 'Pa Phai',
            },
            zipcode: '50210',
          },
        },
      },
      5015: {
        name: {
          th: 'หางดง',
          en: 'Hang Dong',
        },
        tambons: {
          501501: {
            name: {
              th: 'หางดง',
              en: 'Hang Dong',
            },
            zipcode: '50230',
          },
          501502: {
            name: {
              th: 'หนองแก๋ว',
              en: 'Nong Kaeo',
            },
            zipcode: '50230',
          },
          501503: {
            name: {
              th: 'หารแก้ว',
              en: 'Han Kaeo',
            },
            zipcode: '50230',
          },
          501504: {
            name: {
              th: 'หนองตอง',
              en: 'Nong Tong',
            },
            zipcode: '50340',
          },
          501505: {
            name: {
              th: 'ขุนคง',
              en: 'Khun Khong',
            },
            zipcode: '50230',
          },
          501506: {
            name: {
              th: 'สบแม่ข่า',
              en: 'Sop Mae Kha',
            },
            zipcode: '50230',
          },
          501507: {
            name: {
              th: 'บ้านแหวน',
              en: 'Ban Waen',
            },
            zipcode: '50230',
          },
          501508: {
            name: {
              th: 'สันผักหวาน',
              en: 'San Phak Wan',
            },
            zipcode: '50230',
          },
          501509: {
            name: {
              th: 'หนองควาย',
              en: 'Nong Khwai',
            },
            zipcode: '50230',
          },
          501510: {
            name: {
              th: 'บ้านปง',
              en: 'Ban Pong',
            },
            zipcode: '50230',
          },
          501511: {
            name: {
              th: 'น้ำแพร่',
              en: 'Nam Phrae',
            },
            zipcode: '50230',
          },
        },
      },
      5016: {
        name: {
          th: 'ฮอด',
          en: 'Hot',
        },
        tambons: {
          501601: {
            name: {
              th: 'หางดง',
              en: 'Hang Dong',
            },
            zipcode: '50240',
          },
          501602: {
            name: {
              th: 'ฮอด',
              en: 'Hot',
            },
            zipcode: '50240',
          },
          501603: {
            name: {
              th: 'บ้านตาล',
              en: 'Ban Tan',
            },
            zipcode: '50240',
          },
          501604: {
            name: {
              th: 'บ่อหลวง',
              en: 'Bo Luang',
            },
            zipcode: '50240',
          },
          501605: {
            name: {
              th: 'บ่อสลี',
              en: 'Bo Sali',
            },
            zipcode: '50240',
          },
          501606: {
            name: {
              th: 'นาคอเรือ',
              en: 'Na Kho Ruea',
            },
            zipcode: '50240',
          },
        },
      },
      5017: {
        name: {
          th: 'ดอยเต่า',
          en: 'Doi Tao',
        },
        tambons: {
          501701: {
            name: {
              th: 'ดอยเต่า',
              en: 'Doi Tao',
            },
            zipcode: '50260',
          },
          501702: {
            name: {
              th: 'ท่าเดื่อ',
              en: 'Tha Duea',
            },
            zipcode: '50260',
          },
          501703: {
            name: {
              th: 'มืดกา',
              en: 'Muet Ka',
            },
            zipcode: '50260',
          },
          501704: {
            name: {
              th: 'บ้านแอ่น',
              en: 'Ban Aen',
            },
            zipcode: '50260',
          },
          501705: {
            name: {
              th: 'บงตัน',
              en: 'Bong Tan',
            },
            zipcode: '50260',
          },
          501706: {
            name: {
              th: 'โปงทุ่ง',
              en: 'Pong Thung',
            },
            zipcode: '50260',
          },
        },
      },
      5018: {
        name: {
          th: 'อมก๋อย',
          en: 'Omkoi',
        },
        tambons: {
          501801: {
            name: {
              th: 'อมก๋อย',
              en: 'Omkoi',
            },
            zipcode: '50310',
          },
          501802: {
            name: {
              th: 'ยางเปียง',
              en: 'Yang Piang',
            },
            zipcode: '50310',
          },
          501803: {
            name: {
              th: 'แม่ตื่น',
              en: 'Mae Tuen',
            },
            zipcode: '50310',
          },
          501804: {
            name: {
              th: 'ม่อนจอง',
              en: 'Mon Chong',
            },
            zipcode: '50310',
          },
          501805: {
            name: {
              th: 'สบโขง',
              en: 'Sop Khong',
            },
            zipcode: '50310',
          },
          501806: {
            name: {
              th: 'นาเกียน',
              en: 'Na Kian',
            },
            zipcode: '50310',
          },
        },
      },
      5019: {
        name: {
          th: 'สารภี',
          en: 'Saraphi',
        },
        tambons: {
          501901: {
            name: {
              th: 'ยางเนิ้ง',
              en: 'Yang Noeng',
            },
            zipcode: '50140',
          },
          501902: {
            name: {
              th: 'สารภี',
              en: 'Saraphi',
            },
            zipcode: '50140',
          },
          501903: {
            name: {
              th: 'ชมภู',
              en: 'Chom Phu',
            },
            zipcode: '50140',
          },
          501904: {
            name: {
              th: 'ไชยสถาน',
              en: 'Chai Sathan',
            },
            zipcode: '50140',
          },
          501905: {
            name: {
              th: 'ขัวมุง',
              en: 'Khua Mung',
            },
            zipcode: '50140',
          },
          501906: {
            name: {
              th: 'หนองแฝก',
              en: 'Nong Faek',
            },
            zipcode: '50140',
          },
          501907: {
            name: {
              th: 'หนองผึ้ง',
              en: 'Nong Phueng',
            },
            zipcode: '50140',
          },
          501908: {
            name: {
              th: 'ท่ากว้าง',
              en: 'Tha Kwang',
            },
            zipcode: '50140',
          },
          501909: {
            name: {
              th: 'ดอนแก้ว',
              en: 'Don Kaeo',
            },
            zipcode: '50140',
          },
          501910: {
            name: {
              th: 'ท่าวังตาล',
              en: 'Tha Wang Tan',
            },
            zipcode: '50140',
          },
          501911: {
            name: {
              th: 'สันทราย',
              en: 'San Sai',
            },
            zipcode: '50140',
          },
          501912: {
            name: {
              th: 'ป่าบง',
              en: 'Pa Bong',
            },
            zipcode: '50140',
          },
        },
      },
      5020: {
        name: {
          th: 'เวียงแหง',
          en: 'Wiang Haeng',
        },
        tambons: {
          502001: {
            name: {
              th: 'เมืองแหง',
              en: 'Mueang Haeng',
            },
            zipcode: '50350',
          },
          502002: {
            name: {
              th: 'เปียงหลวง',
              en: 'Piang Luang',
            },
            zipcode: '50350',
          },
          502003: {
            name: {
              th: 'แสนไห',
              en: 'Saen Hai',
            },
            zipcode: '50350',
          },
        },
      },
      5021: {
        name: {
          th: 'ไชยปราการ',
          en: 'Chai Prakan',
        },
        tambons: {
          502101: {
            name: {
              th: 'ปงตำ',
              en: 'Pong Tam',
            },
            zipcode: '50320',
          },
          502102: {
            name: {
              th: 'ศรีดงเย็น',
              en: 'Si Dong Yen',
            },
            zipcode: '50320',
          },
          502103: {
            name: {
              th: 'แม่ทะลบ',
              en: 'Mae Thalop',
            },
            zipcode: '50320',
          },
          502104: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '50320',
          },
        },
      },
      5022: {
        name: {
          th: 'แม่วาง',
          en: 'Mae Wang',
        },
        tambons: {
          502201: {
            name: {
              th: 'บ้านกาด',
              en: 'Ban Kat',
            },
            zipcode: '50360',
          },
          502202: {
            name: {
              th: 'ทุ่งปี๊',
              en: 'Thung Pi',
            },
            zipcode: '50360',
          },
          502203: {
            name: {
              th: 'ทุ่งรวงทอง',
              en: 'Thung Ruang Thong',
            },
            zipcode: '50360',
          },
          502204: {
            name: {
              th: 'แม่วิน',
              en: 'Mae Win',
            },
            zipcode: '50360',
          },
          502205: {
            name: {
              th: 'ดอนเปา',
              en: 'Don Pao',
            },
            zipcode: '50360',
          },
        },
      },
      5023: {
        name: {
          th: 'แม่ออน',
          en: 'Mae On',
        },
        tambons: {
          502301: {
            name: {
              th: 'ออนเหนือ',
              en: 'On Nuea',
            },
            zipcode: '50130',
          },
          502302: {
            name: {
              th: 'ออนกลาง',
              en: 'On Klang',
            },
            zipcode: '50130',
          },
          502303: {
            name: {
              th: 'บ้านสหกรณ์',
              en: 'Ban Sahakon',
            },
            zipcode: '50130',
          },
          502304: {
            name: {
              th: 'ห้วยแก้ว',
              en: 'Huai Kaeo',
            },
            zipcode: '50130',
          },
          502305: {
            name: {
              th: 'แม่ทา',
              en: 'Mae Tha',
            },
            zipcode: '50130',
          },
          502306: {
            name: {
              th: 'ทาเหนือ',
              en: 'Tha Nuea',
            },
            zipcode: '50130',
          },
        },
      },
      5024: {
        name: {
          th: 'ดอยหล่อ',
          en: 'Doi Lo',
        },
        tambons: {
          502401: {
            name: {
              th: 'ดอยหล่อ',
              en: 'Doi Lo',
            },
            zipcode: '50160',
          },
          502402: {
            name: {
              th: 'สองแคว',
              en: 'Song Khwae, Doi Lo',
            },
            zipcode: '50160',
          },
          502403: {
            name: {
              th: 'ยางคราม',
              en: 'Yang Khram',
            },
            zipcode: '50160',
          },
          502404: {
            name: {
              th: 'สันติสุข',
              en: 'Santi Suk',
            },
            zipcode: '50160',
          },
        },
      },
      5025: {
        name: {
          th: 'กัลยาณิวัฒนา',
          en: 'Galyani Vadhana',
        },
        tambons: {
          502501: {
            name: {
              th: 'บ้านจันทร์',
              en: 'Ban Chan',
            },
            zipcode: '58130',
          },
          502502: {
            name: {
              th: 'แม่แดด',
              en: 'Mae Daet',
            },
            zipcode: '58130',
          },
          502503: {
            name: {
              th: 'แจ่มหลวง',
              en: 'Chaem Luang',
            },
            zipcode: '58130',
          },
        },
      },
    },
  },
  51: {
    name: {
      th: 'ลำพูน',
      en: 'Lamphun',
    },
    amphoes: {
      5101: {
        name: {
          th: 'เมืองลำพูน',
          en: 'Muang',
        },
        tambons: {
          510101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '51000',
          },
          510102: {
            name: {
              th: 'เหมืองง่า',
              en: 'Mueang Nga',
            },
            zipcode: '51000',
          },
          510103: {
            name: {
              th: 'อุโมงค์',
              en: 'Umong',
            },
            zipcode: '51150',
          },
          510104: {
            name: {
              th: 'หนองช้างคืน',
              en: 'Nong Chang Khuen',
            },
            zipcode: '51150',
          },
          510105: {
            name: {
              th: 'ประตูป่า',
              en: 'Pratu Pa',
            },
            zipcode: '51000',
          },
          510106: {
            name: {
              th: 'ริมปิง',
              en: 'Rim Ping',
            },
            zipcode: '51000',
          },
          510107: {
            name: {
              th: 'ต้นธง',
              en: 'Ton Thong',
            },
            zipcode: '51000',
          },
          510108: {
            name: {
              th: 'บ้านแป้น',
              en: 'Ban Paen',
            },
            zipcode: '51000',
          },
          510109: {
            name: {
              th: 'เหมืองจี้',
              en: 'Mueang Chi',
            },
            zipcode: '51000',
          },
          510110: {
            name: {
              th: 'ป่าสัก',
              en: 'Pa Sak',
            },
            zipcode: '51000',
          },
          510111: {
            name: {
              th: 'เวียงยอง',
              en: 'Wiang Yong',
            },
            zipcode: '51000',
          },
          510112: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '51000',
          },
          510113: {
            name: {
              th: 'มะเขือแจ้',
              en: 'Makhuea Chae',
            },
            zipcode: '51000',
          },
          510116: {
            name: {
              th: 'ศรีบัวบาน',
              en: 'Si Bua Ban',
            },
            zipcode: '51000',
          },
          510117: {
            name: {
              th: 'หนองหนาม',
              en: 'Nong Nam',
            },
            zipcode: '51000',
          },
        },
      },
      5102: {
        name: {
          th: 'แม่ทา',
          en: 'Mae Tha',
        },
        tambons: {
          510201: {
            name: {
              th: 'ทาปลาดุก',
              en: 'Tha Pla Duk',
            },
            zipcode: '51140',
          },
          510202: {
            name: {
              th: 'ทาสบเส้า',
              en: 'Tha Sop Sao',
            },
            zipcode: '51140',
          },
          510203: {
            name: {
              th: 'ทากาศ',
              en: 'Tha Kat',
            },
            zipcode: '51170',
          },
          510204: {
            name: {
              th: 'ทาขุมเงิน',
              en: 'Tha Khum Ngoen',
            },
            zipcode: '51170',
          },
          510205: {
            name: {
              th: 'ทาทุ่งหลวง',
              en: 'Tha Thung Luang',
            },
            zipcode: '51170',
          },
          510206: {
            name: {
              th: 'ทาแม่ลอบ',
              en: 'Tha Mae Lop',
            },
            zipcode: '51170',
          },
        },
      },
      5103: {
        name: {
          th: 'บ้านโฮ่ง',
          en: 'Ban Hong',
        },
        tambons: {
          510301: {
            name: {
              th: 'บ้านโฮ่ง',
              en: 'Ban Hong',
            },
            zipcode: '51130',
          },
          510302: {
            name: {
              th: 'ป่าพลู',
              en: 'Pa Phlu',
            },
            zipcode: '51130',
          },
          510303: {
            name: {
              th: 'เหล่ายาว',
              en: 'Lao Yao',
            },
            zipcode: '51130',
          },
          510304: {
            name: {
              th: 'ศรีเตี้ย',
              en: 'Si Tia',
            },
            zipcode: '51130',
          },
          510305: {
            name: {
              th: 'หนองปลาสะวาย',
              en: 'Nong Pla Sawai',
            },
            zipcode: '51130',
          },
        },
      },
      5104: {
        name: {
          th: 'ลี้',
          en: 'Li',
        },
        tambons: {
          510401: {
            name: {
              th: 'ลี้',
              en: 'Li',
            },
            zipcode: '51110',
          },
          510402: {
            name: {
              th: 'แม่ตืน',
              en: 'Mae Tuen',
            },
            zipcode: '51110',
          },
          510403: {
            name: {
              th: 'นาทราย',
              en: 'Na Sai',
            },
            zipcode: '51110',
          },
          510404: {
            name: {
              th: 'ดงดำ',
              en: 'Dong Dam',
            },
            zipcode: '51110',
          },
          510405: {
            name: {
              th: 'ก้อ',
              en: 'Ko',
            },
            zipcode: '51110',
          },
          510406: {
            name: {
              th: 'แม่ลาน',
              en: 'Mae Lan',
            },
            zipcode: '51110',
          },
          510408: {
            name: {
              th: 'ป่าไผ่',
              en: 'Pa Phai',
            },
            zipcode: '51110',
          },
          510409: {
            name: {
              th: 'ศรีวิชัย',
              en: 'Si Wichai',
            },
            zipcode: '51110',
          },
        },
      },
      5105: {
        name: {
          th: 'ทุ่งหัวช้าง',
          en: 'Thung Hua Chang',
        },
        tambons: {
          510501: {
            name: {
              th: 'ทุ่งหัวช้าง',
              en: 'Thung Hua Chang',
            },
            zipcode: '51160',
          },
          510502: {
            name: {
              th: 'บ้านปวง',
              en: 'Ban Puang',
            },
            zipcode: '51160',
          },
          510503: {
            name: {
              th: 'ตะเคียนปม',
              en: 'Takhian Pom',
            },
            zipcode: '51160',
          },
        },
      },
      5106: {
        name: {
          th: 'ป่าซาง',
          en: 'Pa Sang',
        },
        tambons: {
          510601: {
            name: {
              th: 'ปากบ่อง',
              en: 'Pak Bong',
            },
            zipcode: '51120',
          },
          510602: {
            name: {
              th: 'ป่าซาง',
              en: 'Pa Sang',
            },
            zipcode: '51120',
          },
          510603: {
            name: {
              th: 'แม่แรง',
              en: 'Mae Raeng',
            },
            zipcode: '51120',
          },
          510604: {
            name: {
              th: 'ม่วงน้อย',
              en: 'Muang Noi',
            },
            zipcode: '51120',
          },
          510605: {
            name: {
              th: 'บ้านเรือน',
              en: 'Ban Ruean',
            },
            zipcode: '51120',
          },
          510606: {
            name: {
              th: 'มะกอก',
              en: 'Makok',
            },
            zipcode: '51120',
          },
          510607: {
            name: {
              th: 'ท่าตุ้ม',
              en: 'Tha Tum',
            },
            zipcode: '51120',
          },
          510608: {
            name: {
              th: 'น้ำดิบ',
              en: 'Nam Dip',
            },
            zipcode: '51120',
          },
          510611: {
            name: {
              th: 'นครเจดีย์',
              en: 'Nakhon Chedi',
            },
            zipcode: '51120',
          },
        },
      },
      5107: {
        name: {
          th: 'บ้านธิ',
          en: 'Ban Thi',
        },
        tambons: {
          510701: {
            name: {
              th: 'บ้านธิ',
              en: 'Ban Thi',
            },
            zipcode: '51180',
          },
          510702: {
            name: {
              th: 'ห้วยยาบ',
              en: 'Huai Yap',
            },
            zipcode: '51180',
          },
        },
      },
      5108: {
        name: {
          th: 'เวียงหนองล่อง',
          en: 'King Amphoe Wiang Nong Long',
        },
        tambons: {
          510801: {
            name: {
              th: 'หนองล่อง',
              en: 'Nong Long',
            },
            zipcode: '51120',
          },
          510802: {
            name: {
              th: 'หนองยวง',
              en: 'Nong Yuang',
            },
            zipcode: '51120',
          },
          510803: {
            name: {
              th: 'วังผาง',
              en: 'Wang Phang',
            },
            zipcode: '51120',
          },
        },
      },
    },
  },
  52: {
    name: {
      th: 'ลำปาง',
      en: 'Lampang',
    },
    amphoes: {
      5201: {
        name: {
          th: 'เมืองลำปาง',
          en: 'Muang',
        },
        tambons: {
          520101: {
            name: {
              th: 'เวียงเหนือ',
              en: 'Wiang Nuea',
            },
            zipcode: '52000',
          },
          520102: {
            name: {
              th: 'หัวเวียง',
              en: 'Hua Wiang',
            },
            zipcode: '52000',
          },
          520103: {
            name: {
              th: 'สวนดอก',
              en: 'Suan Dok',
            },
            zipcode: '52100',
          },
          520104: {
            name: {
              th: 'สบตุ๋ย',
              en: 'Sop Tui',
            },
            zipcode: '52100',
          },
          520105: {
            name: {
              th: 'พระบาท',
              en: 'Phra Bat',
            },
            zipcode: '52000',
          },
          520106: {
            name: {
              th: 'ชมพู',
              en: 'Chomphu',
            },
            zipcode: '52100',
          },
          520107: {
            name: {
              th: 'กล้วยแพะ',
              en: 'Kluai Phae',
            },
            zipcode: '52000',
          },
          520108: {
            name: {
              th: 'ปงแสนทอง',
              en: 'Pong Saen Thong',
            },
            zipcode: '52100',
          },
          520109: {
            name: {
              th: 'บ้านแลง',
              en: 'Ban Laeng',
            },
            zipcode: '52000',
          },
          520110: {
            name: {
              th: 'บ้านเสด็จ',
              en: 'Ban Sadet',
            },
            zipcode: '52000',
          },
          520111: {
            name: {
              th: 'พิชัย',
              en: 'Phichai',
            },
            zipcode: '52000',
          },
          520112: {
            name: {
              th: 'ทุ่งฝาย',
              en: 'Thung Fai',
            },
            zipcode: '52000',
          },
          520113: {
            name: {
              th: 'บ้านเอื้อม',
              en: 'Ban Ueam',
            },
            zipcode: '52100',
          },
          520114: {
            name: {
              th: 'บ้านเป้า',
              en: 'Ban Pao',
            },
            zipcode: '52100',
          },
          520115: {
            name: {
              th: 'บ้านค่า',
              en: 'Ban Kha',
            },
            zipcode: '52100',
          },
          520116: {
            name: {
              th: 'บ่อแฮ้ว',
              en: 'Bo Haeo',
            },
            zipcode: '52100',
          },
          520117: {
            name: {
              th: 'ต้นธงชัย',
              en: 'Ton Thong Chai',
            },
            zipcode: '52000',
          },
          520118: {
            name: {
              th: 'นิคมพัฒนา',
              en: 'Nikhom Phatthana',
            },
            zipcode: '52000',
          },
          520119: {
            name: {
              th: 'บุญนาคพัฒนา',
              en: 'Bunnak Phatthana',
            },
            zipcode: '52000',
          },
        },
      },
      5202: {
        name: {
          th: 'แม่เมาะ',
          en: 'Mae Mo',
        },
        tambons: {
          520201: {
            name: {
              th: 'บ้านดง',
              en: 'Ban Dong',
            },
            zipcode: '52220',
          },
          520202: {
            name: {
              th: 'นาสัก',
              en: 'Na Sak',
            },
            zipcode: '52220',
          },
          520203: {
            name: {
              th: 'จางเหนือ',
              en: 'Chang Nuea',
            },
            zipcode: '52220',
          },
          520204: {
            name: {
              th: 'แม่เมาะ',
              en: 'Mae Mo',
            },
            zipcode: '52220',
          },
          520205: {
            name: {
              th: 'สบป้าด',
              en: 'Sop Pat',
            },
            zipcode: '52220',
          },
        },
      },
      5203: {
        name: {
          th: 'เกาะคา',
          en: 'Ko Kha',
        },
        tambons: {
          520301: {
            name: {
              th: 'ลำปางหลวง',
              en: 'Lampang Luang',
            },
            zipcode: '52130',
          },
          520302: {
            name: {
              th: 'นาแก้ว',
              en: 'Na Kaeo',
            },
            zipcode: '52130',
          },
          520303: {
            name: {
              th: 'ไหล่หิน',
              en: 'Lai Hin',
            },
            zipcode: '52130',
          },
          520304: {
            name: {
              th: 'วังพร้าว',
              en: 'Wang Phrao',
            },
            zipcode: '52130',
          },
          520305: {
            name: {
              th: 'ศาลา',
              en: 'Sala',
            },
            zipcode: '52130',
          },
          520306: {
            name: {
              th: 'เกาะคา',
              en: 'Ko Kha',
            },
            zipcode: '52130',
          },
          520307: {
            name: {
              th: 'นาแส่ง',
              en: 'Na Saeng',
            },
            zipcode: '52130',
          },
          520308: {
            name: {
              th: 'ท่าผา',
              en: 'Tha Pha',
            },
            zipcode: '52130',
          },
          520309: {
            name: {
              th: 'ใหม่พัฒนา',
              en: 'Mai Phatthana',
            },
            zipcode: '52130',
          },
        },
      },
      5204: {
        name: {
          th: 'เสริมงาม',
          en: 'Soem Ngam',
        },
        tambons: {
          520401: {
            name: {
              th: 'ทุ่งงาม',
              en: 'Thung Ngam',
            },
            zipcode: '52210',
          },
          520402: {
            name: {
              th: 'เสริมขวา',
              en: 'Soem Khwa',
            },
            zipcode: '52210',
          },
          520403: {
            name: {
              th: 'เสริมซ้าย',
              en: 'Soem Sai',
            },
            zipcode: '52210',
          },
          520404: {
            name: {
              th: 'เสริมกลาง',
              en: 'Soem Klang',
            },
            zipcode: '52210',
          },
        },
      },
      5205: {
        name: {
          th: 'งาว',
          en: 'Ngao',
        },
        tambons: {
          520501: {
            name: {
              th: 'หลวงเหนือ',
              en: 'Luang Nuea',
            },
            zipcode: '52110',
          },
          520502: {
            name: {
              th: 'หลวงใต้',
              en: 'Luang Tai',
            },
            zipcode: '52110',
          },
          520503: {
            name: {
              th: 'บ้านโป่ง',
              en: 'Ban Pong',
            },
            zipcode: '52110',
          },
          520504: {
            name: {
              th: 'บ้านร้อง',
              en: 'Ban Rong',
            },
            zipcode: '52110',
          },
          520505: {
            name: {
              th: 'ปงเตา',
              en: 'Pong Tao',
            },
            zipcode: '52110',
          },
          520506: {
            name: {
              th: 'นาแก',
              en: 'Na Kae',
            },
            zipcode: '52110',
          },
          520507: {
            name: {
              th: 'บ้านอ้อน',
              en: 'Ban On',
            },
            zipcode: '52110',
          },
          520508: {
            name: {
              th: 'บ้านแหง',
              en: 'Ban Haeng',
            },
            zipcode: '52110',
          },
          520509: {
            name: {
              th: 'บ้านหวด',
              en: 'Ban Huat',
            },
            zipcode: '52110',
          },
          520510: {
            name: {
              th: 'แม่ตีบ',
              en: 'Mae Tip',
            },
            zipcode: '52110',
          },
        },
      },
      5206: {
        name: {
          th: 'แจ้ห่ม',
          en: 'Chae Hom',
        },
        tambons: {
          520601: {
            name: {
              th: 'แจ้ห่ม',
              en: 'Chae Hom',
            },
            zipcode: '52120',
          },
          520602: {
            name: {
              th: 'บ้านสา',
              en: 'Ban Sa',
            },
            zipcode: '52120',
          },
          520603: {
            name: {
              th: 'ปงดอน',
              en: 'Pong Don',
            },
            zipcode: '52120',
          },
          520604: {
            name: {
              th: 'แม่สุก',
              en: 'Mae Suk',
            },
            zipcode: '52120',
          },
          520605: {
            name: {
              th: 'เมืองมาย',
              en: 'Mueang Mai',
            },
            zipcode: '52120',
          },
          520606: {
            name: {
              th: 'ทุ่งผึ้ง',
              en: 'Thung Phueng',
            },
            zipcode: '52120',
          },
          520607: {
            name: {
              th: 'วิเชตนคร',
              en: 'Wichet Nakhon',
            },
            zipcode: '52120',
          },
        },
      },
      5207: {
        name: {
          th: 'วังเหนือ',
          en: 'Wang Nuea',
        },
        tambons: {
          520701: {
            name: {
              th: 'ทุ่งฮั้ว',
              en: 'Thung Hua',
            },
            zipcode: '52140',
          },
          520702: {
            name: {
              th: 'วังเหนือ',
              en: 'Wang Nuea',
            },
            zipcode: '52140',
          },
          520703: {
            name: {
              th: 'วังใต้',
              en: 'Wang Tai',
            },
            zipcode: '52140',
          },
          520704: {
            name: {
              th: 'ร่องเคาะ',
              en: 'Rong Kho',
            },
            zipcode: '52140',
          },
          520705: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '52140',
          },
          520706: {
            name: {
              th: 'วังซ้าย',
              en: 'Wang Sai',
            },
            zipcode: '52140',
          },
          520707: {
            name: {
              th: 'วังแก้ว',
              en: 'Wang Kaeo',
            },
            zipcode: '52140',
          },
          520708: {
            name: {
              th: 'วังทรายคำ',
              en: 'Wang Sai Kham',
            },
            zipcode: '52140',
          },
        },
      },
      5208: {
        name: {
          th: 'เถิน',
          en: 'Thoen',
        },
        tambons: {
          520801: {
            name: {
              th: 'ล้อมแรด',
              en: 'Lom Raat',
            },
            zipcode: '52160',
          },
          520802: {
            name: {
              th: 'แม่วะ',
              en: 'Mae Wah',
            },
            zipcode: '52230',
          },
          520803: {
            name: {
              th: 'แม่ปะ',
              en: 'Mae Pa',
            },
            zipcode: '52160',
          },
          520804: {
            name: {
              th: 'แม่มอก',
              en: 'Mae Mok',
            },
            zipcode: '52160',
          },
          520805: {
            name: {
              th: 'เวียงมอก',
              en: 'Viang Mok',
            },
            zipcode: '52160',
          },
          520806: {
            name: {
              th: 'นาโป่ง',
              en: 'Na Pong',
            },
            zipcode: '52160',
          },
          520807: {
            name: {
              th: 'แม่ถอด',
              en: 'Mae Thod',
            },
            zipcode: '52160',
          },
          520808: {
            name: {
              th: 'เถินบุรี',
              en: 'Thoen Buri',
            },
            zipcode: '52160',
          },
        },
      },
      5209: {
        name: {
          th: 'แม่พริก',
          en: 'Mae Phrik',
        },
        tambons: {
          520901: {
            name: {
              th: 'แม่พริก',
              en: 'Mae Phrik',
            },
            zipcode: '52180',
          },
          520902: {
            name: {
              th: 'ผาปัง',
              en: 'Pha Pang',
            },
            zipcode: '52180',
          },
          520903: {
            name: {
              th: 'แม่ปุ',
              en: 'Mae Pu',
            },
            zipcode: '52180',
          },
          520904: {
            name: {
              th: 'พระบาทวังตวง',
              en: 'Phra Bat Wang Tuang',
            },
            zipcode: '52180',
          },
        },
      },
      5210: {
        name: {
          th: 'แม่ทะ',
          en: 'Mae Tha',
        },
        tambons: {
          521001: {
            name: {
              th: 'แม่ทะ',
              en: 'Mae Tha',
            },
            zipcode: '52150',
          },
          521002: {
            name: {
              th: 'นาครัว',
              en: 'Na Khrua',
            },
            zipcode: '52150',
          },
          521003: {
            name: {
              th: 'ป่าตัน',
              en: 'Pa Tan',
            },
            zipcode: '52150',
          },
          521004: {
            name: {
              th: 'บ้านกิ่ว',
              en: 'Ban Kio',
            },
            zipcode: '52150',
          },
          521005: {
            name: {
              th: 'บ้านบอม',
              en: 'Ban Bom',
            },
            zipcode: '52150',
          },
          521006: {
            name: {
              th: 'น้ำโจ้',
              en: 'Nam Cho',
            },
            zipcode: '52150',
          },
          521007: {
            name: {
              th: 'ดอนไฟ',
              en: 'Don Fai',
            },
            zipcode: '52150',
          },
          521008: {
            name: {
              th: 'หัวเสือ',
              en: 'Hua Suea',
            },
            zipcode: '52150',
          },
          521010: {
            name: {
              th: 'วังเงิน',
              en: 'Wang Ngoen',
            },
            zipcode: '52150',
          },
          521011: {
            name: {
              th: 'สันดอนแก้ว',
              en: 'San Don Kaeo',
            },
            zipcode: '52150',
          },
        },
      },
      5211: {
        name: {
          th: 'สบปราบ',
          en: 'Sop Prap',
        },
        tambons: {
          521101: {
            name: {
              th: 'สบปราบ',
              en: 'Sop Prap',
            },
            zipcode: '52170',
          },
          521102: {
            name: {
              th: 'สมัย',
              en: 'Samai',
            },
            zipcode: '52170',
          },
          521103: {
            name: {
              th: 'แม่กัวะ',
              en: 'Mae Kua',
            },
            zipcode: '52170',
          },
          521104: {
            name: {
              th: 'นายาง',
              en: 'Na Yang',
            },
            zipcode: '52170',
          },
        },
      },
      5212: {
        name: {
          th: 'ห้างฉัตร',
          en: 'Hang Chat',
        },
        tambons: {
          521201: {
            name: {
              th: 'ห้างฉัตร',
              en: 'Hang Chat',
            },
            zipcode: '52190',
          },
          521202: {
            name: {
              th: 'หนองหล่ม',
              en: 'Nong Lom',
            },
            zipcode: '52190',
          },
          521203: {
            name: {
              th: 'เมืองยาว',
              en: 'Mueang Yao',
            },
            zipcode: '52190',
          },
          521204: {
            name: {
              th: 'ปงยางคก',
              en: 'Pong Yang Khok',
            },
            zipcode: '52190',
          },
          521205: {
            name: {
              th: 'เวียงตาล',
              en: 'Wiang Tan',
            },
            zipcode: '52190',
          },
          521206: {
            name: {
              th: 'แม่สัน',
              en: 'Mae San',
            },
            zipcode: '52190',
          },
          521207: {
            name: {
              th: 'วอแก้ว',
              en: 'Wo Kaeo',
            },
            zipcode: '52190',
          },
        },
      },
      5213: {
        name: {
          th: 'เมืองปาน',
          en: 'Mueang Pan',
        },
        tambons: {
          521301: {
            name: {
              th: 'เมืองปาน',
              en: 'Mueang Pan',
            },
            zipcode: '52240',
          },
          521302: {
            name: {
              th: 'บ้านขอ',
              en: 'Ban Kho',
            },
            zipcode: '52240',
          },
          521303: {
            name: {
              th: 'ทุ่งกว๋าว',
              en: 'Thung Kwao',
            },
            zipcode: '52240',
          },
          521304: {
            name: {
              th: 'แจ้ซ้อน',
              en: 'Chae Son',
            },
            zipcode: '52240',
          },
          521305: {
            name: {
              th: 'หัวเมือง',
              en: 'Hua Mueang',
            },
            zipcode: '52240',
          },
        },
      },
    },
  },
  53: {
    name: {
      th: 'อุตรดิตถ์',
      en: 'Uttaradit',
    },
    amphoes: {
      5301: {
        name: {
          th: 'เมืองอุตรดิตถ์',
          en: 'Muang',
        },
        tambons: {
          530101: {
            name: {
              th: 'ท่าอิฐ',
              en: 'Tha It',
            },
            zipcode: '53000',
          },
          530102: {
            name: {
              th: 'ท่าเสา',
              en: 'Tha Sao',
            },
            zipcode: '53000',
          },
          530103: {
            name: {
              th: 'บ้านเกาะ',
              en: 'Ban Ko',
            },
            zipcode: '53000',
          },
          530104: {
            name: {
              th: 'ป่าเซ่า',
              en: 'Pa Sao',
            },
            zipcode: '53000',
          },
          530105: {
            name: {
              th: 'คุ้งตะเภา',
              en: 'Khung Taphao',
            },
            zipcode: '53000',
          },
          530106: {
            name: {
              th: 'วังกะพี้',
              en: 'Wang Kaphi',
            },
            zipcode: '53170',
          },
          530107: {
            name: {
              th: 'หาดกรวด',
              en: 'Hat Kruat',
            },
            zipcode: '53000',
          },
          530108: {
            name: {
              th: 'น้ำริด',
              en: 'Nam Rit',
            },
            zipcode: '53000',
          },
          530109: {
            name: {
              th: 'งิ้วงาม',
              en: 'Ngio Ngam',
            },
            zipcode: '53000',
          },
          530110: {
            name: {
              th: 'บ้านด่านนาขาม',
              en: 'Ban Dan Na Kham',
            },
            zipcode: '53000',
          },
          530111: {
            name: {
              th: 'บ้านด่าน',
              en: 'Ban Dan',
            },
            zipcode: '53000',
          },
          530112: {
            name: {
              th: 'ผาจุก',
              en: 'Pha Chuk',
            },
            zipcode: '53000',
          },
          530113: {
            name: {
              th: 'วังดิน',
              en: 'Wang Din',
            },
            zipcode: '53000',
          },
          530114: {
            name: {
              th: 'แสนตอ',
              en: 'Saen To',
            },
            zipcode: '53000',
          },
          530115: {
            name: {
              th: 'หาดงิ้ว',
              en: 'Hat Ngio',
            },
            zipcode: '53000',
          },
          530116: {
            name: {
              th: 'ขุนฝาง',
              en: 'Khun Fang',
            },
            zipcode: '53000',
          },
          530117: {
            name: {
              th: 'ถ้ำฉลอง',
              en: 'Tham Chalong',
            },
            zipcode: '53000',
          },
        },
      },
      5302: {
        name: {
          th: 'ตรอน',
          en: 'Tron',
        },
        tambons: {
          530201: {
            name: {
              th: 'วังแดง',
              en: 'Wang Daeng',
            },
            zipcode: '53140',
          },
          530202: {
            name: {
              th: 'บ้านแก่ง',
              en: 'Ban Kaeng',
            },
            zipcode: '53140',
          },
          530203: {
            name: {
              th: 'หาดสองแคว',
              en: 'Hat Song Khwae',
            },
            zipcode: '53140',
          },
          530204: {
            name: {
              th: 'น้ำอ่าง',
              en: 'Nam Ang',
            },
            zipcode: '53140',
          },
          530205: {
            name: {
              th: 'ข่อยสูง',
              en: 'Khoi Sung',
            },
            zipcode: '53140',
          },
        },
      },
      5303: {
        name: {
          th: 'ท่าปลา',
          en: 'Tha Pla',
        },
        tambons: {
          530301: {
            name: {
              th: 'ท่าปลา',
              en: 'Tha Pla',
            },
            zipcode: '53150',
          },
          530302: {
            name: {
              th: 'หาดล้า',
              en: 'Hat La',
            },
            zipcode: '53150',
          },
          530303: {
            name: {
              th: 'ผาเลือด',
              en: 'Pha Lueat',
            },
            zipcode: '53190',
          },
          530304: {
            name: {
              th: 'จริม',
              en: 'Charim',
            },
            zipcode: '53150',
          },
          530305: {
            name: {
              th: 'น้ำหมัน',
              en: 'Nam Man',
            },
            zipcode: '53150',
          },
          530306: {
            name: {
              th: 'ท่าแฝก',
              en: 'Tha Faek',
            },
            zipcode: '53110',
          },
          530307: {
            name: {
              th: 'นางพญา',
              en: 'Nang Phaya',
            },
            zipcode: '53150',
          },
          530308: {
            name: {
              th: 'ร่วมจิต',
              en: 'Ruam Chit',
            },
            zipcode: '53190',
          },
        },
      },
      5304: {
        name: {
          th: 'น้ำปาด',
          en: 'Nam Pat',
        },
        tambons: {
          530401: {
            name: {
              th: 'แสนตอ',
              en: 'Saen To',
            },
            zipcode: '53110',
          },
          530402: {
            name: {
              th: 'บ้านฝาย',
              en: 'Ban Fai',
            },
            zipcode: '53110',
          },
          530403: {
            name: {
              th: 'เด่นเหล็ก',
              en: 'Den Lek',
            },
            zipcode: '53110',
          },
          530404: {
            name: {
              th: 'น้ำไคร้',
              en: 'Nam Khrai',
            },
            zipcode: '53110',
          },
          530405: {
            name: {
              th: 'น้ำไผ่',
              en: 'Nam Phai',
            },
            zipcode: '53110',
          },
          530406: {
            name: {
              th: 'ห้วยมุ่น',
              en: 'Huai Mun',
            },
            zipcode: '53110',
          },
          530407: {
            name: {
              th: 'ท่าแฝก',
              en: 'Tha Faek',
            },
            zipcode: '53110',
          },
        },
      },
      5305: {
        name: {
          th: 'ฟากท่า',
          en: 'Fak Tha',
        },
        tambons: {
          530501: {
            name: {
              th: 'ฟากท่า',
              en: 'Fak Tha',
            },
            zipcode: '53160',
          },
          530502: {
            name: {
              th: 'สองคอน',
              en: 'Song Khon',
            },
            zipcode: '53160',
          },
          530503: {
            name: {
              th: 'บ้านเสี้ยว',
              en: 'Ban Siao',
            },
            zipcode: '53160',
          },
          530504: {
            name: {
              th: 'สองห้อง',
              en: 'Song Hong',
            },
            zipcode: '53160',
          },
        },
      },
      5306: {
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        tambons: {
          530601: {
            name: {
              th: 'ม่วงเจ็ดต้น',
              en: 'Muang Chet Ton',
            },
            zipcode: '53180',
          },
          530602: {
            name: {
              th: 'บ้านโคก',
              en: 'Ban Khok',
            },
            zipcode: '53180',
          },
          530603: {
            name: {
              th: 'นาขุม',
              en: 'Na Khum',
            },
            zipcode: '53180',
          },
          530604: {
            name: {
              th: 'บ่อเบี้ย',
              en: 'Bo Bia',
            },
            zipcode: '53180',
          },
        },
      },
      5307: {
        name: {
          th: 'พิชัย',
          en: 'Phichai',
        },
        tambons: {
          530701: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '53120',
          },
          530702: {
            name: {
              th: 'บ้านดารา',
              en: 'Ban Dara',
            },
            zipcode: '53220',
          },
          530703: {
            name: {
              th: 'ไร่อ้อย',
              en: 'Rai Oi',
            },
            zipcode: '53120',
          },
          530704: {
            name: {
              th: 'ท่าสัก',
              en: 'Tha Sak',
            },
            zipcode: '53220',
          },
          530705: {
            name: {
              th: 'คอรุม',
              en: 'Kho Rum',
            },
            zipcode: '53120',
          },
          530706: {
            name: {
              th: 'บ้านหม้อ',
              en: 'Ban Mo',
            },
            zipcode: '53120',
          },
          530707: {
            name: {
              th: 'ท่ามะเฟือง',
              en: 'Tha Mafueang',
            },
            zipcode: '53120',
          },
          530708: {
            name: {
              th: 'บ้านโคน',
              en: 'Ban Khon',
            },
            zipcode: '53120',
          },
          530709: {
            name: {
              th: 'พญาแมน',
              en: 'Phaya Maen',
            },
            zipcode: '53120',
          },
          530710: {
            name: {
              th: 'นาอิน',
              en: 'Na In',
            },
            zipcode: '53120',
          },
          530711: {
            name: {
              th: 'นายาง',
              en: 'Na Yang',
            },
            zipcode: '53120',
          },
        },
      },
      5308: {
        name: {
          th: 'ลับแล',
          en: 'Laplae',
        },
        tambons: {
          530801: {
            name: {
              th: 'ศรีพนมมาศ',
              en: 'Si Phanom Mat',
            },
            zipcode: '53130',
          },
          530802: {
            name: {
              th: 'แม่พูล',
              en: 'Mae Phun',
            },
            zipcode: '53130',
          },
          530803: {
            name: {
              th: 'นานกกก',
              en: 'Na Nok Kok',
            },
            zipcode: '53130',
          },
          530804: {
            name: {
              th: 'ฝายหลวง',
              en: 'Fai Luang',
            },
            zipcode: '53130',
          },
          530805: {
            name: {
              th: 'ชัยจุมพล',
              en: 'Chai Chumphon',
            },
            zipcode: '53130',
          },
          530806: {
            name: {
              th: 'ไผ่ล้อม',
              en: 'Phai Lom',
            },
            zipcode: '53210',
          },
          530807: {
            name: {
              th: 'ทุ่งยั้ง',
              en: 'Thung Yang',
            },
            zipcode: '53210',
          },
          530808: {
            name: {
              th: 'ด่านแม่คำมัน',
              en: 'Dan Mae Kham Man',
            },
            zipcode: '53210',
          },
        },
      },
      5309: {
        name: {
          th: 'ทองแสนขัน',
          en: 'Thong Saen Khan',
        },
        tambons: {
          530901: {
            name: {
              th: 'ผักขวง',
              en: 'Phak Khuang',
            },
            zipcode: '53230',
          },
          530902: {
            name: {
              th: 'บ่อทอง',
              en: 'Bo Thong',
            },
            zipcode: '53230',
          },
          530903: {
            name: {
              th: 'ป่าคาย',
              en: 'Pa Khai',
            },
            zipcode: '53230',
          },
          530904: {
            name: {
              th: 'น้ำพี้',
              en: 'Nam Phi',
            },
            zipcode: '53230',
          },
        },
      },
    },
  },
  54: {
    name: {
      th: 'แพร่',
      en: 'Phrae',
    },
    amphoes: {
      5401: {
        name: {
          th: 'เมืองแพร่',
          en: 'Muang',
        },
        tambons: {
          540101: {
            name: {
              th: 'ในเวียง',
              en: 'Nai Wiang',
            },
            zipcode: '54000',
          },
          540102: {
            name: {
              th: 'นาจักร',
              en: 'Na Chak',
            },
            zipcode: '54000',
          },
          540103: {
            name: {
              th: 'น้ำชำ',
              en: 'Nam Cham',
            },
            zipcode: '54000',
          },
          540104: {
            name: {
              th: 'ป่าแดง',
              en: 'Pa Daeng',
            },
            zipcode: '54000',
          },
          540105: {
            name: {
              th: 'ทุ่งโฮ้ง',
              en: 'Thung Hong',
            },
            zipcode: '54000',
          },
          540106: {
            name: {
              th: 'เหมืองหม้อ',
              en: 'Mueang Mo',
            },
            zipcode: '54000',
          },
          540107: {
            name: {
              th: 'วังธง',
              en: 'Wang Thong',
            },
            zipcode: '54000',
          },
          540108: {
            name: {
              th: 'แม่หล่าย',
              en: 'Mae Lai',
            },
            zipcode: '54000',
          },
          540109: {
            name: {
              th: 'ห้วยม้า',
              en: 'Huai Ma',
            },
            zipcode: '54000',
          },
          540110: {
            name: {
              th: 'ป่าแมต',
              en: 'Pa Maet',
            },
            zipcode: '54000',
          },
          540111: {
            name: {
              th: 'บ้านถิ่น',
              en: 'Ban Thin',
            },
            zipcode: '54000',
          },
          540112: {
            name: {
              th: 'สวนเขื่อน',
              en: 'Suan Khuean',
            },
            zipcode: '54000',
          },
          540113: {
            name: {
              th: 'วังหงส์',
              en: 'Wang Hong',
            },
            zipcode: '54000',
          },
          540114: {
            name: {
              th: 'แม่คำมี',
              en: 'Mae Kham Mi',
            },
            zipcode: '54000',
          },
          540115: {
            name: {
              th: 'ทุ่งกวาว',
              en: 'Thung Kwao',
            },
            zipcode: '54000',
          },
          540116: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '54000',
          },
          540117: {
            name: {
              th: 'แม่ยม',
              en: 'Mae Yom',
            },
            zipcode: '54000',
          },
          540118: {
            name: {
              th: 'ช่อแฮ',
              en: 'Cho Hae',
            },
            zipcode: '54000',
          },
          540119: {
            name: {
              th: 'ร่องฟอง',
              en: 'Rong Fong',
            },
            zipcode: '54000',
          },
          540120: {
            name: {
              th: 'กาญจนา',
              en: 'Kanchana',
            },
            zipcode: '54000',
          },
        },
      },
      5402: {
        name: {
          th: 'ร้องกวาง',
          en: 'Rong Kwang',
        },
        tambons: {
          540201: {
            name: {
              th: 'ร้องกวาง',
              en: 'Rong Kwang',
            },
            zipcode: '54140',
          },
          540204: {
            name: {
              th: 'ร้องเข็ม',
              en: 'Rong Khem',
            },
            zipcode: '54140',
          },
          540205: {
            name: {
              th: 'น้ำเลา',
              en: 'Nam Lao',
            },
            zipcode: '54140',
          },
          540206: {
            name: {
              th: 'บ้านเวียง',
              en: 'Ban Wiang',
            },
            zipcode: '54140',
          },
          540207: {
            name: {
              th: 'ทุ่งศรี',
              en: 'Thung Si',
            },
            zipcode: '54140',
          },
          540208: {
            name: {
              th: 'แม่ยางตาล',
              en: 'Mae Yang Tan',
            },
            zipcode: '54140',
          },
          540209: {
            name: {
              th: 'แม่ยางฮ่อ',
              en: 'Mae Yang Ho',
            },
            zipcode: '54140',
          },
          540210: {
            name: {
              th: 'ไผ่โทน',
              en: 'Phai Thon',
            },
            zipcode: '54140',
          },
          540213: {
            name: {
              th: 'ห้วยโรง',
              en: 'Huai Rong',
            },
            zipcode: '54140',
          },
          540214: {
            name: {
              th: 'แม่ทราย',
              en: 'Mae Sai',
            },
            zipcode: '54140',
          },
          540215: {
            name: {
              th: 'แม่ยางร้อง',
              en: 'Mae Yang Rong',
            },
            zipcode: '54140',
          },
        },
      },
      5403: {
        name: {
          th: 'ลอง',
          en: 'Long',
        },
        tambons: {
          540301: {
            name: {
              th: 'ห้วยอ้อ',
              en: 'Huai O',
            },
            zipcode: '54150',
          },
          540302: {
            name: {
              th: 'บ้านปิน',
              en: 'Ban Pin',
            },
            zipcode: '54150',
          },
          540303: {
            name: {
              th: 'ต้าผามอก',
              en: 'Ta Pha Mok',
            },
            zipcode: '54150',
          },
          540304: {
            name: {
              th: 'เวียงต้า',
              en: 'Wiang Ta',
            },
            zipcode: '54150',
          },
          540305: {
            name: {
              th: 'ปากกาง',
              en: 'Pak Kang',
            },
            zipcode: '54150',
          },
          540306: {
            name: {
              th: 'หัวทุ่ง',
              en: 'Hua Thung',
            },
            zipcode: '54150',
          },
          540307: {
            name: {
              th: 'ทุ่งแล้ง',
              en: 'Thung Laeng',
            },
            zipcode: '54150',
          },
          540308: {
            name: {
              th: 'บ่อเหล็กลอง',
              en: 'Bo Lek Long',
            },
            zipcode: '54150',
          },
          540309: {
            name: {
              th: 'แม่ปาน',
              en: 'Mae Pan',
            },
            zipcode: '54150',
          },
        },
      },
      5404: {
        name: {
          th: 'สูงเม่น',
          en: 'Sung Men',
        },
        tambons: {
          540401: {
            name: {
              th: 'สูงเม่น',
              en: 'Sung Men',
            },
            zipcode: '54130',
          },
          540402: {
            name: {
              th: 'น้ำชำ',
              en: 'Nam Cham',
            },
            zipcode: '54130',
          },
          540403: {
            name: {
              th: 'หัวฝาย',
              en: 'Hua Fai',
            },
            zipcode: '54130',
          },
          540404: {
            name: {
              th: 'ดอนมูล',
              en: 'Don Mun',
            },
            zipcode: '54130',
          },
          540405: {
            name: {
              th: 'บ้านเหล่า',
              en: 'Ban Lao',
            },
            zipcode: '54130',
          },
          540406: {
            name: {
              th: 'บ้านกวาง',
              en: 'Ban Kwang',
            },
            zipcode: '54130',
          },
          540407: {
            name: {
              th: 'บ้านปง',
              en: 'Ban Pong',
            },
            zipcode: '54130',
          },
          540408: {
            name: {
              th: 'บ้านกาศ',
              en: 'Ban Kat',
            },
            zipcode: '54130',
          },
          540409: {
            name: {
              th: 'ร่องกาศ',
              en: 'Rong Kat',
            },
            zipcode: '54130',
          },
          540410: {
            name: {
              th: 'สบสาย',
              en: 'Sop Sai',
            },
            zipcode: '54130',
          },
          540411: {
            name: {
              th: 'เวียงทอง',
              en: 'Wiang Thong',
            },
            zipcode: '54000',
          },
          540412: {
            name: {
              th: 'พระหลวง',
              en: 'Phra Luang',
            },
            zipcode: '54130',
          },
        },
      },
      5405: {
        name: {
          th: 'เด่นชัย',
          en: 'Den Chai',
        },
        tambons: {
          540501: {
            name: {
              th: 'เด่นชัย',
              en: 'Den Chai',
            },
            zipcode: '54110',
          },
          540502: {
            name: {
              th: 'แม่จั๊วะ',
              en: 'Mae Chua',
            },
            zipcode: '54110',
          },
          540503: {
            name: {
              th: 'ไทรย้อย',
              en: 'Sai Yoi',
            },
            zipcode: '54110',
          },
          540504: {
            name: {
              th: 'ห้วยไร่',
              en: 'Huai Rai',
            },
            zipcode: '54110',
          },
          540505: {
            name: {
              th: 'ปงป่าหวาย',
              en: 'Pong Pa Wai',
            },
            zipcode: '54110',
          },
        },
      },
      5406: {
        name: {
          th: 'สอง',
          en: 'Song',
        },
        tambons: {
          540601: {
            name: {
              th: 'บ้านหนุน',
              en: 'Ban Nun',
            },
            zipcode: '54120',
          },
          540602: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '54120',
          },
          540603: {
            name: {
              th: 'ห้วยหม้าย',
              en: 'Huai Mai',
            },
            zipcode: '54120',
          },
          540604: {
            name: {
              th: 'เตาปูน',
              en: 'Tao Pun',
            },
            zipcode: '54120',
          },
          540605: {
            name: {
              th: 'หัวเมือง',
              en: 'Hua Mueang',
            },
            zipcode: '54120',
          },
          540606: {
            name: {
              th: 'สะเอียบ',
              en: 'Sa-iap',
            },
            zipcode: '54120',
          },
          540607: {
            name: {
              th: 'แดนชุมพล',
              en: 'Daen Chumphon',
            },
            zipcode: '54120',
          },
          540608: {
            name: {
              th: 'ทุ่งน้าว',
              en: 'Thung Nao',
            },
            zipcode: '54120',
          },
        },
      },
      5407: {
        name: {
          th: 'วังชิ้น',
          en: 'Wang Chin',
        },
        tambons: {
          540701: {
            name: {
              th: 'วังชิ้น',
              en: 'Wang Chin',
            },
            zipcode: '54160',
          },
          540702: {
            name: {
              th: 'สรอย',
              en: 'Soi',
            },
            zipcode: '54160',
          },
          540703: {
            name: {
              th: 'แม่ป้าก',
              en: 'Mae Pak',
            },
            zipcode: '54160',
          },
          540704: {
            name: {
              th: 'นาพูน',
              en: 'Na Phun',
            },
            zipcode: '54160',
          },
          540705: {
            name: {
              th: 'แม่พุง',
              en: 'Mae Phung',
            },
            zipcode: '54160',
          },
          540706: {
            name: {
              th: 'ป่าสัก',
              en: 'Pa Sak',
            },
            zipcode: '54160',
          },
          540707: {
            name: {
              th: 'แม่เกิ๋ง',
              en: 'Mae Koeng',
            },
            zipcode: '54160',
          },
        },
      },
      5408: {
        name: {
          th: 'หนองม่วงไข่',
          en: 'Nong Muang Kai',
        },
        tambons: {
          540801: {
            name: {
              th: 'แม่คำมี',
              en: 'Mae Kham Mi',
            },
            zipcode: '54170',
          },
          540802: {
            name: {
              th: 'หนองม่วงไข่',
              en: 'Nong Muang Khai',
            },
            zipcode: '54170',
          },
          540803: {
            name: {
              th: 'น้ำรัด',
              en: 'Nam Rat',
            },
            zipcode: '54170',
          },
          540804: {
            name: {
              th: 'วังหลวง',
              en: 'Wang Luang',
            },
            zipcode: '54170',
          },
          540805: {
            name: {
              th: 'ตำหนักธรรม',
              en: 'Tamnak Tham',
            },
            zipcode: '54170',
          },
          540806: {
            name: {
              th: 'ทุ่งแค้ว',
              en: 'Thung Khaeo',
            },
            zipcode: '54170',
          },
        },
      },
    },
  },
  55: {
    name: {
      th: 'น่าน',
      en: 'Nan',
    },
    amphoes: {
      5501: {
        name: {
          th: 'เมืองน่าน',
          en: 'Muang',
        },
        tambons: {
          550101: {
            name: {
              th: 'ในเวียง',
              en: 'Nai Wiang',
            },
            zipcode: '55000',
          },
          550102: {
            name: {
              th: 'บ่อ',
              en: 'Bo',
            },
            zipcode: '55000',
          },
          550103: {
            name: {
              th: 'ผาสิงห์',
              en: 'Pha Sing',
            },
            zipcode: '55000',
          },
          550104: {
            name: {
              th: 'ไชยสถาน',
              en: 'Chai Sathan',
            },
            zipcode: '55000',
          },
          550105: {
            name: {
              th: 'ถืมตอง',
              en: 'Thuem Tong',
            },
            zipcode: '55000',
          },
          550106: {
            name: {
              th: 'เรือง',
              en: 'Rueang',
            },
            zipcode: '55000',
          },
          550107: {
            name: {
              th: 'นาซาว',
              en: 'Na Sao',
            },
            zipcode: '55000',
          },
          550108: {
            name: {
              th: 'ดู่ใต้',
              en: 'Du Tai',
            },
            zipcode: '55000',
          },
          550109: {
            name: {
              th: 'กองควาย',
              en: 'Kong Khwai',
            },
            zipcode: '55000',
          },
          550116: {
            name: {
              th: 'บ่อสวก',
              en: 'Bo Suak',
            },
            zipcode: '55000',
          },
          550117: {
            name: {
              th: 'สะเนียน',
              en: 'Sanian',
            },
            zipcode: '55000',
          },
        },
      },
      5502: {
        name: {
          th: 'แม่จริม',
          en: 'Mae Charim',
        },
        tambons: {
          550202: {
            name: {
              th: 'หนองแดง',
              en: 'Nong Daeng',
            },
            zipcode: '55170',
          },
          550203: {
            name: {
              th: 'หมอเมือง',
              en: 'Mo Mueang',
            },
            zipcode: '55170',
          },
          550204: {
            name: {
              th: 'น้ำพาง',
              en: 'Nam Phang',
            },
            zipcode: '55170',
          },
          550205: {
            name: {
              th: 'น้ำปาย',
              en: 'Nam Pai',
            },
            zipcode: '55170',
          },
          550206: {
            name: {
              th: 'แม่จริม',
              en: 'Mae Charim',
            },
            zipcode: '55170',
          },
        },
      },
      5503: {
        name: {
          th: 'บ้านหลวง',
          en: 'Ban Luang',
        },
        tambons: {
          550301: {
            name: {
              th: 'บ้านฟ้า',
              en: 'Ban Fa',
            },
            zipcode: '55190',
          },
          550302: {
            name: {
              th: 'ป่าคาหลวง',
              en: 'Pa Kha Luang',
            },
            zipcode: '55190',
          },
          550303: {
            name: {
              th: 'สวด',
              en: 'Suat',
            },
            zipcode: '55190',
          },
          550304: {
            name: {
              th: 'บ้านพี้',
              en: 'Ban Phi',
            },
            zipcode: '55190',
          },
        },
      },
      5504: {
        name: {
          th: 'นาน้อย',
          en: 'Na Noi',
        },
        tambons: {
          550401: {
            name: {
              th: 'นาน้อย',
              en: 'Na Noi',
            },
            zipcode: '55150',
          },
          550402: {
            name: {
              th: 'เชียงของ',
              en: 'Chiang Khong',
            },
            zipcode: '55150',
          },
          550403: {
            name: {
              th: 'ศรีษะเกษ',
              en: 'Sisaket',
            },
            zipcode: '55150',
          },
          550404: {
            name: {
              th: 'สถาน',
              en: 'Sathan',
            },
            zipcode: '55150',
          },
          550405: {
            name: {
              th: 'สันทะ',
              en: 'Santha',
            },
            zipcode: '55150',
          },
          550406: {
            name: {
              th: 'บัวใหญ่',
              en: 'Bua Yai',
            },
            zipcode: '55150',
          },
          550407: {
            name: {
              th: 'น้ำตก',
              en: 'Nam Tok',
            },
            zipcode: '55150',
          },
        },
      },
      5505: {
        name: {
          th: 'ปัว',
          en: 'Pua',
        },
        tambons: {
          550501: {
            name: {
              th: 'ปัว',
              en: 'Pua',
            },
            zipcode: '55120',
          },
          550502: {
            name: {
              th: 'แงง',
              en: 'Ngaeng',
            },
            zipcode: '55120',
          },
          550503: {
            name: {
              th: 'สถาน',
              en: 'Sathan',
            },
            zipcode: '55120',
          },
          550504: {
            name: {
              th: 'ศิลาแลง',
              en: 'Sila Laeng',
            },
            zipcode: '55120',
          },
          550505: {
            name: {
              th: 'ศิลาเพชร',
              en: 'Sila Phet',
            },
            zipcode: '55120',
          },
          550506: {
            name: {
              th: 'อวน',
              en: 'Uan',
            },
            zipcode: '55120',
          },
          550509: {
            name: {
              th: 'ไชยวัฒนา',
              en: 'Chai Watthana',
            },
            zipcode: '55120',
          },
          550510: {
            name: {
              th: 'เจดีย์ชัย',
              en: 'Chedi Chai',
            },
            zipcode: '55120',
          },
          550511: {
            name: {
              th: 'ภูคา',
              en: 'Phu Kha',
            },
            zipcode: '55120',
          },
          550512: {
            name: {
              th: 'สกาด',
              en: 'Sakat',
            },
            zipcode: '55120',
          },
          550513: {
            name: {
              th: 'ป่ากลาง',
              en: 'Pa Klang',
            },
            zipcode: '55120',
          },
          550514: {
            name: {
              th: 'วรนคร',
              en: 'Wora Nakhon',
            },
            zipcode: '55120',
          },
        },
      },
      5506: {
        name: {
          th: 'ท่าวังผา',
          en: 'Tha Wang Pha',
        },
        tambons: {
          550601: {
            name: {
              th: 'ริม',
              en: 'Rim',
            },
            zipcode: '55140',
          },
          550602: {
            name: {
              th: 'ป่าคา',
              en: 'Pa Kha',
            },
            zipcode: '55140',
          },
          550603: {
            name: {
              th: 'ผาตอ',
              en: 'Pha To',
            },
            zipcode: '55140',
          },
          550604: {
            name: {
              th: 'ยม',
              en: 'Yom',
            },
            zipcode: '55140',
          },
          550605: {
            name: {
              th: 'ตาลชุม',
              en: 'Tan Chum',
            },
            zipcode: '55140',
          },
          550606: {
            name: {
              th: 'ศรีภูมิ',
              en: 'Si Phum',
            },
            zipcode: '55140',
          },
          550607: {
            name: {
              th: 'จอมพระ',
              en: 'Chom Phra',
            },
            zipcode: '55140',
          },
          550608: {
            name: {
              th: 'แสนทอง',
              en: 'Saen Thong',
            },
            zipcode: '55140',
          },
          550609: {
            name: {
              th: 'ท่าวังผา',
              en: 'Tha Wang Pha',
            },
            zipcode: '55140',
          },
          550610: {
            name: {
              th: 'ผาทอง',
              en: 'Pha Thong',
            },
            zipcode: '55140',
          },
        },
      },
      5507: {
        name: {
          th: 'เวียงสา',
          en: 'Wieng Sa',
        },
        tambons: {
          550701: {
            name: {
              th: 'กลางเวียง',
              en: 'Klang Wiang',
            },
            zipcode: '55110',
          },
          550702: {
            name: {
              th: 'ขึ่ง',
              en: 'Khueng',
            },
            zipcode: '55110',
          },
          550703: {
            name: {
              th: 'ไหล่น่าน',
              en: 'Lai Nan',
            },
            zipcode: '55110',
          },
          550704: {
            name: {
              th: 'ตาลชุม',
              en: 'Tan Chum',
            },
            zipcode: '55110',
          },
          550705: {
            name: {
              th: 'นาเหลือง',
              en: 'Na Lueang',
            },
            zipcode: '55110',
          },
          550706: {
            name: {
              th: 'ส้าน',
              en: 'San',
            },
            zipcode: '55110',
          },
          550707: {
            name: {
              th: 'น้ำมวบ',
              en: 'Nam Muap',
            },
            zipcode: '55110',
          },
          550708: {
            name: {
              th: 'น้ำปั้ว',
              en: 'Nam Pua',
            },
            zipcode: '55110',
          },
          550709: {
            name: {
              th: 'ยาบหัวนา',
              en: 'Yap Hua Na',
            },
            zipcode: '55110',
          },
          550710: {
            name: {
              th: 'ปงสนุก',
              en: 'Pong Sanuk',
            },
            zipcode: '55110',
          },
          550711: {
            name: {
              th: 'อ่ายนาไลย',
              en: 'Ai Na Lai',
            },
            zipcode: '55110',
          },
          550712: {
            name: {
              th: 'ส้านนาหนองใหม่',
              en: 'San Na Nong Mai',
            },
            zipcode: '55110',
          },
          550713: {
            name: {
              th: 'แม่ขะนิง',
              en: 'Mae Khaning',
            },
            zipcode: '55110',
          },
          550714: {
            name: {
              th: 'แม่สาคร',
              en: 'Mae Sakhon',
            },
            zipcode: '55110',
          },
          550715: {
            name: {
              th: 'จอมจันทร์',
              en: 'Chom Chan',
            },
            zipcode: '55110',
          },
          550716: {
            name: {
              th: 'แม่สา',
              en: 'Mae Sa',
            },
            zipcode: '55110',
          },
          550717: {
            name: {
              th: 'ทุ่งศรีทอง',
              en: 'Thung Si Thong',
            },
            zipcode: '55110',
          },
        },
      },
      5508: {
        name: {
          th: 'ทุ่งช้าง',
          en: 'Thung Chang',
        },
        tambons: {
          550801: {
            name: {
              th: 'ปอน',
              en: 'Pon',
            },
            zipcode: '55130',
          },
          550802: {
            name: {
              th: 'งอบ',
              en: 'Ngop',
            },
            zipcode: '55130',
          },
          550803: {
            name: {
              th: 'และ',
              en: 'Lae',
            },
            zipcode: '55130',
          },
          550804: {
            name: {
              th: 'ทุ่งช้าง',
              en: 'Thung Chang',
            },
            zipcode: '55130',
          },
        },
      },
      5509: {
        name: {
          th: 'เชียงกลาง',
          en: 'Chiang Klang',
        },
        tambons: {
          550901: {
            name: {
              th: 'เชียงกลาง',
              en: 'Chiang Klang',
            },
            zipcode: '55160',
          },
          550902: {
            name: {
              th: 'เปือ',
              en: 'Puea',
            },
            zipcode: '55160',
          },
          550903: {
            name: {
              th: 'เชียงคาน',
              en: 'Chiang Khan',
            },
            zipcode: '55160',
          },
          550904: {
            name: {
              th: 'พระธาตุ',
              en: 'Phra That',
            },
            zipcode: '55160',
          },
          550908: {
            name: {
              th: 'พญาแก้ว',
              en: 'Phaya Kaeo',
            },
            zipcode: '55160',
          },
          550909: {
            name: {
              th: 'พระพุทธบาท',
              en: 'Phra Phutthabat',
            },
            zipcode: '55160',
          },
        },
      },
      5510: {
        name: {
          th: 'นาหมื่น',
          en: 'Na Mun',
        },
        tambons: {
          551001: {
            name: {
              th: 'นาทะนุง',
              en: 'Na Thanung',
            },
            zipcode: '55180',
          },
          551002: {
            name: {
              th: 'บ่อแก้ว',
              en: 'Bo Kaeo',
            },
            zipcode: '55180',
          },
          551003: {
            name: {
              th: 'เมืองลี',
              en: 'Mueang Li',
            },
            zipcode: '55180',
          },
          551004: {
            name: {
              th: 'ปิงหลวง',
              en: 'Ping Luang',
            },
            zipcode: '55180',
          },
        },
      },
      5511: {
        name: {
          th: 'สันติสุข',
          en: 'Santisuk',
        },
        tambons: {
          551101: {
            name: {
              th: 'ดู่พงษ์',
              en: 'Du Phong',
            },
            zipcode: '55210',
          },
          551102: {
            name: {
              th: 'ป่าแลวหลวง',
              en: 'Pa Laeo Luang',
            },
            zipcode: '55210',
          },
          551103: {
            name: {
              th: 'พงษ์',
              en: 'Phong',
            },
            zipcode: '55210',
          },
        },
      },
      5512: {
        name: {
          th: 'บ่อเกลือ',
          en: 'Bo Klua',
        },
        tambons: {
          551201: {
            name: {
              th: 'บ่อเกลือเหนือ',
              en: 'Bo Kluea Nuea',
            },
            zipcode: '55220',
          },
          551202: {
            name: {
              th: 'บ่อเกลือใต้',
              en: 'Bo Kluea Tai',
            },
            zipcode: '55220',
          },
          551204: {
            name: {
              th: 'ภูฟ้า',
              en: 'Phu Fa',
            },
            zipcode: '55220',
          },
          551205: {
            name: {
              th: 'ดงพญา',
              en: 'Dong Phaya',
            },
            zipcode: '55220',
          },
        },
      },
      5513: {
        name: {
          th: 'สองแคว',
          en: 'Song Kwar',
        },
        tambons: {
          551301: {
            name: {
              th: 'นาไร่หลวง',
              en: 'Na Rai Luang',
            },
            zipcode: '55160',
          },
          551302: {
            name: {
              th: 'ชนแดน',
              en: 'Chon Daen',
            },
            zipcode: '55160',
          },
          551303: {
            name: {
              th: 'ยอด',
              en: 'Yot',
            },
            zipcode: '55160',
          },
        },
      },
      5514: {
        name: {
          th: 'ภูเพียง',
          en: 'Phu Phiang',
        },
        tambons: {
          551401: {
            name: {
              th: 'ม่วงตึ๊ด',
              en: 'Muang Tuet',
            },
            zipcode: '55000',
          },
          551402: {
            name: {
              th: 'นาปัง',
              en: 'Na Pang',
            },
            zipcode: '55000',
          },
          551403: {
            name: {
              th: 'น้ำแก่น',
              en: 'Nam Kaen',
            },
            zipcode: '55000',
          },
          551404: {
            name: {
              th: 'น้ำเกี๋ยน',
              en: 'Nam Kian',
            },
            zipcode: '55000',
          },
          551405: {
            name: {
              th: 'เมืองจัง',
              en: 'Mueang Chang',
            },
            zipcode: '55000',
          },
          551406: {
            name: {
              th: 'ท่าน้าว',
              en: 'Tha Nao',
            },
            zipcode: '55000',
          },
          551407: {
            name: {
              th: 'ฝายแก้ว',
              en: 'Fai Kaeo',
            },
            zipcode: '55000',
          },
        },
      },
      5515: {
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'King Amphoe Phu Pieng',
        },
        tambons: {
          551501: {
            name: {
              th: 'ห้วยโก๋น',
              en: 'Huai Kon',
            },
            zipcode: '55130',
          },
          551502: {
            name: {
              th: 'ขุนน่าน',
              en: 'Khun Nan',
            },
            zipcode: '55130',
          },
        },
      },
    },
  },
  56: {
    name: {
      th: 'พะเยา',
      en: 'Phayao',
    },
    amphoes: {
      5601: {
        name: {
          th: 'เมืองพะเยา',
          en: 'Muang',
        },
        tambons: {
          560101: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '56000',
          },
          560102: {
            name: {
              th: 'แม่ต๋ำ',
              en: 'Mae Tam',
            },
            zipcode: '56000',
          },
          560104: {
            name: {
              th: 'แม่นาเรือ',
              en: 'Mae Na Ruea',
            },
            zipcode: '56000',
          },
          560105: {
            name: {
              th: 'บ้านตุ่น',
              en: 'Ban Tun',
            },
            zipcode: '56000',
          },
          560106: {
            name: {
              th: 'บ้านต๊ำ',
              en: 'Ban Tam',
            },
            zipcode: '56000',
          },
          560107: {
            name: {
              th: 'บ้านต๋อม',
              en: 'Ban Tom',
            },
            zipcode: '56000',
          },
          560108: {
            name: {
              th: 'แม่ปืม',
              en: 'Mae Puem',
            },
            zipcode: '56000',
          },
          560110: {
            name: {
              th: 'แม่กา',
              en: 'Mae Ka',
            },
            zipcode: '56000',
          },
          560111: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '56000',
          },
          560112: {
            name: {
              th: 'จำป่าหวาย',
              en: 'Cham Pa Wai',
            },
            zipcode: '56000',
          },
          560113: {
            name: {
              th: 'ท่าวังทอง',
              en: 'Tha Wang Thong',
            },
            zipcode: '56000',
          },
          560114: {
            name: {
              th: 'แม่ใส',
              en: 'Mae Sai',
            },
            zipcode: '56000',
          },
          560115: {
            name: {
              th: 'บ้านสาง',
              en: 'Ban Sang',
            },
            zipcode: '56000',
          },
          560116: {
            name: {
              th: 'ท่าจำปี',
              en: 'Tha Champi',
            },
            zipcode: '56000',
          },
          560118: {
            name: {
              th: 'สันป่าม่วง',
              en: 'San Pa Muang',
            },
            zipcode: '56000',
          },
        },
      },
      5602: {
        name: {
          th: 'จุน',
          en: 'Chun',
        },
        tambons: {
          560201: {
            name: {
              th: 'ห้วยข้าวก่ำ',
              en: 'Huai Khao Kam',
            },
            zipcode: '56150',
          },
          560202: {
            name: {
              th: 'จุน',
              en: 'Chun',
            },
            zipcode: '56150',
          },
          560203: {
            name: {
              th: 'ลอ',
              en: 'Lo',
            },
            zipcode: '56150',
          },
          560204: {
            name: {
              th: 'หงส์หิน',
              en: 'Hong Hin',
            },
            zipcode: '56150',
          },
          560205: {
            name: {
              th: 'ทุ่งรวงทอง',
              en: 'Thung Ruang Thong',
            },
            zipcode: '56150',
          },
          560206: {
            name: {
              th: 'ห้วยยางขาม',
              en: 'Huai Yang Kham',
            },
            zipcode: '56150',
          },
          560207: {
            name: {
              th: 'พระธาตุขิงแกง',
              en: 'Phra That Khing Kaeng',
            },
            zipcode: '56150',
          },
        },
      },
      5603: {
        name: {
          th: 'เชียงคำ',
          en: 'Chiang Kham',
        },
        tambons: {
          560301: {
            name: {
              th: 'หย่วน',
              en: 'Yuan',
            },
            zipcode: '56110',
          },
          560306: {
            name: {
              th: 'น้ำแวน',
              en: 'Nam Waen',
            },
            zipcode: '56110',
          },
          560307: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '56110',
          },
          560308: {
            name: {
              th: 'ฝายกวาง',
              en: 'Fai Kwang',
            },
            zipcode: '56110',
          },
          560309: {
            name: {
              th: 'เจดีย์คำ',
              en: 'Chedi Kham',
            },
            zipcode: '56110',
          },
          560310: {
            name: {
              th: 'ร่มเย็น',
              en: 'Rom Yen',
            },
            zipcode: '56110',
          },
          560311: {
            name: {
              th: 'เชียงบาน',
              en: 'Chiang Ban',
            },
            zipcode: '56110',
          },
          560312: {
            name: {
              th: 'แม่ลาว',
              en: 'Mae Lao',
            },
            zipcode: '56110',
          },
          560313: {
            name: {
              th: 'อ่างทอง',
              en: 'Ang Thong',
            },
            zipcode: '56110',
          },
          560314: {
            name: {
              th: 'ทุ่งผาสุข',
              en: 'Thung Pha Suk',
            },
            zipcode: '56110',
          },
        },
      },
      5604: {
        name: {
          th: 'เชียงม่วน',
          en: 'Chiang Muan',
        },
        tambons: {
          560401: {
            name: {
              th: 'เชียงม่วน',
              en: 'Chiang Muan',
            },
            zipcode: '56160',
          },
          560402: {
            name: {
              th: 'บ้านมาง',
              en: 'Ban Mang',
            },
            zipcode: '56160',
          },
          560403: {
            name: {
              th: 'สระ',
              en: 'Sa',
            },
            zipcode: '56160',
          },
        },
      },
      5605: {
        name: {
          th: 'ดอกคำใต้',
          en: 'Dok Kham Tai',
        },
        tambons: {
          560501: {
            name: {
              th: 'ดอกคำใต้',
              en: 'Dok Khamtai',
            },
            zipcode: '56120',
          },
          560502: {
            name: {
              th: 'ดอนศรีชุม',
              en: 'Don Si Chum',
            },
            zipcode: '56120',
          },
          560503: {
            name: {
              th: 'บ้านถ้ำ',
              en: 'Ban Tham',
            },
            zipcode: '56120',
          },
          560504: {
            name: {
              th: 'บ้านปิน',
              en: 'Ban Pin',
            },
            zipcode: '56120',
          },
          560505: {
            name: {
              th: 'ห้วยลาน',
              en: 'Huai Lan',
            },
            zipcode: '56120',
          },
          560506: {
            name: {
              th: 'สันโค้ง',
              en: 'San Khong',
            },
            zipcode: '56120',
          },
          560507: {
            name: {
              th: 'ป่าซาง',
              en: 'Pa Sang',
            },
            zipcode: '56120',
          },
          560508: {
            name: {
              th: 'หนองหล่ม',
              en: 'Nong Lom',
            },
            zipcode: '56120',
          },
          560509: {
            name: {
              th: 'ดงสุวรรณ',
              en: 'Dong Suwan',
            },
            zipcode: '56120',
          },
          560510: {
            name: {
              th: 'บุญเกิด',
              en: 'Bun Koet',
            },
            zipcode: '56120',
          },
          560511: {
            name: {
              th: 'สว่างอารมณ์',
              en: 'Sawang Arom',
            },
            zipcode: '56120',
          },
          560512: {
            name: {
              th: 'คือเวียง',
              en: 'Khue Wiang',
            },
            zipcode: '56120',
          },
        },
      },
      5606: {
        name: {
          th: 'ปง',
          en: 'Pong',
        },
        tambons: {
          560601: {
            name: {
              th: 'ปง',
              en: 'Pong',
            },
            zipcode: '56140',
          },
          560602: {
            name: {
              th: 'ควร',
              en: 'Khuan',
            },
            zipcode: '56140',
          },
          560603: {
            name: {
              th: 'ออย',
              en: 'Oi',
            },
            zipcode: '56140',
          },
          560604: {
            name: {
              th: 'งิม',
              en: 'Ngim',
            },
            zipcode: '56140',
          },
          560605: {
            name: {
              th: 'ผาช้างน้อย',
              en: 'Pha Chang Noi',
            },
            zipcode: '56140',
          },
          560606: {
            name: {
              th: 'นาปรัง',
              en: 'Na Prang',
            },
            zipcode: '56140',
          },
          560607: {
            name: {
              th: 'ขุนควร',
              en: 'Khun Khuan',
            },
            zipcode: '56140',
          },
        },
      },
      5607: {
        name: {
          th: 'แม่ใจ',
          en: 'Mae Chai',
        },
        tambons: {
          560701: {
            name: {
              th: 'แม่ใจ',
              en: 'Mae Chai',
            },
            zipcode: '56130',
          },
          560702: {
            name: {
              th: 'ศรีถ้อย',
              en: 'Si Thoi',
            },
            zipcode: '56130',
          },
          560703: {
            name: {
              th: 'แม่สุก',
              en: 'Mae Suk',
            },
            zipcode: '56130',
          },
          560704: {
            name: {
              th: 'ป่าแฝก',
              en: 'Pa Faek',
            },
            zipcode: '56130',
          },
          560705: {
            name: {
              th: 'บ้านเหล่า',
              en: 'Ban Lao',
            },
            zipcode: '56130',
          },
          560706: {
            name: {
              th: 'เจริญราษฎร์',
              en: 'Charoen Rat',
            },
            zipcode: '56130',
          },
        },
      },
      5608: {
        name: {
          th: 'ภูซาง',
          en: 'King Amphoe Phu Sang',
        },
        tambons: {
          560801: {
            name: {
              th: 'ภูซาง',
              en: 'Phu Sang',
            },
            zipcode: '56110',
          },
          560802: {
            name: {
              th: 'ป่าสัก',
              en: 'Pa Sak',
            },
            zipcode: '56110',
          },
          560803: {
            name: {
              th: 'ทุ่งกล้วย',
              en: 'Thung Kluai',
            },
            zipcode: '56110',
          },
          560804: {
            name: {
              th: 'เชียงแรง',
              en: 'Chiang Raeng',
            },
            zipcode: '56110',
          },
          560805: {
            name: {
              th: 'สบบง',
              en: 'Sop Bong',
            },
            zipcode: '56110',
          },
        },
      },
      5609: {
        name: {
          th: 'ภูกามยาว',
          en: 'King Amphoe Phu Kam Yao',
        },
        tambons: {
          560901: {
            name: {
              th: 'ห้วยแก้ว',
              en: 'Huai Kaeo',
            },
            zipcode: '56000',
          },
          560902: {
            name: {
              th: 'ดงเจน',
              en: 'Dong Chen',
            },
            zipcode: '56000',
          },
          560903: {
            name: {
              th: 'แม่อิง',
              en: 'Mae Ing',
            },
            zipcode: '56000',
          },
        },
      },
    },
  },
  57: {
    name: {
      th: 'เชียงราย',
      en: 'Chiang Rai',
    },
    amphoes: {
      5701: {
        name: {
          th: 'เมืองเชียงราย',
          en: 'Muang',
        },
        tambons: {
          570101: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '57000',
          },
          570102: {
            name: {
              th: 'รอบเวียง',
              en: 'Rop Wiang',
            },
            zipcode: '57000',
          },
          570103: {
            name: {
              th: 'บ้านดู่',
              en: 'Ban Du',
            },
            zipcode: '57100',
          },
          570104: {
            name: {
              th: 'นางแล',
              en: 'Nang Lae',
            },
            zipcode: '57100',
          },
          570105: {
            name: {
              th: 'แม่ข้าวต้ม',
              en: 'Mae Khao Tom',
            },
            zipcode: '57100',
          },
          570106: {
            name: {
              th: 'แม่ยาว',
              en: 'Mae Yao',
            },
            zipcode: '57100',
          },
          570107: {
            name: {
              th: 'สันทราย',
              en: 'San Sai',
            },
            zipcode: '57000',
          },
          570111: {
            name: {
              th: 'แม่กรณ์',
              en: 'Mae Kon',
            },
            zipcode: '57000',
          },
          570112: {
            name: {
              th: 'ห้วยชมภู',
              en: 'Huai Chomphu',
            },
            zipcode: '57000',
          },
          570113: {
            name: {
              th: 'ห้วยสัก',
              en: 'Huai Sak',
            },
            zipcode: '57000',
          },
          570114: {
            name: {
              th: 'ริมกก',
              en: 'Rim Kok',
            },
            zipcode: '57100',
          },
          570115: {
            name: {
              th: 'ดอยลาน',
              en: 'Doi Lan',
            },
            zipcode: '57000',
          },
          570116: {
            name: {
              th: 'ป่าอ้อดอนชัย',
              en: 'Pa O Don Chai',
            },
            zipcode: '57000',
          },
          570118: {
            name: {
              th: 'ท่าสาย',
              en: 'Tha Sai',
            },
            zipcode: '57000',
          },
          570120: {
            name: {
              th: 'ดอยฮาง',
              en: 'Doi Hang',
            },
            zipcode: '57000',
          },
          570121: {
            name: {
              th: 'ท่าสุด',
              en: 'Tha Sut',
            },
            zipcode: '57100',
          },
        },
      },
      5702: {
        name: {
          th: 'เวียงชัย',
          en: 'Wiang Chai',
        },
        tambons: {
          570202: {
            name: {
              th: 'เวียงชัย',
              en: 'Wiang Chai',
            },
            zipcode: '57210',
          },
          570203: {
            name: {
              th: 'ผางาม',
              en: 'Pha Ngam',
            },
            zipcode: '57210',
          },
          570204: {
            name: {
              th: 'เวียงเหนือ',
              en: 'Wiang Nuea',
            },
            zipcode: '57210',
          },
          570206: {
            name: {
              th: 'ดอนศิลา',
              en: 'Don Sila',
            },
            zipcode: '57210',
          },
          570208: {
            name: {
              th: 'เมืองชุม',
              en: 'Mueang Chum',
            },
            zipcode: '57210',
          },
        },
      },
      5703: {
        name: {
          th: 'เชียงของ',
          en: 'Chiang Khong',
        },
        tambons: {
          570301: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '57140',
          },
          570302: {
            name: {
              th: 'สถาน',
              en: 'Sathan',
            },
            zipcode: '57140',
          },
          570303: {
            name: {
              th: 'ครึ่ง',
              en: 'Khrueng',
            },
            zipcode: '57140',
          },
          570304: {
            name: {
              th: 'บุญเรือง',
              en: 'Bun Rueang',
            },
            zipcode: '57140',
          },
          570305: {
            name: {
              th: 'ห้วยซ้อ',
              en: 'Huai So',
            },
            zipcode: '57140',
          },
          570308: {
            name: {
              th: 'ศรีดอนชัย',
              en: 'Si Don Chai',
            },
            zipcode: '57230',
          },
          570310: {
            name: {
              th: 'ริมโขง',
              en: 'Rim Khong',
            },
            zipcode: '57140',
          },
        },
      },
      5704: {
        name: {
          th: 'เทิง',
          en: 'Thoeng',
        },
        tambons: {
          570401: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '57160',
          },
          570402: {
            name: {
              th: 'งิ้ว',
              en: 'Ngio',
            },
            zipcode: '57160',
          },
          570403: {
            name: {
              th: 'ปล้อง',
              en: 'Plong',
            },
            zipcode: '57230',
          },
          570404: {
            name: {
              th: 'แม่ลอย',
              en: 'Mae Loi',
            },
            zipcode: '57230',
          },
          570405: {
            name: {
              th: 'เชียงเคี่ยน',
              en: 'Chiang Khian',
            },
            zipcode: '57230',
          },
          570409: {
            name: {
              th: 'ตับเต่า',
              en: 'Tap Tao',
            },
            zipcode: '57160',
          },
          570410: {
            name: {
              th: 'หงาว',
              en: 'Ngao',
            },
            zipcode: '57160',
          },
          570411: {
            name: {
              th: 'สันทรายงาม',
              en: 'San Sai Ngam',
            },
            zipcode: '57160',
          },
          570412: {
            name: {
              th: 'ศรีดอนไชย',
              en: 'Si Don Chai',
            },
            zipcode: '57230',
          },
          570413: {
            name: {
              th: 'หนองแรด',
              en: 'Nong Raet',
            },
            zipcode: '57230',
          },
        },
      },
      5705: {
        name: {
          th: 'พาน',
          en: 'Phan',
        },
        tambons: {
          570501: {
            name: {
              th: 'สันมะเค็ด',
              en: 'San Makhet',
            },
            zipcode: '57120',
          },
          570502: {
            name: {
              th: 'แม่อ้อ',
              en: 'Mae O',
            },
            zipcode: '57120',
          },
          570503: {
            name: {
              th: 'ธารทอง',
              en: 'Than Thong',
            },
            zipcode: '57250',
          },
          570504: {
            name: {
              th: 'สันติสุข',
              en: 'Santi Suk',
            },
            zipcode: '57120',
          },
          570505: {
            name: {
              th: 'ดอยงาม',
              en: 'Doi Ngam',
            },
            zipcode: '57120',
          },
          570506: {
            name: {
              th: 'หัวง้ม',
              en: 'Hua Ngom',
            },
            zipcode: '57120',
          },
          570507: {
            name: {
              th: 'เจริญเมือง',
              en: 'Charoen Mueang',
            },
            zipcode: '57120',
          },
          570508: {
            name: {
              th: 'ป่าหุ่ง',
              en: 'Pa Hung',
            },
            zipcode: '57120',
          },
          570509: {
            name: {
              th: 'ม่วงคำ',
              en: 'Muang Kham',
            },
            zipcode: '57120',
          },
          570510: {
            name: {
              th: 'ทรายขาว',
              en: 'Sai Khao',
            },
            zipcode: '57120',
          },
          570511: {
            name: {
              th: 'สันกลาง',
              en: 'San Klang',
            },
            zipcode: '57120',
          },
          570512: {
            name: {
              th: 'แม่เย็น',
              en: 'Mae Yen',
            },
            zipcode: '57280',
          },
          570513: {
            name: {
              th: 'เมืองพาน',
              en: 'Mueang Phan',
            },
            zipcode: '57120',
          },
          570514: {
            name: {
              th: 'ทานตะวัน',
              en: 'Than Tawan',
            },
            zipcode: '57280',
          },
          570515: {
            name: {
              th: 'เวียงห้าว',
              en: 'Wiang Hao',
            },
            zipcode: '57120',
          },
        },
      },
      5706: {
        name: {
          th: 'ป่าแดด',
          en: 'Pa Daet',
        },
        tambons: {
          570601: {
            name: {
              th: 'ป่าแดด',
              en: 'Pa Daet',
            },
            zipcode: '57190',
          },
          570602: {
            name: {
              th: 'ป่าแงะ',
              en: 'Pa Ngae',
            },
            zipcode: '57190',
          },
          570603: {
            name: {
              th: 'สันมะค่า',
              en: 'San Makha',
            },
            zipcode: '57190',
          },
          570605: {
            name: {
              th: 'โรงช้าง',
              en: 'Rong Chang',
            },
            zipcode: '57190',
          },
          570606: {
            name: {
              th: 'ศรีโพธิ์เงิน',
              en: 'Si Pho Ngoen',
            },
            zipcode: '57190',
          },
        },
      },
      5707: {
        name: {
          th: 'แม่จัน',
          en: 'Mae Chan',
        },
        tambons: {
          570701: {
            name: {
              th: 'แม่จัน',
              en: 'Mae Chan',
            },
            zipcode: '57110',
          },
          570702: {
            name: {
              th: 'จันจว้า',
              en: 'Chan Chawa',
            },
            zipcode: '57270',
          },
          570703: {
            name: {
              th: 'แม่คำ',
              en: 'Mae Kham',
            },
            zipcode: '57240',
          },
          570704: {
            name: {
              th: 'ป่าซาง',
              en: 'Pa Sang',
            },
            zipcode: '57110',
          },
          570705: {
            name: {
              th: 'สันทราย',
              en: 'San Sai',
            },
            zipcode: '57110',
          },
          570706: {
            name: {
              th: 'ท่าข้าวเปลือก',
              en: 'Tha Khao Plueak',
            },
            zipcode: '57110',
          },
          570708: {
            name: {
              th: 'ป่าตึง',
              en: 'Pa Tueng',
            },
            zipcode: '57110',
          },
          570710: {
            name: {
              th: 'แม่ไร่',
              en: 'Mae Rai',
            },
            zipcode: '57240',
          },
          570711: {
            name: {
              th: 'ศรีค้ำ',
              en: 'Si Kham',
            },
            zipcode: '57110',
          },
          570712: {
            name: {
              th: 'จันจว้าใต้',
              en: 'Chan Chawa Tai',
            },
            zipcode: '57270',
          },
          570713: {
            name: {
              th: 'จอมสวรรค์',
              en: 'Chom Sawan',
            },
            zipcode: '57110',
          },
        },
      },
      5708: {
        name: {
          th: 'เชียงแสน',
          en: 'Chiang Saen',
        },
        tambons: {
          570801: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '57150',
          },
          570802: {
            name: {
              th: 'ป่าสัก',
              en: 'Pa Sak',
            },
            zipcode: '57150',
          },
          570803: {
            name: {
              th: 'บ้านแซว',
              en: 'Ban Saeo',
            },
            zipcode: '57150',
          },
          570804: {
            name: {
              th: 'ศรีดอนมูล',
              en: 'Si Don Mun',
            },
            zipcode: '57150',
          },
          570805: {
            name: {
              th: 'แม่เงิน',
              en: 'Mae Ngoen',
            },
            zipcode: '57150',
          },
          570806: {
            name: {
              th: 'โยนก',
              en: 'Yonok',
            },
            zipcode: '57150',
          },
        },
      },
      5709: {
        name: {
          th: 'แม่สาย',
          en: 'Mae Sai',
        },
        tambons: {
          570901: {
            name: {
              th: 'แม่สาย',
              en: 'Mae Sai',
            },
            zipcode: '57130',
          },
          570902: {
            name: {
              th: 'ห้วยไคร้',
              en: 'Huai Khrai',
            },
            zipcode: '57220',
          },
          570903: {
            name: {
              th: 'เกาะช้าง',
              en: 'Ko Chang',
            },
            zipcode: '57130',
          },
          570904: {
            name: {
              th: 'โป่งผา',
              en: 'Pong Pha',
            },
            zipcode: '57130',
          },
          570905: {
            name: {
              th: 'ศรีเมืองชุม',
              en: 'Si Mueang Chum',
            },
            zipcode: '57130',
          },
          570906: {
            name: {
              th: 'เวียงพางคำ',
              en: 'Wiang Phang Kham',
            },
            zipcode: '57130',
          },
          570908: {
            name: {
              th: 'บ้านด้าย',
              en: 'Ban Dai',
            },
            zipcode: '57220',
          },
          570909: {
            name: {
              th: 'โป่งงาม',
              en: 'Pong Ngam',
            },
            zipcode: '57130',
          },
        },
      },
      5710: {
        name: {
          th: 'แม่สรวย',
          en: 'Mae Suai',
        },
        tambons: {
          571001: {
            name: {
              th: 'แม่สรวย',
              en: 'Mae Suai',
            },
            zipcode: '57180',
          },
          571002: {
            name: {
              th: 'ป่าแดด',
              en: 'Pa Daet',
            },
            zipcode: '57180',
          },
          571003: {
            name: {
              th: 'แม่พริก',
              en: 'Mae Phrik',
            },
            zipcode: '57180',
          },
          571004: {
            name: {
              th: 'ศรีถ้อย',
              en: 'Si Thoi',
            },
            zipcode: '57180',
          },
          571005: {
            name: {
              th: 'ท่าก๊อ',
              en: 'Tha Ko',
            },
            zipcode: '57180',
          },
          571006: {
            name: {
              th: 'วาวี',
              en: 'Wawi',
            },
            zipcode: '57180',
          },
          571007: {
            name: {
              th: 'เจดีย์หลวง',
              en: 'Chedi Luang',
            },
            zipcode: '57180',
          },
        },
      },
      5711: {
        name: {
          th: 'เวียงป่าเป้า',
          en: 'Waing Papao',
        },
        tambons: {
          571101: {
            name: {
              th: 'สันสลี',
              en: 'San Sali',
            },
            zipcode: '57170',
          },
          571102: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '57170',
          },
          571103: {
            name: {
              th: 'บ้านโป่ง',
              en: 'Ban Pong',
            },
            zipcode: '57170',
          },
          571104: {
            name: {
              th: 'ป่างิ้ว',
              en: 'Pa Ngio',
            },
            zipcode: '57170',
          },
          571105: {
            name: {
              th: 'เวียงกาหลง',
              en: 'Wiang Kalong',
            },
            zipcode: '57260',
          },
          571106: {
            name: {
              th: 'แม่เจดีย์',
              en: 'Mae Chedi',
            },
            zipcode: '57260',
          },
          571107: {
            name: {
              th: 'แม่เจดีย์ใหม่',
              en: 'Mae Chedi Mai',
            },
            zipcode: '57260',
          },
        },
      },
      5712: {
        name: {
          th: 'พญาเม็งราย',
          en: 'Phraya Meng Rai',
        },
        tambons: {
          571201: {
            name: {
              th: 'แม่เปา',
              en: 'Mae Pao',
            },
            zipcode: '57290',
          },
          571202: {
            name: {
              th: 'แม่ต๋ำ',
              en: 'Mae Tam',
            },
            zipcode: '57290',
          },
          571203: {
            name: {
              th: 'ไม้ยา',
              en: 'Mai Ya',
            },
            zipcode: '57290',
          },
          571204: {
            name: {
              th: 'เม็งราย',
              en: 'Mengrai',
            },
            zipcode: '57290',
          },
          571205: {
            name: {
              th: 'ตาดควัน',
              en: 'Tat Khwan',
            },
            zipcode: '57290',
          },
        },
      },
      5713: {
        name: {
          th: 'เวียงแก่น',
          en: 'Wiang Kaen',
        },
        tambons: {
          571301: {
            name: {
              th: 'ม่วงยาย',
              en: 'Muang Yai',
            },
            zipcode: '57310',
          },
          571302: {
            name: {
              th: 'ปอ',
              en: 'Po',
            },
            zipcode: '57310',
          },
          571303: {
            name: {
              th: 'หล่ายงาว',
              en: 'Lai Ngao',
            },
            zipcode: '57310',
          },
          571304: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '57310',
          },
        },
      },
      5714: {
        name: {
          th: 'ขุนตาล',
          en: 'Khun Tan',
        },
        tambons: {
          571401: {
            name: {
              th: 'ต้า',
              en: 'Ta',
            },
            zipcode: '57340',
          },
          571402: {
            name: {
              th: 'ป่าตาล',
              en: 'Pa Tan',
            },
            zipcode: '57340',
          },
          571403: {
            name: {
              th: 'ยางฮอม',
              en: 'Yang Hom',
            },
            zipcode: '57340',
          },
        },
      },
      5715: {
        name: {
          th: 'แม่ฟ้าหลวง',
          en: 'Mae Fa Luang',
        },
        tambons: {
          571501: {
            name: {
              th: 'เทอดไทย',
              en: 'Thoet Thai',
            },
            zipcode: '57240',
          },
          571502: {
            name: {
              th: 'แม่สลองใน',
              en: 'Mae Salong Nai',
            },
            zipcode: '57110',
          },
          571503: {
            name: {
              th: 'แม่สลองนอก',
              en: 'Mae Salong Nok',
            },
            zipcode: '57110',
          },
          571504: {
            name: {
              th: 'แม่ฟ้าหลวง',
              en: 'เนเธกเนเธเนเธฒเธซเธฅเธงเธ',
            },
            zipcode: '57240',
          },
        },
      },
      5716: {
        name: {
          th: 'แม่ลาว',
          en: 'Mae Lao',
        },
        tambons: {
          571601: {
            name: {
              th: 'ดงมะดะ',
              en: 'Dong Mada',
            },
            zipcode: '57250',
          },
          571602: {
            name: {
              th: 'จอมหมอกแก้ว',
              en: 'Chom Mok Kaeo',
            },
            zipcode: '57250',
          },
          571603: {
            name: {
              th: 'บัวสลี',
              en: 'Bua Sali',
            },
            zipcode: '57250',
          },
          571604: {
            name: {
              th: 'ป่าก่อดำ',
              en: 'Pa Ko Dam',
            },
            zipcode: '57250',
          },
          571605: {
            name: {
              th: 'โป่งแพร่',
              en: 'Pong Phrae',
            },
            zipcode: '57000',
          },
        },
      },
      5717: {
        name: {
          th: 'เวียงเชียงรุ้ง',
          en: 'King Amphoe Chiang Rung',
        },
        tambons: {
          571701: {
            name: {
              th: 'ทุ่งก่อ',
              en: 'Thung Ko',
            },
            zipcode: '57210',
          },
          571702: {
            name: {
              th: 'ดงมหาวัน',
              en: 'Dong Maha Wan',
            },
            zipcode: '57210',
          },
          571703: {
            name: {
              th: 'ป่าซาง',
              en: 'Pa Sang',
            },
            zipcode: '57210',
          },
        },
      },
      5718: {
        name: {
          th: 'ดอยหลวง',
          en: 'King Amphoe Doi Luang',
        },
        tambons: {
          571801: {
            name: {
              th: 'ปงน้อย',
              en: 'Pong Noi',
            },
            zipcode: '57110',
          },
          571802: {
            name: {
              th: 'โชคชัย',
              en: 'Chok Chai',
            },
            zipcode: '57110',
          },
          571803: {
            name: {
              th: 'หนองป่าก่อ',
              en: 'Nong Pa Ko',
            },
            zipcode: '57110',
          },
        },
      },
    },
  },
  58: {
    name: {
      th: 'แม่ฮ่องสอน',
      en: 'Mae Hong Son',
    },
    amphoes: {
      5801: {
        name: {
          th: 'เมืองแม่ฮ่องสอน',
          en: 'Muang',
        },
        tambons: {
          580101: {
            name: {
              th: 'จองคำ',
              en: 'Chong Kham',
            },
            zipcode: '58000',
          },
          580102: {
            name: {
              th: 'ห้วยโป่ง',
              en: 'Huai Pong',
            },
            zipcode: '58000',
          },
          580103: {
            name: {
              th: 'ผาบ่อง',
              en: 'Pha Bong',
            },
            zipcode: '58000',
          },
          580104: {
            name: {
              th: 'ปางหมู',
              en: 'Pang Mu',
            },
            zipcode: '58000',
          },
          580105: {
            name: {
              th: 'หมอกจำแป่',
              en: 'Mok Champae',
            },
            zipcode: '58000',
          },
          580106: {
            name: {
              th: 'ห้วยผา',
              en: 'Huai Pha',
            },
            zipcode: '58000',
          },
          580109: {
            name: {
              th: 'ห้วยปูลิง',
              en: 'Huai Pu Ling',
            },
            zipcode: '58000',
          },
        },
      },
      5802: {
        name: {
          th: 'ขุนยวม',
          en: 'Khun Yuam',
        },
        tambons: {
          580201: {
            name: {
              th: 'ขุนยวม',
              en: 'Khun Yuam',
            },
            zipcode: '58140',
          },
          580202: {
            name: {
              th: 'แม่เงา',
              en: 'Mae Ngao',
            },
            zipcode: '58140',
          },
          580203: {
            name: {
              th: 'เมืองปอน',
              en: 'Mueang Pon',
            },
            zipcode: '58140',
          },
          580204: {
            name: {
              th: 'แม่ยวมน้อย',
              en: 'Mae Yuam Noi',
            },
            zipcode: '58140',
          },
          580205: {
            name: {
              th: 'แม่กิ๊',
              en: 'Mae Ki',
            },
            zipcode: '58140',
          },
          580206: {
            name: {
              th: 'แม่อูคอ',
              en: 'Mae Ukho',
            },
            zipcode: '58140',
          },
        },
      },
      5803: {
        name: {
          th: 'ปาย',
          en: 'Pai',
        },
        tambons: {
          580301: {
            name: {
              th: 'เวียงใต้',
              en: 'Wiang Tai',
            },
            zipcode: '58130',
          },
          580302: {
            name: {
              th: 'เวียงเหนือ',
              en: 'Wiang Nuea',
            },
            zipcode: '58130',
          },
          580303: {
            name: {
              th: 'แม่นาเติง',
              en: 'Mae Na Toeng',
            },
            zipcode: '58130',
          },
          580304: {
            name: {
              th: 'แม่ฮี้',
              en: 'Mae Hi',
            },
            zipcode: '58130',
          },
          580305: {
            name: {
              th: 'ทุ่งยาว',
              en: 'Thung Yao',
            },
            zipcode: '58130',
          },
          580306: {
            name: {
              th: 'เมืองแปง',
              en: 'Mueang Paeng',
            },
            zipcode: '58130',
          },
          580307: {
            name: {
              th: 'โป่งสา',
              en: 'Pong Sa',
            },
            zipcode: '58130',
          },
        },
      },
      5804: {
        name: {
          th: 'แม่สะเรียง',
          en: 'Mae Sariang',
        },
        tambons: {
          580401: {
            name: {
              th: 'บ้านกาศ',
              en: 'Ban Kat',
            },
            zipcode: '58110',
          },
          580402: {
            name: {
              th: 'แม่สะเรียง',
              en: 'Mae Sariang',
            },
            zipcode: '58110',
          },
          580403: {
            name: {
              th: 'แม่คง',
              en: 'Mae Khong',
            },
            zipcode: '58110',
          },
          580404: {
            name: {
              th: 'แม่เหาะ',
              en: 'Mae Ho',
            },
            zipcode: '58110',
          },
          580405: {
            name: {
              th: 'แม่ยวม',
              en: 'Mae Yuam',
            },
            zipcode: '58110',
          },
          580406: {
            name: {
              th: 'เสาหิน',
              en: 'Sao Hin',
            },
            zipcode: '58110',
          },
          580408: {
            name: {
              th: 'ป่าแป๋',
              en: 'Pa Pae',
            },
            zipcode: '58110',
          },
        },
      },
      5805: {
        name: {
          th: 'แม่ลาน้อย',
          en: 'Mae La Noi',
        },
        tambons: {
          580501: {
            name: {
              th: 'แม่ลาน้อย',
              en: 'Mae La Noi',
            },
            zipcode: '58120',
          },
          580502: {
            name: {
              th: 'แม่ลาหลวง',
              en: 'Mae La Luang',
            },
            zipcode: '58120',
          },
          580503: {
            name: {
              th: 'ท่าผาปุ้ม',
              en: 'Tha Pha Pum',
            },
            zipcode: '58120',
          },
          580504: {
            name: {
              th: 'แม่โถ',
              en: 'Mae Tho',
            },
            zipcode: '58120',
          },
          580505: {
            name: {
              th: 'ห้วยห้อม',
              en: 'Huai Hom',
            },
            zipcode: '58120',
          },
          580506: {
            name: {
              th: 'แม่นาจาง',
              en: 'Mae Na Chang',
            },
            zipcode: '58120',
          },
          580507: {
            name: {
              th: 'สันติคีรี',
              en: 'Santi Khiri',
            },
            zipcode: '58120',
          },
          580508: {
            name: {
              th: 'ขุนแม่ลาน้อย',
              en: 'Khun Mae La Noi',
            },
            zipcode: '58120',
          },
        },
      },
      5806: {
        name: {
          th: 'สบเมย',
          en: 'Sop Moi',
        },
        tambons: {
          580601: {
            name: {
              th: 'สบเมย',
              en: 'Sop Moei',
            },
            zipcode: '58110',
          },
          580602: {
            name: {
              th: 'แม่คะตวน',
              en: 'Mae Khatuan',
            },
            zipcode: '58110',
          },
          580603: {
            name: {
              th: 'กองก๋อย',
              en: 'Kong Koi',
            },
            zipcode: '58110',
          },
          580604: {
            name: {
              th: 'แม่สวด',
              en: 'Mae Suat',
            },
            zipcode: '58110',
          },
          580605: {
            name: {
              th: 'ป่าโปง',
              en: 'Pa Pong',
            },
            zipcode: '58110',
          },
          580606: {
            name: {
              th: 'แม่สามแลบ',
              en: 'Mae Sam Laep',
            },
            zipcode: '58110',
          },
        },
      },
      5807: {
        name: {
          th: 'ปางมะผ้า',
          en: 'Pangmapha',
        },
        tambons: {
          580701: {
            name: {
              th: 'สบป่อง',
              en: 'Soppong',
            },
            zipcode: '58150',
          },
          580702: {
            name: {
              th: 'ปางมะผ้า',
              en: 'Pang Mapha',
            },
            zipcode: '58150',
          },
          580703: {
            name: {
              th: 'ถ้ำลอด',
              en: 'Tham Lot',
            },
            zipcode: '58150',
          },
          580704: {
            name: {
              th: 'นาปู่ป้อม',
              en: 'Napu Pom',
            },
            zipcode: '58150',
          },
        },
      },
    },
  },
  60: {
    name: {
      th: 'นครสวรรค์',
      en: 'Nakhon? Sawan',
    },
    amphoes: {
      6001: {
        name: {
          th: 'เมืองนครสวรรค์',
          en: 'Muang',
        },
        tambons: {
          600101: {
            name: {
              th: 'ปากน้ำโพ',
              en: 'Pak Nam Pho',
            },
            zipcode: '60000',
          },
          600102: {
            name: {
              th: 'กลางแดด',
              en: 'Klang Daet',
            },
            zipcode: '60000',
          },
          600103: {
            name: {
              th: 'เกรียงไกร',
              en: 'Kriangkrai',
            },
            zipcode: '60000',
          },
          600104: {
            name: {
              th: 'แควใหญ่',
              en: 'Khwae Yai',
            },
            zipcode: '60000',
          },
          600105: {
            name: {
              th: 'ตะเคียนเลื่อน',
              en: 'Takhian Luean',
            },
            zipcode: '60000',
          },
          600106: {
            name: {
              th: 'นครสวรรค์ตก',
              en: 'Nakhon Sawan Tok',
            },
            zipcode: '60000',
          },
          600107: {
            name: {
              th: 'นครสวรรค์ออก',
              en: 'Nakhon Sawan Ok',
            },
            zipcode: '60000',
          },
          600108: {
            name: {
              th: 'บางพระหลวง',
              en: 'Bang Phra Luang',
            },
            zipcode: '60000',
          },
          600109: {
            name: {
              th: 'บางม่วง',
              en: 'Bang Muang',
            },
            zipcode: '60000',
          },
          600110: {
            name: {
              th: 'บ้านมะเกลือ',
              en: 'Ban Makluea',
            },
            zipcode: '60000',
          },
          600111: {
            name: {
              th: 'บ้านแก่ง',
              en: 'Ban Kaeng',
            },
            zipcode: '60000',
          },
          600112: {
            name: {
              th: 'พระนอน',
              en: 'Phra Non',
            },
            zipcode: '60000',
          },
          600113: {
            name: {
              th: 'วัดไทร',
              en: 'Wat Sai',
            },
            zipcode: '60000',
          },
          600114: {
            name: {
              th: 'หนองกรด',
              en: 'Nong Krot',
            },
            zipcode: '60240',
          },
          600115: {
            name: {
              th: 'หนองกระโดน',
              en: 'Nong Kradon',
            },
            zipcode: '60240',
          },
          600116: {
            name: {
              th: 'หนองปลิง',
              en: 'Nong Pling',
            },
            zipcode: '60000',
          },
          600117: {
            name: {
              th: 'บึงเสนาท',
              en: 'Bueng Senat',
            },
            zipcode: '60000',
          },
        },
      },
      6002: {
        name: {
          th: 'โกรกพระ',
          en: 'Krok Phra',
        },
        tambons: {
          600201: {
            name: {
              th: 'โกรกพระ',
              en: 'Krok Phra',
            },
            zipcode: '60170',
          },
          600202: {
            name: {
              th: 'ยางตาล',
              en: 'Yang Tan',
            },
            zipcode: '60170',
          },
          600203: {
            name: {
              th: 'บางมะฝ่อ',
              en: 'Bang Mafo',
            },
            zipcode: '60170',
          },
          600204: {
            name: {
              th: 'บางประมุง',
              en: 'Bang Pramung',
            },
            zipcode: '60170',
          },
          600205: {
            name: {
              th: 'นากลาง',
              en: 'Na Klang',
            },
            zipcode: '60170',
          },
          600206: {
            name: {
              th: 'ศาลาแดง',
              en: 'Sala Daeng',
            },
            zipcode: '60170',
          },
          600207: {
            name: {
              th: 'เนินกว้าว',
              en: 'Noen Kwao',
            },
            zipcode: '60170',
          },
          600208: {
            name: {
              th: 'เนินศาลา',
              en: 'Noen Sala',
            },
            zipcode: '60170',
          },
          600209: {
            name: {
              th: 'หาดสูง',
              en: 'Hat Sung',
            },
            zipcode: '60170',
          },
        },
      },
      6003: {
        name: {
          th: 'ชุมแสง',
          en: 'Chum Saeng',
        },
        tambons: {
          600301: {
            name: {
              th: 'ชุมแสง',
              en: 'Chum Saeng',
            },
            zipcode: '60120',
          },
          600302: {
            name: {
              th: 'ทับกฤช',
              en: 'Thap Krit',
            },
            zipcode: '60250',
          },
          600303: {
            name: {
              th: 'พิกุล',
              en: 'Phikun',
            },
            zipcode: '60120',
          },
          600304: {
            name: {
              th: 'เกยไชย',
              en: 'Koei Chai',
            },
            zipcode: '60120',
          },
          600305: {
            name: {
              th: 'ท่าไม้',
              en: 'Tha Mai',
            },
            zipcode: '60120',
          },
          600306: {
            name: {
              th: 'บางเคียน',
              en: 'Bang Khian',
            },
            zipcode: '60120',
          },
          600307: {
            name: {
              th: 'หนองกระเจา',
              en: 'Nong Krachao',
            },
            zipcode: '60120',
          },
          600308: {
            name: {
              th: 'พันลาน',
              en: 'Phan Lan',
            },
            zipcode: '60250',
          },
          600309: {
            name: {
              th: 'โคกหม้อ',
              en: 'Khok Mo',
            },
            zipcode: '60120',
          },
          600310: {
            name: {
              th: 'ไผ่สิงห์',
              en: 'Phai Sing',
            },
            zipcode: '60120',
          },
          600311: {
            name: {
              th: 'ฆะมัง',
              en: 'Kha Mang',
            },
            zipcode: '60120',
          },
          600312: {
            name: {
              th: 'ทับกฤชใต้',
              en: 'Thap Krit Tai',
            },
            zipcode: '60250',
          },
        },
      },
      6004: {
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        tambons: {
          600401: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '60110',
          },
          600402: {
            name: {
              th: 'หนองกลับ',
              en: 'Nong Klap',
            },
            zipcode: '60110',
          },
          600403: {
            name: {
              th: 'ธารทหาร',
              en: 'Than Thahan',
            },
            zipcode: '60110',
          },
          600404: {
            name: {
              th: 'ห้วยร่วม',
              en: 'Huai Ruam',
            },
            zipcode: '60110',
          },
          600405: {
            name: {
              th: 'ห้วยถั่วใต้',
              en: 'Huai Thua Tai',
            },
            zipcode: '60110',
          },
          600406: {
            name: {
              th: 'ห้วยถั่วเหนือ',
              en: 'Huai Thua Nuea',
            },
            zipcode: '60110',
          },
          600407: {
            name: {
              th: 'ห้วยใหญ่',
              en: 'Huai Yai',
            },
            zipcode: '60110',
          },
          600408: {
            name: {
              th: 'ทุ่งทอง',
              en: 'Thung Thong',
            },
            zipcode: '60110',
          },
          600409: {
            name: {
              th: 'วังบ่อ',
              en: 'Wang Bo',
            },
            zipcode: '60110',
          },
        },
      },
      6005: {
        name: {
          th: 'บรรพตพิสัย',
          en: 'Banphot Phisai',
        },
        tambons: {
          600501: {
            name: {
              th: 'ท่างิ้ว',
              en: 'Tha Ngio',
            },
            zipcode: '60180',
          },
          600502: {
            name: {
              th: 'บางตาหงาย',
              en: 'Bang Ta Ngai',
            },
            zipcode: '60180',
          },
          600503: {
            name: {
              th: 'หูกวาง',
              en: 'Hukwang',
            },
            zipcode: '60180',
          },
          600504: {
            name: {
              th: 'อ่างทอง',
              en: 'Ang Thong',
            },
            zipcode: '60180',
          },
          600505: {
            name: {
              th: 'บ้านแดน',
              en: 'Ban Daen',
            },
            zipcode: '60180',
          },
          600506: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '60180',
          },
          600507: {
            name: {
              th: 'ตาขีด',
              en: 'Ta Khit',
            },
            zipcode: '60180',
          },
          600508: {
            name: {
              th: 'ตาสัง',
              en: 'Ta Sang',
            },
            zipcode: '60180',
          },
          600509: {
            name: {
              th: 'ด่านช้าง',
              en: 'Dan Chang',
            },
            zipcode: '60180',
          },
          600510: {
            name: {
              th: 'หนองกรด',
              en: 'Nong Krot',
            },
            zipcode: '60180',
          },
          600511: {
            name: {
              th: 'หนองตางู',
              en: 'Nong Ta Ngu',
            },
            zipcode: '60180',
          },
          600512: {
            name: {
              th: 'บึงปลาทู',
              en: 'Bueng Pla Thu',
            },
            zipcode: '60180',
          },
          600513: {
            name: {
              th: 'เจริญผล',
              en: 'Charoen Phon',
            },
            zipcode: '60180',
          },
        },
      },
      6006: {
        name: {
          th: 'เก้าเลี้ยว',
          en: 'Kao Lieo',
        },
        tambons: {
          600601: {
            name: {
              th: 'มหาโพธิ',
              en: 'Maha Phot',
            },
            zipcode: '60230',
          },
          600602: {
            name: {
              th: 'เก้าเลี้ยว',
              en: 'Kao Liao',
            },
            zipcode: '60230',
          },
          600603: {
            name: {
              th: 'หนองเต่า',
              en: 'Nong Tao',
            },
            zipcode: '60230',
          },
          600604: {
            name: {
              th: 'เขาดิน',
              en: 'Khao Din',
            },
            zipcode: '60230',
          },
          600605: {
            name: {
              th: 'หัวดง',
              en: 'Hua Dong',
            },
            zipcode: '60230',
          },
        },
      },
      6007: {
        name: {
          th: 'ตาคลี',
          en: 'Ta Khli',
        },
        tambons: {
          600701: {
            name: {
              th: 'ตาคลี',
              en: 'Takhli',
            },
            zipcode: '60140',
          },
          600702: {
            name: {
              th: 'ช่องแค',
              en: 'Chong Khae',
            },
            zipcode: '60210',
          },
          600703: {
            name: {
              th: 'จันเสน',
              en: 'Chan Sen',
            },
            zipcode: '60260',
          },
          600704: {
            name: {
              th: 'ห้วยหอม',
              en: 'Huai Hom',
            },
            zipcode: '60210',
          },
          600705: {
            name: {
              th: 'หัวหวาย',
              en: 'Hua Wai',
            },
            zipcode: '60140',
          },
          600706: {
            name: {
              th: 'หนองโพ',
              en: 'Nong Pho',
            },
            zipcode: '60140',
          },
          600707: {
            name: {
              th: 'หนองหม้อ',
              en: 'Nong Mo',
            },
            zipcode: '60140',
          },
          600708: {
            name: {
              th: 'สร้อยทอง',
              en: 'Soi Thong',
            },
            zipcode: '60210',
          },
          600709: {
            name: {
              th: 'ลาดทิพรส',
              en: 'Lat Thippharot',
            },
            zipcode: '60260',
          },
          600710: {
            name: {
              th: 'พรหมนิมิต',
              en: 'Phromnimit',
            },
            zipcode: '60210',
          },
        },
      },
      6008: {
        name: {
          th: 'ท่าตะโก',
          en: 'Tha Tako',
        },
        tambons: {
          600801: {
            name: {
              th: 'ท่าตะโก',
              en: 'Tha Tako',
            },
            zipcode: '60160',
          },
          600802: {
            name: {
              th: 'พนมรอก',
              en: 'Phanom Rok',
            },
            zipcode: '60160',
          },
          600803: {
            name: {
              th: 'หัวถนน',
              en: 'Hua Thanon',
            },
            zipcode: '60160',
          },
          600804: {
            name: {
              th: 'สายลำโพง',
              en: 'Sai Lamphong',
            },
            zipcode: '60160',
          },
          600805: {
            name: {
              th: 'วังมหากร',
              en: 'Wang Mahakon',
            },
            zipcode: '60160',
          },
          600806: {
            name: {
              th: 'ดอนคา',
              en: 'Don Kha',
            },
            zipcode: '60160',
          },
          600807: {
            name: {
              th: 'ทำนบ',
              en: 'Thamnop',
            },
            zipcode: '60160',
          },
          600808: {
            name: {
              th: 'วังใหญ่',
              en: 'Wang Yai',
            },
            zipcode: '60160',
          },
          600809: {
            name: {
              th: 'พนมเศษ',
              en: 'Phanom Set',
            },
            zipcode: '60160',
          },
          600810: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '60160',
          },
        },
      },
      6009: {
        name: {
          th: 'ไพศาลี',
          en: 'Phaisali',
        },
        tambons: {
          600901: {
            name: {
              th: 'โคกเดื่อ',
              en: 'Khok Duea',
            },
            zipcode: '60220',
          },
          600902: {
            name: {
              th: 'สำโรงชัย',
              en: 'Samrong Chai',
            },
            zipcode: '60220',
          },
          600903: {
            name: {
              th: 'วังน้ำลัด',
              en: 'Wang Nam Lat',
            },
            zipcode: '60220',
          },
          600904: {
            name: {
              th: 'ตะคร้อ',
              en: 'Takhro',
            },
            zipcode: '60220',
          },
          600905: {
            name: {
              th: 'โพธิ์ประสาท',
              en: 'Pho Prasat',
            },
            zipcode: '60220',
          },
          600906: {
            name: {
              th: 'วังข่อย',
              en: 'Wang Khoi',
            },
            zipcode: '60220',
          },
          600907: {
            name: {
              th: 'นาขอม',
              en: 'Na Khom',
            },
            zipcode: '60220',
          },
          600908: {
            name: {
              th: 'ไพศาลี',
              en: 'Phaisali',
            },
            zipcode: '60220',
          },
        },
      },
      6010: {
        name: {
          th: 'พยุหะคีรี',
          en: 'Phayuha Khili',
        },
        tambons: {
          601001: {
            name: {
              th: 'พยุหะ',
              en: 'Phayuha',
            },
            zipcode: '60130',
          },
          601002: {
            name: {
              th: 'เนินมะกอก',
              en: 'Noen Makok',
            },
            zipcode: '60130',
          },
          601003: {
            name: {
              th: 'นิคมเขาบ่อแก้ว',
              en: 'Nikhom Khao Bo Kaeo',
            },
            zipcode: '60130',
          },
          601004: {
            name: {
              th: 'ม่วงหัก',
              en: 'Muang Hak',
            },
            zipcode: '60130',
          },
          601005: {
            name: {
              th: 'ยางขาว',
              en: 'Yang Khao',
            },
            zipcode: '60130',
          },
          601006: {
            name: {
              th: 'ย่านมัทรี',
              en: 'Yan Matsi',
            },
            zipcode: '60130',
          },
          601007: {
            name: {
              th: 'เขาทอง',
              en: 'Khao Thong',
            },
            zipcode: '60130',
          },
          601008: {
            name: {
              th: 'ท่าน้ำอ้อย',
              en: 'Tha Nam Oi',
            },
            zipcode: '60130',
          },
          601009: {
            name: {
              th: 'น้ำทรง',
              en: 'Nam Song',
            },
            zipcode: '60130',
          },
          601010: {
            name: {
              th: 'เขากะลา',
              en: 'Khao Kala',
            },
            zipcode: '60130',
          },
          601011: {
            name: {
              th: 'สระทะเล',
              en: 'Sa Thale',
            },
            zipcode: '60130',
          },
        },
      },
      6011: {
        name: {
          th: 'ลาดยาว',
          en: 'Lat Yao',
        },
        tambons: {
          601101: {
            name: {
              th: 'ลาดยาว',
              en: 'Lat Yao',
            },
            zipcode: '60150',
          },
          601102: {
            name: {
              th: 'ห้วยน้ำหอม',
              en: 'Huai Nam Hom',
            },
            zipcode: '60150',
          },
          601103: {
            name: {
              th: 'วังม้า',
              en: 'Wang Ma',
            },
            zipcode: '60150',
          },
          601104: {
            name: {
              th: 'วังเมือง',
              en: 'Wang Mueang',
            },
            zipcode: '60150',
          },
          601105: {
            name: {
              th: 'สร้อยละคร',
              en: 'Soi Lakhon',
            },
            zipcode: '60150',
          },
          601106: {
            name: {
              th: 'มาบแก',
              en: 'Map Kae',
            },
            zipcode: '60150',
          },
          601107: {
            name: {
              th: 'หนองยาว',
              en: 'Nong Yao',
            },
            zipcode: '60150',
          },
          601108: {
            name: {
              th: 'หนองนมวัว',
              en: 'Nong Nom Wua',
            },
            zipcode: '60150',
          },
          601109: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '60150',
          },
          601110: {
            name: {
              th: 'เนินขี้เหล็ก',
              en: 'Noen Khilek',
            },
            zipcode: '60150',
          },
          601116: {
            name: {
              th: 'ศาลเจ้าไก่ต่อ',
              en: 'Sanchao Kai To',
            },
            zipcode: '60150',
          },
          601117: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '60150',
          },
        },
      },
      6012: {
        name: {
          th: 'ตากฟ้า',
          en: 'Tak Fa',
        },
        tambons: {
          601201: {
            name: {
              th: 'ตากฟ้า',
              en: 'Tak Fa',
            },
            zipcode: '60190',
          },
          601202: {
            name: {
              th: 'ลำพยนต์',
              en: 'Lam Phayon',
            },
            zipcode: '60190',
          },
          601203: {
            name: {
              th: 'สุขสำราญ',
              en: 'Suk Samran',
            },
            zipcode: '60190',
          },
          601204: {
            name: {
              th: 'หนองพิกุล',
              en: 'Nong Phikun',
            },
            zipcode: '60190',
          },
          601205: {
            name: {
              th: 'พุนกยูง',
              en: 'Phu Nok Yung',
            },
            zipcode: '60190',
          },
          601206: {
            name: {
              th: 'อุดมธัญญา',
              en: 'Udom Thanya',
            },
            zipcode: '60190',
          },
          601207: {
            name: {
              th: 'เขาชายธง',
              en: 'Khao Chai Thong',
            },
            zipcode: '60190',
          },
        },
      },
      6013: {
        name: {
          th: 'แม่วงก์',
          en: 'Mae Wong',
        },
        tambons: {
          601301: {
            name: {
              th: 'แม่วงก์',
              en: 'Mae Wong',
            },
            zipcode: '60150',
          },
          601303: {
            name: {
              th: 'แม่เล่ย์',
              en: 'Mae Le',
            },
            zipcode: '60150',
          },
          601304: {
            name: {
              th: 'วังซ่าน',
              en: 'Wang San',
            },
            zipcode: '60150',
          },
          601305: {
            name: {
              th: 'เขาชนกัน',
              en: 'Khao Chon Kan',
            },
            zipcode: '60150',
          },
        },
      },
      6014: {
        name: {
          th: 'แม่เปิน',
          en: 'Mae Poen',
        },
        tambons: {
          601401: {
            name: {
              th: 'แม่เปิน',
              en: 'Mae Poen',
            },
            zipcode: '60150',
          },
        },
      },
      6015: {
        name: {
          th: 'ชุมตาบง',
          en: 'Chum Ta Bong',
        },
        tambons: {
          601501: {
            name: {
              th: 'ชุมตาบง',
              en: 'Chum Ta Bong',
            },
            zipcode: '60150',
          },
          601502: {
            name: {
              th: 'ปางสวรรค์',
              en: 'Pang Sawan',
            },
            zipcode: '60150',
          },
        },
      },
    },
  },
  61: {
    name: {
      th: 'อุทัยธานี',
      en: 'Uthai Thani',
    },
    amphoes: {
      6101: {
        name: {
          th: 'เมืองอุทัยธานี',
          en: 'Muang',
        },
        tambons: {
          610101: {
            name: {
              th: 'อุทัยใหม่',
              en: 'Uthai Mai',
            },
            zipcode: '61000',
          },
          610102: {
            name: {
              th: 'น้ำซึม',
              en: 'Nam Suem',
            },
            zipcode: '61000',
          },
          610103: {
            name: {
              th: 'สะแกกรัง',
              en: 'Sakae Krang',
            },
            zipcode: '61000',
          },
          610104: {
            name: {
              th: 'ดอนขวาง',
              en: 'Don Khwang',
            },
            zipcode: '61000',
          },
          610105: {
            name: {
              th: 'หาดทนง',
              en: 'Hat Thanong',
            },
            zipcode: '61000',
          },
          610106: {
            name: {
              th: 'เกาะเทโพ',
              en: 'Ko Thepho',
            },
            zipcode: '61000',
          },
          610107: {
            name: {
              th: 'ท่าซุง',
              en: 'Tha Sung',
            },
            zipcode: '61000',
          },
          610108: {
            name: {
              th: 'หนองแก',
              en: 'Nong Kae',
            },
            zipcode: '61000',
          },
          610109: {
            name: {
              th: 'โนนเหล็ก',
              en: 'Non Lek',
            },
            zipcode: '61000',
          },
          610110: {
            name: {
              th: 'หนองเต่า',
              en: 'Nong Tao',
            },
            zipcode: '61000',
          },
          610111: {
            name: {
              th: 'หนองไผ่แบน',
              en: 'Nong Phai Baen',
            },
            zipcode: '61000',
          },
          610112: {
            name: {
              th: 'หนองพังค่า',
              en: 'Nong Phang Kha',
            },
            zipcode: '61000',
          },
          610113: {
            name: {
              th: 'ทุ่งใหญ่',
              en: 'Thung Yai',
            },
            zipcode: '61000',
          },
          610114: {
            name: {
              th: 'เนินแจง',
              en: 'Noen Chaeng',
            },
            zipcode: '61000',
          },
        },
      },
      6102: {
        name: {
          th: 'ทัพทัน',
          en: 'Thap Than',
        },
        tambons: {
          610201: {
            name: {
              th: 'ทัพทัน',
              en: 'Thap Than',
            },
            zipcode: '61120',
          },
          610202: {
            name: {
              th: 'ทุ่งนาไทย',
              en: 'Thung Na Thai',
            },
            zipcode: '61120',
          },
          610203: {
            name: {
              th: 'เขาขี้ฝอย',
              en: 'Khao Khi Foi',
            },
            zipcode: '61120',
          },
          610204: {
            name: {
              th: 'หนองหญ้าปล้อง',
              en: 'Nong Ya Plong',
            },
            zipcode: '61120',
          },
          610205: {
            name: {
              th: 'โคกหม้อ',
              en: 'Khok Mo',
            },
            zipcode: '61120',
          },
          610206: {
            name: {
              th: 'หนองยายดา',
              en: 'Nong Yai Da',
            },
            zipcode: '61120',
          },
          610207: {
            name: {
              th: 'หนองกลางดง',
              en: 'Nong Klang Dong',
            },
            zipcode: '61120',
          },
          610208: {
            name: {
              th: 'หนองกระทุ่ม',
              en: 'Nong Krathum',
            },
            zipcode: '61120',
          },
          610209: {
            name: {
              th: 'หนองสระ',
              en: 'Nong Sa',
            },
            zipcode: '61120',
          },
          610210: {
            name: {
              th: 'ตลุกดู่',
              en: 'Taluk Du',
            },
            zipcode: '61120',
          },
        },
      },
      6103: {
        name: {
          th: 'สว่างอารมณ์',
          en: 'Sawang Arom',
        },
        tambons: {
          610301: {
            name: {
              th: 'สว่างอารมณ์',
              en: 'Sawang Arom',
            },
            zipcode: '61150',
          },
          610302: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '61150',
          },
          610303: {
            name: {
              th: 'พลวงสองนาง',
              en: 'Phluang Song Nang',
            },
            zipcode: '61150',
          },
          610304: {
            name: {
              th: 'ไผ่เขียว',
              en: 'Phai Khiao',
            },
            zipcode: '61150',
          },
          610305: {
            name: {
              th: 'บ่อยาง',
              en: 'Bo Yang',
            },
            zipcode: '61150',
          },
        },
      },
      6104: {
        name: {
          th: 'หนองฉาง',
          en: 'Nong Chang',
        },
        tambons: {
          610401: {
            name: {
              th: 'หนองฉาง',
              en: 'Nong Chang',
            },
            zipcode: '61110',
          },
          610402: {
            name: {
              th: 'หนองยาง',
              en: 'Nong Yang',
            },
            zipcode: '61110',
          },
          610403: {
            name: {
              th: 'หนองนางนวล',
              en: 'Nong Nang Nuan',
            },
            zipcode: '61110',
          },
          610404: {
            name: {
              th: 'หนองสรวง',
              en: 'Nong Suang',
            },
            zipcode: '61110',
          },
          610405: {
            name: {
              th: 'บ้านเก่า',
              en: 'Ban Kao',
            },
            zipcode: '61110',
          },
          610406: {
            name: {
              th: 'อุทัยเก่า',
              en: 'Uthai Kao',
            },
            zipcode: '61110',
          },
          610407: {
            name: {
              th: 'ทุ่งโพ',
              en: 'Thung Pho',
            },
            zipcode: '61110',
          },
          610408: {
            name: {
              th: 'ทุ่งพง',
              en: 'Thung Phong',
            },
            zipcode: '61110',
          },
          610409: {
            name: {
              th: 'เขาบางแกรก',
              en: 'Khao Bang Kraek',
            },
            zipcode: '61170',
          },
          610410: {
            name: {
              th: 'เขากวางทอง',
              en: 'Khao Kwang Thong',
            },
            zipcode: '61110',
          },
        },
      },
      6105: {
        name: {
          th: 'หนองขาหย่าง',
          en: 'Nong Khayang',
        },
        tambons: {
          610501: {
            name: {
              th: 'หนองขาหย่าง',
              en: 'Nong Khayang',
            },
            zipcode: '61130',
          },
          610502: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '61130',
          },
          610503: {
            name: {
              th: 'ดอนกลอย',
              en: 'Don Kloi',
            },
            zipcode: '61130',
          },
          610504: {
            name: {
              th: 'ห้วยรอบ',
              en: 'Huai Rop',
            },
            zipcode: '61130',
          },
          610505: {
            name: {
              th: 'ทุ่งพึ่ง',
              en: 'Thung Phueng',
            },
            zipcode: '61130',
          },
          610506: {
            name: {
              th: 'ท่าโพ',
              en: 'Tha Pho',
            },
            zipcode: '61130',
          },
          610507: {
            name: {
              th: 'หมกแถว',
              en: 'Mok Thaeo',
            },
            zipcode: '61130',
          },
          610508: {
            name: {
              th: 'หลุมเข้า',
              en: 'Lum Khao',
            },
            zipcode: '61130',
          },
          610509: {
            name: {
              th: 'ดงขวาง',
              en: 'Dong Khwang',
            },
            zipcode: '61130',
          },
        },
      },
      6106: {
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        tambons: {
          610601: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '61140',
          },
          610602: {
            name: {
              th: 'ทัพหลวง',
              en: 'Thap Luang',
            },
            zipcode: '61140',
          },
          610603: {
            name: {
              th: 'ห้วยแห้ง',
              en: 'Huai Haeng',
            },
            zipcode: '61140',
          },
          610604: {
            name: {
              th: 'คอกควาย',
              en: 'Khok Khwai',
            },
            zipcode: '61140',
          },
          610605: {
            name: {
              th: 'วังหิน',
              en: 'Wang Hin',
            },
            zipcode: '61180',
          },
          610606: {
            name: {
              th: 'เมืองการุ้ง',
              en: 'Mueang Ka Rung',
            },
            zipcode: '61180',
          },
          610607: {
            name: {
              th: 'แก่นมะกรูด',
              en: 'Kaen Makrut',
            },
            zipcode: '61140',
          },
          610609: {
            name: {
              th: 'หนองจอก',
              en: 'Nong Chok',
            },
            zipcode: '61180',
          },
          610610: {
            name: {
              th: 'หูช้าง',
              en: 'Hu Chang',
            },
            zipcode: '61180',
          },
          610611: {
            name: {
              th: 'บ้านบึง',
              en: 'Ban Bueng',
            },
            zipcode: '61140',
          },
          610612: {
            name: {
              th: 'บ้านใหม่คลองเคียน',
              en: 'Ban Mai Khlong Khian',
            },
            zipcode: '61180',
          },
          610613: {
            name: {
              th: 'หนองบ่มกล้วย',
              en: 'Nong Bom Kluai',
            },
            zipcode: '61180',
          },
          610614: {
            name: {
              th: 'เจ้าวัด',
              en: 'Chao Wat',
            },
            zipcode: '61140',
          },
        },
      },
      6107: {
        name: {
          th: 'ลานสัก',
          en: 'Lan Sak',
        },
        tambons: {
          610701: {
            name: {
              th: 'ลานสัก',
              en: 'Lan Sak',
            },
            zipcode: '61160',
          },
          610702: {
            name: {
              th: 'ประดู่ยืน',
              en: 'Pradu Yuen',
            },
            zipcode: '61160',
          },
          610703: {
            name: {
              th: 'ป่าอ้อ',
              en: 'Pa O',
            },
            zipcode: '61160',
          },
          610704: {
            name: {
              th: 'ระบำ',
              en: 'Rabam',
            },
            zipcode: '61160',
          },
          610705: {
            name: {
              th: 'น้ำรอบ',
              en: 'Nam Rop',
            },
            zipcode: '61160',
          },
          610706: {
            name: {
              th: 'ทุ่งนางาม',
              en: 'Thung Na Ngam',
            },
            zipcode: '61160',
          },
        },
      },
      6108: {
        name: {
          th: 'ห้วยคต',
          en: 'Huai Khot',
        },
        tambons: {
          610801: {
            name: {
              th: 'สุขฤทัย',
              en: 'Suk Ruethai',
            },
            zipcode: '61170',
          },
          610802: {
            name: {
              th: 'ทองหลาง',
              en: 'Thong Lang',
            },
            zipcode: '61170',
          },
          610803: {
            name: {
              th: 'ห้วยคต',
              en: 'Huai Khot',
            },
            zipcode: '61170',
          },
        },
      },
    },
  },
  62: {
    name: {
      th: 'กำแพงเพชร',
      en: 'Kamphaeng Phet',
    },
    amphoes: {
      6201: {
        name: {
          th: 'เมืองกำแพงเพชร',
          en: 'Muang',
        },
        tambons: {
          620101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '62000',
          },
          620102: {
            name: {
              th: 'ไตรตรึงษ์',
              en: 'Trai Trueng',
            },
            zipcode: '62160',
          },
          620103: {
            name: {
              th: 'อ่างทอง',
              en: 'Ang Thong',
            },
            zipcode: '62000',
          },
          620104: {
            name: {
              th: 'นาบ่อคำ',
              en: 'Na Bo Kham',
            },
            zipcode: '62000',
          },
          620105: {
            name: {
              th: 'นครชุม',
              en: 'Nakhon Chum',
            },
            zipcode: '62000',
          },
          620106: {
            name: {
              th: 'ทรงธรรม',
              en: 'Song Tham',
            },
            zipcode: '62000',
          },
          620107: {
            name: {
              th: 'ลานดอกไม้',
              en: 'Lan Dokmai',
            },
            zipcode: '62000',
          },
          620110: {
            name: {
              th: 'หนองปลิง',
              en: 'Nong Pling',
            },
            zipcode: '62000',
          },
          620111: {
            name: {
              th: 'คณฑี',
              en: 'Khonthi',
            },
            zipcode: '62000',
          },
          620112: {
            name: {
              th: 'นิคมทุ่งโพธิ์ทะเล',
              en: 'Nikhom Thung Pho Thale',
            },
            zipcode: '62000',
          },
          620113: {
            name: {
              th: 'เทพนคร',
              en: 'Thep Nakhon',
            },
            zipcode: '62000',
          },
          620114: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '62000',
          },
          620115: {
            name: {
              th: 'ท่าขุนราม',
              en: 'Tha Khun Ram',
            },
            zipcode: '62000',
          },
          620117: {
            name: {
              th: 'คลองแม่ลาย',
              en: 'Khlong Mae Lai',
            },
            zipcode: '62000',
          },
          620118: {
            name: {
              th: 'ธำมรงค์',
              en: 'Thammarong',
            },
            zipcode: '62160',
          },
          620119: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '62000',
          },
        },
      },
      6202: {
        name: {
          th: 'ไทรงาม',
          en: 'Sai Ngam',
        },
        tambons: {
          620201: {
            name: {
              th: 'ไทรงาม',
              en: 'Sai Ngam',
            },
            zipcode: '62150',
          },
          620202: {
            name: {
              th: 'หนองคล้า',
              en: 'Nong Khla',
            },
            zipcode: '62150',
          },
          620203: {
            name: {
              th: 'หนองทอง',
              en: 'Nong Thong',
            },
            zipcode: '62150',
          },
          620204: {
            name: {
              th: 'หนองไม้กอง',
              en: 'Nong Mai Kong',
            },
            zipcode: '62150',
          },
          620205: {
            name: {
              th: 'มหาชัย',
              en: 'Maha Chai',
            },
            zipcode: '62150',
          },
          620206: {
            name: {
              th: 'พานทอง',
              en: 'Phan Thong',
            },
            zipcode: '62150',
          },
          620207: {
            name: {
              th: 'หนองแม่แตง',
              en: 'Nong Mae Taeng',
            },
            zipcode: '62150',
          },
        },
      },
      6203: {
        name: {
          th: 'คลองลาน',
          en: 'Klong Lan',
        },
        tambons: {
          620301: {
            name: {
              th: 'คลองน้ำไหล',
              en: 'Khlong Nam Lai',
            },
            zipcode: '62180',
          },
          620302: {
            name: {
              th: 'โป่งน้ำร้อน',
              en: 'Pong Nam Ron',
            },
            zipcode: '62180',
          },
          620303: {
            name: {
              th: 'คลองลานพัฒนา',
              en: 'Khlong Lan Phatthana',
            },
            zipcode: '62180',
          },
          620304: {
            name: {
              th: 'สักงาม',
              en: 'Sak Ngam',
            },
            zipcode: '62180',
          },
        },
      },
      6204: {
        name: {
          th: 'ขาณุวรลักษบุรี',
          en: 'Khanu Woralaksaburi',
        },
        tambons: {
          620403: {
            name: {
              th: 'ยางสูง',
              en: 'Yang Sung',
            },
            zipcode: '62130',
          },
          620404: {
            name: {
              th: 'ป่าพุทรา',
              en: 'Pa Phutsa',
            },
            zipcode: '62130',
          },
          620405: {
            name: {
              th: 'แสนตอ',
              en: 'Saen To',
            },
            zipcode: '62130',
          },
          620406: {
            name: {
              th: 'สลกบาตร',
              en: 'Salokbat',
            },
            zipcode: '62140',
          },
          620407: {
            name: {
              th: 'บ่อถ้ำ',
              en: 'Bo Tham',
            },
            zipcode: '62140',
          },
          620408: {
            name: {
              th: 'ดอนแตง',
              en: 'Don Taeng',
            },
            zipcode: '62140',
          },
          620409: {
            name: {
              th: 'วังชะพลู',
              en: 'Wang Chaphlu',
            },
            zipcode: '62140',
          },
          620410: {
            name: {
              th: 'โค้งไผ่',
              en: 'Khong Phai',
            },
            zipcode: '62140',
          },
          620411: {
            name: {
              th: 'ปางมะค่า',
              en: 'Pang Makha',
            },
            zipcode: '62140',
          },
          620412: {
            name: {
              th: 'วังหามแห',
              en: 'Wang Hamhae',
            },
            zipcode: '62140',
          },
          620413: {
            name: {
              th: 'เกาะตาล',
              en: 'Ko Tan',
            },
            zipcode: '62130',
          },
        },
      },
      6205: {
        name: {
          th: 'คลองขลุง',
          en: 'Khlong Khlung',
        },
        tambons: {
          620501: {
            name: {
              th: 'คลองขลุง',
              en: 'Khlong Khlung',
            },
            zipcode: '62120',
          },
          620502: {
            name: {
              th: 'ท่ามะเขือ',
              en: 'Tha Makhuea',
            },
            zipcode: '62120',
          },
          620504: {
            name: {
              th: 'ท่าพุทรา',
              en: 'Tha Phutsa',
            },
            zipcode: '62120',
          },
          620505: {
            name: {
              th: 'แม่ลาด',
              en: 'Mae Lat',
            },
            zipcode: '62120',
          },
          620506: {
            name: {
              th: 'วังยาง',
              en: 'Wang Yang',
            },
            zipcode: '62120',
          },
          620507: {
            name: {
              th: 'วังแขม',
              en: 'Wang Khaem',
            },
            zipcode: '62120',
          },
          620508: {
            name: {
              th: 'หัวถนน',
              en: 'Hua Thanon',
            },
            zipcode: '62120',
          },
          620509: {
            name: {
              th: 'วังไทร',
              en: 'Wang Sai',
            },
            zipcode: '62120',
          },
          620513: {
            name: {
              th: 'วังบัว',
              en: 'Wang Bua',
            },
            zipcode: '62120',
          },
          620516: {
            name: {
              th: 'คลองสมบูรณ์',
              en: 'Khlong Sombun',
            },
            zipcode: '62120',
          },
        },
      },
      6206: {
        name: {
          th: 'พรานกระต่าย',
          en: 'Phran Kratai',
        },
        tambons: {
          620601: {
            name: {
              th: 'พรานกระต่าย',
              en: 'Phran Kratai',
            },
            zipcode: '62110',
          },
          620602: {
            name: {
              th: 'หนองหัววัว',
              en: 'Nong Hua Wua',
            },
            zipcode: '62110',
          },
          620603: {
            name: {
              th: 'ท่าไม้',
              en: 'Tha Mai',
            },
            zipcode: '62110',
          },
          620604: {
            name: {
              th: 'วังควง',
              en: 'Wang Khuang',
            },
            zipcode: '62110',
          },
          620605: {
            name: {
              th: 'วังตะแบก',
              en: 'Wang Tabaek',
            },
            zipcode: '62110',
          },
          620606: {
            name: {
              th: 'เขาคีริส',
              en: 'Khao Khirit',
            },
            zipcode: '62110',
          },
          620607: {
            name: {
              th: 'คุยบ้านโอง',
              en: 'Khui Ban Ong',
            },
            zipcode: '62110',
          },
          620608: {
            name: {
              th: 'คลองพิไกร',
              en: 'Khlong Phikrai',
            },
            zipcode: '62110',
          },
          620609: {
            name: {
              th: 'ถ้ำกระต่ายทอง',
              en: 'Tham Kratai Thong',
            },
            zipcode: '62110',
          },
          620610: {
            name: {
              th: 'ห้วยยั้ง',
              en: 'Huai Yang',
            },
            zipcode: '62110',
          },
        },
      },
      6207: {
        name: {
          th: 'ลานกระบือ',
          en: 'Lan Krabu',
        },
        tambons: {
          620701: {
            name: {
              th: 'ลานกระบือ',
              en: 'Lan Krabue',
            },
            zipcode: '62170',
          },
          620702: {
            name: {
              th: 'ช่องลม',
              en: 'Chong Lom',
            },
            zipcode: '62170',
          },
          620703: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '62170',
          },
          620704: {
            name: {
              th: 'โนนพลวง',
              en: 'Non Phluang',
            },
            zipcode: '62170',
          },
          620705: {
            name: {
              th: 'ประชาสุขสันต์',
              en: 'Pracha Suk San',
            },
            zipcode: '62170',
          },
          620706: {
            name: {
              th: 'บึงทับแรต',
              en: 'Bueng Thap Raet',
            },
            zipcode: '62170',
          },
          620707: {
            name: {
              th: 'จันทิมา',
              en: 'Chanthima',
            },
            zipcode: '62170',
          },
        },
      },
      6208: {
        name: {
          th: 'ทรายทองวัฒนา',
          en: 'Saithong Wattana',
        },
        tambons: {
          620801: {
            name: {
              th: 'ทุ่งทราย',
              en: 'Thung Sai',
            },
            zipcode: '62190',
          },
          620802: {
            name: {
              th: 'ทุ่งทอง',
              en: 'Thung Thong',
            },
            zipcode: '62190',
          },
          620803: {
            name: {
              th: 'ถาวรวัฒนา',
              en: 'Thawon Watthana',
            },
            zipcode: '62190',
          },
        },
      },
      6209: {
        name: {
          th: 'ปางศิลาทอง',
          en: 'Pang Silathong',
        },
        tambons: {
          620901: {
            name: {
              th: 'โพธิ์ทอง',
              en: 'Pho Thong',
            },
            zipcode: '62120',
          },
          620902: {
            name: {
              th: 'หินดาต',
              en: 'Hin Dat',
            },
            zipcode: '62120',
          },
          620903: {
            name: {
              th: 'ปางตาไว',
              en: 'Pang Ta Wai',
            },
            zipcode: '62120',
          },
        },
      },
      6210: {
        name: {
          th: 'บึงสามัคคี',
          en: 'Bueng Samakkhi',
        },
        tambons: {
          621001: {
            name: {
              th: 'บึงสามัคคี',
              en: 'Bueng Samakkhi',
            },
            zipcode: '62210',
          },
          621002: {
            name: {
              th: 'วังชะโอน',
              en: 'Wang Cha-on',
            },
            zipcode: '62210',
          },
          621003: {
            name: {
              th: 'ระหาน',
              en: 'Rahan',
            },
            zipcode: '62210',
          },
          621004: {
            name: {
              th: 'เทพนิมิต',
              en: 'Thep Nimit',
            },
            zipcode: '62210',
          },
        },
      },
      6211: {
        name: {
          th: 'โกสัมพีนคร',
          en: 'Kosamphi',
        },
        tambons: {
          621101: {
            name: {
              th: 'โกสัมพี',
              en: 'Kosamphi',
            },
            zipcode: '62000',
          },
          621102: {
            name: {
              th: 'เพชรชมภู',
              en: 'Phet Chomphu',
            },
            zipcode: '62000',
          },
          621103: {
            name: {
              th: 'ลานดอกไม้ตก',
              en: 'Lan Dokmai Tok',
            },
            zipcode: '62000',
          },
        },
      },
    },
  },
  63: {
    name: {
      th: 'ตาก',
      en: 'Tak',
    },
    amphoes: {
      6301: {
        name: {
          th: 'เมืองตาก',
          en: 'Muang',
        },
        tambons: {
          630101: {
            name: {
              th: 'ระแหง',
              en: 'Rahaeng',
            },
            zipcode: '63000',
          },
          630102: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '63000',
          },
          630103: {
            name: {
              th: 'เชียงเงิน',
              en: 'Chiang Ngoen',
            },
            zipcode: '63000',
          },
          630104: {
            name: {
              th: 'หัวเดียด',
              en: 'Hua Diat',
            },
            zipcode: '63000',
          },
          630105: {
            name: {
              th: 'หนองบัวเหนือ',
              en: 'Nong Bua Nuea',
            },
            zipcode: '63000',
          },
          630106: {
            name: {
              th: 'ไม้งาม',
              en: 'Mai Ngam',
            },
            zipcode: '63000',
          },
          630107: {
            name: {
              th: 'โป่งแดง',
              en: 'Pong Daeng',
            },
            zipcode: '63000',
          },
          630108: {
            name: {
              th: 'น้ำรึม',
              en: 'Nam Ruem',
            },
            zipcode: '63000',
          },
          630109: {
            name: {
              th: 'วังหิน',
              en: 'Wang Hin',
            },
            zipcode: '63000',
          },
          630111: {
            name: {
              th: 'แม่ท้อ',
              en: 'Mae Tho',
            },
            zipcode: '63000',
          },
          630112: {
            name: {
              th: 'ป่ามะม่วง',
              en: 'Pa Mamuang',
            },
            zipcode: '63000',
          },
          630113: {
            name: {
              th: 'หนองบัวใต้',
              en: 'Nong Bua Tai',
            },
            zipcode: '63000',
          },
          630114: {
            name: {
              th: 'วังประจบ',
              en: 'Wang Prachop',
            },
            zipcode: '63000',
          },
          630115: {
            name: {
              th: 'ตลุกกลางทุ่ง',
              en: 'Taluk Klang Thung',
            },
            zipcode: '63000',
          },
        },
      },
      6302: {
        name: {
          th: 'บ้านตาก',
          en: 'Ban Tak',
        },
        tambons: {
          630201: {
            name: {
              th: 'ตากออก',
              en: 'Tak Ok',
            },
            zipcode: '63120',
          },
          630202: {
            name: {
              th: 'สมอโคน',
              en: 'Samo Khon',
            },
            zipcode: '63120',
          },
          630203: {
            name: {
              th: 'แม่สลิด',
              en: 'Mae Salit',
            },
            zipcode: '63120',
          },
          630204: {
            name: {
              th: 'ตากตก',
              en: 'Tak Tok',
            },
            zipcode: '63120',
          },
          630205: {
            name: {
              th: 'เกาะตะเภา',
              en: 'Ko Taphao',
            },
            zipcode: '63120',
          },
          630206: {
            name: {
              th: 'ทุ่งกระเชาะ',
              en: 'Thung Kracho',
            },
            zipcode: '63120',
          },
          630207: {
            name: {
              th: 'ท้องฟ้า',
              en: 'Thong Fa',
            },
            zipcode: '63120',
          },
        },
      },
      6303: {
        name: {
          th: 'สามเงา',
          en: 'Sam Hgao',
        },
        tambons: {
          630301: {
            name: {
              th: 'สามเงา',
              en: 'Sam Ngao',
            },
            zipcode: '63130',
          },
          630302: {
            name: {
              th: 'วังหมัน',
              en: 'Wang Man',
            },
            zipcode: '63130',
          },
          630303: {
            name: {
              th: 'ยกกระบัตร',
              en: 'Yokkrabat',
            },
            zipcode: '63130',
          },
          630304: {
            name: {
              th: 'ย่านรี',
              en: 'Yan Ri',
            },
            zipcode: '63130',
          },
          630305: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '63130',
          },
          630306: {
            name: {
              th: 'วังจันทร์',
              en: 'Wang Chan',
            },
            zipcode: '63130',
          },
        },
      },
      6304: {
        name: {
          th: 'แม่ระมาด',
          en: 'Mae Ramat',
        },
        tambons: {
          630401: {
            name: {
              th: 'แม่ระมาด',
              en: 'Mae Ramat',
            },
            zipcode: '63140',
          },
          630402: {
            name: {
              th: 'แม่จะเรา',
              en: 'Mae Charao',
            },
            zipcode: '63140',
          },
          630403: {
            name: {
              th: 'ขะเนจื้อ',
              en: 'Khane Chue',
            },
            zipcode: '63140',
          },
          630404: {
            name: {
              th: 'แม่ตื่น',
              en: 'Mae Tuen',
            },
            zipcode: '63140',
          },
          630405: {
            name: {
              th: 'สามหมื่น',
              en: 'Sam Muen',
            },
            zipcode: '63140',
          },
          630406: {
            name: {
              th: 'พระธาตุ',
              en: 'Phra That',
            },
            zipcode: '63140',
          },
        },
      },
      6305: {
        name: {
          th: 'ท่าสองยาง',
          en: 'Tha Song Yang',
        },
        tambons: {
          630501: {
            name: {
              th: 'ท่าสองยาง',
              en: 'Tha Song Yang',
            },
            zipcode: '63150',
          },
          630502: {
            name: {
              th: 'แม่ต้าน',
              en: 'Mae Tan',
            },
            zipcode: '63150',
          },
          630503: {
            name: {
              th: 'แม่สอง',
              en: 'Mae Song',
            },
            zipcode: '63150',
          },
          630504: {
            name: {
              th: 'แม่หละ',
              en: 'Mae La',
            },
            zipcode: '63150',
          },
          630505: {
            name: {
              th: 'แม่วะหลวง',
              en: 'Mae Wa Luang',
            },
            zipcode: '63150',
          },
          630506: {
            name: {
              th: 'แม่อุสุ',
              en: 'Mae U-su',
            },
            zipcode: '63150',
          },
        },
      },
      6306: {
        name: {
          th: 'แม่สอด',
          en: 'Mae Sot',
        },
        tambons: {
          630601: {
            name: {
              th: 'แม่สอด',
              en: 'Mae Sot',
            },
            zipcode: '63110',
          },
          630602: {
            name: {
              th: 'แม่กุ',
              en: 'Mae Ku',
            },
            zipcode: '63110',
          },
          630603: {
            name: {
              th: 'พะวอ',
              en: 'Phawo',
            },
            zipcode: '63110',
          },
          630604: {
            name: {
              th: 'แม่ตาว',
              en: 'Mae Tao',
            },
            zipcode: '63110',
          },
          630605: {
            name: {
              th: 'แม่กาษา',
              en: 'Mae Kasa',
            },
            zipcode: '63110',
          },
          630606: {
            name: {
              th: 'ท่าสายลวด',
              en: 'Tha Sai Luat',
            },
            zipcode: '63110',
          },
          630607: {
            name: {
              th: 'แม่ปะ',
              en: 'Mae Pa',
            },
            zipcode: '63110',
          },
          630608: {
            name: {
              th: 'มหาวัน',
              en: 'Mahawan',
            },
            zipcode: '63110',
          },
          630609: {
            name: {
              th: 'ด่านแม่ละเมา',
              en: 'Dan Mae La Mao',
            },
            zipcode: '63110',
          },
          630610: {
            name: {
              th: 'พระธาตุผาแดง',
              en: 'Phra That Pha Daeng',
            },
            zipcode: '63110',
          },
        },
      },
      6307: {
        name: {
          th: 'พบพระ',
          en: 'Phop Phra',
        },
        tambons: {
          630701: {
            name: {
              th: 'พบพระ',
              en: 'Phop Phra',
            },
            zipcode: '63160',
          },
          630702: {
            name: {
              th: 'ช่องแคบ',
              en: 'Chong Khaep',
            },
            zipcode: '63160',
          },
          630703: {
            name: {
              th: 'คีรีราษฎร์',
              en: 'Khiri Rat',
            },
            zipcode: '63160',
          },
          630704: {
            name: {
              th: 'วาเล่ย์',
              en: 'Wale',
            },
            zipcode: '63160',
          },
          630705: {
            name: {
              th: 'รวมไทยพัฒนา',
              en: 'Ruam Thai Phatthana',
            },
            zipcode: '63160',
          },
        },
      },
      6308: {
        name: {
          th: 'อุ้มผาง',
          en: 'Umphang',
        },
        tambons: {
          630801: {
            name: {
              th: 'อุ้มผาง',
              en: 'Umphang',
            },
            zipcode: '63170',
          },
          630802: {
            name: {
              th: 'หนองหลวง',
              en: 'Nong Luang',
            },
            zipcode: '63170',
          },
          630803: {
            name: {
              th: 'โมโกร',
              en: 'Mokro',
            },
            zipcode: '63170',
          },
          630804: {
            name: {
              th: 'แม่จัน',
              en: 'Mae Chan',
            },
            zipcode: '63170',
          },
          630805: {
            name: {
              th: 'แม่ละมุ้ง',
              en: 'Mae Lamung',
            },
            zipcode: '63170',
          },
          630806: {
            name: {
              th: 'แม่กลอง',
              en: 'Mae Khlong',
            },
            zipcode: '63170',
          },
        },
      },
      6309: {
        name: {
          th: 'วังเจ้า',
          en: 'King Amphoe  Wang Jao',
        },
        tambons: {
          630901: {
            name: {
              th: 'เชียงทอง',
              en: 'Chiang Thong',
            },
            zipcode: '63000',
          },
          630902: {
            name: {
              th: 'นาโบสถ์',
              en: 'Na Bot',
            },
            zipcode: '63000',
          },
          630903: {
            name: {
              th: 'ประดาง',
              en: 'Pradang',
            },
            zipcode: '63000',
          },
        },
      },
    },
  },
  64: {
    name: {
      th: 'สุโขทัย',
      en: 'Sukhothai',
    },
    amphoes: {
      6401: {
        name: {
          th: 'เมืองสุโขทัย',
          en: 'Muang',
        },
        tambons: {
          640101: {
            name: {
              th: 'ธานี',
              en: 'Thani',
            },
            zipcode: '64000',
          },
          640102: {
            name: {
              th: 'บ้านสวน',
              en: 'Ban Suan',
            },
            zipcode: '64220',
          },
          640103: {
            name: {
              th: 'เมืองเก่า',
              en: 'Mueang Kao',
            },
            zipcode: '64210',
          },
          640104: {
            name: {
              th: 'ปากแคว',
              en: 'Pak Khwae',
            },
            zipcode: '64000',
          },
          640105: {
            name: {
              th: 'ยางซ้าย',
              en: 'Yang Sai',
            },
            zipcode: '64000',
          },
          640106: {
            name: {
              th: 'บ้านกล้วย',
              en: 'Ban Kluai',
            },
            zipcode: '64000',
          },
          640107: {
            name: {
              th: 'บ้านหลุม',
              en: 'Ban Lum',
            },
            zipcode: '64000',
          },
          640108: {
            name: {
              th: 'ตาลเตี้ย',
              en: 'Tan Tia',
            },
            zipcode: '64220',
          },
          640109: {
            name: {
              th: 'ปากพระ',
              en: 'Pak Phra',
            },
            zipcode: '64000',
          },
          640110: {
            name: {
              th: 'วังทองแดง',
              en: 'Wang Thong Daeng',
            },
            zipcode: '64210',
          },
        },
      },
      6402: {
        name: {
          th: 'บ้านด่านลานหอย',
          en: 'Ban Dan Lan Hoi',
        },
        tambons: {
          640201: {
            name: {
              th: 'ลานหอย',
              en: 'Lan Hoi',
            },
            zipcode: '64140',
          },
          640202: {
            name: {
              th: 'บ้านด่าน',
              en: 'Ban Dan',
            },
            zipcode: '64140',
          },
          640203: {
            name: {
              th: 'วังตะคร้อ',
              en: 'Wang Takhro',
            },
            zipcode: '64140',
          },
          640204: {
            name: {
              th: 'วังน้ำขาว',
              en: 'Wang Nam Khao',
            },
            zipcode: '64140',
          },
          640205: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '64140',
          },
          640206: {
            name: {
              th: 'หนองหญ้าปล้อง',
              en: 'Nong Ya Plong',
            },
            zipcode: '64140',
          },
          640207: {
            name: {
              th: 'วังลึก',
              en: 'Wang Luek',
            },
            zipcode: '64140',
          },
        },
      },
      6403: {
        name: {
          th: 'คีรีมาศ',
          en: 'Khiri Mat',
        },
        tambons: {
          640301: {
            name: {
              th: 'โตนด',
              en: 'Tanot',
            },
            zipcode: '64160',
          },
          640302: {
            name: {
              th: 'ทุ่งหลวง',
              en: 'Thung Luang',
            },
            zipcode: '64160',
          },
          640303: {
            name: {
              th: 'บ้านป้อม',
              en: 'Ban Pom',
            },
            zipcode: '64160',
          },
          640304: {
            name: {
              th: 'สามพวง',
              en: 'Sam Phuang',
            },
            zipcode: '64160',
          },
          640305: {
            name: {
              th: 'ศรีคีรีมาศ',
              en: 'Si Khiri Mat',
            },
            zipcode: '64160',
          },
          640306: {
            name: {
              th: 'หนองจิก',
              en: 'Nong Chik',
            },
            zipcode: '64160',
          },
          640307: {
            name: {
              th: 'นาเชิงคีรี',
              en: 'Na Choeng Khiri',
            },
            zipcode: '64160',
          },
          640308: {
            name: {
              th: 'หนองกระดิ่ง',
              en: 'Nong Krading',
            },
            zipcode: '64160',
          },
          640309: {
            name: {
              th: 'บ้านน้ำพุ',
              en: 'Ban Nam Phu',
            },
            zipcode: '64160',
          },
          640310: {
            name: {
              th: 'ทุ่งยางเมือง',
              en: 'Thung Yang Mueang',
            },
            zipcode: '64160',
          },
        },
      },
      6404: {
        name: {
          th: 'กงไกรลาศ',
          en: 'Kong Kralilat',
        },
        tambons: {
          640401: {
            name: {
              th: 'กง',
              en: 'Kong',
            },
            zipcode: '64170',
          },
          640402: {
            name: {
              th: 'บ้านกร่าง',
              en: 'Ban Krang',
            },
            zipcode: '64170',
          },
          640403: {
            name: {
              th: 'ไกรนอก',
              en: 'Krai Nok',
            },
            zipcode: '64170',
          },
          640404: {
            name: {
              th: 'ไกรกลาง',
              en: 'Krai Klang',
            },
            zipcode: '64170',
          },
          640405: {
            name: {
              th: 'ไกรใน',
              en: 'Krai Nai',
            },
            zipcode: '64170',
          },
          640406: {
            name: {
              th: 'ดงเดือย',
              en: 'Dong Dueai',
            },
            zipcode: '64170',
          },
          640407: {
            name: {
              th: 'ป่าแฝก',
              en: 'Pa Faek',
            },
            zipcode: '64170',
          },
          640408: {
            name: {
              th: 'กกแรต',
              en: 'Kok Raet',
            },
            zipcode: '64170',
          },
          640409: {
            name: {
              th: 'ท่าฉนวน',
              en: 'Tha Chanuan',
            },
            zipcode: '64170',
          },
          640410: {
            name: {
              th: 'หนองตูม',
              en: 'Nong Tum',
            },
            zipcode: '64170',
          },
          640411: {
            name: {
              th: 'บ้านใหม่สุขเกษม',
              en: 'Ban Mai Suk Kasem',
            },
            zipcode: '64170',
          },
        },
      },
      6405: {
        name: {
          th: 'ศรีสัชนาลัย',
          en: 'Si Satchanalai',
        },
        tambons: {
          640501: {
            name: {
              th: 'หาดเสี้ยว',
              en: 'Hat Siao',
            },
            zipcode: '64130',
          },
          640502: {
            name: {
              th: 'ป่างิ้ว',
              en: 'Pa Ngio',
            },
            zipcode: '64130',
          },
          640503: {
            name: {
              th: 'แม่สำ',
              en: 'Mae Sam',
            },
            zipcode: '64130',
          },
          640504: {
            name: {
              th: 'แม่สิน',
              en: 'Mae Sin',
            },
            zipcode: '64130',
          },
          640505: {
            name: {
              th: 'บ้านตึก',
              en: 'Ban Tuek',
            },
            zipcode: '64130',
          },
          640506: {
            name: {
              th: 'หนองอ้อ',
              en: 'Nong O',
            },
            zipcode: '64130',
          },
          640507: {
            name: {
              th: 'ท่าชัย',
              en: 'Tha Chai',
            },
            zipcode: '64190',
          },
          640508: {
            name: {
              th: 'ศรีสัชนาลัย',
              en: 'Si Satchanalai',
            },
            zipcode: '64190',
          },
          640509: {
            name: {
              th: 'ดงคู่',
              en: 'Dong Khu',
            },
            zipcode: '64130',
          },
          640510: {
            name: {
              th: 'บ้านแก่ง',
              en: 'Ban Kaeng',
            },
            zipcode: '64130',
          },
          640511: {
            name: {
              th: 'สารจิตร',
              en: 'San Chit',
            },
            zipcode: '64130',
          },
        },
      },
      6406: {
        name: {
          th: 'ศรีสำโรง',
          en: 'Si Sam Rong',
        },
        tambons: {
          640601: {
            name: {
              th: 'คลองตาล',
              en: 'Khlong Tan',
            },
            zipcode: '64120',
          },
          640602: {
            name: {
              th: 'วังลึก',
              en: 'Wang Luek',
            },
            zipcode: '64120',
          },
          640603: {
            name: {
              th: 'สามเรือน',
              en: 'Sam Ruean',
            },
            zipcode: '64120',
          },
          640604: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '64120',
          },
          640605: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '64120',
          },
          640606: {
            name: {
              th: 'นาขุนไกร',
              en: 'Na Khun Krai',
            },
            zipcode: '64120',
          },
          640607: {
            name: {
              th: 'เกาะตาเลี้ยง',
              en: 'Ko Ta Liang',
            },
            zipcode: '64120',
          },
          640608: {
            name: {
              th: 'วัดเกาะ',
              en: 'Wat Ko',
            },
            zipcode: '64120',
          },
          640609: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '64120',
          },
          640610: {
            name: {
              th: 'ทับผึ้ง',
              en: 'Thap Phueng',
            },
            zipcode: '64120',
          },
          640611: {
            name: {
              th: 'บ้านซ่าน',
              en: 'Ban San',
            },
            zipcode: '64120',
          },
          640612: {
            name: {
              th: 'วังใหญ่',
              en: 'Wang Yai',
            },
            zipcode: '64120',
          },
          640613: {
            name: {
              th: 'ราวต้นจันทร์',
              en: 'Rao Ton Chan',
            },
            zipcode: '64120',
          },
        },
      },
      6407: {
        name: {
          th: 'สวรรคโลก',
          en: 'Sawankhalok',
        },
        tambons: {
          640701: {
            name: {
              th: 'เมืองสวรรคโลก',
              en: 'Mueang Sawankhalok',
            },
            zipcode: '64110',
          },
          640702: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '64110',
          },
          640703: {
            name: {
              th: 'คลองกระจง',
              en: 'Khlong Krachong',
            },
            zipcode: '64110',
          },
          640704: {
            name: {
              th: 'วังพิณพาทย์',
              en: 'Wang Phinphat',
            },
            zipcode: '64110',
          },
          640705: {
            name: {
              th: 'วังไม้ขอน',
              en: 'Wang Mai Khon',
            },
            zipcode: '64110',
          },
          640706: {
            name: {
              th: 'ย่านยาว',
              en: 'Yan Yao',
            },
            zipcode: '64110',
          },
          640707: {
            name: {
              th: 'นาทุ่ง',
              en: 'Na Thung',
            },
            zipcode: '64110',
          },
          640708: {
            name: {
              th: 'คลองยาง',
              en: 'Khlong Yang',
            },
            zipcode: '64110',
          },
          640709: {
            name: {
              th: 'เมืองบางยม',
              en: 'Mueang Bang Yom',
            },
            zipcode: '64110',
          },
          640710: {
            name: {
              th: 'ท่าทอง',
              en: 'Tha Thong',
            },
            zipcode: '64110',
          },
          640711: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '64110',
          },
          640712: {
            name: {
              th: 'ป่ากุมเกาะ',
              en: 'Pa Kum Ko',
            },
            zipcode: '64110',
          },
          640713: {
            name: {
              th: 'เมืองบางขลัง',
              en: 'Mueang Bang Khlang',
            },
            zipcode: '64110',
          },
          640714: {
            name: {
              th: 'หนองกลับ',
              en: 'Nong Klap',
            },
            zipcode: '64110',
          },
        },
      },
      6408: {
        name: {
          th: 'ศรีนคร',
          en: 'Si Nakhon',
        },
        tambons: {
          640801: {
            name: {
              th: 'ศรีนคร',
              en: 'Si Nakhon',
            },
            zipcode: '64180',
          },
          640802: {
            name: {
              th: 'นครเดิฐ',
              en: 'Nakhon Doet',
            },
            zipcode: '64180',
          },
          640803: {
            name: {
              th: 'น้ำขุม',
              en: 'Nam Khum',
            },
            zipcode: '64180',
          },
          640804: {
            name: {
              th: 'คลองมะพลับ',
              en: 'Khlong Maphlap',
            },
            zipcode: '64180',
          },
          640805: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '64180',
          },
        },
      },
      6409: {
        name: {
          th: 'ทุ่งเสลี่ยม',
          en: 'Thung Saliam',
        },
        tambons: {
          640901: {
            name: {
              th: 'บ้านใหม่ไชยมงคล',
              en: 'Ban Mai Chai Mongkhon',
            },
            zipcode: '64230',
          },
          640902: {
            name: {
              th: 'ไทยชนะศึก',
              en: 'Thai Chana Suek',
            },
            zipcode: '64150',
          },
          640903: {
            name: {
              th: 'ทุ่งเสลี่ยม',
              en: 'Thung Saliam',
            },
            zipcode: '64150',
          },
          640904: {
            name: {
              th: 'กลางดง',
              en: 'Klang Dong',
            },
            zipcode: '64150',
          },
          640905: {
            name: {
              th: 'เขาแก้วศรีสมบูรณ์',
              en: 'Khao Kaeo Si Sombun',
            },
            zipcode: '64230',
          },
        },
      },
    },
  },
  65: {
    name: {
      th: 'พิษณุโลก',
      en: 'Phisanulok',
    },
    amphoes: {
      6501: {
        name: {
          th: 'เมืองพิษณุโลก',
          en: 'Muang',
        },
        tambons: {
          650101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '65000',
          },
          650102: {
            name: {
              th: 'วังน้ำคู้',
              en: 'Wang Nam Khu',
            },
            zipcode: '65230',
          },
          650103: {
            name: {
              th: 'วัดจันทร์',
              en: 'Wat Chan',
            },
            zipcode: '65000',
          },
          650104: {
            name: {
              th: 'วัดพริก',
              en: 'Wat Phrik',
            },
            zipcode: '65230',
          },
          650105: {
            name: {
              th: 'ท่าทอง',
              en: 'Tha Thong',
            },
            zipcode: '65000',
          },
          650106: {
            name: {
              th: 'ท่าโพธิ์',
              en: 'Tha Pho',
            },
            zipcode: '65000',
          },
          650107: {
            name: {
              th: 'สมอแข',
              en: 'Samo Khae',
            },
            zipcode: '65000',
          },
          650108: {
            name: {
              th: 'ดอนทอง',
              en: 'Don Thong',
            },
            zipcode: '65000',
          },
          650109: {
            name: {
              th: 'บ้านป่า',
              en: 'Ban Pa',
            },
            zipcode: '65000',
          },
          650110: {
            name: {
              th: 'ปากโทก',
              en: 'Pak Thok',
            },
            zipcode: '65000',
          },
          650111: {
            name: {
              th: 'หัวรอ',
              en: 'Hua Ro',
            },
            zipcode: '65000',
          },
          650112: {
            name: {
              th: 'จอมทอง',
              en: 'Chom Thong',
            },
            zipcode: '65000',
          },
          650113: {
            name: {
              th: 'บ้านกร่าง',
              en: 'Ban Krang',
            },
            zipcode: '65000',
          },
          650114: {
            name: {
              th: 'บ้านคลอง',
              en: 'Ban Khlong',
            },
            zipcode: '65000',
          },
          650115: {
            name: {
              th: 'พลายชุมพล',
              en: 'Phlai Chumphon',
            },
            zipcode: '65000',
          },
          650116: {
            name: {
              th: 'มะขามสูง',
              en: 'Makham Sung',
            },
            zipcode: '65000',
          },
          650117: {
            name: {
              th: 'อรัญญิก',
              en: 'Aranyik',
            },
            zipcode: '65000',
          },
          650118: {
            name: {
              th: 'บึงพระ',
              en: 'Bueng Phra',
            },
            zipcode: '65000',
          },
          650119: {
            name: {
              th: 'ไผ่ขอดอน',
              en: 'Phai Kho Don',
            },
            zipcode: '65000',
          },
          650120: {
            name: {
              th: 'งิ้วงาม',
              en: 'Ngio Ngam',
            },
            zipcode: '65230',
          },
        },
      },
      6502: {
        name: {
          th: 'นครไทย',
          en: 'Nakhon Thai',
        },
        tambons: {
          650201: {
            name: {
              th: 'นครไทย',
              en: 'Nakhon Thai',
            },
            zipcode: '65120',
          },
          650202: {
            name: {
              th: 'หนองกะท้าว',
              en: 'Nong Kathao',
            },
            zipcode: '65120',
          },
          650203: {
            name: {
              th: 'บ้านแยง',
              en: 'Ban Yaeng',
            },
            zipcode: '65120',
          },
          650204: {
            name: {
              th: 'เนินเพิ่ม',
              en: 'Noen Phoem',
            },
            zipcode: '65120',
          },
          650205: {
            name: {
              th: 'นาบัว',
              en: 'Na Bua',
            },
            zipcode: '65120',
          },
          650206: {
            name: {
              th: 'นครชุม',
              en: 'Nakhon Chum',
            },
            zipcode: '65120',
          },
          650207: {
            name: {
              th: 'น้ำกุ่ม',
              en: 'Nam Kum',
            },
            zipcode: '65120',
          },
          650208: {
            name: {
              th: 'ยางโกลน',
              en: 'Yang Klon',
            },
            zipcode: '65120',
          },
          650209: {
            name: {
              th: 'บ่อโพธิ์',
              en: 'Bo Pho',
            },
            zipcode: '65120',
          },
          650210: {
            name: {
              th: 'บ้านพร้าว',
              en: 'Ban Phrao',
            },
            zipcode: '65120',
          },
          650211: {
            name: {
              th: 'ห้วยเฮี้ย',
              en: 'Huai Hia',
            },
            zipcode: '65120',
          },
        },
      },
      6503: {
        name: {
          th: 'ชาติตระการ',
          en: 'Chat Trakan',
        },
        tambons: {
          650301: {
            name: {
              th: 'ป่าแดง',
              en: 'Pa Daeng',
            },
            zipcode: '65170',
          },
          650302: {
            name: {
              th: 'ชาติตระการ',
              en: 'Chat Trakan',
            },
            zipcode: '65170',
          },
          650303: {
            name: {
              th: 'สวนเมี่ยง',
              en: 'Suan Miang',
            },
            zipcode: '65170',
          },
          650304: {
            name: {
              th: 'บ้านดง',
              en: 'Ban Dong',
            },
            zipcode: '65170',
          },
          650305: {
            name: {
              th: 'บ่อภาค',
              en: 'Bo Phak',
            },
            zipcode: '65170',
          },
          650306: {
            name: {
              th: 'ท่าสะแก',
              en: 'Tha Sakae',
            },
            zipcode: '65170',
          },
        },
      },
      6504: {
        name: {
          th: 'บางระกำ',
          en: 'Bang Rakam',
        },
        tambons: {
          650401: {
            name: {
              th: 'บางระกำ',
              en: 'Bang Rakam',
            },
            zipcode: '65140',
          },
          650402: {
            name: {
              th: 'ปลักแรด',
              en: 'Plak Raet',
            },
            zipcode: '65140',
          },
          650403: {
            name: {
              th: 'พันเสา',
              en: 'Phan Sao',
            },
            zipcode: '65140',
          },
          650404: {
            name: {
              th: 'วังอิทก',
              en: 'Wang Ithok',
            },
            zipcode: '65140',
          },
          650405: {
            name: {
              th: 'บึงกอก',
              en: 'Bueng Kok',
            },
            zipcode: '65140',
          },
          650406: {
            name: {
              th: 'หนองกุลา',
              en: 'Nong Kula',
            },
            zipcode: '65140',
          },
          650407: {
            name: {
              th: 'ชุมแสงสงคราม',
              en: 'Chum Saeng Songkhram',
            },
            zipcode: '65240',
          },
          650408: {
            name: {
              th: 'นิคมพัฒนา',
              en: 'Nikhom Phatthana',
            },
            zipcode: '65140',
          },
          650409: {
            name: {
              th: 'บ่อทอง',
              en: 'Bo Thong',
            },
            zipcode: '65140',
          },
          650410: {
            name: {
              th: 'ท่านางงาม',
              en: 'Tha Nang Ngam',
            },
            zipcode: '65140',
          },
          650411: {
            name: {
              th: 'คุยม่วง',
              en: 'Khui Muang',
            },
            zipcode: '65240',
          },
        },
      },
      6505: {
        name: {
          th: 'บางกระทุ่ม',
          en: 'Bang Krathum',
        },
        tambons: {
          650501: {
            name: {
              th: 'บางกระทุ่ม',
              en: 'Bang Krathum',
            },
            zipcode: '65110',
          },
          650502: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '65110',
          },
          650503: {
            name: {
              th: 'โคกสลุด',
              en: 'Khok Salut',
            },
            zipcode: '65110',
          },
          650504: {
            name: {
              th: 'สนามคลี',
              en: 'Sanam Khli',
            },
            zipcode: '65110',
          },
          650505: {
            name: {
              th: 'ท่าตาล',
              en: 'Tha Tan',
            },
            zipcode: '65110',
          },
          650506: {
            name: {
              th: 'ไผ่ล้อม',
              en: 'Phai Lom',
            },
            zipcode: '65110',
          },
          650507: {
            name: {
              th: 'นครป่าหมาก',
              en: 'Nakhon Pa Mak',
            },
            zipcode: '65110',
          },
          650508: {
            name: {
              th: 'เนินกุ่ม',
              en: 'Noen Kum',
            },
            zipcode: '65210',
          },
          650509: {
            name: {
              th: 'วัดตายม',
              en: 'Wat Ta Yom',
            },
            zipcode: '65210',
          },
        },
      },
      6506: {
        name: {
          th: 'พรหมพิราม',
          en: 'Phrom Phiram',
        },
        tambons: {
          650601: {
            name: {
              th: 'พรหมพิราม',
              en: 'Phrom Phiram',
            },
            zipcode: '65150',
          },
          650602: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '65150',
          },
          650603: {
            name: {
              th: 'วงฆ้อง',
              en: 'Wong Khong',
            },
            zipcode: '65180',
          },
          650604: {
            name: {
              th: 'มะตูม',
              en: 'Mathum',
            },
            zipcode: '65150',
          },
          650605: {
            name: {
              th: 'หอกลอง',
              en: 'Ho Khlong',
            },
            zipcode: '65150',
          },
          650606: {
            name: {
              th: 'ศรีภิรมย์',
              en: 'Sri Phirom',
            },
            zipcode: '65180',
          },
          650607: {
            name: {
              th: 'ตลุกเทียม',
              en: 'Taluk Thiam',
            },
            zipcode: '65180',
          },
          650608: {
            name: {
              th: 'วังวน',
              en: 'Wang Won',
            },
            zipcode: '65150',
          },
          650609: {
            name: {
              th: 'หนองแขม',
              en: 'Nong Khaem',
            },
            zipcode: '65150',
          },
          650610: {
            name: {
              th: 'มะต้อง',
              en: 'Mathong',
            },
            zipcode: '65180',
          },
          650611: {
            name: {
              th: 'ทับยายเชียง',
              en: 'Thap Yai Chiang',
            },
            zipcode: '65150',
          },
          650612: {
            name: {
              th: 'ดงประคำ',
              en: 'Dong Prakham',
            },
            zipcode: '65180',
          },
        },
      },
      6507: {
        name: {
          th: 'วัดโบสถ์',
          en: 'Wat Bot',
        },
        tambons: {
          650701: {
            name: {
              th: 'วัดโบสถ์',
              en: 'Wat Bot',
            },
            zipcode: '65160',
          },
          650702: {
            name: {
              th: 'ท่างาม',
              en: 'Tha Ngam',
            },
            zipcode: '65160',
          },
          650703: {
            name: {
              th: 'ท้อแท้',
              en: 'Thothae',
            },
            zipcode: '65160',
          },
          650704: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '65160',
          },
          650705: {
            name: {
              th: 'หินลาด',
              en: 'Hin Lat',
            },
            zipcode: '65160',
          },
          650706: {
            name: {
              th: 'คันโช้ง',
              en: 'Khan Chong',
            },
            zipcode: '65160',
          },
        },
      },
      6508: {
        name: {
          th: 'วังทอง',
          en: 'Wang Thong',
        },
        tambons: {
          650801: {
            name: {
              th: 'วังทอง',
              en: 'Wang Thong',
            },
            zipcode: '65130',
          },
          650802: {
            name: {
              th: 'พันชาลี',
              en: 'Phan Chali',
            },
            zipcode: '65130',
          },
          650803: {
            name: {
              th: 'แม่ระกา',
              en: 'Mae Raka',
            },
            zipcode: '65130',
          },
          650804: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '65220',
          },
          650805: {
            name: {
              th: 'วังพิกุล',
              en: 'Wang Phikun',
            },
            zipcode: '65130',
          },
          650806: {
            name: {
              th: 'แก่งโสภา',
              en: 'Kaeng Sopha',
            },
            zipcode: '65220',
          },
          650807: {
            name: {
              th: 'ท่าหมื่นราม',
              en: 'Tha Muen Ram',
            },
            zipcode: '65130',
          },
          650808: {
            name: {
              th: 'วังนกแอ่น',
              en: 'Wang Nok Aen',
            },
            zipcode: '65130',
          },
          650809: {
            name: {
              th: 'หนองพระ',
              en: 'Nong Phra',
            },
            zipcode: '65130',
          },
          650810: {
            name: {
              th: 'ชัยนาม',
              en: 'Chaiyanam',
            },
            zipcode: '65130',
          },
          650811: {
            name: {
              th: 'ดินทอง',
              en: 'Din Thong',
            },
            zipcode: '65130',
          },
        },
      },
      6509: {
        name: {
          th: 'เนินมะปราง',
          en: 'Noen Maprang',
        },
        tambons: {
          650901: {
            name: {
              th: 'ชมพู',
              en: 'Chomphu',
            },
            zipcode: '65190',
          },
          650902: {
            name: {
              th: 'บ้านมุง',
              en: 'Ban Mung',
            },
            zipcode: '65190',
          },
          650903: {
            name: {
              th: 'ไทรย้อย',
              en: 'Sai Yoi',
            },
            zipcode: '65190',
          },
          650904: {
            name: {
              th: 'วังโพรง',
              en: 'Wang Phrong',
            },
            zipcode: '65190',
          },
          650905: {
            name: {
              th: 'บ้านน้อยซุ้มขี้เหล็ก',
              en: 'Ban Noi Sum Khilek',
            },
            zipcode: '65190',
          },
          650906: {
            name: {
              th: 'เนินมะปราง',
              en: 'Noen Maprang',
            },
            zipcode: '65190',
          },
          650907: {
            name: {
              th: 'วังยาง',
              en: 'Wang Yang',
            },
            zipcode: '65190',
          },
          650908: {
            name: {
              th: 'โคกแหลม',
              en: 'Khok Laem',
            },
            zipcode: '65190',
          },
        },
      },
    },
  },
  66: {
    name: {
      th: 'พิจิตร',
      en: 'Phichit',
    },
    amphoes: {
      6601: {
        name: {
          th: 'เมืองพิจิตร',
          en: 'Muang',
        },
        tambons: {
          660101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '66000',
          },
          660102: {
            name: {
              th: 'ไผ่ขวาง',
              en: 'Phai Khwang',
            },
            zipcode: '66000',
          },
          660103: {
            name: {
              th: 'ย่านยาว',
              en: 'Yan Yao',
            },
            zipcode: '66000',
          },
          660104: {
            name: {
              th: 'ท่าฬ่อ',
              en: 'Tha Lo',
            },
            zipcode: '66000',
          },
          660105: {
            name: {
              th: 'ปากทาง',
              en: 'Pak Thang',
            },
            zipcode: '66000',
          },
          660106: {
            name: {
              th: 'คลองคะเชนทร์',
              en: 'Khlong Khachen',
            },
            zipcode: '66000',
          },
          660107: {
            name: {
              th: 'โรงช้าง',
              en: 'Rong Chang',
            },
            zipcode: '66000',
          },
          660108: {
            name: {
              th: 'เมืองเก่า',
              en: 'Mueang Kao',
            },
            zipcode: '66000',
          },
          660109: {
            name: {
              th: 'ท่าหลวง',
              en: 'Tha Luang',
            },
            zipcode: '66000',
          },
          660110: {
            name: {
              th: 'บ้านบุ่ง',
              en: 'Ban Bung',
            },
            zipcode: '66000',
          },
          660111: {
            name: {
              th: 'ฆะมัง',
              en: 'Kha Mang',
            },
            zipcode: '66000',
          },
          660112: {
            name: {
              th: 'ดงป่าคำ',
              en: 'Dong Pa Kham',
            },
            zipcode: '66170',
          },
          660113: {
            name: {
              th: 'หัวดง',
              en: 'Hua Dong',
            },
            zipcode: '66170',
          },
          660115: {
            name: {
              th: 'ป่ามะคาบ',
              en: 'Pa Makhap',
            },
            zipcode: '66000',
          },
          660119: {
            name: {
              th: 'สายคำโห้',
              en: 'Sai Kham Ho',
            },
            zipcode: '66000',
          },
          660120: {
            name: {
              th: 'ดงกลาง',
              en: 'Dong Klang',
            },
            zipcode: '66170',
          },
        },
      },
      6602: {
        name: {
          th: 'วังทรายพูน',
          en: 'Wang Sai Phun',
        },
        tambons: {
          660201: {
            name: {
              th: 'วังทรายพูน',
              en: 'Wang Sai Phun',
            },
            zipcode: '66180',
          },
          660202: {
            name: {
              th: 'หนองปลาไหล',
              en: 'Nong Pla Lai',
            },
            zipcode: '66180',
          },
          660203: {
            name: {
              th: 'หนองพระ',
              en: 'Nong Phra',
            },
            zipcode: '66180',
          },
          660204: {
            name: {
              th: 'หนองปล้อง',
              en: 'Nong Plong',
            },
            zipcode: '66180',
          },
        },
      },
      6603: {
        name: {
          th: 'โพธิ์ประทับช้าง',
          en: 'Pho Prathap Chang',
        },
        tambons: {
          660301: {
            name: {
              th: 'โพธิ์ประทับช้าง',
              en: 'Pho Prathap Chang',
            },
            zipcode: '66190',
          },
          660302: {
            name: {
              th: 'ไผ่ท่าโพ',
              en: 'Phai Tha Pho',
            },
            zipcode: '66190',
          },
          660303: {
            name: {
              th: 'วังจิก',
              en: 'Wang Chik',
            },
            zipcode: '66190',
          },
          660304: {
            name: {
              th: 'ไผ่รอบ',
              en: 'Phai Rop',
            },
            zipcode: '66190',
          },
          660305: {
            name: {
              th: 'ดงเสือเหลือง',
              en: 'Dong Suea Lueang',
            },
            zipcode: '66190',
          },
          660306: {
            name: {
              th: 'เนินสว่าง',
              en: 'Noen Sawang',
            },
            zipcode: '66190',
          },
          660307: {
            name: {
              th: 'ทุ่งใหญ่',
              en: 'Thung Yai',
            },
            zipcode: '66190',
          },
        },
      },
      6604: {
        name: {
          th: 'ตะพานหิน',
          en: 'Taphan Hin',
        },
        tambons: {
          660401: {
            name: {
              th: 'ตะพานหิน',
              en: 'Taphan Hin',
            },
            zipcode: '66110',
          },
          660402: {
            name: {
              th: 'งิ้วราย',
              en: 'Ngio Rai',
            },
            zipcode: '66110',
          },
          660403: {
            name: {
              th: 'ห้วยเกตุ',
              en: 'Huai Ket',
            },
            zipcode: '66110',
          },
          660404: {
            name: {
              th: 'ไทรโรงโขน',
              en: 'Sai Rong Khon',
            },
            zipcode: '66110',
          },
          660405: {
            name: {
              th: 'หนองพยอม',
              en: 'Nong Phayom',
            },
            zipcode: '66110',
          },
          660406: {
            name: {
              th: 'ทุ่งโพธิ์',
              en: 'Thung Pho',
            },
            zipcode: '66150',
          },
          660407: {
            name: {
              th: 'ดงตะขบ',
              en: 'Dong Takhop',
            },
            zipcode: '66110',
          },
          660408: {
            name: {
              th: 'คลองคูณ',
              en: 'Khlong Khun',
            },
            zipcode: '66110',
          },
          660409: {
            name: {
              th: 'วังสำโรง',
              en: 'Wang Samrong',
            },
            zipcode: '66110',
          },
          660410: {
            name: {
              th: 'วังหว้า',
              en: 'Wang Wa',
            },
            zipcode: '66110',
          },
          660411: {
            name: {
              th: 'วังหลุม',
              en: 'Wang Lum',
            },
            zipcode: '66150',
          },
          660412: {
            name: {
              th: 'ทับหมัน',
              en: 'Thap Man',
            },
            zipcode: '66110',
          },
          660413: {
            name: {
              th: 'ไผ่หลวง',
              en: 'Phai Luang',
            },
            zipcode: '66110',
          },
        },
      },
      6605: {
        name: {
          th: 'บางมูลนาก',
          en: 'Bang Mun Nak',
        },
        tambons: {
          660501: {
            name: {
              th: 'บางมูลนาก',
              en: 'Bang Mun Nak',
            },
            zipcode: '66120',
          },
          660502: {
            name: {
              th: 'บางไผ่',
              en: 'Bang Phai',
            },
            zipcode: '66120',
          },
          660503: {
            name: {
              th: 'หอไกร',
              en: 'Ho Krai',
            },
            zipcode: '66120',
          },
          660504: {
            name: {
              th: 'เนินมะกอก',
              en: 'Noen Makok',
            },
            zipcode: '66120',
          },
          660505: {
            name: {
              th: 'วังสำโรง',
              en: 'Wang Samrong',
            },
            zipcode: '66120',
          },
          660506: {
            name: {
              th: 'ภูมิ',
              en: 'Bang Mun Nak',
            },
            zipcode: '66120',
          },
          660507: {
            name: {
              th: 'วังกรด',
              en: 'Wang Krot',
            },
            zipcode: '66120',
          },
          660508: {
            name: {
              th: 'ห้วยเขน',
              en: 'Huai Khen',
            },
            zipcode: '66120',
          },
          660509: {
            name: {
              th: 'วังตะกู',
              en: 'Wang Taku',
            },
            zipcode: '66210',
          },
          660514: {
            name: {
              th: 'ลำประดา',
              en: 'Lam Prada',
            },
            zipcode: '66120',
          },
        },
      },
      6606: {
        name: {
          th: 'โพทะเล',
          en: 'Pho Thalae',
        },
        tambons: {
          660601: {
            name: {
              th: 'โพทะเล',
              en: 'Pho Thale',
            },
            zipcode: '66130',
          },
          660602: {
            name: {
              th: 'ท้ายน้ำ',
              en: 'Thai Nam',
            },
            zipcode: '66130',
          },
          660603: {
            name: {
              th: 'ทะนง',
              en: 'Thanong',
            },
            zipcode: '66130',
          },
          660604: {
            name: {
              th: 'ท่าบัว',
              en: 'Tha Bua',
            },
            zipcode: '66130',
          },
          660605: {
            name: {
              th: 'ทุ่งน้อย',
              en: 'Thung Noi',
            },
            zipcode: '66130',
          },
          660606: {
            name: {
              th: 'ท่าขมิ้น',
              en: 'Tha Khamin',
            },
            zipcode: '66130',
          },
          660607: {
            name: {
              th: 'ท่าเสา',
              en: 'Tha Sao',
            },
            zipcode: '66130',
          },
          660608: {
            name: {
              th: 'บางคลาน',
              en: 'Bang Khlan',
            },
            zipcode: '66130',
          },
          660611: {
            name: {
              th: 'ท่านั่ง',
              en: 'Tha Nang',
            },
            zipcode: '66130',
          },
          660612: {
            name: {
              th: 'บ้านน้อย',
              en: 'Ban Noi',
            },
            zipcode: '66130',
          },
          660613: {
            name: {
              th: 'วัดขวาง',
              en: 'Wat Khwang',
            },
            zipcode: '66130',
          },
        },
      },
      6607: {
        name: {
          th: 'สามง่าม',
          en: 'Sam Ngam',
        },
        tambons: {
          660701: {
            name: {
              th: 'สามง่าม',
              en: 'Sam Ngam',
            },
            zipcode: '66140',
          },
          660702: {
            name: {
              th: 'กำแพงดิน',
              en: 'Kamphaeng Din',
            },
            zipcode: '66140',
          },
          660703: {
            name: {
              th: 'รังนก',
              en: 'Rang Nok',
            },
            zipcode: '66140',
          },
          660706: {
            name: {
              th: 'เนินปอ',
              en: 'Noen Po',
            },
            zipcode: '66140',
          },
          660707: {
            name: {
              th: 'หนองโสน',
              en: 'Nong Sano',
            },
            zipcode: '66140',
          },
        },
      },
      6608: {
        name: {
          th: 'ทับคล้อ',
          en: 'Thap Khlo',
        },
        tambons: {
          660801: {
            name: {
              th: 'ทับคล้อ',
              en: 'Thap Khlo',
            },
            zipcode: '66150',
          },
          660802: {
            name: {
              th: 'เขาทราย',
              en: 'Khao Sai',
            },
            zipcode: '66230',
          },
          660803: {
            name: {
              th: 'เขาเจ็ดลูก',
              en: 'Khao Chet Luk',
            },
            zipcode: '66230',
          },
          660804: {
            name: {
              th: 'ท้ายทุ่ง',
              en: 'Thai Thung',
            },
            zipcode: '66150',
          },
        },
      },
      6609: {
        name: {
          th: 'สากเหล็ก',
          en: 'King Amphoe Sak Lek',
        },
        tambons: {
          660901: {
            name: {
              th: 'สากเหล็ก',
              en: 'Sak Lek',
            },
            zipcode: '66160',
          },
          660902: {
            name: {
              th: 'ท่าเยี่ยม',
              en: 'Tha Yiam',
            },
            zipcode: '66160',
          },
          660903: {
            name: {
              th: 'คลองทราย',
              en: 'Khlong Sai',
            },
            zipcode: '66160',
          },
          660904: {
            name: {
              th: 'หนองหญ้าไทร',
              en: 'Nong Ya Sai',
            },
            zipcode: '66160',
          },
          660905: {
            name: {
              th: 'วังทับไทร',
              en: 'Wang Thap Sai',
            },
            zipcode: '66160',
          },
        },
      },
      6610: {
        name: {
          th: 'บึงนาราง',
          en: 'Bung Narang',
        },
        tambons: {
          661001: {
            name: {
              th: 'ห้วยแก้ว',
              en: 'Huai Kaeo',
            },
            zipcode: '66130',
          },
          661002: {
            name: {
              th: 'โพธิ์ไทรงาม',
              en: 'Pho Sai Ngam',
            },
            zipcode: '66130',
          },
          661003: {
            name: {
              th: 'แหลมรัง',
              en: 'Laem Rang',
            },
            zipcode: '66130',
          },
          661004: {
            name: {
              th: 'บางลาย',
              en: 'Bang Lai',
            },
            zipcode: '66130',
          },
          661005: {
            name: {
              th: 'บึงนาราง',
              en: 'Bueng Na Rang',
            },
            zipcode: '66130',
          },
        },
      },
      6611: {
        name: {
          th: 'ดงเจริญ',
          en: 'Dong Charoen',
        },
        tambons: {
          661101: {
            name: {
              th: 'วังงิ้วใต้',
              en: 'Wang Ngio Tai',
            },
            zipcode: '66210',
          },
          661102: {
            name: {
              th: 'วังงิ้ว',
              en: 'Wang Ngio',
            },
            zipcode: '66210',
          },
          661103: {
            name: {
              th: 'ห้วยร่วม',
              en: 'Huai Ruam',
            },
            zipcode: '66210',
          },
          661104: {
            name: {
              th: 'ห้วยพุก',
              en: 'Huai Phuk',
            },
            zipcode: '66210',
          },
          661105: {
            name: {
              th: 'สำนักขุนเณร',
              en: 'Samnak Khun Nen',
            },
            zipcode: '66210',
          },
        },
      },
      6612: {
        name: {
          th: 'วชิรบารมี',
          en: 'Wachirabarami',
        },
        tambons: {
          661201: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '66140',
          },
          661202: {
            name: {
              th: 'บึงบัว',
              en: 'Bueng Bua',
            },
            zipcode: '66140',
          },
          661203: {
            name: {
              th: 'วังโมกข์',
              en: 'Wang Mok',
            },
            zipcode: '66140',
          },
          661204: {
            name: {
              th: 'หนองหลุม',
              en: 'Nong Lum',
            },
            zipcode: '66220',
          },
        },
      },
    },
  },
  67: {
    name: {
      th: 'เพชรบูรณ์',
      en: 'Phetchabun',
    },
    amphoes: {
      6701: {
        name: {
          th: 'เมืองเพชรบูรณ์',
          en: 'Muang',
        },
        tambons: {
          670101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '67000',
          },
          670102: {
            name: {
              th: 'ตะเบาะ',
              en: 'Tabo',
            },
            zipcode: '67000',
          },
          670103: {
            name: {
              th: 'บ้านโตก',
              en: 'Ban Tok',
            },
            zipcode: '67000',
          },
          670104: {
            name: {
              th: 'สะเดียง',
              en: 'Sadiang',
            },
            zipcode: '67000',
          },
          670105: {
            name: {
              th: 'ป่าเลา',
              en: 'Pa Lao',
            },
            zipcode: '67000',
          },
          670106: {
            name: {
              th: 'นางั่ว',
              en: 'Na Ngua',
            },
            zipcode: '67000',
          },
          670107: {
            name: {
              th: 'ท่าพล',
              en: 'Tha Phon',
            },
            zipcode: '67250',
          },
          670108: {
            name: {
              th: 'ดงมูลเหล็ก',
              en: 'Dong Mun Lek',
            },
            zipcode: '67000',
          },
          670109: {
            name: {
              th: 'บ้านโคก',
              en: 'Ban Khok',
            },
            zipcode: '67000',
          },
          670110: {
            name: {
              th: 'ชอนไพร',
              en: 'Chon Phrai',
            },
            zipcode: '67000',
          },
          670111: {
            name: {
              th: 'นาป่า',
              en: 'Na Pa',
            },
            zipcode: '67000',
          },
          670112: {
            name: {
              th: 'นายม',
              en: 'Na Yom',
            },
            zipcode: '67210',
          },
          670113: {
            name: {
              th: 'วังชมภู',
              en: 'Wang Chomphu',
            },
            zipcode: '67210',
          },
          670114: {
            name: {
              th: 'น้ำร้อน',
              en: 'Nam Ron',
            },
            zipcode: '67000',
          },
          670115: {
            name: {
              th: 'ห้วยสะแก',
              en: 'Huai Sakae',
            },
            zipcode: '67210',
          },
          670116: {
            name: {
              th: 'ห้วยใหญ่',
              en: 'Huai Yai',
            },
            zipcode: '67000',
          },
          670117: {
            name: {
              th: 'ระวิง',
              en: 'Rawing',
            },
            zipcode: '67210',
          },
        },
      },
      6702: {
        name: {
          th: 'ชนแดน',
          en: 'Chon Daen',
        },
        tambons: {
          670201: {
            name: {
              th: 'ชนแดน',
              en: 'Chon Daen',
            },
            zipcode: '67150',
          },
          670202: {
            name: {
              th: 'ดงขุย',
              en: 'Dong Khui',
            },
            zipcode: '67190',
          },
          670203: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '67150',
          },
          670204: {
            name: {
              th: 'พุทธบาท',
              en: 'Phutthabat',
            },
            zipcode: '67150',
          },
          670205: {
            name: {
              th: 'ลาดแค',
              en: 'Lat Khae',
            },
            zipcode: '67150',
          },
          670206: {
            name: {
              th: 'บ้านกล้วย',
              en: 'Ban Kluai',
            },
            zipcode: '67190',
          },
          670208: {
            name: {
              th: 'ซับพุทรา',
              en: 'Sap Phutsa',
            },
            zipcode: '67150',
          },
          670209: {
            name: {
              th: 'ตะกุดไร',
              en: 'Takut Rai',
            },
            zipcode: '67190',
          },
          670210: {
            name: {
              th: 'ศาลาลาย',
              en: 'Sala Lai',
            },
            zipcode: '67150',
          },
        },
      },
      6703: {
        name: {
          th: 'หล่มสัก',
          en: 'Lom Sak',
        },
        tambons: {
          670301: {
            name: {
              th: 'หล่มสัก',
              en: 'Lom Sak',
            },
            zipcode: '67110',
          },
          670302: {
            name: {
              th: 'วัดป่า',
              en: 'Wat Pa',
            },
            zipcode: '67110',
          },
          670303: {
            name: {
              th: 'ตาลเดี่ยว',
              en: 'Tan Diao',
            },
            zipcode: '67110',
          },
          670304: {
            name: {
              th: 'ฝายนาแซง',
              en: 'Fai Na Saeng',
            },
            zipcode: '67110',
          },
          670305: {
            name: {
              th: 'หนองสว่าง',
              en: 'Nong Sawan',
            },
            zipcode: '67110',
          },
          670306: {
            name: {
              th: 'น้ำเฮี้ย',
              en: 'Nam Hia',
            },
            zipcode: '67110',
          },
          670307: {
            name: {
              th: 'สักหลง',
              en: 'Sak Long',
            },
            zipcode: '67110',
          },
          670308: {
            name: {
              th: 'ท่าอิบุญ',
              en: 'Tha Ibun',
            },
            zipcode: '67110',
          },
          670309: {
            name: {
              th: 'บ้านโสก',
              en: 'Ban Sok',
            },
            zipcode: '67110',
          },
          670310: {
            name: {
              th: 'บ้านติ้ว',
              en: 'Ban Tio',
            },
            zipcode: '67110',
          },
          670311: {
            name: {
              th: 'ห้วยไร่',
              en: 'Huai Rai',
            },
            zipcode: '67110',
          },
          670312: {
            name: {
              th: 'น้ำก้อ',
              en: 'Nam Ko',
            },
            zipcode: '67110',
          },
          670313: {
            name: {
              th: 'ปากช่อง',
              en: 'Pak Chong',
            },
            zipcode: '67110',
          },
          670314: {
            name: {
              th: 'น้ำชุน',
              en: 'Nam Chun',
            },
            zipcode: '67110',
          },
          670315: {
            name: {
              th: 'หนองไขว่',
              en: 'Nong Khwai',
            },
            zipcode: '67110',
          },
          670316: {
            name: {
              th: 'ลานบ่า',
              en: 'Lan Ba',
            },
            zipcode: '67110',
          },
          670317: {
            name: {
              th: 'บุ่งคล้า',
              en: 'Bung Khla',
            },
            zipcode: '67110',
          },
          670318: {
            name: {
              th: 'บุ่งน้ำเต้า',
              en: 'Bung Namtao',
            },
            zipcode: '67110',
          },
          670319: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '67110',
          },
          670320: {
            name: {
              th: 'ช้างตะลูด',
              en: 'Chang Talut',
            },
            zipcode: '67110',
          },
          670321: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '67110',
          },
          670322: {
            name: {
              th: 'ปากดุก',
              en: 'Pak Duk',
            },
            zipcode: '67110',
          },
          670323: {
            name: {
              th: 'บ้านหวาย',
              en: 'Ban Wai',
            },
            zipcode: '67110',
          },
        },
      },
      6704: {
        name: {
          th: 'หล่มเก่า',
          en: 'Lom Kao',
        },
        tambons: {
          670401: {
            name: {
              th: 'หล่มเก่า',
              en: 'Lom Kao',
            },
            zipcode: '67120',
          },
          670402: {
            name: {
              th: 'นาซำ',
              en: 'Na Sam',
            },
            zipcode: '67120',
          },
          670403: {
            name: {
              th: 'หินฮาว',
              en: 'Hin Hao',
            },
            zipcode: '67120',
          },
          670404: {
            name: {
              th: 'บ้านเนิน',
              en: 'Ban Noen',
            },
            zipcode: '67120',
          },
          670405: {
            name: {
              th: 'ศิลา',
              en: 'Sila',
            },
            zipcode: '67120',
          },
          670406: {
            name: {
              th: 'นาแซง',
              en: 'Na Saeng',
            },
            zipcode: '67120',
          },
          670407: {
            name: {
              th: 'วังบาล',
              en: 'Wang Ban',
            },
            zipcode: '67120',
          },
          670408: {
            name: {
              th: 'นาเกาะ',
              en: 'Na Ko',
            },
            zipcode: '67120',
          },
          670409: {
            name: {
              th: 'ตาดกลอย',
              en: 'Tat Kloi',
            },
            zipcode: '67120',
          },
        },
      },
      6705: {
        name: {
          th: 'วิเชียรบุรี',
          en: 'Wichain Buri',
        },
        tambons: {
          670501: {
            name: {
              th: 'ท่าโรง',
              en: 'Tha Rong',
            },
            zipcode: '67130',
          },
          670502: {
            name: {
              th: 'สระประดู่',
              en: 'Sa Pradu',
            },
            zipcode: '67130',
          },
          670503: {
            name: {
              th: 'สามแยก',
              en: 'Sam Yaek',
            },
            zipcode: '67130',
          },
          670504: {
            name: {
              th: 'โคกปรง',
              en: 'Khok Prong',
            },
            zipcode: '67130',
          },
          670505: {
            name: {
              th: 'น้ำร้อน',
              en: 'Nam Ron',
            },
            zipcode: '67130',
          },
          670506: {
            name: {
              th: 'บ่อรัง',
              en: 'Bo Rang',
            },
            zipcode: '67130',
          },
          670507: {
            name: {
              th: 'พุเตย',
              en: 'Phu Toei',
            },
            zipcode: '67180',
          },
          670508: {
            name: {
              th: 'พุขาม',
              en: 'Phu Kham',
            },
            zipcode: '67180',
          },
          670509: {
            name: {
              th: 'ภูน้ำหยด',
              en: 'Phu Nam Yot',
            },
            zipcode: '67180',
          },
          670510: {
            name: {
              th: 'ซับสมบูรณ์',
              en: 'Sab Sombun',
            },
            zipcode: '67180',
          },
          670511: {
            name: {
              th: 'บึงกระจับ',
              en: 'Bueng Krachap',
            },
            zipcode: '67130',
          },
          670512: {
            name: {
              th: 'วังใหญ่',
              en: 'Wang Yai',
            },
            zipcode: '67180',
          },
          670513: {
            name: {
              th: 'ยางสาว',
              en: 'Yang Sao',
            },
            zipcode: '67130',
          },
          670514: {
            name: {
              th: 'ซับน้อย',
              en: 'Sap Noi',
            },
            zipcode: '67180',
          },
        },
      },
      6706: {
        name: {
          th: 'ศรีเทพ',
          en: 'Si Thap',
        },
        tambons: {
          670601: {
            name: {
              th: 'ศรีเทพ',
              en: 'Si Thep',
            },
            zipcode: '67170',
          },
          670602: {
            name: {
              th: 'สระกรวด',
              en: 'Sa Kruat',
            },
            zipcode: '67170',
          },
          670603: {
            name: {
              th: 'คลองกระจัง',
              en: 'Khlong Krachang',
            },
            zipcode: '67170',
          },
          670604: {
            name: {
              th: 'นาสนุ่น',
              en: 'Na Sanun',
            },
            zipcode: '67170',
          },
          670605: {
            name: {
              th: 'โคกสะอาด',
              en: 'Khok Sa-at',
            },
            zipcode: '67170',
          },
          670606: {
            name: {
              th: 'หนองย่างทอย',
              en: 'Nong Yang Thoi',
            },
            zipcode: '67170',
          },
          670607: {
            name: {
              th: 'ประดู่งาม',
              en: 'Pradu Ngam',
            },
            zipcode: '67170',
          },
        },
      },
      6707: {
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        tambons: {
          670701: {
            name: {
              th: 'กองทูล',
              en: 'Kong Thun',
            },
            zipcode: '67140',
          },
          670702: {
            name: {
              th: 'นาเฉลียง',
              en: 'Na Chaliang',
            },
            zipcode: '67220',
          },
          670703: {
            name: {
              th: 'บ้านโภชน์',
              en: 'Ban Phot',
            },
            zipcode: '67140',
          },
          670704: {
            name: {
              th: 'ท่าแดง',
              en: 'Tha Daeng',
            },
            zipcode: '67140',
          },
          670705: {
            name: {
              th: 'เพชรละคร',
              en: 'Phet Lakhon',
            },
            zipcode: '67140',
          },
          670706: {
            name: {
              th: 'บ่อไทย',
              en: 'Bo Thai',
            },
            zipcode: '67140',
          },
          670707: {
            name: {
              th: 'ห้วยโป่ง',
              en: 'Huai Pong',
            },
            zipcode: '67220',
          },
          670708: {
            name: {
              th: 'วังท่าดี',
              en: 'Wang Tha Di',
            },
            zipcode: '67140',
          },
          670709: {
            name: {
              th: 'บัววัฒนา',
              en: 'Bua Watthana',
            },
            zipcode: '67140',
          },
          670710: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '67140',
          },
          670711: {
            name: {
              th: 'วังโบสถ์',
              en: 'Wang Bot',
            },
            zipcode: '67140',
          },
          670712: {
            name: {
              th: 'ยางงาม',
              en: 'Yang Ngam',
            },
            zipcode: '67220',
          },
          670713: {
            name: {
              th: 'ท่าด้วง',
              en: 'Tha Duang',
            },
            zipcode: '67140',
          },
        },
      },
      6708: {
        name: {
          th: 'บึงสามพัน',
          en: 'Bung Sam Phan',
        },
        tambons: {
          670801: {
            name: {
              th: 'ซับสมอทอด',
              en: 'Sap Samo Thot',
            },
            zipcode: '67160',
          },
          670802: {
            name: {
              th: 'ซับไม้แดง',
              en: 'Sap Mai Daeng',
            },
            zipcode: '67160',
          },
          670803: {
            name: {
              th: 'หนองแจง',
              en: 'Nong Chaeng',
            },
            zipcode: '67160',
          },
          670804: {
            name: {
              th: 'กันจุ',
              en: 'Kan Chu',
            },
            zipcode: '67160',
          },
          670805: {
            name: {
              th: 'วังพิกุล',
              en: 'Wang Phikun',
            },
            zipcode: '67230',
          },
          670806: {
            name: {
              th: 'พญาวัง',
              en: 'Phaya Wang',
            },
            zipcode: '67160',
          },
          670807: {
            name: {
              th: 'ศรีมงคล',
              en: 'Si Mongkhon',
            },
            zipcode: '67160',
          },
          670808: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '67160',
          },
          670809: {
            name: {
              th: 'บึงสามพัน',
              en: 'Bueng Sam Phan',
            },
            zipcode: '67160',
          },
        },
      },
      6709: {
        name: {
          th: 'น้ำหนาว',
          en: 'Nam Nao',
        },
        tambons: {
          670901: {
            name: {
              th: 'น้ำหนาว',
              en: 'Nam Nao',
            },
            zipcode: '67260',
          },
          670902: {
            name: {
              th: 'หลักด่าน',
              en: 'Lak Dan',
            },
            zipcode: '67260',
          },
          670903: {
            name: {
              th: 'วังกวาง',
              en: 'Wang Kwang',
            },
            zipcode: '67260',
          },
          670904: {
            name: {
              th: 'โคกมน',
              en: 'Khok Mon',
            },
            zipcode: '67260',
          },
        },
      },
      6710: {
        name: {
          th: 'วังโป่ง',
          en: 'Wang Pong',
        },
        tambons: {
          671001: {
            name: {
              th: 'วังโป่ง',
              en: 'Wang Pong',
            },
            zipcode: '67240',
          },
          671002: {
            name: {
              th: 'ท้ายดง',
              en: 'Thai Dong',
            },
            zipcode: '67240',
          },
          671003: {
            name: {
              th: 'ซับเปิบ',
              en: 'Sap Poep',
            },
            zipcode: '67240',
          },
          671004: {
            name: {
              th: 'วังหิน',
              en: 'Wang Hin',
            },
            zipcode: '67240',
          },
          671005: {
            name: {
              th: 'วังศาล',
              en: 'Wang San',
            },
            zipcode: '67240',
          },
        },
      },
      6711: {
        name: {
          th: 'เขาค้อ',
          en: 'Khao Kho',
        },
        tambons: {
          671101: {
            name: {
              th: 'ทุ่งสมอ',
              en: 'Thung Samo',
            },
            zipcode: '67270',
          },
          671102: {
            name: {
              th: 'แคมป์สน',
              en: 'Khaem Son',
            },
            zipcode: '67280',
          },
          671103: {
            name: {
              th: 'เขาค้อ',
              en: 'Khao Kho',
            },
            zipcode: '67270',
          },
          671104: {
            name: {
              th: 'ริมสีม่วง',
              en: 'Rim Si Muang',
            },
            zipcode: '67270',
          },
          671105: {
            name: {
              th: 'สะเดาะพง',
              en: 'Sado Phong',
            },
            zipcode: '67270',
          },
          671106: {
            name: {
              th: 'หนองแม่นา',
              en: 'Nong Mae Na',
            },
            zipcode: '67270',
          },
          671107: {
            name: {
              th: 'เข็กน้อย',
              en: 'Khek Noi',
            },
            zipcode: '67280',
          },
        },
      },
    },
  },
  70: {
    name: {
      th: 'ราชบุรี',
      en: 'Ratchaburi',
    },
    amphoes: {
      7001: {
        name: {
          th: 'เมืองราชบุรี',
          en: 'Muang',
        },
        tambons: {
          700101: {
            name: {
              th: 'หน้าเมือง',
              en: 'Na Mueang',
            },
            zipcode: '70000',
          },
          700102: {
            name: {
              th: 'เจดีย์หัก',
              en: 'Chedi Hak',
            },
            zipcode: '70000',
          },
          700103: {
            name: {
              th: 'ดอนตะโก',
              en: 'Don Tako',
            },
            zipcode: '70000',
          },
          700104: {
            name: {
              th: 'หนองกลางนา',
              en: 'Nong Klang Na',
            },
            zipcode: '70000',
          },
          700105: {
            name: {
              th: 'ห้วยไผ่',
              en: 'Huai Phai',
            },
            zipcode: '70000',
          },
          700106: {
            name: {
              th: 'คุ้งน้ำวน',
              en: 'Khung Nam Won',
            },
            zipcode: '70000',
          },
          700107: {
            name: {
              th: 'คุ้งกระถิน',
              en: 'Khung Krathin',
            },
            zipcode: '70000',
          },
          700108: {
            name: {
              th: 'อ่างทอง',
              en: 'Ang Thong',
            },
            zipcode: '70000',
          },
          700109: {
            name: {
              th: 'โคกหม้อ',
              en: 'Khok Mo',
            },
            zipcode: '70000',
          },
          700110: {
            name: {
              th: 'สามเรือน',
              en: 'Sam Ruean',
            },
            zipcode: '70000',
          },
          700111: {
            name: {
              th: 'พิกุลทอง',
              en: 'Phikun Thong',
            },
            zipcode: '70000',
          },
          700112: {
            name: {
              th: 'น้ำพุ',
              en: 'Nam Phu',
            },
            zipcode: '70000',
          },
          700113: {
            name: {
              th: 'ดอนแร่',
              en: 'Don Rae',
            },
            zipcode: '70000',
          },
          700114: {
            name: {
              th: 'หินกอง',
              en: 'Hin Kong',
            },
            zipcode: '70000',
          },
          700115: {
            name: {
              th: 'เขาแร้ง',
              en: 'Khao Raeng',
            },
            zipcode: '70000',
          },
          700116: {
            name: {
              th: 'เกาะพลับพลา',
              en: 'Ko Phlapphla',
            },
            zipcode: '70000',
          },
          700117: {
            name: {
              th: 'หลุมดิน',
              en: 'Lum Din',
            },
            zipcode: '70000',
          },
          700118: {
            name: {
              th: 'บางป่า',
              en: 'Bang Pa',
            },
            zipcode: '70000',
          },
          700119: {
            name: {
              th: 'พงสวาย',
              en: 'Phong Sawai',
            },
            zipcode: '70000',
          },
          700120: {
            name: {
              th: 'คูบัว',
              en: 'Khu Bua',
            },
            zipcode: '70000',
          },
          700121: {
            name: {
              th: 'ท่าราบ',
              en: 'Tha Rap',
            },
            zipcode: '70000',
          },
          700122: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '70000',
          },
        },
      },
      7002: {
        name: {
          th: 'จอมบึง',
          en: 'Chom Bung',
        },
        tambons: {
          700201: {
            name: {
              th: 'จอมบึง',
              en: 'Chom Bueng',
            },
            zipcode: '70150',
          },
          700202: {
            name: {
              th: 'ปากช่อง',
              en: 'Pak Chong',
            },
            zipcode: '70150',
          },
          700203: {
            name: {
              th: 'เบิกไพร',
              en: 'Boek Phrai',
            },
            zipcode: '70150',
          },
          700204: {
            name: {
              th: 'ด่านทับตะโก',
              en: 'Dan Thap Tako',
            },
            zipcode: '70150',
          },
          700205: {
            name: {
              th: 'แก้มอ้น',
              en: 'Kaem On',
            },
            zipcode: '70150',
          },
          700206: {
            name: {
              th: 'รางบัว',
              en: 'Rang Bua',
            },
            zipcode: '70150',
          },
        },
      },
      7003: {
        name: {
          th: 'สวนผึ้ง',
          en: 'Suan Phung',
        },
        tambons: {
          700301: {
            name: {
              th: 'สวนผึ้ง',
              en: 'Suan Phueng',
            },
            zipcode: '70180',
          },
          700302: {
            name: {
              th: 'ป่าหวาย',
              en: 'Pa Wai',
            },
            zipcode: '70180',
          },
          700304: {
            name: {
              th: 'ท่าเคย',
              en: 'Tha Khoei',
            },
            zipcode: '70180',
          },
          700307: {
            name: {
              th: 'ตะนาวศรี',
              en: 'Thanao Si',
            },
            zipcode: '70180',
          },
        },
      },
      7004: {
        name: {
          th: 'ดำเนินสะดวก',
          en: 'Damnoen Saduak',
        },
        tambons: {
          700401: {
            name: {
              th: 'ดำเนินสะดวก',
              en: 'Damnoen Saduak',
            },
            zipcode: '70130',
          },
          700402: {
            name: {
              th: 'ประสาทสิทธิ์',
              en: 'Prasat Sit',
            },
            zipcode: '70210',
          },
          700403: {
            name: {
              th: 'ศรีสุราษฎร์',
              en: 'Si Surat',
            },
            zipcode: '70130',
          },
          700404: {
            name: {
              th: 'ตาหลวง',
              en: 'Ta Luang',
            },
            zipcode: '70130',
          },
          700405: {
            name: {
              th: 'ดอนกรวย',
              en: 'Don Kruai',
            },
            zipcode: '70130',
          },
          700406: {
            name: {
              th: 'ดอนคลัง',
              en: 'Don Khlang',
            },
            zipcode: '70130',
          },
          700407: {
            name: {
              th: 'บัวงาม',
              en: 'Bua Ngam',
            },
            zipcode: '70210',
          },
          700408: {
            name: {
              th: 'บ้านไร่',
              en: 'Ban Rai',
            },
            zipcode: '70130',
          },
          700409: {
            name: {
              th: 'แพงพวย',
              en: 'Phaengphuai',
            },
            zipcode: '70130',
          },
          700410: {
            name: {
              th: 'สี่หมื่น',
              en: 'Si Muen',
            },
            zipcode: '70130',
          },
          700411: {
            name: {
              th: 'ท่านัด',
              en: 'Tha Nat',
            },
            zipcode: '70130',
          },
          700412: {
            name: {
              th: 'ขุนพิทักษ์',
              en: 'Khun Phithak',
            },
            zipcode: '70130',
          },
          700413: {
            name: {
              th: 'ดอนไผ่',
              en: 'Don Phai',
            },
            zipcode: '70130',
          },
        },
      },
      7005: {
        name: {
          th: 'บ้านโป่ง',
          en: 'Ban Pong',
        },
        tambons: {
          700501: {
            name: {
              th: 'บ้านโป่ง',
              en: 'Ban Pong',
            },
            zipcode: '70110',
          },
          700502: {
            name: {
              th: 'ท่าผา',
              en: 'Tha Pha',
            },
            zipcode: '70110',
          },
          700503: {
            name: {
              th: 'กรับใหญ่',
              en: 'Krap Yai',
            },
            zipcode: '70190',
          },
          700504: {
            name: {
              th: 'ปากแรต',
              en: 'Pak Raet',
            },
            zipcode: '70110',
          },
          700505: {
            name: {
              th: 'หนองกบ',
              en: 'Nong Kop',
            },
            zipcode: '70110',
          },
          700506: {
            name: {
              th: 'หนองอ้อ',
              en: 'Nong O',
            },
            zipcode: '70110',
          },
          700507: {
            name: {
              th: 'ดอนกระเบื้อง',
              en: 'Don Krabueang',
            },
            zipcode: '70110',
          },
          700508: {
            name: {
              th: 'สวนกล้วย',
              en: 'Suan Kluai',
            },
            zipcode: '70110',
          },
          700509: {
            name: {
              th: 'นครชุมน์',
              en: 'Nakhon Chum',
            },
            zipcode: '70110',
          },
          700510: {
            name: {
              th: 'บ้านม่วง',
              en: 'Ban Muang',
            },
            zipcode: '70110',
          },
          700511: {
            name: {
              th: 'คุ้งพยอม',
              en: 'Khung Phayom',
            },
            zipcode: '70110',
          },
          700512: {
            name: {
              th: 'หนองปลาหมอ',
              en: 'Nong Pla Mo',
            },
            zipcode: '70110',
          },
          700513: {
            name: {
              th: 'เขาขลุง',
              en: 'Khao Khlung',
            },
            zipcode: '70110',
          },
          700514: {
            name: {
              th: 'เบิกไพร',
              en: 'Boek Phrai',
            },
            zipcode: '70110',
          },
          700515: {
            name: {
              th: 'ลาดบัวขาว',
              en: 'Lat Bua Khao',
            },
            zipcode: '70110',
          },
        },
      },
      7006: {
        name: {
          th: 'บางแพ',
          en: 'Bang Phae',
        },
        tambons: {
          700601: {
            name: {
              th: 'บางแพ',
              en: 'Bang Phae',
            },
            zipcode: '70160',
          },
          700602: {
            name: {
              th: 'วังเย็น',
              en: 'Wang Yen',
            },
            zipcode: '70160',
          },
          700603: {
            name: {
              th: 'หัวโพ',
              en: 'Hua Pho',
            },
            zipcode: '70160',
          },
          700604: {
            name: {
              th: 'วัดแก้ว',
              en: 'Wat Kaeo',
            },
            zipcode: '70160',
          },
          700605: {
            name: {
              th: 'ดอนใหญ่',
              en: 'Don Yai',
            },
            zipcode: '70160',
          },
          700606: {
            name: {
              th: 'ดอนคา',
              en: 'Don Kha',
            },
            zipcode: '70160',
          },
          700607: {
            name: {
              th: 'โพหัก',
              en: 'Pho Hak',
            },
            zipcode: '70160',
          },
        },
      },
      7007: {
        name: {
          th: 'โพธาราม',
          en: 'Photharam',
        },
        tambons: {
          700701: {
            name: {
              th: 'โพธาราม',
              en: 'Photharam',
            },
            zipcode: '70120',
          },
          700702: {
            name: {
              th: 'ดอนกระเบื้อง',
              en: 'Don Krabueang',
            },
            zipcode: '70120',
          },
          700703: {
            name: {
              th: 'หนองโพ',
              en: 'Nong Pho',
            },
            zipcode: '70120',
          },
          700704: {
            name: {
              th: 'บ้านเลือก',
              en: 'Ban Lueak',
            },
            zipcode: '70120',
          },
          700705: {
            name: {
              th: 'คลองตาคต',
              en: 'Khlong Ta Khot',
            },
            zipcode: '70120',
          },
          700706: {
            name: {
              th: 'บ้านฆ้อง',
              en: 'Ban Khong',
            },
            zipcode: '70120',
          },
          700707: {
            name: {
              th: 'บ้านสิงห์',
              en: 'Ban Sing',
            },
            zipcode: '70120',
          },
          700708: {
            name: {
              th: 'ดอนทราย',
              en: 'Don Sai',
            },
            zipcode: '70120',
          },
          700709: {
            name: {
              th: 'เจ็ดเสมียน',
              en: 'Chet Samian',
            },
            zipcode: '70120',
          },
          700710: {
            name: {
              th: 'คลองข่อย',
              en: 'Khlong Khoi',
            },
            zipcode: '70120',
          },
          700711: {
            name: {
              th: 'ชำแระ',
              en: 'Chamrae',
            },
            zipcode: '70120',
          },
          700712: {
            name: {
              th: 'สร้อยฟ้า',
              en: 'Soi Fa',
            },
            zipcode: '70120',
          },
          700713: {
            name: {
              th: 'ท่าชุมพล',
              en: 'Tha Chumphon',
            },
            zipcode: '70120',
          },
          700714: {
            name: {
              th: 'บางโตนด',
              en: 'Bang Tanot',
            },
            zipcode: '70120',
          },
          700715: {
            name: {
              th: 'เตาปูน',
              en: 'Tao Pun',
            },
            zipcode: '70120',
          },
          700716: {
            name: {
              th: 'นางแก้ว',
              en: 'Nang Kaeo',
            },
            zipcode: '70120',
          },
          700717: {
            name: {
              th: 'ธรรมเสน',
              en: 'Thammasen',
            },
            zipcode: '70120',
          },
          700718: {
            name: {
              th: 'เขาชะงุ้ม',
              en: 'Khao Cha-ngum',
            },
            zipcode: '70120',
          },
          700719: {
            name: {
              th: 'หนองกวาง',
              en: 'Nong Kwang',
            },
            zipcode: '70120',
          },
        },
      },
      7008: {
        name: {
          th: 'ปากท่อ',
          en: 'Pak Tho',
        },
        tambons: {
          700801: {
            name: {
              th: 'ทุ่งหลวง',
              en: 'Thung Luang',
            },
            zipcode: '70140',
          },
          700802: {
            name: {
              th: 'วังมะนาว',
              en: 'Wang Manao',
            },
            zipcode: '70140',
          },
          700803: {
            name: {
              th: 'ดอนทราย',
              en: 'Don Sai',
            },
            zipcode: '70140',
          },
          700804: {
            name: {
              th: 'หนองกระทุ่ม',
              en: 'Nong Krathum',
            },
            zipcode: '70140',
          },
          700805: {
            name: {
              th: 'ปากท่อ',
              en: 'Pak Tho',
            },
            zipcode: '70140',
          },
          700806: {
            name: {
              th: 'ป่าไก่',
              en: 'Pa Kai',
            },
            zipcode: '70140',
          },
          700807: {
            name: {
              th: 'วัดยางงาม',
              en: 'Wat Yang Ngam',
            },
            zipcode: '70140',
          },
          700808: {
            name: {
              th: 'อ่างหิน',
              en: 'Ang Hin',
            },
            zipcode: '70140',
          },
          700809: {
            name: {
              th: 'บ่อกระดาน',
              en: 'Bo Kradan',
            },
            zipcode: '70140',
          },
          700810: {
            name: {
              th: 'ยางหัก',
              en: 'Yang Hak',
            },
            zipcode: '70140',
          },
          700811: {
            name: {
              th: 'วันดาว',
              en: 'Wan Dao',
            },
            zipcode: '70140',
          },
          700812: {
            name: {
              th: 'ห้วยยางโทน',
              en: 'Huai Yang Thon',
            },
            zipcode: '70140',
          },
        },
      },
      7009: {
        name: {
          th: 'วัดเพลง',
          en: 'Wat Phleng',
        },
        tambons: {
          700901: {
            name: {
              th: 'เกาะศาลพระ',
              en: 'Ko San Phra',
            },
            zipcode: '70170',
          },
          700902: {
            name: {
              th: 'จอมประทัด',
              en: 'Chom Prathat',
            },
            zipcode: '70170',
          },
          700903: {
            name: {
              th: 'วัดเพลง',
              en: 'Wat Phleng',
            },
            zipcode: '70170',
          },
        },
      },
      7010: {
        name: {
          th: 'บ้านคา',
          en: 'Ban Kha',
        },
        tambons: {
          701001: {
            name: {
              th: 'บ้านคา',
              en: 'Ban Kha',
            },
            zipcode: '70180',
          },
          701002: {
            name: {
              th: 'บ้านบึง',
              en: 'Ban Bueng',
            },
            zipcode: '70180',
          },
          701003: {
            name: {
              th: 'หนองพันจันทร์',
              en: 'Nong Phan Chan',
            },
            zipcode: '70180',
          },
        },
      },
    },
  },
  71: {
    name: {
      th: 'กาญจนบุรี',
      en: 'Kanchanaburi',
    },
    amphoes: {
      7101: {
        name: {
          th: 'เมืองกาญจนบุรี',
          en: 'Muang',
        },
        tambons: {
          710101: {
            name: {
              th: 'บ้านเหนือ',
              en: 'Ban Nuea',
            },
            zipcode: '71000',
          },
          710102: {
            name: {
              th: 'บ้านใต้',
              en: 'Ban Tai',
            },
            zipcode: '71000',
          },
          710103: {
            name: {
              th: 'ปากแพรก',
              en: 'Pak Phraek',
            },
            zipcode: '71000',
          },
          710104: {
            name: {
              th: 'ท่ามะขาม',
              en: 'Tha Makham',
            },
            zipcode: '71000',
          },
          710105: {
            name: {
              th: 'แก่งเสี้ยน',
              en: 'Kaeng Sian',
            },
            zipcode: '71000',
          },
          710106: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '71190',
          },
          710107: {
            name: {
              th: 'ลาดหญ้า',
              en: 'Lat Ya',
            },
            zipcode: '71190',
          },
          710108: {
            name: {
              th: 'วังด้ง',
              en: 'Wang Dong',
            },
            zipcode: '71190',
          },
          710109: {
            name: {
              th: 'ช่องสะเดา',
              en: 'Chong Sadao',
            },
            zipcode: '71190',
          },
          710110: {
            name: {
              th: 'หนองหญ้า',
              en: 'Nong Ya',
            },
            zipcode: '71000',
          },
          710111: {
            name: {
              th: 'เกาะสำโรง',
              en: 'Ko Samrong',
            },
            zipcode: '71000',
          },
          710113: {
            name: {
              th: 'บ้านเก่า',
              en: 'Ban Kao',
            },
            zipcode: '71000',
          },
          710116: {
            name: {
              th: 'วังเย็น',
              en: 'Wang Yen',
            },
            zipcode: '71000',
          },
        },
      },
      7102: {
        name: {
          th: 'ไทรโยค',
          en: 'Saiyok',
        },
        tambons: {
          710201: {
            name: {
              th: 'ลุ่มสุ่ม',
              en: 'Lum Sum',
            },
            zipcode: '71150',
          },
          710202: {
            name: {
              th: 'ท่าเสา',
              en: 'Tha Sao',
            },
            zipcode: '71150',
          },
          710203: {
            name: {
              th: 'สิงห์',
              en: 'Sing',
            },
            zipcode: '71150',
          },
          710204: {
            name: {
              th: 'ไทรโยค',
              en: 'Sai Yok',
            },
            zipcode: '71150',
          },
          710205: {
            name: {
              th: 'วังกระแจะ',
              en: 'Wang Krachae',
            },
            zipcode: '71150',
          },
          710206: {
            name: {
              th: 'ศรีมงคล',
              en: 'Si Mongkhon',
            },
            zipcode: '71150',
          },
          710207: {
            name: {
              th: 'บ้องตี้',
              en: 'Bongti',
            },
            zipcode: '71150',
          },
        },
      },
      7103: {
        name: {
          th: 'บ่อพลอย',
          en: 'Bo Phloi',
        },
        tambons: {
          710301: {
            name: {
              th: 'บ่อพลอย',
              en: 'Bo Phloi',
            },
            zipcode: '71160',
          },
          710302: {
            name: {
              th: 'หนองกุ่ม',
              en: 'Nong Kum',
            },
            zipcode: '71160',
          },
          710303: {
            name: {
              th: 'หนองรี',
              en: 'Nong Ri',
            },
            zipcode: '71220',
          },
          710305: {
            name: {
              th: 'หลุมรัง',
              en: 'Lum Rang',
            },
            zipcode: '71160',
          },
          710308: {
            name: {
              th: 'ช่องด่าน',
              en: 'Chong Dan',
            },
            zipcode: '71160',
          },
          710309: {
            name: {
              th: 'หนองกร่าง',
              en: 'Nong Krang',
            },
            zipcode: '71220',
          },
        },
      },
      7104: {
        name: {
          th: 'ศรีสวัสดิ์',
          en: 'Srisawatt',
        },
        tambons: {
          710401: {
            name: {
              th: 'นาสวน',
              en: 'Na Suan',
            },
            zipcode: '71250',
          },
          710402: {
            name: {
              th: 'ด่านแม่แฉลบ',
              en: 'Dan Mae Chalaep',
            },
            zipcode: '71250',
          },
          710403: {
            name: {
              th: 'หนองเป็ด',
              en: 'Nong Pet',
            },
            zipcode: '71250',
          },
          710404: {
            name: {
              th: 'ท่ากระดาน',
              en: 'Tha Kradan',
            },
            zipcode: '71250',
          },
          710405: {
            name: {
              th: 'เขาโจด',
              en: 'Khao Chot',
            },
            zipcode: '71220',
          },
          710406: {
            name: {
              th: 'แม่กระบุง',
              en: 'Mae Krabung',
            },
            zipcode: '71250',
          },
        },
      },
      7105: {
        name: {
          th: 'ท่ามะกา',
          en: 'Tha Maka',
        },
        tambons: {
          710501: {
            name: {
              th: 'พงตึก',
              en: 'Phong Tuek',
            },
            zipcode: '71120',
          },
          710502: {
            name: {
              th: 'ยางม่วง',
              en: 'Yang Muang',
            },
            zipcode: '71120',
          },
          710503: {
            name: {
              th: 'ดอนชะเอม',
              en: 'Don Cha-em',
            },
            zipcode: '71130',
          },
          710504: {
            name: {
              th: 'ท่าไม้',
              en: 'Tha Mai',
            },
            zipcode: '71120',
          },
          710505: {
            name: {
              th: 'ตะคร้ำเอน',
              en: 'Takhram En',
            },
            zipcode: '71130',
          },
          710506: {
            name: {
              th: 'ท่ามะกา',
              en: 'Tha Maka',
            },
            zipcode: '71120',
          },
          710507: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '71130',
          },
          710508: {
            name: {
              th: 'โคกตะบอง',
              en: 'Khok Tabong',
            },
            zipcode: '71120',
          },
          710509: {
            name: {
              th: 'ดอนขมิ้น',
              en: 'Don Khamin',
            },
            zipcode: '71120',
          },
          710510: {
            name: {
              th: 'อุโลกสี่หมื่น',
              en: 'Ulok Si Muen',
            },
            zipcode: '71130',
          },
          710511: {
            name: {
              th: 'เขาสามสิบหาบ',
              en: 'Khao Samsip Hap',
            },
            zipcode: '71120',
          },
          710512: {
            name: {
              th: 'พระแท่น',
              en: 'Phra Thaen',
            },
            zipcode: '71130',
          },
          710513: {
            name: {
              th: 'หวายเหนียว',
              en: 'Wai Niao',
            },
            zipcode: '71120',
          },
          710514: {
            name: {
              th: 'แสนตอ',
              en: 'Saen To',
            },
            zipcode: '71130',
          },
          710515: {
            name: {
              th: 'สนามแย้',
              en: 'Sanam Yae',
            },
            zipcode: '70190',
          },
          710516: {
            name: {
              th: 'ท่าเสา',
              en: 'Tha Sao',
            },
            zipcode: '71120',
          },
          710517: {
            name: {
              th: 'หนองลาน',
              en: 'Nong Lan',
            },
            zipcode: '71130',
          },
        },
      },
      7106: {
        name: {
          th: 'ท่าม่วง',
          en: 'Tha Muang',
        },
        tambons: {
          710601: {
            name: {
              th: 'ท่าม่วง',
              en: 'Tha Muang',
            },
            zipcode: '71110',
          },
          710602: {
            name: {
              th: 'วังขนาย',
              en: 'Wang Khanai',
            },
            zipcode: '71110',
          },
          710603: {
            name: {
              th: 'วังศาลา',
              en: 'Wang Sala',
            },
            zipcode: '71110',
          },
          710604: {
            name: {
              th: 'ท่าล้อ',
              en: 'Tha Lo',
            },
            zipcode: '71110',
          },
          710605: {
            name: {
              th: 'หนองขาว',
              en: 'Nong Khao',
            },
            zipcode: '71110',
          },
          710606: {
            name: {
              th: 'ทุ่งทอง',
              en: 'Thung Thong',
            },
            zipcode: '71110',
          },
          710607: {
            name: {
              th: 'เขาน้อย',
              en: 'Khao Noi',
            },
            zipcode: '71110',
          },
          710608: {
            name: {
              th: 'ม่วงชุม',
              en: 'Muang Chum',
            },
            zipcode: '71110',
          },
          710609: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '71110',
          },
          710610: {
            name: {
              th: 'พังตรุ',
              en: 'Phang Tru',
            },
            zipcode: '71110',
          },
          710611: {
            name: {
              th: 'ท่าตะคร้อ',
              en: 'Tha Takhro',
            },
            zipcode: '71130',
          },
          710612: {
            name: {
              th: 'รางสาลี่',
              en: 'Rang Sali',
            },
            zipcode: '71110',
          },
          710613: {
            name: {
              th: 'หนองตากยา',
              en: 'Nong Tak Ya',
            },
            zipcode: '71110',
          },
        },
      },
      7107: {
        name: {
          th: 'ทองผาภูมิ',
          en: 'Thong Pha Phum',
        },
        tambons: {
          710701: {
            name: {
              th: 'ท่าขนุน',
              en: 'Tha Khanun',
            },
            zipcode: '71180',
          },
          710702: {
            name: {
              th: 'ปิล๊อก',
              en: 'Pilok',
            },
            zipcode: '71180',
          },
          710703: {
            name: {
              th: 'หินดาด',
              en: 'Hin Dat',
            },
            zipcode: '71180',
          },
          710704: {
            name: {
              th: 'ลิ่นถิ่น',
              en: 'Linthin',
            },
            zipcode: '71180',
          },
          710705: {
            name: {
              th: 'ชะแล',
              en: 'Chalae',
            },
            zipcode: '71180',
          },
          710706: {
            name: {
              th: 'ห้วยเขย่ง',
              en: 'Huai Khayeng',
            },
            zipcode: '71180',
          },
          710707: {
            name: {
              th: 'สหกรณ์นิคม',
              en: 'Sahakon Nikhom',
            },
            zipcode: '71180',
          },
        },
      },
      7108: {
        name: {
          th: 'สังขละบุรี',
          en: 'Sangkhla Buri',
        },
        tambons: {
          710801: {
            name: {
              th: 'หนองลู',
              en: 'Nong Lu',
            },
            zipcode: '71240',
          },
          710802: {
            name: {
              th: 'ปรังเผล',
              en: 'Prangphle',
            },
            zipcode: '71240',
          },
          710803: {
            name: {
              th: 'ไล่โว่',
              en: 'Laiwo',
            },
            zipcode: '71240',
          },
        },
      },
      7109: {
        name: {
          th: 'พนมทวน',
          en: 'Phanom Thuan',
        },
        tambons: {
          710901: {
            name: {
              th: 'พนมทวน',
              en: 'Phanom Thuan',
            },
            zipcode: '71140',
          },
          710902: {
            name: {
              th: 'หนองโรง',
              en: 'Nong Rong',
            },
            zipcode: '71140',
          },
          710903: {
            name: {
              th: 'ทุ่งสมอ',
              en: 'Thung Samo',
            },
            zipcode: '71140',
          },
          710904: {
            name: {
              th: 'ดอนเจดีย์',
              en: 'Don Chedi',
            },
            zipcode: '71140',
          },
          710905: {
            name: {
              th: 'พังตรุ',
              en: 'Phang Tru',
            },
            zipcode: '71140',
          },
          710906: {
            name: {
              th: 'รางหวาย',
              en: 'Rang Wai',
            },
            zipcode: '71170',
          },
          710911: {
            name: {
              th: 'หนองสาหร่าย',
              en: 'Nong Sarai',
            },
            zipcode: '71140',
          },
          710912: {
            name: {
              th: 'ดอนตาเพชร',
              en: 'Don Ta Phet',
            },
            zipcode: '71140',
          },
        },
      },
      7110: {
        name: {
          th: 'เลาขวัญ',
          en: 'Lao Khwan',
        },
        tambons: {
          711001: {
            name: {
              th: 'เลาขวัญ',
              en: 'Lao Khwan',
            },
            zipcode: '71210',
          },
          711002: {
            name: {
              th: 'หนองโสน',
              en: 'Nong Sano',
            },
            zipcode: '71210',
          },
          711003: {
            name: {
              th: 'หนองประดู่',
              en: 'Nong Pradu',
            },
            zipcode: '71210',
          },
          711004: {
            name: {
              th: 'หนองปลิง',
              en: 'Nong Pling',
            },
            zipcode: '71210',
          },
          711005: {
            name: {
              th: 'หนองนกแก้ว',
              en: 'Nong Nok Kaeo',
            },
            zipcode: '71210',
          },
          711006: {
            name: {
              th: 'ทุ่งกระบ่ำ',
              en: 'Thung Krabam',
            },
            zipcode: '71210',
          },
          711007: {
            name: {
              th: 'หนองฝ้าย',
              en: 'Nong Fai',
            },
            zipcode: '71210',
          },
        },
      },
      7111: {
        name: {
          th: 'ด่านมะขามเตี้ย',
          en: 'Dan Makham Tia',
        },
        tambons: {
          711101: {
            name: {
              th: 'ด่านมะขามเตี้ย',
              en: 'Dan Makham Tia',
            },
            zipcode: '71260',
          },
          711102: {
            name: {
              th: 'กลอนโด',
              en: 'Klondo',
            },
            zipcode: '71260',
          },
          711103: {
            name: {
              th: 'จรเข้เผือก',
              en: 'Chorakhe Phueak',
            },
            zipcode: '71260',
          },
          711104: {
            name: {
              th: 'หนองไผ่',
              en: 'Nong Phai',
            },
            zipcode: '71260',
          },
        },
      },
      7112: {
        name: {
          th: 'หนองปรือ',
          en: 'Nong Pru',
        },
        tambons: {
          711201: {
            name: {
              th: 'หนองปรือ',
              en: 'Nong Prue',
            },
            zipcode: '71220',
          },
          711202: {
            name: {
              th: 'หนองปลาไหล',
              en: 'Nong Pla Lai',
            },
            zipcode: '71220',
          },
          711203: {
            name: {
              th: 'สมเด็จเจริญ',
              en: 'Somdet Charoen',
            },
            zipcode: '71220',
          },
        },
      },
      7113: {
        name: {
          th: 'ห้วยกระเจา',
          en: 'Huai Krajao',
        },
        tambons: {
          711301: {
            name: {
              th: 'ห้วยกระเจา',
              en: 'Huai Krachao',
            },
            zipcode: '71170',
          },
          711302: {
            name: {
              th: 'วังไผ่',
              en: 'Wang Phai',
            },
            zipcode: '71170',
          },
          711303: {
            name: {
              th: 'ดอนแสลบ',
              en: 'Don Salaep',
            },
            zipcode: '71170',
          },
          711304: {
            name: {
              th: 'สระลงเรือ',
              en: 'Sa Long Ruea',
            },
            zipcode: '71170',
          },
        },
      },
    },
  },
  72: {
    name: {
      th: 'สุพรรณบุรี',
      en: 'Suphan Buri',
    },
    amphoes: {
      7201: {
        name: {
          th: 'เมืองสุพรรณบุรี',
          en: 'Muang',
        },
        tambons: {
          720101: {
            name: {
              th: 'ท่าพี่เลี้ยง',
              en: 'Tha Phi Liang',
            },
            zipcode: '72000',
          },
          720102: {
            name: {
              th: 'รั้วใหญ่',
              en: 'Rua Yai',
            },
            zipcode: '72000',
          },
          720103: {
            name: {
              th: 'ทับตีเหล็ก',
              en: 'Thap Ti Lek',
            },
            zipcode: '72000',
          },
          720104: {
            name: {
              th: 'ท่าระหัด',
              en: 'Tha Rahat',
            },
            zipcode: '72000',
          },
          720105: {
            name: {
              th: 'ไผ่ขวาง',
              en: 'Phai Khwang',
            },
            zipcode: '72000',
          },
          720106: {
            name: {
              th: 'โคกโคเฒ่า',
              en: 'Khok Kho Thao',
            },
            zipcode: '72000',
          },
          720107: {
            name: {
              th: 'ดอนตาล',
              en: 'Don Tan',
            },
            zipcode: '72000',
          },
          720108: {
            name: {
              th: 'ดอนมะสังข์',
              en: 'Don Masang',
            },
            zipcode: '72000',
          },
          720109: {
            name: {
              th: 'พิหารแดง',
              en: 'Phihan Daeng',
            },
            zipcode: '72000',
          },
          720110: {
            name: {
              th: 'ดอนกำยาน',
              en: 'Don Kamyan',
            },
            zipcode: '72000',
          },
          720111: {
            name: {
              th: 'ดอนโพธิ์ทอง',
              en: 'Don Pho Thong',
            },
            zipcode: '72000',
          },
          720112: {
            name: {
              th: 'บ้านโพธิ์',
              en: 'Ban Pho',
            },
            zipcode: '72000',
          },
          720113: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '72230',
          },
          720114: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '72230',
          },
          720115: {
            name: {
              th: 'บางกุ้ง',
              en: 'Bang Kung',
            },
            zipcode: '72210',
          },
          720116: {
            name: {
              th: 'ศาลาขาว',
              en: 'Sala Khao',
            },
            zipcode: '72210',
          },
          720117: {
            name: {
              th: 'สวนแตง',
              en: 'Suan Taeng',
            },
            zipcode: '72210',
          },
          720118: {
            name: {
              th: 'สนามชัย',
              en: 'Sanam Chai',
            },
            zipcode: '72000',
          },
          720119: {
            name: {
              th: 'โพธิ์พระยา',
              en: 'Pho Phraya',
            },
            zipcode: '72000',
          },
          720120: {
            name: {
              th: 'สนามคลี',
              en: 'Sanam Khli',
            },
            zipcode: '72230',
          },
        },
      },
      7202: {
        name: {
          th: 'เดิมบางนางบวช',
          en: 'Doembang Nangbuat',
        },
        tambons: {
          720201: {
            name: {
              th: 'เขาพระ',
              en: 'Khao Phra',
            },
            zipcode: '72120',
          },
          720202: {
            name: {
              th: 'เดิมบาง',
              en: 'Doem Bang',
            },
            zipcode: '72120',
          },
          720203: {
            name: {
              th: 'นางบวช',
              en: 'Nang Buat',
            },
            zipcode: '72120',
          },
          720204: {
            name: {
              th: 'เขาดิน',
              en: 'Khao Din',
            },
            zipcode: '72120',
          },
          720205: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '72120',
          },
          720206: {
            name: {
              th: 'ทุ่งคลี',
              en: 'Thung Khli',
            },
            zipcode: '72120',
          },
          720207: {
            name: {
              th: 'โคกช้าง',
              en: 'Khok Chang',
            },
            zipcode: '72120',
          },
          720208: {
            name: {
              th: 'หัวเขา',
              en: 'Hua Khao',
            },
            zipcode: '72120',
          },
          720209: {
            name: {
              th: 'หัวนา',
              en: 'Hua Na',
            },
            zipcode: '72120',
          },
          720210: {
            name: {
              th: 'บ่อกรุ',
              en: 'Bo Kru',
            },
            zipcode: '72120',
          },
          720211: {
            name: {
              th: 'วังศรีราช',
              en: 'Wang Si Rat',
            },
            zipcode: '72120',
          },
          720212: {
            name: {
              th: 'ป่าสะแก',
              en: 'Pa Sakae',
            },
            zipcode: '72120',
          },
          720213: {
            name: {
              th: 'ยางนอน',
              en: 'Yang Non',
            },
            zipcode: '72120',
          },
          720214: {
            name: {
              th: 'หนองกระทุ่ม',
              en: 'Nong Krathum',
            },
            zipcode: '72120',
          },
        },
      },
      7203: {
        name: {
          th: 'ด่านช้าง',
          en: 'Dan Chang',
        },
        tambons: {
          720301: {
            name: {
              th: 'หนองมะค่าโมง',
              en: 'Nong Makha Mong',
            },
            zipcode: '72180',
          },
          720302: {
            name: {
              th: 'ด่านช้าง',
              en: 'Dan Chang',
            },
            zipcode: '72180',
          },
          720303: {
            name: {
              th: 'ห้วยขมิ้น',
              en: 'Huai Khamin',
            },
            zipcode: '72180',
          },
          720304: {
            name: {
              th: 'องค์พระ',
              en: 'Ong Phra',
            },
            zipcode: '72180',
          },
          720305: {
            name: {
              th: 'วังคัน',
              en: 'Wang Khan',
            },
            zipcode: '72180',
          },
          720306: {
            name: {
              th: 'นิคมกระเสียว',
              en: 'Nikhom Krasiao',
            },
            zipcode: '72180',
          },
          720307: {
            name: {
              th: 'วังยาว',
              en: 'Wang Yao',
            },
            zipcode: '72180',
          },
        },
      },
      7204: {
        name: {
          th: 'บางปลาม้า',
          en: 'Bang Plama',
        },
        tambons: {
          720401: {
            name: {
              th: 'โคกคราม',
              en: 'Khok Khram',
            },
            zipcode: '72150',
          },
          720402: {
            name: {
              th: 'บางปลาม้า',
              en: 'Bang Pla Ma',
            },
            zipcode: '72150',
          },
          720403: {
            name: {
              th: 'ตะค่า',
              en: 'Takha',
            },
            zipcode: '72150',
          },
          720404: {
            name: {
              th: 'บางใหญ่',
              en: 'Bang Yai',
            },
            zipcode: '72150',
          },
          720405: {
            name: {
              th: 'กฤษณา',
              en: 'Kritsana',
            },
            zipcode: '72150',
          },
          720406: {
            name: {
              th: 'สาลี',
              en: 'Sali',
            },
            zipcode: '72150',
          },
          720407: {
            name: {
              th: 'ไผ่กองดิน',
              en: 'Phai Kong Din',
            },
            zipcode: '72150',
          },
          720408: {
            name: {
              th: 'องครักษ์',
              en: 'Ongkharak',
            },
            zipcode: '72150',
          },
          720409: {
            name: {
              th: 'จรเข้ใหญ่',
              en: 'Chorakhe Yai',
            },
            zipcode: '72150',
          },
          720410: {
            name: {
              th: 'บ้านแหลม',
              en: 'Ban Laem',
            },
            zipcode: '72150',
          },
          720411: {
            name: {
              th: 'มะขามล้ม',
              en: 'Makham Lom',
            },
            zipcode: '72150',
          },
          720412: {
            name: {
              th: 'วังน้ำเย็น',
              en: 'Wang Nam Yen',
            },
            zipcode: '72150',
          },
          720413: {
            name: {
              th: 'วัดโบสถ์',
              en: 'Wat Bot',
            },
            zipcode: '72150',
          },
          720414: {
            name: {
              th: 'วัดดาว',
              en: 'Wat Dao',
            },
            zipcode: '72150',
          },
        },
      },
      7205: {
        name: {
          th: 'ศรีประจันต์',
          en: 'Si Prachan',
        },
        tambons: {
          720501: {
            name: {
              th: 'ศรีประจันต์',
              en: 'Si Prachan',
            },
            zipcode: '72140',
          },
          720502: {
            name: {
              th: 'บ้านกร่าง',
              en: 'Ban Krang',
            },
            zipcode: '72140',
          },
          720503: {
            name: {
              th: 'มดแดง',
              en: 'Mot Daeng',
            },
            zipcode: '72140',
          },
          720504: {
            name: {
              th: 'บางงาม',
              en: 'Bang Ngam',
            },
            zipcode: '72140',
          },
          720505: {
            name: {
              th: 'ดอนปรู',
              en: 'Don Pru',
            },
            zipcode: '72140',
          },
          720506: {
            name: {
              th: 'ปลายนา',
              en: 'Plai Na',
            },
            zipcode: '72140',
          },
          720507: {
            name: {
              th: 'วังหว้า',
              en: 'Wang Wa',
            },
            zipcode: '72140',
          },
          720508: {
            name: {
              th: 'วังน้ำซับ',
              en: 'Wang Nam Sap',
            },
            zipcode: '72140',
          },
          720509: {
            name: {
              th: 'วังยาง',
              en: 'Wang Yang',
            },
            zipcode: '72140',
          },
        },
      },
      7206: {
        name: {
          th: 'ดอนเจดีย์',
          en: 'Don Chedi',
        },
        tambons: {
          720601: {
            name: {
              th: 'ดอนเจดีย์',
              en: 'Don Chedi',
            },
            zipcode: '72170',
          },
          720602: {
            name: {
              th: 'หนองสาหร่าย',
              en: 'Nong Sarai',
            },
            zipcode: '72170',
          },
          720603: {
            name: {
              th: 'ไร่รถ',
              en: 'Rai Rot',
            },
            zipcode: '72170',
          },
          720604: {
            name: {
              th: 'สระกระโจม',
              en: 'Sa Krachom',
            },
            zipcode: '72250',
          },
          720605: {
            name: {
              th: 'ทะเลบก',
              en: 'Thale Bok',
            },
            zipcode: '72250',
          },
        },
      },
      7207: {
        name: {
          th: 'สองพี่น้อง',
          en: 'Song Phi Nong',
        },
        tambons: {
          720701: {
            name: {
              th: 'สองพี่น้อง',
              en: 'Song Phi Nong',
            },
            zipcode: '72110',
          },
          720702: {
            name: {
              th: 'บางเลน',
              en: 'Bang Len',
            },
            zipcode: '72110',
          },
          720703: {
            name: {
              th: 'บางตาเถร',
              en: 'Bang Ta Then',
            },
            zipcode: '72110',
          },
          720704: {
            name: {
              th: 'บางตะเคียน',
              en: 'Bang Takhian',
            },
            zipcode: '72110',
          },
          720705: {
            name: {
              th: 'บ้านกุ่ม',
              en: 'Ban Kum',
            },
            zipcode: '72110',
          },
          720706: {
            name: {
              th: 'หัวโพธิ์',
              en: 'Hua Pho',
            },
            zipcode: '72110',
          },
          720707: {
            name: {
              th: 'บางพลับ',
              en: 'Bang Phlap',
            },
            zipcode: '72110',
          },
          720708: {
            name: {
              th: 'เนินพระปรางค์',
              en: 'Noen Phra Prang',
            },
            zipcode: '72110',
          },
          720709: {
            name: {
              th: 'บ้านช้าง',
              en: 'Ban Chang',
            },
            zipcode: '72110',
          },
          720710: {
            name: {
              th: 'ต้นตาล',
              en: 'Ton Tan',
            },
            zipcode: '72110',
          },
          720711: {
            name: {
              th: 'ศรีสำราญ',
              en: 'Si Samran',
            },
            zipcode: '72110',
          },
          720712: {
            name: {
              th: 'ทุ่งคอก',
              en: 'Thung Khok',
            },
            zipcode: '72190',
          },
          720713: {
            name: {
              th: 'หนองบ่อ',
              en: 'Nong Bo',
            },
            zipcode: '72110',
          },
          720714: {
            name: {
              th: 'บ่อสุพรรณ',
              en: 'Bo Suphan',
            },
            zipcode: '72190',
          },
          720715: {
            name: {
              th: 'ดอนมะนาว',
              en: 'Don Manao',
            },
            zipcode: '72110',
          },
        },
      },
      7208: {
        name: {
          th: 'สามชุก',
          en: 'Sam Chuk',
        },
        tambons: {
          720801: {
            name: {
              th: 'ย่านยาว',
              en: 'Yan Yao',
            },
            zipcode: '72130',
          },
          720802: {
            name: {
              th: 'วังลึก',
              en: 'Wang Luek',
            },
            zipcode: '72130',
          },
          720803: {
            name: {
              th: 'สามชุก',
              en: 'Sam Chuk',
            },
            zipcode: '72130',
          },
          720804: {
            name: {
              th: 'หนองผักนาก',
              en: 'Nong Phak Nak',
            },
            zipcode: '72130',
          },
          720805: {
            name: {
              th: 'บ้านสระ',
              en: 'Ban Sa',
            },
            zipcode: '72130',
          },
          720806: {
            name: {
              th: 'หนองสะเดา',
              en: 'Nong Sadao',
            },
            zipcode: '72130',
          },
          720807: {
            name: {
              th: 'กระเสียว',
              en: 'Krasiao',
            },
            zipcode: '72130',
          },
        },
      },
      7209: {
        name: {
          th: 'อู่ทอง',
          en: 'U-Thong',
        },
        tambons: {
          720901: {
            name: {
              th: 'อู่ทอง',
              en: 'U Thong',
            },
            zipcode: '72160',
          },
          720902: {
            name: {
              th: 'สระยายโสม',
              en: 'Sa Yai Som',
            },
            zipcode: '72220',
          },
          720903: {
            name: {
              th: 'จรเข้สามพัน',
              en: 'Chorakhe Sam Phanย ',
            },
            zipcode: '72160',
          },
          720904: {
            name: {
              th: 'บ้านดอน',
              en: 'Ban Don',
            },
            zipcode: '72160',
          },
          720905: {
            name: {
              th: 'ยุ้งทะลาย',
              en: 'Yung Thalai',
            },
            zipcode: '72160',
          },
          720906: {
            name: {
              th: 'ดอนมะเกลือ',
              en: 'Don Makluea',
            },
            zipcode: '72220',
          },
          720907: {
            name: {
              th: 'หนองโอ่ง',
              en: 'Nong Ong',
            },
            zipcode: '72160',
          },
          720908: {
            name: {
              th: 'ดอนคา',
              en: 'Don Kha',
            },
            zipcode: '72160',
          },
          720909: {
            name: {
              th: 'พลับพลาไชย',
              en: 'Phlapphla Chai',
            },
            zipcode: '72160',
          },
          720910: {
            name: {
              th: 'บ้านโข้ง',
              en: 'Ban Khong',
            },
            zipcode: '72160',
          },
          720911: {
            name: {
              th: 'เจดีย์',
              en: 'Chedi',
            },
            zipcode: '72160',
          },
          720912: {
            name: {
              th: 'สระพังลาน',
              en: 'Sa Phang Lan',
            },
            zipcode: '72220',
          },
          720913: {
            name: {
              th: 'กระจัน',
              en: 'Kra Chan',
            },
            zipcode: '72160',
          },
        },
      },
      7210: {
        name: {
          th: 'หนองหญ้าไซ',
          en: 'Nong Yasai',
        },
        tambons: {
          721001: {
            name: {
              th: 'หนองหญ้าไซ',
              en: 'Nong Ya Sai',
            },
            zipcode: '72240',
          },
          721002: {
            name: {
              th: 'หนองราชวัตร',
              en: 'Nong Rathawat',
            },
            zipcode: '72240',
          },
          721003: {
            name: {
              th: 'หนองโพธิ์',
              en: 'Nong Pho',
            },
            zipcode: '72240',
          },
          721004: {
            name: {
              th: 'แจงงาม',
              en: 'Chaeng Ngam',
            },
            zipcode: '72240',
          },
          721005: {
            name: {
              th: 'หนองขาม',
              en: 'Nong Kham',
            },
            zipcode: '72240',
          },
          721006: {
            name: {
              th: 'ทัพหลวง',
              en: 'Thap Luang',
            },
            zipcode: '72240',
          },
        },
      },
    },
  },
  73: {
    name: {
      th: 'นครปฐม',
      en: 'Nakhon Pathom',
    },
    amphoes: {
      7301: {
        name: {
          th: 'เมืองนครปฐม',
          en: 'Muang',
        },
        tambons: {
          730101: {
            name: {
              th: 'พระปฐมเจดีย์',
              en: 'Phra Pathom Chedi',
            },
            zipcode: '73000',
          },
          730102: {
            name: {
              th: 'บางแขม',
              en: 'Bang Khaem',
            },
            zipcode: '73000',
          },
          730103: {
            name: {
              th: 'พระประโทน',
              en: 'Phra Prathon',
            },
            zipcode: '73000',
          },
          730104: {
            name: {
              th: 'ธรรมศาลา',
              en: 'Thammasala',
            },
            zipcode: '73000',
          },
          730105: {
            name: {
              th: 'ตาก้อง',
              en: 'Ta Kong',
            },
            zipcode: '73000',
          },
          730106: {
            name: {
              th: 'มาบแค',
              en: 'Map Khae',
            },
            zipcode: '73000',
          },
          730107: {
            name: {
              th: 'สนามจันทร์',
              en: 'Sanam Chan',
            },
            zipcode: '73000',
          },
          730108: {
            name: {
              th: 'ดอนยายหอม',
              en: 'Don Yai Hom',
            },
            zipcode: '73000',
          },
          730109: {
            name: {
              th: 'ถนนขาด',
              en: 'Thanon Khat',
            },
            zipcode: '73000',
          },
          730110: {
            name: {
              th: 'บ่อพลับ',
              en: 'Bo Phlap',
            },
            zipcode: '73000',
          },
          730111: {
            name: {
              th: 'นครปฐม',
              en: 'Nakhon Pathom',
            },
            zipcode: '73000',
          },
          730112: {
            name: {
              th: 'วังตะกู',
              en: 'Wang Taku',
            },
            zipcode: '73000',
          },
          730113: {
            name: {
              th: 'หนองปากโลง',
              en: 'Nong Pak Long',
            },
            zipcode: '73000',
          },
          730114: {
            name: {
              th: 'สามควายเผือก',
              en: 'Sam Khwai Phueak',
            },
            zipcode: '73000',
          },
          730115: {
            name: {
              th: 'ทุ่งน้อย',
              en: 'Thung Noi',
            },
            zipcode: '73000',
          },
          730116: {
            name: {
              th: 'หนองดินแดง',
              en: 'Nong Din Daeng',
            },
            zipcode: '73000',
          },
          730117: {
            name: {
              th: 'วังเย็น',
              en: 'Wang Yen',
            },
            zipcode: '73000',
          },
          730118: {
            name: {
              th: 'โพรงมะเดื่อ',
              en: 'Phrong Maduea',
            },
            zipcode: '73000',
          },
          730119: {
            name: {
              th: 'ลำพยา',
              en: 'Lam Phaya',
            },
            zipcode: '73000',
          },
          730120: {
            name: {
              th: 'สระกะเทียม',
              en: 'Sa Kathiam',
            },
            zipcode: '73000',
          },
          730121: {
            name: {
              th: 'สวนป่าน',
              en: 'Suan Pan',
            },
            zipcode: '73000',
          },
          730122: {
            name: {
              th: 'ห้วยจรเข้',
              en: 'Huai Chorakhe',
            },
            zipcode: '73000',
          },
          730123: {
            name: {
              th: 'ทัพหลวง',
              en: 'Thap Luang',
            },
            zipcode: '73000',
          },
          730124: {
            name: {
              th: 'หนองงูเหลือม',
              en: 'Nong Ngu Lueam',
            },
            zipcode: '73000',
          },
          730125: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '73000',
          },
        },
      },
      7302: {
        name: {
          th: 'กำแพงแสน',
          en: 'Kampheng Saen',
        },
        tambons: {
          730201: {
            name: {
              th: 'ทุ่งกระพังโหม',
              en: 'Thung Kraphang Hom',
            },
            zipcode: '73140',
          },
          730202: {
            name: {
              th: 'กระตีบ',
              en: 'Kratip',
            },
            zipcode: '73180',
          },
          730203: {
            name: {
              th: 'ทุ่งลูกนก',
              en: 'Thung Luk Nok',
            },
            zipcode: '73140',
          },
          730204: {
            name: {
              th: 'ห้วยขวาง',
              en: 'Huai Khwang',
            },
            zipcode: '73140',
          },
          730205: {
            name: {
              th: 'ทุ่งขวาง',
              en: 'Thung Khwang',
            },
            zipcode: '73140',
          },
          730206: {
            name: {
              th: 'สระสี่มุม',
              en: 'Sa Si Mum',
            },
            zipcode: '73140',
          },
          730207: {
            name: {
              th: 'ทุ่งบัว',
              en: 'Thung Bua',
            },
            zipcode: '73140',
          },
          730208: {
            name: {
              th: 'ดอนข่อย',
              en: 'Don Khoi',
            },
            zipcode: '73140',
          },
          730209: {
            name: {
              th: 'สระพัฒนา',
              en: 'Sa Phatthana',
            },
            zipcode: '73180',
          },
          730210: {
            name: {
              th: 'ห้วยหมอนทอง',
              en: 'Huai Mon Thong',
            },
            zipcode: '73140',
          },
          730211: {
            name: {
              th: 'ห้วยม่วง',
              en: 'Huai Muang',
            },
            zipcode: '73180',
          },
          730212: {
            name: {
              th: 'กำแพงแสน',
              en: 'Kamphaeng Saen',
            },
            zipcode: '73140',
          },
          730213: {
            name: {
              th: 'รางพิกุล',
              en: 'Rang Phikun',
            },
            zipcode: '73140',
          },
          730214: {
            name: {
              th: 'หนองกระทุ่ม',
              en: 'Nong Krathum',
            },
            zipcode: '73140',
          },
          730215: {
            name: {
              th: 'วังน้ำเขียว',
              en: 'Wang Nam Khiao',
            },
            zipcode: '73140',
          },
        },
      },
      7303: {
        name: {
          th: 'นครชัยศรี',
          en: 'Nakhon Chaisi',
        },
        tambons: {
          730301: {
            name: {
              th: 'นครชัยศรี',
              en: 'Nakhon Chai Si',
            },
            zipcode: '73120',
          },
          730302: {
            name: {
              th: 'บางกระเบา',
              en: 'Bang Krabao',
            },
            zipcode: '73120',
          },
          730303: {
            name: {
              th: 'วัดแค',
              en: 'Wat Khae',
            },
            zipcode: '73120',
          },
          730304: {
            name: {
              th: 'ท่าตำหนัก',
              en: 'Tha Tamnak',
            },
            zipcode: '73120',
          },
          730305: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '73120',
          },
          730306: {
            name: {
              th: 'ท่ากระชับ',
              en: 'Tha Krachap',
            },
            zipcode: '73120',
          },
          730307: {
            name: {
              th: 'ขุนแก้ว',
              en: 'Khun Kaeo',
            },
            zipcode: '73120',
          },
          730308: {
            name: {
              th: 'ท่าพระยา',
              en: 'Tha Phraya',
            },
            zipcode: '73120',
          },
          730309: {
            name: {
              th: 'พะเนียด',
              en: 'Phaniat',
            },
            zipcode: '73120',
          },
          730310: {
            name: {
              th: 'บางระกำ',
              en: 'Bang Rakam',
            },
            zipcode: '73120',
          },
          730311: {
            name: {
              th: 'โคกพระเจดีย์',
              en: 'Khok Phra Chedi',
            },
            zipcode: '73120',
          },
          730312: {
            name: {
              th: 'ศรีษะทอง',
              en: 'Sisa Thong',
            },
            zipcode: '73120',
          },
          730313: {
            name: {
              th: 'แหลมบัว',
              en: 'Laem Bua',
            },
            zipcode: '73120',
          },
          730314: {
            name: {
              th: 'ศรีมหาโพธิ์',
              en: 'Si Maha Pho',
            },
            zipcode: '73120',
          },
          730315: {
            name: {
              th: 'สัมปทวน',
              en: 'Sam Pot Won',
            },
            zipcode: '73120',
          },
          730316: {
            name: {
              th: 'วัดสำโรง',
              en: 'Wat Samrong',
            },
            zipcode: '73120',
          },
          730317: {
            name: {
              th: 'ดอนแฝก',
              en: 'Don Faek',
            },
            zipcode: '73120',
          },
          730318: {
            name: {
              th: 'ห้วยพลู',
              en: 'Huai Phlu',
            },
            zipcode: '73120',
          },
          730319: {
            name: {
              th: 'วัดละมุด',
              en: 'Wat Lamut',
            },
            zipcode: '73120',
          },
          730320: {
            name: {
              th: 'บางพระ',
              en: 'Bang Phra',
            },
            zipcode: '73120',
          },
          730321: {
            name: {
              th: 'บางแก้วฟ้า',
              en: 'Bang Kaeo Fa',
            },
            zipcode: '73120',
          },
          730322: {
            name: {
              th: 'ลานตากฟ้า',
              en: 'Lan Tak Fa',
            },
            zipcode: '73120',
          },
          730323: {
            name: {
              th: 'งิ้วราย',
              en: 'Ngio Rai',
            },
            zipcode: '73120',
          },
          730324: {
            name: {
              th: 'ไทยาวาส',
              en: 'Thaiyawat',
            },
            zipcode: '73120',
          },
        },
      },
      7304: {
        name: {
          th: 'ดอนตูม',
          en: 'Don Tom',
        },
        tambons: {
          730401: {
            name: {
              th: 'สามง่าม',
              en: 'Sam Ngam',
            },
            zipcode: '73150',
          },
          730402: {
            name: {
              th: 'ห้วยพระ',
              en: 'Huai Phra',
            },
            zipcode: '73150',
          },
          730403: {
            name: {
              th: 'ลำเหย',
              en: 'Lam Hoei',
            },
            zipcode: '73150',
          },
          730404: {
            name: {
              th: 'ดอนพุทรา',
              en: 'Don Phutsa',
            },
            zipcode: '73150',
          },
          730405: {
            name: {
              th: 'บ้านหลวง',
              en: 'Ban Luang',
            },
            zipcode: '73150',
          },
          730406: {
            name: {
              th: 'ดอนรวก',
              en: 'Don Ruak',
            },
            zipcode: '73150',
          },
          730407: {
            name: {
              th: 'ห้วยด้วน',
              en: 'Huai Duan',
            },
            zipcode: '73150',
          },
          730408: {
            name: {
              th: 'ลำลูกบัว',
              en: 'Lam Luk Bua',
            },
            zipcode: '73150',
          },
        },
      },
      7305: {
        name: {
          th: 'บางเลน',
          en: 'Bang Len',
        },
        tambons: {
          730501: {
            name: {
              th: 'บางเลน',
              en: 'Bang Len',
            },
            zipcode: '73130',
          },
          730502: {
            name: {
              th: 'บางปลา',
              en: 'Bang Pla',
            },
            zipcode: '73130',
          },
          730503: {
            name: {
              th: 'บางหลวง',
              en: 'Bang Luang',
            },
            zipcode: '73190',
          },
          730504: {
            name: {
              th: 'บางภาษี',
              en: 'Bang Phasi',
            },
            zipcode: '73130',
          },
          730505: {
            name: {
              th: 'บางระกำ',
              en: 'Bang Rakam',
            },
            zipcode: '73130',
          },
          730506: {
            name: {
              th: 'บางไทรป่า',
              en: 'Bang Sai Pa',
            },
            zipcode: '73130',
          },
          730507: {
            name: {
              th: 'หินมูล',
              en: 'Hin Mun',
            },
            zipcode: '73190',
          },
          730508: {
            name: {
              th: 'ไทรงาม',
              en: 'Sai Ngam',
            },
            zipcode: '73130',
          },
          730509: {
            name: {
              th: 'ดอนตูม',
              en: 'Don Tum',
            },
            zipcode: '73130',
          },
          730510: {
            name: {
              th: 'นิลเพชร',
              en: 'Nin Phet',
            },
            zipcode: '73130',
          },
          730511: {
            name: {
              th: 'บัวปากท่า',
              en: 'Bua Pak Tha',
            },
            zipcode: '73130',
          },
          730512: {
            name: {
              th: 'คลองนกกระทุง',
              en: 'Khlong Nok Krathung',
            },
            zipcode: '73130',
          },
          730513: {
            name: {
              th: 'นราภิรมย์',
              en: 'Naraphirom',
            },
            zipcode: '73130',
          },
          730514: {
            name: {
              th: 'ลำพญา',
              en: 'Lam Phaya',
            },
            zipcode: '73130',
          },
          730515: {
            name: {
              th: 'ไผ่หูช้าง',
              en: 'Phai Hu Chang',
            },
            zipcode: '73130',
          },
        },
      },
      7306: {
        name: {
          th: 'สามพราน',
          en: 'Sam Pharn',
        },
        tambons: {
          730601: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '73110',
          },
          730602: {
            name: {
              th: 'ทรงคนอง',
              en: 'Song Khanong',
            },
            zipcode: '73210',
          },
          730603: {
            name: {
              th: 'หอมเกร็ด',
              en: 'Hom Kret',
            },
            zipcode: '73110',
          },
          730604: {
            name: {
              th: 'บางกระทึก',
              en: 'Bang Krathuek',
            },
            zipcode: '73210',
          },
          730605: {
            name: {
              th: 'บางเตย',
              en: 'Bang Toei',
            },
            zipcode: '73210',
          },
          730606: {
            name: {
              th: 'สามพราน',
              en: 'Sam Phran',
            },
            zipcode: '73110',
          },
          730607: {
            name: {
              th: 'บางช้าง',
              en: 'Bang Chang',
            },
            zipcode: '73110',
          },
          730608: {
            name: {
              th: 'ไร่ขิง',
              en: 'Rai Khing',
            },
            zipcode: '73210',
          },
          730609: {
            name: {
              th: 'ท่าตลาด',
              en: 'Tha Talat',
            },
            zipcode: '73110',
          },
          730610: {
            name: {
              th: 'กระทุ่มล้ม',
              en: 'Krathum Lom',
            },
            zipcode: '73220',
          },
          730611: {
            name: {
              th: 'คลองใหม่',
              en: 'Khlong Mai',
            },
            zipcode: '73110',
          },
          730612: {
            name: {
              th: 'ตลาดจินดา',
              en: 'Talat Chinda',
            },
            zipcode: '73110',
          },
          730613: {
            name: {
              th: 'คลองจินดา',
              en: 'Khlong Chinda',
            },
            zipcode: '73110',
          },
          730614: {
            name: {
              th: 'ยายชา',
              en: 'Yai Cha',
            },
            zipcode: '73110',
          },
          730615: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '73110',
          },
          730616: {
            name: {
              th: 'อ้อมใหญ่',
              en: 'Om Yai',
            },
            zipcode: '73160',
          },
        },
      },
      7307: {
        name: {
          th: 'พุทธมณฑล',
          en: 'Buddha Monthon',
        },
        tambons: {
          730701: {
            name: {
              th: 'ศาลายา',
              en: 'Salaya',
            },
            zipcode: '73170',
          },
          730702: {
            name: {
              th: 'คลองโยง',
              en: 'Khlong Yong',
            },
            zipcode: '73170',
          },
          730703: {
            name: {
              th: 'มหาสวัสดิ์',
              en: 'Maha Sawat',
            },
            zipcode: '73170',
          },
        },
      },
    },
  },
  74: {
    name: {
      th: 'สมุทรสาคร',
      en: 'Samut Sakhon',
    },
    amphoes: {
      7401: {
        name: {
          th: 'เมืองสมุทรสาคร',
          en: 'Muang',
        },
        tambons: {
          740101: {
            name: {
              th: 'มหาชัย',
              en: 'Maha Chai',
            },
            zipcode: '74000',
          },
          740102: {
            name: {
              th: 'ท่าฉลอม',
              en: 'Tha Chalom',
            },
            zipcode: '74000',
          },
          740103: {
            name: {
              th: 'โกรกกราก',
              en: 'Krokkrak',
            },
            zipcode: '74000',
          },
          740104: {
            name: {
              th: 'บ้านบ่อ',
              en: 'Ban Bo',
            },
            zipcode: '74000',
          },
          740105: {
            name: {
              th: 'บางโทรัด',
              en: 'Bang Tho Rat',
            },
            zipcode: '74000',
          },
          740106: {
            name: {
              th: 'กาหลง',
              en: 'Kalong',
            },
            zipcode: '74000',
          },
          740107: {
            name: {
              th: 'นาโคก',
              en: 'Na Khok',
            },
            zipcode: '74000',
          },
          740108: {
            name: {
              th: 'ท่าจีน',
              en: 'Tha Chin',
            },
            zipcode: '74000',
          },
          740109: {
            name: {
              th: 'นาดี',
              en: 'Na Di',
            },
            zipcode: '74000',
          },
          740110: {
            name: {
              th: 'ท่าทราย',
              en: 'Tha Sai',
            },
            zipcode: '74000',
          },
          740111: {
            name: {
              th: 'คอกกระบือ',
              en: 'Khok Krabue',
            },
            zipcode: '74000',
          },
          740112: {
            name: {
              th: 'บางน้ำจืด',
              en: 'Bang Nam Chuet',
            },
            zipcode: '74000',
          },
          740113: {
            name: {
              th: 'พันท้ายนรสิงห์',
              en: 'Phanthai Norasing',
            },
            zipcode: '74000',
          },
          740114: {
            name: {
              th: 'โคกขาม',
              en: 'Khok Kham',
            },
            zipcode: '74000',
          },
          740115: {
            name: {
              th: 'บ้านเกาะ',
              en: 'Ban Ko',
            },
            zipcode: '74000',
          },
          740116: {
            name: {
              th: 'บางกระเจ้า',
              en: 'Bang Krachao',
            },
            zipcode: '74000',
          },
          740117: {
            name: {
              th: 'บางหญ้าแพรก',
              en: 'Bang Ya Phraek',
            },
            zipcode: '74000',
          },
          740118: {
            name: {
              th: 'ชัยมงคล',
              en: 'Chai Mongkhon',
            },
            zipcode: '74000',
          },
        },
      },
      7402: {
        name: {
          th: 'กระทุ่มแบน',
          en: 'Krathumbaen',
        },
        tambons: {
          740201: {
            name: {
              th: 'ตลาดกระทุ่มแบน',
              en: 'Talat Krathum Baen',
            },
            zipcode: '74110',
          },
          740202: {
            name: {
              th: 'อ้อมน้อย',
              en: 'Om Noi',
            },
            zipcode: '74130',
          },
          740203: {
            name: {
              th: 'ท่าไม้',
              en: 'Tha Mai',
            },
            zipcode: '74110',
          },
          740204: {
            name: {
              th: 'สวนหลวง',
              en: 'Suan Luang',
            },
            zipcode: '74110',
          },
          740205: {
            name: {
              th: 'บางยาง',
              en: 'Bang Yang',
            },
            zipcode: '74110',
          },
          740206: {
            name: {
              th: 'คลองมะเดื่อ',
              en: 'Khlong Maduea',
            },
            zipcode: '74110',
          },
          740207: {
            name: {
              th: 'หนองนกไข่',
              en: 'Nong Nok Khai',
            },
            zipcode: '74110',
          },
          740208: {
            name: {
              th: 'ดอนไก่ดี',
              en: 'Don Kai Di',
            },
            zipcode: '74110',
          },
          740209: {
            name: {
              th: 'แคราย',
              en: 'Khae Rai',
            },
            zipcode: '74110',
          },
          740210: {
            name: {
              th: 'ท่าเสา',
              en: 'Tha Sao',
            },
            zipcode: '74110',
          },
        },
      },
      7403: {
        name: {
          th: 'บ้านแพ้ว',
          en: 'Ban Phaeo',
        },
        tambons: {
          740301: {
            name: {
              th: 'บ้านแพ้ว',
              en: 'Ban Phaeo',
            },
            zipcode: '74120',
          },
          740302: {
            name: {
              th: 'หลักสาม',
              en: 'Lak Sam',
            },
            zipcode: '74120',
          },
          740303: {
            name: {
              th: 'ยกกระบัตร',
              en: 'Yokkrabat',
            },
            zipcode: '74120',
          },
          740304: {
            name: {
              th: 'โรงเข้',
              en: 'Rong Khe',
            },
            zipcode: '74120',
          },
          740305: {
            name: {
              th: 'หนองสองห้อง',
              en: 'Nong Song Hong',
            },
            zipcode: '74120',
          },
          740306: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '74120',
          },
          740307: {
            name: {
              th: 'หลักสอง',
              en: 'Lak Song',
            },
            zipcode: '74120',
          },
          740308: {
            name: {
              th: 'เจ็ดริ้ว',
              en: 'Chet Rio',
            },
            zipcode: '74120',
          },
          740309: {
            name: {
              th: 'คลองตัน',
              en: 'Khlong Tan',
            },
            zipcode: '74120',
          },
          740310: {
            name: {
              th: 'อำแพง',
              en: 'Amphaeng',
            },
            zipcode: '74120',
          },
          740311: {
            name: {
              th: 'สวนส้ม',
              en: 'Suan Som',
            },
            zipcode: '74120',
          },
          740312: {
            name: {
              th: 'เกษตรพัฒนา',
              en: 'Kaset Phatthana',
            },
            zipcode: '74120',
          },
        },
      },
    },
  },
  75: {
    name: {
      th: 'สมุทรสงคราม',
      en: 'Samut Songkram',
    },
    amphoes: {
      7501: {
        name: {
          th: 'เมืองสมุทรสงคราม',
          en: 'Muang',
        },
        tambons: {
          750101: {
            name: {
              th: 'แม่กลอง',
              en: 'Mae Khlong',
            },
            zipcode: '75000',
          },
          750102: {
            name: {
              th: 'บางขันแตก',
              en: 'Bang Khan Taek',
            },
            zipcode: '75000',
          },
          750103: {
            name: {
              th: 'ลาดใหญ่',
              en: 'Lat Yai',
            },
            zipcode: '75000',
          },
          750104: {
            name: {
              th: 'บ้านปรก',
              en: 'Ban Prok',
            },
            zipcode: '75000',
          },
          750105: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '75000',
          },
          750106: {
            name: {
              th: 'ท้ายหาด',
              en: 'Thai Hat',
            },
            zipcode: '75000',
          },
          750107: {
            name: {
              th: 'แหลมใหญ่',
              en: 'Laem Yai',
            },
            zipcode: '75000',
          },
          750108: {
            name: {
              th: 'คลองเขิน',
              en: 'Khlong Khoen',
            },
            zipcode: '75000',
          },
          750109: {
            name: {
              th: 'คลองโคน',
              en: 'Khlong Khon',
            },
            zipcode: '75000',
          },
          750110: {
            name: {
              th: 'นางตะเคียน',
              en: 'Nang Takhian',
            },
            zipcode: '75000',
          },
          750111: {
            name: {
              th: 'บางจะเกร็ง',
              en: 'Bang Chakreng',
            },
            zipcode: '75000',
          },
        },
      },
      7502: {
        name: {
          th: 'บางคนที',
          en: 'Bang Khonthi',
        },
        tambons: {
          750201: {
            name: {
              th: 'กระดังงา',
              en: 'Kradang-nga',
            },
            zipcode: '75120',
          },
          750202: {
            name: {
              th: 'บางสะแก',
              en: 'Bang Sakae',
            },
            zipcode: '75120',
          },
          750203: {
            name: {
              th: 'บางยี่รงค์',
              en: 'Bang Yi Rong',
            },
            zipcode: '75120',
          },
          750204: {
            name: {
              th: 'โรงหีบ',
              en: 'Rong Hip',
            },
            zipcode: '75120',
          },
          750205: {
            name: {
              th: 'บางคนที',
              en: 'Bang Khonthi',
            },
            zipcode: '75120',
          },
          750206: {
            name: {
              th: 'ดอนมะโนรา',
              en: 'Don Manora',
            },
            zipcode: '75120',
          },
          750207: {
            name: {
              th: 'บางพรม',
              en: 'Bang Phrom',
            },
            zipcode: '75120',
          },
          750208: {
            name: {
              th: 'บางกุ้ง',
              en: 'Bang Kung',
            },
            zipcode: '75120',
          },
          750209: {
            name: {
              th: 'จอมปลวก',
              en: 'Chom Pluak',
            },
            zipcode: '75120',
          },
          750210: {
            name: {
              th: 'บางนกแขวก',
              en: 'Bang Nok Khwaek',
            },
            zipcode: '75120',
          },
          750211: {
            name: {
              th: 'ยายแพง',
              en: 'Yai Phaeng',
            },
            zipcode: '75120',
          },
          750212: {
            name: {
              th: 'บางกระบือ',
              en: 'Bang Krabue',
            },
            zipcode: '75120',
          },
          750213: {
            name: {
              th: 'บ้านปราโมทย์',
              en: 'Ban Pramot',
            },
            zipcode: '75120',
          },
        },
      },
      7503: {
        name: {
          th: 'อัมพวา',
          en: 'Amphawa',
        },
        tambons: {
          750301: {
            name: {
              th: 'อัมพวา',
              en: 'Amphawa',
            },
            zipcode: '75110',
          },
          750302: {
            name: {
              th: 'สวนหลวง',
              en: 'Suan Luang',
            },
            zipcode: '75110',
          },
          750303: {
            name: {
              th: 'ท่าคา',
              en: 'Tha Kha',
            },
            zipcode: '75110',
          },
          750304: {
            name: {
              th: 'วัดประดู่',
              en: 'Wat Pradu',
            },
            zipcode: '75110',
          },
          750305: {
            name: {
              th: 'เหมืองใหม่',
              en: 'Mueang Mai',
            },
            zipcode: '75110',
          },
          750306: {
            name: {
              th: 'บางช้าง',
              en: 'Bang Chang',
            },
            zipcode: '75110',
          },
          750307: {
            name: {
              th: 'แควอ้อม',
              en: 'Khwae Om',
            },
            zipcode: '75110',
          },
          750308: {
            name: {
              th: 'ปลายโพงพาง',
              en: 'Plai Phongphang',
            },
            zipcode: '75110',
          },
          750309: {
            name: {
              th: 'บางแค',
              en: 'Bang Khae',
            },
            zipcode: '75110',
          },
          750310: {
            name: {
              th: 'แพรกหนามแดง',
              en: 'Phraek Nam Daeng',
            },
            zipcode: '75110',
          },
          750311: {
            name: {
              th: 'ยี่สาร',
              en: 'Yisan',
            },
            zipcode: '75110',
          },
          750312: {
            name: {
              th: 'บางนางลี่',
              en: 'Bang Nang Li',
            },
            zipcode: '75110',
          },
        },
      },
    },
  },
  76: {
    name: {
      th: 'เพชรบุรี',
      en: 'Phetchaburi',
    },
    amphoes: {
      7601: {
        name: {
          th: 'เมืองเพชรบุรี',
          en: 'Muang',
        },
        tambons: {
          760101: {
            name: {
              th: 'ท่าราบ',
              en: 'Tha Rap',
            },
            zipcode: '76000',
          },
          760102: {
            name: {
              th: 'คลองกระแชง',
              en: 'Khlong Krachaeng',
            },
            zipcode: '76000',
          },
          760103: {
            name: {
              th: 'บางจาน',
              en: 'Bang Chan',
            },
            zipcode: '76000',
          },
          760104: {
            name: {
              th: 'นาพันสาม',
              en: 'Na Phan Sam',
            },
            zipcode: '76000',
          },
          760105: {
            name: {
              th: 'ธงชัย',
              en: 'Thong Chai',
            },
            zipcode: '76000',
          },
          760106: {
            name: {
              th: 'บ้านกุ่ม',
              en: 'Ban Kum',
            },
            zipcode: '76000',
          },
          760107: {
            name: {
              th: 'หนองโสน',
              en: 'Nong Sano',
            },
            zipcode: '76000',
          },
          760108: {
            name: {
              th: 'ไร่ส้ม',
              en: 'Rai Som',
            },
            zipcode: '76000',
          },
          760109: {
            name: {
              th: 'เวียงคอย',
              en: 'Wiang Khoi',
            },
            zipcode: '76000',
          },
          760110: {
            name: {
              th: 'บางจาก',
              en: 'Bang Chak',
            },
            zipcode: '76000',
          },
          760111: {
            name: {
              th: 'บ้านหม้อ',
              en: 'Ban Mo',
            },
            zipcode: '76000',
          },
          760112: {
            name: {
              th: 'ต้นมะม่วง',
              en: 'Ton Mamuang',
            },
            zipcode: '76000',
          },
          760113: {
            name: {
              th: 'ช่องสะแก',
              en: 'Chong Sakae',
            },
            zipcode: '76000',
          },
          760114: {
            name: {
              th: 'นาวุ้ง',
              en: 'Na Wung',
            },
            zipcode: '76000',
          },
          760115: {
            name: {
              th: 'สำมะโรง',
              en: 'Sam Marong',
            },
            zipcode: '76000',
          },
          760116: {
            name: {
              th: 'โพพระ',
              en: 'Pho Phra',
            },
            zipcode: '76000',
          },
          760117: {
            name: {
              th: 'หาดเจ้าสำราญ',
              en: 'Hat Chao Samran',
            },
            zipcode: '76100',
          },
          760118: {
            name: {
              th: 'หัวสะพาน',
              en: 'Hua Saphan',
            },
            zipcode: '76000',
          },
          760119: {
            name: {
              th: 'ต้นมะพร้าว',
              en: 'Ton Maphrao',
            },
            zipcode: '76000',
          },
          760120: {
            name: {
              th: 'วังตะโก',
              en: 'Wang Tako',
            },
            zipcode: '76000',
          },
          760121: {
            name: {
              th: 'โพไร่หวาน',
              en: 'Pho Rai Wan',
            },
            zipcode: '76000',
          },
          760122: {
            name: {
              th: 'ดอนยาง',
              en: 'Don Yang',
            },
            zipcode: '76000',
          },
          760123: {
            name: {
              th: 'หนองขนาน',
              en: 'Nong Khanan',
            },
            zipcode: '76000',
          },
          760124: {
            name: {
              th: 'หนองพลับ',
              en: 'Nong Phlap',
            },
            zipcode: '76000',
          },
        },
      },
      7602: {
        name: {
          th: 'เขาย้อย',
          en: 'Khao Yoi',
        },
        tambons: {
          760201: {
            name: {
              th: 'เขาย้อย',
              en: 'Khao Yoi',
            },
            zipcode: '76140',
          },
          760202: {
            name: {
              th: 'สระพัง',
              en: 'Sa Phang',
            },
            zipcode: '76140',
          },
          760203: {
            name: {
              th: 'บางเค็ม',
              en: 'Bang Khem',
            },
            zipcode: '76140',
          },
          760204: {
            name: {
              th: 'ทับคาง',
              en: 'Thap Khang',
            },
            zipcode: '76140',
          },
          760205: {
            name: {
              th: 'หนองปลาไหล',
              en: 'Nong Pla Lai',
            },
            zipcode: '76140',
          },
          760206: {
            name: {
              th: 'หนองปรง',
              en: 'Nong Prong',
            },
            zipcode: '76140',
          },
          760207: {
            name: {
              th: 'หนองชุมพล',
              en: 'Nong Chumphon',
            },
            zipcode: '76140',
          },
          760208: {
            name: {
              th: 'ห้วยโรง',
              en: 'Huai Rong',
            },
            zipcode: '76140',
          },
          760209: {
            name: {
              th: 'ห้วยท่าช้าง',
              en: 'Huai Tha Chang',
            },
            zipcode: '76140',
          },
          760210: {
            name: {
              th: 'หนองชุมพลเหนือ',
              en: 'Nong Chumphon Nuea',
            },
            zipcode: '76140',
          },
        },
      },
      7603: {
        name: {
          th: 'หนองหญ้าปล้อง',
          en: 'Nong Ya Plong',
        },
        tambons: {
          760301: {
            name: {
              th: 'หนองหญ้าปล้อง',
              en: 'Nong Ya Plong',
            },
            zipcode: '76160',
          },
          760302: {
            name: {
              th: 'ยางน้ำกลัดเหนือ',
              en: 'Yang Nam Klat Nuea',
            },
            zipcode: '76160',
          },
          760303: {
            name: {
              th: 'ยางน้ำกลัดใต้',
              en: 'Yang Nam Klat Tai',
            },
            zipcode: '76160',
          },
          760304: {
            name: {
              th: 'ท่าตะคร้อ',
              en: 'Tha Takhro',
            },
            zipcode: '76160',
          },
        },
      },
      7604: {
        name: {
          th: 'ชะอำ',
          en: 'Cha-Am',
        },
        tambons: {
          760401: {
            name: {
              th: 'ชะอำ',
              en: 'Cha-am',
            },
            zipcode: '76120',
          },
          760402: {
            name: {
              th: 'บางเก่า',
              en: 'Bang Kao',
            },
            zipcode: '76120',
          },
          760403: {
            name: {
              th: 'นายาง',
              en: 'Na Yang',
            },
            zipcode: '76120',
          },
          760404: {
            name: {
              th: 'เขาใหญ่',
              en: 'Khao Yai',
            },
            zipcode: '76120',
          },
          760405: {
            name: {
              th: 'หนองศาลา',
              en: 'Nong Sala',
            },
            zipcode: '76120',
          },
          760406: {
            name: {
              th: 'ห้วยทรายเหนือ',
              en: 'Huai Sai Nuea',
            },
            zipcode: '76120',
          },
          760407: {
            name: {
              th: 'ไร่ใหม่พัฒนา',
              en: 'Rai Mai Phatthana',
            },
            zipcode: '76120',
          },
          760408: {
            name: {
              th: 'สามพระยา',
              en: 'Sam Phraya',
            },
            zipcode: '76120',
          },
          760409: {
            name: {
              th: 'ดอนขุนห้วย',
              en: 'Don Khun Huai',
            },
            zipcode: '76120',
          },
        },
      },
      7605: {
        name: {
          th: 'ท่ายาง',
          en: 'Tha Yang',
        },
        tambons: {
          760501: {
            name: {
              th: 'ท่ายาง',
              en: 'Tha Yang',
            },
            zipcode: '76130',
          },
          760502: {
            name: {
              th: 'ท่าคอย',
              en: 'Tha Khoi',
            },
            zipcode: '76130',
          },
          760503: {
            name: {
              th: 'ยางหย่อง',
              en: 'Yang Yong',
            },
            zipcode: '76130',
          },
          760504: {
            name: {
              th: 'หนองจอก',
              en: 'Nong Chok',
            },
            zipcode: '76130',
          },
          760505: {
            name: {
              th: 'มาบปลาเค้า',
              en: 'Map Pla Khao',
            },
            zipcode: '76130',
          },
          760506: {
            name: {
              th: 'ท่าไม้รวก',
              en: 'Tha Mai Ruak',
            },
            zipcode: '76130',
          },
          760507: {
            name: {
              th: 'วังไคร้',
              en: 'Wang Khrai',
            },
            zipcode: '76130',
          },
          760511: {
            name: {
              th: 'กลัดหลวง',
              en: 'Klat Luang',
            },
            zipcode: '76130',
          },
          760512: {
            name: {
              th: 'ปึกเตียน',
              en: 'Puek Tian',
            },
            zipcode: '76130',
          },
          760513: {
            name: {
              th: 'เขากระปุก',
              en: 'Khao Krapuk',
            },
            zipcode: '76130',
          },
          760514: {
            name: {
              th: 'ท่าแลง',
              en: 'Tha Laeng',
            },
            zipcode: '76130',
          },
          760515: {
            name: {
              th: 'บ้านในดง',
              en: 'Ban Nai Dong',
            },
            zipcode: '76130',
          },
        },
      },
      7606: {
        name: {
          th: 'บ้านลาด',
          en: 'Ban Lat',
        },
        tambons: {
          760601: {
            name: {
              th: 'บ้านลาด',
              en: 'Ban Lat',
            },
            zipcode: '76150',
          },
          760602: {
            name: {
              th: 'บ้านหาด',
              en: 'Ban Hat',
            },
            zipcode: '76150',
          },
          760603: {
            name: {
              th: 'บ้านทาน',
              en: 'Ban Than',
            },
            zipcode: '76150',
          },
          760604: {
            name: {
              th: 'ตำหรุ',
              en: 'Tamru',
            },
            zipcode: '76150',
          },
          760605: {
            name: {
              th: 'สมอพลือ',
              en: 'Samo Phlue',
            },
            zipcode: '76150',
          },
          760606: {
            name: {
              th: 'ไร่มะขาม',
              en: 'Rai Makham',
            },
            zipcode: '76150',
          },
          760607: {
            name: {
              th: 'ท่าเสน',
              en: 'Tha Sen',
            },
            zipcode: '76150',
          },
          760608: {
            name: {
              th: 'หนองกระเจ็ด',
              en: 'Nong Krachet',
            },
            zipcode: '76150',
          },
          760609: {
            name: {
              th: 'หนองกะปุ',
              en: 'Nong Kapu',
            },
            zipcode: '76150',
          },
          760610: {
            name: {
              th: 'ลาดโพธิ์',
              en: 'Lat Pho',
            },
            zipcode: '76150',
          },
          760611: {
            name: {
              th: 'สะพานไกร',
              en: 'Saphan Krai',
            },
            zipcode: '76150',
          },
          760612: {
            name: {
              th: 'ไร่โคก',
              en: 'Rai Khok',
            },
            zipcode: '76150',
          },
          760613: {
            name: {
              th: 'โรงเข้',
              en: 'Rong Khe',
            },
            zipcode: '76150',
          },
          760614: {
            name: {
              th: 'ไร่สะท้อน',
              en: 'Rai Sathon',
            },
            zipcode: '76150',
          },
          760615: {
            name: {
              th: 'ห้วยข้อง',
              en: 'Huai Khong',
            },
            zipcode: '76150',
          },
          760616: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '76150',
          },
          760617: {
            name: {
              th: 'ถ้ำรงค์',
              en: 'Tham Rong',
            },
            zipcode: '76150',
          },
          760618: {
            name: {
              th: 'ห้วยลึก',
              en: 'Huai Luek',
            },
            zipcode: '76150',
          },
        },
      },
      7607: {
        name: {
          th: 'บ้านแหลม',
          en: 'Ban Laern',
        },
        tambons: {
          760701: {
            name: {
              th: 'บ้านแหลม',
              en: 'Ban Laem',
            },
            zipcode: '76110',
          },
          760702: {
            name: {
              th: 'บางขุนไทร',
              en: 'Bang Khun Sai',
            },
            zipcode: '76110',
          },
          760703: {
            name: {
              th: 'ปากทะเล',
              en: 'Pak Thale',
            },
            zipcode: '76110',
          },
          760704: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '76110',
          },
          760705: {
            name: {
              th: 'แหลมผักเบี้ย',
              en: 'Laem Phak Bia',
            },
            zipcode: '76100',
          },
          760706: {
            name: {
              th: 'บางตะบูน',
              en: 'Bang Tabun',
            },
            zipcode: '76110',
          },
          760707: {
            name: {
              th: 'บางตะบูนออก',
              en: 'Bang Tabun Ok',
            },
            zipcode: '76110',
          },
          760708: {
            name: {
              th: 'บางครก',
              en: 'Bang Khrok',
            },
            zipcode: '76110',
          },
          760709: {
            name: {
              th: 'ท่าแร้ง',
              en: 'Tha Raeng',
            },
            zipcode: '76110',
          },
          760710: {
            name: {
              th: 'ท่าแร้งออก',
              en: 'Tha Raeng Ok',
            },
            zipcode: '76110',
          },
        },
      },
      7608: {
        name: {
          th: 'แก่งกระจาน',
          en: 'Kaeng Krachan',
        },
        tambons: {
          760801: {
            name: {
              th: 'แก่งกระจาน',
              en: 'Kaeng Krachan',
            },
            zipcode: '76170',
          },
          760802: {
            name: {
              th: 'สองพี่น้อง',
              en: 'Song Phi Nong',
            },
            zipcode: '76170',
          },
          760803: {
            name: {
              th: 'วังจันทร์',
              en: 'Wang Chan',
            },
            zipcode: '76170',
          },
          760804: {
            name: {
              th: 'ป่าเด็ง',
              en: 'Pa Deng',
            },
            zipcode: '76170',
          },
          760805: {
            name: {
              th: 'พุสวรรค์',
              en: 'Phu Sawan',
            },
            zipcode: '76170',
          },
          760806: {
            name: {
              th: 'ห้วยแม่เพรียง',
              en: 'Huai Mae Phriang',
            },
            zipcode: '76170',
          },
        },
      },
    },
  },
  77: {
    name: {
      th: 'ประจวบคีรีขันธ์',
      en: 'Prachuap Khiri Khan',
    },
    amphoes: {
      7701: {
        name: {
          th: 'เมืองประจวบคีรีขันธ์',
          en: 'Muang',
        },
        tambons: {
          770101: {
            name: {
              th: 'ประจวบคีรีขันธ์',
              en: 'Prachuap Khiri Khan',
            },
            zipcode: '77000',
          },
          770102: {
            name: {
              th: 'เกาะหลัก',
              en: 'Ko Lak',
            },
            zipcode: '77000',
          },
          770103: {
            name: {
              th: 'คลองวาฬ',
              en: 'Khlong Wan',
            },
            zipcode: '77000',
          },
          770104: {
            name: {
              th: 'ห้วยทราย',
              en: 'Huai Sai',
            },
            zipcode: '77000',
          },
          770105: {
            name: {
              th: 'อ่าวน้อย',
              en: 'Ao Noi',
            },
            zipcode: '77000',
          },
          770106: {
            name: {
              th: 'บ่อนอก',
              en: 'Bo Nok',
            },
            zipcode: '77210',
          },
        },
      },
      7702: {
        name: {
          th: 'กุยบุรี',
          en: 'Kuiburi',
        },
        tambons: {
          770201: {
            name: {
              th: 'กุยบุรี',
              en: 'Kui Buri',
            },
            zipcode: '77150',
          },
          770202: {
            name: {
              th: 'กุยเหนือ',
              en: 'Kui Nuea',
            },
            zipcode: '77150',
          },
          770203: {
            name: {
              th: 'เขาแดง',
              en: 'Khao Daeng',
            },
            zipcode: '77150',
          },
          770204: {
            name: {
              th: 'ดอนยายหนู',
              en: 'Don Yai Nu',
            },
            zipcode: '77150',
          },
          770206: {
            name: {
              th: 'สามกระทาย',
              en: 'Sam Krathai',
            },
            zipcode: '77150',
          },
          770207: {
            name: {
              th: 'หาดขาม',
              en: 'Hat Kham',
            },
            zipcode: '77150',
          },
        },
      },
      7703: {
        name: {
          th: 'ทับสะแก',
          en: 'Thap Sakae',
        },
        tambons: {
          770301: {
            name: {
              th: 'ทับสะแก',
              en: 'Thap Sakae',
            },
            zipcode: '77130',
          },
          770302: {
            name: {
              th: 'อ่างทอง',
              en: 'Ang Thong',
            },
            zipcode: '77130',
          },
          770303: {
            name: {
              th: 'นาหูกวาง',
              en: 'Na Hu Kwang',
            },
            zipcode: '77130',
          },
          770304: {
            name: {
              th: 'เขาล้าน',
              en: 'Khao Lan',
            },
            zipcode: '77130',
          },
          770305: {
            name: {
              th: 'ห้วยยาง',
              en: 'Huai Yang',
            },
            zipcode: '77130',
          },
          770306: {
            name: {
              th: 'แสงอรุณ',
              en: 'Saeng Arun',
            },
            zipcode: '77130',
          },
        },
      },
      7704: {
        name: {
          th: 'บางสะพาน',
          en: 'Bang Saphan',
        },
        tambons: {
          770401: {
            name: {
              th: 'กำเนิดนพคุณ',
              en: 'Kamnoet Nopphakhun',
            },
            zipcode: '77140',
          },
          770402: {
            name: {
              th: 'พงศ์ประศาสน์',
              en: 'Phong Prasat',
            },
            zipcode: '77140',
          },
          770403: {
            name: {
              th: 'ร่อนทอง',
              en: 'Ron Thong',
            },
            zipcode: '77230',
          },
          770404: {
            name: {
              th: 'ธงชัย',
              en: 'Thong Chai',
            },
            zipcode: '77190',
          },
          770405: {
            name: {
              th: 'ชัยเกษม',
              en: 'Chai Kasem',
            },
            zipcode: '77190',
          },
          770406: {
            name: {
              th: 'ทองมงคล',
              en: 'Thong Mongkhon',
            },
            zipcode: '77230',
          },
          770407: {
            name: {
              th: 'แม่รำพึง',
              en: 'Mae Ramphueng',
            },
            zipcode: '77140',
          },
        },
      },
      7705: {
        name: {
          th: 'บางสะพานน้อย',
          en: 'Bang Saphan Noi',
        },
        tambons: {
          770501: {
            name: {
              th: 'ปากแพรก',
              en: 'Pak Phraek',
            },
            zipcode: '77170',
          },
          770502: {
            name: {
              th: 'บางสะพาน',
              en: 'Bang Saphan',
            },
            zipcode: '77170',
          },
          770503: {
            name: {
              th: 'ทรายทอง',
              en: 'Sai Thong',
            },
            zipcode: '77170',
          },
          770504: {
            name: {
              th: 'ช้างแรก',
              en: 'Chang Raek',
            },
            zipcode: '77170',
          },
          770505: {
            name: {
              th: 'ไชยราช',
              en: 'Chaiyarit',
            },
            zipcode: '77170',
          },
        },
      },
      7706: {
        name: {
          th: 'ปราณบุรี',
          en: 'Pran Buri',
        },
        tambons: {
          770601: {
            name: {
              th: 'ปราณบุรี',
              en: 'Pran Buri',
            },
            zipcode: '77120',
          },
          770602: {
            name: {
              th: 'เขาน้อย',
              en: 'Khao Noi',
            },
            zipcode: '77120',
          },
          770604: {
            name: {
              th: 'ปากน้ำปราณ',
              en: 'Pak Nam Pran',
            },
            zipcode: '77220',
          },
          770607: {
            name: {
              th: 'หนองตาแต้ม',
              en: 'Nong Ta Taem',
            },
            zipcode: '77120',
          },
          770608: {
            name: {
              th: 'วังก์พง',
              en: 'Wang Phong',
            },
            zipcode: '77120',
          },
          770609: {
            name: {
              th: 'เขาจ้าว',
              en: 'Khao Chao',
            },
            zipcode: '77120',
          },
        },
      },
      7707: {
        name: {
          th: 'หัวหิน',
          en: 'Hua Hin',
        },
        tambons: {
          770701: {
            name: {
              th: 'หัวหิน',
              en: 'Hua Hin',
            },
            zipcode: '77110',
          },
          770702: {
            name: {
              th: 'หนองแก',
              en: 'Nong Kae',
            },
            zipcode: '77110',
          },
          770703: {
            name: {
              th: 'หินเหล็กไฟ',
              en: 'Hin Lek Fai',
            },
            zipcode: '77110',
          },
          770704: {
            name: {
              th: 'หนองพลับ',
              en: 'Nong Phlap',
            },
            zipcode: '77110',
          },
          770705: {
            name: {
              th: 'ทับใต้',
              en: 'Thap Tai',
            },
            zipcode: '77110',
          },
          770706: {
            name: {
              th: 'ห้วยสัตว์ใหญ่',
              en: 'Huai sat Yai',
            },
            zipcode: '77110',
          },
          770707: {
            name: {
              th: 'บึงนคร',
              en: 'Bueng Nakhon',
            },
            zipcode: '77110',
          },
        },
      },
      7708: {
        name: {
          th: 'สามร้อยยอด',
          en: 'King Amphoe Sam Roi Yot',
        },
        tambons: {
          770801: {
            name: {
              th: 'สามร้อยยอด',
              en: 'Sam Roi Yot',
            },
            zipcode: '77120',
          },
          770802: {
            name: {
              th: 'ศิลาลอย',
              en: 'Sila Loi',
            },
            zipcode: '77180',
          },
          770803: {
            name: {
              th: 'ไร่เก่า',
              en: 'Rai Kao',
            },
            zipcode: '77180',
          },
          770804: {
            name: {
              th: 'ศาลาลัย',
              en: 'Salalai',
            },
            zipcode: '77180',
          },
          770805: {
            name: {
              th: 'ไร่ใหม่',
              en: 'Rai Mai',
            },
            zipcode: '77180',
          },
        },
      },
    },
  },
  80: {
    name: {
      th: 'นครศรีธรรมราช',
      en: 'Nakhon Si Thammarat',
    },
    amphoes: {
      8001: {
        name: {
          th: 'เมืองนครศรีธรรมราช',
          en: 'Muang',
        },
        tambons: {
          800101: {
            name: {
              th: 'ในเมือง',
              en: 'Nai Mueang',
            },
            zipcode: '80000',
          },
          800102: {
            name: {
              th: 'ท่าวัง',
              en: 'Tha Wang',
            },
            zipcode: '80000',
          },
          800103: {
            name: {
              th: 'คลัง',
              en: 'Khlang',
            },
            zipcode: '80000',
          },
          800106: {
            name: {
              th: 'ท่าไร่',
              en: 'Tha Rai',
            },
            zipcode: '80000',
          },
          800107: {
            name: {
              th: 'ปากนคร',
              en: 'Pak Nakhon',
            },
            zipcode: '80000',
          },
          800108: {
            name: {
              th: 'นาทราย',
              en: 'Na Sai',
            },
            zipcode: '80280',
          },
          800112: {
            name: {
              th: 'กำแพงเซา',
              en: 'Kamphaeng Sao',
            },
            zipcode: '80280',
          },
          800113: {
            name: {
              th: 'ไชยมนตรี',
              en: 'Chaiyamontri',
            },
            zipcode: '80000',
          },
          800114: {
            name: {
              th: 'มะม่วงสองต้น',
              en: 'Mamuang Song Ton',
            },
            zipcode: '80000',
          },
          800115: {
            name: {
              th: 'นาเคียน',
              en: 'Na Khian',
            },
            zipcode: '80000',
          },
          800116: {
            name: {
              th: 'ท่างิ้ว',
              en: 'Tha Ngio',
            },
            zipcode: '80280',
          },
          800118: {
            name: {
              th: 'โพธิ์เสด็จ',
              en: 'Pho Sadet',
            },
            zipcode: '80000',
          },
          800119: {
            name: {
              th: 'บางจาก',
              en: 'Bang Chak',
            },
            zipcode: '80330',
          },
          800120: {
            name: {
              th: 'ปากพูน',
              en: 'Pak Phun',
            },
            zipcode: '80000',
          },
          800121: {
            name: {
              th: 'ท่าซัก',
              en: 'Tha Sak',
            },
            zipcode: '80000',
          },
          800122: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '80000',
          },
        },
      },
      8002: {
        name: {
          th: 'พรหมคีรี',
          en: 'Phrom Khire',
        },
        tambons: {
          800201: {
            name: {
              th: 'พรหมโลก',
              en: 'Phrommalok',
            },
            zipcode: '80320',
          },
          800202: {
            name: {
              th: 'บ้านเกาะ',
              en: 'Ban Ko',
            },
            zipcode: '80320',
          },
          800203: {
            name: {
              th: 'อินคีรี',
              en: 'In Khiri',
            },
            zipcode: '80320',
          },
          800204: {
            name: {
              th: 'ทอนหงส์',
              en: 'Thon Hong',
            },
            zipcode: '80320',
          },
          800205: {
            name: {
              th: 'นาเรียง',
              en: 'Na Riang',
            },
            zipcode: '80320',
          },
        },
      },
      8003: {
        name: {
          th: 'ลานสกา',
          en: 'Lan Saka',
        },
        tambons: {
          800301: {
            name: {
              th: 'เขาแก้ว',
              en: 'Khao Kaeo',
            },
            zipcode: '80230',
          },
          800302: {
            name: {
              th: 'ลานสกา',
              en: 'Lan Saka',
            },
            zipcode: '80230',
          },
          800303: {
            name: {
              th: 'ท่าดี',
              en: 'Tha Di',
            },
            zipcode: '80230',
          },
          800304: {
            name: {
              th: 'กำโลน',
              en: 'Kamlon',
            },
            zipcode: '80230',
          },
          800305: {
            name: {
              th: 'ขุนทะเล',
              en: 'Khun Thale',
            },
            zipcode: '80230',
          },
        },
      },
      8004: {
        name: {
          th: 'ฉวาง',
          en: 'Chawang',
        },
        tambons: {
          800401: {
            name: {
              th: 'ฉวาง',
              en: 'Chawang',
            },
            zipcode: '80150',
          },
          800403: {
            name: {
              th: 'ละอาย',
              en: 'La-ai',
            },
            zipcode: '80250',
          },
          800404: {
            name: {
              th: 'นาแว',
              en: 'Na Wae',
            },
            zipcode: '80150',
          },
          800405: {
            name: {
              th: 'ไม้เรียง',
              en: 'Mai Riang',
            },
            zipcode: '80150',
          },
          800406: {
            name: {
              th: 'กะเปียด',
              en: 'Kabiat',
            },
            zipcode: '80260',
          },
          800407: {
            name: {
              th: 'นากะชะ',
              en: 'Na Kacha',
            },
            zipcode: '80150',
          },
          800409: {
            name: {
              th: 'ห้วยปริก',
              en: 'Huai Prik',
            },
            zipcode: '80260',
          },
          800410: {
            name: {
              th: 'ไสหร้า',
              en: 'Saira',
            },
            zipcode: '80150',
          },
          800415: {
            name: {
              th: 'นาเขลียง',
              en: 'Na Khliang',
            },
            zipcode: '80260',
          },
          800416: {
            name: {
              th: 'จันดี',
              en: 'Chan Di',
            },
            zipcode: '80250',
          },
        },
      },
      8005: {
        name: {
          th: 'พิปูน',
          en: 'Phipun',
        },
        tambons: {
          800501: {
            name: {
              th: 'พิปูน',
              en: 'Phipun',
            },
            zipcode: '80270',
          },
          800502: {
            name: {
              th: 'กะทูน',
              en: 'Kathun',
            },
            zipcode: '80270',
          },
          800503: {
            name: {
              th: 'เขาพระ',
              en: 'Khao Phra',
            },
            zipcode: '80270',
          },
          800504: {
            name: {
              th: 'ยางค้อม',
              en: 'Yang Khom',
            },
            zipcode: '80270',
          },
          800505: {
            name: {
              th: 'ควนกลาง',
              en: 'Khuan Klang',
            },
            zipcode: '80270',
          },
        },
      },
      8006: {
        name: {
          th: 'เชียรใหญ่',
          en: 'Chian Yai',
        },
        tambons: {
          800601: {
            name: {
              th: 'เชียรใหญ่',
              en: 'Chian Yai',
            },
            zipcode: '80190',
          },
          800603: {
            name: {
              th: 'ท่าขนาน',
              en: 'Tha Khanan',
            },
            zipcode: '80190',
          },
          800604: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '80190',
          },
          800605: {
            name: {
              th: 'บ้านเนิน',
              en: 'Ban Noen',
            },
            zipcode: '80190',
          },
          800606: {
            name: {
              th: 'ไสหมาก',
              en: 'Sai Mak',
            },
            zipcode: '80190',
          },
          800607: {
            name: {
              th: 'ท้องลำเจียก',
              en: 'Thong Lamchiak',
            },
            zipcode: '80190',
          },
          800610: {
            name: {
              th: 'เสือหึง',
              en: 'Suea Hueng',
            },
            zipcode: '80190',
          },
          800611: {
            name: {
              th: 'การะเกด',
              en: 'Karaket',
            },
            zipcode: '80190',
          },
          800612: {
            name: {
              th: 'เขาพระบาท',
              en: 'Khao Phrabat',
            },
            zipcode: '80190',
          },
          800613: {
            name: {
              th: 'แม่เจ้าอยู่หัว',
              en: 'Mae Chao Yu Hua',
            },
            zipcode: '80190',
          },
        },
      },
      8007: {
        name: {
          th: 'ชะอวด',
          en: 'Vha Uat',
        },
        tambons: {
          800701: {
            name: {
              th: 'ชะอวด',
              en: 'Cha-uat',
            },
            zipcode: '80180',
          },
          800702: {
            name: {
              th: 'ท่าเสม็ด',
              en: 'Tha Samet',
            },
            zipcode: '80180',
          },
          800703: {
            name: {
              th: 'ท่าประจะ',
              en: 'Tha Pracha',
            },
            zipcode: '80180',
          },
          800704: {
            name: {
              th: 'เคร็ง',
              en: 'Khreng',
            },
            zipcode: '80180',
          },
          800705: {
            name: {
              th: 'วังอ่าง',
              en: 'Wang Ang',
            },
            zipcode: '80180',
          },
          800706: {
            name: {
              th: 'บ้านตูล',
              en: 'Ban Tun',
            },
            zipcode: '80180',
          },
          800707: {
            name: {
              th: 'ขอนหาด',
              en: 'Khon Hat',
            },
            zipcode: '80180',
          },
          800708: {
            name: {
              th: 'เกาะขันธ์',
              en: 'Ko Khan',
            },
            zipcode: '80180',
          },
          800709: {
            name: {
              th: 'ควนหนองหงษ์',
              en: 'Khuan Nong Hong',
            },
            zipcode: '80180',
          },
          800710: {
            name: {
              th: 'เขาพระทอง',
              en: 'Khao Phra Thong',
            },
            zipcode: '80180',
          },
          800711: {
            name: {
              th: 'นางหลง',
              en: 'Nang Long',
            },
            zipcode: '80180',
          },
        },
      },
      8008: {
        name: {
          th: 'ท่าศาลา',
          en: 'Tha Sala',
        },
        tambons: {
          800801: {
            name: {
              th: 'ท่าศาลา',
              en: 'Tha Sala',
            },
            zipcode: '80160',
          },
          800802: {
            name: {
              th: 'กลาย',
              en: 'Klai',
            },
            zipcode: '80160',
          },
          800803: {
            name: {
              th: 'ท่าขึ้น',
              en: 'Tha Khuen',
            },
            zipcode: '80160',
          },
          800804: {
            name: {
              th: 'หัวตะพาน',
              en: 'Hua Taphan',
            },
            zipcode: '80160',
          },
          800806: {
            name: {
              th: 'สระแก้ว',
              en: 'Sa Kaeo',
            },
            zipcode: '80160',
          },
          800807: {
            name: {
              th: 'โมคลาน',
              en: 'Mokhlan',
            },
            zipcode: '80160',
          },
          800809: {
            name: {
              th: 'ไทยบุรี',
              en: 'Thai Buri',
            },
            zipcode: '80160',
          },
          800810: {
            name: {
              th: 'ดอนตะโก',
              en: 'Don Tako',
            },
            zipcode: '80160',
          },
          800811: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '80160',
          },
          800813: {
            name: {
              th: 'โพธิ์ทอง',
              en: 'Pho Thong',
            },
            zipcode: '80160',
          },
        },
      },
      8009: {
        name: {
          th: 'ทุ่งสง',
          en: 'Thung Song',
        },
        tambons: {
          800901: {
            name: {
              th: 'ปากแพรก',
              en: 'Pak Phraek',
            },
            zipcode: '80110',
          },
          800902: {
            name: {
              th: 'ชะมาย',
              en: 'Chamai',
            },
            zipcode: '80110',
          },
          800903: {
            name: {
              th: 'หนองหงส์',
              en: 'Nong Hong',
            },
            zipcode: '80110',
          },
          800904: {
            name: {
              th: 'ควนกรด',
              en: 'Khuan Krot',
            },
            zipcode: '80110',
          },
          800905: {
            name: {
              th: 'นาไม้ไผ่',
              en: 'Na Mai Phai',
            },
            zipcode: '80110',
          },
          800906: {
            name: {
              th: 'นาหลวงเสน',
              en: 'Na Luang Sen',
            },
            zipcode: '80110',
          },
          800907: {
            name: {
              th: 'เขาโร',
              en: 'Khao Ro',
            },
            zipcode: '80110',
          },
          800908: {
            name: {
              th: 'กะปาง',
              en: 'Kapang',
            },
            zipcode: '80310',
          },
          800909: {
            name: {
              th: 'ที่วัง',
              en: 'Thi Wang',
            },
            zipcode: '80110',
          },
          800910: {
            name: {
              th: 'น้ำตก',
              en: 'Nam Tok',
            },
            zipcode: '80110',
          },
          800911: {
            name: {
              th: 'ถ้ำใหญ่',
              en: 'Tham Yai',
            },
            zipcode: '80110',
          },
          800912: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '80110',
          },
          800913: {
            name: {
              th: 'เขาขาว',
              en: 'Khao Khao',
            },
            zipcode: '80110',
          },
        },
      },
      8010: {
        name: {
          th: 'นาบอน',
          en: 'Na Bon',
        },
        tambons: {
          801001: {
            name: {
              th: 'นาบอน',
              en: 'Na Bon',
            },
            zipcode: '80220',
          },
          801002: {
            name: {
              th: 'ทุ่งสง',
              en: 'Thung Song',
            },
            zipcode: '80220',
          },
          801003: {
            name: {
              th: 'แก้วแสน',
              en: 'Kaeo Saen',
            },
            zipcode: '80220',
          },
        },
      },
      8011: {
        name: {
          th: 'ทุ่งใหญ่',
          en: 'Thung Yai',
        },
        tambons: {
          801101: {
            name: {
              th: 'ท่ายาง',
              en: 'Tha Yang',
            },
            zipcode: '80240',
          },
          801102: {
            name: {
              th: 'ทุ่งสัง',
              en: 'Thung Sang',
            },
            zipcode: '80240',
          },
          801103: {
            name: {
              th: 'ทุ่งใหญ่',
              en: 'Thung Yai',
            },
            zipcode: '80240',
          },
          801104: {
            name: {
              th: 'กุแหระ',
              en: 'Kurae',
            },
            zipcode: '80240',
          },
          801105: {
            name: {
              th: 'ปริก',
              en: 'Prik',
            },
            zipcode: '80240',
          },
          801106: {
            name: {
              th: 'บางรูป',
              en: 'Bang Rup',
            },
            zipcode: '80240',
          },
          801107: {
            name: {
              th: 'กรุงหยัน',
              en: 'Krung Yan',
            },
            zipcode: '80240',
          },
        },
      },
      8012: {
        name: {
          th: 'ปากพนัง',
          en: 'Pak Phanang',
        },
        tambons: {
          801201: {
            name: {
              th: 'ปากพนัง',
              en: 'Pak Phanang',
            },
            zipcode: '80140',
          },
          801202: {
            name: {
              th: 'คลองน้อย',
              en: 'Khlong Noi',
            },
            zipcode: '80330',
          },
          801203: {
            name: {
              th: 'ป่าระกำ',
              en: 'Pa Rakam',
            },
            zipcode: '80140',
          },
          801204: {
            name: {
              th: 'ชะเมา',
              en: 'Chamao',
            },
            zipcode: '80330',
          },
          801205: {
            name: {
              th: 'คลองกระบือ',
              en: 'Khlong Krabue',
            },
            zipcode: '80140',
          },
          801206: {
            name: {
              th: 'เกาะทวด',
              en: 'Ko Thuat',
            },
            zipcode: '80330',
          },
          801207: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '80140',
          },
          801208: {
            name: {
              th: 'หูล่อง',
              en: 'Hu Long',
            },
            zipcode: '80140',
          },
          801209: {
            name: {
              th: 'แหลมตะลุมพุก',
              en: 'Laem Talumphuk',
            },
            zipcode: '80140',
          },
          801210: {
            name: {
              th: 'ปากพนังฝั่งตะวันตก',
              en: 'Pak Phanang Fang Tawan Tok',
            },
            zipcode: '80140',
          },
          801211: {
            name: {
              th: 'บางศาลา',
              en: 'Bang Sala',
            },
            zipcode: '80140',
          },
          801212: {
            name: {
              th: 'บางพระ',
              en: 'Bang Phra',
            },
            zipcode: '80140',
          },
          801213: {
            name: {
              th: 'บางตะพง',
              en: 'Bang Taphong',
            },
            zipcode: '80140',
          },
          801214: {
            name: {
              th: 'ปากพนังฝั่งตะวันออก',
              en: 'Pak Phanang Fang Tawan Ok',
            },
            zipcode: '80140',
          },
          801215: {
            name: {
              th: 'บ้านเพิง',
              en: 'Ban Phoeng',
            },
            zipcode: '80140',
          },
          801216: {
            name: {
              th: 'ท่าพยา',
              en: 'Tha Phaya',
            },
            zipcode: '80140',
          },
          801217: {
            name: {
              th: 'ปากแพรก',
              en: 'Pak Phraek',
            },
            zipcode: '80140',
          },
          801218: {
            name: {
              th: 'ขนาบนาก',
              en: 'Khanap Nak',
            },
            zipcode: '80140',
          },
        },
      },
      8013: {
        name: {
          th: 'ร่อนพิบูลย์',
          en: 'Ron Phibun',
        },
        tambons: {
          801301: {
            name: {
              th: 'ร่อนพิบูลย์',
              en: 'Ron Phibun',
            },
            zipcode: '80130',
          },
          801302: {
            name: {
              th: 'หินตก',
              en: 'Hin Tok',
            },
            zipcode: '80350',
          },
          801303: {
            name: {
              th: 'เสาธง',
              en: 'Sao Thong',
            },
            zipcode: '80350',
          },
          801304: {
            name: {
              th: 'ควนเกย',
              en: 'Khuan Koei',
            },
            zipcode: '80130',
          },
          801305: {
            name: {
              th: 'ควนพัง',
              en: 'Khuan Phang',
            },
            zipcode: '80130',
          },
          801306: {
            name: {
              th: 'ควนชุม',
              en: 'Khuan Chum',
            },
            zipcode: '80130',
          },
        },
      },
      8014: {
        name: {
          th: 'สิชล',
          en: 'Sichon',
        },
        tambons: {
          801401: {
            name: {
              th: 'สิชล',
              en: 'Sichon',
            },
            zipcode: '80120',
          },
          801402: {
            name: {
              th: 'ทุ่งปรัง',
              en: 'Thung Prang',
            },
            zipcode: '80120',
          },
          801403: {
            name: {
              th: 'ฉลอง',
              en: 'Chalong',
            },
            zipcode: '80120',
          },
          801404: {
            name: {
              th: 'เสาเภา',
              en: 'Sao Phao',
            },
            zipcode: '80340',
          },
          801405: {
            name: {
              th: 'เปลี่ยน',
              en: 'Plian',
            },
            zipcode: '80120',
          },
          801406: {
            name: {
              th: 'สี่ขีด',
              en: 'Si Khit',
            },
            zipcode: '80120',
          },
          801407: {
            name: {
              th: 'เทพราช',
              en: 'Theppharat',
            },
            zipcode: '80340',
          },
          801408: {
            name: {
              th: 'เขาน้อย',
              en: 'Khao Noi',
            },
            zipcode: '80120',
          },
          801409: {
            name: {
              th: 'ทุ่งใส',
              en: 'Thung Sai',
            },
            zipcode: '80120',
          },
        },
      },
      8015: {
        name: {
          th: 'ขนอม',
          en: 'Khanom',
        },
        tambons: {
          801501: {
            name: {
              th: 'ขนอม',
              en: 'Khanom',
            },
            zipcode: '80210',
          },
          801502: {
            name: {
              th: 'ควนทอง',
              en: 'Khuan Thong',
            },
            zipcode: '80210',
          },
          801503: {
            name: {
              th: 'ท้องเนียน',
              en: 'Thong Nian',
            },
            zipcode: '80210',
          },
        },
      },
      8016: {
        name: {
          th: 'หัวไทร',
          en: 'Hua Sai',
        },
        tambons: {
          801601: {
            name: {
              th: 'หัวไทร',
              en: 'Hua Sai',
            },
            zipcode: '80170',
          },
          801602: {
            name: {
              th: 'หน้าสตน',
              en: 'Na Saton',
            },
            zipcode: '80170',
          },
          801603: {
            name: {
              th: 'ทรายขาว',
              en: 'Sai Khao',
            },
            zipcode: '80170',
          },
          801604: {
            name: {
              th: 'แหลม',
              en: 'Laem',
            },
            zipcode: '80170',
          },
          801605: {
            name: {
              th: 'เขาพังไกร',
              en: 'Khao Phang Krai',
            },
            zipcode: '80170',
          },
          801606: {
            name: {
              th: 'บ้านราม',
              en: 'Ban Ram',
            },
            zipcode: '80170',
          },
          801607: {
            name: {
              th: 'บางนบ',
              en: 'Bang Nop',
            },
            zipcode: '80170',
          },
          801608: {
            name: {
              th: 'ท่าซอม',
              en: 'Tha Som',
            },
            zipcode: '80170',
          },
          801609: {
            name: {
              th: 'ควนชะลิก',
              en: 'Khuan Chalik',
            },
            zipcode: '80170',
          },
          801610: {
            name: {
              th: 'รามแก้ว',
              en: 'Ram Kaeo',
            },
            zipcode: '80170',
          },
          801611: {
            name: {
              th: 'เกาะเพชร',
              en: 'Ko Phet',
            },
            zipcode: '80170',
          },
        },
      },
      8017: {
        name: {
          th: 'บางขัน',
          en: 'Bang Kun',
        },
        tambons: {
          801701: {
            name: {
              th: 'บางขัน',
              en: 'Bang Khan',
            },
            zipcode: '80360',
          },
          801702: {
            name: {
              th: 'บ้านลำนาว',
              en: 'Ban Lamnao',
            },
            zipcode: '80360',
          },
          801703: {
            name: {
              th: 'วังหิน',
              en: 'Wang Hin',
            },
            zipcode: '80360',
          },
          801704: {
            name: {
              th: 'บ้านนิคม',
              en: 'Ban Nikhom',
            },
            zipcode: '80360',
          },
        },
      },
      8018: {
        name: {
          th: 'ถ้ำพรรณรา',
          en: 'Tham Phanara',
        },
        tambons: {
          801801: {
            name: {
              th: 'ถ้ำพรรณรา',
              en: 'Tham Phannara',
            },
            zipcode: '80260',
          },
          801802: {
            name: {
              th: 'คลองเส',
              en: 'Khlong Se',
            },
            zipcode: '80260',
          },
          801803: {
            name: {
              th: 'ดุสิต',
              en: 'Dusit',
            },
            zipcode: '80260',
          },
        },
      },
      8019: {
        name: {
          th: 'จุฬาภรณ์',
          en: 'Chula Porn',
        },
        tambons: {
          801901: {
            name: {
              th: 'บ้านควนมุด',
              en: 'Ban Khuan Mut',
            },
            zipcode: '80180',
          },
          801902: {
            name: {
              th: 'บ้านชะอวด',
              en: 'Ban Cha-uat',
            },
            zipcode: '80180',
          },
          801903: {
            name: {
              th: 'ควนหนองคว้า',
              en: 'Khuan Nong Khwa',
            },
            zipcode: '80130',
          },
          801904: {
            name: {
              th: 'ทุ่งโพธิ์',
              en: 'Thung Pho',
            },
            zipcode: '80130',
          },
          801905: {
            name: {
              th: 'นาหมอบุญ',
              en: 'Na Mo Bun',
            },
            zipcode: '80130',
          },
          801906: {
            name: {
              th: 'สามตำบล',
              en: 'Sam Tambon',
            },
            zipcode: '80130',
          },
        },
      },
      8020: {
        name: {
          th: 'พระพรหม',
          en: 'Phra Phrom',
        },
        tambons: {
          802001: {
            name: {
              th: 'นาพรุ',
              en: 'Na Phru',
            },
            zipcode: '80000',
          },
          802002: {
            name: {
              th: 'นาสาร',
              en: 'Na San',
            },
            zipcode: '80000',
          },
          802003: {
            name: {
              th: 'ท้ายสำเภา',
              en: 'Thai Samphao',
            },
            zipcode: '80000',
          },
          802004: {
            name: {
              th: 'ช้างซ้าย',
              en: 'Chang Sai',
            },
            zipcode: '80000',
          },
        },
      },
      8021: {
        name: {
          th: 'นบพิตำ',
          en: 'Nopphitam',
        },
        tambons: {
          802101: {
            name: {
              th: 'นบพิตำ',
              en: 'Nopphitam',
            },
            zipcode: '80160',
          },
          802102: {
            name: {
              th: 'กรุงชิง',
              en: 'Krung Ching',
            },
            zipcode: '80160',
          },
          802103: {
            name: {
              th: 'กะหรอ',
              en: 'Karo',
            },
            zipcode: '80160',
          },
          802104: {
            name: {
              th: 'นาเหรง',
              en: 'Na Reng',
            },
            zipcode: '80160',
          },
        },
      },
      8022: {
        name: {
          th: 'ช้างกลาง',
          en: 'Chang Klang',
        },
        tambons: {
          802201: {
            name: {
              th: 'ช้างกลาง',
              en: 'Chang Klang',
            },
            zipcode: '80250',
          },
          802202: {
            name: {
              th: 'หลักช้าง',
              en: 'Lak Chang',
            },
            zipcode: '80250',
          },
          802203: {
            name: {
              th: 'สวนขัน',
              en: 'Suan Khan',
            },
            zipcode: '80250',
          },
        },
      },
      8023: {
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chalermprakiat',
        },
        tambons: {
          802301: {
            name: {
              th: 'เชียรเขา',
              en: 'Chian Khao',
            },
            zipcode: '80190',
          },
          802302: {
            name: {
              th: 'ดอนตรอ',
              en: 'Don Tro',
            },
            zipcode: '80290',
          },
          802303: {
            name: {
              th: 'สวนหลวง',
              en: 'Suan Luang',
            },
            zipcode: '80190',
          },
          802304: {
            name: {
              th: 'ทางพูน',
              en: 'Thang Phun',
            },
            zipcode: '80290',
          },
        },
      },
    },
  },
  81: {
    name: {
      th: 'กระบี่',
      en: 'Krabi',
    },
    amphoes: {
      8101: {
        name: {
          th: 'เมืองกระบี่',
          en: 'Muang',
        },
        tambons: {
          810101: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '81000',
          },
          810102: {
            name: {
              th: 'กระบี่ใหญ่',
              en: 'Krabi Yai',
            },
            zipcode: '81000',
          },
          810103: {
            name: {
              th: 'กระบี่น้อย',
              en: 'Krabi Noi',
            },
            zipcode: '81000',
          },
          810105: {
            name: {
              th: 'เขาคราม',
              en: 'Khao Khram',
            },
            zipcode: '81000',
          },
          810106: {
            name: {
              th: 'เขาทอง',
              en: 'Khao Thong',
            },
            zipcode: '81000',
          },
          810111: {
            name: {
              th: 'ทับปริก',
              en: 'Thap Prik',
            },
            zipcode: '81000',
          },
          810115: {
            name: {
              th: 'ไสไทย',
              en: 'Sai Thai',
            },
            zipcode: '81000',
          },
          810116: {
            name: {
              th: 'อ่าวนาง',
              en: 'Ao Nang',
            },
            zipcode: '81000',
          },
          810117: {
            name: {
              th: 'หนองทะเล',
              en: 'Nong Thale',
            },
            zipcode: '81000',
          },
          810118: {
            name: {
              th: 'คลองประสงค์',
              en: 'Khlong Prasong',
            },
            zipcode: '81000',
          },
        },
      },
      8102: {
        name: {
          th: 'เขาพนม',
          en: 'Kho Phanom',
        },
        tambons: {
          810201: {
            name: {
              th: 'เขาพนม',
              en: 'Khao Phanom',
            },
            zipcode: '81140',
          },
          810202: {
            name: {
              th: 'เขาดิน',
              en: 'Khao Din',
            },
            zipcode: '81140',
          },
          810203: {
            name: {
              th: 'สินปุน',
              en: 'Sin Pun',
            },
            zipcode: '80240',
          },
          810204: {
            name: {
              th: 'พรุเตียว',
              en: 'Phru Tiao',
            },
            zipcode: '81140',
          },
          810205: {
            name: {
              th: 'หน้าเขา',
              en: 'Na Khao',
            },
            zipcode: '81140',
          },
          810206: {
            name: {
              th: 'โคกหาร',
              en: 'Khok Han',
            },
            zipcode: '80240',
          },
        },
      },
      8103: {
        name: {
          th: 'เกาะลันตา',
          en: 'Khao Lanta',
        },
        tambons: {
          810301: {
            name: {
              th: 'เกาะลันตาใหญ่',
              en: 'Ko Lanta Yai',
            },
            zipcode: '81150',
          },
          810302: {
            name: {
              th: 'เกาะลันตาน้อย',
              en: 'Ko Lanta Noi',
            },
            zipcode: '81150',
          },
          810303: {
            name: {
              th: 'เกาะกลาง',
              en: 'Ko Klang',
            },
            zipcode: '81120',
          },
          810304: {
            name: {
              th: 'คลองยาง',
              en: 'Khlong Yang',
            },
            zipcode: '81120',
          },
          810305: {
            name: {
              th: 'ศาลาด่าน',
              en: 'Sala Dan',
            },
            zipcode: '81150',
          },
        },
      },
      8104: {
        name: {
          th: 'คลองท่อม',
          en: 'Khong Thom',
        },
        tambons: {
          810401: {
            name: {
              th: 'คลองท่อมใต้',
              en: 'Khlong Thom Tai',
            },
            zipcode: '81120',
          },
          810402: {
            name: {
              th: 'คลองท่อมเหนือ',
              en: 'Khlong Thom Nuea',
            },
            zipcode: '81120',
          },
          810403: {
            name: {
              th: 'คลองพน',
              en: 'Khlong Phon',
            },
            zipcode: '81170',
          },
          810404: {
            name: {
              th: 'ทรายขาว',
              en: 'Sai Khao',
            },
            zipcode: '81170',
          },
          810405: {
            name: {
              th: 'ห้วยน้ำขาว',
              en: 'Huai Nam Khao',
            },
            zipcode: '81120',
          },
          810406: {
            name: {
              th: 'พรุดินนา',
              en: 'Phru Din Na',
            },
            zipcode: '81120',
          },
          810407: {
            name: {
              th: 'เพหลา',
              en: 'Phela',
            },
            zipcode: '81120',
          },
        },
      },
      8105: {
        name: {
          th: 'อ่าวลึก',
          en: 'Ao Luk',
        },
        tambons: {
          810501: {
            name: {
              th: 'อ่าวลึกใต้',
              en: 'Ao Luek Tai',
            },
            zipcode: '81110',
          },
          810502: {
            name: {
              th: 'แหลมสัก',
              en: 'Laem Sak',
            },
            zipcode: '81110',
          },
          810503: {
            name: {
              th: 'นาเหนือ',
              en: 'Na Nuea',
            },
            zipcode: '81110',
          },
          810504: {
            name: {
              th: 'คลองหิน',
              en: 'Khlong Hin',
            },
            zipcode: '81110',
          },
          810505: {
            name: {
              th: 'อ่าวลึกน้อย',
              en: 'Ao Luek Noi',
            },
            zipcode: '81110',
          },
          810506: {
            name: {
              th: 'อ่าวลึกเหนือ',
              en: 'Ao Luek Nuea',
            },
            zipcode: '81110',
          },
          810507: {
            name: {
              th: 'เขาใหญ่',
              en: 'Khao Yai',
            },
            zipcode: '81110',
          },
          810508: {
            name: {
              th: 'คลองยา',
              en: 'Khlong Ya',
            },
            zipcode: '81110',
          },
          810509: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '81110',
          },
        },
      },
      8106: {
        name: {
          th: 'ปลายพระยา',
          en: 'Plai Phraya',
        },
        tambons: {
          810601: {
            name: {
              th: 'ปลายพระยา',
              en: 'Plai Phraya',
            },
            zipcode: '81160',
          },
          810602: {
            name: {
              th: 'เขาเขน',
              en: 'Khao Khen',
            },
            zipcode: '81160',
          },
          810603: {
            name: {
              th: 'เขาต่อ',
              en: 'Khao To',
            },
            zipcode: '81160',
          },
          810604: {
            name: {
              th: 'คีรีวง',
              en: 'Khiri Wong',
            },
            zipcode: '81160',
          },
        },
      },
      8107: {
        name: {
          th: 'ลำทับ',
          en: 'Lum Tub',
        },
        tambons: {
          810701: {
            name: {
              th: 'ลำทับ',
              en: 'Lam Thap',
            },
            zipcode: '81120',
          },
          810702: {
            name: {
              th: 'ดินอุดม',
              en: 'Din Udom',
            },
            zipcode: '81120',
          },
          810703: {
            name: {
              th: 'ทุ่งไทรทอง',
              en: 'Thung Sai Thong',
            },
            zipcode: '81120',
          },
          810704: {
            name: {
              th: 'ดินแดง',
              en: 'Din Daeng',
            },
            zipcode: '81120',
          },
        },
      },
      8108: {
        name: {
          th: 'เหนือคลอง',
          en: 'Nua Klong',
        },
        tambons: {
          810801: {
            name: {
              th: 'เหนือคลอง',
              en: 'Nuea Khlong',
            },
            zipcode: '81130',
          },
          810802: {
            name: {
              th: 'เกาะศรีบอยา',
              en: 'Ko Siboya',
            },
            zipcode: '81130',
          },
          810803: {
            name: {
              th: 'คลองขนาน',
              en: 'Khlong Khanan',
            },
            zipcode: '81130',
          },
          810804: {
            name: {
              th: 'คลองเขม้า',
              en: 'Khlong Khamao',
            },
            zipcode: '81130',
          },
          810805: {
            name: {
              th: 'โคกยาง',
              en: 'Khok Yang',
            },
            zipcode: '81130',
          },
          810806: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '81130',
          },
          810807: {
            name: {
              th: 'ปกาสัย',
              en: 'Pakasai',
            },
            zipcode: '81130',
          },
          810808: {
            name: {
              th: 'ห้วยยูง',
              en: 'Huai Yung',
            },
            zipcode: '81130',
          },
        },
      },
    },
  },
  82: {
    name: {
      th: 'พังงา',
      en: 'Phangnga',
    },
    amphoes: {
      8201: {
        name: {
          th: 'เมืองพังงา',
          en: 'Muang',
        },
        tambons: {
          820101: {
            name: {
              th: 'ท้ายช้าง',
              en: 'Thai Chang',
            },
            zipcode: '82000',
          },
          820102: {
            name: {
              th: 'นบปริง',
              en: 'Nop Pring',
            },
            zipcode: '82000',
          },
          820103: {
            name: {
              th: 'ถ้ำน้ำผุด',
              en: 'Tham Nam Phut',
            },
            zipcode: '82000',
          },
          820104: {
            name: {
              th: 'บางเตย',
              en: 'Bang Toei',
            },
            zipcode: '82000',
          },
          820105: {
            name: {
              th: 'ตากแดด',
              en: 'Tak Daet',
            },
            zipcode: '82000',
          },
          820106: {
            name: {
              th: 'สองแพรก',
              en: 'Song Phraek',
            },
            zipcode: '82000',
          },
          820107: {
            name: {
              th: 'ทุ่งคาโงก',
              en: 'Thung Kha Ngok',
            },
            zipcode: '82000',
          },
          820108: {
            name: {
              th: 'เกาะปันหยี',
              en: 'Ko Panyi',
            },
            zipcode: '82000',
          },
          820109: {
            name: {
              th: 'ป่ากอ',
              en: 'Pa Ko',
            },
            zipcode: '82000',
          },
        },
      },
      8202: {
        name: {
          th: 'เกาะยาว',
          en: 'Ko Yao',
        },
        tambons: {
          820201: {
            name: {
              th: 'เกาะยาวน้อย',
              en: 'Ko Yao Noi',
            },
            zipcode: '82160',
          },
          820202: {
            name: {
              th: 'เกาะยาวใหญ่',
              en: 'Ko Yao Yai',
            },
            zipcode: '82160',
          },
          820203: {
            name: {
              th: 'พรุใน',
              en: 'Phru Nai',
            },
            zipcode: '83000',
          },
        },
      },
      8203: {
        name: {
          th: 'กะปง',
          en: 'Kapong',
        },
        tambons: {
          820301: {
            name: {
              th: 'กะปง',
              en: 'Kapong',
            },
            zipcode: '82170',
          },
          820302: {
            name: {
              th: 'ท่านา',
              en: 'Tha Na',
            },
            zipcode: '82170',
          },
          820303: {
            name: {
              th: 'เหมาะ',
              en: 'Mo',
            },
            zipcode: '82170',
          },
          820304: {
            name: {
              th: 'เหล',
              en: 'Le',
            },
            zipcode: '82170',
          },
          820305: {
            name: {
              th: 'รมณีย์',
              en: 'Rommani',
            },
            zipcode: '82170',
          },
        },
      },
      8204: {
        name: {
          th: 'ตะกั่วทุ่ง',
          en: 'Takuo Thung',
        },
        tambons: {
          820401: {
            name: {
              th: 'ถ้ำ',
              en: 'Tham',
            },
            zipcode: '82130',
          },
          820402: {
            name: {
              th: 'กระโสม',
              en: 'Krasom',
            },
            zipcode: '82130',
          },
          820403: {
            name: {
              th: 'กะไหล',
              en: 'Kalai',
            },
            zipcode: '82130',
          },
          820404: {
            name: {
              th: 'ท่าอยู่',
              en: 'Tha Yu',
            },
            zipcode: '82130',
          },
          820405: {
            name: {
              th: 'หล่อยูง',
              en: 'Lo Yung',
            },
            zipcode: '82140',
          },
          820406: {
            name: {
              th: 'โคกกลอย',
              en: 'Khok Kloi',
            },
            zipcode: '82140',
          },
          820407: {
            name: {
              th: 'คลองเคียน',
              en: 'Khlong Khian',
            },
            zipcode: '82130',
          },
        },
      },
      8205: {
        name: {
          th: 'ตะกั่วป่า',
          en: 'Takuo Pa',
        },
        tambons: {
          820501: {
            name: {
              th: 'ตะกั่วป่า',
              en: 'Takua Pa',
            },
            zipcode: '82110',
          },
          820502: {
            name: {
              th: 'บางนายสี',
              en: 'Bang Nai Si',
            },
            zipcode: '82110',
          },
          820503: {
            name: {
              th: 'บางไทร',
              en: 'Bang Sai',
            },
            zipcode: '82110',
          },
          820504: {
            name: {
              th: 'บางม่วง',
              en: 'Bang Muang',
            },
            zipcode: '82190',
          },
          820505: {
            name: {
              th: 'ตำตัว',
              en: 'Tam Tua',
            },
            zipcode: '82110',
          },
          820506: {
            name: {
              th: 'โคกเคียน',
              en: 'Khok Khian',
            },
            zipcode: '82110',
          },
          820507: {
            name: {
              th: 'คึกคัก',
              en: 'Khuekkhak',
            },
            zipcode: '82190',
          },
          820508: {
            name: {
              th: 'เกาะคอเขา',
              en: 'Ko Kho Khao',
            },
            zipcode: '82190',
          },
        },
      },
      8206: {
        name: {
          th: 'คุระบุรี',
          en: 'Khura Buri',
        },
        tambons: {
          820601: {
            name: {
              th: 'คุระ',
              en: 'Khura',
            },
            zipcode: '82150',
          },
          820602: {
            name: {
              th: 'บางวัน',
              en: 'Bang Wan',
            },
            zipcode: '82150',
          },
          820603: {
            name: {
              th: 'เกาะพระทอง',
              en: 'Ko Phra Thong',
            },
            zipcode: '82150',
          },
          820605: {
            name: {
              th: 'แม่นางขาว',
              en: 'Mae Nang Khao',
            },
            zipcode: '82150',
          },
        },
      },
      8207: {
        name: {
          th: 'ทับปุด',
          en: 'Thap Put',
        },
        tambons: {
          820701: {
            name: {
              th: 'ทับปุด',
              en: 'Thap Put',
            },
            zipcode: '82180',
          },
          820702: {
            name: {
              th: 'มะรุ่ย',
              en: 'Marui',
            },
            zipcode: '82180',
          },
          820703: {
            name: {
              th: 'บ่อแสน',
              en: 'Bo Saen',
            },
            zipcode: '82180',
          },
          820704: {
            name: {
              th: 'ถ้ำทองหลาง',
              en: 'Tham Thonglang',
            },
            zipcode: '82180',
          },
          820705: {
            name: {
              th: 'โคกเจริญ',
              en: 'Khok Charoen',
            },
            zipcode: '82180',
          },
          820706: {
            name: {
              th: 'บางเหรียง',
              en: 'Bang Riang',
            },
            zipcode: '82180',
          },
        },
      },
      8208: {
        name: {
          th: 'ท้ายเหมือง',
          en: 'Thai Muang',
        },
        tambons: {
          820801: {
            name: {
              th: 'ท้ายเหมือง',
              en: 'Thai Mueang',
            },
            zipcode: '82120',
          },
          820802: {
            name: {
              th: 'นาเตย',
              en: 'Na Toei',
            },
            zipcode: '82120',
          },
          820803: {
            name: {
              th: 'บางทอง',
              en: 'Bang Thong',
            },
            zipcode: '82120',
          },
          820804: {
            name: {
              th: 'ทุ่งมะพร้าว',
              en: 'Thung Maphrao',
            },
            zipcode: '82120',
          },
          820805: {
            name: {
              th: 'ลำภี',
              en: 'Lam Phi',
            },
            zipcode: '82120',
          },
          820806: {
            name: {
              th: 'ลำแก่น',
              en: 'Lam Kaen',
            },
            zipcode: '82120',
          },
        },
      },
    },
  },
  83: {
    name: {
      th: 'ภูเก็ต',
      en: 'Phuket',
    },
    amphoes: {
      8301: {
        name: {
          th: 'เมืองภูเก็ต',
          en: 'Muang',
        },
        tambons: {
          830101: {
            name: {
              th: 'ตลาดใหญ่',
              en: 'Talat Yai',
            },
            zipcode: '83000',
          },
          830102: {
            name: {
              th: 'ตลาดเหนือ',
              en: 'Talat Nuea',
            },
            zipcode: '83000',
          },
          830103: {
            name: {
              th: 'เกาะแก้ว',
              en: 'Ko Kaeo',
            },
            zipcode: '83000',
          },
          830104: {
            name: {
              th: 'รัษฎา',
              en: 'Ratsada',
            },
            zipcode: '83000',
          },
          830105: {
            name: {
              th: 'วิชิต',
              en: 'Wichit',
            },
            zipcode: '83000',
          },
          830106: {
            name: {
              th: 'ฉลอง',
              en: 'Chalong',
            },
            zipcode: '83130',
          },
          830107: {
            name: {
              th: 'ราไวย์',
              en: 'Rawai',
            },
            zipcode: '83130',
          },
          830108: {
            name: {
              th: 'กะรน',
              en: 'Karon',
            },
            zipcode: '83100',
          },
        },
      },
      8302: {
        name: {
          th: 'กะทู้',
          en: 'Krathu',
        },
        tambons: {
          830201: {
            name: {
              th: 'กะทู้',
              en: 'Kathu',
            },
            zipcode: '83120',
          },
          830202: {
            name: {
              th: 'ป่าตอง',
              en: 'Pa Tong',
            },
            zipcode: '83150',
          },
          830203: {
            name: {
              th: 'กมลา',
              en: 'Kamala',
            },
            zipcode: '83150',
          },
        },
      },
      8303: {
        name: {
          th: 'ถลาง',
          en: 'Thalang',
        },
        tambons: {
          830301: {
            name: {
              th: 'เทพกระษัตรี',
              en: 'Thep Krasatti',
            },
            zipcode: '83110',
          },
          830302: {
            name: {
              th: 'ศรีสุนทร',
              en: 'Si Sunthon',
            },
            zipcode: '83110',
          },
          830303: {
            name: {
              th: 'เชิงทะเล',
              en: 'Choeng Thale',
            },
            zipcode: '83110',
          },
          830304: {
            name: {
              th: 'ป่าคลอก',
              en: 'Pa Khlok',
            },
            zipcode: '83110',
          },
          830305: {
            name: {
              th: 'ไม้ขาว',
              en: 'Mai Khao',
            },
            zipcode: '83110',
          },
          830306: {
            name: {
              th: 'สาคู',
              en: 'Sakhu',
            },
            zipcode: '83110',
          },
        },
      },
    },
  },
  84: {
    name: {
      th: 'สุราษฎร์ธานี',
      en: 'Surat Thani',
    },
    amphoes: {
      8401: {
        name: {
          th: 'เมืองสุราษฎร์ธานี',
          en: 'Muang',
        },
        tambons: {
          840101: {
            name: {
              th: 'ตลาด',
              en: 'Talat',
            },
            zipcode: '84000',
          },
          840102: {
            name: {
              th: 'มะขามเตี้ย',
              en: 'Makham Tia',
            },
            zipcode: '84000',
          },
          840103: {
            name: {
              th: 'วัดประดู่',
              en: 'Wat Pradu',
            },
            zipcode: '84000',
          },
          840104: {
            name: {
              th: 'ขุนทะเล',
              en: 'Khun Thale',
            },
            zipcode: '84100',
          },
          840105: {
            name: {
              th: 'บางใบไม้',
              en: 'Bang Bai Mai',
            },
            zipcode: '84000',
          },
          840106: {
            name: {
              th: 'บางชนะ',
              en: 'Bang Chana',
            },
            zipcode: '84000',
          },
          840107: {
            name: {
              th: 'คลองน้อย',
              en: 'Khlong Noi',
            },
            zipcode: '84000',
          },
          840108: {
            name: {
              th: 'บางไทร',
              en: 'Bang Sai',
            },
            zipcode: '84000',
          },
          840109: {
            name: {
              th: 'บางโพธิ์',
              en: 'Bang Pho',
            },
            zipcode: '84000',
          },
          840110: {
            name: {
              th: 'บางกุ้ง',
              en: 'Bang Kung',
            },
            zipcode: '84000',
          },
          840111: {
            name: {
              th: 'คลองฉนาก',
              en: 'Khlong Chanak',
            },
            zipcode: '84000',
          },
        },
      },
      8402: {
        name: {
          th: 'กาญจนดิษฐ์',
          en: 'Kanchanadit',
        },
        tambons: {
          840201: {
            name: {
              th: 'ท่าทองใหม่',
              en: 'Tha Thong Mai',
            },
            zipcode: '84290',
          },
          840202: {
            name: {
              th: 'ท่าทอง',
              en: 'Tha Thong',
            },
            zipcode: '84160',
          },
          840203: {
            name: {
              th: 'กะแดะ',
              en: 'Kadae',
            },
            zipcode: '84160',
          },
          840204: {
            name: {
              th: 'ทุ่งกง',
              en: 'Thung Kong',
            },
            zipcode: '84290',
          },
          840205: {
            name: {
              th: 'กรูด',
              en: 'Krut',
            },
            zipcode: '84160',
          },
          840206: {
            name: {
              th: 'ช้างซ้าย',
              en: 'Chang Sai',
            },
            zipcode: '84160',
          },
          840207: {
            name: {
              th: 'พลายวาส',
              en: 'Phlai Wat',
            },
            zipcode: '84160',
          },
          840208: {
            name: {
              th: 'ป่าร่อน',
              en: 'Pa Ron',
            },
            zipcode: '84160',
          },
          840209: {
            name: {
              th: 'ตะเคียนทอง',
              en: 'Takhian Thong',
            },
            zipcode: '84160',
          },
          840210: {
            name: {
              th: 'ช้างขวา',
              en: 'Chang Khwa',
            },
            zipcode: '84160',
          },
          840211: {
            name: {
              th: 'ท่าอุแท',
              en: 'Tha U-thae',
            },
            zipcode: '84160',
          },
          840212: {
            name: {
              th: 'ทุ่งรัง',
              en: 'Thung Rang',
            },
            zipcode: '84290',
          },
          840213: {
            name: {
              th: 'คลองสระ',
              en: 'Khlong Sa',
            },
            zipcode: '84160',
          },
        },
      },
      8403: {
        name: {
          th: 'ดอนสัก',
          en: 'Don Sak',
        },
        tambons: {
          840301: {
            name: {
              th: 'ดอนสัก',
              en: 'Don Sak',
            },
            zipcode: '84220',
          },
          840302: {
            name: {
              th: 'ชลคราม',
              en: 'Chonlakhram',
            },
            zipcode: '84160',
          },
          840303: {
            name: {
              th: 'ไชยคราม',
              en: 'Chaiyakhram',
            },
            zipcode: '84220',
          },
          840304: {
            name: {
              th: 'ปากแพรก',
              en: 'Pak Phraek',
            },
            zipcode: '84340',
          },
        },
      },
      8404: {
        name: {
          th: 'เกาะสมุย',
          en: 'Ko Samui',
        },
        tambons: {
          840401: {
            name: {
              th: 'อ่างทอง',
              en: 'Ang Thong',
            },
            zipcode: '84140',
          },
          840402: {
            name: {
              th: 'ลิปะน้อย',
              en: 'Lipa Noi',
            },
            zipcode: '84140',
          },
          840403: {
            name: {
              th: 'ตลิ่งงาม',
              en: 'Taling Ngam',
            },
            zipcode: '84140',
          },
          840404: {
            name: {
              th: 'หน้าเมือง',
              en: 'Na Mueang',
            },
            zipcode: '84140',
          },
          840405: {
            name: {
              th: 'มะเร็ต',
              en: 'Maret',
            },
            zipcode: '84310',
          },
          840406: {
            name: {
              th: 'บ่อผุด',
              en: 'Bo Phut',
            },
            zipcode: '84320',
          },
          840407: {
            name: {
              th: 'แม่น้ำ',
              en: 'Mae Nam',
            },
            zipcode: '84330',
          },
        },
      },
      8405: {
        name: {
          th: 'เกาะพะงัน',
          en: 'Ko Phangan',
        },
        tambons: {
          840501: {
            name: {
              th: 'เกาะพะงัน',
              en: 'Ko Pha-ngan',
            },
            zipcode: '84280',
          },
          840502: {
            name: {
              th: 'บ้านใต้',
              en: 'Ban Tai',
            },
            zipcode: '84280',
          },
          840503: {
            name: {
              th: 'เกาะเต่า',
              en: 'Ko Tao',
            },
            zipcode: '84280',
          },
        },
      },
      8406: {
        name: {
          th: 'ไชยา',
          en: 'Chaiya',
        },
        tambons: {
          840601: {
            name: {
              th: 'ตลาดไชยา',
              en: 'Talat Chaiya',
            },
            zipcode: '84110',
          },
          840602: {
            name: {
              th: 'พุมเรียง',
              en: 'Phumriang',
            },
            zipcode: '84110',
          },
          840603: {
            name: {
              th: 'เลม็ด',
              en: 'Lamet',
            },
            zipcode: '84110',
          },
          840604: {
            name: {
              th: 'เวียง',
              en: 'Wiang',
            },
            zipcode: '84110',
          },
          840605: {
            name: {
              th: 'ทุ่ง',
              en: 'Thung',
            },
            zipcode: '84110',
          },
          840606: {
            name: {
              th: 'ป่าเว',
              en: 'Pa We',
            },
            zipcode: '84110',
          },
          840607: {
            name: {
              th: 'ตะกรบ',
              en: 'Takrop',
            },
            zipcode: '84110',
          },
          840608: {
            name: {
              th: 'โมถ่าย',
              en: 'Mo Thai',
            },
            zipcode: '84110',
          },
          840609: {
            name: {
              th: 'ปากหมาก',
              en: 'Pak Mak',
            },
            zipcode: '84110',
          },
        },
      },
      8407: {
        name: {
          th: 'ท่าชนะ',
          en: 'Tha Chana',
        },
        tambons: {
          840701: {
            name: {
              th: 'ท่าชนะ',
              en: 'Tha Chana',
            },
            zipcode: '84170',
          },
          840702: {
            name: {
              th: 'สมอทอง',
              en: 'Samo Thong',
            },
            zipcode: '84170',
          },
          840703: {
            name: {
              th: 'ประสงค์',
              en: 'Prasong',
            },
            zipcode: '84170',
          },
          840704: {
            name: {
              th: 'คันธุลี',
              en: 'Khan Thuli',
            },
            zipcode: '84170',
          },
          840705: {
            name: {
              th: 'วัง',
              en: 'Wang',
            },
            zipcode: '84170',
          },
          840706: {
            name: {
              th: 'คลองพา',
              en: 'Khlong Pha',
            },
            zipcode: '84170',
          },
        },
      },
      8408: {
        name: {
          th: 'คีรีรัฐนิคม',
          en: 'Khiriratthanikhom',
        },
        tambons: {
          840801: {
            name: {
              th: 'ท่าขนอน',
              en: 'Tha Khanon',
            },
            zipcode: '84180',
          },
          840802: {
            name: {
              th: 'บ้านยาง',
              en: 'Ban Yang',
            },
            zipcode: '84180',
          },
          840803: {
            name: {
              th: 'น้ำหัก',
              en: 'Nam Hak',
            },
            zipcode: '84180',
          },
          840806: {
            name: {
              th: 'กะเปา',
              en: 'Kapao',
            },
            zipcode: '84180',
          },
          840807: {
            name: {
              th: 'ท่ากระดาน',
              en: 'Tha Kradan',
            },
            zipcode: '84180',
          },
          840808: {
            name: {
              th: 'ย่านยาว',
              en: 'Yan Yao',
            },
            zipcode: '84180',
          },
          840809: {
            name: {
              th: 'ถ้ำสิงขร',
              en: 'Tham Singkhon',
            },
            zipcode: '84180',
          },
          840810: {
            name: {
              th: 'บ้านทำเนียบ',
              en: 'Ban Thamniap',
            },
            zipcode: '84180',
          },
        },
      },
      8409: {
        name: {
          th: 'บ้านตาขุน',
          en: 'Ban Ta Khun',
        },
        tambons: {
          840901: {
            name: {
              th: 'เขาวง',
              en: 'Khao Wong',
            },
            zipcode: '84230',
          },
          840902: {
            name: {
              th: 'พะแสง',
              en: 'Phasaeng',
            },
            zipcode: '84230',
          },
          840903: {
            name: {
              th: 'พรุไทย',
              en: 'Phru Thai',
            },
            zipcode: '84230',
          },
          840904: {
            name: {
              th: 'เขาพัง',
              en: 'Khao Phang',
            },
            zipcode: '84230',
          },
        },
      },
      8410: {
        name: {
          th: 'พนม',
          en: 'Phanom',
        },
        tambons: {
          841001: {
            name: {
              th: 'พนม',
              en: 'Phanom',
            },
            zipcode: '84250',
          },
          841002: {
            name: {
              th: 'ต้นยวน',
              en: 'Ton Yuan',
            },
            zipcode: '84250',
          },
          841003: {
            name: {
              th: 'คลองศก',
              en: 'Khlong Sok',
            },
            zipcode: '84250',
          },
          841004: {
            name: {
              th: 'พลูเถื่อน',
              en: 'Phlu Thuean',
            },
            zipcode: '84250',
          },
          841005: {
            name: {
              th: 'พังกาญจน์',
              en: 'Phang Kan',
            },
            zipcode: '84250',
          },
          841006: {
            name: {
              th: 'คลองชะอุ่น',
              en: 'Khlong Cha-un',
            },
            zipcode: '84250',
          },
        },
      },
      8411: {
        name: {
          th: 'ท่าฉาง',
          en: 'Tha Chang',
        },
        tambons: {
          841101: {
            name: {
              th: 'ท่าฉาง',
              en: 'Tha Chang',
            },
            zipcode: '84150',
          },
          841102: {
            name: {
              th: 'ท่าเคย',
              en: 'Tha Khoei',
            },
            zipcode: '84150',
          },
          841103: {
            name: {
              th: 'คลองไทร',
              en: 'Khlong Sai',
            },
            zipcode: '84150',
          },
          841104: {
            name: {
              th: 'เขาถ่าน',
              en: 'Khao Than',
            },
            zipcode: '84150',
          },
          841105: {
            name: {
              th: 'เสวียด',
              en: 'Sawiat',
            },
            zipcode: '84150',
          },
          841106: {
            name: {
              th: 'ปากฉลุย',
              en: 'Pak Chalui',
            },
            zipcode: '84150',
          },
        },
      },
      8412: {
        name: {
          th: 'บ้านนาสาร',
          en: 'Ban Na San',
        },
        tambons: {
          841201: {
            name: {
              th: 'นาสาร',
              en: 'Na San',
            },
            zipcode: '84120',
          },
          841202: {
            name: {
              th: 'พรุพี',
              en: 'Phru Phi',
            },
            zipcode: '84270',
          },
          841203: {
            name: {
              th: 'ทุ่งเตา',
              en: 'Thung Tao',
            },
            zipcode: '84120',
          },
          841204: {
            name: {
              th: 'ลำพูน',
              en: 'Lamphun',
            },
            zipcode: '84120',
          },
          841205: {
            name: {
              th: 'ท่าชี',
              en: 'Tha Chi',
            },
            zipcode: '84120',
          },
          841206: {
            name: {
              th: 'ควนศรี',
              en: 'Khuan Si',
            },
            zipcode: '84270',
          },
          841207: {
            name: {
              th: 'ควนสุบรรณ',
              en: 'Khuan Suban',
            },
            zipcode: '84120',
          },
          841208: {
            name: {
              th: 'คลองปราบ',
              en: 'Khlong Prap',
            },
            zipcode: '84120',
          },
          841209: {
            name: {
              th: 'น้ำพุ',
              en: 'Nam Phu',
            },
            zipcode: '84120',
          },
          841210: {
            name: {
              th: 'ทุ่งเตาใหม่',
              en: 'Thung Tao Mai',
            },
            zipcode: '84120',
          },
          841211: {
            name: {
              th: 'เพิ่มพูนทรัพย์',
              en: 'Phoem Phun Sap',
            },
            zipcode: '84120',
          },
        },
      },
      8413: {
        name: {
          th: 'บ้านนาเดิม',
          en: 'Ban Na Doem',
        },
        tambons: {
          841301: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '84240',
          },
          841302: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '84240',
          },
          841303: {
            name: {
              th: 'ทรัพย์ทวี',
              en: 'Sap Thawi',
            },
            zipcode: '84240',
          },
          841304: {
            name: {
              th: 'นาใต้',
              en: 'Na Tai',
            },
            zipcode: '84240',
          },
        },
      },
      8414: {
        name: {
          th: 'เคียนซา',
          en: 'Khian Sa',
        },
        tambons: {
          841401: {
            name: {
              th: 'เคียนซา',
              en: 'Khian Sa',
            },
            zipcode: '84260',
          },
          841402: {
            name: {
              th: 'พ่วงพรมคร',
              en: 'Phuang Phromkhon',
            },
            zipcode: '84210',
          },
          841403: {
            name: {
              th: 'เขาตอก',
              en: 'Khao Tok',
            },
            zipcode: '84260',
          },
          841404: {
            name: {
              th: 'อรัญคามวารี',
              en: 'Aranyakham Wari',
            },
            zipcode: '84260',
          },
          841405: {
            name: {
              th: 'บ้านเสด็จ',
              en: 'Ban Sadet',
            },
            zipcode: '84260',
          },
        },
      },
      8415: {
        name: {
          th: 'เวียงสระ',
          en: 'Wieng Sa',
        },
        tambons: {
          841501: {
            name: {
              th: 'เวียงสระ',
              en: 'Wiang Sa',
            },
            zipcode: '84190',
          },
          841502: {
            name: {
              th: 'บ้านส้อง',
              en: 'Ban Song',
            },
            zipcode: '84190',
          },
          841503: {
            name: {
              th: 'คลองฉนวน',
              en: 'Khlong Chanuan',
            },
            zipcode: '84190',
          },
          841504: {
            name: {
              th: 'ทุ่งหลวง',
              en: 'Thung Luang',
            },
            zipcode: '84190',
          },
          841505: {
            name: {
              th: 'เขานิพันธ์',
              en: 'Khao Niphan',
            },
            zipcode: '84190',
          },
        },
      },
      8416: {
        name: {
          th: 'พระแสง',
          en: 'Phra Saeng',
        },
        tambons: {
          841601: {
            name: {
              th: 'อิปัน',
              en: 'I-pan',
            },
            zipcode: '84210',
          },
          841602: {
            name: {
              th: 'สินปุน',
              en: 'Sin Pun',
            },
            zipcode: '84210',
          },
          841603: {
            name: {
              th: 'บางสวรรค์',
              en: 'Bang Sawan',
            },
            zipcode: '84210',
          },
          841604: {
            name: {
              th: 'ไทรขึง',
              en: 'Sai Khueng',
            },
            zipcode: '84210',
          },
          841605: {
            name: {
              th: 'สินเจริญ',
              en: 'Sin Charoen',
            },
            zipcode: '84210',
          },
          841606: {
            name: {
              th: 'ไทรโสภา',
              en: 'Sai Sopha',
            },
            zipcode: '84210',
          },
          841607: {
            name: {
              th: 'สาคู',
              en: 'Sakhu',
            },
            zipcode: '84210',
          },
        },
      },
      8417: {
        name: {
          th: 'พุนพิน',
          en: 'Phun Phin',
        },
        tambons: {
          841701: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '84130',
          },
          841702: {
            name: {
              th: 'ท่าสะท้อน',
              en: 'Tha Sathon',
            },
            zipcode: '84130',
          },
          841703: {
            name: {
              th: 'ลีเล็ด',
              en: 'Lilet',
            },
            zipcode: '84130',
          },
          841704: {
            name: {
              th: 'บางมะเดื่อ',
              en: 'Bang Maduea',
            },
            zipcode: '84130',
          },
          841705: {
            name: {
              th: 'บางเดือน',
              en: 'Bang Duean',
            },
            zipcode: '84130',
          },
          841706: {
            name: {
              th: 'ท่าโรงช้าง',
              en: 'Tha Rong Chang',
            },
            zipcode: '84130',
          },
          841707: {
            name: {
              th: 'กรูด',
              en: 'Krut',
            },
            zipcode: '84130',
          },
          841708: {
            name: {
              th: 'พุนพิน',
              en: 'Phunphin',
            },
            zipcode: '84130',
          },
          841709: {
            name: {
              th: 'บางงอน',
              en: 'Bang Ngon',
            },
            zipcode: '84130',
          },
          841710: {
            name: {
              th: 'ศรีวิชัย',
              en: 'Si Wichai',
            },
            zipcode: '84130',
          },
          841711: {
            name: {
              th: 'น้ำรอบ',
              en: 'Nam Rop',
            },
            zipcode: '84130',
          },
          841712: {
            name: {
              th: 'มะลวน',
              en: 'Maluan',
            },
            zipcode: '84130',
          },
          841713: {
            name: {
              th: 'หัวเตย',
              en: 'Hua Toei',
            },
            zipcode: '84130',
          },
          841714: {
            name: {
              th: 'หนองไทร',
              en: 'Nong Sai',
            },
            zipcode: '84130',
          },
          841715: {
            name: {
              th: 'เขาหัวควาย',
              en: 'Khao Hua Khwai',
            },
            zipcode: '84130',
          },
          841716: {
            name: {
              th: 'ตะปาน',
              en: 'Tapan',
            },
            zipcode: '84130',
          },
        },
      },
      8418: {
        name: {
          th: 'ชัยบุรี',
          en: 'Chai Buri',
        },
        tambons: {
          841801: {
            name: {
              th: 'สองแพรก',
              en: 'Song Phraek',
            },
            zipcode: '84350',
          },
          841802: {
            name: {
              th: 'ชัยบุรี',
              en: 'Chai Buri',
            },
            zipcode: '84350',
          },
          841803: {
            name: {
              th: 'คลองน้อย',
              en: 'Khlong Noi',
            },
            zipcode: '84350',
          },
          841804: {
            name: {
              th: 'ไทรทอง',
              en: 'Sai Thong',
            },
            zipcode: '84350',
          },
        },
      },
      8419: {
        name: {
          th: 'วิภาวดี',
          en: 'King Amphoe Wiphawadi',
        },
        tambons: {
          841901: {
            name: {
              th: 'ตะกุกใต้',
              en: 'Takuk Tai',
            },
            zipcode: '84180',
          },
          841902: {
            name: {
              th: 'ตะกุกเหนือ',
              en: 'Takuk Nuea',
            },
            zipcode: '84180',
          },
        },
      },
    },
  },
  85: {
    name: {
      th: 'ระนอง',
      en: 'Ranong',
    },
    amphoes: {
      8501: {
        name: {
          th: 'เมืองระนอง',
          en: 'Muang',
        },
        tambons: {
          850101: {
            name: {
              th: 'เขานิเวศน์',
              en: 'Khao Niwet',
            },
            zipcode: '85000',
          },
          850102: {
            name: {
              th: 'ราชกรูด',
              en: 'Ratchakrut',
            },
            zipcode: '85000',
          },
          850103: {
            name: {
              th: 'หงาว',
              en: 'Ngao',
            },
            zipcode: '85000',
          },
          850104: {
            name: {
              th: 'บางริ้น',
              en: 'Bang Rin',
            },
            zipcode: '85000',
          },
          850105: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '85000',
          },
          850106: {
            name: {
              th: 'บางนอน',
              en: 'Bang Non',
            },
            zipcode: '85000',
          },
          850107: {
            name: {
              th: 'หาดส้มแป้น',
              en: 'Hat Som Paen',
            },
            zipcode: '85000',
          },
          850108: {
            name: {
              th: 'ทรายแดง',
              en: 'Sai Daeng',
            },
            zipcode: '85130',
          },
          850109: {
            name: {
              th: 'เกาะพยาม',
              en: 'Ko Phayam',
            },
            zipcode: '85000',
          },
        },
      },
      8502: {
        name: {
          th: 'ละอุ่น',
          en: 'La-Un',
        },
        tambons: {
          850201: {
            name: {
              th: 'ละอุ่นใต้',
              en: 'La-un Tai',
            },
            zipcode: '85130',
          },
          850202: {
            name: {
              th: 'ละอุ่นเหนือ',
              en: 'La-un Nuea',
            },
            zipcode: '85130',
          },
          850203: {
            name: {
              th: 'บางพระใต้',
              en: 'Bang Phra Tai',
            },
            zipcode: '85130',
          },
          850204: {
            name: {
              th: 'บางพระเหนือ',
              en: 'Bang Phra Nuea',
            },
            zipcode: '85130',
          },
          850205: {
            name: {
              th: 'บางแก้ว',
              en: 'Bang Kaeo',
            },
            zipcode: '85130',
          },
          850206: {
            name: {
              th: 'ในวงเหนือ',
              en: 'Nai Wong Nuea',
            },
            zipcode: '85130',
          },
          850207: {
            name: {
              th: 'ในวงใต้',
              en: 'Nai Wong Tai',
            },
            zipcode: '85130',
          },
        },
      },
      8503: {
        name: {
          th: 'กะเปอร์',
          en: 'Kaper',
        },
        tambons: {
          850301: {
            name: {
              th: 'ม่วงกลวง',
              en: 'Muang Kluang',
            },
            zipcode: '85120',
          },
          850302: {
            name: {
              th: 'กะเปอร์',
              en: 'Kapoe',
            },
            zipcode: '85120',
          },
          850303: {
            name: {
              th: 'เชี่ยวเหลียง',
              en: 'Chiao Liang',
            },
            zipcode: '85120',
          },
          850304: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '85120',
          },
          850305: {
            name: {
              th: 'บางหิน',
              en: 'Bang Hin',
            },
            zipcode: '85120',
          },
        },
      },
      8504: {
        name: {
          th: 'กระบุรี',
          en: 'Kra Buri',
        },
        tambons: {
          850401: {
            name: {
              th: 'น้ำจืด',
              en: 'Nam Chuet',
            },
            zipcode: '85110',
          },
          850402: {
            name: {
              th: 'น้ำจืดน้อย',
              en: 'Nam Chuet Noi',
            },
            zipcode: '85110',
          },
          850403: {
            name: {
              th: 'มะมุ',
              en: 'Mamu',
            },
            zipcode: '85110',
          },
          850404: {
            name: {
              th: 'ปากจั่น',
              en: 'Pak Chan',
            },
            zipcode: '85110',
          },
          850405: {
            name: {
              th: 'ลำเลียง',
              en: 'Lam Liang',
            },
            zipcode: '85110',
          },
          850406: {
            name: {
              th: 'จ.ป.ร.',
              en: 'Choporo',
            },
            zipcode: '85110',
          },
          850407: {
            name: {
              th: 'บางใหญ่',
              en: 'Bang Yai',
            },
            zipcode: '85110',
          },
        },
      },
      8505: {
        name: {
          th: 'สุขสำราญ',
          en: 'King Amphoe Sook Samran',
        },
        tambons: {
          850501: {
            name: {
              th: 'นาคา',
              en: 'Nakha',
            },
            zipcode: '85120',
          },
          850502: {
            name: {
              th: 'กำพวน',
              en: 'Kamphuan',
            },
            zipcode: '85120',
          },
        },
      },
    },
  },
  86: {
    name: {
      th: 'ชุมพร',
      en: 'Chumphon',
    },
    amphoes: {
      8601: {
        name: {
          th: 'เมืองชุมพร',
          en: 'Muang',
        },
        tambons: {
          860101: {
            name: {
              th: 'ท่าตะเภา',
              en: 'Tha Taphao',
            },
            zipcode: '86000',
          },
          860102: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '86120',
          },
          860103: {
            name: {
              th: 'ท่ายาง',
              en: 'Tha Yang',
            },
            zipcode: '86000',
          },
          860104: {
            name: {
              th: 'บางหมาก',
              en: 'Bang Mak',
            },
            zipcode: '86000',
          },
          860105: {
            name: {
              th: 'นาทุ่ง',
              en: 'Na Thung',
            },
            zipcode: '86000',
          },
          860106: {
            name: {
              th: 'นาชะอัง',
              en: 'Na Cha-ang',
            },
            zipcode: '86000',
          },
          860107: {
            name: {
              th: 'ตากแดด',
              en: 'Tak Daet',
            },
            zipcode: '86000',
          },
          860108: {
            name: {
              th: 'บางลึก',
              en: 'Bang Luek',
            },
            zipcode: '86000',
          },
          860109: {
            name: {
              th: 'หาดพันไกร',
              en: 'Hat Phan Krai',
            },
            zipcode: '86000',
          },
          860110: {
            name: {
              th: 'วังไผ่',
              en: 'Wang Phai',
            },
            zipcode: '86000',
          },
          860111: {
            name: {
              th: 'วังใหม่',
              en: 'Wang Mai',
            },
            zipcode: '86190',
          },
          860112: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '86190',
          },
          860113: {
            name: {
              th: 'ขุนกระทิง',
              en: 'Khun Krathing',
            },
            zipcode: '86000',
          },
          860114: {
            name: {
              th: 'ทุ่งคา',
              en: 'Thung Kha',
            },
            zipcode: '86100',
          },
          860115: {
            name: {
              th: 'วิสัยเหนือ',
              en: 'Wisai Nuea',
            },
            zipcode: '86100',
          },
          860116: {
            name: {
              th: 'หาดทรายรี',
              en: 'Hat Sai Ri',
            },
            zipcode: '86120',
          },
          860117: {
            name: {
              th: 'ถ้ำสิงห์',
              en: 'Tham Sing',
            },
            zipcode: '86100',
          },
        },
      },
      8602: {
        name: {
          th: 'ท่าแซะ',
          en: 'Tha Sae',
        },
        tambons: {
          860201: {
            name: {
              th: 'ท่าแซะ',
              en: 'Tha Sae',
            },
            zipcode: '86140',
          },
          860202: {
            name: {
              th: 'คุริง',
              en: 'Khuring',
            },
            zipcode: '86140',
          },
          860203: {
            name: {
              th: 'สลุย',
              en: 'Salui',
            },
            zipcode: '86140',
          },
          860204: {
            name: {
              th: 'นากระตาม',
              en: 'Na Kratam',
            },
            zipcode: '86140',
          },
          860205: {
            name: {
              th: 'รับร่อ',
              en: 'Rap Ro',
            },
            zipcode: '86140',
          },
          860206: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '86140',
          },
          860207: {
            name: {
              th: 'หงษ์เจริญ',
              en: 'Hong Charoen',
            },
            zipcode: '86140',
          },
          860208: {
            name: {
              th: 'หินแก้ว',
              en: 'Hin Kaeo',
            },
            zipcode: '86190',
          },
          860209: {
            name: {
              th: 'ทรัพย์อนันต์',
              en: 'Sap Anan',
            },
            zipcode: '86140',
          },
          860210: {
            name: {
              th: 'สองพี่น้อง',
              en: 'Song Phi Nong',
            },
            zipcode: '86140',
          },
        },
      },
      8603: {
        name: {
          th: 'ปะทิว',
          en: 'Pathiu',
        },
        tambons: {
          860301: {
            name: {
              th: 'บางสน',
              en: 'Bang Son',
            },
            zipcode: '86160',
          },
          860302: {
            name: {
              th: 'ทะเลทรัพย์',
              en: 'Thale Sap',
            },
            zipcode: '86160',
          },
          860303: {
            name: {
              th: 'สะพลี',
              en: 'Saphli',
            },
            zipcode: '86230',
          },
          860304: {
            name: {
              th: 'ชุมโค',
              en: 'Chum Kho',
            },
            zipcode: '86160',
          },
          860305: {
            name: {
              th: 'ดอนยาง',
              en: 'Don Yang',
            },
            zipcode: '86210',
          },
          860306: {
            name: {
              th: 'ปากคลอง',
              en: 'Pak Khlong',
            },
            zipcode: '86210',
          },
          860307: {
            name: {
              th: 'เขาไชยราช',
              en: 'Khao Chai Rat',
            },
            zipcode: '86210',
          },
        },
      },
      8604: {
        name: {
          th: 'หลังสวน',
          en: 'Lang Suan',
        },
        tambons: {
          860401: {
            name: {
              th: 'หลังสวน',
              en: 'Lang Suan',
            },
            zipcode: '86110',
          },
          860402: {
            name: {
              th: 'ขันเงิน',
              en: 'Khan Ngoen',
            },
            zipcode: '86110',
          },
          860403: {
            name: {
              th: 'ท่ามะพลา',
              en: 'Tha Maphla',
            },
            zipcode: '86110',
          },
          860404: {
            name: {
              th: 'นาขา',
              en: 'Na Kha',
            },
            zipcode: '86110',
          },
          860405: {
            name: {
              th: 'นาพญา',
              en: 'Na Phaya',
            },
            zipcode: '86110',
          },
          860406: {
            name: {
              th: 'บ้านควน',
              en: 'Ban Khuan',
            },
            zipcode: '86110',
          },
          860407: {
            name: {
              th: 'บางมะพร้าว',
              en: 'Bang Maphrao',
            },
            zipcode: '86110',
          },
          860408: {
            name: {
              th: 'บางน้ำจืด',
              en: 'Bang Nam Chuet',
            },
            zipcode: '86150',
          },
          860409: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '86150',
          },
          860410: {
            name: {
              th: 'พ้อแดง',
              en: 'Pho Daeng',
            },
            zipcode: '86110',
          },
          860411: {
            name: {
              th: 'แหลมทราย',
              en: 'Laem Sai',
            },
            zipcode: '86110',
          },
          860412: {
            name: {
              th: 'วังตะกอ',
              en: 'Wang Tako',
            },
            zipcode: '86110',
          },
          860413: {
            name: {
              th: 'หาดยาย',
              en: 'Hat Yai',
            },
            zipcode: '86110',
          },
        },
      },
      8605: {
        name: {
          th: 'ละแม',
          en: 'Lamae',
        },
        tambons: {
          860501: {
            name: {
              th: 'ละแม',
              en: 'Lamae',
            },
            zipcode: '86170',
          },
          860502: {
            name: {
              th: 'ทุ่งหลวง',
              en: 'Thung Luang',
            },
            zipcode: '86170',
          },
          860503: {
            name: {
              th: 'สวนแตง',
              en: 'Suan Taeng',
            },
            zipcode: '86170',
          },
          860504: {
            name: {
              th: 'ทุ่งคาวัด',
              en: 'Thung Kha Wat',
            },
            zipcode: '86170',
          },
        },
      },
      8606: {
        name: {
          th: 'พะโต๊ะ',
          en: 'Phato',
        },
        tambons: {
          860601: {
            name: {
              th: 'พะโต๊ะ',
              en: 'Phato',
            },
            zipcode: '86180',
          },
          860602: {
            name: {
              th: 'ปากทรง',
              en: 'Pak Song',
            },
            zipcode: '86180',
          },
          860603: {
            name: {
              th: 'ปังหวาน',
              en: 'Pang Wan',
            },
            zipcode: '86180',
          },
          860604: {
            name: {
              th: 'พระรักษ์',
              en: 'Phra Rak',
            },
            zipcode: '86180',
          },
        },
      },
      8607: {
        name: {
          th: 'สวี',
          en: 'Sawi',
        },
        tambons: {
          860701: {
            name: {
              th: 'นาโพธิ์',
              en: 'Na Pho',
            },
            zipcode: '86130',
          },
          860702: {
            name: {
              th: 'สวี',
              en: 'Sawi',
            },
            zipcode: '86130',
          },
          860703: {
            name: {
              th: 'ทุ่งระยะ',
              en: 'Thung Raya',
            },
            zipcode: '86130',
          },
          860704: {
            name: {
              th: 'ท่าหิน',
              en: 'Tha Hin',
            },
            zipcode: '86130',
          },
          860705: {
            name: {
              th: 'ปากแพรก',
              en: 'Pak Phraek',
            },
            zipcode: '86130',
          },
          860706: {
            name: {
              th: 'ด่านสวี',
              en: 'Dan Sawi',
            },
            zipcode: '86130',
          },
          860707: {
            name: {
              th: 'ครน',
              en: 'Khron',
            },
            zipcode: '86130',
          },
          860708: {
            name: {
              th: 'วิสัยใต้',
              en: 'Wisai Tai',
            },
            zipcode: '86130',
          },
          860709: {
            name: {
              th: 'นาสัก',
              en: 'Na Sak',
            },
            zipcode: '86130',
          },
          860710: {
            name: {
              th: 'เขาทะลุ',
              en: 'Khao Thalu',
            },
            zipcode: '86130',
          },
          860711: {
            name: {
              th: 'เขาค่าย',
              en: 'Khao Khai',
            },
            zipcode: '86130',
          },
        },
      },
      8608: {
        name: {
          th: 'ทุ่งตะโก',
          en: 'Thung Tako',
        },
        tambons: {
          860801: {
            name: {
              th: 'ปากตะโก',
              en: 'Pak Tako',
            },
            zipcode: '86220',
          },
          860802: {
            name: {
              th: 'ทุ่งตะไคร',
              en: 'Thung Takhrai',
            },
            zipcode: '86220',
          },
          860803: {
            name: {
              th: 'ตะโก',
              en: 'Tako',
            },
            zipcode: '86220',
          },
          860804: {
            name: {
              th: 'ช่องไม้แก้ว',
              en: 'Chong Mai Kaeo',
            },
            zipcode: '86220',
          },
        },
      },
    },
  },
  90: {
    name: {
      th: 'สงขลา',
      en: 'Songkhla',
    },
    amphoes: {
      9001: {
        name: {
          th: 'เมืองสงขลา',
          en: 'Muang',
        },
        tambons: {
          900101: {
            name: {
              th: 'บ่อยาง',
              en: 'Bo Yang',
            },
            zipcode: '90000',
          },
          900102: {
            name: {
              th: 'เขารูปช้าง',
              en: 'Khao Rup Chang',
            },
            zipcode: '90000',
          },
          900103: {
            name: {
              th: 'เกาะแต้ว',
              en: 'Ko Taeo',
            },
            zipcode: '90000',
          },
          900104: {
            name: {
              th: 'พะวง',
              en: 'Phawong',
            },
            zipcode: '90100',
          },
          900105: {
            name: {
              th: 'ทุ่งหวัง',
              en: 'Thung Wang',
            },
            zipcode: '90000',
          },
          900106: {
            name: {
              th: 'เกาะยอ',
              en: 'Ko Yo',
            },
            zipcode: '90100',
          },
        },
      },
      9002: {
        name: {
          th: 'สทิงพระ',
          en: 'Sathing Phra',
        },
        tambons: {
          900201: {
            name: {
              th: 'จะทิ้งพระ',
              en: 'Chathing Phra',
            },
            zipcode: '90190',
          },
          900202: {
            name: {
              th: 'กระดังงา',
              en: 'Kradang-nga',
            },
            zipcode: '90190',
          },
          900203: {
            name: {
              th: 'สนามชัย',
              en: 'Sanam Chai',
            },
            zipcode: '90190',
          },
          900204: {
            name: {
              th: 'ดีหลวง',
              en: 'Di Luang',
            },
            zipcode: '90190',
          },
          900205: {
            name: {
              th: 'ชุมพล',
              en: 'Chumphon',
            },
            zipcode: '90190',
          },
          900206: {
            name: {
              th: 'คลองรี',
              en: 'Khlong Ri',
            },
            zipcode: '90190',
          },
          900207: {
            name: {
              th: 'คูขุด',
              en: 'Khu Khut',
            },
            zipcode: '90190',
          },
          900208: {
            name: {
              th: 'ท่าหิน',
              en: 'Tha Hin',
            },
            zipcode: '90190',
          },
          900209: {
            name: {
              th: 'วัดจันทร์',
              en: 'Wat Chan',
            },
            zipcode: '90190',
          },
          900210: {
            name: {
              th: 'บ่อแดง',
              en: 'Bo Daeng',
            },
            zipcode: '90190',
          },
          900211: {
            name: {
              th: 'บ่อดาน',
              en: 'Bo Dan',
            },
            zipcode: '90190',
          },
        },
      },
      9003: {
        name: {
          th: 'จะนะ',
          en: 'Chana',
        },
        tambons: {
          900301: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '90130',
          },
          900302: {
            name: {
              th: 'ป่าชิง',
              en: 'Pa Ching',
            },
            zipcode: '90130',
          },
          900303: {
            name: {
              th: 'สะพานไม้แก่น',
              en: 'Saphan Mai Kaen',
            },
            zipcode: '90130',
          },
          900304: {
            name: {
              th: 'สะกอม',
              en: 'Sakom',
            },
            zipcode: '90130',
          },
          900305: {
            name: {
              th: 'นาหว้า',
              en: 'Na Wa',
            },
            zipcode: '90130',
          },
          900306: {
            name: {
              th: 'นาทับ',
              en: 'Na Thap',
            },
            zipcode: '90130',
          },
          900307: {
            name: {
              th: 'น้ำขาว',
              en: 'Nam Khao',
            },
            zipcode: '90130',
          },
          900308: {
            name: {
              th: 'ขุนตัดหวาย',
              en: 'Khun Tat Wai',
            },
            zipcode: '90130',
          },
          900309: {
            name: {
              th: 'ท่าหมอไทร',
              en: 'Tha Mo Sai',
            },
            zipcode: '90130',
          },
          900310: {
            name: {
              th: 'จะโหนง',
              en: 'Chanong',
            },
            zipcode: '90130',
          },
          900311: {
            name: {
              th: 'คู',
              en: 'Khu',
            },
            zipcode: '90130',
          },
          900312: {
            name: {
              th: 'แค',
              en: 'Khae',
            },
            zipcode: '90130',
          },
          900313: {
            name: {
              th: 'คลองเปียะ',
              en: 'Khlong Pia',
            },
            zipcode: '90130',
          },
          900314: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '90130',
          },
        },
      },
      9004: {
        name: {
          th: 'นาทวี',
          en: 'Na Thawi',
        },
        tambons: {
          900401: {
            name: {
              th: 'นาทวี',
              en: 'Na Thawi',
            },
            zipcode: '90160',
          },
          900402: {
            name: {
              th: 'ฉาง',
              en: 'Chang',
            },
            zipcode: '90160',
          },
          900403: {
            name: {
              th: 'นาหมอศรี',
              en: 'Na Mo Si',
            },
            zipcode: '90160',
          },
          900404: {
            name: {
              th: 'คลองทราย',
              en: 'Khlong Sai',
            },
            zipcode: '90160',
          },
          900405: {
            name: {
              th: 'ปลักหนู',
              en: 'Plak Nu',
            },
            zipcode: '90160',
          },
          900406: {
            name: {
              th: 'ท่าประดู่',
              en: 'Tha Pradu',
            },
            zipcode: '90160',
          },
          900407: {
            name: {
              th: 'สะท้อน',
              en: 'Sathon',
            },
            zipcode: '90160',
          },
          900408: {
            name: {
              th: 'ทับช้าง',
              en: 'Thap Chang',
            },
            zipcode: '90160',
          },
          900409: {
            name: {
              th: 'ประกอบ',
              en: 'Prakop',
            },
            zipcode: '90160',
          },
          900410: {
            name: {
              th: 'คลองกวาง',
              en: 'Khlong Kwang',
            },
            zipcode: '90160',
          },
        },
      },
      9005: {
        name: {
          th: 'เทพา',
          en: 'Thepha',
        },
        tambons: {
          900501: {
            name: {
              th: 'เทพา',
              en: 'Thepha',
            },
            zipcode: '90150',
          },
          900502: {
            name: {
              th: 'ปากบาง',
              en: 'Pak Bang',
            },
            zipcode: '90150',
          },
          900503: {
            name: {
              th: 'เกาะสะบ้า',
              en: 'Ko Saba',
            },
            zipcode: '90150',
          },
          900504: {
            name: {
              th: 'ลำไพล',
              en: 'Lam Phlai',
            },
            zipcode: '90260',
          },
          900505: {
            name: {
              th: 'ท่าม่วง',
              en: 'Tha Muang',
            },
            zipcode: '90150',
          },
          900506: {
            name: {
              th: 'วังใหญ่',
              en: 'Wang Yai',
            },
            zipcode: '90260',
          },
          900507: {
            name: {
              th: 'สะกอม',
              en: 'Sakom',
            },
            zipcode: '90150',
          },
        },
      },
      9006: {
        name: {
          th: 'สะบ้าย้อย',
          en: 'Saba Yoi',
        },
        tambons: {
          900601: {
            name: {
              th: 'สะบ้าย้อย',
              en: 'Saba Yoi',
            },
            zipcode: '90210',
          },
          900602: {
            name: {
              th: 'ทุ่งพอ',
              en: 'Thung Pho',
            },
            zipcode: '90210',
          },
          900603: {
            name: {
              th: 'เปียน',
              en: 'Pian',
            },
            zipcode: '90210',
          },
          900604: {
            name: {
              th: 'บ้านโหนด',
              en: 'Ban Not',
            },
            zipcode: '90210',
          },
          900605: {
            name: {
              th: 'จะแหน',
              en: 'Chanae',
            },
            zipcode: '90210',
          },
          900606: {
            name: {
              th: 'คูหา',
              en: 'Khuha',
            },
            zipcode: '90210',
          },
          900607: {
            name: {
              th: 'เขาแดง',
              en: 'Khao Daeng',
            },
            zipcode: '90210',
          },
          900608: {
            name: {
              th: 'บาโหย',
              en: 'Ba Hoi',
            },
            zipcode: '90210',
          },
          900609: {
            name: {
              th: 'ธารคีรี',
              en: 'Than Khiri',
            },
            zipcode: '90210',
          },
        },
      },
      9007: {
        name: {
          th: 'ระโนด',
          en: 'Ranot',
        },
        tambons: {
          900701: {
            name: {
              th: 'ระโนด',
              en: 'Ranot',
            },
            zipcode: '90140',
          },
          900702: {
            name: {
              th: 'คลองแดน',
              en: 'Khlong Daen',
            },
            zipcode: '90140',
          },
          900703: {
            name: {
              th: 'ตะเครียะ',
              en: 'Takhria',
            },
            zipcode: '90140',
          },
          900704: {
            name: {
              th: 'ท่าบอน',
              en: 'Tha Bon',
            },
            zipcode: '90140',
          },
          900705: {
            name: {
              th: 'บ้านใหม่',
              en: 'Ban Mai',
            },
            zipcode: '90140',
          },
          900706: {
            name: {
              th: 'บ่อตรุ',
              en: 'Bo Tru',
            },
            zipcode: '90140',
          },
          900707: {
            name: {
              th: 'ปากแตระ',
              en: 'Pak Trae',
            },
            zipcode: '90140',
          },
          900708: {
            name: {
              th: 'พังยาง',
              en: 'Phang Yang',
            },
            zipcode: '90140',
          },
          900709: {
            name: {
              th: 'ระวะ',
              en: 'Rawa',
            },
            zipcode: '90140',
          },
          900710: {
            name: {
              th: 'วัดสน',
              en: 'Wat Son',
            },
            zipcode: '90140',
          },
          900711: {
            name: {
              th: 'บ้านขาว',
              en: 'Ban Khao',
            },
            zipcode: '90140',
          },
          900712: {
            name: {
              th: 'แดนสงวน',
              en: 'Daen Sa-nguan',
            },
            zipcode: '90140',
          },
        },
      },
      9008: {
        name: {
          th: 'กระแสสินธุ์',
          en: 'Krasae Sin',
        },
        tambons: {
          900801: {
            name: {
              th: 'เกาะใหญ่',
              en: 'Ko Yai',
            },
            zipcode: '90270',
          },
          900802: {
            name: {
              th: 'โรง',
              en: 'Rong',
            },
            zipcode: '90270',
          },
          900803: {
            name: {
              th: 'เชิงแส',
              en: 'Choeng Sae',
            },
            zipcode: '90270',
          },
          900804: {
            name: {
              th: 'กระแสสินธุ์',
              en: 'Krasae Sin',
            },
            zipcode: '90270',
          },
        },
      },
      9009: {
        name: {
          th: 'รัตภูมิ',
          en: 'Rattaphum',
        },
        tambons: {
          900901: {
            name: {
              th: 'กำแพงเพชร',
              en: 'Kamphaeng Phet',
            },
            zipcode: '90180',
          },
          900902: {
            name: {
              th: 'ท่าชะมวง',
              en: 'Tha Chamuang',
            },
            zipcode: '90180',
          },
          900903: {
            name: {
              th: 'คูหาใต้',
              en: 'Khuha Tai',
            },
            zipcode: '90180',
          },
          900904: {
            name: {
              th: 'ควนรู',
              en: 'Khuan Ru',
            },
            zipcode: '90180',
          },
          900909: {
            name: {
              th: 'เขาพระ',
              en: 'Khao Phra',
            },
            zipcode: '90180',
          },
        },
      },
      9010: {
        name: {
          th: 'สะเดา',
          en: 'Sadao',
        },
        tambons: {
          901001: {
            name: {
              th: 'สะเดา',
              en: 'Sadao',
            },
            zipcode: '90120',
          },
          901002: {
            name: {
              th: 'ปริก',
              en: 'Prik',
            },
            zipcode: '90120',
          },
          901003: {
            name: {
              th: 'พังลา',
              en: 'Phang La',
            },
            zipcode: '90170',
          },
          901004: {
            name: {
              th: 'สำนักแต้ว',
              en: 'Samnak Taeo',
            },
            zipcode: '90120',
          },
          901005: {
            name: {
              th: 'ทุ่งหมอ',
              en: 'Thung Mo',
            },
            zipcode: '90240',
          },
          901006: {
            name: {
              th: 'ท่าโพธิ์',
              en: 'Tha Pho',
            },
            zipcode: '90170',
          },
          901007: {
            name: {
              th: 'ปาดังเบซาร์',
              en: 'Padang Besa',
            },
            zipcode: '90240',
          },
          901008: {
            name: {
              th: 'สำนักขาม',
              en: 'Samnak Kham',
            },
            zipcode: '90120',
          },
          901009: {
            name: {
              th: 'เขามีเกียรติ',
              en: 'Khao Mi Kiat',
            },
            zipcode: '90170',
          },
        },
      },
      9011: {
        name: {
          th: 'หาดใหญ่',
          en: 'Hat Yai',
        },
        tambons: {
          901101: {
            name: {
              th: 'หาดใหญ่',
              en: 'Hat Yai',
            },
            zipcode: '90110',
          },
          901102: {
            name: {
              th: 'ควนลัง',
              en: 'Khuan Lang',
            },
            zipcode: '90110',
          },
          901103: {
            name: {
              th: 'คูเต่า',
              en: 'Khu Tao',
            },
            zipcode: '90110',
          },
          901104: {
            name: {
              th: 'คอหงส์',
              en: 'Kho Hong',
            },
            zipcode: '90110',
          },
          901105: {
            name: {
              th: 'คลองแห',
              en: 'Khlong Hae',
            },
            zipcode: '90110',
          },
          901107: {
            name: {
              th: 'คลองอู่ตะเภา',
              en: 'Khlong U Taphao',
            },
            zipcode: '90110',
          },
          901108: {
            name: {
              th: 'ฉลุง',
              en: 'Chalung',
            },
            zipcode: '90110',
          },
          901111: {
            name: {
              th: 'ทุ่งใหญ่',
              en: 'Thung Yai',
            },
            zipcode: '90110',
          },
          901112: {
            name: {
              th: 'ทุ่งตำเสา',
              en: 'Thung Tam Sao',
            },
            zipcode: '90110',
          },
          901113: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '90110',
          },
          901114: {
            name: {
              th: 'น้ำน้อย',
              en: 'Nam Noi',
            },
            zipcode: '90110',
          },
          901116: {
            name: {
              th: 'บ้านพรุ',
              en: 'Ban Phru',
            },
            zipcode: '90250',
          },
          901118: {
            name: {
              th: 'พะตง',
              en: 'Phatong',
            },
            zipcode: '90230',
          },
        },
      },
      9012: {
        name: {
          th: 'นาหม่อม',
          en: 'Na Mom',
        },
        tambons: {
          901201: {
            name: {
              th: 'นาหม่อม',
              en: 'Na Mom',
            },
            zipcode: '90310',
          },
          901202: {
            name: {
              th: 'พิจิตร',
              en: 'Phichit',
            },
            zipcode: '90310',
          },
          901203: {
            name: {
              th: 'ทุ่งขมิ้น',
              en: 'Thung Khamin',
            },
            zipcode: '90310',
          },
          901204: {
            name: {
              th: 'คลองหรัง',
              en: 'Khlong Rang',
            },
            zipcode: '90310',
          },
        },
      },
      9013: {
        name: {
          th: 'ควนเนียง',
          en: 'Khuan Niang',
        },
        tambons: {
          901301: {
            name: {
              th: 'รัตภูมิ',
              en: 'Rattaphum',
            },
            zipcode: '90220',
          },
          901302: {
            name: {
              th: 'ควนโส',
              en: 'Khuan So',
            },
            zipcode: '90220',
          },
          901303: {
            name: {
              th: 'ห้วยลึก',
              en: 'Huai Luek',
            },
            zipcode: '90220',
          },
          901304: {
            name: {
              th: 'บางเหรียง',
              en: 'Bang Riang',
            },
            zipcode: '90220',
          },
        },
      },
      9014: {
        name: {
          th: 'บางกล่ำ',
          en: 'Bang Khum',
        },
        tambons: {
          901401: {
            name: {
              th: 'บางกล่ำ',
              en: 'Bang Klam',
            },
            zipcode: '90110',
          },
          901402: {
            name: {
              th: 'ท่าช้าง',
              en: 'Tha Chang',
            },
            zipcode: '90110',
          },
          901403: {
            name: {
              th: 'แม่ทอม',
              en: 'Mae Thom',
            },
            zipcode: '90110',
          },
          901404: {
            name: {
              th: 'บ้านหาร',
              en: 'Ban Han',
            },
            zipcode: '90110',
          },
        },
      },
      9015: {
        name: {
          th: 'สิงหนคร',
          en: 'SinghaNakhon',
        },
        tambons: {
          901501: {
            name: {
              th: 'ชิงโค',
              en: 'Ching Kho',
            },
            zipcode: '90280',
          },
          901502: {
            name: {
              th: 'สทิงหม้อ',
              en: 'Sathing Mo',
            },
            zipcode: '90280',
          },
          901503: {
            name: {
              th: 'ทำนบ',
              en: 'Thamnop',
            },
            zipcode: '90280',
          },
          901504: {
            name: {
              th: 'รำแดง',
              en: 'Ram Daeng',
            },
            zipcode: '90330',
          },
          901505: {
            name: {
              th: 'วัดขนุน',
              en: 'Wat Khanun',
            },
            zipcode: '90330',
          },
          901506: {
            name: {
              th: 'ชะแล้',
              en: 'Chalae',
            },
            zipcode: '90330',
          },
          901507: {
            name: {
              th: 'ปากรอ',
              en: 'Pak Ro',
            },
            zipcode: '90330',
          },
          901508: {
            name: {
              th: 'ป่าขาด',
              en: 'Pa Khat',
            },
            zipcode: '90330',
          },
          901509: {
            name: {
              th: 'หัวเขา',
              en: 'Hua Khao',
            },
            zipcode: '90280',
          },
          901510: {
            name: {
              th: 'บางเขียด',
              en: 'Bang Khiat',
            },
            zipcode: '90330',
          },
          901511: {
            name: {
              th: 'ม่วงงาม',
              en: 'Muang Ngam',
            },
            zipcode: '90330',
          },
        },
      },
      9016: {
        name: {
          th: 'คลองหอยโข่ง',
          en: 'Khlong Hoi Khong',
        },
        tambons: {
          901601: {
            name: {
              th: 'คลองหอยโข่ง',
              en: 'Khlong Hoi Khong',
            },
            zipcode: '90230',
          },
          901602: {
            name: {
              th: 'ทุ่งลาน',
              en: 'Thung Lan',
            },
            zipcode: '90230',
          },
          901603: {
            name: {
              th: 'โคกม่วง',
              en: 'Khok Muang',
            },
            zipcode: '90230',
          },
          901604: {
            name: {
              th: 'คลองหลา',
              en: 'Khlong La',
            },
            zipcode: '90115',
          },
        },
      },
    },
  },
  91: {
    name: {
      th: 'สตูล',
      en: 'Satun',
    },
    amphoes: {
      9101: {
        name: {
          th: 'เมืองสตูล',
          en: 'Muang',
        },
        tambons: {
          910101: {
            name: {
              th: 'พิมาน',
              en: 'Phiman',
            },
            zipcode: '91000',
          },
          910102: {
            name: {
              th: 'คลองขุด',
              en: 'Khlong Khut',
            },
            zipcode: '91000',
          },
          910103: {
            name: {
              th: 'ควนขัน',
              en: 'Khuan Khan',
            },
            zipcode: '91000',
          },
          910104: {
            name: {
              th: 'บ้านควน',
              en: 'Ban Khuan',
            },
            zipcode: '91140',
          },
          910105: {
            name: {
              th: 'ฉลุง',
              en: 'Chalung',
            },
            zipcode: '91140',
          },
          910106: {
            name: {
              th: 'เกาะสาหร่าย',
              en: 'Ko Sarai',
            },
            zipcode: '91000',
          },
          910107: {
            name: {
              th: 'ตันหยงโป',
              en: 'Tanyong Po',
            },
            zipcode: '91000',
          },
          910108: {
            name: {
              th: 'เจ๊ะบิลัง',
              en: 'Che Bilang',
            },
            zipcode: '91000',
          },
          910109: {
            name: {
              th: 'ตำมะลัง',
              en: 'Tam Malang',
            },
            zipcode: '91000',
          },
          910110: {
            name: {
              th: 'ปูยู',
              en: 'Puyu',
            },
            zipcode: '91000',
          },
          910111: {
            name: {
              th: 'ควนโพธิ์',
              en: 'Khuan Pho',
            },
            zipcode: '91140',
          },
          910112: {
            name: {
              th: 'เกตรี',
              en: 'Ketri',
            },
            zipcode: '91140',
          },
        },
      },
      9102: {
        name: {
          th: 'ควนโดน',
          en: 'Khuan Don',
        },
        tambons: {
          910201: {
            name: {
              th: 'ควนโดน',
              en: 'Khuan Don',
            },
            zipcode: '91160',
          },
          910202: {
            name: {
              th: 'ควนสตอ',
              en: 'Khuan Sato',
            },
            zipcode: '91160',
          },
          910203: {
            name: {
              th: 'ย่านซื่อ',
              en: 'Yan Sue',
            },
            zipcode: '91160',
          },
          910204: {
            name: {
              th: 'วังประจัน',
              en: 'Wang Prachan',
            },
            zipcode: '91160',
          },
        },
      },
      9103: {
        name: {
          th: 'ควนกาหลง',
          en: 'Khuan Ka Long',
        },
        tambons: {
          910301: {
            name: {
              th: 'ทุ่งนุ้ย',
              en: 'Thung Nui',
            },
            zipcode: '91130',
          },
          910302: {
            name: {
              th: 'ควนกาหลง',
              en: 'Khuan Kalong',
            },
            zipcode: '91130',
          },
          910303: {
            name: {
              th: 'อุใดเจริญ',
              en: 'Udai Charoen',
            },
            zipcode: '91130',
          },
        },
      },
      9104: {
        name: {
          th: 'ท่าแพ',
          en: 'Tha Phae',
        },
        tambons: {
          910401: {
            name: {
              th: 'ท่าแพ',
              en: 'Tha Phae',
            },
            zipcode: '91150',
          },
          910402: {
            name: {
              th: 'แป-ระ',
              en: 'Pae-ra',
            },
            zipcode: '91150',
          },
          910403: {
            name: {
              th: 'สาคร',
              en: 'Sakhon',
            },
            zipcode: '91150',
          },
          910404: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '91150',
          },
        },
      },
      9105: {
        name: {
          th: 'ละงู',
          en: 'Langu',
        },
        tambons: {
          910501: {
            name: {
              th: 'กำแพง',
              en: 'Kamphaeng',
            },
            zipcode: '91110',
          },
          910502: {
            name: {
              th: 'ละงู',
              en: 'La-ngu',
            },
            zipcode: '91110',
          },
          910503: {
            name: {
              th: 'เขาขาว',
              en: 'Khao Khao',
            },
            zipcode: '91110',
          },
          910504: {
            name: {
              th: 'ปากน้ำ',
              en: 'Pak Nam',
            },
            zipcode: '91110',
          },
          910505: {
            name: {
              th: 'น้ำผุด',
              en: 'Nam Phut',
            },
            zipcode: '91110',
          },
          910506: {
            name: {
              th: 'แหลมสน',
              en: 'Laem Son',
            },
            zipcode: '91110',
          },
        },
      },
      9106: {
        name: {
          th: 'ทุ่งหว้า',
          en: 'Thung Wa',
        },
        tambons: {
          910601: {
            name: {
              th: 'ทุ่งหว้า',
              en: 'Thung Wa',
            },
            zipcode: '91120',
          },
          910602: {
            name: {
              th: 'นาทอน',
              en: 'Na Thon',
            },
            zipcode: '91120',
          },
          910603: {
            name: {
              th: 'ขอนคลาน',
              en: 'Khon Klan',
            },
            zipcode: '91120',
          },
          910604: {
            name: {
              th: 'ทุ่งบุหลัง',
              en: 'Thung Bulang',
            },
            zipcode: '91120',
          },
          910605: {
            name: {
              th: 'ป่าแก่บ่อหิน',
              en: 'Pakae Bohin',
            },
            zipcode: '91120',
          },
        },
      },
      9107: {
        name: {
          th: 'มะนัง',
          en: 'King Amphoe Manang',
        },
        tambons: {
          910701: {
            name: {
              th: 'ปาล์มพัฒนา',
              en: 'Palm Phatthana',
            },
            zipcode: '91130',
          },
          910702: {
            name: {
              th: 'นิคมพัฒนา',
              en: 'Nikhom Phatthana',
            },
            zipcode: '91130',
          },
        },
      },
    },
  },
  92: {
    name: {
      th: 'ตรัง',
      en: 'Trang',
    },
    amphoes: {
      9201: {
        name: {
          th: 'เมืองตรัง',
          en: 'Muang',
        },
        tambons: {
          920101: {
            name: {
              th: 'ทับเที่ยง',
              en: 'Thap Thiang',
            },
            zipcode: '92000',
          },
          920104: {
            name: {
              th: 'นาพละ',
              en: 'Na Phala',
            },
            zipcode: '92000',
          },
          920105: {
            name: {
              th: 'บ้านควน',
              en: 'Ban Khuan',
            },
            zipcode: '92000',
          },
          920106: {
            name: {
              th: 'นาบินหลา',
              en: 'Na Bin La',
            },
            zipcode: '92000',
          },
          920107: {
            name: {
              th: 'ควนปริง',
              en: 'Khuan Pring',
            },
            zipcode: '92000',
          },
          920108: {
            name: {
              th: 'นาโยงใต้',
              en: 'Na Yong Tai',
            },
            zipcode: '92170',
          },
          920109: {
            name: {
              th: 'บางรัก',
              en: 'Bang Rak',
            },
            zipcode: '92000',
          },
          920110: {
            name: {
              th: 'โคกหล่อ',
              en: 'Khok Lo',
            },
            zipcode: '92000',
          },
          920113: {
            name: {
              th: 'นาโต๊ะหมิง',
              en: 'Na To Ming',
            },
            zipcode: '92000',
          },
          920114: {
            name: {
              th: 'หนองตรุด',
              en: 'Nong Trut',
            },
            zipcode: '92000',
          },
          920115: {
            name: {
              th: 'น้ำผุด',
              en: 'Nam Phut',
            },
            zipcode: '92000',
          },
          920117: {
            name: {
              th: 'นาตาล่วง',
              en: 'Na Ta Luang',
            },
            zipcode: '92000',
          },
          920118: {
            name: {
              th: 'บ้านโพธิ์',
              en: 'Ban Pho',
            },
            zipcode: '92000',
          },
          920119: {
            name: {
              th: 'นาท่ามเหนือ',
              en: 'Na Tham Nuea',
            },
            zipcode: '92190',
          },
          920120: {
            name: {
              th: 'นาท่ามใต้',
              en: 'Na Tham Tai',
            },
            zipcode: '92190',
          },
        },
      },
      9202: {
        name: {
          th: 'กันตัง',
          en: 'Kantang',
        },
        tambons: {
          920201: {
            name: {
              th: 'กันตัง',
              en: 'Kantang',
            },
            zipcode: '92110',
          },
          920202: {
            name: {
              th: 'ควนธานี',
              en: 'Khuan Thani',
            },
            zipcode: '92110',
          },
          920203: {
            name: {
              th: 'บางหมาก',
              en: 'Bang Mak',
            },
            zipcode: '92110',
          },
          920204: {
            name: {
              th: 'บางเป้า',
              en: 'Bang Pao',
            },
            zipcode: '92110',
          },
          920205: {
            name: {
              th: 'วังวน',
              en: 'Wang Won',
            },
            zipcode: '92110',
          },
          920206: {
            name: {
              th: 'กันตังใต้',
              en: 'Kantang Tai',
            },
            zipcode: '92110',
          },
          920207: {
            name: {
              th: 'โคกยาง',
              en: 'Khok Yang',
            },
            zipcode: '92110',
          },
          920208: {
            name: {
              th: 'คลองลุ',
              en: 'Khlong Lu',
            },
            zipcode: '92110',
          },
          920209: {
            name: {
              th: 'ย่านซื่อ',
              en: 'Yan Sue',
            },
            zipcode: '92110',
          },
          920210: {
            name: {
              th: 'บ่อน้ำร้อน',
              en: 'Bo Nam Ron',
            },
            zipcode: '92110',
          },
          920211: {
            name: {
              th: 'บางสัก',
              en: 'Bang Sak',
            },
            zipcode: '92110',
          },
          920212: {
            name: {
              th: 'นาเกลือ',
              en: 'Na Kluea',
            },
            zipcode: '92110',
          },
          920213: {
            name: {
              th: 'เกาะลิบง',
              en: 'Ko Libong',
            },
            zipcode: '92110',
          },
          920214: {
            name: {
              th: 'คลองชีล้อม',
              en: 'Khlong Chi Lom',
            },
            zipcode: '92110',
          },
        },
      },
      9203: {
        name: {
          th: 'ย่านตาขาว',
          en: 'Yan Takhoa',
        },
        tambons: {
          920301: {
            name: {
              th: 'ย่านตาขาว',
              en: 'Yan Ta Khao',
            },
            zipcode: '92140',
          },
          920302: {
            name: {
              th: 'หนองบ่อ',
              en: 'Nong Bo',
            },
            zipcode: '92140',
          },
          920303: {
            name: {
              th: 'นาชุมเห็ด',
              en: 'Na Chum Het',
            },
            zipcode: '92140',
          },
          920304: {
            name: {
              th: 'ในควน',
              en: 'Nai Khuan',
            },
            zipcode: '92140',
          },
          920305: {
            name: {
              th: 'โพรงจระเข้',
              en: 'Phrong Chorakhe',
            },
            zipcode: '92140',
          },
          920306: {
            name: {
              th: 'ทุ่งกระบือ',
              en: 'Thung Krabue',
            },
            zipcode: '92140',
          },
          920307: {
            name: {
              th: 'ทุ่งค่าย',
              en: 'Thung Khai',
            },
            zipcode: '92140',
          },
          920308: {
            name: {
              th: 'เกาะเปียะ',
              en: 'Ko Pia',
            },
            zipcode: '92140',
          },
        },
      },
      9204: {
        name: {
          th: 'ปะเหลียน',
          en: 'Palian',
        },
        tambons: {
          920401: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '92120',
          },
          920402: {
            name: {
              th: 'ทุ่งยาว',
              en: 'Thung Yao',
            },
            zipcode: '92180',
          },
          920403: {
            name: {
              th: 'ปะเหลียน',
              en: 'Palian',
            },
            zipcode: '92180',
          },
          920404: {
            name: {
              th: 'บางด้วน',
              en: 'Bang Duan',
            },
            zipcode: '92140',
          },
          920407: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '92140',
          },
          920409: {
            name: {
              th: 'สุโสะ',
              en: 'Suso',
            },
            zipcode: '92120',
          },
          920410: {
            name: {
              th: 'ลิพัง',
              en: 'Li Phang',
            },
            zipcode: '92180',
          },
          920411: {
            name: {
              th: 'เกาะสุกร',
              en: 'Ko Sukon',
            },
            zipcode: '92120',
          },
          920412: {
            name: {
              th: 'ท่าพญา',
              en: 'Tha Phaya',
            },
            zipcode: '92140',
          },
          920413: {
            name: {
              th: 'แหลมสอม',
              en: 'Laem Som',
            },
            zipcode: '92180',
          },
        },
      },
      9205: {
        name: {
          th: 'สิเกา',
          en: 'Sikao',
        },
        tambons: {
          920501: {
            name: {
              th: 'บ่อหิน',
              en: 'Bo Hin',
            },
            zipcode: '92150',
          },
          920502: {
            name: {
              th: 'เขาไม้แก้ว',
              en: 'Khao Mai Kaeo',
            },
            zipcode: '92150',
          },
          920503: {
            name: {
              th: 'กะลาเส',
              en: 'Kalase',
            },
            zipcode: '92150',
          },
          920504: {
            name: {
              th: 'ไม้ฝาด',
              en: 'Mai Fat',
            },
            zipcode: '92150',
          },
          920505: {
            name: {
              th: 'นาเมืองเพชร',
              en: 'Na Mueang Phet',
            },
            zipcode: '92000',
          },
        },
      },
      9206: {
        name: {
          th: 'ห้วยยอด',
          en: 'Huai Yot',
        },
        tambons: {
          920601: {
            name: {
              th: 'ห้วยยอด',
              en: 'Huai Yot',
            },
            zipcode: '92130',
          },
          920602: {
            name: {
              th: 'หนองช้างแล่น',
              en: 'Nong Chang Laen',
            },
            zipcode: '92130',
          },
          920605: {
            name: {
              th: 'บางดี',
              en: 'Bang Di',
            },
            zipcode: '92210',
          },
          920606: {
            name: {
              th: 'บางกุ้ง',
              en: 'Bang Kung',
            },
            zipcode: '92210',
          },
          920607: {
            name: {
              th: 'เขากอบ',
              en: 'Khao Kop',
            },
            zipcode: '92130',
          },
          920608: {
            name: {
              th: 'เขาขาว',
              en: 'Khao Khao',
            },
            zipcode: '92130',
          },
          920609: {
            name: {
              th: 'เขาปูน',
              en: 'Khao Pun',
            },
            zipcode: '92130',
          },
          920610: {
            name: {
              th: 'ปากแจ่ม',
              en: 'Pak Chaem',
            },
            zipcode: '92190',
          },
          920611: {
            name: {
              th: 'ปากคม',
              en: 'Pak Khom',
            },
            zipcode: '92130',
          },
          920614: {
            name: {
              th: 'ท่างิ้ว',
              en: 'Tha Ngio',
            },
            zipcode: '92130',
          },
          920615: {
            name: {
              th: 'ลำภูรา',
              en: 'Lamphu Ra',
            },
            zipcode: '92190',
          },
          920616: {
            name: {
              th: 'นาวง',
              en: 'Na Wong',
            },
            zipcode: '92210',
          },
          920617: {
            name: {
              th: 'ห้วยนาง',
              en: 'Huai Nang',
            },
            zipcode: '92130',
          },
          920619: {
            name: {
              th: 'ในเตา',
              en: 'Nai Tao',
            },
            zipcode: '92130',
          },
          920620: {
            name: {
              th: 'ทุ่งต่อ',
              en: 'Thung To',
            },
            zipcode: '92130',
          },
          920621: {
            name: {
              th: 'วังคีรี',
              en: 'Wang Khiri',
            },
            zipcode: '92210',
          },
        },
      },
      9207: {
        name: {
          th: 'วังวิเศษ',
          en: 'Wang Wiset',
        },
        tambons: {
          920701: {
            name: {
              th: 'เขาวิเศษ',
              en: 'Khao Wiset',
            },
            zipcode: '92220',
          },
          920702: {
            name: {
              th: 'วังมะปราง',
              en: 'Wang Maprang',
            },
            zipcode: '92220',
          },
          920703: {
            name: {
              th: 'อ่าวตง',
              en: 'Ao Tong',
            },
            zipcode: '92220',
          },
          920704: {
            name: {
              th: 'ท่าสะบ้า',
              en: 'Tha Saba',
            },
            zipcode: '92000',
          },
          920705: {
            name: {
              th: 'วังมะปรางเหนือ',
              en: 'Wang Maprang Nuea',
            },
            zipcode: '92220',
          },
        },
      },
      9208: {
        name: {
          th: 'นาโยง',
          en: 'Na Yong',
        },
        tambons: {
          920801: {
            name: {
              th: 'นาโยงเหนือ',
              en: 'Na Yong Nuea',
            },
            zipcode: '92170',
          },
          920802: {
            name: {
              th: 'ช่อง',
              en: 'Chong',
            },
            zipcode: '92170',
          },
          920803: {
            name: {
              th: 'ละมอ',
              en: 'Lamo',
            },
            zipcode: '92170',
          },
          920804: {
            name: {
              th: 'โคกสะบ้า',
              en: 'Khok Saba',
            },
            zipcode: '92170',
          },
          920805: {
            name: {
              th: 'นาหมื่นศรี',
              en: 'Na Muen Si',
            },
            zipcode: '92170',
          },
          920806: {
            name: {
              th: 'นาข้าวเสีย',
              en: 'Na Khao Sia',
            },
            zipcode: '92170',
          },
        },
      },
      9209: {
        name: {
          th: 'รัษฎา',
          en: 'Rasda',
        },
        tambons: {
          920901: {
            name: {
              th: 'ควนเมา',
              en: 'Khuan Mao',
            },
            zipcode: '92160',
          },
          920902: {
            name: {
              th: 'คลองปาง',
              en: 'Khlong Pang',
            },
            zipcode: '92160',
          },
          920903: {
            name: {
              th: 'หนองบัว',
              en: 'Nong Bua',
            },
            zipcode: '92160',
          },
          920904: {
            name: {
              th: 'หนองปรือ',
              en: 'Nong Prue',
            },
            zipcode: '92130',
          },
          920905: {
            name: {
              th: 'เขาไพร',
              en: 'Khao Phrai',
            },
            zipcode: '92160',
          },
        },
      },
      9210: {
        name: {
          th: 'หาดสำราญ',
          en: 'King Amphoe Had Someran',
        },
        tambons: {
          921001: {
            name: {
              th: 'หาดสำราญ',
              en: 'Hat Samran',
            },
            zipcode: '92120',
          },
          921002: {
            name: {
              th: 'บ้าหวี',
              en: 'Ba Wi',
            },
            zipcode: '92120',
          },
          921003: {
            name: {
              th: 'ตะเสะ',
              en: 'Tase',
            },
            zipcode: '92120',
          },
        },
      },
    },
  },
  93: {
    name: {
      th: 'พัทลุง',
      en: 'Phatthalung',
    },
    amphoes: {
      9301: {
        name: {
          th: 'เมืองพัทลุง',
          en: 'Muang',
        },
        tambons: {
          930101: {
            name: {
              th: 'คูหาสวรรค์',
              en: 'Khuha Sawan',
            },
            zipcode: '93000',
          },
          930103: {
            name: {
              th: 'เขาเจียก',
              en: 'Khao Chiak',
            },
            zipcode: '93000',
          },
          930104: {
            name: {
              th: 'ท่ามิหรำ',
              en: 'Tha Miram',
            },
            zipcode: '93000',
          },
          930105: {
            name: {
              th: 'โคกชะงาย',
              en: 'Khok Cha-ngai',
            },
            zipcode: '93000',
          },
          930106: {
            name: {
              th: 'นาท่อม',
              en: 'Na Thom',
            },
            zipcode: '93000',
          },
          930107: {
            name: {
              th: 'ปรางหมู่',
              en: 'Prang Mu',
            },
            zipcode: '93000',
          },
          930108: {
            name: {
              th: 'ท่าแค',
              en: 'Tha Khae',
            },
            zipcode: '93000',
          },
          930109: {
            name: {
              th: 'ลำปำ',
              en: 'Lampam',
            },
            zipcode: '93000',
          },
          930110: {
            name: {
              th: 'ตำนาน',
              en: 'Tamnan',
            },
            zipcode: '93000',
          },
          930111: {
            name: {
              th: 'ควนมะพร้าว',
              en: 'Khuan Maphrao',
            },
            zipcode: '93000',
          },
          930112: {
            name: {
              th: 'ร่มเมือง',
              en: 'Rom Mueang',
            },
            zipcode: '93000',
          },
          930113: {
            name: {
              th: 'ชัยบุรี',
              en: 'Chai Buri',
            },
            zipcode: '93000',
          },
          930114: {
            name: {
              th: 'นาโหนด',
              en: 'Na Not',
            },
            zipcode: '93000',
          },
          930115: {
            name: {
              th: 'พญาขัน',
              en: 'Phaya Khan',
            },
            zipcode: '93000',
          },
        },
      },
      9302: {
        name: {
          th: 'กงหรา',
          en: 'Kong Ra',
        },
        tambons: {
          930201: {
            name: {
              th: 'กงหรา',
              en: 'Kong Ra',
            },
            zipcode: '93180',
          },
          930202: {
            name: {
              th: 'ชะรัด',
              en: 'Charat',
            },
            zipcode: '93000',
          },
          930203: {
            name: {
              th: 'คลองเฉลิม',
              en: 'Khlong Chaloem',
            },
            zipcode: '93180',
          },
          930204: {
            name: {
              th: 'คลองทรายขาว',
              en: 'Khlong Sai Khao',
            },
            zipcode: '93180',
          },
          930205: {
            name: {
              th: 'สมหวัง',
              en: 'Som Wang',
            },
            zipcode: '93000',
          },
        },
      },
      9303: {
        name: {
          th: 'เขาชัยสน',
          en: 'Khao Chaison',
        },
        tambons: {
          930301: {
            name: {
              th: 'เขาชัยสน',
              en: 'Khao Chaison',
            },
            zipcode: '93130',
          },
          930302: {
            name: {
              th: 'ควนขนุน',
              en: 'Khuan Khanun',
            },
            zipcode: '93130',
          },
          930305: {
            name: {
              th: 'จองถนน',
              en: 'Chong Thanon',
            },
            zipcode: '93130',
          },
          930306: {
            name: {
              th: 'หานโพธิ์',
              en: 'Han Pho',
            },
            zipcode: '93130',
          },
          930307: {
            name: {
              th: 'โคกม่วง',
              en: 'Khok Muang',
            },
            zipcode: '93130',
          },
        },
      },
      9304: {
        name: {
          th: 'ตะโหมด',
          en: 'Tamot',
        },
        tambons: {
          930401: {
            name: {
              th: 'แม่ขรี',
              en: 'Mae Khari',
            },
            zipcode: '93160',
          },
          930402: {
            name: {
              th: 'ตะโหมด',
              en: 'Tamot',
            },
            zipcode: '93160',
          },
          930403: {
            name: {
              th: 'คลองใหญ่',
              en: 'Khlong Yai',
            },
            zipcode: '93160',
          },
        },
      },
      9305: {
        name: {
          th: 'ควนขนุน',
          en: 'Khuan Khanun',
        },
        tambons: {
          930501: {
            name: {
              th: 'ควนขนุน',
              en: 'Khuan Khanun',
            },
            zipcode: '93110',
          },
          930502: {
            name: {
              th: 'ทะเลน้อย',
              en: 'Thale Noi',
            },
            zipcode: '93150',
          },
          930504: {
            name: {
              th: 'นาขยาด',
              en: 'Na Khayat',
            },
            zipcode: '93110',
          },
          930505: {
            name: {
              th: 'พนมวังก์',
              en: 'Phanom Wang',
            },
            zipcode: '93110',
          },
          930506: {
            name: {
              th: 'แหลมโตนด',
              en: 'Laem Tanot',
            },
            zipcode: '93110',
          },
          930508: {
            name: {
              th: 'ปันแต',
              en: 'Pan Tae',
            },
            zipcode: '93110',
          },
          930509: {
            name: {
              th: 'โตนดด้วน',
              en: 'Tanot Duan',
            },
            zipcode: '93110',
          },
          930510: {
            name: {
              th: 'ดอนทราย',
              en: 'Don Sai',
            },
            zipcode: '93110',
          },
          930511: {
            name: {
              th: 'มะกอกเหนือ',
              en: 'Makok Nuea',
            },
            zipcode: '93150',
          },
          930512: {
            name: {
              th: 'พนางตุง',
              en: 'Phanang Tung',
            },
            zipcode: '93150',
          },
          930513: {
            name: {
              th: 'ชะมวง',
              en: 'Chamuang',
            },
            zipcode: '93110',
          },
          930516: {
            name: {
              th: 'แพรกหา',
              en: 'Phraek Ha',
            },
            zipcode: '93110',
          },
        },
      },
      9306: {
        name: {
          th: 'ปากพะยูน',
          en: 'Pak Phayun',
        },
        tambons: {
          930601: {
            name: {
              th: 'ปากพะยูน',
              en: 'Pak Phayun',
            },
            zipcode: '93120',
          },
          930602: {
            name: {
              th: 'ดอนประดู่',
              en: 'Don Pradu',
            },
            zipcode: '93120',
          },
          930603: {
            name: {
              th: 'เกาะนางคำ',
              en: 'Ko Nang Kham',
            },
            zipcode: '93120',
          },
          930604: {
            name: {
              th: 'เกาะหมาก',
              en: 'Ko Mak',
            },
            zipcode: '93120',
          },
          930605: {
            name: {
              th: 'ฝาละมี',
              en: 'Falami',
            },
            zipcode: '93120',
          },
          930606: {
            name: {
              th: 'หารเทา',
              en: 'Han Thao',
            },
            zipcode: '93120',
          },
          930607: {
            name: {
              th: 'ดอนทราย',
              en: 'Don Sai',
            },
            zipcode: '93120',
          },
        },
      },
      9307: {
        name: {
          th: 'ศรีบรรพต',
          en: 'Si Banphot',
        },
        tambons: {
          930701: {
            name: {
              th: 'เขาย่า',
              en: 'Khao Ya',
            },
            zipcode: '93190',
          },
          930702: {
            name: {
              th: 'เขาปู่',
              en: 'Khao Pu',
            },
            zipcode: '93190',
          },
          930703: {
            name: {
              th: 'ตะแพน',
              en: 'Taphaen',
            },
            zipcode: '93190',
          },
        },
      },
      9308: {
        name: {
          th: 'ป่าบอน',
          en: 'Pa Bon',
        },
        tambons: {
          930801: {
            name: {
              th: 'ป่าบอน',
              en: 'Pa Bon',
            },
            zipcode: '93170',
          },
          930802: {
            name: {
              th: 'โคกทราย',
              en: 'Khok Sai',
            },
            zipcode: '93170',
          },
          930803: {
            name: {
              th: 'หนองธง',
              en: 'Nong Thong',
            },
            zipcode: '93170',
          },
          930804: {
            name: {
              th: 'ทุ่งนารี',
              en: 'Thung Nari',
            },
            zipcode: '93170',
          },
          930806: {
            name: {
              th: 'วังใหม่',
              en: 'Wang Mai',
            },
            zipcode: '93170',
          },
        },
      },
      9309: {
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        tambons: {
          930901: {
            name: {
              th: 'ท่ามะเดื่อ',
              en: 'Tha Maduea',
            },
            zipcode: '93140',
          },
          930902: {
            name: {
              th: 'นาปะขอ',
              en: 'Na Pakho',
            },
            zipcode: '93140',
          },
          930903: {
            name: {
              th: 'โคกสัก',
              en: 'Khok Sak',
            },
            zipcode: '93140',
          },
        },
      },
      9310: {
        name: {
          th: 'ป่าพะยอม',
          en: 'Pa Phayom',
        },
        tambons: {
          931001: {
            name: {
              th: 'ป่าพะยอม',
              en: 'Pa Phayom',
            },
            zipcode: '93110',
          },
          931002: {
            name: {
              th: 'ลานข่อย',
              en: 'Lan Khoi',
            },
            zipcode: '93110',
          },
          931003: {
            name: {
              th: 'เกาะเต่า',
              en: 'Ko Tao',
            },
            zipcode: '93110',
          },
          931004: {
            name: {
              th: 'บ้านพร้าว',
              en: 'Ban Phrao',
            },
            zipcode: '93110',
          },
        },
      },
      9311: {
        name: {
          th: 'ศรีนครินทร์',
          en: 'Srinagarindra',
        },
        tambons: {
          931101: {
            name: {
              th: 'ชุมพล',
              en: 'Chumphon',
            },
            zipcode: '93000',
          },
          931102: {
            name: {
              th: 'บ้านนา',
              en: 'Ban Na',
            },
            zipcode: '93000',
          },
          931103: {
            name: {
              th: 'อ่างทอง',
              en: 'Ang Thong',
            },
            zipcode: '93000',
          },
          931104: {
            name: {
              th: 'ลำสินธุ์',
              en: 'Lam Sin',
            },
            zipcode: '93000',
          },
        },
      },
    },
  },
  94: {
    name: {
      th: 'ปัตตานี',
      en: 'Pattani',
    },
    amphoes: {
      9401: {
        name: {
          th: 'เมืองปัตตานี',
          en: 'Muang',
        },
        tambons: {
          940101: {
            name: {
              th: 'สะบารัง',
              en: 'Sabarang',
            },
            zipcode: '94000',
          },
          940102: {
            name: {
              th: 'อาเนาะรู',
              en: 'Anoru',
            },
            zipcode: '94000',
          },
          940103: {
            name: {
              th: 'จะบังติกอ',
              en: 'Chabang Tiko',
            },
            zipcode: '94000',
          },
          940104: {
            name: {
              th: 'บานา',
              en: 'Bana',
            },
            zipcode: '94000',
          },
          940105: {
            name: {
              th: 'ตันหยงลุโละ',
              en: 'Tanyong Lulo',
            },
            zipcode: '94000',
          },
          940106: {
            name: {
              th: 'คลองมานิง',
              en: 'Khlong Maning',
            },
            zipcode: '94000',
          },
          940107: {
            name: {
              th: 'กะมิยอ',
              en: 'Kamiyo',
            },
            zipcode: '94000',
          },
          940108: {
            name: {
              th: 'บาราโหม',
              en: 'Barahom',
            },
            zipcode: '94000',
          },
          940109: {
            name: {
              th: 'ปะกาฮะรัง',
              en: 'Paka Harang',
            },
            zipcode: '94000',
          },
          940110: {
            name: {
              th: 'รูสะมิแล',
              en: 'Rusa Milae',
            },
            zipcode: '94000',
          },
          940111: {
            name: {
              th: 'ตะลุโบะ',
              en: 'Talubo',
            },
            zipcode: '94000',
          },
          940112: {
            name: {
              th: 'บาราเฮาะ',
              en: 'Baraho',
            },
            zipcode: '94000',
          },
          940113: {
            name: {
              th: 'ปุยุด',
              en: 'Puyut',
            },
            zipcode: '94000',
          },
        },
      },
      9402: {
        name: {
          th: 'โคกโพธิ์',
          en: 'Khok Pho',
        },
        tambons: {
          940201: {
            name: {
              th: 'โคกโพธิ์',
              en: 'Khok Pho',
            },
            zipcode: '94120',
          },
          940202: {
            name: {
              th: 'มะกรูด',
              en: 'Makrut',
            },
            zipcode: '94120',
          },
          940203: {
            name: {
              th: 'บางโกระ',
              en: 'Bang Kro',
            },
            zipcode: '94120',
          },
          940204: {
            name: {
              th: 'ป่าบอน',
              en: 'Pa Bon',
            },
            zipcode: '94120',
          },
          940205: {
            name: {
              th: 'ทรายขาว',
              en: 'Sai Khao',
            },
            zipcode: '94120',
          },
          940206: {
            name: {
              th: 'นาประดู่',
              en: 'Na Pradu',
            },
            zipcode: '94180',
          },
          940207: {
            name: {
              th: 'ปากล่อ',
              en: 'Pak Lo',
            },
            zipcode: '94180',
          },
          940208: {
            name: {
              th: 'ทุ่งพลา',
              en: 'Thung Phala',
            },
            zipcode: '94180',
          },
          940211: {
            name: {
              th: 'ท่าเรือ',
              en: 'Tha Ruea',
            },
            zipcode: '94120',
          },
          940213: {
            name: {
              th: 'นาเกตุ',
              en: 'Na Ket',
            },
            zipcode: '94120',
          },
          940214: {
            name: {
              th: 'ควนโนรี',
              en: 'Khuan Nori',
            },
            zipcode: '94180',
          },
          940215: {
            name: {
              th: 'ช้างให้ตก',
              en: 'Chang Hai Tok',
            },
            zipcode: '94120',
          },
        },
      },
      9403: {
        name: {
          th: 'หนองจิก',
          en: 'Nong Chilk',
        },
        tambons: {
          940301: {
            name: {
              th: 'เกาะเปาะ',
              en: 'Ko Po',
            },
            zipcode: '94170',
          },
          940302: {
            name: {
              th: 'คอลอตันหยง',
              en: 'Kholo Tanyong',
            },
            zipcode: '94170',
          },
          940303: {
            name: {
              th: 'ดอนรัก',
              en: 'Don Rak',
            },
            zipcode: '94170',
          },
          940304: {
            name: {
              th: 'ดาโต๊ะ',
              en: 'Dato',
            },
            zipcode: '94170',
          },
          940305: {
            name: {
              th: 'ตุยง',
              en: 'Tuyong',
            },
            zipcode: '94170',
          },
          940306: {
            name: {
              th: 'ท่ากำชำ',
              en: 'Tha Kamcham',
            },
            zipcode: '94170',
          },
          940307: {
            name: {
              th: 'บ่อทอง',
              en: 'Bo Thong',
            },
            zipcode: '94170',
          },
          940308: {
            name: {
              th: 'บางเขา',
              en: 'Bang Khao',
            },
            zipcode: '94170',
          },
          940309: {
            name: {
              th: 'บางตาวา',
              en: 'Bang Tawa',
            },
            zipcode: '94170',
          },
          940310: {
            name: {
              th: 'ปุโละปุโย',
              en: 'Pulo Puyo',
            },
            zipcode: '94170',
          },
          940311: {
            name: {
              th: 'ยาบี',
              en: 'Yabi',
            },
            zipcode: '94170',
          },
          940312: {
            name: {
              th: 'ลิปะสะโง',
              en: 'Lipa Sa-ngo',
            },
            zipcode: '94170',
          },
        },
      },
      9404: {
        name: {
          th: 'ปะนาเระ',
          en: 'Panare',
        },
        tambons: {
          940401: {
            name: {
              th: 'ปะนาเระ',
              en: 'Panare',
            },
            zipcode: '94130',
          },
          940402: {
            name: {
              th: 'ท่าข้าม',
              en: 'Tha Kham',
            },
            zipcode: '94130',
          },
          940403: {
            name: {
              th: 'บ้านนอก',
              en: 'Ban Nok',
            },
            zipcode: '94130',
          },
          940404: {
            name: {
              th: 'ดอน',
              en: 'Don',
            },
            zipcode: '94130',
          },
          940405: {
            name: {
              th: 'ควน',
              en: 'Khuan',
            },
            zipcode: '94190',
          },
          940406: {
            name: {
              th: 'ท่าน้ำ',
              en: 'Tha Nam',
            },
            zipcode: '94130',
          },
          940407: {
            name: {
              th: 'คอกกระบือ',
              en: 'Khok Krabue',
            },
            zipcode: '94130',
          },
          940408: {
            name: {
              th: 'พ่อมิ่ง',
              en: 'Pho Ming',
            },
            zipcode: '94130',
          },
          940409: {
            name: {
              th: 'บ้านกลาง',
              en: 'Ban Klang',
            },
            zipcode: '94130',
          },
          940410: {
            name: {
              th: 'บ้านน้ำบ่อ',
              en: 'Ban Nam Bo',
            },
            zipcode: '94130',
          },
        },
      },
      9405: {
        name: {
          th: 'มายอ',
          en: 'Mayo',
        },
        tambons: {
          940501: {
            name: {
              th: 'มายอ',
              en: 'Mayo',
            },
            zipcode: '94140',
          },
          940502: {
            name: {
              th: 'ถนน',
              en: 'Thanon',
            },
            zipcode: '94140',
          },
          940503: {
            name: {
              th: 'ตรัง',
              en: 'Trang',
            },
            zipcode: '94140',
          },
          940504: {
            name: {
              th: 'กระหวะ',
              en: 'Krawa',
            },
            zipcode: '94140',
          },
          940505: {
            name: {
              th: 'ลุโบะยิไร',
              en: 'Lubo Yirai',
            },
            zipcode: '94140',
          },
          940506: {
            name: {
              th: 'ลางา',
              en: 'La-nga',
            },
            zipcode: '94190',
          },
          940507: {
            name: {
              th: 'กระเสาะ',
              en: 'Kraso',
            },
            zipcode: '94140',
          },
          940508: {
            name: {
              th: 'เกาะจัน',
              en: 'Ko Chan',
            },
            zipcode: '94140',
          },
          940509: {
            name: {
              th: 'ปะโด',
              en: 'Pado',
            },
            zipcode: '94140',
          },
          940510: {
            name: {
              th: 'สาคอบน',
              en: 'Sakho Bon',
            },
            zipcode: '94140',
          },
          940511: {
            name: {
              th: 'สาคอใต้',
              en: 'Sakho Tai',
            },
            zipcode: '94140',
          },
          940512: {
            name: {
              th: 'สะกำ',
              en: 'Sakam',
            },
            zipcode: '94140',
          },
          940513: {
            name: {
              th: 'ปานัน',
              en: 'Panan',
            },
            zipcode: '94140',
          },
        },
      },
      9406: {
        name: {
          th: 'ทุ่งยางแดง',
          en: 'Thung Yang Daeng',
        },
        tambons: {
          940601: {
            name: {
              th: 'ตะโละแมะนา',
              en: 'Talo Maena',
            },
            zipcode: '94140',
          },
          940602: {
            name: {
              th: 'พิเทน',
              en: 'Phithen',
            },
            zipcode: '94140',
          },
          940603: {
            name: {
              th: 'น้ำดำ',
              en: 'Nam Dam',
            },
            zipcode: '94140',
          },
          940604: {
            name: {
              th: 'ปากู',
              en: 'Paku',
            },
            zipcode: '94140',
          },
        },
      },
      9407: {
        name: {
          th: 'สายบุรี',
          en: 'Sai Buri',
        },
        tambons: {
          940701: {
            name: {
              th: 'ตะลุบัน',
              en: 'Taluban',
            },
            zipcode: '94110',
          },
          940702: {
            name: {
              th: 'ตะบิ้ง',
              en: 'Tabing',
            },
            zipcode: '94110',
          },
          940703: {
            name: {
              th: 'ปะเสยะวอ',
              en: 'Pase Yawo',
            },
            zipcode: '94110',
          },
          940704: {
            name: {
              th: 'บางเก่า',
              en: 'Bang Kao',
            },
            zipcode: '94110',
          },
          940705: {
            name: {
              th: 'บือเระ',
              en: 'Bue Re',
            },
            zipcode: '94110',
          },
          940706: {
            name: {
              th: 'เตราะบอน',
              en: 'Tro Bon',
            },
            zipcode: '94110',
          },
          940707: {
            name: {
              th: 'กะดุนง',
              en: 'Kadunong',
            },
            zipcode: '94110',
          },
          940708: {
            name: {
              th: 'ละหาร',
              en: 'Lahan',
            },
            zipcode: '94110',
          },
          940709: {
            name: {
              th: 'มะนังดาลำ',
              en: 'Manang Dalam',
            },
            zipcode: '94110',
          },
          940710: {
            name: {
              th: 'แป้น',
              en: 'Paen',
            },
            zipcode: '94110',
          },
          940711: {
            name: {
              th: 'ทุ่งคล้า',
              en: 'Thung Khla',
            },
            zipcode: '94190',
          },
        },
      },
      9408: {
        name: {
          th: 'ไม้แก่น',
          en: 'Mai Kaen',
        },
        tambons: {
          940801: {
            name: {
              th: 'ไทรทอง',
              en: 'Sai Thong',
            },
            zipcode: '94220',
          },
          940802: {
            name: {
              th: 'ไม้แก่น',
              en: 'Mai Kaen',
            },
            zipcode: '94220',
          },
          940803: {
            name: {
              th: 'ตะโละไกรทอง',
              en: 'Talo Kraithong',
            },
            zipcode: '94220',
          },
          940804: {
            name: {
              th: 'ดอนทราย',
              en: 'Don Sai',
            },
            zipcode: '94220',
          },
        },
      },
      9409: {
        name: {
          th: 'ยะหริ่ง',
          en: 'Yaring',
        },
        tambons: {
          940901: {
            name: {
              th: 'ตะโละ',
              en: 'Talo',
            },
            zipcode: '94150',
          },
          940902: {
            name: {
              th: 'ตะโละกาโปร์',
              en: 'Talo Kapo',
            },
            zipcode: '94150',
          },
          940903: {
            name: {
              th: 'ตันหยงดาลอ',
              en: 'Tanyong Talo',
            },
            zipcode: '94150',
          },
          940904: {
            name: {
              th: 'ตันหยงจึงงา',
              en: 'Tanyong Chueng-nga',
            },
            zipcode: '94190',
          },
          940905: {
            name: {
              th: 'ตอหลัง',
              en: 'Tolang',
            },
            zipcode: '94150',
          },
          940906: {
            name: {
              th: 'ตาแกะ',
              en: 'Takae',
            },
            zipcode: '94150',
          },
          940907: {
            name: {
              th: 'ตาลีอายร์',
              en: 'Tali-ai',
            },
            zipcode: '94150',
          },
          940908: {
            name: {
              th: 'ยามู',
              en: 'Yamu',
            },
            zipcode: '94150',
          },
          940909: {
            name: {
              th: 'บางปู',
              en: 'Bang Pu',
            },
            zipcode: '94150',
          },
          940910: {
            name: {
              th: 'หนองแรต',
              en: 'Nong Raet',
            },
            zipcode: '94150',
          },
          940911: {
            name: {
              th: 'ปิยามุมัง',
              en: 'Piya Mumang',
            },
            zipcode: '94150',
          },
          940912: {
            name: {
              th: 'ปุลากง',
              en: 'Pulakong',
            },
            zipcode: '94150',
          },
          940913: {
            name: {
              th: 'บาโลย',
              en: 'Baloi',
            },
            zipcode: '94190',
          },
          940914: {
            name: {
              th: 'สาบัน',
              en: 'Saban',
            },
            zipcode: '94150',
          },
          940915: {
            name: {
              th: 'มะนังยง',
              en: 'Manang Yong',
            },
            zipcode: '94150',
          },
          940916: {
            name: {
              th: 'ราตาปันยัง',
              en: 'Rata Panyang',
            },
            zipcode: '94150',
          },
          940917: {
            name: {
              th: 'จะรัง',
              en: 'Charang',
            },
            zipcode: '94150',
          },
          940918: {
            name: {
              th: 'แหลมโพธิ์',
              en: 'Laem Pho',
            },
            zipcode: '94150',
          },
        },
      },
      9410: {
        name: {
          th: 'ยะรัง',
          en: 'Yarang',
        },
        tambons: {
          941001: {
            name: {
              th: 'ยะรัง',
              en: 'Yarang',
            },
            zipcode: '94160',
          },
          941002: {
            name: {
              th: 'สะดาวา',
              en: 'Sadawa',
            },
            zipcode: '94160',
          },
          941003: {
            name: {
              th: 'ประจัน',
              en: 'Prachan',
            },
            zipcode: '94160',
          },
          941004: {
            name: {
              th: 'สะนอ',
              en: 'Sano',
            },
            zipcode: '94160',
          },
          941005: {
            name: {
              th: 'ระแว้ง',
              en: 'Rawaeng',
            },
            zipcode: '94160',
          },
          941006: {
            name: {
              th: 'ปิตูมุดี',
              en: 'Pitu Mudi',
            },
            zipcode: '94160',
          },
          941007: {
            name: {
              th: 'วัด',
              en: 'Wat',
            },
            zipcode: '94160',
          },
          941008: {
            name: {
              th: 'กระโด',
              en: 'Krado',
            },
            zipcode: '94160',
          },
          941009: {
            name: {
              th: 'คลองใหม่',
              en: 'Khlong Mai',
            },
            zipcode: '94160',
          },
          941010: {
            name: {
              th: 'เมาะมาวี',
              en: 'Mo Mawi',
            },
            zipcode: '94160',
          },
          941011: {
            name: {
              th: 'กอลำ',
              en: 'Kolam',
            },
            zipcode: '94160',
          },
          941012: {
            name: {
              th: 'เขาตูม',
              en: 'Khao Tum',
            },
            zipcode: '94160',
          },
        },
      },
      9411: {
        name: {
          th: 'กะพ้อ',
          en: 'Kapho',
        },
        tambons: {
          941101: {
            name: {
              th: 'กะรุบี',
              en: 'Karubi',
            },
            zipcode: '94230',
          },
          941102: {
            name: {
              th: 'ตะโละดือรามัน',
              en: 'Talo Due Raman',
            },
            zipcode: '94230',
          },
          941103: {
            name: {
              th: 'ปล่องหอย',
              en: 'Plong Hoi',
            },
            zipcode: '94230',
          },
        },
      },
      9412: {
        name: {
          th: 'แม่ลาน',
          en: 'Mae Lan',
        },
        tambons: {
          941201: {
            name: {
              th: 'แม่ลาน',
              en: 'Mae Lan',
            },
            zipcode: '94180',
          },
          941202: {
            name: {
              th: 'ม่วงเตี้ย',
              en: 'Muang Tia',
            },
            zipcode: '94180',
          },
          941203: {
            name: {
              th: 'ป่าไร่',
              en: 'Pa Rai',
            },
            zipcode: '94180',
          },
        },
      },
    },
  },
  95: {
    name: {
      th: 'ยะลา',
      en: 'Yala',
    },
    amphoes: {
      9501: {
        name: {
          th: 'เมืองยะลา',
          en: 'Muang',
        },
        tambons: {
          950101: {
            name: {
              th: 'สะเตง',
              en: 'Sateng',
            },
            zipcode: '95000',
          },
          950102: {
            name: {
              th: 'บุดี',
              en: 'Budi',
            },
            zipcode: '95000',
          },
          950103: {
            name: {
              th: 'ยุโป',
              en: 'Yupo',
            },
            zipcode: '95000',
          },
          950104: {
            name: {
              th: 'ลิดล',
              en: 'Lidon',
            },
            zipcode: '95160',
          },
          950106: {
            name: {
              th: 'ยะลา',
              en: 'Yala',
            },
            zipcode: '95000',
          },
          950108: {
            name: {
              th: 'ท่าสาป',
              en: 'Tha Sap',
            },
            zipcode: '95000',
          },
          950109: {
            name: {
              th: 'ลำใหม่',
              en: 'Lam Mai',
            },
            zipcode: '95160',
          },
          950110: {
            name: {
              th: 'หน้าถ้ำ',
              en: 'Na Tham',
            },
            zipcode: '95000',
          },
          950111: {
            name: {
              th: 'ลำพะยา',
              en: 'Lam Phaya',
            },
            zipcode: '95160',
          },
          950112: {
            name: {
              th: 'เปาะเส้ง',
              en: 'Po Seng',
            },
            zipcode: '95000',
          },
          950114: {
            name: {
              th: 'พร่อน',
              en: 'Phron',
            },
            zipcode: '95160',
          },
          950115: {
            name: {
              th: 'บันนังสาเรง',
              en: 'Bannang Sareng',
            },
            zipcode: '95000',
          },
          950116: {
            name: {
              th: 'สะเตงนอก',
              en: 'Sateng Nok',
            },
            zipcode: '95000',
          },
          950118: {
            name: {
              th: 'ตาเซะ',
              en: 'Tase',
            },
            zipcode: '95000',
          },
        },
      },
      9502: {
        name: {
          th: 'เบตง',
          en: 'Betong',
        },
        tambons: {
          950201: {
            name: {
              th: 'เบตง',
              en: 'Betong',
            },
            zipcode: '95110',
          },
          950202: {
            name: {
              th: 'ยะรม',
              en: 'Yarom',
            },
            zipcode: '95110',
          },
          950203: {
            name: {
              th: 'ตาเนาะแมเราะ',
              en: 'Tano Maero',
            },
            zipcode: '95110',
          },
          950204: {
            name: {
              th: 'อัยเยอร์เวง',
              en: 'Aiyoeweng',
            },
            zipcode: '95110',
          },
          950205: {
            name: {
              th: 'ธารน้ำทิพย์',
              en: 'Than Nam Thip',
            },
            zipcode: '95110',
          },
        },
      },
      9503: {
        name: {
          th: 'บันนังสตา',
          en: 'Bannang Sata',
        },
        tambons: {
          950301: {
            name: {
              th: 'บันนังสตา',
              en: 'Bannang Sata',
            },
            zipcode: '95130',
          },
          950302: {
            name: {
              th: 'บาเจาะ',
              en: 'Bacho',
            },
            zipcode: '95130',
          },
          950303: {
            name: {
              th: 'ตาเนาะปูเต๊ะ',
              en: 'Tano Pute',
            },
            zipcode: '95130',
          },
          950304: {
            name: {
              th: 'ถ้ำทะลุ',
              en: 'Tham Thalu',
            },
            zipcode: '95130',
          },
          950305: {
            name: {
              th: 'ตลิ่งชัน',
              en: 'Taling Chan',
            },
            zipcode: '95130',
          },
          950306: {
            name: {
              th: 'เขื่อนบางลาง',
              en: 'Khuean Bang Lang',
            },
            zipcode: '95130',
          },
        },
      },
      9504: {
        name: {
          th: 'ธารโต',
          en: 'Than To',
        },
        tambons: {
          950401: {
            name: {
              th: 'ธารโต',
              en: 'Than To',
            },
            zipcode: '95150',
          },
          950402: {
            name: {
              th: 'บ้านแหร',
              en: 'Ban Rae',
            },
            zipcode: '95150',
          },
          950403: {
            name: {
              th: 'แม่หวาด',
              en: 'Mae Wat',
            },
            zipcode: '95170',
          },
          950404: {
            name: {
              th: 'คีรีเขต',
              en: 'Khiri Khet',
            },
            zipcode: '95150',
          },
        },
      },
      9505: {
        name: {
          th: 'ยะหา',
          en: 'Yaha',
        },
        tambons: {
          950501: {
            name: {
              th: 'ยะหา',
              en: 'Yaha',
            },
            zipcode: '95120',
          },
          950502: {
            name: {
              th: 'ละแอ',
              en: 'La-ae',
            },
            zipcode: '95120',
          },
          950503: {
            name: {
              th: 'ปะแต',
              en: 'Patae',
            },
            zipcode: '95120',
          },
          950504: {
            name: {
              th: 'บาโร๊ะ',
              en: 'Baro',
            },
            zipcode: '95120',
          },
          950506: {
            name: {
              th: 'ตาชี',
              en: 'Tachi',
            },
            zipcode: '95120',
          },
          950507: {
            name: {
              th: 'บาโงยซิแน',
              en: 'Ba-ngoi Sinae',
            },
            zipcode: '95120',
          },
          950508: {
            name: {
              th: 'กาตอง',
              en: 'Katong',
            },
            zipcode: '95120',
          },
        },
      },
      9506: {
        name: {
          th: 'รามัน',
          en: 'Raman',
        },
        tambons: {
          950601: {
            name: {
              th: 'กายูบอเกาะ',
              en: 'Kayu Boko',
            },
            zipcode: '95140',
          },
          950602: {
            name: {
              th: 'กาลูปัง',
              en: 'Kalupang',
            },
            zipcode: '95140',
          },
          950603: {
            name: {
              th: 'กาลอ',
              en: 'Kalo',
            },
            zipcode: '95140',
          },
          950604: {
            name: {
              th: 'กอตอตือร๊ะ',
              en: 'Koto Tuera',
            },
            zipcode: '95140',
          },
          950605: {
            name: {
              th: 'โกตาบารู',
              en: 'Kota Baru',
            },
            zipcode: '95140',
          },
          950606: {
            name: {
              th: 'เกะรอ',
              en: 'Kero',
            },
            zipcode: '95140',
          },
          950607: {
            name: {
              th: 'จะกว๊ะ',
              en: 'Cha-kwa',
            },
            zipcode: '95140',
          },
          950608: {
            name: {
              th: 'ท่าธง',
              en: 'Tha Thong',
            },
            zipcode: '95140',
          },
          950609: {
            name: {
              th: 'เนินงาม',
              en: 'Noen Ngam',
            },
            zipcode: '95140',
          },
          950610: {
            name: {
              th: 'บาลอ',
              en: 'Balo',
            },
            zipcode: '95140',
          },
          950611: {
            name: {
              th: 'บาโงย',
              en: 'Ba-ngoi',
            },
            zipcode: '95140',
          },
          950612: {
            name: {
              th: 'บือมัง',
              en: 'Buemang',
            },
            zipcode: '95140',
          },
          950613: {
            name: {
              th: 'ยะต๊ะ',
              en: 'Yata',
            },
            zipcode: '95140',
          },
          950614: {
            name: {
              th: 'วังพญา',
              en: 'Wang Phaya',
            },
            zipcode: '95140',
          },
          950615: {
            name: {
              th: 'อาซ่อง',
              en: 'A-song',
            },
            zipcode: '95140',
          },
          950616: {
            name: {
              th: 'ตะโล๊ะหะลอ',
              en: 'Talo Halo',
            },
            zipcode: '95140',
          },
        },
      },
      9507: {
        name: {
          th: 'กาบัง',
          en: 'Kabang',
        },
        tambons: {
          950701: {
            name: {
              th: 'กาบัง',
              en: 'Kabang',
            },
            zipcode: '95120',
          },
          950702: {
            name: {
              th: 'บาละ',
              en: 'Bala',
            },
            zipcode: '95120',
          },
        },
      },
      9508: {
        name: {
          th: 'กรงปินัง',
          en: 'Kong Phinang',
        },
        tambons: {
          950801: {
            name: {
              th: 'กรงปินัง',
              en: 'Krong Pinang',
            },
            zipcode: '95000',
          },
          950802: {
            name: {
              th: 'สะเอะ',
              en: 'Sa-ae',
            },
            zipcode: '95000',
          },
          950803: {
            name: {
              th: 'ห้วยกระทิง',
              en: 'Huai Krathing',
            },
            zipcode: '95000',
          },
          950804: {
            name: {
              th: 'ปุโรง',
              en: 'Purong',
            },
            zipcode: '95000',
          },
        },
      },
    },
  },
  96: {
    name: {
      th: 'นราธิวาส',
      en: 'Narathiwat',
    },
    amphoes: {
      9601: {
        name: {
          th: 'เมืองนราธิวาส',
          en: 'Muang',
        },
        tambons: {
          960101: {
            name: {
              th: 'บางนาค',
              en: 'Bang Nak',
            },
            zipcode: '96000',
          },
          960102: {
            name: {
              th: 'ลำภู',
              en: 'Lam Phu',
            },
            zipcode: '96000',
          },
          960103: {
            name: {
              th: 'มะนังตายอ',
              en: 'Manang Tayo',
            },
            zipcode: '96000',
          },
          960104: {
            name: {
              th: 'บางปอ',
              en: 'Bang Po',
            },
            zipcode: '96000',
          },
          960105: {
            name: {
              th: 'กะลุวอ',
              en: 'Kaluwo',
            },
            zipcode: '96000',
          },
          960106: {
            name: {
              th: 'กะลุวอเหนือ',
              en: 'Kaluwo Nuea',
            },
            zipcode: '96000',
          },
          960107: {
            name: {
              th: 'โคกเคียน',
              en: 'Khok Khian',
            },
            zipcode: '96000',
          },
        },
      },
      9602: {
        name: {
          th: 'ตากใบ',
          en: 'Takbai',
        },
        tambons: {
          960201: {
            name: {
              th: 'เจ๊ะเห',
              en: 'Chehe',
            },
            zipcode: '96110',
          },
          960202: {
            name: {
              th: 'ไพรวัน',
              en: 'Phraiwan',
            },
            zipcode: '96110',
          },
          960203: {
            name: {
              th: 'พร่อน',
              en: 'Phron',
            },
            zipcode: '96110',
          },
          960204: {
            name: {
              th: 'ศาลาใหม่',
              en: 'Sala Mai',
            },
            zipcode: '96110',
          },
          960205: {
            name: {
              th: 'บางขุนทอง',
              en: 'Bang Khun Thong',
            },
            zipcode: '96110',
          },
          960206: {
            name: {
              th: 'เกาะสะท้อน',
              en: 'Ko Sathon',
            },
            zipcode: '96110',
          },
          960207: {
            name: {
              th: 'นานาค',
              en: 'Na Nak',
            },
            zipcode: '96110',
          },
          960208: {
            name: {
              th: 'โฆษิต',
              en: 'Khosit',
            },
            zipcode: '96110',
          },
        },
      },
      9603: {
        name: {
          th: 'บาเจาะ',
          en: 'Bacho',
        },
        tambons: {
          960301: {
            name: {
              th: 'บาเจาะ',
              en: 'Bacho',
            },
            zipcode: '96170',
          },
          960302: {
            name: {
              th: 'ลุโบะสาวอ',
              en: 'Lubo Sawo',
            },
            zipcode: '96170',
          },
          960303: {
            name: {
              th: 'กาเยาะมาตี',
              en: 'Kayo Mati',
            },
            zipcode: '96170',
          },
          960304: {
            name: {
              th: 'ปะลุกาสาเมาะ',
              en: 'Paluka Samo',
            },
            zipcode: '96170',
          },
          960305: {
            name: {
              th: 'บาเระเหนือ',
              en: 'Bare Nuea',
            },
            zipcode: '96170',
          },
          960306: {
            name: {
              th: 'บาเระใต้',
              en: 'Bare Tai',
            },
            zipcode: '96170',
          },
        },
      },
      9604: {
        name: {
          th: 'ยี่งอ',
          en: 'Yi-Ngo',
        },
        tambons: {
          960401: {
            name: {
              th: 'ยี่งอ',
              en: 'Yi-ngo',
            },
            zipcode: '96180',
          },
          960402: {
            name: {
              th: 'ละหาร',
              en: 'Lahan',
            },
            zipcode: '96180',
          },
          960403: {
            name: {
              th: 'จอเบาะ',
              en: 'Cho Bo',
            },
            zipcode: '96180',
          },
          960404: {
            name: {
              th: 'ลุโบะบายะ',
              en: 'Lubo Baya',
            },
            zipcode: '96180',
          },
          960405: {
            name: {
              th: 'ลุโบะบือซา',
              en: 'Lubo Buesa',
            },
            zipcode: '96180',
          },
          960406: {
            name: {
              th: 'ตะปอเยาะ',
              en: 'Tapoyo',
            },
            zipcode: '96180',
          },
        },
      },
      9605: {
        name: {
          th: 'ระแงะ',
          en: 'Rangae',
        },
        tambons: {
          960501: {
            name: {
              th: 'ตันหยงมัส',
              en: 'Tanyong Mat',
            },
            zipcode: '96130',
          },
          960502: {
            name: {
              th: 'ตันหยงลิมอ',
              en: 'Tanyong Limo',
            },
            zipcode: '96130',
          },
          960506: {
            name: {
              th: 'บองอ',
              en: 'Bo-ngo',
            },
            zipcode: '96220',
          },
          960507: {
            name: {
              th: 'กาลิซา',
              en: 'Kalisa',
            },
            zipcode: '96130',
          },
          960508: {
            name: {
              th: 'บาโงสะโต',
              en: 'Ba-ngo Sato',
            },
            zipcode: '96130',
          },
          960509: {
            name: {
              th: 'เฉลิม',
              en: 'Chaloem',
            },
            zipcode: '96130',
          },
          960510: {
            name: {
              th: 'มะรือโบตก',
              en: 'Marue Botok',
            },
            zipcode: '96130',
          },
        },
      },
      9606: {
        name: {
          th: 'รือเสาะ',
          en: 'Ruso',
        },
        tambons: {
          960601: {
            name: {
              th: 'รือเสาะ',
              en: 'Rueso',
            },
            zipcode: '96150',
          },
          960602: {
            name: {
              th: 'สาวอ',
              en: 'Sawo',
            },
            zipcode: '96150',
          },
          960603: {
            name: {
              th: 'เรียง',
              en: 'Riang',
            },
            zipcode: '96150',
          },
          960604: {
            name: {
              th: 'สามัคคี',
              en: 'Samakkhi',
            },
            zipcode: '96150',
          },
          960605: {
            name: {
              th: 'บาตง',
              en: 'Batong',
            },
            zipcode: '96150',
          },
          960606: {
            name: {
              th: 'ลาโละ',
              en: 'Lalo',
            },
            zipcode: '96150',
          },
          960607: {
            name: {
              th: 'รือเสาะออก',
              en: 'Rueso Ok',
            },
            zipcode: '96150',
          },
          960608: {
            name: {
              th: 'โคกสะตอ',
              en: 'Khok Sato',
            },
            zipcode: '96150',
          },
          960609: {
            name: {
              th: 'สุวารี',
              en: 'Suwari',
            },
            zipcode: '96150',
          },
        },
      },
      9607: {
        name: {
          th: 'ศรีสาคร',
          en: 'Si Sakhon',
        },
        tambons: {
          960701: {
            name: {
              th: 'ซากอ',
              en: 'Sako',
            },
            zipcode: '96210',
          },
          960702: {
            name: {
              th: 'ตะมะยูง',
              en: 'Tamayung',
            },
            zipcode: '96210',
          },
          960703: {
            name: {
              th: 'ศรีสาคร',
              en: 'Si Sakhon',
            },
            zipcode: '96210',
          },
          960704: {
            name: {
              th: 'เชิงคีรี',
              en: 'Choeng Khiri',
            },
            zipcode: '96210',
          },
          960705: {
            name: {
              th: 'กาหลง',
              en: 'Kalong',
            },
            zipcode: '96210',
          },
          960706: {
            name: {
              th: 'ศรีบรรพต',
              en: 'Si Banphot',
            },
            zipcode: '96210',
          },
        },
      },
      9608: {
        name: {
          th: 'แว้ง',
          en: 'Waeng',
        },
        tambons: {
          960801: {
            name: {
              th: 'แว้ง',
              en: 'Waeng',
            },
            zipcode: '96160',
          },
          960802: {
            name: {
              th: 'กายูคละ',
              en: 'Kayu Khla',
            },
            zipcode: '96160',
          },
          960803: {
            name: {
              th: 'ฆอเลาะ',
              en: 'Kholo',
            },
            zipcode: '96160',
          },
          960804: {
            name: {
              th: 'โละจูด',
              en: 'Lochut',
            },
            zipcode: '96160',
          },
          960805: {
            name: {
              th: 'แม่ดง',
              en: 'Mae Dong',
            },
            zipcode: '96160',
          },
          960806: {
            name: {
              th: 'เอราวัณ',
              en: 'Erawan',
            },
            zipcode: '96160',
          },
        },
      },
      9609: {
        name: {
          th: 'สุคิริน',
          en: 'Sukhirin',
        },
        tambons: {
          960901: {
            name: {
              th: 'มาโมง',
              en: 'Mamong',
            },
            zipcode: '96190',
          },
          960902: {
            name: {
              th: 'สุคิริน',
              en: 'Sukhirin',
            },
            zipcode: '96190',
          },
          960903: {
            name: {
              th: 'เกียร์',
              en: 'Kia',
            },
            zipcode: '96190',
          },
          960904: {
            name: {
              th: 'ภูเขาทอง',
              en: 'Phukhao Thong',
            },
            zipcode: '96190',
          },
          960905: {
            name: {
              th: 'ร่มไทร',
              en: 'Rom Sai',
            },
            zipcode: '96190',
          },
        },
      },
      9610: {
        name: {
          th: 'สุไหงโก-ลก',
          en: 'Sungai Kolok',
        },
        tambons: {
          961001: {
            name: {
              th: 'สุไหงโก-ลก',
              en: 'Su-ngai Kolok',
            },
            zipcode: '96120',
          },
          961002: {
            name: {
              th: 'ปาเสมัส',
              en: 'Pasemat',
            },
            zipcode: '96120',
          },
          961003: {
            name: {
              th: 'มูโนะ',
              en: 'Muno',
            },
            zipcode: '96120',
          },
          961004: {
            name: {
              th: 'ปูโยะ',
              en: 'Puyo',
            },
            zipcode: '96120',
          },
        },
      },
      9611: {
        name: {
          th: 'สุไหงปาดี',
          en: 'Sungai Padi',
        },
        tambons: {
          961101: {
            name: {
              th: 'ปะลุรู',
              en: 'Paluru',
            },
            zipcode: '96140',
          },
          961102: {
            name: {
              th: 'สุไหงปาดี',
              en: 'Su-ngai Padi',
            },
            zipcode: '96140',
          },
          961103: {
            name: {
              th: 'โต๊ะเด็ง',
              en: 'Todeng',
            },
            zipcode: '96140',
          },
          961104: {
            name: {
              th: 'สากอ',
              en: 'Sa Ko',
            },
            zipcode: '96140',
          },
          961105: {
            name: {
              th: 'ริโก๋',
              en: 'Riko',
            },
            zipcode: '96140',
          },
          961106: {
            name: {
              th: 'กาวะ',
              en: 'Kawa',
            },
            zipcode: '96140',
          },
        },
      },
      9612: {
        name: {
          th: 'จะแนะ',
          en: 'Ja-Nae',
        },
        tambons: {
          961201: {
            name: {
              th: 'จะแนะ',
              en: 'Chanae',
            },
            zipcode: '96220',
          },
          961202: {
            name: {
              th: 'ดุซงญอ',
              en: 'Dusongyo',
            },
            zipcode: '96220',
          },
          961203: {
            name: {
              th: 'ผดุงมาตร',
              en: 'Phadung Mat',
            },
            zipcode: '96220',
          },
          961204: {
            name: {
              th: 'ช้างเผือก',
              en: 'Chang Phueak',
            },
            zipcode: '96220',
          },
        },
      },
      9613: {
        name: {
          th: 'เจาะไอร้อง',
          en: 'Cho-Airong',
        },
        tambons: {
          961301: {
            name: {
              th: 'จวบ',
              en: 'Chuap',
            },
            zipcode: '96130',
          },
          961302: {
            name: {
              th: 'บูกิต',
              en: 'Bukit',
            },
            zipcode: '96130',
          },
          961303: {
            name: {
              th: 'มะรือโบออก',
              en: 'Maruebo Ok',
            },
            zipcode: '96130',
          },
        },
      },
    },
  },
};
